
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2e1e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2e1e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
"use strict";
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.2.0";

});

parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $0b2e6adb871a3b94$var$Mg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Ng = null, $0b2e6adb871a3b94$var$Og = null, $0b2e6adb871a3b94$var$Pg = null;
function $0b2e6adb871a3b94$var$Qg() {
    $0b2e6adb871a3b94$var$Pg = $0b2e6adb871a3b94$var$Og = $0b2e6adb871a3b94$var$Ng = null;
}
function $0b2e6adb871a3b94$var$Rg(a) {
    var b = $0b2e6adb871a3b94$var$Mg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Mg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$Tg(a, b) {
    $0b2e6adb871a3b94$var$Ng = a;
    $0b2e6adb871a3b94$var$Pg = $0b2e6adb871a3b94$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$Ug = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$Vg(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Og) {
            if (null === $0b2e6adb871a3b94$var$Ng) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Og = a;
            $0b2e6adb871a3b94$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Og = $0b2e6adb871a3b94$var$Og.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$Wg = null;
function $0b2e6adb871a3b94$var$Xg(a) {
    null === $0b2e6adb871a3b94$var$Wg ? $0b2e6adb871a3b94$var$Wg = [
        a
    ] : $0b2e6adb871a3b94$var$Wg.push(a);
}
function $0b2e6adb871a3b94$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$Zg(a, d);
}
function $0b2e6adb871a3b94$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$$g = !1;
function $0b2e6adb871a3b94$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$Zg(a, c);
}
function $0b2e6adb871a3b94$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$jh = (new $acw62.Component).refs;
function $0b2e6adb871a3b94$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$L(), e = $0b2e6adb871a3b94$var$lh(a), f = $0b2e6adb871a3b94$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$dh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, e, d), $0b2e6adb871a3b94$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$L(), e = $0b2e6adb871a3b94$var$lh(a), f = $0b2e6adb871a3b94$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$dh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, e, d), $0b2e6adb871a3b94$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$L(), d = $0b2e6adb871a3b94$var$lh(a), e = $0b2e6adb871a3b94$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$dh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, d, c), $0b2e6adb871a3b94$var$eh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$ph(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$Vg(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$nh.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $0b2e6adb871a3b94$var$jh;
    $0b2e6adb871a3b94$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$Vg(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$nh.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $0b2e6adb871a3b94$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$sh(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$sh(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$zh(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Ah(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Bh = $0b2e6adb871a3b94$var$vh(!0), $0b2e6adb871a3b94$var$Ch = $0b2e6adb871a3b94$var$vh(!1), $0b2e6adb871a3b94$var$Dh = {}, $0b2e6adb871a3b94$var$Eh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh), $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh), $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh);
function $0b2e6adb871a3b94$var$Hh(a) {
    if (a === $0b2e6adb871a3b94$var$Dh) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$Ih(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Gh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Fh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, $0b2e6adb871a3b94$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, b);
}
function $0b2e6adb871a3b94$var$Jh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Fh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Gh);
}
function $0b2e6adb871a3b94$var$Kh(a) {
    $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
    var b = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Fh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, c));
}
function $0b2e6adb871a3b94$var$Lh(a) {
    $0b2e6adb871a3b94$var$Fh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Fh));
}
var $0b2e6adb871a3b94$var$M = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nh = [];
function $0b2e6adb871a3b94$var$Oh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Nh.length; a++)$0b2e6adb871a3b94$var$Nh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Nh.length = 0;
}
var $0b2e6adb871a3b94$var$Ph = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Qh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Rh = 0, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$P = null, $0b2e6adb871a3b94$var$Sh = !1, $0b2e6adb871a3b94$var$Th = !1, $0b2e6adb871a3b94$var$Uh = 0, $0b2e6adb871a3b94$var$Vh = 0;
function $0b2e6adb871a3b94$var$Q() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Xh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Rh = f;
    $0b2e6adb871a3b94$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Ph.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Yh : $0b2e6adb871a3b94$var$Zh;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Th) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Th = !1;
            $0b2e6adb871a3b94$var$Uh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$$h;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Th);
    }
    $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$ai;
    b = null !== $0b2e6adb871a3b94$var$O && null !== $0b2e6adb871a3b94$var$O.next;
    $0b2e6adb871a3b94$var$Rh = 0;
    $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
    $0b2e6adb871a3b94$var$Sh = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$bi() {
    var a = 0 !== $0b2e6adb871a3b94$var$Uh;
    $0b2e6adb871a3b94$var$Uh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState = $0b2e6adb871a3b94$var$P = a : $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$P.next = a;
    return $0b2e6adb871a3b94$var$P;
}
function $0b2e6adb871a3b94$var$di() {
    if (null === $0b2e6adb871a3b94$var$O) {
        var a = $0b2e6adb871a3b94$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$O.next;
    var b = null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState : $0b2e6adb871a3b94$var$P.next;
    if (null !== b) $0b2e6adb871a3b94$var$P = b, $0b2e6adb871a3b94$var$O = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$O = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$O.memoizedState,
            baseState: $0b2e6adb871a3b94$var$O.baseState,
            baseQueue: $0b2e6adb871a3b94$var$O.baseQueue,
            queue: $0b2e6adb871a3b94$var$O.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState = $0b2e6adb871a3b94$var$P = a : $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$P.next = a;
    }
    return $0b2e6adb871a3b94$var$P;
}
function $0b2e6adb871a3b94$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$di(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$N.lanes |= m;
                $0b2e6adb871a3b94$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$N.lanes |= f, $0b2e6adb871a3b94$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$gi(a) {
    var b = $0b2e6adb871a3b94$var$di(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$hi() {}
function $0b2e6adb871a3b94$var$ii(a, b) {
    var c = $0b2e6adb871a3b94$var$N, d = $0b2e6adb871a3b94$var$di(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$Ug = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$ji($0b2e6adb871a3b94$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$P && $0b2e6adb871a3b94$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$li(9, $0b2e6adb871a3b94$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$R) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Rh & 30) || $0b2e6adb871a3b94$var$ni(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$oi(b) && $0b2e6adb871a3b94$var$pi(a);
}
function $0b2e6adb871a3b94$var$ki(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$oi(b) && $0b2e6adb871a3b94$var$pi(a);
    });
}
function $0b2e6adb871a3b94$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$pi(a) {
    var b = $0b2e6adb871a3b94$var$Zg(a, 1);
    null !== b && $0b2e6adb871a3b94$var$mh(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$qi(a) {
    var b = $0b2e6adb871a3b94$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ri.bind(null, $0b2e6adb871a3b94$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$si() {
    return $0b2e6adb871a3b94$var$di().memoizedState;
}
function $0b2e6adb871a3b94$var$ti(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$ci();
    $0b2e6adb871a3b94$var$N.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$ui(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$O) {
        var g = $0b2e6adb871a3b94$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Wh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$li(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$N.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$li(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    return $0b2e6adb871a3b94$var$ti(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$ji(a, b) {
    return $0b2e6adb871a3b94$var$ui(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$wi(a, b) {
    return $0b2e6adb871a3b94$var$ui(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$xi(a, b) {
    return $0b2e6adb871a3b94$var$ui(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$ui(4, 4, $0b2e6adb871a3b94$var$yi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$Ai() {}
function $0b2e6adb871a3b94$var$Bi(a, b) {
    var c = $0b2e6adb871a3b94$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$Ci(a, b) {
    var c = $0b2e6adb871a3b94$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$Di(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Rh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$Ug = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$N.lanes |= c, $0b2e6adb871a3b94$var$hh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$Ei(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Qh.transition;
    $0b2e6adb871a3b94$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Qh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$Fi() {
    return $0b2e6adb871a3b94$var$di().memoizedState;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$Hi(a)) $0b2e6adb871a3b94$var$Ii(b, c);
    else if (c = $0b2e6adb871a3b94$var$Yg(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$L();
        $0b2e6adb871a3b94$var$mh(c, a, d, e);
        $0b2e6adb871a3b94$var$Ji(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ri(a, b, c) {
    var d = $0b2e6adb871a3b94$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$Hi(a)) $0b2e6adb871a3b94$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$Yg(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$L(), $0b2e6adb871a3b94$var$mh(c, a, d, e), $0b2e6adb871a3b94$var$Ji(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$Hi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$N || null !== b && b === $0b2e6adb871a3b94$var$N;
}
function $0b2e6adb871a3b94$var$Ii(a, b) {
    $0b2e6adb871a3b94$var$Th = $0b2e6adb871a3b94$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$ai = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Q,
    useContext: $0b2e6adb871a3b94$var$Q,
    useEffect: $0b2e6adb871a3b94$var$Q,
    useImperativeHandle: $0b2e6adb871a3b94$var$Q,
    useInsertionEffect: $0b2e6adb871a3b94$var$Q,
    useLayoutEffect: $0b2e6adb871a3b94$var$Q,
    useMemo: $0b2e6adb871a3b94$var$Q,
    useReducer: $0b2e6adb871a3b94$var$Q,
    useRef: $0b2e6adb871a3b94$var$Q,
    useState: $0b2e6adb871a3b94$var$Q,
    useDebugValue: $0b2e6adb871a3b94$var$Q,
    useDeferredValue: $0b2e6adb871a3b94$var$Q,
    useTransition: $0b2e6adb871a3b94$var$Q,
    useMutableSource: $0b2e6adb871a3b94$var$Q,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Q,
    useId: $0b2e6adb871a3b94$var$Q,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Yh = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ti(4194308, 4, $0b2e6adb871a3b94$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$Gi.bind(null, $0b2e6adb871a3b94$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$qi,
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$qi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$Ei.bind(null, a[1]);
        $0b2e6adb871a3b94$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$N, e = $0b2e6adb871a3b94$var$ci();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$R) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Rh & 30) || $0b2e6adb871a3b94$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$vi($0b2e6adb871a3b94$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$li(9, $0b2e6adb871a3b94$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$ci(), b = $0b2e6adb871a3b94$var$R.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Zh = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Bi,
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$ji,
    useImperativeHandle: $0b2e6adb871a3b94$var$zi,
    useInsertionEffect: $0b2e6adb871a3b94$var$wi,
    useLayoutEffect: $0b2e6adb871a3b94$var$xi,
    useMemo: $0b2e6adb871a3b94$var$Ci,
    useReducer: $0b2e6adb871a3b94$var$fi,
    useRef: $0b2e6adb871a3b94$var$si,
    useState: function() {
        return $0b2e6adb871a3b94$var$fi($0b2e6adb871a3b94$var$ei);
    },
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$di();
        return $0b2e6adb871a3b94$var$Di(b, $0b2e6adb871a3b94$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$fi($0b2e6adb871a3b94$var$ei)[0], b = $0b2e6adb871a3b94$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$hi,
    useSyncExternalStore: $0b2e6adb871a3b94$var$ii,
    useId: $0b2e6adb871a3b94$var$Fi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$$h = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Bi,
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$ji,
    useImperativeHandle: $0b2e6adb871a3b94$var$zi,
    useInsertionEffect: $0b2e6adb871a3b94$var$wi,
    useLayoutEffect: $0b2e6adb871a3b94$var$xi,
    useMemo: $0b2e6adb871a3b94$var$Ci,
    useReducer: $0b2e6adb871a3b94$var$gi,
    useRef: $0b2e6adb871a3b94$var$si,
    useState: function() {
        return $0b2e6adb871a3b94$var$gi($0b2e6adb871a3b94$var$ei);
    },
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$di();
        return null === $0b2e6adb871a3b94$var$O ? b.memoizedState = a : $0b2e6adb871a3b94$var$Di(b, $0b2e6adb871a3b94$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$gi($0b2e6adb871a3b94$var$ei)[0], b = $0b2e6adb871a3b94$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$hi,
    useSyncExternalStore: $0b2e6adb871a3b94$var$ii,
    useId: $0b2e6adb871a3b94$var$Fi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Oi(a, b, c) {
    c = $0b2e6adb871a3b94$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Pi || ($0b2e6adb871a3b94$var$Pi = !0, $0b2e6adb871a3b94$var$Qi = d);
        $0b2e6adb871a3b94$var$Mi(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Ri(a, b, c) {
    c = $0b2e6adb871a3b94$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Mi(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Si ? $0b2e6adb871a3b94$var$Si = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$ch(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Xi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$Ug = !1;
function $0b2e6adb871a3b94$var$Yi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Ch(b, null, c, d) : $0b2e6adb871a3b94$var$Bh(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$Tg(b, e);
    d = $0b2e6adb871a3b94$var$Xh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$bi();
    if (null !== a && !$0b2e6adb871a3b94$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$$i(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Yi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$cj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$Ug = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$$i(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$dj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj);
            $0b2e6adb871a3b94$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= d;
    $0b2e6adb871a3b94$var$Yi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$dj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$Tg(b, e);
    c = $0b2e6adb871a3b94$var$Xh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$bi();
    if (null !== a && !$0b2e6adb871a3b94$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$$i(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Yi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$Tg(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$jj(a, b), $0b2e6adb871a3b94$var$ph(b, c, d), $0b2e6adb871a3b94$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$Vg(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$qh(b, g, d, l);
        $0b2e6adb871a3b94$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$$g ? ("function" === typeof m && ($0b2e6adb871a3b94$var$kh(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$$g || $0b2e6adb871a3b94$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$Vg(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$qh(b, g, d, k);
        $0b2e6adb871a3b94$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$$g ? ("function" === typeof y && ($0b2e6adb871a3b94$var$kh(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$$g || $0b2e6adb871a3b94$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$kj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$kj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$$i(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Bh(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Bh(b, null, h, f)) : $0b2e6adb871a3b94$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$Ih(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$mj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Yi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$pj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$qj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$oj(c), b.memoizedState = $0b2e6adb871a3b94$var$nj, a) : $0b2e6adb871a3b94$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$wh(h, f) : (f = $0b2e6adb871a3b94$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$rj(a, b) {
    b = $0b2e6adb871a3b94$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$tj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Bh(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Li(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$oj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Li(f, d, void 0);
        return $0b2e6adb871a3b94$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$Ug || h) {
        d = $0b2e6adb871a3b94$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$Zg(a, e), $0b2e6adb871a3b94$var$mh(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$uj();
        d = $0b2e6adb871a3b94$var$Li(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$Sg(a.return, b, c);
}
function $0b2e6adb871a3b94$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Yi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$wj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$lj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Kh(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$pj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1);
                a = $0b2e6adb871a3b94$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$ej(a, b, c);
    }
    return $0b2e6adb871a3b94$var$$i(a, b, c);
}
var $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj, $0b2e6adb871a3b94$var$Dj;
$0b2e6adb871a3b94$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Bj = function() {};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Ej(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$Jh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Gj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Bj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Lh(b);
            var e = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
                $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Gj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$M.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$Jh(), $0b2e6adb871a3b94$var$Bj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$Rg(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Ej(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Hj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$M.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$gj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Jj(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$Jh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Lh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M), null;
        case 4:
            return $0b2e6adb871a3b94$var$Jh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Kj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Oj = !1;
function $0b2e6adb871a3b94$var$Pj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Oj;
    $0b2e6adb871a3b94$var$Oj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Xj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Xj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Yj = !1;
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$ak(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$ak(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Mj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Yj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Yj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Yj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Yj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Yj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Yj = !0;
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Nj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Zj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Zj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Lj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Yj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Yj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$ak(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$ek(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Qj(3, a, a.return), $0b2e6adb871a3b94$var$Rj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Qj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Mj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$gk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$dk(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 4 && $0b2e6adb871a3b94$var$bk(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$dk(b, a), $0b2e6adb871a3b94$var$fk(a);
    }
}
function $0b2e6adb871a3b94$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Vj(a);
                    $0b2e6adb871a3b94$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Vj(a);
                    $0b2e6adb871a3b94$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$jk(a, b, c);
}
function $0b2e6adb871a3b94$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Kj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Kj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$kk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$kk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$jk(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Kj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$lk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$lk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Sj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$hk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Sj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Sj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$mk = Math.ceil, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$pk = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$gj = 0, $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$qk = null, $0b2e6adb871a3b94$var$hh = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = 0, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$gk = 0, $0b2e6adb871a3b94$var$Hj = Infinity, $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Pi = !1, $0b2e6adb871a3b94$var$Qi = null, $0b2e6adb871a3b94$var$Si = null, $0b2e6adb871a3b94$var$wk = !1, $0b2e6adb871a3b94$var$xk = null, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = null, $0b2e6adb871a3b94$var$Bk = -1, $0b2e6adb871a3b94$var$Ck = 0;
function $0b2e6adb871a3b94$var$L() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Bk ? $0b2e6adb871a3b94$var$Bk : $0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Ck && ($0b2e6adb871a3b94$var$Ck = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Ck;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$mh(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$zk) throw $0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$R) a === $0b2e6adb871a3b94$var$R && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$rk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Ek(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Ek(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$R ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Fk.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Fk.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Gk(c, $0b2e6adb871a3b94$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Hk(a, b) {
    $0b2e6adb871a3b94$var$Bk = -1;
    $0b2e6adb871a3b94$var$Ck = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Ik() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$R ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Jk(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Kk();
        if ($0b2e6adb871a3b94$var$R !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Lk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Mk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Nk(a, h);
        }
        $0b2e6adb871a3b94$var$Qg();
        $0b2e6adb871a3b94$var$nk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Ok(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, d), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Pk(e) && (b = $0b2e6adb871a3b94$var$Jk(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Ok(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, d), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$gk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Qk.bind(null, a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Qk.bind(null, a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Hk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Ok(a, b) {
    var c = $0b2e6adb871a3b94$var$tk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Lk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Jk(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$uk = c, null !== b && $0b2e6adb871a3b94$var$Gj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Gj(a) {
    null === $0b2e6adb871a3b94$var$uk ? $0b2e6adb871a3b94$var$uk = a : $0b2e6adb871a3b94$var$uk.push.apply($0b2e6adb871a3b94$var$uk, a);
}
function $0b2e6adb871a3b94$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    b &= ~$0b2e6adb871a3b94$var$sk;
    b &= ~$0b2e6adb871a3b94$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Fk(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Ik();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Ok(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, b), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Rk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Sk(a) {
    null !== $0b2e6adb871a3b94$var$xk && 0 === $0b2e6adb871a3b94$var$xk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Ik();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$pk.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$pk.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$pk.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Ij() {
    $0b2e6adb871a3b94$var$gj = $0b2e6adb871a3b94$var$fj.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$fj);
}
function $0b2e6adb871a3b94$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$Jh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Oh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Lh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$Jh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
                break;
            case 10:
                $0b2e6adb871a3b94$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Ij();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$R = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$wh(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$gj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$qk = null;
    $0b2e6adb871a3b94$var$sk = $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$hh = 0;
    $0b2e6adb871a3b94$var$uk = $0b2e6adb871a3b94$var$tk = null;
    if (null !== $0b2e6adb871a3b94$var$Wg) {
        for(b = 0; b < $0b2e6adb871a3b94$var$Wg.length; b++)if (c = $0b2e6adb871a3b94$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$Wg = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$Qg();
            $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$ai;
            if ($0b2e6adb871a3b94$var$Sh) {
                for(var d = $0b2e6adb871a3b94$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Sh = !1;
            }
            $0b2e6adb871a3b94$var$Rh = 0;
            $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            $0b2e6adb871a3b94$var$Th = !1;
            $0b2e6adb871a3b94$var$Uh = 0;
            $0b2e6adb871a3b94$var$ok.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$qk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Ti(f, l, b);
                            $0b2e6adb871a3b94$var$uj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Wi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ki(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = [
                    f
                ] : $0b2e6adb871a3b94$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Oi(f, k, b);
                            $0b2e6adb871a3b94$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Si || !$0b2e6adb871a3b94$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Ri(f, h, b);
                                $0b2e6adb871a3b94$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Tk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Kk() {
    var a = $0b2e6adb871a3b94$var$nk.current;
    $0b2e6adb871a3b94$var$nk.current = $0b2e6adb871a3b94$var$ai;
    return null === a ? $0b2e6adb871a3b94$var$ai : a;
}
function $0b2e6adb871a3b94$var$uj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$R || 0 === ($0b2e6adb871a3b94$var$hh & 268435455) && 0 === ($0b2e6adb871a3b94$var$rk & 268435455) || $0b2e6adb871a3b94$var$Dk($0b2e6adb871a3b94$var$R, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Jk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Kk();
    if ($0b2e6adb871a3b94$var$R !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Lk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Uk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Nk(a, e);
    }
    $0b2e6adb871a3b94$var$Qg();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$nk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$R = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Uk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Vk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Mk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Vk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Vk(a) {
    var b = $0b2e6adb871a3b94$var$Wk(a.alternate, a, $0b2e6adb871a3b94$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Tk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$ok.current = null;
}
function $0b2e6adb871a3b94$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Fj(c, b, $0b2e6adb871a3b94$var$gj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Qk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$pk.transition;
    try {
        $0b2e6adb871a3b94$var$pk.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Xk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$pk.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Ik();
    while (null !== $0b2e6adb871a3b94$var$xk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$R && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$wk || ($0b2e6adb871a3b94$var$wk = !0, $0b2e6adb871a3b94$var$Gk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$pk.transition;
        $0b2e6adb871a3b94$var$pk.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$ok.current = null;
        $0b2e6adb871a3b94$var$Pj(a, c);
        $0b2e6adb871a3b94$var$ek(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$ik(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$pk.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$wk && ($0b2e6adb871a3b94$var$wk = !1, $0b2e6adb871a3b94$var$xk = a, $0b2e6adb871a3b94$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Si = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Pi) throw $0b2e6adb871a3b94$var$Pi = !1, a = $0b2e6adb871a3b94$var$Qi, $0b2e6adb871a3b94$var$Qi = null, a;
    0 !== ($0b2e6adb871a3b94$var$yk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$zk++ : ($0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = a) : $0b2e6adb871a3b94$var$zk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Ik() {
    if (null !== $0b2e6adb871a3b94$var$xk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$yk), b = $0b2e6adb871a3b94$var$pk.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$pk.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$xk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$xk;
                $0b2e6adb871a3b94$var$xk = null;
                $0b2e6adb871a3b94$var$yk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Tj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Rj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$pk.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Yk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ki(c, b);
    b = $0b2e6adb871a3b94$var$Oi(a, b, 1);
    a = $0b2e6adb871a3b94$var$dh(a, b, 1);
    b = $0b2e6adb871a3b94$var$L();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Ek(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Si || !$0b2e6adb871a3b94$var$Si.has(d))) {
                a = $0b2e6adb871a3b94$var$Ki(c, a);
                a = $0b2e6adb871a3b94$var$Ri(b, a, 1);
                b = $0b2e6adb871a3b94$var$dh(b, a, 1);
                a = $0b2e6adb871a3b94$var$L();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$R === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$gk ? $0b2e6adb871a3b94$var$Lk(a, 0) : $0b2e6adb871a3b94$var$sk |= c);
    $0b2e6adb871a3b94$var$Ek(a, b);
}
function $0b2e6adb871a3b94$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$L();
    a = $0b2e6adb871a3b94$var$Zg(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Ek(a, c));
}
function $0b2e6adb871a3b94$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Zk(a, c);
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Zk(a, c);
}
var $0b2e6adb871a3b94$var$Wk;
$0b2e6adb871a3b94$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$Ug = !1, $0b2e6adb871a3b94$var$zj(a, b, c);
            $0b2e6adb871a3b94$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$Ug = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$jj(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$Tg(b, c);
            e = $0b2e6adb871a3b94$var$Xh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$ah(b), e.updater = $0b2e6adb871a3b94$var$nh, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$rh(b, d, a, c), b = $0b2e6adb871a3b94$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$$k(d);
                a = $0b2e6adb871a3b94$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$aj(null, b, d, $0b2e6adb871a3b94$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$lj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$bh(a, b);
                $0b2e6adb871a3b94$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$mj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$$i(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Kh(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$hj(a, b), $0b2e6adb871a3b94$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$pj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Bh(b, null, d, c) : $0b2e6adb871a3b94$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$Zi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$Tg(b, c), e = $0b2e6adb871a3b94$var$Vg(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Lg(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Lg(d.type, e), $0b2e6adb871a3b94$var$aj(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$jj(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$Tg(b, c), $0b2e6adb871a3b94$var$ph(b, d, e), $0b2e6adb871a3b94$var$rh(b, d, e, c), $0b2e6adb871a3b94$var$kj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$yj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$ej(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Gk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$al(a, b, c, d);
}
function $0b2e6adb871a3b94$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$$k(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Ah(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Ah(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$qj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$xh(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$zh(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$ah(f);
    return a;
}
function $0b2e6adb871a3b94$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$el(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$el(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$L();
    e = $0b2e6adb871a3b94$var$lh(c);
    f = $0b2e6adb871a3b94$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$dh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Ek(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$gl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$L(), g = $0b2e6adb871a3b94$var$lh(e);
    c = $0b2e6adb871a3b94$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$dh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$mh(a, e, g, f), $0b2e6adb871a3b94$var$eh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$jl(a, b) {
    $0b2e6adb871a3b94$var$il(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$il(a, b);
}
function $0b2e6adb871a3b94$var$kl() {
    return null;
}
var $0b2e6adb871a3b94$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$nl.prototype.render = $0b2e6adb871a3b94$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$gl(a, b, null, null);
};
$0b2e6adb871a3b94$var$nl.prototype.unmount = $0b2e6adb871a3b94$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Sk(function() {
            $0b2e6adb871a3b94$var$gl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$ql() {}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$hl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$fl(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$ql);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$hl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$cl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$ql);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Sk(function() {
        $0b2e6adb871a3b94$var$gl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$hl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$gl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$rl(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$hl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Ek(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Sk(function() {
                var b = $0b2e6adb871a3b94$var$Zg(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$L();
                    $0b2e6adb871a3b94$var$mh(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$jl(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$L();
            $0b2e6adb871a3b94$var$mh(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$jl(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$lh(a), c = $0b2e6adb871a3b94$var$Zg(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$L();
            $0b2e6adb871a3b94$var$mh(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$jl(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Rk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Sk;
var $0b2e6adb871a3b94$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Rk
    ]
}, $0b2e6adb871a3b94$var$ul = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$vl = {
    bundleType: $0b2e6adb871a3b94$var$ul.bundleType,
    version: $0b2e6adb871a3b94$var$ul.version,
    rendererPackageName: $0b2e6adb871a3b94$var$ul.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$ul.findFiberByHostInstance || $0b2e6adb871a3b94$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$wl.isDisabled && $0b2e6adb871a3b94$var$wl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$wl.inject($0b2e6adb871a3b94$var$vl), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$wl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$tl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$dl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Sk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$pl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$sl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$nl(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$pl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$sl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$pl(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Sk(function() {
        $0b2e6adb871a3b94$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Rk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$pl(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$sl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("acw62", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2pUnB"));

});

parcelRegister("fO90s", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
"use strict";
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});



parcelRegister("gbH6E", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $bc8f1c68f78f02e6$export$bf730a2d8bf68b42, (v) => $bc8f1c68f78f02e6$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bc8f1c68f78f02e6$export$bf730a2d8bf68b42;
"use strict";

var $acw62 = parcelRequire("acw62");
function $bc8f1c68f78f02e6$var$n(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $bc8f1c68f78f02e6$var$p = "function" === typeof Object.is ? Object.is : $bc8f1c68f78f02e6$var$n, $bc8f1c68f78f02e6$var$q = $acw62.useSyncExternalStore, $bc8f1c68f78f02e6$var$r = $acw62.useRef, $bc8f1c68f78f02e6$var$t = $acw62.useEffect, $bc8f1c68f78f02e6$var$u = $acw62.useMemo, $bc8f1c68f78f02e6$var$v = $acw62.useDebugValue;
$bc8f1c68f78f02e6$export$bf730a2d8bf68b42 = function(a, b, e, l, h) {
    var c = $bc8f1c68f78f02e6$var$r(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $bc8f1c68f78f02e6$var$u(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== h && f.hasValue) {
                    var b = f.value;
                    if (h(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($bc8f1c68f78f02e6$var$p(d, a)) return b;
            var e = l(a);
            if (void 0 !== h && h(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        h
    ]);
    var d = $bc8f1c68f78f02e6$var$q(a, c[0], c[1]);
    $bc8f1c68f78f02e6$var$t(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $bc8f1c68f78f02e6$var$v(d);
    return d;
};

});

parcelRegister("hOzOt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $kZO5c = parcelRequire("kZO5c");
function $cf82e2ef667d5788$var$emptyFunction() {}
function $cf82e2ef667d5788$var$emptyFunctionWithReset() {}
$cf82e2ef667d5788$var$emptyFunctionWithReset.resetWarningCache = $cf82e2ef667d5788$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kZO5c) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $cf82e2ef667d5788$var$emptyFunctionWithReset,
        resetWarningCache: $cf82e2ef667d5788$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $f4905a8b274aa381$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});


parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
"use strict";

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});

parcelRegister("45fvw", function(module, exports) {
//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    "use strict";
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === "[object Object]";
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, "toString")) a.toString = b.toString;
        if (hasOwnProp(b, "valueOf")) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m), parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            }), isNowValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
            if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
            else return isNowValid;
        }
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) console.warn("Deprecation warning: " + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = "";
                    if (typeof arguments[i] === "object") {
                        arg += "\n[" + i + "] ";
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ": " + arguments[0][key] + ", ";
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this["_" + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar["sameElse"];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = "" + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === "string") func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, "");
        return input.replace(/\\/g, "");
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = "", i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") return tok.slice(1);
            return tok;
        }).join("");
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = "Invalid date";
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace("%d", number);
    }
    var defaultRelativeTime = {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        w: "a week",
        ww: "%d weeks",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? "future" : "past"];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {};
    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + "s"] = aliases[shorthand] = unit;
    }
    function normalizeUnits(units) {
        return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {};
    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        return mom.isValid() ? mom._d["get" + (mom._isUTC ? "UTC" : "") + unit]() : NaN;
    }
    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === "FullYear" && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                value = toInt(value);
                mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](value, mom.month(), daysInMonth(value, mom.month()));
            } else mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](value);
        }
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === "object") {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === "string") token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken("M", [
        "MM",
        2
    ], "Mo", function() {
        return this.month() + 1;
    });
    addFormatToken("MMM", 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken("MMMM", 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // ALIASES
    addUnitAlias("month", "M");
    // PRIORITY
    addUnitPriority("month", 8);
    // PARSING
    addRegexToken("M", match1to2);
    addRegexToken("MM", match1to2, match2);
    addRegexToken("MMM", function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken("MMMM", function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        "M",
        "MM"
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        "MMM",
        "MMMM"
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months["standalone"];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? "format" : "standalone"][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? "format" : "standalone"][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, "").toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "MMM") {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === "MMM") {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp("^" + this.months(mom, "").replace(".", "") + "$", "i");
                this._shortMonthsParse[i] = new RegExp("^" + this.monthsShort(mom, "").replace(".", "") + "$", "i");
            }
            if (!strict && !this._monthsParse[i]) {
                regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
                this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "MMMM" && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === "MMM" && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        var dayOfMonth;
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === "string") {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d["set" + (mom._isUTC ? "UTC" : "") + "Month"](value, dayOfMonth);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, "Month");
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, "_monthsShortRegex")) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, "_monthsRegex")) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortPieces.push(this.monthsShort(mom, ""));
            longPieces.push(this.months(mom, ""));
            mixedPieces.push(this.months(mom, ""));
            mixedPieces.push(this.monthsShort(mom, ""));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for(i = 0; i < 12; i++){
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for(i = 0; i < 24; i++)mixedPieces[i] = regexEscape(mixedPieces[i]);
        this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._monthsShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken("Y", 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : "+" + y;
    });
    addFormatToken(0, [
        "YY",
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        "YYYY",
        4
    ], 0, "year");
    addFormatToken(0, [
        "YYYYY",
        5
    ], 0, "year");
    addFormatToken(0, [
        "YYYYYY",
        6,
        true
    ], 0, "year");
    // ALIASES
    addUnitAlias("year", "y");
    // PRIORITIES
    addUnitPriority("year", 1);
    // PARSING
    addRegexToken("Y", matchSigned);
    addRegexToken("YY", match1to2, match2);
    addRegexToken("YYYY", match1to4, match4);
    addRegexToken("YYYYY", match1to6, match6);
    addRegexToken("YYYYYY", match1to6, match6);
    addParseToken([
        "YYYYY",
        "YYYYYY"
    ], YEAR);
    addParseToken("YYYY", function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken("YY", function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken("Y", function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet("FullYear", true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken("w", [
        "ww",
        2
    ], "wo", "week");
    addFormatToken("W", [
        "WW",
        2
    ], "Wo", "isoWeek");
    // ALIASES
    addUnitAlias("week", "w");
    addUnitAlias("isoWeek", "W");
    // PRIORITIES
    addUnitPriority("week", 5);
    addUnitPriority("isoWeek", 5);
    // PARSING
    addRegexToken("w", match1to2);
    addRegexToken("ww", match1to2, match2);
    addRegexToken("W", match1to2);
    addRegexToken("WW", match1to2, match2);
    addWeekParseToken([
        "w",
        "ww",
        "W",
        "WW"
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    // FORMATTING
    addFormatToken("d", 0, "do", "day");
    addFormatToken("dd", 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken("ddd", 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken("dddd", 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken("e", 0, 0, "weekday");
    addFormatToken("E", 0, 0, "isoWeekday");
    // ALIASES
    addUnitAlias("day", "d");
    addUnitAlias("weekday", "e");
    addUnitAlias("isoWeekday", "E");
    // PRIORITY
    addUnitPriority("day", 11);
    addUnitPriority("weekday", 11);
    addUnitPriority("isoWeekday", 11);
    // PARSING
    addRegexToken("d", match1to2);
    addRegexToken("e", match1to2);
    addRegexToken("E", match1to2);
    addRegexToken("dd", function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken("ddd", function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken("dddd", function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        "dd",
        "ddd",
        "dddd"
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        "d",
        "e",
        "E"
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== "string") return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === "number") return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === "string") return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? "format" : "standalone"];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, "").toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, "").toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp("^" + this.weekdays(mom, "").replace(".", "\\.?") + "$", "i");
                this._shortWeekdaysParse[i] = new RegExp("^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$", "i");
                this._minWeekdaysParse[i] = new RegExp("^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$", "i");
            }
            if (!this._weekdaysParse[i]) {
                regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
                this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "dd" && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, "d");
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, "d");
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysRegex")) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysShortRegex")) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysMinRegex")) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ""));
            shortp = regexEscape(this.weekdaysShort(mom, ""));
            longp = regexEscape(this.weekdays(mom, ""));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._weekdaysShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
        this._weekdaysMinStrictRegex = new RegExp("^(" + minPieces.join("|") + ")", "i");
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken("H", [
        "HH",
        2
    ], 0, "hour");
    addFormatToken("h", [
        "hh",
        2
    ], 0, hFormat);
    addFormatToken("k", [
        "kk",
        2
    ], 0, kFormat);
    addFormatToken("hmm", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken("hmmss", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken("Hmm", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken("Hmmss", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem("a", true);
    meridiem("A", false);
    // ALIASES
    addUnitAlias("hour", "h");
    // PRIORITY
    addUnitPriority("hour", 13);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken("a", matchMeridiem);
    addRegexToken("A", matchMeridiem);
    addRegexToken("H", match1to2);
    addRegexToken("h", match1to2);
    addRegexToken("k", match1to2);
    addRegexToken("HH", match1to2, match2);
    addRegexToken("hh", match1to2, match2);
    addRegexToken("kk", match1to2, match2);
    addRegexToken("hmm", match3to4);
    addRegexToken("hmmss", match5to6);
    addRegexToken("Hmm", match3to4);
    addRegexToken("Hmmss", match5to6);
    addParseToken([
        "H",
        "HH"
    ], HOUR);
    addParseToken([
        "k",
        "kk"
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        "a",
        "A"
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        "h",
        "hh"
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("Hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken("Hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + "").toLowerCase().charAt(0) === "p";
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet("Hours", true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? "pm" : "PM";
        else return isLower ? "am" : "AM";
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace("_", "-") : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split("-");
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split("-") : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join("-"));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        return name.match("^[^/\\\\]*$") != null;
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire("./locale/" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== "undefined" && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn("Locale " + key + " not found. Did you forget to load it?");
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            "YYYYYY-MM-DD",
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            "YYYY-MM-DD",
            /\d{4}-\d\d-\d\d/
        ],
        [
            "GGGG-[W]WW-E",
            /\d{4}-W\d\d-\d/
        ],
        [
            "GGGG-[W]WW",
            /\d{4}-W\d\d/,
            false
        ],
        [
            "YYYY-DDD",
            /\d{4}-\d{3}/
        ],
        [
            "YYYY-MM",
            /\d{4}-\d\d/,
            false
        ],
        [
            "YYYYYYMMDD",
            /[+-]\d{10}/
        ],
        [
            "YYYYMMDD",
            /\d{8}/
        ],
        [
            "GGGG[W]WWE",
            /\d{4}W\d{3}/
        ],
        [
            "GGGG[W]WW",
            /\d{4}W\d{2}/,
            false
        ],
        [
            "YYYYDDD",
            /\d{7}/
        ],
        [
            "YYYYMM",
            /\d{6}/,
            false
        ],
        [
            "YYYY",
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            "HH:mm:ss.SSSS",
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            "HH:mm:ss,SSSS",
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            "HH:mm:ss",
            /\d\d:\d\d:\d\d/
        ],
        [
            "HH:mm",
            /\d\d:\d\d/
        ],
        [
            "HHmmss.SSSS",
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            "HHmmss,SSSS",
            /\d\d\d\d\d\d,\d+/
        ],
        [
            "HHmmss",
            /\d\d\d\d\d\d/
        ],
        [
            "HHmm",
            /\d\d\d\d/
        ],
        [
            "HH",
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || " ") + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = "Z";
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? " UTC" : ""));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = "" + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, "d");
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === "") return createInvalid({
            nullInput: true
        });
        if (typeof input === "string") config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === "string") configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isBefore", args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isAfter", args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        "year",
        "quarter",
        "month",
        "week",
        "day",
        "hour",
        "minute",
        "second",
        "millisecond"
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = "+";
            if (offset < 0) {
                offset = -offset;
                sign = "-";
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset("Z", ":");
    offset("ZZ", "");
    // PARSING
    addRegexToken("Z", matchShortOffset);
    addRegexToken("ZZ", matchShortOffset);
    addParseToken([
        "Z",
        "ZZ"
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || "").match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + "").match(chunkOffset) || [
            "-",
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === "+" ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === "string") {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, "m");
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, "m"), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== "string") input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), "m");
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === "string") {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, "_locale")) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, "_isValid")) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(",", "."));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, "M").isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, "M");
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). " + "See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.");
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, "Month") + months * isAdding);
        if (days) set$1(mom, "Date", get(mom, "Date") + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
    function isString(input) {
        return typeof input === "string" || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "years",
            "year",
            "y",
            "months",
            "month",
            "M",
            "days",
            "day",
            "d",
            "dates",
            "date",
            "D",
            "hours",
            "hour",
            "h",
            "minutes",
            "minute",
            "m",
            "seconds",
            "second",
            "s",
            "milliseconds",
            "millisecond",
            "ms"
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "sameDay",
            "nextDay",
            "lastDay",
            "nextWeek",
            "lastWeek",
            "sameElse"
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, "days", true);
        return diff < -6 ? "sameElse" : diff < -1 ? "lastWeek" : diff < 0 ? "lastDay" : diff < 1 ? "sameDay" : diff < 2 ? "nextDay" : diff < 7 ? "nextWeek" : "sameElse";
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf("day"), format = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || "()";
        return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case "year":
                output = monthDiff(this, that) / 12;
                break;
            case "month":
                output = monthDiff(this, that);
                break;
            case "quarter":
                output = monthDiff(this, that) / 3;
                break;
            case "second":
                output = (this - that) / 1e3;
                break; // 1000
            case "minute":
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case "hour":
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case "day":
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case "week":
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
    hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
    function toString() {
        return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ");
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace("Z", formatMoment(m, "Z"));
        }
        return formatMoment(m, utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
        var func = "moment", zone = "", prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
            zone = "Z";
        }
        prefix = "[" + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
        datetime = "-MM-DD[T]HH:mm:ss.SSS";
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year(), 0, 1);
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case "month":
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case "hour":
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case "minute":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case "second":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case "month":
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case "hour":
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case "minute":
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case "second":
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken("N", 0, 0, "eraAbbr");
    addFormatToken("NN", 0, 0, "eraAbbr");
    addFormatToken("NNN", 0, 0, "eraAbbr");
    addFormatToken("NNNN", 0, 0, "eraName");
    addFormatToken("NNNNN", 0, 0, "eraNarrow");
    addFormatToken("y", [
        "y",
        1
    ], "yo", "eraYear");
    addFormatToken("y", [
        "yy",
        2
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyy",
        3
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyyy",
        4
    ], 0, "eraYear");
    addRegexToken("N", matchEraAbbr);
    addRegexToken("NN", matchEraAbbr);
    addRegexToken("NNN", matchEraAbbr);
    addRegexToken("NNNN", matchEraName);
    addRegexToken("NNNNN", matchEraNarrow);
    addParseToken([
        "N",
        "NN",
        "NNN",
        "NNNN",
        "NNNNN"
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken("y", matchUnsigned);
    addRegexToken("yy", matchUnsigned);
    addRegexToken("yyy", matchUnsigned);
    addRegexToken("yyyy", matchUnsigned);
    addRegexToken("yo", matchEraYearOrdinal);
    addParseToken([
        "y",
        "yy",
        "yyy",
        "yyyy"
    ], YEAR);
    addParseToken([
        "yo"
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale("en")._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case "string":
                    // truncate time
                    date = hooks(eras[i].since).startOf("day");
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case "undefined":
                    eras[i].until = Infinity;
                    break;
                case "string":
                    // truncate time
                    date = hooks(eras[i].until).startOf("day").valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case "N":
                case "NN":
                case "NNN":
                    if (abbr === eraName) return eras[i];
                    break;
                case "NNNN":
                    if (name === eraName) return eras[i];
                    break;
                case "NNNNN":
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return "";
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return "";
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return "";
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNameRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, "_erasAbbrRegex")) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNarrowRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));
            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }
        this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
        this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
        this._erasNarrowRegex = new RegExp("^(" + narrowPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken(0, [
        "gg",
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        "GG",
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken("gggg", "weekYear");
    addWeekYearFormatToken("ggggg", "weekYear");
    addWeekYearFormatToken("GGGG", "isoWeekYear");
    addWeekYearFormatToken("GGGGG", "isoWeekYear");
    // ALIASES
    addUnitAlias("weekYear", "gg");
    addUnitAlias("isoWeekYear", "GG");
    // PRIORITY
    addUnitPriority("weekYear", 1);
    addUnitPriority("isoWeekYear", 1);
    // PARSING
    addRegexToken("G", matchSigned);
    addRegexToken("g", matchSigned);
    addRegexToken("GG", match1to2, match2);
    addRegexToken("gg", match1to2, match2);
    addRegexToken("GGGG", match1to4, match4);
    addRegexToken("gggg", match1to4, match4);
    addRegexToken("GGGGG", match1to6, match6);
    addRegexToken("ggggg", match1to6, match6);
    addWeekParseToken([
        "gggg",
        "ggggg",
        "GGGG",
        "GGGGG"
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        "gg",
        "GG"
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken("Q", 0, "Qo", "quarter");
    // ALIASES
    addUnitAlias("quarter", "Q");
    // PRIORITY
    addUnitPriority("quarter", 7);
    // PARSING
    addRegexToken("Q", match1);
    addParseToken("Q", function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken("D", [
        "DD",
        2
    ], "Do", "date");
    // ALIASES
    addUnitAlias("date", "D");
    // PRIORITY
    addUnitPriority("date", 9);
    // PARSING
    addRegexToken("D", match1to2);
    addRegexToken("DD", match1to2, match2);
    addRegexToken("Do", function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        "D",
        "DD"
    ], DATE);
    addParseToken("Do", function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet("Date", true);
    // FORMATTING
    addFormatToken("DDD", [
        "DDDD",
        3
    ], "DDDo", "dayOfYear");
    // ALIASES
    addUnitAlias("dayOfYear", "DDD");
    // PRIORITY
    addUnitPriority("dayOfYear", 4);
    // PARSING
    addRegexToken("DDD", match1to3);
    addRegexToken("DDDD", match3);
    addParseToken([
        "DDD",
        "DDDD"
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
    }
    // FORMATTING
    addFormatToken("m", [
        "mm",
        2
    ], 0, "minute");
    // ALIASES
    addUnitAlias("minute", "m");
    // PRIORITY
    addUnitPriority("minute", 14);
    // PARSING
    addRegexToken("m", match1to2);
    addRegexToken("mm", match1to2, match2);
    addParseToken([
        "m",
        "mm"
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet("Minutes", false);
    // FORMATTING
    addFormatToken("s", [
        "ss",
        2
    ], 0, "second");
    // ALIASES
    addUnitAlias("second", "s");
    // PRIORITY
    addUnitPriority("second", 15);
    // PARSING
    addRegexToken("s", match1to2);
    addRegexToken("ss", match1to2, match2);
    addParseToken([
        "s",
        "ss"
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet("Seconds", false);
    // FORMATTING
    addFormatToken("S", 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        "SS",
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        "SSS",
        3
    ], 0, "millisecond");
    addFormatToken(0, [
        "SSSS",
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        "SSSSS",
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        "SSSSSS",
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        "SSSSSSS",
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        "SSSSSSSS",
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        "SSSSSSSSS",
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // ALIASES
    addUnitAlias("millisecond", "ms");
    // PRIORITY
    addUnitPriority("millisecond", 16);
    // PARSING
    addRegexToken("S", match1to3, match1);
    addRegexToken("SS", match1to3, match2);
    addRegexToken("SSS", match1to3, match3);
    var token, getSetMillisecond;
    for(token = "SSSS"; token.length <= 9; token += "S")addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(("0." + input) * 1000);
    }
    for(token = "S"; token.length <= 9; token += "S")addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet("Milliseconds", false);
    // FORMATTING
    addFormatToken("z", 0, 0, "zoneAbbr");
    addFormatToken("zz", 0, 0, "zoneName");
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? "UTC" : "";
    }
    function getZoneName() {
        return this._isUTC ? "Coordinated Universal Time" : "";
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== "undefined" && Symbol.for != null) proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
        return "Moment<" + this.format() + ">";
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate("dates accessor is deprecated. Use date instead.", getSetDayOfMonth);
    proto.months = deprecate("months accessor is deprecated. Use month instead", getSetMonth);
    proto.years = deprecate("years accessor is deprecated. Use year instead", getSetYear);
    proto.zone = deprecate("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", getSetZone);
    proto.isDSTShifted = deprecate("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || "";
        if (index != null) return get$1(format, index, field, "month");
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, "month");
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === "boolean") {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, "day");
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, "day");
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, "months");
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, "monthsShort");
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdays");
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysShort");
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysMin");
    }
    getSetGlobalLocale("en", {
        eras: [
            {
                since: "0001-01-01",
                until: Infinity,
                offset: 1,
                name: "Anno Domini",
                narrow: "AD",
                abbr: "AD"
            },
            {
                since: "0000-12-31",
                until: -Infinity,
                offset: 1,
                name: "Before Christ",
                narrow: "BC",
                abbr: "BC"
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate("moment.lang is deprecated. Use moment.locale instead.", getSetGlobalLocale);
    hooks.langData = deprecate("moment.langData is deprecated. Use moment.localeData instead.", getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === "month" || units === "quarter" || units === "year") {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case "month":
                    return months;
                case "quarter":
                    return months / 3;
                case "year":
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case "week":
                    return days / 7 + milliseconds / 6048e5;
                case "day":
                    return days + milliseconds / 864e5;
                case "hour":
                    return days * 24 + milliseconds / 36e5;
                case "minute":
                    return days * 1440 + milliseconds / 6e4;
                case "second":
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case "millisecond":
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error("Unknown unit " + units);
            }
        }
    }
    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) return NaN;
        return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y");
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + "s"]() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as("s")), minutes = round(duration.as("m")), hours = round(duration.as("h")), days = round(duration.as("d")), months = round(duration.as("M")), weeks = round(duration.as("w")), years = round(duration.as("y")), a = seconds <= thresholds.ss && [
            "s",
            seconds
        ] || seconds < thresholds.s && [
            "ss",
            seconds
        ] || minutes <= 1 && [
            "m"
        ] || minutes < thresholds.m && [
            "mm",
            minutes
        ] || hours <= 1 && [
            "h"
        ] || hours < thresholds.h && [
            "hh",
            hours
        ] || days <= 1 && [
            "d"
        ] || days < thresholds.d && [
            "dd",
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            "w"
        ] || weeks < thresholds.w && [
            "ww",
            weeks
        ];
        a = a || months <= 1 && [
            "M"
        ] || months < thresholds.M && [
            "MM",
            months
        ] || years <= 1 && [
            "y"
        ] || [
            "yy",
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === "function") {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === "s") thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === "object") {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === "boolean") withSuffix = argWithSuffix;
        if (typeof argThresholds === "object") {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return "P0D";
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, "") : "";
        totalSign = total < 0 ? "-" : "";
        ymSign = sign(this._months) !== sign(total) ? "-" : "";
        daysSign = sign(this._days) !== sign(total) ? "-" : "";
        hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
        return totalSign + "P" + (years ? ymSign + years + "Y" : "") + (months ? ymSign + months + "M" : "") + (days ? daysSign + days + "D" : "") + (hours || minutes || seconds ? "T" : "") + (hours ? hmsSign + hours + "H" : "") + (minutes ? hmsSign + minutes + "M" : "") + (seconds ? hmsSign + s + "S" : "");
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken("X", 0, 0, "unix");
    addFormatToken("x", 0, 0, "valueOf");
    // PARSING
    addRegexToken("x", matchSigned);
    addRegexToken("X", matchTimestamp);
    addParseToken("X", function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken("x", function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = "2.29.4";
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
        DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
        DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
        DATE: "YYYY-MM-DD",
        TIME: "HH:mm",
        TIME_SECONDS: "HH:mm:ss",
        TIME_MS: "HH:mm:ss.SSS",
        WEEK: "GGGG-[W]WW",
        MONTH: "YYYY-MM"
    };
    return hooks;
});

});

parcelRegister("12eZZ", function(module, exports) {
(function() {
    var base64map = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", crypt = {
        // Bit-wise rotation left
        rotl: function(n, b) {
            return n << b | n >>> 32 - b;
        },
        // Bit-wise rotation right
        rotr: function(n, b) {
            return n << 32 - b | n >>> b;
        },
        // Swap big-endian to little-endian and vice versa
        endian: function(n) {
            // If number given, swap endian
            if (n.constructor == Number) return crypt.rotl(n, 8) & 0x00FF00FF | crypt.rotl(n, 24) & 0xFF00FF00;
            // Else, assume array and swap all items
            for(var i = 0; i < n.length; i++)n[i] = crypt.endian(n[i]);
            return n;
        },
        // Generate an array of any length of random bytes
        randomBytes: function(n) {
            for(var bytes = []; n > 0; n--)bytes.push(Math.floor(Math.random() * 256));
            return bytes;
        },
        // Convert a byte array to big-endian 32-bit words
        bytesToWords: function(bytes) {
            for(var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)words[b >>> 5] |= bytes[i] << 24 - b % 32;
            return words;
        },
        // Convert big-endian 32-bit words to a byte array
        wordsToBytes: function(words) {
            for(var bytes = [], b = 0; b < words.length * 32; b += 8)bytes.push(words[b >>> 5] >>> 24 - b % 32 & 0xFF);
            return bytes;
        },
        // Convert a byte array to a hex string
        bytesToHex: function(bytes) {
            for(var hex = [], i = 0; i < bytes.length; i++){
                hex.push((bytes[i] >>> 4).toString(16));
                hex.push((bytes[i] & 0xF).toString(16));
            }
            return hex.join("");
        },
        // Convert a hex string to a byte array
        hexToBytes: function(hex) {
            for(var bytes = [], c = 0; c < hex.length; c += 2)bytes.push(parseInt(hex.substr(c, 2), 16));
            return bytes;
        },
        // Convert a byte array to a base-64 string
        bytesToBase64: function(bytes) {
            for(var base64 = [], i = 0; i < bytes.length; i += 3){
                var triplet = bytes[i] << 16 | bytes[i + 1] << 8 | bytes[i + 2];
                for(var j = 0; j < 4; j++)if (i * 8 + j * 6 <= bytes.length * 8) base64.push(base64map.charAt(triplet >>> 6 * (3 - j) & 0x3F));
                else base64.push("=");
            }
            return base64.join("");
        },
        // Convert a base-64 string to a byte array
        base64ToBytes: function(base64) {
            // Remove non-base-64 characters
            base64 = base64.replace(/[^A-Z0-9+\/]/ig, "");
            for(var bytes = [], i = 0, imod4 = 0; i < base64.length; imod4 = ++i % 4){
                if (imod4 == 0) continue;
                bytes.push((base64map.indexOf(base64.charAt(i - 1)) & Math.pow(2, -2 * imod4 + 8) - 1) << imod4 * 2 | base64map.indexOf(base64.charAt(i)) >>> 6 - imod4 * 2);
            }
            return bytes;
        }
    };
    module.exports = crypt;
})();

});

parcelRegister("a74v9", function(module, exports) {
var $75ce0cb6501c8271$var$charenc = {
    // UTF-8 encoding
    utf8: {
        // Convert a string to a byte array
        stringToBytes: function(str) {
            return $75ce0cb6501c8271$var$charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
        },
        // Convert a byte array to a string
        bytesToString: function(bytes) {
            return decodeURIComponent(escape($75ce0cb6501c8271$var$charenc.bin.bytesToString(bytes)));
        }
    },
    // Binary encoding
    bin: {
        // Convert a string to a byte array
        stringToBytes: function(str) {
            for(var bytes = [], i = 0; i < str.length; i++)bytes.push(str.charCodeAt(i) & 0xFF);
            return bytes;
        },
        // Convert a byte array to a string
        bytesToString: function(bytes) {
            for(var str = [], i = 0; i < bytes.length; i++)str.push(String.fromCharCode(bytes[i]));
            return str.join("");
        }
    }
};
module.exports = $75ce0cb6501c8271$var$charenc;

});

parcelRegister("7B5Ea", function(module, exports) {
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ // The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function(obj) {
    return obj != null && ($58805e71bbbc0b37$var$isBuffer(obj) || $58805e71bbbc0b37$var$isSlowBuffer(obj) || !!obj._isBuffer);
};
function $58805e71bbbc0b37$var$isBuffer(obj) {
    return !!obj.constructor && typeof obj.constructor.isBuffer === "function" && obj.constructor.isBuffer(obj);
}
// For Node v0.10 support. Remove this eventually.
function $58805e71bbbc0b37$var$isSlowBuffer(obj) {
    return typeof obj.readFloatLE === "function" && typeof obj.slice === "function" && $58805e71bbbc0b37$var$isBuffer(obj.slice(0, 0));
}

});

parcelRegister("dNL7g", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $a0c46644c9629c37$export$2b8d127b894957b9, (v) => $a0c46644c9629c37$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $a0c46644c9629c37$export$cea3a54a6425200c, (v) => $a0c46644c9629c37$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $a0c46644c9629c37$export$a7c73072b1a182ae, (v) => $a0c46644c9629c37$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $a0c46644c9629c37$export$9f27bc3417b4524d, (v) => $a0c46644c9629c37$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $a0c46644c9629c37$export$db77ccec0bb4ccac, (v) => $a0c46644c9629c37$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $a0c46644c9629c37$export$8392c0c9d3dcbd35, (v) => $a0c46644c9629c37$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $a0c46644c9629c37$export$ffb0004e005737fa, (v) => $a0c46644c9629c37$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $a0c46644c9629c37$export$b624eff549462981, (v) => $a0c46644c9629c37$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $a0c46644c9629c37$export$7897aa7841a5380c, (v) => $a0c46644c9629c37$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $a0c46644c9629c37$export$602eac185826482c, (v) => $a0c46644c9629c37$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $a0c46644c9629c37$export$e2c29f18771995cb, (v) => $a0c46644c9629c37$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $a0c46644c9629c37$export$5f8d39834fd61797, (v) => $a0c46644c9629c37$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $a0c46644c9629c37$export$74bf444e3cd11ea5, (v) => $a0c46644c9629c37$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $a0c46644c9629c37$export$92387174baf9b227, (v) => $a0c46644c9629c37$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $a0c46644c9629c37$export$ec112efeb987d9c6, (v) => $a0c46644c9629c37$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $a0c46644c9629c37$export$b706b080d889d2c9, (v) => $a0c46644c9629c37$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $a0c46644c9629c37$export$5be5a87408f70ddc, (v) => $a0c46644c9629c37$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $a0c46644c9629c37$export$45a5e7f76e0caa8d, (v) => $a0c46644c9629c37$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $a0c46644c9629c37$export$455c2e768291efa6, (v) => $a0c46644c9629c37$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $a0c46644c9629c37$export$9522e17588c12572, (v) => $a0c46644c9629c37$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $a0c46644c9629c37$export$2110ac352bb060b9, (v) => $a0c46644c9629c37$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $a0c46644c9629c37$export$56885ab8b9c456ab, (v) => $a0c46644c9629c37$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $a0c46644c9629c37$export$d927fcb6adf8f9de, (v) => $a0c46644c9629c37$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $a0c46644c9629c37$export$b82d16f27459e05a, (v) => $a0c46644c9629c37$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $a0c46644c9629c37$export$522c17b4f5e123e8, (v) => $a0c46644c9629c37$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $a0c46644c9629c37$export$1aabd8a0274ecfd6, (v) => $a0c46644c9629c37$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $a0c46644c9629c37$export$9b621391a187a31a, (v) => $a0c46644c9629c37$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $a0c46644c9629c37$export$f5bbd400c2f4426f, (v) => $a0c46644c9629c37$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a0c46644c9629c37$export$2b8d127b894957b9;
var $a0c46644c9629c37$export$cea3a54a6425200c;
var $a0c46644c9629c37$export$a7c73072b1a182ae;
var $a0c46644c9629c37$export$9f27bc3417b4524d;
var $a0c46644c9629c37$export$db77ccec0bb4ccac;
var $a0c46644c9629c37$export$8392c0c9d3dcbd35;
var $a0c46644c9629c37$export$ffb0004e005737fa;
var $a0c46644c9629c37$export$b624eff549462981;
var $a0c46644c9629c37$export$7897aa7841a5380c;
var $a0c46644c9629c37$export$602eac185826482c;
var $a0c46644c9629c37$export$e2c29f18771995cb;
var $a0c46644c9629c37$export$5f8d39834fd61797;
var $a0c46644c9629c37$export$74bf444e3cd11ea5;
var $a0c46644c9629c37$export$92387174baf9b227;
var $a0c46644c9629c37$export$ec112efeb987d9c6;
var $a0c46644c9629c37$export$b706b080d889d2c9;
var $a0c46644c9629c37$export$5be5a87408f70ddc;
var $a0c46644c9629c37$export$45a5e7f76e0caa8d;
var $a0c46644c9629c37$export$455c2e768291efa6;
var $a0c46644c9629c37$export$9522e17588c12572;
var $a0c46644c9629c37$export$2110ac352bb060b9;
var $a0c46644c9629c37$export$56885ab8b9c456ab;
var $a0c46644c9629c37$export$d927fcb6adf8f9de;
var $a0c46644c9629c37$export$b82d16f27459e05a;
var $a0c46644c9629c37$export$522c17b4f5e123e8;
var $a0c46644c9629c37$export$1aabd8a0274ecfd6;
var $a0c46644c9629c37$export$9b621391a187a31a;
var $a0c46644c9629c37$export$f5bbd400c2f4426f;
"use strict";
var $a0c46644c9629c37$var$b = "function" === typeof Symbol && Symbol.for, $a0c46644c9629c37$var$c = $a0c46644c9629c37$var$b ? Symbol.for("react.element") : 60103, $a0c46644c9629c37$var$d = $a0c46644c9629c37$var$b ? Symbol.for("react.portal") : 60106, $a0c46644c9629c37$var$e = $a0c46644c9629c37$var$b ? Symbol.for("react.fragment") : 60107, $a0c46644c9629c37$var$f = $a0c46644c9629c37$var$b ? Symbol.for("react.strict_mode") : 60108, $a0c46644c9629c37$var$g = $a0c46644c9629c37$var$b ? Symbol.for("react.profiler") : 60114, $a0c46644c9629c37$var$h = $a0c46644c9629c37$var$b ? Symbol.for("react.provider") : 60109, $a0c46644c9629c37$var$k = $a0c46644c9629c37$var$b ? Symbol.for("react.context") : 60110, $a0c46644c9629c37$var$l = $a0c46644c9629c37$var$b ? Symbol.for("react.async_mode") : 60111, $a0c46644c9629c37$var$m = $a0c46644c9629c37$var$b ? Symbol.for("react.concurrent_mode") : 60111, $a0c46644c9629c37$var$n = $a0c46644c9629c37$var$b ? Symbol.for("react.forward_ref") : 60112, $a0c46644c9629c37$var$p = $a0c46644c9629c37$var$b ? Symbol.for("react.suspense") : 60113, $a0c46644c9629c37$var$q = $a0c46644c9629c37$var$b ? Symbol.for("react.suspense_list") : 60120, $a0c46644c9629c37$var$r = $a0c46644c9629c37$var$b ? Symbol.for("react.memo") : 60115, $a0c46644c9629c37$var$t = $a0c46644c9629c37$var$b ? Symbol.for("react.lazy") : 60116, $a0c46644c9629c37$var$v = $a0c46644c9629c37$var$b ? Symbol.for("react.block") : 60121, $a0c46644c9629c37$var$w = $a0c46644c9629c37$var$b ? Symbol.for("react.fundamental") : 60117, $a0c46644c9629c37$var$x = $a0c46644c9629c37$var$b ? Symbol.for("react.responder") : 60118, $a0c46644c9629c37$var$y = $a0c46644c9629c37$var$b ? Symbol.for("react.scope") : 60119;
function $a0c46644c9629c37$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $a0c46644c9629c37$var$c:
                switch(a = a.type, a){
                    case $a0c46644c9629c37$var$l:
                    case $a0c46644c9629c37$var$m:
                    case $a0c46644c9629c37$var$e:
                    case $a0c46644c9629c37$var$g:
                    case $a0c46644c9629c37$var$f:
                    case $a0c46644c9629c37$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $a0c46644c9629c37$var$k:
                            case $a0c46644c9629c37$var$n:
                            case $a0c46644c9629c37$var$t:
                            case $a0c46644c9629c37$var$r:
                            case $a0c46644c9629c37$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $a0c46644c9629c37$var$d:
                return u;
        }
    }
}
function $a0c46644c9629c37$var$A(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$m;
}
$a0c46644c9629c37$export$2b8d127b894957b9 = $a0c46644c9629c37$var$l;
$a0c46644c9629c37$export$cea3a54a6425200c = $a0c46644c9629c37$var$m;
$a0c46644c9629c37$export$a7c73072b1a182ae = $a0c46644c9629c37$var$k;
$a0c46644c9629c37$export$9f27bc3417b4524d = $a0c46644c9629c37$var$h;
$a0c46644c9629c37$export$db77ccec0bb4ccac = $a0c46644c9629c37$var$c;
$a0c46644c9629c37$export$8392c0c9d3dcbd35 = $a0c46644c9629c37$var$n;
$a0c46644c9629c37$export$ffb0004e005737fa = $a0c46644c9629c37$var$e;
$a0c46644c9629c37$export$b624eff549462981 = $a0c46644c9629c37$var$t;
$a0c46644c9629c37$export$7897aa7841a5380c = $a0c46644c9629c37$var$r;
$a0c46644c9629c37$export$602eac185826482c = $a0c46644c9629c37$var$d;
$a0c46644c9629c37$export$e2c29f18771995cb = $a0c46644c9629c37$var$g;
$a0c46644c9629c37$export$5f8d39834fd61797 = $a0c46644c9629c37$var$f;
$a0c46644c9629c37$export$74bf444e3cd11ea5 = $a0c46644c9629c37$var$p;
$a0c46644c9629c37$export$92387174baf9b227 = function(a) {
    return $a0c46644c9629c37$var$A(a) || $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$l;
};
$a0c46644c9629c37$export$ec112efeb987d9c6 = $a0c46644c9629c37$var$A;
$a0c46644c9629c37$export$b706b080d889d2c9 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$k;
};
$a0c46644c9629c37$export$5be5a87408f70ddc = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$h;
};
$a0c46644c9629c37$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $a0c46644c9629c37$var$c;
};
$a0c46644c9629c37$export$455c2e768291efa6 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$n;
};
$a0c46644c9629c37$export$9522e17588c12572 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$e;
};
$a0c46644c9629c37$export$2110ac352bb060b9 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$t;
};
$a0c46644c9629c37$export$56885ab8b9c456ab = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$r;
};
$a0c46644c9629c37$export$d927fcb6adf8f9de = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$d;
};
$a0c46644c9629c37$export$b82d16f27459e05a = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$g;
};
$a0c46644c9629c37$export$522c17b4f5e123e8 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$f;
};
$a0c46644c9629c37$export$1aabd8a0274ecfd6 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$p;
};
$a0c46644c9629c37$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $a0c46644c9629c37$var$e || a === $a0c46644c9629c37$var$m || a === $a0c46644c9629c37$var$g || a === $a0c46644c9629c37$var$f || a === $a0c46644c9629c37$var$p || a === $a0c46644c9629c37$var$q || "object" === typeof a && null !== a && (a.$$typeof === $a0c46644c9629c37$var$t || a.$$typeof === $a0c46644c9629c37$var$r || a.$$typeof === $a0c46644c9629c37$var$h || a.$$typeof === $a0c46644c9629c37$var$k || a.$$typeof === $a0c46644c9629c37$var$n || a.$$typeof === $a0c46644c9629c37$var$w || a.$$typeof === $a0c46644c9629c37$var$x || a.$$typeof === $a0c46644c9629c37$var$y || a.$$typeof === $a0c46644c9629c37$var$v);
};
$a0c46644c9629c37$export$f5bbd400c2f4426f = $a0c46644c9629c37$var$z;

});


var $acw62 = parcelRequire("acw62");
"use client";
function $592c29b91893a27d$export$28f2b15e704f599d() {
    const originalError = console.error;
    console.error = (...args)=>{
        if (args.length > 1 && typeof args[0] === "string" && args[0].toLowerCase().includes("extra attributes from the server") && typeof args[1] === "string" && args[1].toLowerCase().includes("data-mantine-color-scheme")) ;
        else originalError(...args);
    };
}



var $acw62 = parcelRequire("acw62");
"use client";
const $bbb97275c373484a$export$4ba45a360873bd20 = (0, $acw62.createContext)(null);
function $bbb97275c373484a$export$2f9729a1501fd576() {
    const ctx = (0, $acw62.useContext)($bbb97275c373484a$export$4ba45a360873bd20);
    if (!ctx) throw new Error("[@mantine/core] MantineProvider was not found in tree");
    return ctx;
}
function $bbb97275c373484a$export$875b251c245b8c99() {
    return $bbb97275c373484a$export$2f9729a1501fd576().cssVariablesResolver;
}
function $bbb97275c373484a$export$635322ad820b722f() {
    return $bbb97275c373484a$export$2f9729a1501fd576().classNamesPrefix;
}
function $bbb97275c373484a$export$ca3d89ae7d92a638() {
    return $bbb97275c373484a$export$2f9729a1501fd576().getStyleNonce;
}


"use client";
function $0819c57096921b23$export$65daf38465c08e79(value) {
    return value === "auto" || value === "dark" || value === "light";
}


"use client";
function $3bad1881056c620a$export$3114d9bddade735e({ key: key = "mantine-color-scheme-value" } = {}) {
    let handleStorageEvent;
    return {
        get: (defaultValue)=>{
            if (typeof window === "undefined") return defaultValue;
            try {
                const storedColorScheme = window.localStorage.getItem(key);
                return (0, $0819c57096921b23$export$65daf38465c08e79)(storedColorScheme) ? storedColorScheme : defaultValue;
            } catch (e) {
                return defaultValue;
            }
        },
        set: (value)=>{
            try {
                window.localStorage.setItem(key, value);
            } catch (error) {
                console.warn("[@mantine/core] Local storage color scheme manager was unable to save color scheme.", error);
            }
        },
        subscribe: (onUpdate)=>{
            handleStorageEvent = (event)=>{
                if (event.storageArea === window.localStorage && event.key === key) (0, $0819c57096921b23$export$65daf38465c08e79)(event.newValue) && onUpdate(event.newValue);
            };
            window.addEventListener("storage", handleStorageEvent);
        },
        unsubscribe: ()=>{
            window.removeEventListener("storage", handleStorageEvent);
        },
        clear: ()=>{
            window.localStorage.removeItem(key);
        }
    };
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
"use client";
const $562774022e0ac3ca$export$363c9f3eb56bbdbe = typeof document !== "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);


"use client";
function $e58862222fe72cb1$var$setColorSchemeAttribute(colorScheme, getRootElement) {
    var _a;
    const computedColorScheme = colorScheme !== "auto" ? colorScheme : window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
    (_a = getRootElement()) == null || _a.setAttribute("data-mantine-color-scheme", computedColorScheme);
}
function $e58862222fe72cb1$export$390785fb3763d6cf({ manager: manager, defaultColorScheme: defaultColorScheme, getRootElement: getRootElement, forceColorScheme: forceColorScheme }) {
    const media = (0, $acw62.useRef)();
    const [value, setValue] = (0, $acw62.useState)(()=>manager.get(defaultColorScheme));
    const colorSchemeValue = forceColorScheme || value;
    const setColorScheme = (0, $acw62.useCallback)((colorScheme)=>{
        if (!forceColorScheme) {
            $e58862222fe72cb1$var$setColorSchemeAttribute(colorScheme, getRootElement);
            setValue(colorScheme);
            manager.set(colorScheme);
        }
    }, [
        manager.set,
        colorSchemeValue,
        forceColorScheme
    ]);
    const clearColorScheme = (0, $acw62.useCallback)(()=>{
        setValue(defaultColorScheme);
        $e58862222fe72cb1$var$setColorSchemeAttribute(defaultColorScheme, getRootElement);
        manager.clear();
    }, [
        manager.clear,
        defaultColorScheme
    ]);
    (0, $acw62.useEffect)(()=>{
        manager.subscribe(setColorScheme);
        return manager.unsubscribe;
    }, [
        manager.subscribe,
        manager.unsubscribe
    ]);
    (0, $562774022e0ac3ca$export$363c9f3eb56bbdbe)(()=>{
        $e58862222fe72cb1$var$setColorSchemeAttribute(manager.get(defaultColorScheme), getRootElement);
    }, []);
    (0, $acw62.useEffect)(()=>{
        var _a;
        if (forceColorScheme) {
            $e58862222fe72cb1$var$setColorSchemeAttribute(forceColorScheme, getRootElement);
            return ()=>{};
        }
        media.current = window.matchMedia("(prefers-color-scheme: dark)");
        const listener = (event)=>{
            if (value === "auto") $e58862222fe72cb1$var$setColorSchemeAttribute(event.matches ? "dark" : "light", getRootElement);
        };
        (_a = media.current) == null || _a.addEventListener("change", listener);
        return ()=>{
            var _a2;
            return (_a2 = media.current) == null ? void 0 : _a2.removeEventListener("change", listener);
        };
    }, [
        value,
        forceColorScheme
    ]);
    return {
        colorScheme: colorSchemeValue,
        setColorScheme: setColorScheme,
        clearColorScheme: clearColorScheme
    };
}



"use client";
function $d45a0048df23fa10$export$aca9c65a2d2518b2({ respectReducedMotion: respectReducedMotion, getRootElement: getRootElement }) {
    (0, $562774022e0ac3ca$export$363c9f3eb56bbdbe)(()=>{
        var _a;
        if (respectReducedMotion) (_a = getRootElement()) == null || _a.setAttribute("data-respect-reduced-motion", "true");
    }, [
        respectReducedMotion
    ]);
}



var $acw62 = parcelRequire("acw62");
"use client";
const $b5aa84565affcc12$export$e60cfe038231c681 = {
    dark: [
        "#C1C2C5",
        "#A6A7AB",
        "#909296",
        "#5c5f66",
        "#373A40",
        "#2C2E33",
        "#25262b",
        "#1A1B1E",
        "#141517",
        "#101113"
    ],
    gray: [
        "#f8f9fa",
        "#f1f3f5",
        "#e9ecef",
        "#dee2e6",
        "#ced4da",
        "#adb5bd",
        "#868e96",
        "#495057",
        "#343a40",
        "#212529"
    ],
    red: [
        "#fff5f5",
        "#ffe3e3",
        "#ffc9c9",
        "#ffa8a8",
        "#ff8787",
        "#ff6b6b",
        "#fa5252",
        "#f03e3e",
        "#e03131",
        "#c92a2a"
    ],
    pink: [
        "#fff0f6",
        "#ffdeeb",
        "#fcc2d7",
        "#faa2c1",
        "#f783ac",
        "#f06595",
        "#e64980",
        "#d6336c",
        "#c2255c",
        "#a61e4d"
    ],
    grape: [
        "#f8f0fc",
        "#f3d9fa",
        "#eebefa",
        "#e599f7",
        "#da77f2",
        "#cc5de8",
        "#be4bdb",
        "#ae3ec9",
        "#9c36b5",
        "#862e9c"
    ],
    violet: [
        "#f3f0ff",
        "#e5dbff",
        "#d0bfff",
        "#b197fc",
        "#9775fa",
        "#845ef7",
        "#7950f2",
        "#7048e8",
        "#6741d9",
        "#5f3dc4"
    ],
    indigo: [
        "#edf2ff",
        "#dbe4ff",
        "#bac8ff",
        "#91a7ff",
        "#748ffc",
        "#5c7cfa",
        "#4c6ef5",
        "#4263eb",
        "#3b5bdb",
        "#364fc7"
    ],
    blue: [
        "#e7f5ff",
        "#d0ebff",
        "#a5d8ff",
        "#74c0fc",
        "#4dabf7",
        "#339af0",
        "#228be6",
        "#1c7ed6",
        "#1971c2",
        "#1864ab"
    ],
    cyan: [
        "#e3fafc",
        "#c5f6fa",
        "#99e9f2",
        "#66d9e8",
        "#3bc9db",
        "#22b8cf",
        "#15aabf",
        "#1098ad",
        "#0c8599",
        "#0b7285"
    ],
    teal: [
        "#e6fcf5",
        "#c3fae8",
        "#96f2d7",
        "#63e6be",
        "#38d9a9",
        "#20c997",
        "#12b886",
        "#0ca678",
        "#099268",
        "#087f5b"
    ],
    green: [
        "#ebfbee",
        "#d3f9d8",
        "#b2f2bb",
        "#8ce99a",
        "#69db7c",
        "#51cf66",
        "#40c057",
        "#37b24d",
        "#2f9e44",
        "#2b8a3e"
    ],
    lime: [
        "#f4fce3",
        "#e9fac8",
        "#d8f5a2",
        "#c0eb75",
        "#a9e34b",
        "#94d82d",
        "#82c91e",
        "#74b816",
        "#66a80f",
        "#5c940d"
    ],
    yellow: [
        "#fff9db",
        "#fff3bf",
        "#ffec99",
        "#ffe066",
        "#ffd43b",
        "#fcc419",
        "#fab005",
        "#f59f00",
        "#f08c00",
        "#e67700"
    ],
    orange: [
        "#fff4e6",
        "#ffe8cc",
        "#ffd8a8",
        "#ffc078",
        "#ffa94d",
        "#ff922b",
        "#fd7e14",
        "#f76707",
        "#e8590c",
        "#d9480f"
    ]
};


"use client";
function $8c0a85c8b0a1cf67$export$577a930223dcda99(theme, colorScheme) {
    if (typeof theme.primaryShade === "number") return theme.primaryShade;
    if (colorScheme === "dark") return theme.primaryShade.dark;
    return theme.primaryShade.light;
}


"use client";
function $33a822173b5f4b0f$export$83e0a426d2da8ac1({ color: color, theme: theme, colorScheme: colorScheme }) {
    if (typeof color !== "string") throw new Error(`[@mantine/core] Failed to parse color. Instead got ${typeof color}`);
    if (color === "white" || color === "black") return {
        color: color,
        value: color === "white" ? theme.white : theme.black,
        shade: void 0,
        isThemeColor: false,
        variable: `--mantine-color-${color}`
    };
    const [_color, shade] = color.split(".");
    const colorShade = shade ? Number(shade) : void 0;
    const isThemeColor = _color in theme.colors;
    if (isThemeColor) return {
        color: _color,
        value: colorShade !== void 0 ? theme.colors[_color][colorShade] : theme.colors[_color][(0, $8c0a85c8b0a1cf67$export$577a930223dcda99)(theme, colorScheme || "light")],
        shade: colorShade,
        isThemeColor: isThemeColor,
        variable: shade ? `--mantine-color-${_color}-${colorShade}` : `--mantine-color-${_color}-filled`
    };
    return {
        color: color,
        value: color,
        isThemeColor: isThemeColor,
        shade: colorShade,
        variable: void 0
    };
}



"use client";
function $0a9c57cec2a3e373$export$e22c5d06d177c3fa(color, theme) {
    const parsed = (0, $33a822173b5f4b0f$export$83e0a426d2da8ac1)({
        color: color || theme.primaryColor,
        theme: theme
    });
    return parsed.variable ? `var(${parsed.variable})` : color;
}


"use client";
function $bdea122fb92e1007$export$e14995d3ec1747ee(gradient, theme) {
    const merged = {
        from: (gradient == null ? void 0 : gradient.from) || theme.defaultGradient.from,
        to: (gradient == null ? void 0 : gradient.to) || theme.defaultGradient.to,
        deg: (gradient == null ? void 0 : gradient.deg) || theme.defaultGradient.deg || 0
    };
    const fromColor = (0, $0a9c57cec2a3e373$export$e22c5d06d177c3fa)(merged.from, theme);
    const toColor = (0, $0a9c57cec2a3e373$export$e22c5d06d177c3fa)(merged.to, theme);
    return `linear-gradient(${merged.deg}deg, ${fromColor} 0%, ${toColor} 100%)`;
}


"use client";
function $eedf50c1f1ee6321$var$isHexColor(hex) {
    const HEX_REGEXP = /^#?([0-9A-F]{3}){1,2}$/i;
    return HEX_REGEXP.test(hex);
}
function $eedf50c1f1ee6321$var$hexToRgba(color) {
    let hexString = color.replace("#", "");
    if (hexString.length === 3) {
        const shorthandHex = hexString.split("");
        hexString = [
            shorthandHex[0],
            shorthandHex[0],
            shorthandHex[1],
            shorthandHex[1],
            shorthandHex[2],
            shorthandHex[2]
        ].join("");
    }
    const parsed = parseInt(hexString, 16);
    const r = parsed >> 16 & 255;
    const g = parsed >> 8 & 255;
    const b = parsed & 255;
    return {
        r: r,
        g: g,
        b: b,
        a: 1
    };
}
function $eedf50c1f1ee6321$var$rgbStringToRgba(color) {
    const [r, g, b, a] = color.replace(/[^0-9,.]/g, "").split(",").map(Number);
    return {
        r: r,
        g: g,
        b: b,
        a: a || 1
    };
}
function $eedf50c1f1ee6321$var$hslStringToRgba(hslaString) {
    const hslaRegex = /^hsla?\(\s*(\d+)\s*,\s*(\d+%)\s*,\s*(\d+%)\s*(,\s*(0?\.\d+|\d+(\.\d+)?))?\s*\)$/i;
    const matches = hslaString.match(hslaRegex);
    if (!matches) return {
        r: 0,
        g: 0,
        b: 0,
        a: 1
    };
    const h = parseInt(matches[1], 10);
    const s = parseInt(matches[2], 10) / 100;
    const l = parseInt(matches[3], 10) / 100;
    const a = matches[5] ? parseFloat(matches[5]) : void 0;
    const chroma = (1 - Math.abs(2 * l - 1)) * s;
    const huePrime = h / 60;
    const x = chroma * (1 - Math.abs(huePrime % 2 - 1));
    const m = l - chroma / 2;
    let r;
    let g;
    let b;
    if (huePrime >= 0 && huePrime < 1) {
        r = chroma;
        g = x;
        b = 0;
    } else if (huePrime >= 1 && huePrime < 2) {
        r = x;
        g = chroma;
        b = 0;
    } else if (huePrime >= 2 && huePrime < 3) {
        r = 0;
        g = chroma;
        b = x;
    } else if (huePrime >= 3 && huePrime < 4) {
        r = 0;
        g = x;
        b = chroma;
    } else if (huePrime >= 4 && huePrime < 5) {
        r = x;
        g = 0;
        b = chroma;
    } else {
        r = chroma;
        g = 0;
        b = x;
    }
    return {
        r: Math.round((r + m) * 255),
        g: Math.round((g + m) * 255),
        b: Math.round((b + m) * 255),
        a: a || 1
    };
}
function $eedf50c1f1ee6321$export$5db297beaffffbfc(color) {
    if ($eedf50c1f1ee6321$var$isHexColor(color)) return $eedf50c1f1ee6321$var$hexToRgba(color);
    if (color.startsWith("rgb")) return $eedf50c1f1ee6321$var$rgbStringToRgba(color);
    if (color.startsWith("hsl")) return $eedf50c1f1ee6321$var$hslStringToRgba(color);
    return {
        r: 0,
        g: 0,
        b: 0,
        a: 1
    };
}


"use client";
function $658d03b0d202e9a7$export$4b073707ff63303(color, alpha) {
    if (color.startsWith("var(")) return color;
    const { r: r, g: g, b: b, a: a } = (0, $eedf50c1f1ee6321$export$5db297beaffffbfc)(color);
    const f = 1 - alpha;
    const dark = (input)=>Math.round(input * f);
    return `rgba(${dark(r)}, ${dark(g)}, ${dark(b)}, ${a})`;
}



"use client";
function $a29d51c1f7df5c7c$export$4e46ac54fc82cf3b(color, alpha) {
    if (typeof color !== "string" || alpha > 1 || alpha < 0) return "rgba(0, 0, 0, 1)";
    const { r: r, g: g, b: b } = (0, $eedf50c1f1ee6321$export$5db297beaffffbfc)(color);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}


"use client";
function $7a68b0670ce0ab52$var$scaleRem(remValue) {
    return `calc(${remValue} * var(--mantine-scale))`;
}
function $7a68b0670ce0ab52$var$createConverter(units, { shouldScale: shouldScale = false } = {}) {
    return (value)=>{
        if (value === 0 || value === "0") return "0";
        if (typeof value === "number") {
            const val = `${value / 16}${units}`;
            return shouldScale ? $7a68b0670ce0ab52$var$scaleRem(val) : val;
        }
        if (typeof value === "string") {
            if (value.includes("calc(") || value.includes("var(")) return value;
            if (value.includes(units)) return shouldScale ? $7a68b0670ce0ab52$var$scaleRem(value) : value;
            const replaced = value.replace("px", "");
            if (!Number.isNaN(Number(replaced))) {
                const val = `${Number(replaced) / 16}${units}`;
                return shouldScale ? $7a68b0670ce0ab52$var$scaleRem(val) : val;
            }
        }
        return value;
    };
}
const $7a68b0670ce0ab52$export$fb1897a40d146f7f = $7a68b0670ce0ab52$var$createConverter("rem", {
    shouldScale: true
});
const $7a68b0670ce0ab52$export$c63c6f932822f543 = $7a68b0670ce0ab52$var$createConverter("em");


"use client";
const $1f26a13d318caa8d$export$a75cb1ab905fa258 = ({ color: color, theme: theme, variant: variant, gradient: gradient })=>{
    const parsed = (0, $33a822173b5f4b0f$export$83e0a426d2da8ac1)({
        color: color,
        theme: theme
    });
    if (variant === "filled") {
        if (parsed.isThemeColor) {
            if (parsed.shade === void 0) return {
                background: `var(--mantine-color-${color}-filled)`,
                hover: `var(--mantine-color-${color}-filled-hover)`,
                color: "var(--mantine-color-white)",
                border: `${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(1)} solid transparent`
            };
            return {
                background: `var(--mantine-color-${parsed.color}-${parsed.shade})`,
                hover: `var(--mantine-color-${parsed.color}-${parsed.shade === 9 ? 8 : parsed.shade + 1})`,
                color: "var(--mantine-color-white)",
                border: `${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(1)} solid transparent`
            };
        }
        return {
            background: color,
            hover: (0, $658d03b0d202e9a7$export$4b073707ff63303)(color, 0.1),
            color: "var(--mantine-color-white)",
            border: `${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(1)} solid transparent`
        };
    }
    if (variant === "light") {
        if (parsed.isThemeColor) {
            if (parsed.shade === void 0) return {
                background: `var(--mantine-color-${color}-light)`,
                hover: `var(--mantine-color-${color}-light-hover)`,
                color: `var(--mantine-color-${color}-light-color)`,
                border: `${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(1)} solid transparent`
            };
            const parsedColor = theme.colors[parsed.color][parsed.shade];
            return {
                background: (0, $a29d51c1f7df5c7c$export$4e46ac54fc82cf3b)(parsedColor, 0.1),
                hover: (0, $a29d51c1f7df5c7c$export$4e46ac54fc82cf3b)(parsedColor, 0.12),
                color: `var(--mantine-color-${parsed.color}-${Math.min(parsed.shade, 6)})`,
                border: `${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(1)} solid transparent`
            };
        }
        return {
            background: (0, $a29d51c1f7df5c7c$export$4e46ac54fc82cf3b)(color, 0.1),
            hover: (0, $a29d51c1f7df5c7c$export$4e46ac54fc82cf3b)(color, 0.12),
            color: color,
            border: `${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(1)} solid transparent`
        };
    }
    if (variant === "outline") {
        if (parsed.isThemeColor) {
            if (parsed.shade === void 0) return {
                background: "transparent",
                hover: `var(--mantine-color-${color}-outline-hover)`,
                color: `var(--mantine-color-${color}-outline)`,
                border: `${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(1)} solid var(--mantine-color-${color}-outline)`
            };
            return {
                background: "transparent",
                hover: (0, $a29d51c1f7df5c7c$export$4e46ac54fc82cf3b)(theme.colors[parsed.color][parsed.shade], 0.05),
                color: `var(--mantine-color-${parsed.color}-${parsed.shade})`,
                border: `${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(1)} solid var(--mantine-color-${parsed.color}-${parsed.shade})`
            };
        }
        return {
            background: "transparent",
            hover: (0, $a29d51c1f7df5c7c$export$4e46ac54fc82cf3b)(color, 0.05),
            color: color,
            border: `${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(1)} solid ${color}`
        };
    }
    if (variant === "subtle") {
        if (parsed.isThemeColor) {
            if (parsed.shade === void 0) return {
                background: "transparent",
                hover: `var(--mantine-color-${color}-light-hover)`,
                color: `var(--mantine-color-${color}-light-color)`,
                border: `${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(1)} solid transparent`
            };
            const parsedColor = theme.colors[parsed.color][parsed.shade];
            return {
                background: "transparent",
                hover: (0, $a29d51c1f7df5c7c$export$4e46ac54fc82cf3b)(parsedColor, 0.12),
                color: `var(--mantine-color-${parsed.color}-${Math.min(parsed.shade, 6)})`,
                border: `${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(1)} solid transparent`
            };
        }
        return {
            background: "transparent",
            hover: (0, $a29d51c1f7df5c7c$export$4e46ac54fc82cf3b)(color, 0.12),
            color: color,
            border: `${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(1)} solid transparent`
        };
    }
    if (variant === "transparent") {
        if (parsed.isThemeColor) {
            if (parsed.shade === void 0) return {
                background: "transparent",
                hover: "transparent",
                color: `var(--mantine-color-${color}-light-color)`,
                border: `${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(1)} solid transparent`
            };
            return {
                background: "transparent",
                hover: "transparent",
                color: `var(--mantine-color-${parsed.color}-${Math.min(parsed.shade, 6)})`,
                border: `${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(1)} solid transparent`
            };
        }
        return {
            background: "transparent",
            hover: "transparent",
            color: color,
            border: `${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(1)} solid transparent`
        };
    }
    if (variant === "white") {
        if (parsed.isThemeColor) {
            if (parsed.shade === void 0) return {
                background: "var(--mantine-color-white)",
                hover: (0, $658d03b0d202e9a7$export$4b073707ff63303)(theme.white, 0.01),
                color: `var(--mantine-color-${color}-filled)`,
                border: `${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(1)} solid transparent`
            };
            return {
                background: "var(--mantine-color-white)",
                hover: (0, $658d03b0d202e9a7$export$4b073707ff63303)(theme.white, 0.01),
                color: `var(--mantine-color-${parsed.color}-${parsed.shade})`,
                border: `${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(1)} solid transparent`
            };
        }
        return {
            background: "var(--mantine-color-white)",
            hover: (0, $658d03b0d202e9a7$export$4b073707ff63303)(theme.white, 0.01),
            color: color,
            border: `${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(1)} solid transparent`
        };
    }
    if (variant === "gradient") return {
        background: (0, $bdea122fb92e1007$export$e14995d3ec1747ee)(gradient, theme),
        hover: (0, $bdea122fb92e1007$export$e14995d3ec1747ee)(gradient, theme),
        color: "var(--mantine-color-white)",
        border: "none"
    };
    if (variant === "default") return {
        background: "var(--mantine-color-default)",
        hover: "var(--mantine-color-default-hover)",
        color: "var(--mantine-color-default-color)",
        border: `${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(1)} solid var(--mantine-color-default-border)`
    };
    return {};
};



"use client";
const $5b6cd714d8388858$var$DEFAULT_FONT_FAMILY = "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji";
const $5b6cd714d8388858$export$2faeed762aac6741 = {
    scale: 1,
    fontSmoothing: true,
    focusRing: "auto",
    white: "#fff",
    black: "#000",
    colors: (0, $b5aa84565affcc12$export$e60cfe038231c681),
    primaryShade: {
        light: 6,
        dark: 8
    },
    primaryColor: "blue",
    variantColorResolver: (0, $1f26a13d318caa8d$export$a75cb1ab905fa258),
    fontFamily: $5b6cd714d8388858$var$DEFAULT_FONT_FAMILY,
    fontFamilyMonospace: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace",
    respectReducedMotion: false,
    cursorType: "default",
    defaultGradient: {
        from: "blue",
        to: "cyan",
        deg: 45
    },
    defaultRadius: "sm",
    activeClassName: "mantine-active",
    focusClassName: "",
    headings: {
        fontFamily: $5b6cd714d8388858$var$DEFAULT_FONT_FAMILY,
        fontWeight: "700",
        sizes: {
            h1: {
                fontSize: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(34),
                lineHeight: "1.3"
            },
            h2: {
                fontSize: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(26),
                lineHeight: "1.35"
            },
            h3: {
                fontSize: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(22),
                lineHeight: "1.4"
            },
            h4: {
                fontSize: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(18),
                lineHeight: "1.45"
            },
            h5: {
                fontSize: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(16),
                lineHeight: "1.5"
            },
            h6: {
                fontSize: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(14),
                lineHeight: "1.5"
            }
        }
    },
    fontSizes: {
        xs: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(12),
        sm: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(14),
        md: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(16),
        lg: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(18),
        xl: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(20)
    },
    lineHeights: {
        xs: "1.4",
        sm: "1.45",
        md: "1.55",
        lg: "1.6",
        xl: "1.65"
    },
    radius: {
        xs: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(2),
        sm: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(4),
        md: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(8),
        lg: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(16),
        xl: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(32)
    },
    spacing: {
        xs: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(10),
        sm: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(12),
        md: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(16),
        lg: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(20),
        xl: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(32)
    },
    breakpoints: {
        xs: "36em",
        sm: "48em",
        md: "62em",
        lg: "75em",
        xl: "88em"
    },
    shadows: {
        xs: `0 ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(1)} ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(3)} rgba(0, 0, 0, 0.05), 0 ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(1)} ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(2)} rgba(0, 0, 0, 0.1)`,
        sm: `0 ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(1)} ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(3)} rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(10)} ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(15)} ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(-5)}, rgba(0, 0, 0, 0.04) 0 ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(7)} ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(7)} ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(-5)}`,
        md: `0 ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(1)} ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(3)} rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(20)} ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(25)} ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(-5)}, rgba(0, 0, 0, 0.04) 0 ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(10)} ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(10)} ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(-5)}`,
        lg: `0 ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(1)} ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(3)} rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(28)} ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(23)} ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(-7)}, rgba(0, 0, 0, 0.04) 0 ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(12)} ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(12)} ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(-7)}`,
        xl: `0 ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(1)} ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(3)} rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(36)} ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(28)} ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(-7)}, rgba(0, 0, 0, 0.04) 0 ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(17)} ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(17)} ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(-7)}`
    },
    other: {},
    components: {}
};


"use client";
var $8ff81336d9cb648b$var$__defProp = Object.defineProperty;
var $8ff81336d9cb648b$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $8ff81336d9cb648b$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $8ff81336d9cb648b$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $8ff81336d9cb648b$var$__defNormalProp = (obj, key, value)=>key in obj ? $8ff81336d9cb648b$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $8ff81336d9cb648b$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($8ff81336d9cb648b$var$__hasOwnProp.call(b, prop)) $8ff81336d9cb648b$var$__defNormalProp(a, prop, b[prop]);
    if ($8ff81336d9cb648b$var$__getOwnPropSymbols) {
        for (var prop of $8ff81336d9cb648b$var$__getOwnPropSymbols(b))if ($8ff81336d9cb648b$var$__propIsEnum.call(b, prop)) $8ff81336d9cb648b$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
function $8ff81336d9cb648b$var$isObject(item) {
    return item && typeof item === "object" && !Array.isArray(item);
}
function $8ff81336d9cb648b$export$6969335ea1e4e77c(target, source) {
    const result = $8ff81336d9cb648b$var$__spreadValues({}, target);
    const _source = source;
    if ($8ff81336d9cb648b$var$isObject(target) && $8ff81336d9cb648b$var$isObject(source)) Object.keys(source).forEach((key)=>{
        if ($8ff81336d9cb648b$var$isObject(_source[key])) {
            if (!(key in target)) result[key] = _source[key];
            else result[key] = $8ff81336d9cb648b$export$6969335ea1e4e77c(result[key], _source[key]);
        } else result[key] = _source[key];
    });
    return result;
}


"use client";
const $b1497e5035b07e57$export$c37e78526d965f66 = "[@mantine/core] MantineProvider: Invalid theme.primaryColor, it accepts only key of theme.colors, learn more \u2013 https://mantine.dev/theming/colors/#primary-color";
const $b1497e5035b07e57$export$8b77776745020255 = "[@mantine/core] MantineProvider: Invalid theme.primaryShade, it accepts only 0-9 integers or an object { light: 0-9, dark: 0-9 }";
function $b1497e5035b07e57$var$isValidPrimaryShade(shade) {
    if (shade < 0 || shade > 9) return false;
    return parseInt(shade.toString(), 10) === shade;
}
function $b1497e5035b07e57$export$2368dd16b50ed520(theme) {
    if (!(theme.primaryColor in theme.colors)) throw new Error($b1497e5035b07e57$export$c37e78526d965f66);
    if (typeof theme.primaryShade === "object") {
        if (!$b1497e5035b07e57$var$isValidPrimaryShade(theme.primaryShade.dark) || !$b1497e5035b07e57$var$isValidPrimaryShade(theme.primaryShade.light)) throw new Error($b1497e5035b07e57$export$8b77776745020255);
    }
    if (typeof theme.primaryShade === "number" && !$b1497e5035b07e57$var$isValidPrimaryShade(theme.primaryShade)) throw new Error($b1497e5035b07e57$export$8b77776745020255);
}
function $b1497e5035b07e57$export$c3dbee3ac229ebad(currentTheme, themeOverride) {
    var _a;
    if (!themeOverride) {
        $b1497e5035b07e57$export$2368dd16b50ed520(currentTheme);
        return currentTheme;
    }
    const result = (0, $8ff81336d9cb648b$export$6969335ea1e4e77c)(currentTheme, themeOverride);
    if (themeOverride.fontFamily && !((_a = themeOverride.headings) == null ? void 0 : _a.fontFamily)) result.headings.fontFamily = themeOverride.fontFamily;
    $b1497e5035b07e57$export$2368dd16b50ed520(result);
    return result;
}


"use client";
const $692af3391f7b0a55$export$7fd5915d8252bddf = (0, $acw62.createContext)(null);
const $692af3391f7b0a55$export$374685f039976992 = ()=>(0, $acw62.useContext)($692af3391f7b0a55$export$7fd5915d8252bddf) || (0, $5b6cd714d8388858$export$2faeed762aac6741);
function $692af3391f7b0a55$export$5eb0e84f6418b457() {
    const ctx = (0, $acw62.useContext)($692af3391f7b0a55$export$7fd5915d8252bddf);
    if (!ctx) throw new Error("@mantine/core: MantineProvider was not found in component tree, make sure you have it in your app");
    return ctx;
}
function $692af3391f7b0a55$export$58281642be5f461a({ theme: theme, children: children, inherit: inherit = true }) {
    const parentTheme = $692af3391f7b0a55$export$374685f039976992();
    const mergedTheme = (0, $acw62.useMemo)(()=>(0, $b1497e5035b07e57$export$c3dbee3ac229ebad)(inherit ? parentTheme : (0, $5b6cd714d8388858$export$2faeed762aac6741), theme), [
        theme,
        parentTheme,
        inherit
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($692af3391f7b0a55$export$7fd5915d8252bddf.Provider, {
        value: mergedTheme
    }, children);
}
$692af3391f7b0a55$export$58281642be5f461a.displayName = "@mantine/core/MantineThemeProvider";



var $acw62 = parcelRequire("acw62");

"use client";
function $fb4c966bff9e1163$export$75fae6257d54d243(variables) {
    return Object.entries(variables).map(([name, value])=>`${name}: ${value};`).join("");
}


"use client";
function $73cc3715d290e1dc$export$db316f3451201609(selectors, code) {
    const _selectors = Array.isArray(selectors) ? selectors : [
        selectors
    ];
    return _selectors.reduce((acc, selector)=>`${selector}{${acc}}`, code);
}


"use client";
function $6754ab582a2c604a$export$6147dbdcc6854746(input, selector) {
    const sharedVariables = (0, $fb4c966bff9e1163$export$75fae6257d54d243)(input.variables);
    const shared = sharedVariables ? (0, $73cc3715d290e1dc$export$db316f3451201609)(selector, sharedVariables) : "";
    const dark = (0, $fb4c966bff9e1163$export$75fae6257d54d243)(input.dark);
    const darkForced = dark ? (0, $73cc3715d290e1dc$export$db316f3451201609)(`${selector}[data-mantine-color-scheme="dark"]`, dark) : "";
    const light = (0, $fb4c966bff9e1163$export$75fae6257d54d243)(input.light);
    const lightForced = light ? (0, $73cc3715d290e1dc$export$db316f3451201609)(`${selector}[data-mantine-color-scheme="light"]`, light) : "";
    return `${shared}${darkForced}${lightForced}`;
}




"use client";
function $76cd5f02de8ee394$export$ed97f33186d4b816(object) {
    return Object.keys(object);
}



"use client";
function $7c7ebb59e6d0d04d$var$assignSizeVariables(variables, sizes, name) {
    (0, $76cd5f02de8ee394$export$ed97f33186d4b816)(sizes).forEach((size)=>Object.assign(variables, {
            [`--mantine-${name}-${size}`]: sizes[size]
        }));
}
const $7c7ebb59e6d0d04d$export$f1525197a070c054 = (theme)=>{
    const darkPrimaryShade = (0, $8c0a85c8b0a1cf67$export$577a930223dcda99)(theme, "dark");
    const lightPrimaryShade = (0, $8c0a85c8b0a1cf67$export$577a930223dcda99)(theme, "light");
    const defaultRadius = theme.defaultRadius in theme.radius ? theme.radius[theme.defaultRadius] : (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(theme.defaultRadius);
    const result = {
        variables: {
            "--mantine-scale": theme.scale.toString(),
            "--mantine-cursor-type": theme.cursorType,
            "--mantine-webkit-font-smoothing": theme.fontSmoothing ? "antialiased" : "unset",
            "--mantine-color-scheme": "light dark",
            "--mantine-moz-font-smoothing": theme.fontSmoothing ? "grayscale" : "unset",
            "--mantine-color-white": theme.white,
            "--mantine-color-black": theme.black,
            "--mantine-line-height": theme.lineHeights.md,
            "--mantine-font-family": theme.fontFamily,
            "--mantine-font-family-monospace": theme.fontFamilyMonospace,
            "--mantine-font-family-headings": theme.headings.fontFamily,
            "--mantine-heading-font-weight": theme.headings.fontWeight,
            "--mantine-radius-default": defaultRadius,
            // Primary colors
            "--mantine-primary-color-filled": `var(--mantine-color-${theme.primaryColor}-filled)`,
            "--mantine-primary-color-filled-hover": `var(--mantine-color-${theme.primaryColor}-filled-hover)`,
            "--mantine-primary-color-light": `var(--mantine-color-${theme.primaryColor}-light)`,
            "--mantine-primary-color-light-hover": `var(--mantine-color-${theme.primaryColor}-light-hover)`,
            "--mantine-primary-color-light-color": `var(--mantine-color-${theme.primaryColor}-light-color)`
        },
        light: {
            "--mantine-color-bright": "var(--mantine-color-black)",
            "--mantine-color-text": theme.black,
            "--mantine-color-body": theme.white,
            "--mantine-color-error": theme.colors.red[6],
            "--mantine-color-placeholder": theme.colors.gray[5],
            "--mantine-color-anchor": theme.colors[theme.primaryColor][lightPrimaryShade],
            "--mantine-color-default": theme.white,
            "--mantine-color-default-hover": theme.colors.gray[0],
            "--mantine-color-default-color": theme.black,
            "--mantine-color-default-border": theme.colors.gray[4]
        },
        dark: {
            "--mantine-color-bright": "var(--mantine-color-white)",
            "--mantine-color-text": "var(--mantine-color-dark-0)",
            "--mantine-color-body": theme.colors.dark[7],
            "--mantine-color-error": theme.colors.red[9],
            "--mantine-color-placeholder": theme.colors.dark[3],
            "--mantine-color-anchor": theme.colors[theme.primaryColor][4],
            "--mantine-color-default": theme.colors.dark[6],
            "--mantine-color-default-hover": theme.colors.dark[5],
            "--mantine-color-default-color": theme.white,
            "--mantine-color-default-border": theme.colors.dark[4]
        }
    };
    $7c7ebb59e6d0d04d$var$assignSizeVariables(result.variables, theme.breakpoints, "breakpoint");
    $7c7ebb59e6d0d04d$var$assignSizeVariables(result.variables, theme.spacing, "spacing");
    $7c7ebb59e6d0d04d$var$assignSizeVariables(result.variables, theme.fontSizes, "font-size");
    $7c7ebb59e6d0d04d$var$assignSizeVariables(result.variables, theme.lineHeights, "line-height");
    $7c7ebb59e6d0d04d$var$assignSizeVariables(result.variables, theme.shadows, "shadow");
    $7c7ebb59e6d0d04d$var$assignSizeVariables(result.variables, theme.radius, "radius");
    (0, $76cd5f02de8ee394$export$ed97f33186d4b816)(theme.colors).forEach((color)=>{
        theme.colors[color].forEach((shade, index)=>{
            result.variables[`--mantine-color-${color}-${index}`] = shade;
        });
        const lightFilledHover = lightPrimaryShade === 9 ? theme.colors[color][8] : theme.colors[color][lightPrimaryShade + 1];
        const darkFilledHover = darkPrimaryShade === 9 ? theme.colors[color][8] : theme.colors[color][darkPrimaryShade + 1];
        result.light["--mantine-color-dimmed"] = "var(--mantine-color-gray-6)";
        result.light[`--mantine-color-${color}-filled`] = theme.colors[color][lightPrimaryShade];
        result.light[`--mantine-color-${color}-filled-hover`] = lightFilledHover;
        result.light[`--mantine-color-${color}-light`] = (0, $a29d51c1f7df5c7c$export$4e46ac54fc82cf3b)(theme.colors[color][lightPrimaryShade], 0.1);
        result.light[`--mantine-color-${color}-light-hover`] = (0, $a29d51c1f7df5c7c$export$4e46ac54fc82cf3b)(theme.colors[color][lightPrimaryShade], 0.12);
        result.light[`--mantine-color-${color}-light-color`] = theme.colors[color][lightPrimaryShade];
        result.light[`--mantine-color-${color}-outline`] = theme.colors[color][lightPrimaryShade];
        result.light[`--mantine-color-${color}-outline-hover`] = (0, $a29d51c1f7df5c7c$export$4e46ac54fc82cf3b)(theme.colors[color][lightPrimaryShade], 0.05);
        result.dark["--mantine-color-dimmed"] = "var(--mantine-color-dark-2)";
        result.dark[`--mantine-color-${color}-filled`] = theme.colors[color][darkPrimaryShade];
        result.dark[`--mantine-color-${color}-filled-hover`] = darkFilledHover;
        result.dark[`--mantine-color-${color}-light`] = (0, $a29d51c1f7df5c7c$export$4e46ac54fc82cf3b)(theme.colors[color][Math.max(0, darkPrimaryShade - 2)], 0.15);
        result.dark[`--mantine-color-${color}-light-hover`] = (0, $a29d51c1f7df5c7c$export$4e46ac54fc82cf3b)(theme.colors[color][Math.max(0, darkPrimaryShade - 2)], 0.2);
        result.dark[`--mantine-color-${color}-light-color`] = theme.colors[color][Math.max(darkPrimaryShade - 5, 0)];
        result.dark[`--mantine-color-${color}-outline`] = theme.colors[color][Math.max(darkPrimaryShade - 4, 0)];
        result.dark[`--mantine-color-${color}-outline-hover`] = (0, $a29d51c1f7df5c7c$export$4e46ac54fc82cf3b)(theme.colors[color][Math.max(darkPrimaryShade - 4, 0)], 0.05);
    });
    const headings = theme.headings.sizes;
    (0, $76cd5f02de8ee394$export$ed97f33186d4b816)(headings).forEach((heading)=>{
        result.variables[`--mantine-${heading}-font-size`] = headings[heading].fontSize;
        result.variables[`--mantine-${heading}-line-height`] = headings[heading].lineHeight;
        result.variables[`--mantine-${heading}-font-weight`] = headings[heading].fontWeight || theme.headings.fontWeight;
    });
    return result;
};



"use client";
function $8c6d0c59070748ce$export$6e7ec19697e023e9({ theme: theme, generator: generator }) {
    const defaultResolver = (0, $7c7ebb59e6d0d04d$export$f1525197a070c054)(theme);
    const providerGenerator = generator == null ? void 0 : generator(theme);
    return providerGenerator ? (0, $8ff81336d9cb648b$export$6969335ea1e4e77c)(defaultResolver, providerGenerator) : defaultResolver;
}





"use client";
const $aa1cfada76150c50$var$defaultCssVariables = (0, $7c7ebb59e6d0d04d$export$f1525197a070c054)((0, $5b6cd714d8388858$export$2faeed762aac6741));
function $aa1cfada76150c50$export$cfc05db1e6c5ab80(input) {
    const cleaned = {
        variables: {},
        light: {},
        dark: {}
    };
    (0, $76cd5f02de8ee394$export$ed97f33186d4b816)(input.variables).forEach((key)=>{
        if ($aa1cfada76150c50$var$defaultCssVariables.variables[key] !== input.variables[key]) cleaned.variables[key] = input.variables[key];
    });
    (0, $76cd5f02de8ee394$export$ed97f33186d4b816)(input.light).forEach((key)=>{
        if ($aa1cfada76150c50$var$defaultCssVariables.light[key] !== input.light[key]) cleaned.light[key] = input.light[key];
    });
    (0, $76cd5f02de8ee394$export$ed97f33186d4b816)(input.dark).forEach((key)=>{
        if ($aa1cfada76150c50$var$defaultCssVariables.dark[key] !== input.dark[key]) cleaned.dark[key] = input.dark[key];
    });
    return cleaned;
}



"use client";
function $d31deba178d0679f$var$getColorSchemeCssVariables(selector) {
    return `
  ${selector}[data-mantine-color-scheme="dark"] { --mantine-color-scheme: dark; }
  ${selector}[data-mantine-color-scheme="light"] { --mantine-color-scheme: light; }
`;
}
function $d31deba178d0679f$export$bfc71f5317840eaf({ cssVariablesSelector: cssVariablesSelector }) {
    const theme = (0, $692af3391f7b0a55$export$5eb0e84f6418b457)();
    const nonce = (0, $bbb97275c373484a$export$ca3d89ae7d92a638)();
    const generator = (0, $bbb97275c373484a$export$875b251c245b8c99)();
    const mergedVariables = (0, $8c6d0c59070748ce$export$6e7ec19697e023e9)({
        theme: theme,
        generator: generator
    });
    const shouldCleanVariables = cssVariablesSelector === ":root";
    const cleanedVariables = shouldCleanVariables ? (0, $aa1cfada76150c50$export$cfc05db1e6c5ab80)(mergedVariables) : mergedVariables;
    const css = (0, $6754ab582a2c604a$export$6147dbdcc6854746)(cleanedVariables, cssVariablesSelector);
    if (css) return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", {
        "data-mantine-styles": true,
        nonce: nonce == null ? void 0 : nonce(),
        dangerouslySetInnerHTML: {
            __html: `${css}${shouldCleanVariables ? "" : $d31deba178d0679f$var$getColorSchemeCssVariables(cssVariablesSelector)}`
        }
    });
    return null;
}
$d31deba178d0679f$export$bfc71f5317840eaf.displayName = "@mantine/CssVariables";



var $acw62 = parcelRequire("acw62");



"use client";
function $36050ce217b59930$var$getTransformedScaledValue(value) {
    var _a;
    if (typeof value !== "string" || !value.includes("var(--mantine-scale)")) return value;
    return (_a = value.match(/^calc\((.*?)\)$/)) == null ? void 0 : _a[1].split("*")[0].trim();
}
function $36050ce217b59930$export$91c0eda1d06bf008(value) {
    const transformedValue = $36050ce217b59930$var$getTransformedScaledValue(value);
    if (typeof transformedValue === "number") return transformedValue;
    if (typeof transformedValue === "string") {
        if (transformedValue.includes("calc") || transformedValue.includes("var")) return transformedValue;
        if (transformedValue.includes("px")) return Number(transformedValue.replace("px", ""));
        if (transformedValue.includes("rem")) return Number(transformedValue.replace("rem", "")) * 16;
        if (transformedValue.includes("em")) return Number(transformedValue.replace("em", "")) * 16;
        return Number(transformedValue);
    }
    return NaN;
}



"use client";
function $cea444195a17e4a3$export$a9121e68af319ab5() {
    const theme = (0, $692af3391f7b0a55$export$5eb0e84f6418b457)();
    const nonce = (0, $bbb97275c373484a$export$ca3d89ae7d92a638)();
    const classes = (0, $76cd5f02de8ee394$export$ed97f33186d4b816)(theme.breakpoints).reduce((acc, breakpoint)=>{
        const pxValue = (0, $36050ce217b59930$export$91c0eda1d06bf008)(theme.breakpoints[breakpoint]);
        return `${acc}@media (max-width: ${(0, $7a68b0670ce0ab52$export$c63c6f932822f543)(pxValue - 0.1)}) {.mantine-visible-from-${breakpoint} {display: none !important;}}@media (min-width: ${(0, $7a68b0670ce0ab52$export$c63c6f932822f543)(pxValue)}) {.mantine-hidden-from-${breakpoint} {display: none !important;}}`;
    }, "");
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", {
        "data-mantine-styles": "classes",
        nonce: nonce == null ? void 0 : nonce(),
        dangerouslySetInnerHTML: {
            __html: classes
        }
    });
}


"use client";
(0, $592c29b91893a27d$export$28f2b15e704f599d)();
function $5f8e78febad0631e$export$2ec8a50af9fc9ed7({ theme: theme, children: children, getStyleNonce: getStyleNonce, withCssVariables: withCssVariables = true, cssVariablesSelector: cssVariablesSelector = ":root", classNamesPrefix: classNamesPrefix = "mantine", colorSchemeManager: colorSchemeManager = (0, $3bad1881056c620a$export$3114d9bddade735e)(), defaultColorScheme: defaultColorScheme = "light", getRootElement: getRootElement = ()=>document.documentElement, cssVariablesResolver: cssVariablesResolver, forceColorScheme: forceColorScheme }) {
    const { colorScheme: colorScheme, setColorScheme: setColorScheme, clearColorScheme: clearColorScheme } = (0, $e58862222fe72cb1$export$390785fb3763d6cf)({
        defaultColorScheme: defaultColorScheme,
        forceColorScheme: forceColorScheme,
        manager: colorSchemeManager,
        getRootElement: getRootElement
    });
    (0, $d45a0048df23fa10$export$aca9c65a2d2518b2)({
        respectReducedMotion: (theme == null ? void 0 : theme.respectReducedMotion) || false,
        getRootElement: getRootElement
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bbb97275c373484a$export$4ba45a360873bd20).Provider, {
        value: {
            colorSchemeManager: colorSchemeManager,
            colorScheme: colorScheme,
            setColorScheme: setColorScheme,
            clearColorScheme: clearColorScheme,
            getRootElement: getRootElement,
            classNamesPrefix: classNamesPrefix,
            getStyleNonce: getStyleNonce,
            cssVariablesResolver: cssVariablesResolver,
            cssVariablesSelector: cssVariablesSelector
        }
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $692af3391f7b0a55$export$58281642be5f461a), {
        theme: theme
    }, withCssVariables && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d31deba178d0679f$export$bfc71f5317840eaf), {
        cssVariablesSelector: cssVariablesSelector
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cea444195a17e4a3$export$a9121e68af319ab5), null), children));
}
$5f8e78febad0631e$export$2ec8a50af9fc9ed7.displayName = "@mantine/core/MantineProvider";



parcelRequire("acw62");
var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
"use strict";
var $11492dca620dcaa5$exports = {};
"use strict";
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));


var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $11492dca620dcaa5$exports.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $11492dca620dcaa5$exports.hydrateRoot;



var $acw62 = parcelRequire("acw62");
var $701b6c0516155145$exports = {};
"use strict";

$701b6c0516155145$exports = (parcelRequire("gbH6E"));


var $55388fc2f116d4d7$var$__defProp = Object.defineProperty;
var $55388fc2f116d4d7$var$__defProps = Object.defineProperties;
var $55388fc2f116d4d7$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $55388fc2f116d4d7$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $55388fc2f116d4d7$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $55388fc2f116d4d7$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $55388fc2f116d4d7$var$__defNormalProp = (obj, key, value)=>key in obj ? $55388fc2f116d4d7$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $55388fc2f116d4d7$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($55388fc2f116d4d7$var$__hasOwnProp.call(b, prop)) $55388fc2f116d4d7$var$__defNormalProp(a, prop, b[prop]);
    if ($55388fc2f116d4d7$var$__getOwnPropSymbols) {
        for (var prop of $55388fc2f116d4d7$var$__getOwnPropSymbols(b))if ($55388fc2f116d4d7$var$__propIsEnum.call(b, prop)) $55388fc2f116d4d7$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $55388fc2f116d4d7$var$__spreadProps = (a, b)=>$55388fc2f116d4d7$var$__defProps(a, $55388fc2f116d4d7$var$__getOwnPropDescs(b));
var $55388fc2f116d4d7$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($55388fc2f116d4d7$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $55388fc2f116d4d7$var$__getOwnPropSymbols) {
        for (var prop of $55388fc2f116d4d7$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $55388fc2f116d4d7$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $55388fc2f116d4d7$var$React = // prettier-ignore
// @ts-ignore
"default" in $acw62 ? $acw62["default"] : $acw62;
// src/components/Context.ts
var $55388fc2f116d4d7$var$ContextKey = Symbol.for(`react-redux-context`);
var $55388fc2f116d4d7$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $55388fc2f116d4d7$var$getContext() {
    var _a;
    if (!$55388fc2f116d4d7$var$React.createContext) return {};
    const contextMap = (_a = $55388fc2f116d4d7$var$gT[$55388fc2f116d4d7$var$ContextKey]) != null ? _a : $55388fc2f116d4d7$var$gT[$55388fc2f116d4d7$var$ContextKey] = /* @__PURE__ */ new Map();
    let realContext = contextMap.get($55388fc2f116d4d7$var$React.createContext);
    if (!realContext) {
        realContext = $55388fc2f116d4d7$var$React.createContext(null);
        contextMap.set($55388fc2f116d4d7$var$React.createContext, realContext);
    }
    return realContext;
}
var $55388fc2f116d4d7$export$cc80c08dc91f1c00 = /* @__PURE__ */ $55388fc2f116d4d7$var$getContext();
// src/utils/useSyncExternalStore.ts
var $55388fc2f116d4d7$var$notInitialized = ()=>{
    throw new Error("uSES not initialized!");
};
// src/hooks/useReduxContext.ts
function $55388fc2f116d4d7$var$createReduxContextHook(context = $55388fc2f116d4d7$export$cc80c08dc91f1c00) {
    return function useReduxContext2() {
        const contextValue = $55388fc2f116d4d7$var$React.useContext(context);
        return contextValue;
    };
}
var $55388fc2f116d4d7$var$useReduxContext = /* @__PURE__ */ $55388fc2f116d4d7$var$createReduxContextHook();
// src/hooks/useSelector.ts
var $55388fc2f116d4d7$var$useSyncExternalStoreWithSelector = $55388fc2f116d4d7$var$notInitialized;
var $55388fc2f116d4d7$var$initializeUseSelector = (fn)=>{
    $55388fc2f116d4d7$var$useSyncExternalStoreWithSelector = fn;
};
var $55388fc2f116d4d7$var$refEquality = (a, b)=>a === b;
function $55388fc2f116d4d7$export$2b53f90d2bd1cbfb(context = $55388fc2f116d4d7$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $55388fc2f116d4d7$export$cc80c08dc91f1c00 ? $55388fc2f116d4d7$var$useReduxContext : $55388fc2f116d4d7$var$createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn: equalityFn = $55388fc2f116d4d7$var$refEquality, devModeChecks: devModeChecks = {} } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: stabilityCheck, identityFunctionCheck: identityFunctionCheck } = useReduxContext2();
        const firstRun = $55388fc2f116d4d7$var$React.useRef(true);
        const wrappedSelector = $55388fc2f116d4d7$var$React.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector,
            stabilityCheck,
            devModeChecks.stabilityCheck
        ]);
        const selectedState = $55388fc2f116d4d7$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $55388fc2f116d4d7$var$React.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var $55388fc2f116d4d7$export$2105062e25df4afe = /* @__PURE__ */ $55388fc2f116d4d7$export$2b53f90d2bd1cbfb();
// src/utils/react-is.ts
var $55388fc2f116d4d7$var$REACT_ELEMENT_TYPE = Symbol.for("react.element");
var $55388fc2f116d4d7$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
var $55388fc2f116d4d7$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
var $55388fc2f116d4d7$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
var $55388fc2f116d4d7$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler");
var $55388fc2f116d4d7$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider");
var $55388fc2f116d4d7$var$REACT_CONTEXT_TYPE = Symbol.for("react.context");
var $55388fc2f116d4d7$var$REACT_SERVER_CONTEXT_TYPE = Symbol.for("react.server_context");
var $55388fc2f116d4d7$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
var $55388fc2f116d4d7$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
var $55388fc2f116d4d7$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
var $55388fc2f116d4d7$var$REACT_MEMO_TYPE = Symbol.for("react.memo");
var $55388fc2f116d4d7$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
var $55388fc2f116d4d7$var$REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
var $55388fc2f116d4d7$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
var $55388fc2f116d4d7$var$ForwardRef = $55388fc2f116d4d7$var$REACT_FORWARD_REF_TYPE;
var $55388fc2f116d4d7$var$Memo = $55388fc2f116d4d7$var$REACT_MEMO_TYPE;
function $55388fc2f116d4d7$var$isValidElementType(type) {
    if (typeof type === "string" || typeof type === "function") return true;
    if (type === $55388fc2f116d4d7$var$REACT_FRAGMENT_TYPE || type === $55388fc2f116d4d7$var$REACT_PROFILER_TYPE || type === $55388fc2f116d4d7$var$REACT_STRICT_MODE_TYPE || type === $55388fc2f116d4d7$var$REACT_SUSPENSE_TYPE || type === $55388fc2f116d4d7$var$REACT_SUSPENSE_LIST_TYPE || type === $55388fc2f116d4d7$var$REACT_OFFSCREEN_TYPE) return true;
    if (typeof type === "object" && type !== null) {
        if (type.$$typeof === $55388fc2f116d4d7$var$REACT_LAZY_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_MEMO_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_PROVIDER_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_CONTEXT_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
        // types supported by any Flight configuration anywhere since
        // we don't know which Flight build this will end up being used
        // with.
        type.$$typeof === $55388fc2f116d4d7$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) return true;
    }
    return false;
}
function $55388fc2f116d4d7$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const $$typeof = object.$$typeof;
        switch($$typeof){
            case $55388fc2f116d4d7$var$REACT_ELEMENT_TYPE:
                {
                    const type = object.type;
                    switch(type){
                        case $55388fc2f116d4d7$var$REACT_FRAGMENT_TYPE:
                        case $55388fc2f116d4d7$var$REACT_PROFILER_TYPE:
                        case $55388fc2f116d4d7$var$REACT_STRICT_MODE_TYPE:
                        case $55388fc2f116d4d7$var$REACT_SUSPENSE_TYPE:
                        case $55388fc2f116d4d7$var$REACT_SUSPENSE_LIST_TYPE:
                            return type;
                        default:
                            {
                                const $$typeofType = type && type.$$typeof;
                                switch($$typeofType){
                                    case $55388fc2f116d4d7$var$REACT_SERVER_CONTEXT_TYPE:
                                    case $55388fc2f116d4d7$var$REACT_CONTEXT_TYPE:
                                    case $55388fc2f116d4d7$var$REACT_FORWARD_REF_TYPE:
                                    case $55388fc2f116d4d7$var$REACT_LAZY_TYPE:
                                    case $55388fc2f116d4d7$var$REACT_MEMO_TYPE:
                                    case $55388fc2f116d4d7$var$REACT_PROVIDER_TYPE:
                                        return $$typeofType;
                                    default:
                                        return $$typeof;
                                }
                            }
                    }
                }
            case $55388fc2f116d4d7$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
    return void 0;
}
function $55388fc2f116d4d7$var$isContextConsumer(object) {
    return $55388fc2f116d4d7$var$typeOf(object) === $55388fc2f116d4d7$var$REACT_CONTEXT_TYPE;
}
function $55388fc2f116d4d7$var$isMemo(object) {
    return $55388fc2f116d4d7$var$typeOf(object) === $55388fc2f116d4d7$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $55388fc2f116d4d7$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $55388fc2f116d4d7$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $55388fc2f116d4d7$var$warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $55388fc2f116d4d7$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $55388fc2f116d4d7$var$verify(mapStateToProps, "mapStateToProps");
    $55388fc2f116d4d7$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $55388fc2f116d4d7$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $55388fc2f116d4d7$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $55388fc2f116d4d7$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _b, options = $55388fc2f116d4d7$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $55388fc2f116d4d7$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $55388fc2f116d4d7$var$bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $55388fc2f116d4d7$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $55388fc2f116d4d7$var$verifyPlainObject(value, displayName, methodName) {
    if (!$55388fc2f116d4d7$var$isPlainObject(value)) $55388fc2f116d4d7$var$warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function $55388fc2f116d4d7$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $55388fc2f116d4d7$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $55388fc2f116d4d7$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $55388fc2f116d4d7$var$getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $55388fc2f116d4d7$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $55388fc2f116d4d7$var$createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function $55388fc2f116d4d7$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $55388fc2f116d4d7$var$wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        $55388fc2f116d4d7$var$bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? $55388fc2f116d4d7$var$wrapMapToPropsConstant((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $55388fc2f116d4d7$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $55388fc2f116d4d7$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $55388fc2f116d4d7$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $55388fc2f116d4d7$var$wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    $55388fc2f116d4d7$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $55388fc2f116d4d7$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $55388fc2f116d4d7$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $55388fc2f116d4d7$var$__spreadValues($55388fc2f116d4d7$var$__spreadValues($55388fc2f116d4d7$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $55388fc2f116d4d7$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $55388fc2f116d4d7$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>$55388fc2f116d4d7$var$defaultMergeProps : typeof mergeProps === "function" ? $55388fc2f116d4d7$var$wrapMergePropsFunc(mergeProps) : $55388fc2f116d4d7$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $55388fc2f116d4d7$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $55388fc2f116d4d7$var$createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            $55388fc2f116d4d7$var$defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $55388fc2f116d4d7$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $55388fc2f116d4d7$var$createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = $55388fc2f116d4d7$var$nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $55388fc2f116d4d7$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $55388fc2f116d4d7$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $55388fc2f116d4d7$var$canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $55388fc2f116d4d7$var$useIsomorphicLayoutEffect = $55388fc2f116d4d7$var$canUseDOM ? $55388fc2f116d4d7$var$React.useLayoutEffect : $55388fc2f116d4d7$var$React.useEffect;
// src/utils/shallowEqual.ts
function $55388fc2f116d4d7$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $55388fc2f116d4d7$export$d36bdfa510afb180(objA, objB) {
    if ($55388fc2f116d4d7$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$55388fc2f116d4d7$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $55388fc2f116d4d7$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $55388fc2f116d4d7$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $55388fc2f116d4d7$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $55388fc2f116d4d7$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $55388fc2f116d4d7$var$TYPE_STATICS = {
    [$55388fc2f116d4d7$var$ForwardRef]: $55388fc2f116d4d7$var$FORWARD_REF_STATICS,
    [$55388fc2f116d4d7$var$Memo]: $55388fc2f116d4d7$var$MEMO_STATICS
};
function $55388fc2f116d4d7$var$getStatics(component) {
    if ($55388fc2f116d4d7$var$isMemo(component)) return $55388fc2f116d4d7$var$MEMO_STATICS;
    return $55388fc2f116d4d7$var$TYPE_STATICS[component["$$typeof"]] || $55388fc2f116d4d7$var$REACT_STATICS;
}
var $55388fc2f116d4d7$var$defineProperty = Object.defineProperty;
var $55388fc2f116d4d7$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $55388fc2f116d4d7$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $55388fc2f116d4d7$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $55388fc2f116d4d7$var$getPrototypeOf = Object.getPrototypeOf;
var $55388fc2f116d4d7$var$objectPrototype = Object.prototype;
function $55388fc2f116d4d7$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($55388fc2f116d4d7$var$objectPrototype) {
            const inheritedComponent = $55388fc2f116d4d7$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $55388fc2f116d4d7$var$objectPrototype) $55388fc2f116d4d7$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = $55388fc2f116d4d7$var$getOwnPropertyNames(sourceComponent);
        if ($55388fc2f116d4d7$var$getOwnPropertySymbols) keys = keys.concat($55388fc2f116d4d7$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $55388fc2f116d4d7$var$getStatics(targetComponent);
        const sourceStatics = $55388fc2f116d4d7$var$getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!$55388fc2f116d4d7$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = $55388fc2f116d4d7$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $55388fc2f116d4d7$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/connect.tsx
var $55388fc2f116d4d7$var$useSyncExternalStore = $55388fc2f116d4d7$var$notInitialized;
var $55388fc2f116d4d7$var$initializeConnect = (fn)=>{
    $55388fc2f116d4d7$var$useSyncExternalStore = fn;
};
var $55388fc2f116d4d7$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $55388fc2f116d4d7$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $55388fc2f116d4d7$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $55388fc2f116d4d7$var$useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function $55388fc2f116d4d7$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $55388fc2f116d4d7$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $55388fc2f116d4d7$var$strictEqual(a, b) {
    return a === b;
}
var $55388fc2f116d4d7$var$hasWarnedAboutDeprecatedPureOption = false;
function $55388fc2f116d4d7$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $55388fc2f116d4d7$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = $55388fc2f116d4d7$export$d36bdfa510afb180, areStatePropsEqual: areStatePropsEqual = $55388fc2f116d4d7$export$d36bdfa510afb180, areMergedPropsEqual: areMergedPropsEqual = $55388fc2f116d4d7$export$d36bdfa510afb180, forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = $55388fc2f116d4d7$export$cc80c08dc91f1c00 } = {}) {
    const Context = context;
    const initMapStateToProps = $55388fc2f116d4d7$var$mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = $55388fc2f116d4d7$var$mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = $55388fc2f116d4d7$var$mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $55388fc2f116d4d7$var$React.useMemo(()=>{
                const _a = props, { reactReduxForwardedRef: reactReduxForwardedRef2 } = _a, wrapperProps2 = $55388fc2f116d4d7$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = $55388fc2f116d4d7$var$React.useMemo(()=>{
                let ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = $55388fc2f116d4d7$var$React.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $55388fc2f116d4d7$var$React.useMemo(()=>{
                return $55388fc2f116d4d7$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $55388fc2f116d4d7$var$React.useMemo(()=>{
                if (!shouldHandleStateChanges) return $55388fc2f116d4d7$var$NO_SUBSCRIPTION_ARRAY;
                const subscription2 = $55388fc2f116d4d7$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = $55388fc2f116d4d7$var$React.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return $55388fc2f116d4d7$var$__spreadProps($55388fc2f116d4d7$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = $55388fc2f116d4d7$var$React.useRef();
            const lastWrapperProps = $55388fc2f116d4d7$var$React.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $55388fc2f116d4d7$var$React.useRef();
            const renderIsScheduled = $55388fc2f116d4d7$var$React.useRef(false);
            const isProcessingDispatch = $55388fc2f116d4d7$var$React.useRef(false);
            const isMounted = $55388fc2f116d4d7$var$React.useRef(false);
            const latestSubscriptionCallbackError = $55388fc2f116d4d7$var$React.useRef();
            $55388fc2f116d4d7$var$useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $55388fc2f116d4d7$var$React.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = $55388fc2f116d4d7$var$React.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $55388fc2f116d4d7$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $55388fc2f116d4d7$var$useIsomorphicLayoutEffectWithArgs($55388fc2f116d4d7$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $55388fc2f116d4d7$var$useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            $55388fc2f116d4d7$var$useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = $55388fc2f116d4d7$var$React.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ $55388fc2f116d4d7$var$React.createElement(WrappedComponent, $55388fc2f116d4d7$var$__spreadProps($55388fc2f116d4d7$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = $55388fc2f116d4d7$var$React.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ $55388fc2f116d4d7$var$React.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $55388fc2f116d4d7$var$React.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $55388fc2f116d4d7$var$React.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $55388fc2f116d4d7$var$React.createElement(Connect, $55388fc2f116d4d7$var$__spreadProps($55388fc2f116d4d7$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $55388fc2f116d4d7$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $55388fc2f116d4d7$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $55388fc2f116d4d7$export$64605811ab45167f = $55388fc2f116d4d7$var$connect;
// src/components/Provider.tsx
function $55388fc2f116d4d7$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = "once", identityFunctionCheck: identityFunctionCheck = "once" }) {
    const contextValue = $55388fc2f116d4d7$var$React.useMemo(()=>{
        const subscription = $55388fc2f116d4d7$var$createSubscription(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : void 0,
            stabilityCheck: stabilityCheck,
            identityFunctionCheck: identityFunctionCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        identityFunctionCheck
    ]);
    const previousState = $55388fc2f116d4d7$var$React.useMemo(()=>store.getState(), [
        store
    ]);
    $55388fc2f116d4d7$var$useIsomorphicLayoutEffect(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || $55388fc2f116d4d7$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $55388fc2f116d4d7$var$React.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $55388fc2f116d4d7$export$2881499e37b75b9a = $55388fc2f116d4d7$var$Provider;
// src/hooks/useStore.ts
function $55388fc2f116d4d7$export$671dba69185d0304(context = $55388fc2f116d4d7$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $55388fc2f116d4d7$export$cc80c08dc91f1c00 ? $55388fc2f116d4d7$var$useReduxContext : // @ts-ignore
    $55388fc2f116d4d7$var$createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store: store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var $55388fc2f116d4d7$export$6ccbb43953eebf8 = /* @__PURE__ */ $55388fc2f116d4d7$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $55388fc2f116d4d7$export$bc9b55530897c558(context = $55388fc2f116d4d7$export$cc80c08dc91f1c00) {
    const useStore2 = context === $55388fc2f116d4d7$export$cc80c08dc91f1c00 ? $55388fc2f116d4d7$export$6ccbb43953eebf8 : $55388fc2f116d4d7$export$671dba69185d0304(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var $55388fc2f116d4d7$export$8ad76b76a4c905f8 = /* @__PURE__ */ $55388fc2f116d4d7$export$bc9b55530897c558();
// src/exports.ts
var $55388fc2f116d4d7$export$712ea50be43a7858 = $55388fc2f116d4d7$var$defaultNoopBatch;
// src/index.ts
$55388fc2f116d4d7$var$initializeUseSelector((0, $701b6c0516155145$exports.useSyncExternalStoreWithSelector));
$55388fc2f116d4d7$var$initializeConnect($acw62.useSyncExternalStore);


/**
 * React Router DOM v6.17.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");
/**
 * @remix-run/router v1.10.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1d34d5c4a288b213$var$_extends() {
    $1d34d5c4a288b213$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1d34d5c4a288b213$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $1d34d5c4a288b213$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($1d34d5c4a288b213$export$e19cd5f9376f8cee || ($1d34d5c4a288b213$export$e19cd5f9376f8cee = {}));
const $1d34d5c4a288b213$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $1d34d5c4a288b213$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $1d34d5c4a288b213$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $1d34d5c4a288b213$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $1d34d5c4a288b213$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $1d34d5c4a288b213$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1d34d5c4a288b213$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1d34d5c4a288b213$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $1d34d5c4a288b213$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $1d34d5c4a288b213$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $1d34d5c4a288b213$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $1d34d5c4a288b213$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1d34d5c4a288b213$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1d34d5c4a288b213$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($1d34d5c4a288b213$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
        $1d34d5c4a288b213$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $1d34d5c4a288b213$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($1d34d5c4a288b213$var$ResultType || ($1d34d5c4a288b213$var$ResultType = {}));
const $1d34d5c4a288b213$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $1d34d5c4a288b213$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1d34d5c4a288b213$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $1d34d5c4a288b213$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($1d34d5c4a288b213$var$isIndexRoute(route)) {
            let indexRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $1d34d5c4a288b213$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $1d34d5c4a288b213$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $1d34d5c4a288b213$var$flattenRoutes(routes);
    $1d34d5c4a288b213$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $1d34d5c4a288b213$var$matchRouteBranch(branches[i], // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $1d34d5c4a288b213$var$safelyDecodeURI(pathname));
    return matches;
}
function $1d34d5c4a288b213$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $1d34d5c4a288b213$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $1d34d5c4a288b213$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $1d34d5c4a288b213$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1d34d5c4a288b213$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $1d34d5c4a288b213$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $1d34d5c4a288b213$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $1d34d5c4a288b213$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $1d34d5c4a288b213$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $1d34d5c4a288b213$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $1d34d5c4a288b213$var$paramRe = /^:\w+$/;
const $1d34d5c4a288b213$var$dynamicSegmentValue = 3;
const $1d34d5c4a288b213$var$indexRouteValue = 2;
const $1d34d5c4a288b213$var$emptySegmentValue = 1;
const $1d34d5c4a288b213$var$staticSegmentValue = 10;
const $1d34d5c4a288b213$var$splatPenalty = -2;
const $1d34d5c4a288b213$var$isSplat = (s)=>s === "*";
function $1d34d5c4a288b213$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($1d34d5c4a288b213$var$isSplat)) initialScore += $1d34d5c4a288b213$var$splatPenalty;
    if (index) initialScore += $1d34d5c4a288b213$var$indexRouteValue;
    return segments.filter((s)=>!$1d34d5c4a288b213$var$isSplat(s)).reduce((score, segment)=>score + ($1d34d5c4a288b213$var$paramRe.test(segment) ? $1d34d5c4a288b213$var$dynamicSegmentValue : segment === "" ? $1d34d5c4a288b213$var$emptySegmentValue : $1d34d5c4a288b213$var$staticSegmentValue), initialScore);
}
function $1d34d5c4a288b213$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $1d34d5c4a288b213$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1d34d5c4a288b213$export$a5c6d149b50c1d86($1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1d34d5c4a288b213$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $1d34d5c4a288b213$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:(\w+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $1d34d5c4a288b213$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $1d34d5c4a288b213$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, paramNames] = $1d34d5c4a288b213$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = paramNames.reduce((memo, paramName, index)=>{
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = $1d34d5c4a288b213$var$safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1d34d5c4a288b213$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $1d34d5c4a288b213$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let paramNames = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)/g, (_, paramName)=>{
        paramNames.push(paramName);
        return "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function $1d34d5c4a288b213$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $1d34d5c4a288b213$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $1d34d5c4a288b213$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $1d34d5c4a288b213$var$normalizeSearch(search),
        hash: $1d34d5c4a288b213$var$normalizeHash(hash)
    };
}
function $1d34d5c4a288b213$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1d34d5c4a288b213$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $1d34d5c4a288b213$export$90ba53ce1c7fdff2(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $1d34d5c4a288b213$export$8ccf933b0513f8d0(toArg);
    else {
        to = $1d34d5c4a288b213$var$_extends({}, toArg);
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $1d34d5c4a288b213$var$getInvalidPathError("?", "pathname", "search", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "pathname", "hash", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (isPathRelative || toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $1d34d5c4a288b213$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $1d34d5c4a288b213$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $1d34d5c4a288b213$export$42a99a7a4bc0e76a extends Error {
}
class $1d34d5c4a288b213$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $1d34d5c4a288b213$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $1d34d5c4a288b213$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref)=>{
            let [key, value] = _ref;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $1d34d5c4a288b213$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $1d34d5c4a288b213$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: $1d34d5c4a288b213$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $1d34d5c4a288b213$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $1d34d5c4a288b213$var$unwrapTrackedPromise(value) {
    if (!$1d34d5c4a288b213$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $1d34d5c4a288b213$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $1d34d5c4a288b213$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $1d34d5c4a288b213$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $1d34d5c4a288b213$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $1d34d5c4a288b213$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $1d34d5c4a288b213$var$validMutationMethods = new Set($1d34d5c4a288b213$var$validMutationMethodsArr);
const $1d34d5c4a288b213$var$validRequestMethodsArr = [
    "get",
    ...$1d34d5c4a288b213$var$validMutationMethodsArr
];
const $1d34d5c4a288b213$var$validRequestMethods = new Set($1d34d5c4a288b213$var$validRequestMethodsArr);
const $1d34d5c4a288b213$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $1d34d5c4a288b213$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $1d34d5c4a288b213$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $1d34d5c4a288b213$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_normalizeFormMethod: false,
        v7_prependBasename: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized = // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    !initialMatches.some((m)=>m.route.lazy) && // And we have to either have no loaders or have been provided hydrationData
    (!initialMatches.some((m)=>m.route.loader) || init.hydrationData != null);
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $1d34d5c4a288b213$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $1d34d5c4a288b213$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$1d34d5c4a288b213$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, viewTransitionOpts) {
        state = $1d34d5c4a288b213$var$_extends({}, state, newState);
        subscribers.forEach((subscriber)=>subscriber(state, {
                unstable_viewTransitionOpts: viewTransitionOpts
            }));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState) {
        var _location$state, _location$state2;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $1d34d5c4a288b213$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($1d34d5c4a288b213$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), viewTransitionOpts);
        // Reset stateful navigation vars
        pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $1d34d5c4a288b213$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $1d34d5c4a288b213$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, location, basename);
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $1d34d5c4a288b213$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$1d34d5c4a288b213$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(location, opts.submission);
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $1d34d5c4a288b213$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        });
        // Call our action and get the result
        let result;
        let actionMatch = $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $1d34d5c4a288b213$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $1d34d5c4a288b213$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $1d34d5c4a288b213$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $1d34d5c4a288b213$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        if (!isUninterruptedRevalidation) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($1d34d5c4a288b213$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $1d34d5c4a288b213$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $1d34d5c4a288b213$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getFetcher(key) {
        return state.fetchers.get(key) || $1d34d5c4a288b213$export$52eace9c284d3585;
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, routeId, opts == null ? void 0 : opts.relative);
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }));
            return;
        }
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error);
            return;
        }
        let match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error);
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        let fetcher = $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher);
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await $1d34d5c4a288b213$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by ou our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(actionResult)) {
            fetchControllers.delete(key);
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our action started, so that
                // should take precedence over this redirect navigation.  We already
                // set isRevalidationRequired so all loaders for the new route should
                // fire unless opted out via shouldRevalidate
                let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(undefined);
                state.fetchers.set(key, doneFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return;
            } else {
                fetchRedirectIds.add(key);
                let loadingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission);
                state.fetchers.set(key, loadingFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return startRedirectNavigation(state, actionResult, {
                    fetcherSubmission: submission
                });
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(actionResult)) {
            setFetcherError(key, routeId, actionResult.error);
            return;
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(actionResult)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $1d34d5c4a288b213$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $1d34d5c4a288b213$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        let didAbortFetchLoads = abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState($1d34d5c4a288b213$var$_extends({
                errors: errors,
                loaderData: $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, loaderData, matches, errors)
            }, didAbortFetchLoads || revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, submission) {
        let existingFetcher = state.fetchers.get(key);
        // Put this fetcher into it's loading state
        let loadingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined);
        state.fetchers.set(key, loadingFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await $1d34d5c4a288b213$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) result = await $1d34d5c4a288b213$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(undefined);
                state.fetchers.set(key, doneFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
            state.fetchers.delete(key);
            // TODO: In remix, this would reset to IDLE_NAVIGATION if it was a catch -
            // do we need to behave any differently with our non-redirect errors?
            // What if it was a non-redirect Response?
            updateState({
                fetchers: new Map(state.fetchers),
                errors: {
                    [boundaryMatch.route.id]: result.error
                }
            });
            return;
        }
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(result.data);
        state.fetchers.set(key, doneFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp === void 0 ? {} : _temp;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $1d34d5c4a288b213$var$createLocation(state.location, redirect.location, {
            _isRedirect: true
        });
        $1d34d5c4a288b213$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace : $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $1d34d5c4a288b213$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $1d34d5c4a288b213$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $1d34d5c4a288b213$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$1d34d5c4a288b213$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $1d34d5c4a288b213$var$callLoaderOrAction("loader", $1d34d5c4a288b213$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename);
                else {
                    let error = {
                        type: $1d34d5c4a288b213$var$ResultType.error,
                        error: $1d34d5c4a288b213$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function setFetcherError(key, routeId, error) {
        let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        });
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        state.fetchers.delete(key);
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $1d34d5c4a288b213$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $1d34d5c4a288b213$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $1d34d5c4a288b213$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $1d34d5c4a288b213$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$1d34d5c4a288b213$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcher,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $1d34d5c4a288b213$export$4d0306f8f6a4585b = Symbol("deferred");
function $1d34d5c4a288b213$export$3336b097a6fbc59a(routes, opts) {
    $1d34d5c4a288b213$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp2) {
        let { requestContext: requestContext } = _temp2 === void 0 ? {} : _temp2;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD") {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $1d34d5c4a288b213$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp3) {
        let { routeId: routeId, requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $1d34d5c4a288b213$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$1d34d5c4a288b213$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $1d34d5c4a288b213$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($1d34d5c4a288b213$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $1d34d5c4a288b213$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $1d34d5c4a288b213$var$isResponse(result) ? result : $1d34d5c4a288b213$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($1d34d5c4a288b213$var$isQueryRouteResponse(e)) {
                if (e.type === $1d34d5c4a288b213$var$ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($1d34d5c4a288b213$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        } else {
            result = await $1d34d5c4a288b213$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) {
                let method = isRouteRequest ? "queryRoute" : "query";
                throw new Error(method + "() call aborted: " + request.method + " " + request.url);
            }
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($1d34d5c4a288b213$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $1d34d5c4a288b213$var$_extends({}, context, {
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $1d34d5c4a288b213$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$1d34d5c4a288b213$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) {
            let method = isRouteRequest ? "queryRoute" : "query";
            throw new Error(method + "() call aborted: " + request.method + " " + request.url);
        }
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $1d34d5c4a288b213$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $1d34d5c4a288b213$export$fec11da027c70692(routes, context, error) {
    let newContext = $1d34d5c4a288b213$var$_extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $1d34d5c4a288b213$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $1d34d5c4a288b213$var$normalizeTo(location, matches, basename, prependBasename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId != null && relative !== "path") {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route.  When using relative:path,
        // fromRouteId is ignored since that is always relative to the current
        // location path
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $1d34d5c4a288b213$export$cae722b0cc860f13(to ? to : ".", $1d34d5c4a288b213$export$90ba53ce1c7fdff2(contextualMatches).map((m)=>m.pathnameBase), $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$1d34d5c4a288b213$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $1d34d5c4a288b213$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $1d34d5c4a288b213$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $1d34d5c4a288b213$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$1d34d5c4a288b213$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1d34d5c4a288b213$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $1d34d5c4a288b213$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $1d34d5c4a288b213$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $1d34d5c4a288b213$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $1d34d5c4a288b213$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $1d34d5c4a288b213$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $1d34d5c4a288b213$var$getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        if (match.route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (match.route.loader == null) return false;
        // Always call the loader on new route instances and pending defer cancellations
        if ($1d34d5c4a288b213$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $1d34d5c4a288b213$var$shouldRevalidateLoader(match, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $1d34d5c4a288b213$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate if fetcher won't be present in the subsequent render
        if (!matches.some((m)=>m.route.id === f.routeId)) return;
        let fetcherMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $1d34d5c4a288b213$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $1d34d5c4a288b213$var$shouldRevalidateLoader(fetcherMatch, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $1d34d5c4a288b213$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $1d34d5c4a288b213$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $1d34d5c4a288b213$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $1d34d5c4a288b213$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $1d34d5c4a288b213$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$1d34d5c4a288b213$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $1d34d5c4a288b213$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let values = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $1d34d5c4a288b213$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError) throw handlerError;
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $1d34d5c4a288b213$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $1d34d5c4a288b213$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $1d34d5c4a288b213$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $1d34d5c4a288b213$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($1d34d5c4a288b213$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($1d34d5c4a288b213$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) location = $1d34d5c4a288b213$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $1d34d5c4a288b213$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === $1d34d5c4a288b213$var$ResultType.error ? $1d34d5c4a288b213$var$ResultType.error : $1d34d5c4a288b213$var$ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        let contentType = result.headers.get("Content-Type");
        // Check between word boundaries instead of startsWith() due to the last
        // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
        if (contentType && /\bapplication\/json\b/.test(contentType)) data = await result.json();
        else data = await result.text();
        if (resultType === $1d34d5c4a288b213$var$ResultType.error) return {
            type: resultType,
            error: new $1d34d5c4a288b213$export$6c6580e81da25755(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $1d34d5c4a288b213$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($1d34d5c4a288b213$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $1d34d5c4a288b213$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $1d34d5c4a288b213$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($1d34d5c4a288b213$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $1d34d5c4a288b213$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1d34d5c4a288b213$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $1d34d5c4a288b213$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $1d34d5c4a288b213$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($1d34d5c4a288b213$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1d34d5c4a288b213$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $1d34d5c4a288b213$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $1d34d5c4a288b213$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $1d34d5c4a288b213$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1d34d5c4a288b213$var$getInternalRouterError(status, _temp4) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp4 === void 0 ? {} : _temp4;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $1d34d5c4a288b213$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $1d34d5c4a288b213$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $1d34d5c4a288b213$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) : path;
    return $1d34d5c4a288b213$export$fe53371bee54353d($1d34d5c4a288b213$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $1d34d5c4a288b213$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $1d34d5c4a288b213$var$isDeferredResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.deferred;
}
function $1d34d5c4a288b213$var$isErrorResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.error;
}
function $1d34d5c4a288b213$var$isRedirectResult(result) {
    return (result && result.type) === $1d34d5c4a288b213$var$ResultType.redirect;
}
function $1d34d5c4a288b213$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $1d34d5c4a288b213$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1d34d5c4a288b213$var$isRedirectResponse(result) {
    if (!$1d34d5c4a288b213$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $1d34d5c4a288b213$var$isQueryRouteResponse(obj) {
    return obj && $1d34d5c4a288b213$var$isResponse(obj.response) && (obj.type === $1d34d5c4a288b213$var$ResultType.data || obj.type === $1d34d5c4a288b213$var$ResultType.error);
}
function $1d34d5c4a288b213$var$isValidMethod(method) {
    return $1d34d5c4a288b213$var$validRequestMethods.has(method.toLowerCase());
}
function $1d34d5c4a288b213$var$isMutationMethod(method) {
    return $1d34d5c4a288b213$var$validMutationMethods.has(method.toLowerCase());
}
async function $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($1d34d5c4a288b213$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $1d34d5c4a288b213$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $1d34d5c4a288b213$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $1d34d5c4a288b213$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $1d34d5c4a288b213$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $1d34d5c4a288b213$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1d34d5c4a288b213$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $1d34d5c4a288b213$export$90ba53ce1c7fdff2(matches);
    return pathMatches[pathMatches.length - 1];
}
function $1d34d5c4a288b213$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $1d34d5c4a288b213$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $1d34d5c4a288b213$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $1d34d5c4a288b213$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.17.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

function $7939e29d663dd3ed$var$_extends() {
    $7939e29d663dd3ed$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7939e29d663dd3ed$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7939e29d663dd3ed$export$3add0d5dce533e2e = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$145dfa71566a64dc = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$var$AwaitContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7939e29d663dd3ed$export$26749e8557646306 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$c7914228fb69b0f5 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$9072aa6dd1f93057 = /*#__PURE__*/ $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $7939e29d663dd3ed$var$RouteErrorContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $7939e29d663dd3ed$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $7939e29d663dd3ed$export$9c954a9d03d32f4a() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $7939e29d663dd3ed$export$45d76561a5302f2b() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $7939e29d663dd3ed$export$1b3f31771c5d07c() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $7939e29d663dd3ed$export$6c330e8992e8a295(pattern) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7939e29d663dd3ed$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $acw62.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $7939e29d663dd3ed$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7939e29d663dd3ed$var$useNavigateStable() : $7939e29d663dd3ed$var$useNavigateUnstable();
}
function $7939e29d663dd3ed$var$useNavigateUnstable() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$OutletContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $7939e29d663dd3ed$export$4138103a3ae699cc() {
    return $acw62.useContext($7939e29d663dd3ed$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $7939e29d663dd3ed$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $7939e29d663dd3ed$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $7939e29d663dd3ed$export$5d3fca4a98652595(routes, locationArg) {
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg, dataRouterState) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: parentMatches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $1d34d5c4a288b213$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7939e29d663dd3ed$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7939e29d663dd3ed$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7939e29d663dd3ed$var$DefaultErrorComponent() {
    let error = $7939e29d663dd3ed$export$ed527bf60f6e05f2();
    let message = (0, $1d34d5c4a288b213$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7939e29d663dd3ed$var$defaultErrorElement = /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DefaultErrorComponent, null);
class $7939e29d663dd3ed$var$RenderErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error || state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7939e29d663dd3ed$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7939e29d663dd3ed$var$_renderMatches(matches, parentMatches, dataRouterState) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null;
        // Only data routers handle errors
        let errorElement = null;
        if (dataRouterState) errorElement = match.route.errorElement || $7939e29d663dd3ed$var$defaultErrorElement;
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7939e29d663dd3ed$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7939e29d663dd3ed$var$DataRouterHook || {});
var $7939e29d663dd3ed$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7939e29d663dd3ed$var$DataRouterStateHook || {});
function $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $7939e29d663dd3ed$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $7939e29d663dd3ed$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($7939e29d663dd3ed$export$145dfa71566a64dc);
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
function $7939e29d663dd3ed$var$useRouteContext(hookName) {
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $7939e29d663dd3ed$var$useCurrentRouteId(hookName) {
    let route = $7939e29d663dd3ed$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7939e29d663dd3ed$export$5fc8298006ad9e58() {
    return $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7939e29d663dd3ed$export$d0fd4b7106de2769() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7939e29d663dd3ed$export$600dc272ed516c15() {
    let dataRouterContext = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseRevalidator);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRevalidator);
    return $acw62.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7939e29d663dd3ed$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseMatches);
    return $acw62.useMemo(()=>matches.map((m)=>(0, $1d34d5c4a288b213$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7939e29d663dd3ed$export$1448a5050d252c4d() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7939e29d663dd3ed$export$fd5d37484eab868d(routeId) {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7939e29d663dd3ed$export$fdc00f3f26066d5e() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseActionData);
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return Object.values((state == null ? void 0 : state.actionData) || {})[0];
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7939e29d663dd3ed$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $acw62.useContext($7939e29d663dd3ed$var$RouteErrorContext);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$17f53340677d5831() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7939e29d663dd3ed$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7939e29d663dd3ed$export$2af03a1de5c0910(shouldBlock) {
    let { router: router, basename: basename } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseBlocker);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7939e29d663dd3ed$var$_extends({}, currentLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7939e29d663dd3ed$var$_extends({}, nextLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $acw62.useEffect(()=>{
        let key = String(++$7939e29d663dd3ed$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $1d34d5c4a288b213$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7939e29d663dd3ed$var$useNavigateStable() {
    let { router: router } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseNavigateStable);
    let id = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7939e29d663dd3ed$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$alreadyWarned = {};
function $7939e29d663dd3ed$var$warningOnce(key, cond, message) {
    if (!cond && !$7939e29d663dd3ed$var$alreadyWarned[key]) $7939e29d663dd3ed$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7939e29d663dd3ed$var$START_TRANSITION = "startTransition";
const $7939e29d663dd3ed$var$startTransitionImpl = $acw62[$7939e29d663dd3ed$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7939e29d663dd3ed$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        if (v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl) $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))), null);
}
function $7939e29d663dd3ed$var$DataRoutes(_ref2) {
    let { routes: routes, state: state } = _ref2;
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, undefined, state);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $7939e29d663dd3ed$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl ? $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $7939e29d663dd3ed$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let navigate = $7939e29d663dd3ed$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, (0, $1d34d5c4a288b213$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $7939e29d663dd3ed$export$910ae8079b2c2852(props) {
    return $7939e29d663dd3ed$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $7939e29d663dd3ed$export$e7b0ac011bb776c6(_props) {
    (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $7939e29d663dd3ed$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false } = _ref5;
    !!$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $7939e29d663dd3ed$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7939e29d663dd3ed$export$5d3fca4a98652595($7939e29d663dd3ed$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7939e29d663dd3ed$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$ResolveAwait, null, children));
}
var $7939e29d663dd3ed$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7939e29d663dd3ed$var$AwaitRenderStatus || {});
const $7939e29d663dd3ed$var$neverSettledPromise = new Promise(()=>{});
class $7939e29d663dd3ed$var$AwaitErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $7939e29d663dd3ed$var$AwaitRenderStatus.error : promise._data !== undefined ? $7939e29d663dd3ed$var$AwaitRenderStatus.success : $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && promise._error instanceof (0, $1d34d5c4a288b213$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $7939e29d663dd3ed$var$neverSettledPromise;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $7939e29d663dd3ed$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7939e29d663dd3ed$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $7939e29d663dd3ed$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7939e29d663dd3ed$export$e7b0ac011bb776c6) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7939e29d663dd3ed$export$daf73786167a7f72(matches) {
    return $7939e29d663dd3ed$var$_renderMatches(matches);
}
function $7939e29d663dd3ed$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $acw62.createElement(route.Component),
        Component: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $acw62.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7939e29d663dd3ed$export$f30f7e456d254e83(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7939e29d663dd3ed$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7939e29d663dd3ed$export$52b333d321859367
    }).initialize();
}



function $040dbb9c344a508d$var$_extends() {
    $040dbb9c344a508d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $040dbb9c344a508d$var$_extends.apply(this, arguments);
}
function $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $040dbb9c344a508d$var$defaultMethod = "get";
const $040dbb9c344a508d$var$defaultEncType = "application/x-www-form-urlencoded";
function $040dbb9c344a508d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $040dbb9c344a508d$var$isButtonElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $040dbb9c344a508d$var$isFormElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $040dbb9c344a508d$var$isInputElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $040dbb9c344a508d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $040dbb9c344a508d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$040dbb9c344a508d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $040dbb9c344a508d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $040dbb9c344a508d$var$_formDataSupportsSubmitter = null;
function $040dbb9c344a508d$var$isFormDataSubmitterSupported() {
    if ($040dbb9c344a508d$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = true;
    }
    return $040dbb9c344a508d$var$_formDataSupportsSubmitter;
}
const $040dbb9c344a508d$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $040dbb9c344a508d$var$getFormEncType(encType) {
    if (encType != null && !$040dbb9c344a508d$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($040dbb9c344a508d$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(target);
    } else if ($040dbb9c344a508d$var$isButtonElement(target) || $040dbb9c344a508d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("formenctype")) || $040dbb9c344a508d$var$getFormEncType(form.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$040dbb9c344a508d$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($040dbb9c344a508d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $040dbb9c344a508d$var$defaultMethod;
        action = null;
        encType = $040dbb9c344a508d$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $040dbb9c344a508d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $040dbb9c344a508d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $040dbb9c344a508d$var$_excluded3 = [
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "submit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
function $040dbb9c344a508d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $040dbb9c344a508d$var$_extends({}, state, {
        errors: $040dbb9c344a508d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $040dbb9c344a508d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $1d34d5c4a288b213$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $040dbb9c344a508d$export$7ad602f0e94e62d1 = /*#__PURE__*/ $acw62.createContext({
    isTransitioning: false
});
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $040dbb9c344a508d$var$START_TRANSITION = "startTransition";
const $040dbb9c344a508d$var$startTransitionImpl = $acw62[$040dbb9c344a508d$var$START_TRANSITION];
function $040dbb9c344a508d$var$startTransitionSafe(cb) {
    if ($040dbb9c344a508d$var$startTransitionImpl) $040dbb9c344a508d$var$startTransitionImpl(cb);
    else cb();
}
class $040dbb9c344a508d$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $040dbb9c344a508d$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $acw62.useCallback((cb)=>{
        if (v7_startTransition) $040dbb9c344a508d$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $acw62.useCallback((newState, _ref2)=>{
        let { unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        if (!viewTransitionOpts || router.window == null || typeof router.window.document.startViewTransition !== "function") // Mid-navigation state update, or startViewTransition isn't available
        optInStartTransition(()=>setStateImpl(newState));
        else if (transition && renderDfd) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        optInStartTransition,
        transition,
        renderDfd,
        router.window
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning) setRenderDfd(new $040dbb9c344a508d$var$Deferred());
    }, [
        vtContext.isTransitioning
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement)))), null);
}
function $040dbb9c344a508d$var$DataRoutes(_ref3) {
    let { routes: routes, state: state } = _ref3;
    return (0, $7939e29d663dd3ed$export$5fcee62552a12fbf)(routes, undefined, state);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $040dbb9c344a508d$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $040dbb9c344a508d$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $040dbb9c344a508d$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
const $040dbb9c344a508d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $040dbb9c344a508d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $acw62.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref7, $040dbb9c344a508d$var$_excluded);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($040dbb9c344a508d$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $7939e29d663dd3ed$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $040dbb9c344a508d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $acw62.createElement("a", $040dbb9c344a508d$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $040dbb9c344a508d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $acw62.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref8, $040dbb9c344a508d$var$_excluded2);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let routerState = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    let { navigator: navigator } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $040dbb9c344a508d$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a6c7ac8248d6e38a, $040dbb9c344a508d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $040dbb9c344a508d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    let submit = $040dbb9c344a508d$export$47c85c6e3a081d3();
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$FormImpl, $040dbb9c344a508d$var$_extends({}, props, {
        submit: submit,
        ref: ref
    }));
});
const $040dbb9c344a508d$var$FormImpl = /*#__PURE__*/ $acw62.forwardRef((_ref9, forwardedRef)=>{
    let { reloadDocument: reloadDocument, replace: replace, state: state, method: method = $040dbb9c344a508d$var$defaultMethod, action: action, onSubmit: onSubmit, submit: submit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref9, $040dbb9c344a508d$var$_excluded3);
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let formAction = $040dbb9c344a508d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            method: submitMethod,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $acw62.createElement("form", $040dbb9c344a508d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $040dbb9c344a508d$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $040dbb9c344a508d$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $040dbb9c344a508d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($040dbb9c344a508d$var$DataRouterHook || ($040dbb9c344a508d$var$DataRouterHook = {}));
var $040dbb9c344a508d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($040dbb9c344a508d$var$DataRouterStateHook || ($040dbb9c344a508d$var$DataRouterStateHook = {}));
function $040dbb9c344a508d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $040dbb9c344a508d$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext((0, $7939e29d663dd3ed$export$3add0d5dce533e2e));
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $040dbb9c344a508d$var$useDataRouterState(hookName) {
    let state = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $040dbb9c344a508d$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($040dbb9c344a508d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $1d34d5c4a288b213$export$fe53371bee54353d)(location) === (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $040dbb9c344a508d$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $acw62.useRef($040dbb9c344a508d$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $040dbb9c344a508d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $040dbb9c344a508d$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $040dbb9c344a508d$export$47c85c6e3a081d3() {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let currentRouteId = (0, $7939e29d663dd3ed$export$5fc8298006ad9e58)();
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $040dbb9c344a508d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename);
        router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
/**
 * Returns the implementation for fetcher.submit
 */ function $040dbb9c344a508d$var$useSubmitFetcher(fetcherKey, fetcherRouteId) {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmitFetcher);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $040dbb9c344a508d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename);
        !(fetcherRouteId != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, fetcherRouteId, options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType
        });
    }, [
        router,
        basename,
        fetcherKey,
        fetcherRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $040dbb9c344a508d$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let routeContext = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    !routeContext && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $040dbb9c344a508d$var$_extends({}, (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params of the resolved URL. This is
    // the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove the automatically
        // inserted ?index param so we match the useResolvedPath search behavior
        // which would not include ?index
        if (match.route.index) {
            let params = new URLSearchParams(path.search);
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
}
function $040dbb9c344a508d$var$createFetcherForm(fetcherKey, routeId) {
    let FetcherForm = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
        let submit = $040dbb9c344a508d$var$useSubmitFetcher(fetcherKey, routeId);
        return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$FormImpl, $040dbb9c344a508d$var$_extends({}, props, {
            ref: ref,
            submit: submit
        }));
    });
    return FetcherForm;
}
let $040dbb9c344a508d$var$fetcherId = 0;
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $040dbb9c344a508d$export$5b0d2d9a9921565a() {
    var _route$matches;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseFetcher);
    let route = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !(routeId != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let [fetcherKey] = $acw62.useState(()=>String(++$040dbb9c344a508d$var$fetcherId));
    let [Form] = $acw62.useState(()=>{
        !routeId && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        return $040dbb9c344a508d$var$createFetcherForm(fetcherKey, routeId);
    });
    let [load] = $acw62.useState(()=>(href)=>{
            !router && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
            !routeId && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
            router.fetch(fetcherKey, routeId, href);
        });
    let submit = $040dbb9c344a508d$var$useSubmitFetcher(fetcherKey, routeId);
    let fetcher = router.getFetcher(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>$040dbb9c344a508d$var$_extends({
            Form: Form,
            submit: submit,
            load: load
        }, fetcher), [
        fetcher,
        Form,
        submit,
        load
    ]);
    $acw62.useEffect(()=>{
        // Is this busted when the React team gets real weird and calls effects
        // twice on mount?  We really just need to garbage collect here when this
        // fetcher is no longer around.
        return ()=>{
            if (!router) {
                console.warn("No router available to clean up from useFetcher()");
                return;
            }
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $040dbb9c344a508d$export$fa996778a3a31087() {
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetchers);
    return [
        ...state.fetchers.values()
    ];
}
const $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $040dbb9c344a508d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $040dbb9c344a508d$export$25057cfe5591e3e9(_temp3) {
    let { getKey: getKey, storageKey: storageKey } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let matches = (0, $7939e29d663dd3ed$export$2378eb7f5ff86053)();
    let navigation = (0, $7939e29d663dd3ed$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $040dbb9c344a508d$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $040dbb9c344a508d$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($040dbb9c344a508d$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $040dbb9c344a508d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($040dbb9c344a508d$var$_extends({}, location, {
                    pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($040dbb9c344a508d$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $040dbb9c344a508d$export$39f4eb3dbd812741(_ref11) {
    let { when: when, message: message } = _ref11;
    let blocker = (0, $7939e29d663dd3ed$export$2af03a1de5c0910)(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $040dbb9c344a508d$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $acw62.useContext($040dbb9c344a508d$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.useViewTransitionState);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}


parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
"use client";
function $0bf9cc213b4abd2e$export$97d0e477aacf9b7d(errorMessage) {
    const Context = (0, $acw62.createContext)(null);
    const useSafeContext = ()=>{
        const ctx = (0, $acw62.useContext)(Context);
        if (ctx === null) throw new Error(errorMessage);
        return ctx;
    };
    const Provider = ({ children: children, value: value })=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Context.Provider, {
            value: value
        }, children);
    return [
        Provider,
        useSafeContext
    ];
}


"use client";
const [$bc836bedbf7f5239$export$f1c70b06465d541e, $bc836bedbf7f5239$export$6a9abcfe5948d367] = (0, $0bf9cc213b4abd2e$export$97d0e477aacf9b7d)("AppShell was not found in tree");


"use client";
var $5d5e905597c33b78$var$classes = {
    "root": "m-89ab340",
    "navbar": "m-45252eee",
    "aside": "m-9cdde9a",
    "header": "m-3b16f56b",
    "main": "m-8983817",
    "footer": "m-3840c879",
    "section": "m-6dcfc7c7"
};
var $5d5e905597c33b78$export$2e2bcd8739ae039 = $5d5e905597c33b78$var$classes;



var $acw62 = parcelRequire("acw62");
"use client";
function $f1a4862560c68aef$export$f0954fd7d5368655(value) {
    return value;
}
function $f1a4862560c68aef$export$e9008f2713103c6c(ui) {
    const Component = (0, $acw62.forwardRef)(ui);
    Component.extend = $f1a4862560c68aef$export$f0954fd7d5368655;
    return Component;
}



"use client";
function $3fdf1c4abf64babc$export$d697c39a2985a4c(props) {
    return Object.keys(props).reduce((acc, key)=>{
        if (props[key] !== void 0) acc[key] = props[key];
        return acc;
    }, {});
}


"use client";
var $4fa4869d2d954dac$var$__defProp = Object.defineProperty;
var $4fa4869d2d954dac$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $4fa4869d2d954dac$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $4fa4869d2d954dac$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $4fa4869d2d954dac$var$__defNormalProp = (obj, key, value)=>key in obj ? $4fa4869d2d954dac$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $4fa4869d2d954dac$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($4fa4869d2d954dac$var$__hasOwnProp.call(b, prop)) $4fa4869d2d954dac$var$__defNormalProp(a, prop, b[prop]);
    if ($4fa4869d2d954dac$var$__getOwnPropSymbols) {
        for (var prop of $4fa4869d2d954dac$var$__getOwnPropSymbols(b))if ($4fa4869d2d954dac$var$__propIsEnum.call(b, prop)) $4fa4869d2d954dac$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
function $4fa4869d2d954dac$export$1f264be2c424fccf(component, defaultProps, props) {
    var _a;
    const theme = (0, $692af3391f7b0a55$export$5eb0e84f6418b457)();
    const contextPropsPayload = (_a = theme.components[component]) == null ? void 0 : _a.defaultProps;
    const contextProps = typeof contextPropsPayload === "function" ? contextPropsPayload(theme) : contextPropsPayload;
    return $4fa4869d2d954dac$var$__spreadValues($4fa4869d2d954dac$var$__spreadValues($4fa4869d2d954dac$var$__spreadValues({}, defaultProps), contextProps), (0, $3fdf1c4abf64babc$export$d697c39a2985a4c)(props));
}



var $acw62 = parcelRequire("acw62");
function $f2ccb2ae3c8742b7$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $f2ccb2ae3c8742b7$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $f2ccb2ae3c8742b7$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $f2ccb2ae3c8742b7$export$2e2bcd8739ae039 = $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37;


"use client";
var $7b2d4b12475827bc$var$__defProp = Object.defineProperty;
var $7b2d4b12475827bc$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $7b2d4b12475827bc$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $7b2d4b12475827bc$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $7b2d4b12475827bc$var$__defNormalProp = (obj, key, value)=>key in obj ? $7b2d4b12475827bc$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $7b2d4b12475827bc$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($7b2d4b12475827bc$var$__hasOwnProp.call(b, prop)) $7b2d4b12475827bc$var$__defNormalProp(a, prop, b[prop]);
    if ($7b2d4b12475827bc$var$__getOwnPropSymbols) {
        for (var prop of $7b2d4b12475827bc$var$__getOwnPropSymbols(b))if ($7b2d4b12475827bc$var$__propIsEnum.call(b, prop)) $7b2d4b12475827bc$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
function $7b2d4b12475827bc$var$mergeStyles(styles, theme) {
    if (Array.isArray(styles)) return [
        ...styles
    ].reduce((acc, item)=>$7b2d4b12475827bc$var$__spreadValues($7b2d4b12475827bc$var$__spreadValues({}, acc), $7b2d4b12475827bc$var$mergeStyles(item, theme)), {});
    if (typeof styles === "function") return styles(theme);
    if (styles == null) return {};
    return styles;
}
function $7b2d4b12475827bc$export$19e246842511d5b({ theme: theme, style: style, vars: vars, styleProps: styleProps }) {
    const _style = $7b2d4b12475827bc$var$mergeStyles(style, theme);
    const _vars = $7b2d4b12475827bc$var$mergeStyles(vars, theme);
    return $7b2d4b12475827bc$var$__spreadValues($7b2d4b12475827bc$var$__spreadValues($7b2d4b12475827bc$var$__spreadValues({}, _style), _vars), styleProps);
}



var $acw62 = parcelRequire("acw62");
"use client";
function $6f7b5997f3c2d4f0$export$27120f2982e012b1() {
    const id = (0, $acw62.useId)().replace(/:/g, "");
    return `__m__-${id}`;
}


"use client";
var $723471e9004c98dc$var$__defProp = Object.defineProperty;
var $723471e9004c98dc$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $723471e9004c98dc$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $723471e9004c98dc$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $723471e9004c98dc$var$__defNormalProp = (obj, key, value)=>key in obj ? $723471e9004c98dc$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $723471e9004c98dc$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($723471e9004c98dc$var$__hasOwnProp.call(b, prop)) $723471e9004c98dc$var$__defNormalProp(a, prop, b[prop]);
    if ($723471e9004c98dc$var$__getOwnPropSymbols) {
        for (var prop of $723471e9004c98dc$var$__getOwnPropSymbols(b))if ($723471e9004c98dc$var$__propIsEnum.call(b, prop)) $723471e9004c98dc$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
function $723471e9004c98dc$var$transformModKey(key) {
    return key.startsWith("data-") ? key : `data-${key}`;
}
function $723471e9004c98dc$export$6e2be8e3a84cb13b(props) {
    return Object.keys(props).reduce((acc, key)=>{
        const value = props[key];
        if (value === void 0 || value === "" || value === false || value === null) return acc;
        acc[$723471e9004c98dc$var$transformModKey(key)] = props[key];
        return acc;
    }, {});
}
function $723471e9004c98dc$export$3ac4144d30a9eee0(mod) {
    if (!mod) return null;
    if (typeof mod === "string") return {
        [$723471e9004c98dc$var$transformModKey(mod)]: true
    };
    if (Array.isArray(mod)) return [
        ...mod
    ].reduce((acc, value)=>$723471e9004c98dc$var$__spreadValues($723471e9004c98dc$var$__spreadValues({}, acc), $723471e9004c98dc$export$3ac4144d30a9eee0(value)), {});
    return $723471e9004c98dc$export$6e2be8e3a84cb13b(mod);
}




"use client";
var $2e4262c949ef0e61$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $2e4262c949ef0e61$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $2e4262c949ef0e61$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $2e4262c949ef0e61$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($2e4262c949ef0e61$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $2e4262c949ef0e61$var$__getOwnPropSymbols) {
        for (var prop of $2e4262c949ef0e61$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $2e4262c949ef0e61$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
function $2e4262c949ef0e61$export$fbc67becbdd26fbf(others) {
    const _a = others, { m: m, mx: mx, my: my, mt: mt, mb: mb, ml: ml, mr: mr, p: p, px: px, py: py, pt: pt, pb: pb, pl: pl, pr: pr, bg: bg, c: c, opacity: opacity, ff: ff, fz: fz, fw: fw, lts: lts, ta: ta, lh: lh, fs: fs, tt: tt, td: td, w: w, miw: miw, maw: maw, h: h, mih: mih, mah: mah, bgsz: bgsz, bgp: bgp, bgr: bgr, bga: bga, pos: pos, top: top, left: left, bottom: bottom, right: right, inset: inset, display: display, hiddenFrom: hiddenFrom, visibleFrom: visibleFrom } = _a, rest = $2e4262c949ef0e61$var$__objRest(_a, [
        "m",
        "mx",
        "my",
        "mt",
        "mb",
        "ml",
        "mr",
        "p",
        "px",
        "py",
        "pt",
        "pb",
        "pl",
        "pr",
        "bg",
        "c",
        "opacity",
        "ff",
        "fz",
        "fw",
        "lts",
        "ta",
        "lh",
        "fs",
        "tt",
        "td",
        "w",
        "miw",
        "maw",
        "h",
        "mih",
        "mah",
        "bgsz",
        "bgp",
        "bgr",
        "bga",
        "pos",
        "top",
        "left",
        "bottom",
        "right",
        "inset",
        "display",
        "hiddenFrom",
        "visibleFrom"
    ]);
    const styleProps = (0, $3fdf1c4abf64babc$export$d697c39a2985a4c)({
        m: m,
        mx: mx,
        my: my,
        mt: mt,
        mb: mb,
        ml: ml,
        mr: mr,
        p: p,
        px: px,
        py: py,
        pt: pt,
        pb: pb,
        pl: pl,
        pr: pr,
        bg: bg,
        c: c,
        opacity: opacity,
        ff: ff,
        fz: fz,
        fw: fw,
        lts: lts,
        ta: ta,
        lh: lh,
        fs: fs,
        tt: tt,
        td: td,
        w: w,
        miw: miw,
        maw: maw,
        h: h,
        mih: mih,
        mah: mah,
        bgsz: bgsz,
        bgp: bgp,
        bgr: bgr,
        bga: bga,
        pos: pos,
        top: top,
        left: left,
        bottom: bottom,
        right: right,
        inset: inset,
        display: display,
        hiddenFrom: hiddenFrom,
        visibleFrom: visibleFrom
    });
    return {
        styleProps: styleProps,
        rest: rest
    };
}



"use client";
function $35bccfb500178ec5$export$4eae9cf015af18e5(color, theme) {
    const parsedColor = (0, $33a822173b5f4b0f$export$83e0a426d2da8ac1)({
        color: color,
        theme: theme
    });
    if (parsedColor.color === "dimmed") return "var(--mantine-color-dimmed)";
    if (parsedColor.color === "bright") return "var(--mantine-color-bright)";
    return parsedColor.variable ? `var(${parsedColor.variable})` : parsedColor.color;
}



"use client";
function $be02c3e429f44fcc$export$878e905dd08d927c(value, theme) {
    if (typeof value === "string" && value in theme.fontSizes) return `var(--mantine-font-size-${value})`;
    if (typeof value === "number") return (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(value);
    if (typeof value === "string") return (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(value);
    return value;
}



"use client";
function $e65e36a42f72f660$export$923b9614c33e29ca(value, theme) {
    if (typeof value === "number") return (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(value);
    if (typeof value === "string") {
        const mod = value.replace("-", "");
        if (!(mod in theme.spacing)) return (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(value);
        const variable = `--mantine-spacing-${mod}`;
        return value.startsWith("-") ? `calc(var(${variable}) * -1)` : `var(${variable})`;
    }
    return value;
}


"use client";
function $c8c0c63f11a096c2$export$b5037849b1d1bf66(value) {
    return value;
}



"use client";
function $49a8ebb02bf8e3c8$export$523b15dd291e73b8(value) {
    if (typeof value === "number") return (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(value);
    return value;
}


"use client";
function $05bb07fad2d65ceb$export$850e3162a100106c(value, theme) {
    if (typeof value === "string" && value in theme.fontSizes) return `var(--mantine-line-height-${value})`;
    return value;
}


"use client";
const $9ba7ded20a33cd51$export$f62412552be5daf2 = {
    color: (0, $35bccfb500178ec5$export$4eae9cf015af18e5),
    fontSize: (0, $be02c3e429f44fcc$export$878e905dd08d927c),
    spacing: (0, $e65e36a42f72f660$export$923b9614c33e29ca),
    identity: (0, $c8c0c63f11a096c2$export$b5037849b1d1bf66),
    size: (0, $49a8ebb02bf8e3c8$export$523b15dd291e73b8),
    lineHeight: (0, $05bb07fad2d65ceb$export$850e3162a100106c)
};


"use client";
var $c7cc304b6badeae9$var$__defProp = Object.defineProperty;
var $c7cc304b6badeae9$var$__defProps = Object.defineProperties;
var $c7cc304b6badeae9$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $c7cc304b6badeae9$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $c7cc304b6badeae9$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $c7cc304b6badeae9$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $c7cc304b6badeae9$var$__defNormalProp = (obj, key, value)=>key in obj ? $c7cc304b6badeae9$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $c7cc304b6badeae9$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($c7cc304b6badeae9$var$__hasOwnProp.call(b, prop)) $c7cc304b6badeae9$var$__defNormalProp(a, prop, b[prop]);
    if ($c7cc304b6badeae9$var$__getOwnPropSymbols) {
        for (var prop of $c7cc304b6badeae9$var$__getOwnPropSymbols(b))if ($c7cc304b6badeae9$var$__propIsEnum.call(b, prop)) $c7cc304b6badeae9$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $c7cc304b6badeae9$var$__spreadProps = (a, b)=>$c7cc304b6badeae9$var$__defProps(a, $c7cc304b6badeae9$var$__getOwnPropDescs(b));
var $c7cc304b6badeae9$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($c7cc304b6badeae9$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $c7cc304b6badeae9$var$__getOwnPropSymbols) {
        for (var prop of $c7cc304b6badeae9$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $c7cc304b6badeae9$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
function $c7cc304b6badeae9$var$replaceMediaQuery(query) {
    return query.replace("(min-width: ", "").replace("em)", "");
}
function $c7cc304b6badeae9$export$7b166a3227e41284(_a) {
    var _b = _a, { media: media } = _b, props = $c7cc304b6badeae9$var$__objRest(_b, [
        "media"
    ]);
    const breakpoints = Object.keys(media);
    const sortedMedia = breakpoints.sort((a, b)=>Number($c7cc304b6badeae9$var$replaceMediaQuery(a)) - Number($c7cc304b6badeae9$var$replaceMediaQuery(b))).map((query)=>({
            query: query,
            styles: media[query]
        }));
    return $c7cc304b6badeae9$var$__spreadProps($c7cc304b6badeae9$var$__spreadValues({}, props), {
        media: sortedMedia
    });
}



"use client";
var $06c0be1ba7c6b78f$var$__defProp = Object.defineProperty;
var $06c0be1ba7c6b78f$var$__defProps = Object.defineProperties;
var $06c0be1ba7c6b78f$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $06c0be1ba7c6b78f$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $06c0be1ba7c6b78f$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $06c0be1ba7c6b78f$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $06c0be1ba7c6b78f$var$__defNormalProp = (obj, key, value)=>key in obj ? $06c0be1ba7c6b78f$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $06c0be1ba7c6b78f$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($06c0be1ba7c6b78f$var$__hasOwnProp.call(b, prop)) $06c0be1ba7c6b78f$var$__defNormalProp(a, prop, b[prop]);
    if ($06c0be1ba7c6b78f$var$__getOwnPropSymbols) {
        for (var prop of $06c0be1ba7c6b78f$var$__getOwnPropSymbols(b))if ($06c0be1ba7c6b78f$var$__propIsEnum.call(b, prop)) $06c0be1ba7c6b78f$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $06c0be1ba7c6b78f$var$__spreadProps = (a, b)=>$06c0be1ba7c6b78f$var$__defProps(a, $06c0be1ba7c6b78f$var$__getOwnPropDescs(b));
function $06c0be1ba7c6b78f$var$hasResponsiveStyles(styleProp) {
    if (typeof styleProp !== "object" || styleProp === null) return false;
    const breakpoints = Object.keys(styleProp);
    if (breakpoints.length === 1 && breakpoints[0] === "base") return false;
    return true;
}
function $06c0be1ba7c6b78f$var$getBaseValue(value) {
    if (typeof value === "object" && value !== null) {
        if ("base" in value) return value.base;
        return void 0;
    }
    return value;
}
function $06c0be1ba7c6b78f$var$getBreakpointKeys(value) {
    if (typeof value === "object" && value !== null) return (0, $76cd5f02de8ee394$export$ed97f33186d4b816)(value).filter((key)=>key !== "base");
    return [];
}
function $06c0be1ba7c6b78f$var$getBreakpointValue(value, breakpoint) {
    if (typeof value === "object" && value !== null && breakpoint in value) return value[breakpoint];
    return value;
}
function $06c0be1ba7c6b78f$export$369a566827bae64e({ styleProps: styleProps, data: data, theme: theme }) {
    return (0, $c7cc304b6badeae9$export$7b166a3227e41284)((0, $76cd5f02de8ee394$export$ed97f33186d4b816)(styleProps).reduce((acc, styleProp)=>{
        if (styleProp === "hiddenFrom" || styleProp === "visibleFrom") return acc;
        const propertyData = data[styleProp];
        const properties = Array.isArray(propertyData.property) ? propertyData.property : [
            propertyData.property
        ];
        const baseValue = $06c0be1ba7c6b78f$var$getBaseValue(styleProps[styleProp]);
        if (!$06c0be1ba7c6b78f$var$hasResponsiveStyles(styleProps[styleProp])) {
            properties.forEach((property)=>{
                acc.inlineStyles[property] = (0, $9ba7ded20a33cd51$export$f62412552be5daf2)[propertyData.type](baseValue, theme);
            });
            return acc;
        }
        acc.hasResponsiveStyles = true;
        const breakpoints = $06c0be1ba7c6b78f$var$getBreakpointKeys(styleProps[styleProp]);
        properties.forEach((property)=>{
            if (baseValue) acc.styles[property] = (0, $9ba7ded20a33cd51$export$f62412552be5daf2)[propertyData.type](baseValue, theme);
            breakpoints.forEach((breakpoint)=>{
                const bp = `(min-width: ${theme.breakpoints[breakpoint]})`;
                acc.media[bp] = $06c0be1ba7c6b78f$var$__spreadProps($06c0be1ba7c6b78f$var$__spreadValues({}, acc.media[bp]), {
                    [property]: (0, $9ba7ded20a33cd51$export$f62412552be5daf2)[propertyData.type]($06c0be1ba7c6b78f$var$getBreakpointValue(styleProps[styleProp], breakpoint), theme)
                });
            });
        });
        return acc;
    }, {
        hasResponsiveStyles: false,
        styles: {},
        inlineStyles: {},
        media: {}
    }));
}


"use client";
const $b59b7faf20a9d5d4$export$2716120594d536e8 = {
    m: {
        type: "spacing",
        property: "margin"
    },
    mt: {
        type: "spacing",
        property: "marginTop"
    },
    mb: {
        type: "spacing",
        property: "marginBottom"
    },
    ml: {
        type: "spacing",
        property: "marginLeft"
    },
    mr: {
        type: "spacing",
        property: "marginRight"
    },
    mx: {
        type: "spacing",
        property: [
            "marginRight",
            "marginLeft"
        ]
    },
    my: {
        type: "spacing",
        property: [
            "marginTop",
            "marginBottom"
        ]
    },
    p: {
        type: "spacing",
        property: "padding"
    },
    pt: {
        type: "spacing",
        property: "paddingTop"
    },
    pb: {
        type: "spacing",
        property: "paddingBottom"
    },
    pl: {
        type: "spacing",
        property: "paddingLeft"
    },
    pr: {
        type: "spacing",
        property: "paddingRight"
    },
    px: {
        type: "spacing",
        property: [
            "paddingRight",
            "paddingLeft"
        ]
    },
    py: {
        type: "spacing",
        property: [
            "paddingTop",
            "paddingBottom"
        ]
    },
    bg: {
        type: "color",
        property: "background"
    },
    c: {
        type: "color",
        property: "color"
    },
    opacity: {
        type: "identity",
        property: "opacity"
    },
    ff: {
        type: "identity",
        property: "fontFamily"
    },
    fz: {
        type: "fontSize",
        property: "fontSize"
    },
    fw: {
        type: "identity",
        property: "fontWeight"
    },
    lts: {
        type: "size",
        property: "letterSpacing"
    },
    ta: {
        type: "identity",
        property: "textAlign"
    },
    lh: {
        type: "lineHeight",
        property: "lineHeight"
    },
    fs: {
        type: "identity",
        property: "fontStyle"
    },
    tt: {
        type: "identity",
        property: "textTransform"
    },
    td: {
        type: "identity",
        property: "textDecoration"
    },
    w: {
        type: "spacing",
        property: "width"
    },
    miw: {
        type: "spacing",
        property: "minWidth"
    },
    maw: {
        type: "spacing",
        property: "maxWidth"
    },
    h: {
        type: "spacing",
        property: "height"
    },
    mih: {
        type: "spacing",
        property: "minHeight"
    },
    mah: {
        type: "spacing",
        property: "maxHeight"
    },
    bgsz: {
        type: "size",
        property: "backgroundSize"
    },
    bgp: {
        type: "identity",
        property: "backgroundPosition"
    },
    bgr: {
        type: "identity",
        property: "backgroundRepeat"
    },
    bga: {
        type: "identity",
        property: "backgroundAttachment"
    },
    pos: {
        type: "identity",
        property: "position"
    },
    top: {
        type: "identity",
        property: "top"
    },
    left: {
        type: "size",
        property: "left"
    },
    bottom: {
        type: "size",
        property: "bottom"
    },
    right: {
        type: "size",
        property: "right"
    },
    inset: {
        type: "size",
        property: "inset"
    },
    display: {
        type: "identity",
        property: "display"
    }
};


"use client";
function $e5afc710a090ec45$export$bbf2f88383591790(value) {
    if (typeof value === "number") return true;
    if (typeof value === "string") {
        if (value.startsWith("calc(") || value.startsWith("var(")) return true;
        return /[0-9]/.test(value.trim().replace("-", "")[0]);
    }
    return false;
}



var $acw62 = parcelRequire("acw62");

"use client";
function $8251449e4ce423eb$export$12e614f5e6e4ebe4(value) {
    return value.replace(/[A-Z]/g, (letter)=>`-${letter.toLowerCase()}`);
}


"use client";
function $2a0efa82827a21b7$export$aa9768612bfaff7b(css) {
    return (0, $76cd5f02de8ee394$export$ed97f33186d4b816)(css).reduce((acc, rule)=>css[rule] !== void 0 ? `${acc}${(0, $8251449e4ce423eb$export$12e614f5e6e4ebe4)(rule)}:${css[rule]};` : acc, "").trim();
}


"use client";
function $eda5bb01d7647257$export$7790f45375f1d41({ selector: selector, styles: styles, media: media }) {
    const baseStyles = styles ? (0, $2a0efa82827a21b7$export$aa9768612bfaff7b)(styles) : "";
    const mediaQueryStyles = !Array.isArray(media) ? [] : media.map((item)=>`@media${item.query}{${selector}{${(0, $2a0efa82827a21b7$export$aa9768612bfaff7b)(item.styles)}}}`);
    return `${baseStyles ? `${selector}{${baseStyles}}` : ""}${mediaQueryStyles.join("")}`.trim();
}



"use client";
function $e221d2b030e78e40$export$6b8bda124c097cf0({ selector: selector, styles: styles, media: media }) {
    const nonce = (0, $bbb97275c373484a$export$ca3d89ae7d92a638)();
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", {
        "data-mantine-styles": "inline",
        nonce: nonce == null ? void 0 : nonce(),
        dangerouslySetInnerHTML: {
            __html: (0, $eda5bb01d7647257$export$7790f45375f1d41)({
                selector: selector,
                styles: styles,
                media: media
            })
        }
    });
}


"use client";
function $1a5a3b9a879562b6$export$639b89ea563ec697(component) {
    return component;
}


"use client";
var $8978bf78d2f2c844$var$__defProp = Object.defineProperty;
var $8978bf78d2f2c844$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $8978bf78d2f2c844$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $8978bf78d2f2c844$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $8978bf78d2f2c844$var$__defNormalProp = (obj, key, value)=>key in obj ? $8978bf78d2f2c844$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $8978bf78d2f2c844$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($8978bf78d2f2c844$var$__hasOwnProp.call(b, prop)) $8978bf78d2f2c844$var$__defNormalProp(a, prop, b[prop]);
    if ($8978bf78d2f2c844$var$__getOwnPropSymbols) {
        for (var prop of $8978bf78d2f2c844$var$__getOwnPropSymbols(b))if ($8978bf78d2f2c844$var$__propIsEnum.call(b, prop)) $8978bf78d2f2c844$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $8978bf78d2f2c844$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($8978bf78d2f2c844$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $8978bf78d2f2c844$var$__getOwnPropSymbols) {
        for (var prop of $8978bf78d2f2c844$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $8978bf78d2f2c844$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $8978bf78d2f2c844$var$_Box = (0, $acw62.forwardRef)((_a, ref)=>{
    var _b = _a, { component: component, style: style, __vars: __vars, className: className, variant: variant, mod: mod, size: size, hiddenFrom: hiddenFrom, visibleFrom: visibleFrom, renderRoot: renderRoot } = _b, others = $8978bf78d2f2c844$var$__objRest(_b, [
        "component",
        "style",
        "__vars",
        "className",
        "variant",
        "mod",
        "size",
        "hiddenFrom",
        "visibleFrom",
        "renderRoot"
    ]);
    const theme = (0, $692af3391f7b0a55$export$5eb0e84f6418b457)();
    const Element = component || "div";
    const { styleProps: styleProps, rest: rest } = (0, $2e4262c949ef0e61$export$fbc67becbdd26fbf)(others);
    const responsiveClassName = (0, $6f7b5997f3c2d4f0$export$27120f2982e012b1)();
    const parsedStyleProps = (0, $06c0be1ba7c6b78f$export$369a566827bae64e)({
        styleProps: styleProps,
        theme: theme,
        data: (0, $b59b7faf20a9d5d4$export$2716120594d536e8)
    });
    const props = $8978bf78d2f2c844$var$__spreadValues($8978bf78d2f2c844$var$__spreadValues({
        ref: ref,
        style: (0, $7b2d4b12475827bc$export$19e246842511d5b)({
            theme: theme,
            style: style,
            vars: __vars,
            styleProps: parsedStyleProps.inlineStyles
        }),
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(className, {
            [responsiveClassName]: parsedStyleProps.hasResponsiveStyles,
            [`mantine-hidden-from-${hiddenFrom}`]: hiddenFrom,
            [`mantine-visible-from-${visibleFrom}`]: visibleFrom
        }),
        "data-variant": variant,
        "data-size": (0, $e5afc710a090ec45$export$bbf2f88383591790)(size) ? void 0 : size || void 0
    }, (0, $723471e9004c98dc$export$3ac4144d30a9eee0)(mod)), rest);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, parsedStyleProps.hasResponsiveStyles && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e221d2b030e78e40$export$6b8bda124c097cf0), {
        selector: `.${responsiveClassName}`,
        styles: parsedStyleProps.styles,
        media: parsedStyleProps.media
    }), typeof renderRoot === "function" ? renderRoot(props) : /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Element, $8978bf78d2f2c844$var$__spreadValues({}, props)));
});
$8978bf78d2f2c844$var$_Box.displayName = "@mantine/core/Box";
const $8978bf78d2f2c844$export$e71c4d32a2263218 = (0, $1a5a3b9a879562b6$export$639b89ea563ec697)($8978bf78d2f2c844$var$_Box);


"use client";
var $81ba6bfef5e37874$var$__defProp = Object.defineProperty;
var $81ba6bfef5e37874$var$__defProps = Object.defineProperties;
var $81ba6bfef5e37874$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $81ba6bfef5e37874$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $81ba6bfef5e37874$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $81ba6bfef5e37874$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $81ba6bfef5e37874$var$__defNormalProp = (obj, key, value)=>key in obj ? $81ba6bfef5e37874$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $81ba6bfef5e37874$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($81ba6bfef5e37874$var$__hasOwnProp.call(b, prop)) $81ba6bfef5e37874$var$__defNormalProp(a, prop, b[prop]);
    if ($81ba6bfef5e37874$var$__getOwnPropSymbols) {
        for (var prop of $81ba6bfef5e37874$var$__getOwnPropSymbols(b))if ($81ba6bfef5e37874$var$__propIsEnum.call(b, prop)) $81ba6bfef5e37874$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $81ba6bfef5e37874$var$__spreadProps = (a, b)=>$81ba6bfef5e37874$var$__defProps(a, $81ba6bfef5e37874$var$__getOwnPropDescs(b));
var $81ba6bfef5e37874$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($81ba6bfef5e37874$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $81ba6bfef5e37874$var$__getOwnPropSymbols) {
        for (var prop of $81ba6bfef5e37874$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $81ba6bfef5e37874$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $81ba6bfef5e37874$var$defaultProps = {};
const $81ba6bfef5e37874$export$8a923106bebaaaad = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("AppShellNavbar", $81ba6bfef5e37874$var$defaultProps, _props);
    const _a = props, { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, withBorder: withBorder, zIndex: zIndex } = _a, others = $81ba6bfef5e37874$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "withBorder",
        "zIndex"
    ]);
    const ctx = (0, $bc836bedbf7f5239$export$6a9abcfe5948d367)();
    if (ctx.disabled) return null;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $81ba6bfef5e37874$var$__spreadProps($81ba6bfef5e37874$var$__spreadValues($81ba6bfef5e37874$var$__spreadValues({
        component: "nav",
        ref: ref,
        mod: {
            "with-border": withBorder != null ? withBorder : ctx.withBorder
        }
    }, ctx.getStyles("navbar", {
        className: className,
        classNames: classNames,
        styles: styles,
        style: style
    })), others), {
        __vars: {
            "--app-shell-navbar-z-index": `calc(${zIndex != null ? zIndex : ctx.zIndex} + 1)`
        }
    }));
});
$81ba6bfef5e37874$export$8a923106bebaaaad.classes = (0, $5d5e905597c33b78$export$2e2bcd8739ae039);
$81ba6bfef5e37874$export$8a923106bebaaaad.displayName = "@mantine/core/AppShellNavbar";




var $acw62 = parcelRequire("acw62");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92
};



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $3f8d56f1a38c65c8$export$1da7500147d4bc3 = "right-scroll-bar-position";
var $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e = "width-before-scroll-bar";
var $3f8d56f1a38c65c8$export$bb813dfbbc432abc = "with-scroll-bars-hidden";
var $3f8d56f1a38c65c8$export$63d0edf80fea83b1 = "--removed-body-scroll-bar-size";


/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $9ce81be4473c2c96$export$d734136a7b018efe(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
    return ref;
}



var $acw62 = parcelRequire("acw62");
function $05ac61ef45da8ec5$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $acw62.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}


function $1ec01e2201501f3d$export$74665b213cb5c4cf(refs, defaultValue) {
    return (0, $05ac61ef45da8ec5$export$25bec8c6f54ee79a)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $9ce81be4473c2c96$export$d734136a7b018efe)(ref, newValue);
        });
    });
}



function $dce67a1050af61cf$var$ItoI(a) {
    return a;
}
function $dce67a1050af61cf$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $dce67a1050af61cf$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $dce67a1050af61cf$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $dce67a1050af61cf$var$ItoI;
    return $dce67a1050af61cf$var$innerCreateMedium(defaults, middleware);
}
function $dce67a1050af61cf$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $dce67a1050af61cf$var$innerCreateMedium(null);
    medium.options = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        async: true,
        ssr: false
    }, options);
    return medium;
}


var $f6d5b57f3512e73c$export$e27363444bedfeac = (0, $dce67a1050af61cf$export$e13ec7dd7a14088d)();


var $cac2578984d345ac$var$nothing = function() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var $cac2578984d345ac$export$22940b497e769dee = $acw62.forwardRef(function(props, parentRef) {
    var ref = $acw62.useRef(null);
    var _a = $acw62.useState({
        onScrollCapture: $cac2578984d345ac$var$nothing,
        onWheelCapture: $cac2578984d345ac$var$nothing,
        onTouchMoveCapture: $cac2578984d345ac$var$nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? "div" : _b, gapMode = props.gapMode, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as",
        "gapMode"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, $1ec01e2201501f3d$export$74665b213cb5c4cf)([
        ref,
        parentRef
    ]);
    var containerProps = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, rest), callbacks);
    return $acw62.createElement($acw62.Fragment, null, enabled && $acw62.createElement(SideCar, {
        sideCar: (0, $f6d5b57f3512e73c$export$e27363444bedfeac),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref,
        gapMode: gapMode
    }), forwardProps ? $acw62.cloneElement($acw62.Children.only(children), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, containerProps), {
        ref: containerRef
    })) : $acw62.createElement(Container, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
$cac2578984d345ac$export$22940b497e769dee.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
$cac2578984d345ac$export$22940b497e769dee.classNames = {
    fullWidth: (0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e),
    zeroRight: (0, $3f8d56f1a38c65c8$export$1da7500147d4bc3)
};




var $acw62 = parcelRequire("acw62");
var $c86481a7b0dfcc68$var$SideCar = function(_a) {
    var sideCar = _a.sideCar, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "sideCar"
    ]);
    if (!sideCar) throw new Error("Sidecar: please provide `sideCar` property to import the right car");
    var Target = sideCar.read();
    if (!Target) throw new Error("Sidecar medium not found");
    return $acw62.createElement(Target, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, rest));
};
$c86481a7b0dfcc68$var$SideCar.isSideCarExport = true;
function $c86481a7b0dfcc68$export$6cacc8fb0a9b94ce(medium, exported) {
    medium.useMedium(exported);
    return $c86481a7b0dfcc68$var$SideCar;
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $1334c25f36aeceaf$var$currentNonce;
var $1334c25f36aeceaf$export$c5f670b24c0ae95a = function(nonce) {
    $1334c25f36aeceaf$var$currentNonce = nonce;
};
var $1334c25f36aeceaf$export$2b85b721e524d74b = function() {
    if ($1334c25f36aeceaf$var$currentNonce) return $1334c25f36aeceaf$var$currentNonce;
    if (typeof __webpack_nonce__ !== "undefined") return __webpack_nonce__;
    return undefined;
};


function $be1d9ed5bb532264$var$makeStyleTag() {
    if (!document) return null;
    var tag = document.createElement("style");
    tag.type = "text/css";
    var nonce = (0, $1334c25f36aeceaf$export$2b85b721e524d74b)();
    if (nonce) tag.setAttribute("nonce", nonce);
    return tag;
}
function $be1d9ed5bb532264$var$injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) // @ts-ignore
    tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $be1d9ed5bb532264$var$insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName("head")[0];
    head.appendChild(tag);
}
var $be1d9ed5bb532264$export$7c74eec858d5d226 = function() {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function(style) {
            if (counter == 0) {
                if (stylesheet = $be1d9ed5bb532264$var$makeStyleTag()) {
                    $be1d9ed5bb532264$var$injectStyles(stylesheet, style);
                    $be1d9ed5bb532264$var$insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function() {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        }
    };
};


var $b5f767dd03f483e5$export$7d7b35c2d250e94c = function() {
    var sheet = (0, $be1d9ed5bb532264$export$7c74eec858d5d226)();
    return function(styles, isDynamic) {
        $acw62.useEffect(function() {
            sheet.add(styles);
            return function() {
                sheet.remove();
            };
        }, [
            styles && isDynamic
        ]);
    };
};


var $eb3b6a23a33fb1ba$export$c1248ee86ba532c8 = function() {
    var useStyle = (0, $b5f767dd03f483e5$export$7d7b35c2d250e94c)();
    var Sheet = function(_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};







var $19c77eb414ad2a19$export$efed13b5d0ca3386 = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
};
var $19c77eb414ad2a19$var$parse = function(x) {
    return parseInt(x || "", 10) || 0;
};
var $19c77eb414ad2a19$var$getOffset = function(gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === "padding" ? "paddingLeft" : "marginLeft"];
    var top = cs[gapMode === "padding" ? "paddingTop" : "marginTop"];
    var right = cs[gapMode === "padding" ? "paddingRight" : "marginRight"];
    return [
        $19c77eb414ad2a19$var$parse(left),
        $19c77eb414ad2a19$var$parse(top),
        $19c77eb414ad2a19$var$parse(right)
    ];
};
var $19c77eb414ad2a19$export$75f2ca8f029c77f4 = function(gapMode) {
    if (gapMode === void 0) gapMode = "margin";
    if (typeof window === "undefined") return $19c77eb414ad2a19$export$efed13b5d0ca3386;
    var offsets = $19c77eb414ad2a19$var$getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
    };
};


var $9f2b7a700f678519$var$Style = (0, $eb3b6a23a33fb1ba$export$c1248ee86ba532c8)();
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var $9f2b7a700f678519$var$getStyles = function(_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) gapMode = "margin";
    return "\n  .".concat((0, $3f8d56f1a38c65c8$export$bb813dfbbc432abc), " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === "margin" && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === "padding" && "padding-right: ".concat(gap, "px ").concat(important, ";")
    ].filter(Boolean).join(""), "\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$1da7500147d4bc3), " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e), " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$1da7500147d4bc3), " .").concat((0, $3f8d56f1a38c65c8$export$1da7500147d4bc3), " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e), " .").concat((0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e), " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body {\n    ").concat((0, $3f8d56f1a38c65c8$export$63d0edf80fea83b1), ": ").concat(gap, "px;\n  }\n");
};
var $9f2b7a700f678519$export$9aa43b459c5ae9b9 = function(props) {
    var noRelative = props.noRelative, noImportant = props.noImportant, _a = props.gapMode, gapMode = _a === void 0 ? "margin" : _a;
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */ var gap = $acw62.useMemo(function() {
        return (0, $19c77eb414ad2a19$export$75f2ca8f029c77f4)(gapMode);
    }, [
        gapMode
    ]);
    return $acw62.createElement($9f2b7a700f678519$var$Style, {
        styles: $9f2b7a700f678519$var$getStyles(gap, !noRelative, gapMode, !noImportant ? "!important" : "")
    });
};







var $6f0aa8d921410141$var$passiveSupported = false;
if (typeof window !== "undefined") try {
    var $6f0aa8d921410141$var$options = Object.defineProperty({}, "passive", {
        get: function() {
            $6f0aa8d921410141$var$passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener("test", $6f0aa8d921410141$var$options, $6f0aa8d921410141$var$options);
    // @ts-ignore
    window.removeEventListener("test", $6f0aa8d921410141$var$options, $6f0aa8d921410141$var$options);
} catch (err) {
    $6f0aa8d921410141$var$passiveSupported = false;
}
var $6f0aa8d921410141$export$10a6e88623fa9454 = $6f0aa8d921410141$var$passiveSupported ? {
    passive: false
} : false;


var $a7f277057d6643d0$var$alwaysContainsScroll = function(node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === "TEXTAREA";
};
var $a7f277057d6643d0$var$elementCanBeScrolled = function(node, overflow) {
    var styles = window.getComputedStyle(node);
    return(// not-not-scrollable
    styles[overflow] !== "hidden" && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !$a7f277057d6643d0$var$alwaysContainsScroll(node) && styles[overflow] === "visible"));
};
var $a7f277057d6643d0$var$elementCouldBeVScrolled = function(node) {
    return $a7f277057d6643d0$var$elementCanBeScrolled(node, "overflowY");
};
var $a7f277057d6643d0$var$elementCouldBeHScrolled = function(node) {
    return $a7f277057d6643d0$var$elementCanBeScrolled(node, "overflowX");
};
var $a7f277057d6643d0$export$9ec64480cae49817 = function(axis, node) {
    var ownerDocument = node.ownerDocument;
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== "undefined" && current instanceof ShadowRoot) current = current.host;
        var isScrollable = $a7f277057d6643d0$var$elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = $a7f277057d6643d0$var$getScrollVariables(axis, current), s = _a[1], d = _a[2];
            if (s > d) return true;
        }
        current = current.parentNode;
    }while (current && current !== ownerDocument.body);
    return false;
};
var $a7f277057d6643d0$var$getVScrollVariables = function(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var $a7f277057d6643d0$var$getHScrollVariables = function(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var $a7f277057d6643d0$var$elementCouldBeScrolled = function(axis, node) {
    return axis === "v" ? $a7f277057d6643d0$var$elementCouldBeVScrolled(node) : $a7f277057d6643d0$var$elementCouldBeHScrolled(node);
};
var $a7f277057d6643d0$var$getScrollVariables = function(axis, node) {
    return axis === "v" ? $a7f277057d6643d0$var$getVScrollVariables(node) : $a7f277057d6643d0$var$getHScrollVariables(node);
};
var $a7f277057d6643d0$var$getDirectionFactor = function(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === "h" && direction === "rtl" ? -1 : 1;
};
var $a7f277057d6643d0$export$dde0441bd4a6ded8 = function(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = $a7f277057d6643d0$var$getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        var _a = $a7f277057d6643d0$var$getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if ($a7f277057d6643d0$var$elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        if (target instanceof ShadowRoot) target = target.host;
        else target = target.parentNode;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    // handle epsilon around 0 (non standard zoom levels)
    if (isDeltaPositive && (noOverscroll && Math.abs(availableScroll) < 1 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && Math.abs(availableScrollTop) < 1 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};


var $f5f147098910888d$export$6e085704a79f4f56 = function(event) {
    return "changedTouches" in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var $f5f147098910888d$export$39efaa2ca254a28d = function(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var $f5f147098910888d$var$extractRef = function(ref) {
    return ref && "current" in ref ? ref.current : ref;
};
var $f5f147098910888d$var$deltaCompare = function(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var $f5f147098910888d$var$generateStyle = function(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var $f5f147098910888d$var$idCounter = 0;
var $f5f147098910888d$var$lockStack = [];
function $f5f147098910888d$export$a09dbff87b5da2d(props) {
    var shouldPreventQueue = $acw62.useRef([]);
    var touchStartRef = $acw62.useRef([
        0,
        0
    ]);
    var activeAxis = $acw62.useRef();
    var id = $acw62.useState($f5f147098910888d$var$idCounter++)[0];
    var Style = $acw62.useState((0, $eb3b6a23a33fb1ba$export$c1248ee86ba532c8))[0];
    var lastProps = $acw62.useRef(props);
    $acw62.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    $acw62.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
                props.lockRef.current
            ], (props.shards || []).map($f5f147098910888d$var$extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = $acw62.useCallback(function(event, parent) {
        if ("touches" in event && event.touches.length === 2) return !lastProps.current.allowPinchZoom;
        var touch = $f5f147098910888d$export$6e085704a79f4f56(event);
        var touchStart = touchStartRef.current;
        var deltaX = "deltaX" in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = "deltaY" in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? "h" : "v";
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ("touches" in event && moveDirection === "h" && target.type === "range") return false;
        var canBeScrolledInMainDirection = (0, $a7f277057d6643d0$export$9ec64480cae49817)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === "v" ? "h" : "v";
            canBeScrolledInMainDirection = (0, $a7f277057d6643d0$export$9ec64480cae49817)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && "changedTouches" in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, $a7f277057d6643d0$export$dde0441bd4a6ded8)(cancelingAxis, parent, event, cancelingAxis === "h" ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = $acw62.useCallback(function(_event) {
        var event = _event;
        if (!$f5f147098910888d$var$lockStack.length || $f5f147098910888d$var$lockStack[$f5f147098910888d$var$lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = "deltaY" in event ? $f5f147098910888d$export$39efaa2ca254a28d(event) : $f5f147098910888d$export$6e085704a79f4f56(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && (e.target === event.target || event.target === e.shadowParent) && $f5f147098910888d$var$deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map($f5f147098910888d$var$extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) event.preventDefault();
            }
        }
    }, []);
    var shouldCancel = $acw62.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should,
            shadowParent: $f5f147098910888d$var$getOutermostShadowParent(target)
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = $acw62.useCallback(function(event) {
        touchStartRef.current = $f5f147098910888d$export$6e085704a79f4f56(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = $acw62.useCallback(function(event) {
        shouldCancel(event.type, $f5f147098910888d$export$39efaa2ca254a28d(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = $acw62.useCallback(function(event) {
        shouldCancel(event.type, $f5f147098910888d$export$6e085704a79f4f56(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    $acw62.useEffect(function() {
        $f5f147098910888d$var$lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener("wheel", shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        document.addEventListener("touchmove", shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        document.addEventListener("touchstart", scrollTouchStart, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        return function() {
            $f5f147098910888d$var$lockStack = $f5f147098910888d$var$lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener("wheel", shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
            document.removeEventListener("touchmove", shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
            document.removeEventListener("touchstart", scrollTouchStart, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return $acw62.createElement($acw62.Fragment, null, inert ? $acw62.createElement(Style, {
        styles: $f5f147098910888d$var$generateStyle(id)
    }) : null, removeScrollBar ? $acw62.createElement((0, $9f2b7a700f678519$export$9aa43b459c5ae9b9), {
        gapMode: props.gapMode
    }) : null);
}
function $f5f147098910888d$var$getOutermostShadowParent(node) {
    var shadowParent = null;
    while(node !== null){
        if (node instanceof ShadowRoot) {
            shadowParent = node.host;
            node = node.host;
        }
        node = node.parentNode;
    }
    return shadowParent;
}



var $0e88b28988758ab2$export$2e2bcd8739ae039 = (0, $c86481a7b0dfcc68$export$6cacc8fb0a9b94ce)((0, $f6d5b57f3512e73c$export$e27363444bedfeac), (0, $f5f147098910888d$export$a09dbff87b5da2d));


var $cfb1c25e3ef3d3bc$var$ReactRemoveScroll = $acw62.forwardRef(function(props, ref) {
    return $acw62.createElement((0, $cac2578984d345ac$export$22940b497e769dee), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, props, {
        ref: ref,
        sideCar: (0, $0e88b28988758ab2$export$2e2bcd8739ae039)
    }));
});
$cfb1c25e3ef3d3bc$var$ReactRemoveScroll.classNames = (0, $cac2578984d345ac$export$22940b497e769dee).classNames;
var $cfb1c25e3ef3d3bc$export$2e2bcd8739ae039 = $cfb1c25e3ef3d3bc$var$ReactRemoveScroll;







"use client";
var $f45aa3268986d2cf$var$__defProp = Object.defineProperty;
var $f45aa3268986d2cf$var$__defProps = Object.defineProperties;
var $f45aa3268986d2cf$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $f45aa3268986d2cf$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $f45aa3268986d2cf$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $f45aa3268986d2cf$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $f45aa3268986d2cf$var$__defNormalProp = (obj, key, value)=>key in obj ? $f45aa3268986d2cf$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $f45aa3268986d2cf$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($f45aa3268986d2cf$var$__hasOwnProp.call(b, prop)) $f45aa3268986d2cf$var$__defNormalProp(a, prop, b[prop]);
    if ($f45aa3268986d2cf$var$__getOwnPropSymbols) {
        for (var prop of $f45aa3268986d2cf$var$__getOwnPropSymbols(b))if ($f45aa3268986d2cf$var$__propIsEnum.call(b, prop)) $f45aa3268986d2cf$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $f45aa3268986d2cf$var$__spreadProps = (a, b)=>$f45aa3268986d2cf$var$__defProps(a, $f45aa3268986d2cf$var$__getOwnPropDescs(b));
var $f45aa3268986d2cf$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($f45aa3268986d2cf$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $f45aa3268986d2cf$var$__getOwnPropSymbols) {
        for (var prop of $f45aa3268986d2cf$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $f45aa3268986d2cf$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $f45aa3268986d2cf$var$defaultProps = {};
const $f45aa3268986d2cf$export$7932a9fc07def21a = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props, ref)=>{
    var _b;
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("AppShellHeader", $f45aa3268986d2cf$var$defaultProps, _props);
    const _a = props, { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, withBorder: withBorder, zIndex: zIndex } = _a, others = $f45aa3268986d2cf$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "withBorder",
        "zIndex"
    ]);
    const ctx = (0, $bc836bedbf7f5239$export$6a9abcfe5948d367)();
    if (ctx.disabled) return null;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $f45aa3268986d2cf$var$__spreadProps($f45aa3268986d2cf$var$__spreadValues($f45aa3268986d2cf$var$__spreadValues({
        component: "header",
        ref: ref,
        mod: {
            "with-border": withBorder != null ? withBorder : ctx.withBorder
        }
    }, ctx.getStyles("header", {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)((0, $cfb1c25e3ef3d3bc$export$2e2bcd8739ae039).classNames.zeroRight, className),
        classNames: classNames,
        styles: styles,
        style: style
    })), others), {
        __vars: {
            "--app-shell-header-z-index": (_b = zIndex != null ? zIndex : ctx.zIndex) == null ? void 0 : _b.toString()
        }
    }));
});
$f45aa3268986d2cf$export$7932a9fc07def21a.classes = (0, $5d5e905597c33b78$export$2e2bcd8739ae039);
$f45aa3268986d2cf$export$7932a9fc07def21a.displayName = "@mantine/core/AppShellHeader";




var $acw62 = parcelRequire("acw62");






"use client";
var $7f89d268cd453eb6$var$__defProp = Object.defineProperty;
var $7f89d268cd453eb6$var$__defProps = Object.defineProperties;
var $7f89d268cd453eb6$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $7f89d268cd453eb6$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $7f89d268cd453eb6$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $7f89d268cd453eb6$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $7f89d268cd453eb6$var$__defNormalProp = (obj, key, value)=>key in obj ? $7f89d268cd453eb6$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $7f89d268cd453eb6$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($7f89d268cd453eb6$var$__hasOwnProp.call(b, prop)) $7f89d268cd453eb6$var$__defNormalProp(a, prop, b[prop]);
    if ($7f89d268cd453eb6$var$__getOwnPropSymbols) {
        for (var prop of $7f89d268cd453eb6$var$__getOwnPropSymbols(b))if ($7f89d268cd453eb6$var$__propIsEnum.call(b, prop)) $7f89d268cd453eb6$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $7f89d268cd453eb6$var$__spreadProps = (a, b)=>$7f89d268cd453eb6$var$__defProps(a, $7f89d268cd453eb6$var$__getOwnPropDescs(b));
var $7f89d268cd453eb6$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($7f89d268cd453eb6$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $7f89d268cd453eb6$var$__getOwnPropSymbols) {
        for (var prop of $7f89d268cd453eb6$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $7f89d268cd453eb6$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $7f89d268cd453eb6$var$defaultProps = {};
const $7f89d268cd453eb6$export$c7be6f5ced93654d = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props, ref)=>{
    var _b;
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("AppShellFooter", $7f89d268cd453eb6$var$defaultProps, _props);
    const _a = props, { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, withBorder: withBorder, zIndex: zIndex } = _a, others = $7f89d268cd453eb6$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "withBorder",
        "zIndex"
    ]);
    const ctx = (0, $bc836bedbf7f5239$export$6a9abcfe5948d367)();
    if (ctx.disabled) return null;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $7f89d268cd453eb6$var$__spreadProps($7f89d268cd453eb6$var$__spreadValues($7f89d268cd453eb6$var$__spreadValues({
        component: "footer",
        ref: ref,
        mod: {
            "with-border": withBorder != null ? withBorder : ctx.withBorder
        }
    }, ctx.getStyles("footer", {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)((0, $cfb1c25e3ef3d3bc$export$2e2bcd8739ae039).classNames.zeroRight, className),
        classNames: classNames,
        styles: styles,
        style: style
    })), others), {
        __vars: {
            "--app-shell-footer-z-index": (_b = zIndex != null ? zIndex : ctx.zIndex) == null ? void 0 : _b.toString()
        }
    }));
});
$7f89d268cd453eb6$export$c7be6f5ced93654d.classes = (0, $5d5e905597c33b78$export$2e2bcd8739ae039);
$7f89d268cd453eb6$export$c7be6f5ced93654d.displayName = "@mantine/core/AppShellFooter";



var $acw62 = parcelRequire("acw62");





"use client";
var $78e6f4a4a0198500$var$__defProp = Object.defineProperty;
var $78e6f4a4a0198500$var$__defProps = Object.defineProperties;
var $78e6f4a4a0198500$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $78e6f4a4a0198500$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $78e6f4a4a0198500$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $78e6f4a4a0198500$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $78e6f4a4a0198500$var$__defNormalProp = (obj, key, value)=>key in obj ? $78e6f4a4a0198500$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $78e6f4a4a0198500$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($78e6f4a4a0198500$var$__hasOwnProp.call(b, prop)) $78e6f4a4a0198500$var$__defNormalProp(a, prop, b[prop]);
    if ($78e6f4a4a0198500$var$__getOwnPropSymbols) {
        for (var prop of $78e6f4a4a0198500$var$__getOwnPropSymbols(b))if ($78e6f4a4a0198500$var$__propIsEnum.call(b, prop)) $78e6f4a4a0198500$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $78e6f4a4a0198500$var$__spreadProps = (a, b)=>$78e6f4a4a0198500$var$__defProps(a, $78e6f4a4a0198500$var$__getOwnPropDescs(b));
var $78e6f4a4a0198500$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($78e6f4a4a0198500$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $78e6f4a4a0198500$var$__getOwnPropSymbols) {
        for (var prop of $78e6f4a4a0198500$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $78e6f4a4a0198500$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $78e6f4a4a0198500$var$defaultProps = {};
const $78e6f4a4a0198500$export$53f6f96f8b7092f2 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("AppShellAside", $78e6f4a4a0198500$var$defaultProps, _props);
    const _a = props, { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, withBorder: withBorder, zIndex: zIndex } = _a, others = $78e6f4a4a0198500$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "withBorder",
        "zIndex"
    ]);
    const ctx = (0, $bc836bedbf7f5239$export$6a9abcfe5948d367)();
    if (ctx.disabled) return null;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $78e6f4a4a0198500$var$__spreadProps($78e6f4a4a0198500$var$__spreadValues($78e6f4a4a0198500$var$__spreadValues({
        component: "aside",
        ref: ref,
        mod: {
            "with-border": withBorder != null ? withBorder : ctx.withBorder
        }
    }, ctx.getStyles("aside", {
        className: className,
        classNames: classNames,
        styles: styles,
        style: style
    })), others), {
        __vars: {
            "--app-shell-aside-z-index": `calc(${zIndex != null ? zIndex : ctx.zIndex} + 1)`
        }
    }));
});
$78e6f4a4a0198500$export$53f6f96f8b7092f2.classes = (0, $5d5e905597c33b78$export$2e2bcd8739ae039);
$78e6f4a4a0198500$export$53f6f96f8b7092f2.displayName = "@mantine/core/AppShellAside";



var $acw62 = parcelRequire("acw62");





"use client";
var $b02392ee6d9b6089$var$__defProp = Object.defineProperty;
var $b02392ee6d9b6089$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $b02392ee6d9b6089$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $b02392ee6d9b6089$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $b02392ee6d9b6089$var$__defNormalProp = (obj, key, value)=>key in obj ? $b02392ee6d9b6089$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $b02392ee6d9b6089$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($b02392ee6d9b6089$var$__hasOwnProp.call(b, prop)) $b02392ee6d9b6089$var$__defNormalProp(a, prop, b[prop]);
    if ($b02392ee6d9b6089$var$__getOwnPropSymbols) {
        for (var prop of $b02392ee6d9b6089$var$__getOwnPropSymbols(b))if ($b02392ee6d9b6089$var$__propIsEnum.call(b, prop)) $b02392ee6d9b6089$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $b02392ee6d9b6089$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($b02392ee6d9b6089$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $b02392ee6d9b6089$var$__getOwnPropSymbols) {
        for (var prop of $b02392ee6d9b6089$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $b02392ee6d9b6089$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $b02392ee6d9b6089$var$defaultProps = {};
const $b02392ee6d9b6089$export$38840998a170df80 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("AppShellMain", $b02392ee6d9b6089$var$defaultProps, _props);
    const _a = props, { classNames: classNames, className: className, style: style, styles: styles, vars: vars } = _a, others = $b02392ee6d9b6089$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars"
    ]);
    const ctx = (0, $bc836bedbf7f5239$export$6a9abcfe5948d367)();
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $b02392ee6d9b6089$var$__spreadValues($b02392ee6d9b6089$var$__spreadValues({
        component: "main",
        ref: ref
    }, ctx.getStyles("main", {
        className: className,
        style: style,
        classNames: classNames,
        styles: styles
    })), others));
});
$b02392ee6d9b6089$export$38840998a170df80.classes = (0, $5d5e905597c33b78$export$2e2bcd8739ae039);
$b02392ee6d9b6089$export$38840998a170df80.displayName = "@mantine/core/AppShellMain";



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

"use client";
function $dfead8eb7283bc39$export$197bdd704df40a29(ui) {
    const Component = (0, $acw62.forwardRef)(ui);
    Component.extend = (0, $f1a4862560c68aef$export$f0954fd7d5368655);
    return Component;
}




"use client";
var $bbd9fd8be7935767$var$__defProp = Object.defineProperty;
var $bbd9fd8be7935767$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $bbd9fd8be7935767$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $bbd9fd8be7935767$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $bbd9fd8be7935767$var$__defNormalProp = (obj, key, value)=>key in obj ? $bbd9fd8be7935767$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $bbd9fd8be7935767$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($bbd9fd8be7935767$var$__hasOwnProp.call(b, prop)) $bbd9fd8be7935767$var$__defNormalProp(a, prop, b[prop]);
    if ($bbd9fd8be7935767$var$__getOwnPropSymbols) {
        for (var prop of $bbd9fd8be7935767$var$__getOwnPropSymbols(b))if ($bbd9fd8be7935767$var$__propIsEnum.call(b, prop)) $bbd9fd8be7935767$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $bbd9fd8be7935767$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($bbd9fd8be7935767$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $bbd9fd8be7935767$var$__getOwnPropSymbols) {
        for (var prop of $bbd9fd8be7935767$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $bbd9fd8be7935767$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $bbd9fd8be7935767$var$defaultProps = {};
const $bbd9fd8be7935767$export$807454a51b0b3c53 = (0, $dfead8eb7283bc39$export$197bdd704df40a29)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("AppShellSection", $bbd9fd8be7935767$var$defaultProps, _props);
    const _a = props, { classNames: classNames, className: className, style: style, styles: styles, vars: vars, grow: grow } = _a, others = $bbd9fd8be7935767$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars",
        "grow"
    ]);
    const ctx = (0, $bc836bedbf7f5239$export$6a9abcfe5948d367)();
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $bbd9fd8be7935767$var$__spreadValues($bbd9fd8be7935767$var$__spreadValues({
        ref: ref,
        mod: {
            grow: grow
        }
    }, ctx.getStyles("section", {
        className: className,
        style: style,
        classNames: classNames,
        styles: styles
    })), others));
});
$bbd9fd8be7935767$export$807454a51b0b3c53.classes = (0, $5d5e905597c33b78$export$2e2bcd8739ae039);
$bbd9fd8be7935767$export$807454a51b0b3c53.displayName = "@mantine/core/AppShellSection";



var $acw62 = parcelRequire("acw62");
"use client";
function $3e5e4a7b004b31ae$export$13e1ea2a48bdc51e(size) {
    if (typeof size !== "object" || size === null) return false;
    if (Object.keys(size).length === 1 && "base" in size) return false;
    return true;
}


"use client";
function $dbe2020228889b86$export$595d4c6c22e3891(size) {
    const isBaseSize = typeof size === "object" && size !== null && typeof size.base !== "undefined" && Object.keys(size).length === 1;
    return typeof size === "number" || typeof size === "string" || isBaseSize;
}


"use client";
function $0788b76ca8d1217c$export$88a9076c5877d24f(size) {
    if (typeof size === "object") return size.base;
    return size;
}




"use client";
function $0b047129fb57dfcc$export$4adb988360925c51(breakpoint, theme) {
    if (breakpoint in theme.breakpoints) return (0, $36050ce217b59930$export$91c0eda1d06bf008)(theme.breakpoints[breakpoint]);
    return (0, $36050ce217b59930$export$91c0eda1d06bf008)(breakpoint);
}



"use client";
function $e50d39ec24509fdf$export$b266d6a359856a1d({ baseStyles: baseStyles, minMediaStyles: minMediaStyles, maxMediaStyles: maxMediaStyles, aside: aside, theme: theme }) {
    var _a, _b, _c;
    const asideWidth = aside == null ? void 0 : aside.width;
    const collapsedAsideTransform = "translateX(var(--app-shell-aside-width))";
    const collapsedAsideTransformRtl = "translateX(calc(var(--app-shell-aside-width) * -1))";
    if ((aside == null ? void 0 : aside.breakpoint) && !((_a = aside == null ? void 0 : aside.collapsed) == null ? void 0 : _a.mobile)) {
        maxMediaStyles[aside == null ? void 0 : aside.breakpoint] = maxMediaStyles[aside == null ? void 0 : aside.breakpoint] || {};
        maxMediaStyles[aside == null ? void 0 : aside.breakpoint]["--app-shell-aside-width"] = "100%";
        maxMediaStyles[aside == null ? void 0 : aside.breakpoint]["--app-shell-aside-offset"] = "0px";
    }
    if ((0, $dbe2020228889b86$export$595d4c6c22e3891)(asideWidth)) {
        const baseSize = (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)((0, $0788b76ca8d1217c$export$88a9076c5877d24f)(asideWidth));
        baseStyles["--app-shell-aside-width"] = baseSize;
        baseStyles["--app-shell-aside-offset"] = baseSize;
    }
    if ((0, $3e5e4a7b004b31ae$export$13e1ea2a48bdc51e)(asideWidth)) {
        if (typeof asideWidth.base !== "undefined") {
            baseStyles["--app-shell-aside-width"] = (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(asideWidth.base);
            baseStyles["--app-shell-aside-offset"] = (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(asideWidth.base);
        }
        (0, $76cd5f02de8ee394$export$ed97f33186d4b816)(asideWidth).forEach((key)=>{
            if (key !== "base") {
                minMediaStyles[key] = minMediaStyles[key] || {};
                minMediaStyles[key]["--app-shell-aside-width"] = (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(asideWidth[key]);
                minMediaStyles[key]["--app-shell-aside-offset"] = (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(asideWidth[key]);
            }
        });
    }
    if ((_b = aside == null ? void 0 : aside.collapsed) == null ? void 0 : _b.desktop) {
        const breakpointValue = aside.breakpoint;
        minMediaStyles[breakpointValue] = minMediaStyles[breakpointValue] || {};
        minMediaStyles[breakpointValue]["--app-shell-aside-transform"] = collapsedAsideTransform;
        minMediaStyles[breakpointValue]["--app-shell-aside-transform-rtl"] = collapsedAsideTransformRtl;
        minMediaStyles[breakpointValue]["--app-shell-aside-offset"] = "0px !important";
    }
    if ((_c = aside == null ? void 0 : aside.collapsed) == null ? void 0 : _c.mobile) {
        const breakpointValue = (0, $0b047129fb57dfcc$export$4adb988360925c51)(aside.breakpoint, theme) - 0.1;
        maxMediaStyles[breakpointValue] = maxMediaStyles[breakpointValue] || {};
        maxMediaStyles[breakpointValue]["--app-shell-aside-width"] = "100%";
        maxMediaStyles[breakpointValue]["--app-shell-aside-offset"] = "0px";
        maxMediaStyles[breakpointValue]["--app-shell-aside-transform"] = collapsedAsideTransform;
        maxMediaStyles[breakpointValue]["--app-shell-aside-transform-rtl"] = collapsedAsideTransformRtl;
    }
}







"use client";
function $2fb426187e235bef$export$9b0931cecc660105({ baseStyles: baseStyles, minMediaStyles: minMediaStyles, footer: footer }) {
    var _a;
    const footerHeight = footer == null ? void 0 : footer.height;
    const collapsedFooterTransform = "translateY(var(--app-shell-footer-height))";
    const shouldOffset = (_a = footer == null ? void 0 : footer.offset) != null ? _a : true;
    if ((0, $dbe2020228889b86$export$595d4c6c22e3891)(footerHeight)) {
        const baseSize = (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)((0, $0788b76ca8d1217c$export$88a9076c5877d24f)(footerHeight));
        baseStyles["--app-shell-footer-height"] = baseSize;
        if (shouldOffset) baseStyles["--app-shell-footer-offset"] = baseSize;
    }
    if ((0, $3e5e4a7b004b31ae$export$13e1ea2a48bdc51e)(footerHeight)) {
        if (typeof footerHeight.base !== "undefined") {
            baseStyles["--app-shell-footer-height"] = (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(footerHeight.base);
            if (shouldOffset) baseStyles["--app-shell-footer-offset"] = (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(footerHeight.base);
        }
        (0, $76cd5f02de8ee394$export$ed97f33186d4b816)(footerHeight).forEach((key)=>{
            if (key !== "base") {
                minMediaStyles[key] = minMediaStyles[key] || {};
                minMediaStyles[key]["--app-shell-footer-height"] = (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(footerHeight[key]);
                if (shouldOffset) minMediaStyles[key]["--app-shell-footer-offset"] = (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(footerHeight[key]);
            }
        });
    }
    if (footer == null ? void 0 : footer.collapsed) {
        baseStyles["--app-shell-footer-transform"] = collapsedFooterTransform;
        baseStyles["--app-shell-footer-offset"] = "0px !important";
    }
}







"use client";
function $2bb10e190151b86d$export$9990017af629c1d7({ baseStyles: baseStyles, minMediaStyles: minMediaStyles, header: header }) {
    var _a;
    const headerHeight = header == null ? void 0 : header.height;
    const collapsedHeaderTransform = "translateY(calc(var(--app-shell-header-height) * -1))";
    const shouldOffset = (_a = header == null ? void 0 : header.offset) != null ? _a : true;
    if ((0, $dbe2020228889b86$export$595d4c6c22e3891)(headerHeight)) {
        const baseSize = (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)((0, $0788b76ca8d1217c$export$88a9076c5877d24f)(headerHeight));
        baseStyles["--app-shell-header-height"] = baseSize;
        if (shouldOffset) baseStyles["--app-shell-header-offset"] = baseSize;
    }
    if ((0, $3e5e4a7b004b31ae$export$13e1ea2a48bdc51e)(headerHeight)) {
        if (typeof headerHeight.base !== "undefined") {
            baseStyles["--app-shell-header-height"] = (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(headerHeight.base);
            if (shouldOffset) baseStyles["--app-shell-header-offset"] = (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(headerHeight.base);
        }
        (0, $76cd5f02de8ee394$export$ed97f33186d4b816)(headerHeight).forEach((key)=>{
            if (key !== "base") {
                minMediaStyles[key] = minMediaStyles[key] || {};
                minMediaStyles[key]["--app-shell-header-height"] = (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(headerHeight[key]);
                if (shouldOffset) minMediaStyles[key]["--app-shell-header-offset"] = (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(headerHeight[key]);
            }
        });
    }
    if (header == null ? void 0 : header.collapsed) {
        baseStyles["--app-shell-header-transform"] = collapsedHeaderTransform;
        baseStyles["--app-shell-header-offset"] = "0px !important";
    }
}








"use client";
function $5b76db2b2ae599e8$export$4e3d4baa5f113da9({ baseStyles: baseStyles, minMediaStyles: minMediaStyles, maxMediaStyles: maxMediaStyles, navbar: navbar, theme: theme }) {
    var _a, _b, _c;
    const navbarWidth = navbar == null ? void 0 : navbar.width;
    const collapsedNavbarTransform = "translateX(calc(var(--app-shell-navbar-width) * -1))";
    const collapsedNavbarTransformRtl = "translateX(var(--app-shell-navbar-width))";
    if ((navbar == null ? void 0 : navbar.breakpoint) && !((_a = navbar == null ? void 0 : navbar.collapsed) == null ? void 0 : _a.mobile)) {
        maxMediaStyles[navbar == null ? void 0 : navbar.breakpoint] = maxMediaStyles[navbar == null ? void 0 : navbar.breakpoint] || {};
        maxMediaStyles[navbar == null ? void 0 : navbar.breakpoint]["--app-shell-navbar-width"] = "100%";
        maxMediaStyles[navbar == null ? void 0 : navbar.breakpoint]["--app-shell-navbar-offset"] = "0px";
    }
    if ((0, $dbe2020228889b86$export$595d4c6c22e3891)(navbarWidth)) {
        const baseSize = (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)((0, $0788b76ca8d1217c$export$88a9076c5877d24f)(navbarWidth));
        baseStyles["--app-shell-navbar-width"] = baseSize;
        baseStyles["--app-shell-navbar-offset"] = baseSize;
    }
    if ((0, $3e5e4a7b004b31ae$export$13e1ea2a48bdc51e)(navbarWidth)) {
        if (typeof navbarWidth.base !== "undefined") {
            baseStyles["--app-shell-navbar-width"] = (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(navbarWidth.base);
            baseStyles["--app-shell-navbar-offset"] = (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(navbarWidth.base);
        }
        (0, $76cd5f02de8ee394$export$ed97f33186d4b816)(navbarWidth).forEach((key)=>{
            if (key !== "base") {
                minMediaStyles[key] = minMediaStyles[key] || {};
                minMediaStyles[key]["--app-shell-navbar-width"] = (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(navbarWidth[key]);
                minMediaStyles[key]["--app-shell-navbar-offset"] = (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(navbarWidth[key]);
            }
        });
    }
    if ((_b = navbar == null ? void 0 : navbar.collapsed) == null ? void 0 : _b.desktop) {
        const breakpointValue = navbar.breakpoint;
        minMediaStyles[breakpointValue] = minMediaStyles[breakpointValue] || {};
        minMediaStyles[breakpointValue]["--app-shell-navbar-transform"] = collapsedNavbarTransform;
        minMediaStyles[breakpointValue]["--app-shell-navbar-transform-rtl"] = collapsedNavbarTransformRtl;
        minMediaStyles[breakpointValue]["--app-shell-navbar-offset"] = "0px !important";
    }
    if ((_c = navbar == null ? void 0 : navbar.collapsed) == null ? void 0 : _c.mobile) {
        const breakpointValue = (0, $0b047129fb57dfcc$export$4adb988360925c51)(navbar.breakpoint, theme) - 0.1;
        maxMediaStyles[breakpointValue] = maxMediaStyles[breakpointValue] || {};
        maxMediaStyles[breakpointValue]["--app-shell-navbar-width"] = "100%";
        maxMediaStyles[breakpointValue]["--app-shell-navbar-offset"] = "0px";
        maxMediaStyles[breakpointValue]["--app-shell-navbar-transform"] = collapsedNavbarTransform;
        maxMediaStyles[breakpointValue]["--app-shell-navbar-transform-rtl"] = collapsedNavbarTransformRtl;
    }
}





"use client";
function $fcab4af601ce7e99$export$31b21d0167753bb4(size, prefix = "size", convertToRem = true) {
    if (size === void 0) return void 0;
    return (0, $e5afc710a090ec45$export$bbf2f88383591790)(size) ? convertToRem ? (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(size) : size : `var(--${prefix}-${size})`;
}
function $fcab4af601ce7e99$export$f63796f8a9382bfb(size) {
    return $fcab4af601ce7e99$export$31b21d0167753bb4(size, "mantine-spacing");
}
function $fcab4af601ce7e99$export$35724d9c2979edc5(size) {
    if (size === void 0) return "var(--mantine-radius-default)";
    return $fcab4af601ce7e99$export$31b21d0167753bb4(size, "mantine-radius");
}
function $fcab4af601ce7e99$export$7d055c252aebca58(size) {
    return $fcab4af601ce7e99$export$31b21d0167753bb4(size, "mantine-font-size");
}
function $fcab4af601ce7e99$export$56204a27a2958a55(size) {
    return $fcab4af601ce7e99$export$31b21d0167753bb4(size, "mantine-line-height", false);
}
function $fcab4af601ce7e99$export$db93b77dbb14f011(size) {
    if (!size) return void 0;
    return $fcab4af601ce7e99$export$31b21d0167753bb4(size, "mantine-shadow");
}


"use client";
function $ed317108986257b0$export$802b63d1375ae912(padding) {
    return Number(padding) === 0 ? "0px" : (0, $fcab4af601ce7e99$export$f63796f8a9382bfb)(padding);
}





"use client";
function $00df409f9b7f8b8f$export$32b13804b21181d0({ padding: padding, baseStyles: baseStyles, minMediaStyles: minMediaStyles }) {
    if ((0, $dbe2020228889b86$export$595d4c6c22e3891)(padding)) baseStyles["--app-shell-padding"] = (0, $ed317108986257b0$export$802b63d1375ae912)((0, $0788b76ca8d1217c$export$88a9076c5877d24f)(padding));
    if ((0, $3e5e4a7b004b31ae$export$13e1ea2a48bdc51e)(padding)) {
        if (padding.base) baseStyles["--app-shell-padding"] = (0, $ed317108986257b0$export$802b63d1375ae912)(padding.base);
        (0, $76cd5f02de8ee394$export$ed97f33186d4b816)(padding).forEach((key)=>{
            if (key !== "base") {
                minMediaStyles[key] = minMediaStyles[key] || {};
                minMediaStyles[key]["--app-shell-padding"] = (0, $ed317108986257b0$export$802b63d1375ae912)(padding[key]);
            }
        });
    }
}



"use client";
function $e4e164d3d352ee58$export$bd80382e31449c0e(breakpoints, theme) {
    const convertedBreakpoints = breakpoints.map((breakpoint)=>({
            value: breakpoint,
            px: (0, $0b047129fb57dfcc$export$4adb988360925c51)(breakpoint, theme)
        }));
    convertedBreakpoints.sort((a, b)=>a.px - b.px);
    return convertedBreakpoints;
}




"use client";
function $fcb9f4e004c28daf$export$a39eddd73bba62c1({ navbar: navbar, header: header, footer: footer, aside: aside, padding: padding, theme: theme }) {
    const minMediaStyles = {};
    const maxMediaStyles = {};
    const baseStyles = {};
    (0, $5b76db2b2ae599e8$export$4e3d4baa5f113da9)({
        baseStyles: baseStyles,
        minMediaStyles: minMediaStyles,
        maxMediaStyles: maxMediaStyles,
        navbar: navbar,
        theme: theme
    });
    (0, $e50d39ec24509fdf$export$b266d6a359856a1d)({
        baseStyles: baseStyles,
        minMediaStyles: minMediaStyles,
        maxMediaStyles: maxMediaStyles,
        aside: aside,
        theme: theme
    });
    (0, $2bb10e190151b86d$export$9990017af629c1d7)({
        baseStyles: baseStyles,
        minMediaStyles: minMediaStyles,
        header: header
    });
    (0, $2fb426187e235bef$export$9b0931cecc660105)({
        baseStyles: baseStyles,
        minMediaStyles: minMediaStyles,
        footer: footer
    });
    (0, $00df409f9b7f8b8f$export$32b13804b21181d0)({
        baseStyles: baseStyles,
        minMediaStyles: minMediaStyles,
        padding: padding
    });
    const minMedia = (0, $e4e164d3d352ee58$export$bd80382e31449c0e)((0, $76cd5f02de8ee394$export$ed97f33186d4b816)(minMediaStyles), theme).map((breakpoint)=>({
            query: `(min-width: ${(0, $7a68b0670ce0ab52$export$c63c6f932822f543)(breakpoint.px)})`,
            styles: minMediaStyles[breakpoint.value]
        }));
    const maxMedia = (0, $e4e164d3d352ee58$export$bd80382e31449c0e)((0, $76cd5f02de8ee394$export$ed97f33186d4b816)(maxMediaStyles), theme).map((breakpoint)=>({
            query: `(max-width: ${(0, $7a68b0670ce0ab52$export$c63c6f932822f543)(breakpoint.px)})`,
            styles: maxMediaStyles[breakpoint.value]
        }));
    const media = [
        ...minMedia,
        ...maxMedia
    ];
    return {
        baseStyles: baseStyles,
        media: media
    };
}





"use client";
function $dbef21a227d6a722$export$f0ff95717b842c51({ navbar: navbar, header: header, aside: aside, footer: footer, padding: padding }) {
    const theme = (0, $692af3391f7b0a55$export$5eb0e84f6418b457)();
    const ctx = (0, $bbb97275c373484a$export$2f9729a1501fd576)();
    const { media: media, baseStyles: baseStyles } = (0, $fcb9f4e004c28daf$export$a39eddd73bba62c1)({
        navbar: navbar,
        header: header,
        footer: footer,
        aside: aside,
        padding: padding,
        theme: theme
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e221d2b030e78e40$export$6b8bda124c097cf0), {
        media: media,
        styles: baseStyles,
        selector: ctx.cssVariablesSelector
    });
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
"use client";
function $f73e1d55da1ebeeb$export$ee579bb285b8d4aa(type, listener, options) {
    (0, $acw62.useEffect)(()=>{
        window.addEventListener(type, listener, options);
        return ()=>window.removeEventListener(type, listener, options);
    }, [
        type,
        listener
    ]);
}


"use client";
function $32177cc1fc184ed4$export$a300664a1a230956({ transitionDuration: transitionDuration, disabled: disabled }) {
    const [resizing, setResizing] = (0, $acw62.useState)(false);
    const resizingTimeout = (0, $acw62.useRef)();
    const disabledTimeout = (0, $acw62.useRef)();
    (0, $f73e1d55da1ebeeb$export$ee579bb285b8d4aa)("resize", ()=>{
        setResizing(true);
        clearTimeout(resizingTimeout.current);
        resizingTimeout.current = window.setTimeout(()=>setResizing(false), 200);
    });
    (0, $562774022e0ac3ca$export$363c9f3eb56bbdbe)(()=>{
        setResizing(true);
        clearTimeout(disabledTimeout.current);
        disabledTimeout.current = window.setTimeout(()=>setResizing(false), transitionDuration || 0);
    }, [
        disabled,
        transitionDuration
    ]);
    return resizing;
}






"use client";
function $3e4744740ea17450$export$8e7d06930ec89569({ themeName: themeName, classNamesPrefix: classNamesPrefix, selector: selector }) {
    return themeName.map((n)=>`${classNamesPrefix}-${n}-${selector}`);
}



"use client";
const $ba12a721d32e28d3$var$EMPTY_CLASS_NAMES = {};
function $ba12a721d32e28d3$var$mergeClassNames(objects) {
    const merged = {};
    objects.forEach((obj)=>{
        Object.entries(obj).forEach(([key, value])=>{
            if (merged[key]) merged[key] = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(merged[key], value);
            else merged[key] = value;
        });
    });
    return merged;
}
function $ba12a721d32e28d3$export$7df0003ea9a4d3a4({ theme: theme, classNames: classNames, props: props, stylesCtx: stylesCtx }) {
    const arrayClassNames = Array.isArray(classNames) ? classNames : [
        classNames
    ];
    const resolvedClassNames = arrayClassNames.map((item)=>typeof item === "function" ? item(theme, props, stylesCtx) : item || $ba12a721d32e28d3$var$EMPTY_CLASS_NAMES);
    return $ba12a721d32e28d3$var$mergeClassNames(resolvedClassNames);
}


"use client";
function $0e26bd4cb57c3cf9$export$40c9ba1af6da110e({ themeName: themeName, theme: theme, selector: selector, props: props, stylesCtx: stylesCtx }) {
    return themeName.map((n)=>{
        var _a, _b;
        return (_b = (0, $ba12a721d32e28d3$export$7df0003ea9a4d3a4)({
            theme: theme,
            classNames: (_a = theme.components[n]) == null ? void 0 : _a.classNames,
            props: props,
            stylesCtx: stylesCtx
        })) == null ? void 0 : _b[selector];
    });
}



"use client";
const $3ca60559339b6e87$export$a04011e0788b5983 = {
    always: "mantine-focus-always",
    auto: "mantine-focus-auto",
    never: "mantine-focus-never"
};
function $3ca60559339b6e87$export$e14385d8f1853921({ theme: theme, options: options, unstyled: unstyled }) {
    return (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)((options == null ? void 0 : options.focusable) && !unstyled && (theme.focusClassName || $3ca60559339b6e87$export$a04011e0788b5983[theme.focusRing]), (options == null ? void 0 : options.active) && !unstyled && theme.activeClassName);
}


"use client";
function $c045c3b67c26f6b9$export$298d4a593fcafeff({ options: options, classes: classes, selector: selector, unstyled: unstyled }) {
    return (options == null ? void 0 : options.variant) && !unstyled ? classes[`${selector}--${options.variant}`] : void 0;
}


"use client";
function $d45d65829f01fd32$export$ed68779644c0480d({ rootSelector: rootSelector, selector: selector, className: className }) {
    return rootSelector === selector ? className : void 0;
}


"use client";
function $d883915b9d10d1e9$export$b7a73d31db4300dd({ selector: selector, classes: classes, unstyled: unstyled }) {
    return unstyled ? void 0 : classes[selector];
}



"use client";
function $c68d38cde857116f$export$c8ee29f5e6126f29({ selector: selector, stylesCtx: stylesCtx, theme: theme, classNames: classNames, props: props }) {
    return (0, $ba12a721d32e28d3$export$7df0003ea9a4d3a4)({
        theme: theme,
        classNames: classNames,
        props: props,
        stylesCtx: stylesCtx
    })[selector];
}



"use client";
function $bc1fc9c10c57d64d$export$7a7a11f4686fc73({ selector: selector, stylesCtx: stylesCtx, options: options, props: props, theme: theme }) {
    return (0, $ba12a721d32e28d3$export$7df0003ea9a4d3a4)({
        theme: theme,
        classNames: options == null ? void 0 : options.classNames,
        props: (options == null ? void 0 : options.props) || props,
        stylesCtx: stylesCtx
    })[selector];
}


"use client";
function $8adf988400b74449$export$307b18b61172f7ed({ theme: theme, options: options, themeName: themeName, selector: selector, classNamesPrefix: classNamesPrefix, classNames: classNames, classes: classes, unstyled: unstyled, className: className, rootSelector: rootSelector, props: props, stylesCtx: stylesCtx }) {
    return (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)((0, $3ca60559339b6e87$export$e14385d8f1853921)({
        theme: theme,
        options: options,
        unstyled: unstyled
    }), (0, $0e26bd4cb57c3cf9$export$40c9ba1af6da110e)({
        theme: theme,
        themeName: themeName,
        selector: selector,
        props: props,
        stylesCtx: stylesCtx
    }), (0, $c045c3b67c26f6b9$export$298d4a593fcafeff)({
        options: options,
        classes: classes,
        selector: selector,
        unstyled: unstyled
    }), (0, $c68d38cde857116f$export$c8ee29f5e6126f29)({
        selector: selector,
        stylesCtx: stylesCtx,
        theme: theme,
        classNames: classNames,
        props: props
    }), (0, $bc1fc9c10c57d64d$export$7a7a11f4686fc73)({
        selector: selector,
        stylesCtx: stylesCtx,
        options: options,
        props: props,
        theme: theme
    }), (0, $d45d65829f01fd32$export$ed68779644c0480d)({
        rootSelector: rootSelector,
        selector: selector,
        className: className
    }), (0, $d883915b9d10d1e9$export$b7a73d31db4300dd)({
        selector: selector,
        classes: classes,
        unstyled: unstyled
    }), (0, $3e4744740ea17450$export$8e7d06930ec89569)({
        themeName: themeName,
        classNamesPrefix: classNamesPrefix,
        selector: selector
    }), options == null ? void 0 : options.className);
}


"use client";
var $d9501d38e7649221$var$__defProp = Object.defineProperty;
var $d9501d38e7649221$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $d9501d38e7649221$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $d9501d38e7649221$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $d9501d38e7649221$var$__defNormalProp = (obj, key, value)=>key in obj ? $d9501d38e7649221$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $d9501d38e7649221$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($d9501d38e7649221$var$__hasOwnProp.call(b, prop)) $d9501d38e7649221$var$__defNormalProp(a, prop, b[prop]);
    if ($d9501d38e7649221$var$__getOwnPropSymbols) {
        for (var prop of $d9501d38e7649221$var$__getOwnPropSymbols(b))if ($d9501d38e7649221$var$__propIsEnum.call(b, prop)) $d9501d38e7649221$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
function $d9501d38e7649221$export$5376e124e9154c53({ theme: theme, styles: styles, props: props, stylesCtx: stylesCtx }) {
    const arrayStyles = Array.isArray(styles) ? styles : [
        styles
    ];
    return arrayStyles.reduce((acc, style)=>{
        if (typeof style === "function") return $d9501d38e7649221$var$__spreadValues($d9501d38e7649221$var$__spreadValues({}, acc), style(theme, props, stylesCtx));
        return $d9501d38e7649221$var$__spreadValues($d9501d38e7649221$var$__spreadValues({}, acc), style);
    }, {});
}


"use client";
var $df4641323f2d42d2$var$__defProp = Object.defineProperty;
var $df4641323f2d42d2$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $df4641323f2d42d2$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $df4641323f2d42d2$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $df4641323f2d42d2$var$__defNormalProp = (obj, key, value)=>key in obj ? $df4641323f2d42d2$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $df4641323f2d42d2$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($df4641323f2d42d2$var$__hasOwnProp.call(b, prop)) $df4641323f2d42d2$var$__defNormalProp(a, prop, b[prop]);
    if ($df4641323f2d42d2$var$__getOwnPropSymbols) {
        for (var prop of $df4641323f2d42d2$var$__getOwnPropSymbols(b))if ($df4641323f2d42d2$var$__propIsEnum.call(b, prop)) $df4641323f2d42d2$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
function $df4641323f2d42d2$export$a3fc04b8551e006a({ theme: theme, themeName: themeName, props: props, stylesCtx: stylesCtx, selector: selector }) {
    return themeName.map((n)=>{
        var _a;
        return (0, $d9501d38e7649221$export$5376e124e9154c53)({
            theme: theme,
            styles: (_a = theme.components[n]) == null ? void 0 : _a.styles,
            props: props,
            stylesCtx: stylesCtx
        })[selector];
    }).reduce((acc, val)=>$df4641323f2d42d2$var$__spreadValues($df4641323f2d42d2$var$__spreadValues({}, acc), val), {});
}



"use client";
var $6a3ebd58250268aa$var$__defProp = Object.defineProperty;
var $6a3ebd58250268aa$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $6a3ebd58250268aa$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $6a3ebd58250268aa$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $6a3ebd58250268aa$var$__defNormalProp = (obj, key, value)=>key in obj ? $6a3ebd58250268aa$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $6a3ebd58250268aa$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($6a3ebd58250268aa$var$__hasOwnProp.call(b, prop)) $6a3ebd58250268aa$var$__defNormalProp(a, prop, b[prop]);
    if ($6a3ebd58250268aa$var$__getOwnPropSymbols) {
        for (var prop of $6a3ebd58250268aa$var$__getOwnPropSymbols(b))if ($6a3ebd58250268aa$var$__propIsEnum.call(b, prop)) $6a3ebd58250268aa$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
function $6a3ebd58250268aa$export$d2850a44b8d56931({ style: style, theme: theme }) {
    if (Array.isArray(style)) return [
        ...style
    ].reduce((acc, item)=>$6a3ebd58250268aa$var$__spreadValues($6a3ebd58250268aa$var$__spreadValues({}, acc), $6a3ebd58250268aa$export$d2850a44b8d56931({
            style: item,
            theme: theme
        })), {});
    if (typeof style === "function") return style(theme);
    if (style == null) return {};
    return style;
}



"use client";
var $1e6d95f5c77cc341$var$__defProp = Object.defineProperty;
var $1e6d95f5c77cc341$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $1e6d95f5c77cc341$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $1e6d95f5c77cc341$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $1e6d95f5c77cc341$var$__defNormalProp = (obj, key, value)=>key in obj ? $1e6d95f5c77cc341$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $1e6d95f5c77cc341$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($1e6d95f5c77cc341$var$__hasOwnProp.call(b, prop)) $1e6d95f5c77cc341$var$__defNormalProp(a, prop, b[prop]);
    if ($1e6d95f5c77cc341$var$__getOwnPropSymbols) {
        for (var prop of $1e6d95f5c77cc341$var$__getOwnPropSymbols(b))if ($1e6d95f5c77cc341$var$__propIsEnum.call(b, prop)) $1e6d95f5c77cc341$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
function $1e6d95f5c77cc341$export$55b7902d9d3bf524(vars) {
    return vars.reduce((acc, current)=>{
        if (current) Object.keys(current).forEach((key)=>{
            acc[key] = $1e6d95f5c77cc341$var$__spreadValues($1e6d95f5c77cc341$var$__spreadValues({}, acc[key]), (0, $3fdf1c4abf64babc$export$d697c39a2985a4c)(current[key]));
        });
        return acc;
    }, {});
}


"use client";
function $dc713164c956960f$export$d536e995dbbd0045({ vars: vars, varsResolver: varsResolver, theme: theme, props: props, stylesCtx: stylesCtx, selector: selector, themeName: themeName }) {
    var _a;
    return (_a = (0, $1e6d95f5c77cc341$export$55b7902d9d3bf524)([
        varsResolver == null ? void 0 : varsResolver(theme, props, stylesCtx),
        ...themeName.map((name)=>{
            var _a2, _b, _c;
            return (_c = (_b = (_a2 = theme.components) == null ? void 0 : _a2[name]) == null ? void 0 : _b.vars) == null ? void 0 : _c.call(_b, theme, props, stylesCtx);
        }),
        vars == null ? void 0 : vars(theme, props, stylesCtx)
    ])) == null ? void 0 : _a[selector];
}


"use client";
var $b81ffff4e2011c98$var$__defProp = Object.defineProperty;
var $b81ffff4e2011c98$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $b81ffff4e2011c98$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $b81ffff4e2011c98$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $b81ffff4e2011c98$var$__defNormalProp = (obj, key, value)=>key in obj ? $b81ffff4e2011c98$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $b81ffff4e2011c98$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($b81ffff4e2011c98$var$__hasOwnProp.call(b, prop)) $b81ffff4e2011c98$var$__defNormalProp(a, prop, b[prop]);
    if ($b81ffff4e2011c98$var$__getOwnPropSymbols) {
        for (var prop of $b81ffff4e2011c98$var$__getOwnPropSymbols(b))if ($b81ffff4e2011c98$var$__propIsEnum.call(b, prop)) $b81ffff4e2011c98$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
function $b81ffff4e2011c98$export$3d2f074408bd1b82({ theme: theme, themeName: themeName, selector: selector, options: options, props: props, stylesCtx: stylesCtx, rootSelector: rootSelector, styles: styles, style: style, vars: vars, varsResolver: varsResolver }) {
    return $b81ffff4e2011c98$var$__spreadValues($b81ffff4e2011c98$var$__spreadValues($b81ffff4e2011c98$var$__spreadValues($b81ffff4e2011c98$var$__spreadValues($b81ffff4e2011c98$var$__spreadValues($b81ffff4e2011c98$var$__spreadValues({}, (0, $df4641323f2d42d2$export$a3fc04b8551e006a)({
        theme: theme,
        themeName: themeName,
        props: props,
        stylesCtx: stylesCtx,
        selector: selector
    })), (0, $d9501d38e7649221$export$5376e124e9154c53)({
        theme: theme,
        styles: styles,
        props: props,
        stylesCtx: stylesCtx
    })[selector]), (0, $d9501d38e7649221$export$5376e124e9154c53)({
        theme: theme,
        styles: options == null ? void 0 : options.styles,
        props: (options == null ? void 0 : options.props) || props,
        stylesCtx: stylesCtx
    })[selector]), (0, $dc713164c956960f$export$d536e995dbbd0045)({
        theme: theme,
        props: props,
        stylesCtx: stylesCtx,
        vars: vars,
        varsResolver: varsResolver,
        selector: selector,
        themeName: themeName
    })), rootSelector === selector ? (0, $6a3ebd58250268aa$export$d2850a44b8d56931)({
        style: style,
        theme: theme
    }) : null), (0, $6a3ebd58250268aa$export$d2850a44b8d56931)({
        style: options == null ? void 0 : options.style,
        theme: theme
    }));
}




"use client";
function $4689b421f37b1ee0$export$28e6b9b82ee883c({ name: name, classes: classes, props: props, stylesCtx: stylesCtx, className: className, style: style, rootSelector: rootSelector = "root", unstyled: unstyled, classNames: classNames, styles: styles, vars: vars, varsResolver: varsResolver }) {
    const theme = (0, $692af3391f7b0a55$export$5eb0e84f6418b457)();
    const classNamesPrefix = (0, $bbb97275c373484a$export$635322ad820b722f)();
    const themeName = (Array.isArray(name) ? name : [
        name
    ]).filter((n)=>n);
    return (selector, options)=>({
            className: (0, $8adf988400b74449$export$307b18b61172f7ed)({
                theme: theme,
                options: options,
                themeName: themeName,
                selector: selector,
                classNamesPrefix: classNamesPrefix,
                classNames: classNames,
                classes: classes,
                unstyled: unstyled,
                className: className,
                rootSelector: rootSelector,
                props: props,
                stylesCtx: stylesCtx
            }),
            style: (0, $b81ffff4e2011c98$export$3d2f074408bd1b82)({
                theme: theme,
                themeName: themeName,
                selector: selector,
                options: options,
                props: props,
                stylesCtx: stylesCtx,
                rootSelector: rootSelector,
                styles: styles,
                style: style,
                vars: vars,
                varsResolver: varsResolver
            })
        });
}



"use client";
const $f4b868e08831abbf$var$elevations = {
    app: 100,
    modal: 200,
    popover: 300,
    overlay: 400,
    max: 9999
};
function $f4b868e08831abbf$export$65573e7d509c92dc(level) {
    return $f4b868e08831abbf$var$elevations[level];
}


"use client";
function $aa82169640332897$export$b64e283f076215ce(resolver) {
    return resolver;
}


"use client";
var $dc95f0b8bd3f9327$var$__defProp = Object.defineProperty;
var $dc95f0b8bd3f9327$var$__defProps = Object.defineProperties;
var $dc95f0b8bd3f9327$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $dc95f0b8bd3f9327$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $dc95f0b8bd3f9327$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $dc95f0b8bd3f9327$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $dc95f0b8bd3f9327$var$__defNormalProp = (obj, key, value)=>key in obj ? $dc95f0b8bd3f9327$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $dc95f0b8bd3f9327$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($dc95f0b8bd3f9327$var$__hasOwnProp.call(b, prop)) $dc95f0b8bd3f9327$var$__defNormalProp(a, prop, b[prop]);
    if ($dc95f0b8bd3f9327$var$__getOwnPropSymbols) {
        for (var prop of $dc95f0b8bd3f9327$var$__getOwnPropSymbols(b))if ($dc95f0b8bd3f9327$var$__propIsEnum.call(b, prop)) $dc95f0b8bd3f9327$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $dc95f0b8bd3f9327$var$__spreadProps = (a, b)=>$dc95f0b8bd3f9327$var$__defProps(a, $dc95f0b8bd3f9327$var$__getOwnPropDescs(b));
var $dc95f0b8bd3f9327$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($dc95f0b8bd3f9327$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $dc95f0b8bd3f9327$var$__getOwnPropSymbols) {
        for (var prop of $dc95f0b8bd3f9327$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $dc95f0b8bd3f9327$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $dc95f0b8bd3f9327$var$defaultProps = {
    withBorder: true,
    padding: 0,
    transitionDuration: 200,
    transitionTimingFunction: "ease",
    zIndex: (0, $f4b868e08831abbf$export$65573e7d509c92dc)("app")
};
const $dc95f0b8bd3f9327$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((_, { transitionDuration: transitionDuration, transitionTimingFunction: transitionTimingFunction })=>({
        root: {
            "--app-shell-transition-duration": `${transitionDuration}ms`,
            "--app-shell-transition-timing-function": transitionTimingFunction
        }
    }));
const $dc95f0b8bd3f9327$export$2afed54d6b7d68d9 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("AppShell", $dc95f0b8bd3f9327$var$defaultProps, _props);
    const _a = props, { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, navbar: navbar, withBorder: withBorder, padding: padding, transitionDuration: transitionDuration, transitionTimingFunction: transitionTimingFunction, header: header, zIndex: zIndex, layout: layout, disabled: disabled, aside: aside, footer: footer } = _a, others = $dc95f0b8bd3f9327$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "navbar",
        "withBorder",
        "padding",
        "transitionDuration",
        "transitionTimingFunction",
        "header",
        "zIndex",
        "layout",
        "disabled",
        "aside",
        "footer"
    ]);
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: "AppShell",
        classes: $5d5e905597c33b78$export$2e2bcd8739ae039,
        props: props,
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        vars: vars,
        varsResolver: $dc95f0b8bd3f9327$var$varsResolver
    });
    const resizing = (0, $32177cc1fc184ed4$export$a300664a1a230956)({
        disabled: disabled,
        transitionDuration: transitionDuration
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bc836bedbf7f5239$export$f1c70b06465d541e), {
        value: {
            getStyles: getStyles,
            withBorder: withBorder,
            zIndex: zIndex,
            disabled: disabled
        }
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dbef21a227d6a722$export$f0ff95717b842c51), {
        navbar: navbar,
        header: header,
        aside: aside,
        footer: footer,
        padding: padding
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $dc95f0b8bd3f9327$var$__spreadValues($dc95f0b8bd3f9327$var$__spreadProps($dc95f0b8bd3f9327$var$__spreadValues({
        ref: ref
    }, getStyles("root")), {
        mod: {
            resizing: resizing,
            layout: layout,
            disabled: disabled
        }
    }), others)));
});
$dc95f0b8bd3f9327$export$2afed54d6b7d68d9.classes = (0, $5d5e905597c33b78$export$2e2bcd8739ae039);
$dc95f0b8bd3f9327$export$2afed54d6b7d68d9.displayName = "@mantine/core/AppShell";
$dc95f0b8bd3f9327$export$2afed54d6b7d68d9.Navbar = (0, $81ba6bfef5e37874$export$8a923106bebaaaad);
$dc95f0b8bd3f9327$export$2afed54d6b7d68d9.Header = (0, $f45aa3268986d2cf$export$7932a9fc07def21a);
$dc95f0b8bd3f9327$export$2afed54d6b7d68d9.Main = (0, $b02392ee6d9b6089$export$38840998a170df80);
$dc95f0b8bd3f9327$export$2afed54d6b7d68d9.Aside = (0, $78e6f4a4a0198500$export$53f6f96f8b7092f2);
$dc95f0b8bd3f9327$export$2afed54d6b7d68d9.Footer = (0, $7f89d268cd453eb6$export$c7be6f5ced93654d);
$dc95f0b8bd3f9327$export$2afed54d6b7d68d9.Section = (0, $bbd9fd8be7935767$export$807454a51b0b3c53);



var $acw62 = parcelRequire("acw62");
"use client";
function $f8988135042e9951$export$6e3e27031a30522f(initialState = false, callbacks) {
    const { onOpen: onOpen, onClose: onClose } = callbacks || {};
    const [opened, setOpened] = (0, $acw62.useState)(initialState);
    const open = (0, $acw62.useCallback)(()=>{
        setOpened((isOpened)=>{
            if (!isOpened) {
                onOpen == null || onOpen();
                return true;
            }
            return isOpened;
        });
    }, [
        onOpen
    ]);
    const close = (0, $acw62.useCallback)(()=>{
        setOpened((isOpened)=>{
            if (isOpened) {
                onClose == null || onClose();
                return false;
            }
            return isOpened;
        });
    }, [
        onClose
    ]);
    const toggle = (0, $acw62.useCallback)(()=>{
        opened ? close() : open();
    }, [
        close,
        open,
        opened
    ]);
    return [
        opened,
        {
            open: open,
            close: close,
            toggle: toggle
        }
    ];
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
"use client";
var $2d6b6e5f45e37227$var$classes = {
    "root": "m-77c9d27d",
    "inner": "m-80f1301b",
    "label": "m-811560b9",
    "section": "m-a74036a",
    "loader": "m-a25b86ee",
    "group": "m-80d6d844"
};
var $2d6b6e5f45e37227$export$2e2bcd8739ae039 = $2d6b6e5f45e37227$var$classes;








"use client";
var $6ec1bea904b3b08b$var$__defProp = Object.defineProperty;
var $6ec1bea904b3b08b$var$__defProps = Object.defineProperties;
var $6ec1bea904b3b08b$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $6ec1bea904b3b08b$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $6ec1bea904b3b08b$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $6ec1bea904b3b08b$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $6ec1bea904b3b08b$var$__defNormalProp = (obj, key, value)=>key in obj ? $6ec1bea904b3b08b$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $6ec1bea904b3b08b$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($6ec1bea904b3b08b$var$__hasOwnProp.call(b, prop)) $6ec1bea904b3b08b$var$__defNormalProp(a, prop, b[prop]);
    if ($6ec1bea904b3b08b$var$__getOwnPropSymbols) {
        for (var prop of $6ec1bea904b3b08b$var$__getOwnPropSymbols(b))if ($6ec1bea904b3b08b$var$__propIsEnum.call(b, prop)) $6ec1bea904b3b08b$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $6ec1bea904b3b08b$var$__spreadProps = (a, b)=>$6ec1bea904b3b08b$var$__defProps(a, $6ec1bea904b3b08b$var$__getOwnPropDescs(b));
var $6ec1bea904b3b08b$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($6ec1bea904b3b08b$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $6ec1bea904b3b08b$var$__getOwnPropSymbols) {
        for (var prop of $6ec1bea904b3b08b$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $6ec1bea904b3b08b$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $6ec1bea904b3b08b$var$defaultProps = {
    orientation: "horizontal"
};
const $6ec1bea904b3b08b$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((_, { borderWidth: borderWidth })=>({
        group: {
            "--button-border-width": (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(borderWidth)
        }
    }));
const $6ec1bea904b3b08b$export$69b1032f2ecdf404 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("ButtonGroup", $6ec1bea904b3b08b$var$defaultProps, _props);
    const _a = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("ButtonGroup", $6ec1bea904b3b08b$var$defaultProps, _props), { className: className, style: style, classNames: classNames, styles: styles, unstyled: unstyled, orientation: orientation, vars: vars, borderWidth: borderWidth, variant: variant } = _a, others = $6ec1bea904b3b08b$var$__objRest(_a, [
        "className",
        "style",
        "classNames",
        "styles",
        "unstyled",
        "orientation",
        "vars",
        "borderWidth",
        "variant"
    ]);
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: "ButtonGroup",
        props: props,
        classes: $2d6b6e5f45e37227$export$2e2bcd8739ae039,
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        vars: vars,
        varsResolver: $6ec1bea904b3b08b$var$varsResolver,
        rootSelector: "group"
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $6ec1bea904b3b08b$var$__spreadValues($6ec1bea904b3b08b$var$__spreadProps($6ec1bea904b3b08b$var$__spreadValues({}, getStyles("group")), {
        ref: ref,
        variant: variant,
        mod: {
            "data-orientation": orientation
        },
        role: "group"
    }), others));
});
$6ec1bea904b3b08b$export$69b1032f2ecdf404.classes = (0, $2d6b6e5f45e37227$export$2e2bcd8739ae039);
$6ec1bea904b3b08b$export$69b1032f2ecdf404.displayName = "@mantine/core/ButtonGroup";




var $acw62 = parcelRequire("acw62");
"use client";
var $7e97a5f4ed4ff539$var$classes = {
    "root": "m-87cf2631"
};
var $7e97a5f4ed4ff539$export$2e2bcd8739ae039 = $7e97a5f4ed4ff539$var$classes;






"use client";
var $b9babe59f8fa61e8$var$__defProp = Object.defineProperty;
var $b9babe59f8fa61e8$var$__defProps = Object.defineProperties;
var $b9babe59f8fa61e8$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $b9babe59f8fa61e8$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $b9babe59f8fa61e8$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $b9babe59f8fa61e8$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $b9babe59f8fa61e8$var$__defNormalProp = (obj, key, value)=>key in obj ? $b9babe59f8fa61e8$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $b9babe59f8fa61e8$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($b9babe59f8fa61e8$var$__hasOwnProp.call(b, prop)) $b9babe59f8fa61e8$var$__defNormalProp(a, prop, b[prop]);
    if ($b9babe59f8fa61e8$var$__getOwnPropSymbols) {
        for (var prop of $b9babe59f8fa61e8$var$__getOwnPropSymbols(b))if ($b9babe59f8fa61e8$var$__propIsEnum.call(b, prop)) $b9babe59f8fa61e8$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $b9babe59f8fa61e8$var$__spreadProps = (a, b)=>$b9babe59f8fa61e8$var$__defProps(a, $b9babe59f8fa61e8$var$__getOwnPropDescs(b));
var $b9babe59f8fa61e8$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($b9babe59f8fa61e8$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $b9babe59f8fa61e8$var$__getOwnPropSymbols) {
        for (var prop of $b9babe59f8fa61e8$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $b9babe59f8fa61e8$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $b9babe59f8fa61e8$var$defaultProps = {
    __staticSelector: "UnstyledButton"
};
const $b9babe59f8fa61e8$export$3167f6ecaaaa3457 = (0, $dfead8eb7283bc39$export$197bdd704df40a29)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("UnstyledButton", $b9babe59f8fa61e8$var$defaultProps, _props);
    const _a = props, { className: className, component: component = "button", __staticSelector: __staticSelector, unstyled: unstyled, classNames: classNames, styles: styles, style: style } = _a, others = $b9babe59f8fa61e8$var$__objRest(_a, [
        "className",
        "component",
        "__staticSelector",
        "unstyled",
        "classNames",
        "styles",
        "style"
    ]);
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: __staticSelector,
        props: props,
        classes: $7e97a5f4ed4ff539$export$2e2bcd8739ae039,
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $b9babe59f8fa61e8$var$__spreadValues($b9babe59f8fa61e8$var$__spreadProps($b9babe59f8fa61e8$var$__spreadValues({}, getStyles("root", {
        focusable: true
    })), {
        component: component,
        ref: ref,
        type: component === "button" ? "button" : void 0
    }), others));
});
$b9babe59f8fa61e8$export$3167f6ecaaaa3457.classes = (0, $7e97a5f4ed4ff539$export$2e2bcd8739ae039);
$b9babe59f8fa61e8$export$3167f6ecaaaa3457.displayName = "@mantine/core/UnstyledButton";



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

"use client";
var $b90e9c0269727d12$var$classes = {
    "root": "m-5ae2e3c",
    "barsLoader": "m-7a2bd4cd",
    "bar": "m-870bb79",
    "bars-loader-animation": "m-5d2b3b9d",
    "dotsLoader": "m-4e3f22d7",
    "dot": "m-870c4af",
    "loader-dots-animation": "m-aac34a1",
    "ovalLoader": "m-b34414df",
    "oval-loader-animation": "m-f8e89c4b"
};
var $b90e9c0269727d12$export$2e2bcd8739ae039 = $b90e9c0269727d12$var$classes;



"use client";
var $d3bea8b47e5cc43d$var$__defProp = Object.defineProperty;
var $d3bea8b47e5cc43d$var$__defProps = Object.defineProperties;
var $d3bea8b47e5cc43d$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $d3bea8b47e5cc43d$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $d3bea8b47e5cc43d$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $d3bea8b47e5cc43d$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $d3bea8b47e5cc43d$var$__defNormalProp = (obj, key, value)=>key in obj ? $d3bea8b47e5cc43d$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $d3bea8b47e5cc43d$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($d3bea8b47e5cc43d$var$__hasOwnProp.call(b, prop)) $d3bea8b47e5cc43d$var$__defNormalProp(a, prop, b[prop]);
    if ($d3bea8b47e5cc43d$var$__getOwnPropSymbols) {
        for (var prop of $d3bea8b47e5cc43d$var$__getOwnPropSymbols(b))if ($d3bea8b47e5cc43d$var$__propIsEnum.call(b, prop)) $d3bea8b47e5cc43d$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $d3bea8b47e5cc43d$var$__spreadProps = (a, b)=>$d3bea8b47e5cc43d$var$__defProps(a, $d3bea8b47e5cc43d$var$__getOwnPropDescs(b));
var $d3bea8b47e5cc43d$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($d3bea8b47e5cc43d$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $d3bea8b47e5cc43d$var$__getOwnPropSymbols) {
        for (var prop of $d3bea8b47e5cc43d$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $d3bea8b47e5cc43d$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $d3bea8b47e5cc43d$export$fbc7d6f7dd821b47 = (0, $acw62.forwardRef)((_a, ref)=>{
    var _b = _a, { className: className } = _b, others = $d3bea8b47e5cc43d$var$__objRest(_b, [
        "className"
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $d3bea8b47e5cc43d$var$__spreadProps($d3bea8b47e5cc43d$var$__spreadValues({
        component: "span",
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)((0, $b90e9c0269727d12$export$2e2bcd8739ae039).barsLoader, className)
    }, others), {
        ref: ref
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $b90e9c0269727d12$export$2e2bcd8739ae039).bar
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $b90e9c0269727d12$export$2e2bcd8739ae039).bar
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $b90e9c0269727d12$export$2e2bcd8739ae039).bar
    }));
});



var $acw62 = parcelRequire("acw62");



"use client";
var $48b6c6c3667834c0$var$__defProp = Object.defineProperty;
var $48b6c6c3667834c0$var$__defProps = Object.defineProperties;
var $48b6c6c3667834c0$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $48b6c6c3667834c0$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $48b6c6c3667834c0$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $48b6c6c3667834c0$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $48b6c6c3667834c0$var$__defNormalProp = (obj, key, value)=>key in obj ? $48b6c6c3667834c0$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $48b6c6c3667834c0$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($48b6c6c3667834c0$var$__hasOwnProp.call(b, prop)) $48b6c6c3667834c0$var$__defNormalProp(a, prop, b[prop]);
    if ($48b6c6c3667834c0$var$__getOwnPropSymbols) {
        for (var prop of $48b6c6c3667834c0$var$__getOwnPropSymbols(b))if ($48b6c6c3667834c0$var$__propIsEnum.call(b, prop)) $48b6c6c3667834c0$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $48b6c6c3667834c0$var$__spreadProps = (a, b)=>$48b6c6c3667834c0$var$__defProps(a, $48b6c6c3667834c0$var$__getOwnPropDescs(b));
var $48b6c6c3667834c0$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($48b6c6c3667834c0$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $48b6c6c3667834c0$var$__getOwnPropSymbols) {
        for (var prop of $48b6c6c3667834c0$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $48b6c6c3667834c0$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $48b6c6c3667834c0$export$67ad50c48ca3ede4 = (0, $acw62.forwardRef)((_a, ref)=>{
    var _b = _a, { className: className } = _b, others = $48b6c6c3667834c0$var$__objRest(_b, [
        "className"
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $48b6c6c3667834c0$var$__spreadProps($48b6c6c3667834c0$var$__spreadValues({
        component: "span",
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)((0, $b90e9c0269727d12$export$2e2bcd8739ae039).ovalLoader, className)
    }, others), {
        ref: ref
    }));
});



var $acw62 = parcelRequire("acw62");



"use client";
var $22d94f1a07eb5634$var$__defProp = Object.defineProperty;
var $22d94f1a07eb5634$var$__defProps = Object.defineProperties;
var $22d94f1a07eb5634$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $22d94f1a07eb5634$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $22d94f1a07eb5634$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $22d94f1a07eb5634$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $22d94f1a07eb5634$var$__defNormalProp = (obj, key, value)=>key in obj ? $22d94f1a07eb5634$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $22d94f1a07eb5634$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($22d94f1a07eb5634$var$__hasOwnProp.call(b, prop)) $22d94f1a07eb5634$var$__defNormalProp(a, prop, b[prop]);
    if ($22d94f1a07eb5634$var$__getOwnPropSymbols) {
        for (var prop of $22d94f1a07eb5634$var$__getOwnPropSymbols(b))if ($22d94f1a07eb5634$var$__propIsEnum.call(b, prop)) $22d94f1a07eb5634$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $22d94f1a07eb5634$var$__spreadProps = (a, b)=>$22d94f1a07eb5634$var$__defProps(a, $22d94f1a07eb5634$var$__getOwnPropDescs(b));
var $22d94f1a07eb5634$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($22d94f1a07eb5634$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $22d94f1a07eb5634$var$__getOwnPropSymbols) {
        for (var prop of $22d94f1a07eb5634$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $22d94f1a07eb5634$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $22d94f1a07eb5634$export$8da50d3722682be0 = (0, $acw62.forwardRef)((_a, ref)=>{
    var _b = _a, { className: className } = _b, others = $22d94f1a07eb5634$var$__objRest(_b, [
        "className"
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $22d94f1a07eb5634$var$__spreadProps($22d94f1a07eb5634$var$__spreadValues({
        component: "span",
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)((0, $b90e9c0269727d12$export$2e2bcd8739ae039).dotsLoader, className)
    }, others), {
        ref: ref
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $b90e9c0269727d12$export$2e2bcd8739ae039).dot
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $b90e9c0269727d12$export$2e2bcd8739ae039).dot
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $b90e9c0269727d12$export$2e2bcd8739ae039).dot
    }));
});










"use client";
var $f943dfe4129424c6$var$__defProp = Object.defineProperty;
var $f943dfe4129424c6$var$__defProps = Object.defineProperties;
var $f943dfe4129424c6$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $f943dfe4129424c6$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $f943dfe4129424c6$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $f943dfe4129424c6$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $f943dfe4129424c6$var$__defNormalProp = (obj, key, value)=>key in obj ? $f943dfe4129424c6$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $f943dfe4129424c6$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($f943dfe4129424c6$var$__hasOwnProp.call(b, prop)) $f943dfe4129424c6$var$__defNormalProp(a, prop, b[prop]);
    if ($f943dfe4129424c6$var$__getOwnPropSymbols) {
        for (var prop of $f943dfe4129424c6$var$__getOwnPropSymbols(b))if ($f943dfe4129424c6$var$__propIsEnum.call(b, prop)) $f943dfe4129424c6$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $f943dfe4129424c6$var$__spreadProps = (a, b)=>$f943dfe4129424c6$var$__defProps(a, $f943dfe4129424c6$var$__getOwnPropDescs(b));
var $f943dfe4129424c6$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($f943dfe4129424c6$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $f943dfe4129424c6$var$__getOwnPropSymbols) {
        for (var prop of $f943dfe4129424c6$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $f943dfe4129424c6$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $f943dfe4129424c6$export$67c811dd955240bb = {
    bars: (0, $d3bea8b47e5cc43d$export$fbc7d6f7dd821b47),
    oval: (0, $48b6c6c3667834c0$export$67ad50c48ca3ede4),
    dots: (0, $22d94f1a07eb5634$export$8da50d3722682be0)
};
const $f943dfe4129424c6$var$defaultProps = {
    loaders: $f943dfe4129424c6$export$67c811dd955240bb,
    type: "oval"
};
const $f943dfe4129424c6$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((theme, { size: size, color: color })=>({
        root: {
            "--loader-size": (0, $fcab4af601ce7e99$export$31b21d0167753bb4)(size, "loader-size"),
            "--loader-color": color ? (0, $0a9c57cec2a3e373$export$e22c5d06d177c3fa)(color, theme) : void 0
        }
    }));
const $f943dfe4129424c6$export$3b0d6d7590275603 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("Loader", $f943dfe4129424c6$var$defaultProps, _props);
    const _a = props, { size: size, color: color, type: type, vars: vars, className: className, style: style, classNames: classNames, styles: styles, unstyled: unstyled, loaders: loaders, variant: variant } = _a, others = $f943dfe4129424c6$var$__objRest(_a, [
        "size",
        "color",
        "type",
        "vars",
        "className",
        "style",
        "classNames",
        "styles",
        "unstyled",
        "loaders",
        "variant"
    ]);
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: "Loader",
        props: props,
        classes: $b90e9c0269727d12$export$2e2bcd8739ae039,
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        vars: vars,
        varsResolver: $f943dfe4129424c6$var$varsResolver
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $f943dfe4129424c6$var$__spreadValues($f943dfe4129424c6$var$__spreadProps($f943dfe4129424c6$var$__spreadValues({}, getStyles("root")), {
        ref: ref,
        component: loaders[type],
        variant: variant,
        size: size
    }), others));
});
$f943dfe4129424c6$export$3b0d6d7590275603.classes = (0, $b90e9c0269727d12$export$2e2bcd8739ae039);
$f943dfe4129424c6$export$3b0d6d7590275603.displayName = "@mantine/core/Loader";








"use client";
var $4416f4ee338d8f77$var$__defProp = Object.defineProperty;
var $4416f4ee338d8f77$var$__defProps = Object.defineProperties;
var $4416f4ee338d8f77$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $4416f4ee338d8f77$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $4416f4ee338d8f77$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $4416f4ee338d8f77$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $4416f4ee338d8f77$var$__defNormalProp = (obj, key, value)=>key in obj ? $4416f4ee338d8f77$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $4416f4ee338d8f77$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($4416f4ee338d8f77$var$__hasOwnProp.call(b, prop)) $4416f4ee338d8f77$var$__defNormalProp(a, prop, b[prop]);
    if ($4416f4ee338d8f77$var$__getOwnPropSymbols) {
        for (var prop of $4416f4ee338d8f77$var$__getOwnPropSymbols(b))if ($4416f4ee338d8f77$var$__propIsEnum.call(b, prop)) $4416f4ee338d8f77$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $4416f4ee338d8f77$var$__spreadProps = (a, b)=>$4416f4ee338d8f77$var$__defProps(a, $4416f4ee338d8f77$var$__getOwnPropDescs(b));
var $4416f4ee338d8f77$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($4416f4ee338d8f77$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $4416f4ee338d8f77$var$__getOwnPropSymbols) {
        for (var prop of $4416f4ee338d8f77$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $4416f4ee338d8f77$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $4416f4ee338d8f77$var$defaultProps = {};
const $4416f4ee338d8f77$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((theme, { radius: radius, color: color, gradient: gradient, variant: variant, size: size, justify: justify })=>{
    const colors = theme.variantColorResolver({
        color: color || theme.primaryColor,
        theme: theme,
        gradient: gradient,
        variant: variant || "filled"
    });
    return {
        root: {
            "--button-justify": justify,
            "--button-height": (0, $fcab4af601ce7e99$export$31b21d0167753bb4)(size, "button-height"),
            "--button-padding-x": (0, $fcab4af601ce7e99$export$31b21d0167753bb4)(size, "button-padding-x"),
            "--button-fz": (size == null ? void 0 : size.includes("compact")) ? (0, $fcab4af601ce7e99$export$7d055c252aebca58)(size.replace("compact-", "")) : (0, $fcab4af601ce7e99$export$7d055c252aebca58)(size),
            "--button-radius": radius === void 0 ? void 0 : (0, $fcab4af601ce7e99$export$35724d9c2979edc5)(radius),
            "--button-bg": color || variant ? colors.background : void 0,
            "--button-hover": color || variant ? colors.hover : void 0,
            "--button-color": color || variant ? colors.color : void 0,
            "--button-bd": color || variant ? colors.border : void 0
        }
    };
});
const $4416f4ee338d8f77$export$353f5b6fc5456de1 = (0, $dfead8eb7283bc39$export$197bdd704df40a29)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("Button", $4416f4ee338d8f77$var$defaultProps, _props);
    const _a = props, { style: style, vars: vars, className: className, color: color, disabled: disabled, children: children, leftSection: leftSection, rightSection: rightSection, fullWidth: fullWidth, variant: variant, radius: radius, loading: loading, loaderProps: loaderProps, gradient: gradient, classNames: classNames, styles: styles, unstyled: unstyled, "data-disabled": dataDisabled } = _a, others = $4416f4ee338d8f77$var$__objRest(_a, [
        "style",
        "vars",
        "className",
        "color",
        "disabled",
        "children",
        "leftSection",
        "rightSection",
        "fullWidth",
        "variant",
        "radius",
        "loading",
        "loaderProps",
        "gradient",
        "classNames",
        "styles",
        "unstyled",
        "data-disabled"
    ]);
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: "Button",
        props: props,
        classes: $2d6b6e5f45e37227$export$2e2bcd8739ae039,
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        vars: vars,
        varsResolver: $4416f4ee338d8f77$var$varsResolver
    });
    const hasLeftSection = !!leftSection;
    const hasRightSection = !!rightSection;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b9babe59f8fa61e8$export$3167f6ecaaaa3457), $4416f4ee338d8f77$var$__spreadValues($4416f4ee338d8f77$var$__spreadProps($4416f4ee338d8f77$var$__spreadValues({
        ref: ref
    }, getStyles("root", {
        active: !disabled && !loading && !dataDisabled
    })), {
        unstyled: unstyled,
        variant: variant,
        disabled: disabled || loading,
        mod: {
            disabled: disabled || dataDisabled,
            loading: loading,
            block: fullWidth,
            "with-left-section": hasLeftSection,
            "with-right-section": hasRightSection
        }
    }), others), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", $4416f4ee338d8f77$var$__spreadValues({}, getStyles("inner")), leftSection && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $4416f4ee338d8f77$var$__spreadProps($4416f4ee338d8f77$var$__spreadValues({
        component: "span"
    }, getStyles("section")), {
        mod: {
            position: "left"
        }
    }), leftSection), loading && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $4416f4ee338d8f77$var$__spreadValues({
        component: "span"
    }, getStyles("loader")), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f943dfe4129424c6$export$3b0d6d7590275603), $4416f4ee338d8f77$var$__spreadValues({
        color: "var(--button-color)",
        size: "calc(var(--button-height) / 1.8)"
    }, loaderProps))), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $4416f4ee338d8f77$var$__spreadValues({
        component: "span",
        mod: {
            loading: loading
        }
    }, getStyles("label")), children), rightSection && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $4416f4ee338d8f77$var$__spreadProps($4416f4ee338d8f77$var$__spreadValues({
        component: "span"
    }, getStyles("section")), {
        mod: {
            position: "right"
        }
    }), rightSection)));
});
$4416f4ee338d8f77$export$353f5b6fc5456de1.classes = (0, $2d6b6e5f45e37227$export$2e2bcd8739ae039);
$4416f4ee338d8f77$export$353f5b6fc5456de1.displayName = "@mantine/core/Button";
$4416f4ee338d8f77$export$353f5b6fc5456de1.Group = (0, $6ec1bea904b3b08b$export$69b1032f2ecdf404);


var $acw62 = parcelRequire("acw62");
"use client";
var $bd12188ed7dd9507$var$classes = {
    "root": "m-7485cace"
};
var $bd12188ed7dd9507$export$2e2bcd8739ae039 = $bd12188ed7dd9507$var$classes;








"use client";
var $2903b8a25a65807a$var$__defProp = Object.defineProperty;
var $2903b8a25a65807a$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $2903b8a25a65807a$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $2903b8a25a65807a$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $2903b8a25a65807a$var$__defNormalProp = (obj, key, value)=>key in obj ? $2903b8a25a65807a$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $2903b8a25a65807a$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($2903b8a25a65807a$var$__hasOwnProp.call(b, prop)) $2903b8a25a65807a$var$__defNormalProp(a, prop, b[prop]);
    if ($2903b8a25a65807a$var$__getOwnPropSymbols) {
        for (var prop of $2903b8a25a65807a$var$__getOwnPropSymbols(b))if ($2903b8a25a65807a$var$__propIsEnum.call(b, prop)) $2903b8a25a65807a$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $2903b8a25a65807a$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($2903b8a25a65807a$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $2903b8a25a65807a$var$__getOwnPropSymbols) {
        for (var prop of $2903b8a25a65807a$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $2903b8a25a65807a$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $2903b8a25a65807a$var$defaultProps = {};
const $2903b8a25a65807a$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((_, { size: size, fluid: fluid })=>({
        root: {
            "--container-size": fluid ? void 0 : (0, $fcab4af601ce7e99$export$31b21d0167753bb4)(size, "container-size")
        }
    }));
const $2903b8a25a65807a$export$42a852a2b6b56249 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("Container", $2903b8a25a65807a$var$defaultProps, _props);
    const _a = props, { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, fluid: fluid } = _a, others = $2903b8a25a65807a$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "fluid"
    ]);
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: "Container",
        classes: $bd12188ed7dd9507$export$2e2bcd8739ae039,
        props: props,
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        vars: vars,
        varsResolver: $2903b8a25a65807a$var$varsResolver
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $2903b8a25a65807a$var$__spreadValues($2903b8a25a65807a$var$__spreadValues({
        ref: ref,
        mod: {
            fluid: fluid
        }
    }, getStyles("root")), others));
});
$2903b8a25a65807a$export$42a852a2b6b56249.classes = (0, $bd12188ed7dd9507$export$2e2bcd8739ae039);
$2903b8a25a65807a$export$42a852a2b6b56249.displayName = "@mantine/core/Container";


var $acw62 = parcelRequire("acw62");
"use client";
const $f04e45bcb65980b1$export$b9ee9b94296c3ad4 = {
    gap: {
        type: "spacing",
        property: "gap"
    },
    rowGap: {
        type: "spacing",
        property: "rowGap"
    },
    columnGap: {
        type: "spacing",
        property: "columnGap"
    },
    align: {
        type: "identity",
        property: "alignItems"
    },
    justify: {
        type: "identity",
        property: "justifyContent"
    },
    wrap: {
        type: "identity",
        property: "flexWrap"
    },
    direction: {
        type: "identity",
        property: "flexDirection"
    }
};


"use client";
var $70657417e75163cb$var$classes = {
    "root": "m-8bffd616"
};
var $70657417e75163cb$export$2e2bcd8739ae039 = $70657417e75163cb$var$classes;











"use client";
var $4e00d137aa7b325a$var$__defProp = Object.defineProperty;
var $4e00d137aa7b325a$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $4e00d137aa7b325a$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $4e00d137aa7b325a$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $4e00d137aa7b325a$var$__defNormalProp = (obj, key, value)=>key in obj ? $4e00d137aa7b325a$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $4e00d137aa7b325a$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($4e00d137aa7b325a$var$__hasOwnProp.call(b, prop)) $4e00d137aa7b325a$var$__defNormalProp(a, prop, b[prop]);
    if ($4e00d137aa7b325a$var$__getOwnPropSymbols) {
        for (var prop of $4e00d137aa7b325a$var$__getOwnPropSymbols(b))if ($4e00d137aa7b325a$var$__propIsEnum.call(b, prop)) $4e00d137aa7b325a$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $4e00d137aa7b325a$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($4e00d137aa7b325a$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $4e00d137aa7b325a$var$__getOwnPropSymbols) {
        for (var prop of $4e00d137aa7b325a$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $4e00d137aa7b325a$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $4e00d137aa7b325a$var$defaultProps = {};
const $4e00d137aa7b325a$export$f51f4c4ede09e011 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("Flex", $4e00d137aa7b325a$var$defaultProps, _props);
    const _a = props, { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, gap: gap, rowGap: rowGap, columnGap: columnGap, align: align, justify: justify, wrap: wrap, direction: direction } = _a, others = $4e00d137aa7b325a$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "gap",
        "rowGap",
        "columnGap",
        "align",
        "justify",
        "wrap",
        "direction"
    ]);
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: "Flex",
        classes: $70657417e75163cb$export$2e2bcd8739ae039,
        props: props,
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        vars: vars
    });
    const theme = (0, $692af3391f7b0a55$export$5eb0e84f6418b457)();
    const responsiveClassName = (0, $6f7b5997f3c2d4f0$export$27120f2982e012b1)();
    const parsedStyleProps = (0, $06c0be1ba7c6b78f$export$369a566827bae64e)({
        styleProps: {
            gap: gap,
            rowGap: rowGap,
            columnGap: columnGap,
            align: align,
            justify: justify,
            wrap: wrap,
            direction: direction
        },
        theme: theme,
        data: (0, $f04e45bcb65980b1$export$b9ee9b94296c3ad4)
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, parsedStyleProps.hasResponsiveStyles && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e221d2b030e78e40$export$6b8bda124c097cf0), {
        selector: `.${responsiveClassName}`,
        styles: parsedStyleProps.styles,
        media: parsedStyleProps.media
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $4e00d137aa7b325a$var$__spreadValues($4e00d137aa7b325a$var$__spreadValues({
        ref: ref
    }, getStyles("root", {
        className: responsiveClassName,
        style: (0, $3fdf1c4abf64babc$export$d697c39a2985a4c)(parsedStyleProps.inlineStyles)
    })), others)));
});
$4e00d137aa7b325a$export$f51f4c4ede09e011.classes = (0, $70657417e75163cb$export$2e2bcd8739ae039);
$4e00d137aa7b325a$export$f51f4c4ede09e011.displayName = "@mantine/core/Flex";


var $acw62 = parcelRequire("acw62");
"use client";
var $ea78a9b6a5023729$var$classes = {
    "root": "m-b6d8b162"
};
var $ea78a9b6a5023729$export$2e2bcd8739ae039 = $ea78a9b6a5023729$var$classes;










"use client";
var $5889434a75bd9d22$var$__defProp = Object.defineProperty;
var $5889434a75bd9d22$var$__defProps = Object.defineProperties;
var $5889434a75bd9d22$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $5889434a75bd9d22$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $5889434a75bd9d22$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $5889434a75bd9d22$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $5889434a75bd9d22$var$__defNormalProp = (obj, key, value)=>key in obj ? $5889434a75bd9d22$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $5889434a75bd9d22$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($5889434a75bd9d22$var$__hasOwnProp.call(b, prop)) $5889434a75bd9d22$var$__defNormalProp(a, prop, b[prop]);
    if ($5889434a75bd9d22$var$__getOwnPropSymbols) {
        for (var prop of $5889434a75bd9d22$var$__getOwnPropSymbols(b))if ($5889434a75bd9d22$var$__propIsEnum.call(b, prop)) $5889434a75bd9d22$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $5889434a75bd9d22$var$__spreadProps = (a, b)=>$5889434a75bd9d22$var$__defProps(a, $5889434a75bd9d22$var$__getOwnPropDescs(b));
var $5889434a75bd9d22$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($5889434a75bd9d22$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $5889434a75bd9d22$var$__getOwnPropSymbols) {
        for (var prop of $5889434a75bd9d22$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $5889434a75bd9d22$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
function $5889434a75bd9d22$var$getTextTruncate(truncate) {
    if (truncate === "start") return "start";
    if (truncate === "end" || truncate) return "end";
    return void 0;
}
const $5889434a75bd9d22$var$defaultProps = {
    inherit: false
};
const $5889434a75bd9d22$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((theme, { variant: variant, lineClamp: lineClamp, gradient: gradient, size: size, color: color })=>({
        root: {
            "--text-fz": (0, $fcab4af601ce7e99$export$7d055c252aebca58)(size),
            "--text-lh": (0, $fcab4af601ce7e99$export$56204a27a2958a55)(size),
            "--text-gradient": variant === "gradient" ? (0, $bdea122fb92e1007$export$e14995d3ec1747ee)(gradient, theme) : void 0,
            "--text-line-clamp": typeof lineClamp === "number" ? lineClamp.toString() : void 0,
            "--text-color": color ? (0, $0a9c57cec2a3e373$export$e22c5d06d177c3fa)(color, theme) : void 0
        }
    }));
const $5889434a75bd9d22$export$5f1af8db9871e1d6 = (0, $dfead8eb7283bc39$export$197bdd704df40a29)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("Text", $5889434a75bd9d22$var$defaultProps, _props);
    const _a = props, { lineClamp: lineClamp, truncate: truncate, inline: inline, inherit: inherit, gradient: gradient, span: span, __staticSelector: __staticSelector, vars: vars, className: className, style: style, classNames: classNames, styles: styles, unstyled: unstyled, variant: variant, mod: mod, size: size } = _a, others = $5889434a75bd9d22$var$__objRest(_a, [
        "lineClamp",
        "truncate",
        "inline",
        "inherit",
        "gradient",
        "span",
        "__staticSelector",
        "vars",
        "className",
        "style",
        "classNames",
        "styles",
        "unstyled",
        "variant",
        "mod",
        "size"
    ]);
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: [
            "Text",
            __staticSelector
        ],
        props: props,
        classes: $ea78a9b6a5023729$export$2e2bcd8739ae039,
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        vars: vars,
        varsResolver: $5889434a75bd9d22$var$varsResolver
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $5889434a75bd9d22$var$__spreadValues($5889434a75bd9d22$var$__spreadProps($5889434a75bd9d22$var$__spreadValues({}, getStyles("root", {
        focusable: true
    })), {
        ref: ref,
        component: span ? "span" : "p",
        variant: variant,
        mod: [
            {
                "data-truncate": $5889434a75bd9d22$var$getTextTruncate(truncate),
                "data-line-clamp": typeof lineClamp === "number",
                "data-inline": inline,
                "data-inherit": inherit
            },
            mod
        ],
        size: size
    }), others));
});
$5889434a75bd9d22$export$5f1af8db9871e1d6.classes = (0, $ea78a9b6a5023729$export$2e2bcd8739ae039);
$5889434a75bd9d22$export$5f1af8db9871e1d6.displayName = "@mantine/core/Text";


/**
 * @tabler/icons-react v2.42.0 - MIT
 */ /**
 * @tabler/icons-react v2.42.0 - MIT
 */ 
var $acw62 = parcelRequire("acw62");
var $8da5bfbbed271cd7$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8da5bfbbed271cd7$var$ReactIs, $8da5bfbbed271cd7$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$8da5bfbbed271cd7$exports = (parcelRequire("hOzOt"))();


/**
 * @tabler/icons-react v2.42.0 - MIT
 */ var $136c6b1249c8cb09$export$2e2bcd8739ae039 = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
};


var $a86819fe50d185cb$var$__defProp = Object.defineProperty;
var $a86819fe50d185cb$var$__defProps = Object.defineProperties;
var $a86819fe50d185cb$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $a86819fe50d185cb$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $a86819fe50d185cb$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $a86819fe50d185cb$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $a86819fe50d185cb$var$__defNormalProp = (obj, key, value)=>key in obj ? $a86819fe50d185cb$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $a86819fe50d185cb$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($a86819fe50d185cb$var$__hasOwnProp.call(b, prop)) $a86819fe50d185cb$var$__defNormalProp(a, prop, b[prop]);
    if ($a86819fe50d185cb$var$__getOwnPropSymbols) {
        for (var prop of $a86819fe50d185cb$var$__getOwnPropSymbols(b))if ($a86819fe50d185cb$var$__propIsEnum.call(b, prop)) $a86819fe50d185cb$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $a86819fe50d185cb$var$__spreadProps = (a, b)=>$a86819fe50d185cb$var$__defProps(a, $a86819fe50d185cb$var$__getOwnPropDescs(b));
var $a86819fe50d185cb$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($a86819fe50d185cb$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $a86819fe50d185cb$var$__getOwnPropSymbols) {
        for (var prop of $a86819fe50d185cb$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $a86819fe50d185cb$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $a86819fe50d185cb$export$2e2bcd8739ae039 = (iconName, iconNamePascal, iconNode)=>{
    const Component = (0, $acw62.forwardRef)((_a, ref)=>{
        var _b = _a, { color: color = "currentColor", size: size = 24, stroke: stroke = 2, children: children } = _b, rest = $a86819fe50d185cb$var$__objRest(_b, [
            "color",
            "size",
            "stroke",
            "children"
        ]);
        return (0, $acw62.createElement)("svg", $a86819fe50d185cb$var$__spreadValues($a86819fe50d185cb$var$__spreadProps($a86819fe50d185cb$var$__spreadValues({
            ref: ref
        }, (0, $136c6b1249c8cb09$export$2e2bcd8739ae039)), {
            width: size,
            height: size,
            stroke: color,
            strokeWidth: stroke,
            className: `tabler-icon tabler-icon-${iconName}`
        }), rest), [
            ...iconNode.map(([tag, attrs])=>(0, $acw62.createElement)(tag, attrs)),
            ...children || []
        ]);
    });
    Component.propTypes = {
        color: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        size: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number
        ]),
        stroke: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number
        ])
    };
    Component.displayName = `${iconNamePascal}`;
    return Component;
};


var $058c864623b900db$export$2e2bcd8739ae039 = (0, $a86819fe50d185cb$export$2e2bcd8739ae039)("check", "IconCheck", [
    [
        "path",
        {
            d: "M5 12l5 5l10 -10",
            key: "svg-0"
        }
    ]
]);

/**
 * @tabler/icons-react v2.42.0 - MIT
 */ 
var $e254d1424d005608$export$2e2bcd8739ae039 = (0, $a86819fe50d185cb$export$2e2bcd8739ae039)("edit", "IconEdit", [
    [
        "path",
        {
            d: "M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1",
            key: "svg-0"
        }
    ],
    [
        "path",
        {
            d: "M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z",
            key: "svg-1"
        }
    ],
    [
        "path",
        {
            d: "M16 5l3 3",
            key: "svg-2"
        }
    ]
]);

/**
 * @tabler/icons-react v2.42.0 - MIT
 */ 
var $96c0311e1348944b$export$2e2bcd8739ae039 = (0, $a86819fe50d185cb$export$2e2bcd8739ae039)("plus", "IconPlus", [
    [
        "path",
        {
            d: "M12 5l0 14",
            key: "svg-0"
        }
    ],
    [
        "path",
        {
            d: "M5 12l14 0",
            key: "svg-1"
        }
    ]
]);



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
"use client";
const $8bfe23d77fc8b69d$var$__useId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useId".toString()] || (()=>void 0);
function $8bfe23d77fc8b69d$export$a64f454050c00176() {
    const id = $8bfe23d77fc8b69d$var$__useId();
    return id ? `mantine-${id.replace(/:/g, "")}` : "";
}


"use client";
function $9e1d22b9666695e5$export$5e699d18035b41af() {
    return `mantine-${Math.random().toString(36).slice(2, 11)}`;
}


"use client";
function $cee42e5537afff93$export$f680877a34711e37(staticId) {
    const reactId = (0, $8bfe23d77fc8b69d$export$a64f454050c00176)();
    const [uuid, setUuid] = (0, $acw62.useState)(reactId);
    (0, $562774022e0ac3ca$export$363c9f3eb56bbdbe)(()=>{
        setUuid((0, $9e1d22b9666695e5$export$5e699d18035b41af)());
    }, []);
    if (typeof staticId === "string") return staticId;
    if (typeof window === "undefined") return reactId;
    return uuid;
}


var $acw62 = parcelRequire("acw62");
"use client";
function $4197894a742d9f84$export$ec55e9daaf703a7d({ value: value, defaultValue: defaultValue, finalValue: finalValue, onChange: onChange = ()=>{} }) {
    const [uncontrolledValue, setUncontrolledValue] = (0, $acw62.useState)(defaultValue !== void 0 ? defaultValue : finalValue);
    const handleUncontrolledChange = (val)=>{
        setUncontrolledValue(val);
        onChange == null || onChange(val);
    };
    if (value !== void 0) return [
        value,
        onChange,
        true
    ];
    return [
        uncontrolledValue,
        handleUncontrolledChange,
        false
    ];
}



var $acw62 = parcelRequire("acw62");

"use client";
var $4e38105621a976b3$var$__defProp = Object.defineProperty;
var $4e38105621a976b3$var$__defProps = Object.defineProperties;
var $4e38105621a976b3$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $4e38105621a976b3$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $4e38105621a976b3$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $4e38105621a976b3$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $4e38105621a976b3$var$__defNormalProp = (obj, key, value)=>key in obj ? $4e38105621a976b3$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $4e38105621a976b3$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($4e38105621a976b3$var$__hasOwnProp.call(b, prop)) $4e38105621a976b3$var$__defNormalProp(a, prop, b[prop]);
    if ($4e38105621a976b3$var$__getOwnPropSymbols) {
        for (var prop of $4e38105621a976b3$var$__getOwnPropSymbols(b))if ($4e38105621a976b3$var$__propIsEnum.call(b, prop)) $4e38105621a976b3$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $4e38105621a976b3$var$__spreadProps = (a, b)=>$4e38105621a976b3$var$__defProps(a, $4e38105621a976b3$var$__getOwnPropDescs(b));
var $4e38105621a976b3$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($4e38105621a976b3$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $4e38105621a976b3$var$__getOwnPropSymbols) {
        for (var prop of $4e38105621a976b3$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $4e38105621a976b3$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
function $4e38105621a976b3$export$507d1a3a571ba3b7(_a) {
    var _b = _a, { style: style, size: size = 16 } = _b, others = $4e38105621a976b3$var$__objRest(_b, [
        "style",
        "size"
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $4e38105621a976b3$var$__spreadValues({
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: $4e38105621a976b3$var$__spreadProps($4e38105621a976b3$var$__spreadValues({}, style), {
            width: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(size),
            height: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(size),
            display: "block"
        })
    }, others), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M3.13523 6.15803C3.3241 5.95657 3.64052 5.94637 3.84197 6.13523L7.5 9.56464L11.158 6.13523C11.3595 5.94637 11.6759 5.95657 11.8648 6.15803C12.0536 6.35949 12.0434 6.67591 11.842 6.86477L7.84197 10.6148C7.64964 10.7951 7.35036 10.7951 7.15803 10.6148L3.15803 6.86477C2.95657 6.67591 2.94637 6.35949 3.13523 6.15803Z",
        fill: "currentColor",
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
}
$4e38105621a976b3$export$507d1a3a571ba3b7.displayName = "@mantine/core/AccordionChevron";



var $acw62 = parcelRequire("acw62");

"use client";
const [$5fb7aa28075c68b5$export$a7339cf504e447d7, $5fb7aa28075c68b5$export$33b38874135ce337] = (0, $0bf9cc213b4abd2e$export$97d0e477aacf9b7d)("Accordion component was not found in the tree");



"use client";
const [$cc7d90d368203f02$export$460e63a7964f88ee, $cc7d90d368203f02$export$26f4eabe9fa88f4f] = (0, $0bf9cc213b4abd2e$export$97d0e477aacf9b7d)("Accordion.Item component was not found in the tree");


"use client";
var $011abef20648f05f$var$classes = {
    "root": "m-9bdbb667",
    "panel": "m-df78851f",
    "content": "m-4ba554d4",
    "itemTitle": "m-8fa820a0",
    "control": "m-4ba585b8",
    "control--default": "m-6939a5e9",
    "control--contained": "m-4271d21b",
    "label": "m-df3ffa0f",
    "chevron": "m-3f35ae96",
    "icon": "m-9bd771fe",
    "item": "m-9bd7b098",
    "item--default": "m-fe19b709",
    "item--contained": "m-1f921b3b",
    "item--filled": "m-2cdf939a",
    "item--separated": "m-9f59b069"
};
var $011abef20648f05f$export$2e2bcd8739ae039 = $011abef20648f05f$var$classes;





"use client";
var $2d896f246ec83aed$var$__defProp = Object.defineProperty;
var $2d896f246ec83aed$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $2d896f246ec83aed$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $2d896f246ec83aed$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $2d896f246ec83aed$var$__defNormalProp = (obj, key, value)=>key in obj ? $2d896f246ec83aed$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $2d896f246ec83aed$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($2d896f246ec83aed$var$__hasOwnProp.call(b, prop)) $2d896f246ec83aed$var$__defNormalProp(a, prop, b[prop]);
    if ($2d896f246ec83aed$var$__getOwnPropSymbols) {
        for (var prop of $2d896f246ec83aed$var$__getOwnPropSymbols(b))if ($2d896f246ec83aed$var$__propIsEnum.call(b, prop)) $2d896f246ec83aed$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $2d896f246ec83aed$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($2d896f246ec83aed$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $2d896f246ec83aed$var$__getOwnPropSymbols) {
        for (var prop of $2d896f246ec83aed$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $2d896f246ec83aed$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $2d896f246ec83aed$var$defaultProps = {};
const $2d896f246ec83aed$export$d99097c13d4dac9f = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((props, ref)=>{
    const _a = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("AccordionItem", $2d896f246ec83aed$var$defaultProps, props), { classNames: classNames, className: className, style: style, styles: styles, vars: vars, value: value } = _a, others = $2d896f246ec83aed$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars",
        "value"
    ]);
    const ctx = (0, $5fb7aa28075c68b5$export$33b38874135ce337)();
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cc7d90d368203f02$export$460e63a7964f88ee), {
        value: {
            value: value
        }
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $2d896f246ec83aed$var$__spreadValues($2d896f246ec83aed$var$__spreadValues({
        ref: ref,
        mod: {
            active: ctx.isItemActive(value)
        }
    }, ctx.getStyles("item", {
        className: className,
        classNames: classNames,
        styles: styles,
        style: style,
        variant: ctx.variant
    })), others)));
});
$2d896f246ec83aed$export$d99097c13d4dac9f.displayName = "@mantine/core/AccordionItem";
$2d896f246ec83aed$export$d99097c13d4dac9f.classes = (0, $011abef20648f05f$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
"use client";
function $3e336cc32962af14$var$attachMediaListener(query, callback) {
    try {
        query.addEventListener("change", callback);
        return ()=>query.removeEventListener("change", callback);
    } catch (e) {
        query.addListener(callback);
        return ()=>query.removeListener(callback);
    }
}
function $3e336cc32962af14$var$getInitialValue(query, initialValue) {
    if (typeof initialValue === "boolean") return initialValue;
    if (typeof window !== "undefined" && "matchMedia" in window) return window.matchMedia(query).matches;
    return false;
}
function $3e336cc32962af14$export$32d5543ab307c01(query, initialValue, { getInitialValueInEffect: getInitialValueInEffect } = {
    getInitialValueInEffect: true
}) {
    const [matches, setMatches] = (0, $acw62.useState)(getInitialValueInEffect ? initialValue : $3e336cc32962af14$var$getInitialValue(query, initialValue));
    const queryRef = (0, $acw62.useRef)();
    (0, $acw62.useEffect)(()=>{
        if ("matchMedia" in window) {
            queryRef.current = window.matchMedia(query);
            setMatches(queryRef.current.matches);
            return $3e336cc32962af14$var$attachMediaListener(queryRef.current, (event)=>setMatches(event.matches));
        }
        return void 0;
    }, [
        query
    ]);
    return matches;
}


"use client";
function $91a4302ee7795ed2$export$6a42007cf1e7b6f8(initialValue, options) {
    return (0, $3e336cc32962af14$export$32d5543ab307c01)("(prefers-reduced-motion: reduce)", initialValue, options);
}



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
"use client";
function $7034a45159125c0b$export$d734136a7b018efe(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (typeof ref === "object" && ref !== null && "current" in ref) ref.current = value;
}
function $7034a45159125c0b$export$c9058316764c140e(...refs) {
    return (node)=>{
        refs.forEach((ref)=>$7034a45159125c0b$export$d734136a7b018efe(ref, node));
    };
}
function $7034a45159125c0b$export$36a55fa7500f01f(...refs) {
    return (0, $acw62.useCallback)($7034a45159125c0b$export$c9058316764c140e(...refs), refs);
}


var $acw62 = parcelRequire("acw62");
"use client";
function $d9273517323905a9$export$e34ed88fef4dc107(fn, dependencies) {
    const mounted = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>()=>{
            mounted.current = false;
        }, []);
    (0, $acw62.useEffect)(()=>{
        if (mounted.current) return fn();
        mounted.current = true;
        return void 0;
    }, dependencies);
}


"use client";
var $8c639d939ee71e41$var$__defProp = Object.defineProperty;
var $8c639d939ee71e41$var$__defProps = Object.defineProperties;
var $8c639d939ee71e41$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $8c639d939ee71e41$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $8c639d939ee71e41$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $8c639d939ee71e41$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $8c639d939ee71e41$var$__defNormalProp = (obj, key, value)=>key in obj ? $8c639d939ee71e41$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $8c639d939ee71e41$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($8c639d939ee71e41$var$__hasOwnProp.call(b, prop)) $8c639d939ee71e41$var$__defNormalProp(a, prop, b[prop]);
    if ($8c639d939ee71e41$var$__getOwnPropSymbols) {
        for (var prop of $8c639d939ee71e41$var$__getOwnPropSymbols(b))if ($8c639d939ee71e41$var$__propIsEnum.call(b, prop)) $8c639d939ee71e41$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $8c639d939ee71e41$var$__spreadProps = (a, b)=>$8c639d939ee71e41$var$__defProps(a, $8c639d939ee71e41$var$__getOwnPropDescs(b));
var $8c639d939ee71e41$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($8c639d939ee71e41$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $8c639d939ee71e41$var$__getOwnPropSymbols) {
        for (var prop of $8c639d939ee71e41$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $8c639d939ee71e41$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
function $8c639d939ee71e41$var$getAutoHeightDuration(height) {
    if (!height || typeof height === "string") return 0;
    const constant = height / 36;
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $8c639d939ee71e41$export$8e0f1520ce23a388(el) {
    return (el == null ? void 0 : el.current) ? el.current.scrollHeight : "auto";
}
const $8c639d939ee71e41$var$raf = typeof window !== "undefined" && window.requestAnimationFrame;
function $8c639d939ee71e41$export$e8be2fc690e5dac2({ transitionDuration: transitionDuration, transitionTimingFunction: transitionTimingFunction = "ease", onTransitionEnd: onTransitionEnd = ()=>{}, opened: opened }) {
    const el = (0, $acw62.useRef)(null);
    const collapsedHeight = 0;
    const collapsedStyles = {
        display: "none",
        height: 0,
        overflow: "hidden"
    };
    const [styles, setStylesRaw] = (0, $acw62.useState)(opened ? {} : collapsedStyles);
    const setStyles = (newStyles)=>{
        (0, $11492dca620dcaa5$exports.flushSync)(()=>setStylesRaw(newStyles));
    };
    const mergeStyles = (newStyles)=>{
        setStyles((oldStyles)=>$8c639d939ee71e41$var$__spreadValues($8c639d939ee71e41$var$__spreadValues({}, oldStyles), newStyles));
    };
    function getTransitionStyles(height) {
        const _duration = transitionDuration || $8c639d939ee71e41$var$getAutoHeightDuration(height);
        return {
            transition: `height ${_duration}ms ${transitionTimingFunction}`
        };
    }
    (0, $d9273517323905a9$export$e34ed88fef4dc107)(()=>{
        if (typeof $8c639d939ee71e41$var$raf === "function") {
            if (opened) $8c639d939ee71e41$var$raf(()=>{
                mergeStyles({
                    willChange: "height",
                    display: "block",
                    overflow: "hidden"
                });
                $8c639d939ee71e41$var$raf(()=>{
                    const height = $8c639d939ee71e41$export$8e0f1520ce23a388(el);
                    mergeStyles($8c639d939ee71e41$var$__spreadProps($8c639d939ee71e41$var$__spreadValues({}, getTransitionStyles(height)), {
                        height: height
                    }));
                });
            });
            else $8c639d939ee71e41$var$raf(()=>{
                const height = $8c639d939ee71e41$export$8e0f1520ce23a388(el);
                mergeStyles($8c639d939ee71e41$var$__spreadProps($8c639d939ee71e41$var$__spreadValues({}, getTransitionStyles(height)), {
                    willChange: "height",
                    height: height
                }));
                $8c639d939ee71e41$var$raf(()=>mergeStyles({
                        height: collapsedHeight,
                        overflow: "hidden"
                    }));
            });
        }
    }, [
        opened
    ]);
    const handleTransitionEnd = (e)=>{
        if (e.target !== el.current || e.propertyName !== "height") return;
        if (opened) {
            const height = $8c639d939ee71e41$export$8e0f1520ce23a388(el);
            if (height === styles.height) setStyles({});
            else mergeStyles({
                height: height
            });
            onTransitionEnd();
        } else if (styles.height === collapsedHeight) {
            setStyles(collapsedStyles);
            onTransitionEnd();
        }
    };
    function getCollapseProps(_a = {}) {
        var _b = _a, { style: style = {}, refKey: refKey = "ref" } = _b, rest = $8c639d939ee71e41$var$__objRest(_b, [
            "style",
            "refKey"
        ]);
        const theirRef = rest[refKey];
        return $8c639d939ee71e41$var$__spreadProps($8c639d939ee71e41$var$__spreadValues({
            "aria-hidden": !opened
        }, rest), {
            [refKey]: (0, $7034a45159125c0b$export$c9058316764c140e)(el, theirRef),
            onTransitionEnd: handleTransitionEnd,
            style: $8c639d939ee71e41$var$__spreadValues($8c639d939ee71e41$var$__spreadValues({
                boxSizing: "border-box"
            }, style), styles)
        });
    }
    return getCollapseProps;
}





"use client";
var $9f77ba4d5177d71b$var$__defProp = Object.defineProperty;
var $9f77ba4d5177d71b$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $9f77ba4d5177d71b$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $9f77ba4d5177d71b$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $9f77ba4d5177d71b$var$__defNormalProp = (obj, key, value)=>key in obj ? $9f77ba4d5177d71b$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $9f77ba4d5177d71b$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($9f77ba4d5177d71b$var$__hasOwnProp.call(b, prop)) $9f77ba4d5177d71b$var$__defNormalProp(a, prop, b[prop]);
    if ($9f77ba4d5177d71b$var$__getOwnPropSymbols) {
        for (var prop of $9f77ba4d5177d71b$var$__getOwnPropSymbols(b))if ($9f77ba4d5177d71b$var$__propIsEnum.call(b, prop)) $9f77ba4d5177d71b$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
function $9f77ba4d5177d71b$export$6dbbdf4a0acaecb4(style, theme) {
    if (Array.isArray(style)) return [
        ...style
    ].reduce((acc, item)=>$9f77ba4d5177d71b$var$__spreadValues($9f77ba4d5177d71b$var$__spreadValues({}, acc), $9f77ba4d5177d71b$export$6dbbdf4a0acaecb4(item, theme)), {});
    if (typeof style === "function") return style(theme);
    if (style == null) return {};
    return style;
}


"use client";
var $8f2ec29da821ca87$var$__defProp = Object.defineProperty;
var $8f2ec29da821ca87$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $8f2ec29da821ca87$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $8f2ec29da821ca87$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $8f2ec29da821ca87$var$__defNormalProp = (obj, key, value)=>key in obj ? $8f2ec29da821ca87$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $8f2ec29da821ca87$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($8f2ec29da821ca87$var$__hasOwnProp.call(b, prop)) $8f2ec29da821ca87$var$__defNormalProp(a, prop, b[prop]);
    if ($8f2ec29da821ca87$var$__getOwnPropSymbols) {
        for (var prop of $8f2ec29da821ca87$var$__getOwnPropSymbols(b))if ($8f2ec29da821ca87$var$__propIsEnum.call(b, prop)) $8f2ec29da821ca87$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $8f2ec29da821ca87$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($8f2ec29da821ca87$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $8f2ec29da821ca87$var$__getOwnPropSymbols) {
        for (var prop of $8f2ec29da821ca87$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $8f2ec29da821ca87$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $8f2ec29da821ca87$var$defaultProps = {
    transitionDuration: 200,
    transitionTimingFunction: "ease",
    animateOpacity: true
};
const $8f2ec29da821ca87$export$78768a9af065a7b = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("Collapse", $8f2ec29da821ca87$var$defaultProps, props), { children: children, in: opened, transitionDuration: transitionDuration, transitionTimingFunction: transitionTimingFunction, style: style, onTransitionEnd: onTransitionEnd, animateOpacity: animateOpacity } = _a, others = $8f2ec29da821ca87$var$__objRest(_a, [
        "children",
        "in",
        "transitionDuration",
        "transitionTimingFunction",
        "style",
        "onTransitionEnd",
        "animateOpacity"
    ]);
    const theme = (0, $692af3391f7b0a55$export$5eb0e84f6418b457)();
    const shouldReduceMotion = (0, $91a4302ee7795ed2$export$6a42007cf1e7b6f8)();
    const reduceMotion = theme.respectReducedMotion ? shouldReduceMotion : false;
    const duration = reduceMotion ? 0 : transitionDuration;
    const getCollapseProps = (0, $8c639d939ee71e41$export$e8be2fc690e5dac2)({
        opened: opened,
        transitionDuration: duration,
        transitionTimingFunction: transitionTimingFunction,
        onTransitionEnd: onTransitionEnd
    });
    if (duration === 0) return opened ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $8f2ec29da821ca87$var$__spreadValues({}, others), children) : null;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $8f2ec29da821ca87$var$__spreadValues({}, getCollapseProps($8f2ec29da821ca87$var$__spreadValues({
        style: (0, $9f77ba4d5177d71b$export$6dbbdf4a0acaecb4)(style, theme),
        ref: ref
    }, others))), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            opacity: opened || !animateOpacity ? 1 : 0,
            transition: animateOpacity ? `opacity ${duration}ms ${transitionTimingFunction}` : "none"
        }
    }, children));
});
$8f2ec29da821ca87$export$78768a9af065a7b.displayName = "@mantine/core/Collapse";




"use client";
var $368e52beb7ab74c4$var$__defProp = Object.defineProperty;
var $368e52beb7ab74c4$var$__defProps = Object.defineProperties;
var $368e52beb7ab74c4$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $368e52beb7ab74c4$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $368e52beb7ab74c4$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $368e52beb7ab74c4$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $368e52beb7ab74c4$var$__defNormalProp = (obj, key, value)=>key in obj ? $368e52beb7ab74c4$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $368e52beb7ab74c4$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($368e52beb7ab74c4$var$__hasOwnProp.call(b, prop)) $368e52beb7ab74c4$var$__defNormalProp(a, prop, b[prop]);
    if ($368e52beb7ab74c4$var$__getOwnPropSymbols) {
        for (var prop of $368e52beb7ab74c4$var$__getOwnPropSymbols(b))if ($368e52beb7ab74c4$var$__propIsEnum.call(b, prop)) $368e52beb7ab74c4$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $368e52beb7ab74c4$var$__spreadProps = (a, b)=>$368e52beb7ab74c4$var$__defProps(a, $368e52beb7ab74c4$var$__getOwnPropDescs(b));
var $368e52beb7ab74c4$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($368e52beb7ab74c4$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $368e52beb7ab74c4$var$__getOwnPropSymbols) {
        for (var prop of $368e52beb7ab74c4$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $368e52beb7ab74c4$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $368e52beb7ab74c4$var$defaultProps = {};
const $368e52beb7ab74c4$export$7cad6f17fd6e117b = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((props, ref)=>{
    var _b;
    const _a = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("AccordionPanel", $368e52beb7ab74c4$var$defaultProps, props), { classNames: classNames, className: className, style: style, styles: styles, vars: vars, children: children } = _a, others = $368e52beb7ab74c4$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars",
        "children"
    ]);
    const { value: value } = (0, $cc7d90d368203f02$export$26f4eabe9fa88f4f)();
    const ctx = (0, $5fb7aa28075c68b5$export$33b38874135ce337)();
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8f2ec29da821ca87$export$78768a9af065a7b), $368e52beb7ab74c4$var$__spreadProps($368e52beb7ab74c4$var$__spreadValues($368e52beb7ab74c4$var$__spreadValues({
        ref: ref
    }, ctx.getStyles("panel", {
        className: className,
        classNames: classNames,
        style: style,
        styles: styles
    })), others), {
        in: ctx.isItemActive(value),
        transitionDuration: (_b = ctx.transitionDuration) != null ? _b : 200,
        role: "region",
        id: ctx.getRegionId(value),
        "aria-labelledby": ctx.getControlId(value)
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $368e52beb7ab74c4$var$__spreadValues({}, ctx.getStyles("content", {
        classNames: classNames,
        styles: styles
    })), children));
});
$368e52beb7ab74c4$export$7cad6f17fd6e117b.displayName = "@mantine/core/AccordionPanel";
$368e52beb7ab74c4$export$7cad6f17fd6e117b.classes = (0, $011abef20648f05f$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");




"use client";
function $2c8b9d23474a2600$export$3d0f3f5781bcdc48(element, selector) {
    let _element = element;
    while((_element = _element.parentElement) && !_element.matches(selector));
    return _element;
}


"use client";
function $afa38183edceda99$var$getPreviousIndex(current, elements, loop) {
    for(let i = current - 1; i >= 0; i -= 1){
        if (!elements[i].disabled) return i;
    }
    if (loop) for(let i = elements.length - 1; i > -1; i -= 1){
        if (!elements[i].disabled) return i;
    }
    return current;
}
function $afa38183edceda99$var$getNextIndex(current, elements, loop) {
    for(let i = current + 1; i < elements.length; i += 1){
        if (!elements[i].disabled) return i;
    }
    if (loop) for(let i = 0; i < elements.length; i += 1){
        if (!elements[i].disabled) return i;
    }
    return current;
}
function $afa38183edceda99$var$onSameLevel(target, sibling, parentSelector) {
    return (0, $2c8b9d23474a2600$export$3d0f3f5781bcdc48)(target, parentSelector) === (0, $2c8b9d23474a2600$export$3d0f3f5781bcdc48)(sibling, parentSelector);
}
function $afa38183edceda99$export$5b1acc7188190893({ parentSelector: parentSelector, siblingSelector: siblingSelector, onKeyDown: onKeyDown, loop: loop = true, activateOnFocus: activateOnFocus = false, dir: dir = "rtl", orientation: orientation }) {
    return (event)=>{
        var _a;
        onKeyDown == null || onKeyDown(event);
        const elements = Array.from(((_a = (0, $2c8b9d23474a2600$export$3d0f3f5781bcdc48)(event.currentTarget, parentSelector)) == null ? void 0 : _a.querySelectorAll(siblingSelector)) || []).filter((node)=>$afa38183edceda99$var$onSameLevel(event.currentTarget, node, parentSelector));
        const current = elements.findIndex((el)=>event.currentTarget === el);
        const _nextIndex = $afa38183edceda99$var$getNextIndex(current, elements, loop);
        const _previousIndex = $afa38183edceda99$var$getPreviousIndex(current, elements, loop);
        const nextIndex = dir === "rtl" ? _previousIndex : _nextIndex;
        const previousIndex = dir === "rtl" ? _nextIndex : _previousIndex;
        switch(event.key){
            case "ArrowRight":
                if (orientation === "horizontal") {
                    event.stopPropagation();
                    event.preventDefault();
                    elements[nextIndex].focus();
                    activateOnFocus && elements[nextIndex].click();
                }
                break;
            case "ArrowLeft":
                if (orientation === "horizontal") {
                    event.stopPropagation();
                    event.preventDefault();
                    elements[previousIndex].focus();
                    activateOnFocus && elements[previousIndex].click();
                }
                break;
            case "ArrowUp":
                if (orientation === "vertical") {
                    event.stopPropagation();
                    event.preventDefault();
                    elements[_previousIndex].focus();
                    activateOnFocus && elements[_previousIndex].click();
                }
                break;
            case "ArrowDown":
                if (orientation === "vertical") {
                    event.stopPropagation();
                    event.preventDefault();
                    elements[_nextIndex].focus();
                    activateOnFocus && elements[_nextIndex].click();
                }
                break;
            case "Home":
                event.stopPropagation();
                event.preventDefault();
                !elements[0].disabled && elements[0].focus();
                break;
            case "End":
                {
                    event.stopPropagation();
                    event.preventDefault();
                    const last = elements.length - 1;
                    !elements[last].disabled && elements[last].focus();
                    break;
                }
        }
    };
}





"use client";
var $abb97211147a2c79$var$__defProp = Object.defineProperty;
var $abb97211147a2c79$var$__defProps = Object.defineProperties;
var $abb97211147a2c79$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $abb97211147a2c79$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $abb97211147a2c79$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $abb97211147a2c79$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $abb97211147a2c79$var$__defNormalProp = (obj, key, value)=>key in obj ? $abb97211147a2c79$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $abb97211147a2c79$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($abb97211147a2c79$var$__hasOwnProp.call(b, prop)) $abb97211147a2c79$var$__defNormalProp(a, prop, b[prop]);
    if ($abb97211147a2c79$var$__getOwnPropSymbols) {
        for (var prop of $abb97211147a2c79$var$__getOwnPropSymbols(b))if ($abb97211147a2c79$var$__propIsEnum.call(b, prop)) $abb97211147a2c79$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $abb97211147a2c79$var$__spreadProps = (a, b)=>$abb97211147a2c79$var$__defProps(a, $abb97211147a2c79$var$__getOwnPropDescs(b));
var $abb97211147a2c79$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($abb97211147a2c79$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $abb97211147a2c79$var$__getOwnPropSymbols) {
        for (var prop of $abb97211147a2c79$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $abb97211147a2c79$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $abb97211147a2c79$var$defaultProps = {};
const $abb97211147a2c79$export$165fb10d16cf13d3 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((props, ref)=>{
    const _a = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("AccordionControl", $abb97211147a2c79$var$defaultProps, props), { classNames: classNames, className: className, style: style, styles: styles, vars: vars, chevron: chevron, icon: icon, onClick: onClick, onKeyDown: onKeyDown, children: children, disabled: disabled } = _a, others = $abb97211147a2c79$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars",
        "chevron",
        "icon",
        "onClick",
        "onKeyDown",
        "children",
        "disabled"
    ]);
    const { value: value } = (0, $cc7d90d368203f02$export$26f4eabe9fa88f4f)();
    const ctx = (0, $5fb7aa28075c68b5$export$33b38874135ce337)();
    const isActive = ctx.isItemActive(value);
    const shouldWrapWithHeading = typeof ctx.order === "number";
    const Heading = `h${ctx.order}`;
    const content = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b9babe59f8fa61e8$export$3167f6ecaaaa3457), $abb97211147a2c79$var$__spreadProps($abb97211147a2c79$var$__spreadValues($abb97211147a2c79$var$__spreadValues({}, others), ctx.getStyles("control", {
        className: className,
        classNames: classNames,
        style: style,
        styles: styles,
        variant: ctx.variant
    })), {
        unstyled: ctx.unstyled,
        mod: [
            "accordion-control",
            {
                active: isActive,
                "chevron-position": ctx.chevronPosition,
                disabled: disabled
            }
        ],
        ref: ref,
        onClick: (event)=>{
            onClick == null || onClick(event);
            ctx.onChange(value);
        },
        type: "button",
        disabled: disabled,
        "aria-expanded": isActive,
        "aria-controls": ctx.getRegionId(value),
        id: ctx.getControlId(value),
        onKeyDown: (0, $afa38183edceda99$export$5b1acc7188190893)({
            siblingSelector: "[data-accordion-control]",
            parentSelector: "[data-accordion]",
            activateOnFocus: false,
            loop: ctx.loop,
            orientation: "vertical",
            onKeyDown: onKeyDown
        })
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $abb97211147a2c79$var$__spreadValues({
        component: "span",
        mod: {
            rotate: !ctx.disableChevronRotation && isActive,
            position: ctx.chevronPosition
        }
    }, ctx.getStyles("chevron", {
        classNames: classNames,
        styles: styles
    })), chevron || ctx.chevron), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", $abb97211147a2c79$var$__spreadValues({}, ctx.getStyles("label", {
        classNames: classNames,
        styles: styles
    })), children), icon && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $abb97211147a2c79$var$__spreadValues({
        component: "span",
        mod: {
            "chevron-position": ctx.chevronPosition
        }
    }, ctx.getStyles("icon", {
        classNames: classNames,
        styles: styles
    })), icon));
    return shouldWrapWithHeading ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Heading, $abb97211147a2c79$var$__spreadValues({}, ctx.getStyles("itemTitle", {
        classNames: classNames,
        styles: styles
    })), content) : content;
});
$abb97211147a2c79$export$165fb10d16cf13d3.displayName = "@mantine/core/AccordionControl";
$abb97211147a2c79$export$165fb10d16cf13d3.classes = (0, $011abef20648f05f$export$2e2bcd8739ae039);




"use client";
function $aedbb40cfdf4bb61$export$d1aa29729505dfb6(uid, errorMessage) {
    return (value)=>{
        if (typeof value !== "string" || value.trim().length === 0) throw new Error(errorMessage);
        return `${uid}-${value}`;
    };
}








"use client";
var $082a1c451bb0006a$var$__defProp = Object.defineProperty;
var $082a1c451bb0006a$var$__defProps = Object.defineProperties;
var $082a1c451bb0006a$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $082a1c451bb0006a$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $082a1c451bb0006a$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $082a1c451bb0006a$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $082a1c451bb0006a$var$__defNormalProp = (obj, key, value)=>key in obj ? $082a1c451bb0006a$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $082a1c451bb0006a$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($082a1c451bb0006a$var$__hasOwnProp.call(b, prop)) $082a1c451bb0006a$var$__defNormalProp(a, prop, b[prop]);
    if ($082a1c451bb0006a$var$__getOwnPropSymbols) {
        for (var prop of $082a1c451bb0006a$var$__getOwnPropSymbols(b))if ($082a1c451bb0006a$var$__propIsEnum.call(b, prop)) $082a1c451bb0006a$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $082a1c451bb0006a$var$__spreadProps = (a, b)=>$082a1c451bb0006a$var$__defProps(a, $082a1c451bb0006a$var$__getOwnPropDescs(b));
var $082a1c451bb0006a$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($082a1c451bb0006a$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $082a1c451bb0006a$var$__getOwnPropSymbols) {
        for (var prop of $082a1c451bb0006a$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $082a1c451bb0006a$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $082a1c451bb0006a$var$defaultProps = {
    multiple: false,
    disableChevronRotation: false,
    chevronPosition: "right",
    variant: "default",
    chevron: /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4e38105621a976b3$export$507d1a3a571ba3b7), null)
};
const $082a1c451bb0006a$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((_, { transitionDuration: transitionDuration, chevronSize: chevronSize, radius: radius })=>({
        root: {
            "--accordion-transition-duration": transitionDuration === void 0 ? void 0 : `${transitionDuration}ms`,
            "--accordion-chevron-size": chevronSize === void 0 ? void 0 : (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(chevronSize),
            "--accordion-radius": radius === void 0 ? void 0 : (0, $fcab4af601ce7e99$export$35724d9c2979edc5)(radius)
        }
    }));
function $082a1c451bb0006a$export$a766cd26d0d69044(_props) {
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("Accordion", $082a1c451bb0006a$var$defaultProps, _props);
    const _a = props, { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, children: children, multiple: multiple, value: value, defaultValue: defaultValue, onChange: onChange, id: id, loop: loop, transitionDuration: transitionDuration, disableChevronRotation: disableChevronRotation, chevronPosition: chevronPosition, chevronSize: chevronSize, order: order, chevron: chevron, variant: variant, radius: radius } = _a, others = $082a1c451bb0006a$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "children",
        "multiple",
        "value",
        "defaultValue",
        "onChange",
        "id",
        "loop",
        "transitionDuration",
        "disableChevronRotation",
        "chevronPosition",
        "chevronSize",
        "order",
        "chevron",
        "variant",
        "radius"
    ]);
    const uid = (0, $cee42e5537afff93$export$f680877a34711e37)(id);
    const [_value, handleChange] = (0, $4197894a742d9f84$export$ec55e9daaf703a7d)({
        value: value,
        defaultValue: defaultValue,
        finalValue: multiple ? [] : null,
        onChange: onChange
    });
    const isItemActive = (itemValue)=>Array.isArray(_value) ? _value.includes(itemValue) : itemValue === _value;
    const handleItemChange = (itemValue)=>{
        const nextValue = Array.isArray(_value) ? _value.includes(itemValue) ? _value.filter((selectedValue)=>selectedValue !== itemValue) : [
            ..._value,
            itemValue
        ] : itemValue === _value ? null : itemValue;
        handleChange(nextValue);
    };
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: "Accordion",
        classes: $011abef20648f05f$export$2e2bcd8739ae039,
        props: props,
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        vars: vars,
        varsResolver: $082a1c451bb0006a$var$varsResolver
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5fb7aa28075c68b5$export$a7339cf504e447d7), {
        value: {
            isItemActive: isItemActive,
            onChange: handleItemChange,
            getControlId: (0, $aedbb40cfdf4bb61$export$d1aa29729505dfb6)(`${uid}-control`, "Accordion.Item component was rendered with invalid value or without value"),
            getRegionId: (0, $aedbb40cfdf4bb61$export$d1aa29729505dfb6)(`${uid}-panel`, "Accordion.Item component was rendered with invalid value or without value"),
            transitionDuration: transitionDuration,
            disableChevronRotation: disableChevronRotation,
            chevronPosition: chevronPosition,
            order: order,
            chevron: chevron,
            loop: loop,
            getStyles: getStyles,
            variant: variant,
            unstyled: unstyled
        }
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $082a1c451bb0006a$var$__spreadProps($082a1c451bb0006a$var$__spreadValues($082a1c451bb0006a$var$__spreadProps($082a1c451bb0006a$var$__spreadValues({}, getStyles("root")), {
        id: uid
    }), others), {
        variant: variant,
        "data-accordion": true
    }), children));
}
const $082a1c451bb0006a$var$extendAccordion = (c)=>c;
$082a1c451bb0006a$export$a766cd26d0d69044.extend = $082a1c451bb0006a$var$extendAccordion;
$082a1c451bb0006a$export$a766cd26d0d69044.classes = (0, $011abef20648f05f$export$2e2bcd8739ae039);
$082a1c451bb0006a$export$a766cd26d0d69044.displayName = "@mantine/core/Accordion";
$082a1c451bb0006a$export$a766cd26d0d69044.Item = (0, $2d896f246ec83aed$export$d99097c13d4dac9f);
$082a1c451bb0006a$export$a766cd26d0d69044.Panel = (0, $368e52beb7ab74c4$export$7cad6f17fd6e117b);
$082a1c451bb0006a$export$a766cd26d0d69044.Control = (0, $abb97211147a2c79$export$165fb10d16cf13d3);
$082a1c451bb0006a$export$a766cd26d0d69044.Chevron = (0, $4e38105621a976b3$export$507d1a3a571ba3b7);


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
"use client";
function $765d0434bc8e1ded$export$21ff29ccd4c87981(children) {
    return (0, $acw62.Children).toArray(children).filter(Boolean);
}


"use client";
var $e7b26f515173d491$var$classes = {
    "root": "m-4081bf90"
};
var $e7b26f515173d491$export$2e2bcd8739ae039 = $e7b26f515173d491$var$classes;








"use client";
var $da41c60fbf9c6a46$var$__defProp = Object.defineProperty;
var $da41c60fbf9c6a46$var$__defProps = Object.defineProperties;
var $da41c60fbf9c6a46$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $da41c60fbf9c6a46$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $da41c60fbf9c6a46$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $da41c60fbf9c6a46$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $da41c60fbf9c6a46$var$__defNormalProp = (obj, key, value)=>key in obj ? $da41c60fbf9c6a46$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $da41c60fbf9c6a46$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($da41c60fbf9c6a46$var$__hasOwnProp.call(b, prop)) $da41c60fbf9c6a46$var$__defNormalProp(a, prop, b[prop]);
    if ($da41c60fbf9c6a46$var$__getOwnPropSymbols) {
        for (var prop of $da41c60fbf9c6a46$var$__getOwnPropSymbols(b))if ($da41c60fbf9c6a46$var$__propIsEnum.call(b, prop)) $da41c60fbf9c6a46$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $da41c60fbf9c6a46$var$__spreadProps = (a, b)=>$da41c60fbf9c6a46$var$__defProps(a, $da41c60fbf9c6a46$var$__getOwnPropDescs(b));
var $da41c60fbf9c6a46$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($da41c60fbf9c6a46$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $da41c60fbf9c6a46$var$__getOwnPropSymbols) {
        for (var prop of $da41c60fbf9c6a46$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $da41c60fbf9c6a46$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $da41c60fbf9c6a46$var$defaultProps = {
    preventGrowOverflow: true,
    gap: "md",
    align: "center",
    justify: "flex-start",
    wrap: "wrap"
};
const $da41c60fbf9c6a46$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((_, { grow: grow, preventGrowOverflow: preventGrowOverflow, gap: gap, align: align, justify: justify, wrap: wrap }, { childWidth: childWidth })=>({
        root: {
            "--group-child-width": grow && preventGrowOverflow ? childWidth : void 0,
            "--group-gap": (0, $fcab4af601ce7e99$export$f63796f8a9382bfb)(gap),
            "--group-align": align,
            "--group-justify": justify,
            "--group-wrap": wrap
        }
    }));
const $da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("Group", $da41c60fbf9c6a46$var$defaultProps, _props);
    const _a = props, { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, children: children, gap: gap, align: align, justify: justify, wrap: wrap, grow: grow, preventGrowOverflow: preventGrowOverflow, vars: vars, variant: variant, __size: __size } = _a, others = $da41c60fbf9c6a46$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "children",
        "gap",
        "align",
        "justify",
        "wrap",
        "grow",
        "preventGrowOverflow",
        "vars",
        "variant",
        "__size"
    ]);
    const filteredChildren = (0, $765d0434bc8e1ded$export$21ff29ccd4c87981)(children);
    const childrenCount = filteredChildren.length;
    const resolvedGap = (0, $fcab4af601ce7e99$export$f63796f8a9382bfb)(gap != null ? gap : "md");
    const childWidth = `calc(${100 / childrenCount}% - (${resolvedGap} - ${resolvedGap} / ${childrenCount}))`;
    const stylesCtx = {
        childWidth: childWidth
    };
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: "Group",
        props: props,
        stylesCtx: stylesCtx,
        className: className,
        style: style,
        classes: $e7b26f515173d491$export$2e2bcd8739ae039,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        vars: vars,
        varsResolver: $da41c60fbf9c6a46$var$varsResolver
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $da41c60fbf9c6a46$var$__spreadValues($da41c60fbf9c6a46$var$__spreadProps($da41c60fbf9c6a46$var$__spreadValues({}, getStyles("root")), {
        ref: ref,
        variant: variant,
        mod: {
            grow: grow
        },
        size: __size
    }), others), filteredChildren);
});
$da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4.classes = (0, $e7b26f515173d491$export$2e2bcd8739ae039);
$da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4.displayName = "@mantine/core/Group";


var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

"use client";
function $08de56cbba53e67f$export$d02631cccf789723(start, end) {
    const length = end - start + 1;
    return Array.from({
        length: length
    }, (_, index)=>index + start);
}


"use client";
const $97bbd6fd1ca23925$export$fadfbce9325ec320 = "dots";
function $97bbd6fd1ca23925$export$f80c710216eae131({ total: total, siblings: siblings = 1, boundaries: boundaries = 1, page: page, initialPage: initialPage = 1, onChange: onChange }) {
    const _total = Math.max(Math.trunc(total), 0);
    const [activePage, setActivePage] = (0, $4197894a742d9f84$export$ec55e9daaf703a7d)({
        value: page,
        onChange: onChange,
        defaultValue: initialPage,
        finalValue: initialPage
    });
    const setPage = (pageNumber)=>{
        if (pageNumber <= 0) setActivePage(1);
        else if (pageNumber > _total) setActivePage(_total);
        else setActivePage(pageNumber);
    };
    const next = ()=>setPage(activePage + 1);
    const previous = ()=>setPage(activePage - 1);
    const first = ()=>setPage(1);
    const last = ()=>setPage(_total);
    const paginationRange = (0, $acw62.useMemo)(()=>{
        const totalPageNumbers = siblings * 2 + 3 + boundaries * 2;
        if (totalPageNumbers >= _total) return (0, $08de56cbba53e67f$export$d02631cccf789723)(1, _total);
        const leftSiblingIndex = Math.max(activePage - siblings, boundaries);
        const rightSiblingIndex = Math.min(activePage + siblings, _total - boundaries);
        const shouldShowLeftDots = leftSiblingIndex > boundaries + 2;
        const shouldShowRightDots = rightSiblingIndex < _total - (boundaries + 1);
        if (!shouldShowLeftDots && shouldShowRightDots) {
            const leftItemCount = siblings * 2 + boundaries + 2;
            return [
                ...(0, $08de56cbba53e67f$export$d02631cccf789723)(1, leftItemCount),
                $97bbd6fd1ca23925$export$fadfbce9325ec320,
                ...(0, $08de56cbba53e67f$export$d02631cccf789723)(_total - (boundaries - 1), _total)
            ];
        }
        if (shouldShowLeftDots && !shouldShowRightDots) {
            const rightItemCount = boundaries + 1 + 2 * siblings;
            return [
                ...(0, $08de56cbba53e67f$export$d02631cccf789723)(1, boundaries),
                $97bbd6fd1ca23925$export$fadfbce9325ec320,
                ...(0, $08de56cbba53e67f$export$d02631cccf789723)(_total - rightItemCount, _total)
            ];
        }
        return [
            ...(0, $08de56cbba53e67f$export$d02631cccf789723)(1, boundaries),
            $97bbd6fd1ca23925$export$fadfbce9325ec320,
            ...(0, $08de56cbba53e67f$export$d02631cccf789723)(leftSiblingIndex, rightSiblingIndex),
            $97bbd6fd1ca23925$export$fadfbce9325ec320,
            ...(0, $08de56cbba53e67f$export$d02631cccf789723)(_total - boundaries + 1, _total)
        ];
    }, [
        _total,
        siblings,
        activePage
    ]);
    return {
        range: paginationRange,
        active: activePage,
        setPage: setPage,
        next: next,
        previous: previous,
        first: first,
        last: last
    };
}



"use client";
const [$33075221da238fe6$export$59e6051fa3261ff5, $33075221da238fe6$export$983fe576d9f212b7] = (0, $0bf9cc213b4abd2e$export$97d0e477aacf9b7d)("Pagination.Root component was not found in tree");


"use client";
var $1aee5de5663562ea$var$classes = {
    "root": "m-4addd315",
    "control": "m-326d024a",
    "dots": "m-4ad7767d"
};
var $1aee5de5663562ea$export$2e2bcd8739ae039 = $1aee5de5663562ea$var$classes;









"use client";
function $528465f85c56cc6b$export$48d1ea6320830260(parentEventHandler, eventHandler) {
    return (event)=>{
        parentEventHandler == null || parentEventHandler(event);
        eventHandler == null || eventHandler(event);
    };
}


"use client";
var $6a720fa90a51f2dc$var$__defProp = Object.defineProperty;
var $6a720fa90a51f2dc$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $6a720fa90a51f2dc$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $6a720fa90a51f2dc$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $6a720fa90a51f2dc$var$__defNormalProp = (obj, key, value)=>key in obj ? $6a720fa90a51f2dc$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $6a720fa90a51f2dc$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($6a720fa90a51f2dc$var$__hasOwnProp.call(b, prop)) $6a720fa90a51f2dc$var$__defNormalProp(a, prop, b[prop]);
    if ($6a720fa90a51f2dc$var$__getOwnPropSymbols) {
        for (var prop of $6a720fa90a51f2dc$var$__getOwnPropSymbols(b))if ($6a720fa90a51f2dc$var$__propIsEnum.call(b, prop)) $6a720fa90a51f2dc$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $6a720fa90a51f2dc$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($6a720fa90a51f2dc$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $6a720fa90a51f2dc$var$__getOwnPropSymbols) {
        for (var prop of $6a720fa90a51f2dc$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $6a720fa90a51f2dc$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $6a720fa90a51f2dc$var$defaultProps = {
    siblings: 1,
    boundaries: 1
};
const $6a720fa90a51f2dc$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((theme, { size: size, radius: radius, color: color })=>({
        root: {
            "--pagination-control-radius": radius === void 0 ? void 0 : (0, $fcab4af601ce7e99$export$35724d9c2979edc5)(radius),
            "--pagination-control-size": (0, $fcab4af601ce7e99$export$31b21d0167753bb4)(size, "pagination-control-size"),
            "--pagination-control-fz": (0, $fcab4af601ce7e99$export$7d055c252aebca58)(size),
            "--pagination-active-bg": color ? (0, $0a9c57cec2a3e373$export$e22c5d06d177c3fa)(color, theme) : void 0
        }
    }));
const $6a720fa90a51f2dc$export$9254240822e521a5 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("PaginationRoot", $6a720fa90a51f2dc$var$defaultProps, _props);
    const _a = props, { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, total: total, value: value, defaultValue: defaultValue, onChange: onChange, disabled: disabled, siblings: siblings, boundaries: boundaries, color: color, radius: radius, onNextPage: onNextPage, onPreviousPage: onPreviousPage, onFirstPage: onFirstPage, onLastPage: onLastPage, getItemProps: getItemProps } = _a, others = $6a720fa90a51f2dc$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "total",
        "value",
        "defaultValue",
        "onChange",
        "disabled",
        "siblings",
        "boundaries",
        "color",
        "radius",
        "onNextPage",
        "onPreviousPage",
        "onFirstPage",
        "onLastPage",
        "getItemProps"
    ]);
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: "Pagination",
        classes: $1aee5de5663562ea$export$2e2bcd8739ae039,
        props: props,
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        vars: vars,
        varsResolver: $6a720fa90a51f2dc$var$varsResolver
    });
    const { range: range, setPage: setPage, next: next, previous: previous, active: active, first: first, last: last } = (0, $97bbd6fd1ca23925$export$f80c710216eae131)({
        page: value,
        initialPage: defaultValue,
        onChange: onChange,
        total: total,
        siblings: siblings,
        boundaries: boundaries
    });
    const handleNextPage = (0, $528465f85c56cc6b$export$48d1ea6320830260)(onNextPage, next);
    const handlePreviousPage = (0, $528465f85c56cc6b$export$48d1ea6320830260)(onPreviousPage, previous);
    const handleFirstPage = (0, $528465f85c56cc6b$export$48d1ea6320830260)(onFirstPage, first);
    const handleLastPage = (0, $528465f85c56cc6b$export$48d1ea6320830260)(onLastPage, last);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $33075221da238fe6$export$59e6051fa3261ff5), {
        value: {
            total: total,
            range: range,
            active: active,
            disabled: disabled,
            getItemProps: getItemProps,
            onChange: setPage,
            onNext: handleNextPage,
            onPrevious: handlePreviousPage,
            onFirst: handleFirstPage,
            onLast: handleLastPage,
            getStyles: getStyles
        }
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $6a720fa90a51f2dc$var$__spreadValues($6a720fa90a51f2dc$var$__spreadValues({
        ref: ref
    }, getStyles("root")), others)));
});
$6a720fa90a51f2dc$export$9254240822e521a5.classes = (0, $1aee5de5663562ea$export$2e2bcd8739ae039);
$6a720fa90a51f2dc$export$9254240822e521a5.displayName = "@mantine/core/PaginationRoot";



var $acw62 = parcelRequire("acw62");





"use client";
var $18dc76bfac9cb274$var$__defProp = Object.defineProperty;
var $18dc76bfac9cb274$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $18dc76bfac9cb274$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $18dc76bfac9cb274$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $18dc76bfac9cb274$var$__defNormalProp = (obj, key, value)=>key in obj ? $18dc76bfac9cb274$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $18dc76bfac9cb274$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($18dc76bfac9cb274$var$__hasOwnProp.call(b, prop)) $18dc76bfac9cb274$var$__defNormalProp(a, prop, b[prop]);
    if ($18dc76bfac9cb274$var$__getOwnPropSymbols) {
        for (var prop of $18dc76bfac9cb274$var$__getOwnPropSymbols(b))if ($18dc76bfac9cb274$var$__propIsEnum.call(b, prop)) $18dc76bfac9cb274$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $18dc76bfac9cb274$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($18dc76bfac9cb274$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $18dc76bfac9cb274$var$__getOwnPropSymbols) {
        for (var prop of $18dc76bfac9cb274$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $18dc76bfac9cb274$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $18dc76bfac9cb274$var$defaultProps = {
    withPadding: true
};
const $18dc76bfac9cb274$export$a4805060b1c76e2b = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("PaginationControl", $18dc76bfac9cb274$var$defaultProps, _props);
    const _a = props, { classNames: classNames, className: className, style: style, styles: styles, vars: vars, active: active, disabled: disabled, withPadding: withPadding } = _a, others = $18dc76bfac9cb274$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars",
        "active",
        "disabled",
        "withPadding"
    ]);
    const ctx = (0, $33075221da238fe6$export$983fe576d9f212b7)();
    const _disabled = disabled || ctx.disabled;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b9babe59f8fa61e8$export$3167f6ecaaaa3457), $18dc76bfac9cb274$var$__spreadValues($18dc76bfac9cb274$var$__spreadValues({
        ref: ref,
        disabled: _disabled,
        mod: {
            active: active,
            disabled: _disabled,
            "with-padding": withPadding
        }
    }, ctx.getStyles("control", {
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        active: !_disabled
    })), others));
});
$18dc76bfac9cb274$export$a4805060b1c76e2b.classes = (0, $1aee5de5663562ea$export$2e2bcd8739ae039);
$18dc76bfac9cb274$export$a4805060b1c76e2b.displayName = "@mantine/core/PaginationControl";



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
"use client";
var $16f38961ccff8e5c$var$__defProp = Object.defineProperty;
var $16f38961ccff8e5c$var$__defProps = Object.defineProperties;
var $16f38961ccff8e5c$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $16f38961ccff8e5c$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $16f38961ccff8e5c$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $16f38961ccff8e5c$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $16f38961ccff8e5c$var$__defNormalProp = (obj, key, value)=>key in obj ? $16f38961ccff8e5c$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $16f38961ccff8e5c$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($16f38961ccff8e5c$var$__hasOwnProp.call(b, prop)) $16f38961ccff8e5c$var$__defNormalProp(a, prop, b[prop]);
    if ($16f38961ccff8e5c$var$__getOwnPropSymbols) {
        for (var prop of $16f38961ccff8e5c$var$__getOwnPropSymbols(b))if ($16f38961ccff8e5c$var$__propIsEnum.call(b, prop)) $16f38961ccff8e5c$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $16f38961ccff8e5c$var$__spreadProps = (a, b)=>$16f38961ccff8e5c$var$__defProps(a, $16f38961ccff8e5c$var$__getOwnPropDescs(b));
var $16f38961ccff8e5c$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($16f38961ccff8e5c$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $16f38961ccff8e5c$var$__getOwnPropSymbols) {
        for (var prop of $16f38961ccff8e5c$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $16f38961ccff8e5c$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
function $16f38961ccff8e5c$var$PaginationIcon(_a) {
    var _b = _a, { style: style, children: children, path: path } = _b, others = $16f38961ccff8e5c$var$__objRest(_b, [
        "style",
        "children",
        "path"
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $16f38961ccff8e5c$var$__spreadValues({
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        style: $16f38961ccff8e5c$var$__spreadValues({
            width: "calc(var(--pagination-control-size) / 1.8)",
            height: "calc(var(--pagination-control-size) / 1.8)"
        }, style)
    }, others), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: path,
        fill: "currentColor"
    }));
}
const $16f38961ccff8e5c$export$dc180090659eda71 = (props)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($16f38961ccff8e5c$var$PaginationIcon, $16f38961ccff8e5c$var$__spreadProps($16f38961ccff8e5c$var$__spreadValues({}, props), {
        path: "M8.781 8l-3.3-3.3.943-.943L10.667 8l-4.243 4.243-.943-.943 3.3-3.3z"
    }));
const $16f38961ccff8e5c$export$102e17a9fcf2c2c = (props)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($16f38961ccff8e5c$var$PaginationIcon, $16f38961ccff8e5c$var$__spreadProps($16f38961ccff8e5c$var$__spreadValues({}, props), {
        path: "M7.219 8l3.3 3.3-.943.943L5.333 8l4.243-4.243.943.943-3.3 3.3z"
    }));
const $16f38961ccff8e5c$export$331f74485dba16cc = (props)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($16f38961ccff8e5c$var$PaginationIcon, $16f38961ccff8e5c$var$__spreadProps($16f38961ccff8e5c$var$__spreadValues({}, props), {
        path: "M6.85355 3.85355C7.04882 3.65829 7.04882 3.34171 6.85355 3.14645C6.65829 2.95118 6.34171 2.95118 6.14645 3.14645L2.14645 7.14645C1.95118 7.34171 1.95118 7.65829 2.14645 7.85355L6.14645 11.8536C6.34171 12.0488 6.65829 12.0488 6.85355 11.8536C7.04882 11.6583 7.04882 11.3417 6.85355 11.1464L3.20711 7.5L6.85355 3.85355ZM12.8536 3.85355C13.0488 3.65829 13.0488 3.34171 12.8536 3.14645C12.6583 2.95118 12.3417 2.95118 12.1464 3.14645L8.14645 7.14645C7.95118 7.34171 7.95118 7.65829 8.14645 7.85355L12.1464 11.8536C12.3417 12.0488 12.6583 12.0488 12.8536 11.8536C13.0488 11.6583 13.0488 11.3417 12.8536 11.1464L9.20711 7.5L12.8536 3.85355Z"
    }));
const $16f38961ccff8e5c$export$5a55abde184ff64f = (props)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($16f38961ccff8e5c$var$PaginationIcon, $16f38961ccff8e5c$var$__spreadProps($16f38961ccff8e5c$var$__spreadValues({}, props), {
        path: "M2.14645 11.1464C1.95118 11.3417 1.95118 11.6583 2.14645 11.8536C2.34171 12.0488 2.65829 12.0488 2.85355 11.8536L6.85355 7.85355C7.04882 7.65829 7.04882 7.34171 6.85355 7.14645L2.85355 3.14645C2.65829 2.95118 2.34171 2.95118 2.14645 3.14645C1.95118 3.34171 1.95118 3.65829 2.14645 3.85355L5.79289 7.5L2.14645 11.1464ZM8.14645 11.1464C7.95118 11.3417 7.95118 11.6583 8.14645 11.8536C8.34171 12.0488 8.65829 12.0488 8.85355 11.8536L12.8536 7.85355C13.0488 7.65829 13.0488 7.34171 12.8536 7.14645L8.85355 3.14645C8.65829 2.95118 8.34171 2.95118 8.14645 3.14645C7.95118 3.34171 7.95118 3.65829 8.14645 3.85355L11.7929 7.5L8.14645 11.1464Z"
    }));
const $16f38961ccff8e5c$export$f7c369ac1cb967e7 = (props)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($16f38961ccff8e5c$var$PaginationIcon, $16f38961ccff8e5c$var$__spreadProps($16f38961ccff8e5c$var$__spreadValues({}, props), {
        path: "M2 8c0-.733.6-1.333 1.333-1.333.734 0 1.334.6 1.334 1.333s-.6 1.333-1.334 1.333C2.6 9.333 2 8.733 2 8zm9.333 0c0-.733.6-1.333 1.334-1.333C13.4 6.667 14 7.267 14 8s-.6 1.333-1.333 1.333c-.734 0-1.334-.6-1.334-1.333zM6.667 8c0-.733.6-1.333 1.333-1.333s1.333.6 1.333 1.333S8.733 9.333 8 9.333 6.667 8.733 6.667 8z"
    }));






"use client";
var $c7e8d4105784bd6a$var$__defProp = Object.defineProperty;
var $c7e8d4105784bd6a$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $c7e8d4105784bd6a$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $c7e8d4105784bd6a$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $c7e8d4105784bd6a$var$__defNormalProp = (obj, key, value)=>key in obj ? $c7e8d4105784bd6a$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $c7e8d4105784bd6a$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($c7e8d4105784bd6a$var$__hasOwnProp.call(b, prop)) $c7e8d4105784bd6a$var$__defNormalProp(a, prop, b[prop]);
    if ($c7e8d4105784bd6a$var$__getOwnPropSymbols) {
        for (var prop of $c7e8d4105784bd6a$var$__getOwnPropSymbols(b))if ($c7e8d4105784bd6a$var$__propIsEnum.call(b, prop)) $c7e8d4105784bd6a$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $c7e8d4105784bd6a$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($c7e8d4105784bd6a$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $c7e8d4105784bd6a$var$__getOwnPropSymbols) {
        for (var prop of $c7e8d4105784bd6a$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $c7e8d4105784bd6a$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $c7e8d4105784bd6a$var$defaultProps = {
    icon: (0, $16f38961ccff8e5c$export$f7c369ac1cb967e7)
};
const $c7e8d4105784bd6a$export$fec1f421a303d41 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("PaginationDots", $c7e8d4105784bd6a$var$defaultProps, _props);
    const _a = props, { classNames: classNames, className: className, style: style, styles: styles, vars: vars, icon: icon } = _a, others = $c7e8d4105784bd6a$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars",
        "icon"
    ]);
    const ctx = (0, $33075221da238fe6$export$983fe576d9f212b7)();
    const Icon = icon;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $c7e8d4105784bd6a$var$__spreadValues($c7e8d4105784bd6a$var$__spreadValues({
        ref: ref
    }, ctx.getStyles("dots", {
        className: className,
        style: style,
        styles: styles,
        classNames: classNames
    })), others), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        style: {
            width: "calc(var(--pagination-control-size) / 1.8)",
            height: "calc(var(--pagination-control-size) / 1.8)"
        }
    }));
});
$c7e8d4105784bd6a$export$fec1f421a303d41.classes = (0, $1aee5de5663562ea$export$2e2bcd8739ae039);
$c7e8d4105784bd6a$export$fec1f421a303d41.displayName = "@mantine/core/PaginationDots";



var $acw62 = parcelRequire("acw62");





"use client";
var $4268b02e68a9196d$var$__defProp = Object.defineProperty;
var $4268b02e68a9196d$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $4268b02e68a9196d$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $4268b02e68a9196d$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $4268b02e68a9196d$var$__defNormalProp = (obj, key, value)=>key in obj ? $4268b02e68a9196d$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $4268b02e68a9196d$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($4268b02e68a9196d$var$__hasOwnProp.call(b, prop)) $4268b02e68a9196d$var$__defNormalProp(a, prop, b[prop]);
    if ($4268b02e68a9196d$var$__getOwnPropSymbols) {
        for (var prop of $4268b02e68a9196d$var$__getOwnPropSymbols(b))if ($4268b02e68a9196d$var$__propIsEnum.call(b, prop)) $4268b02e68a9196d$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $4268b02e68a9196d$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($4268b02e68a9196d$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $4268b02e68a9196d$var$__getOwnPropSymbols) {
        for (var prop of $4268b02e68a9196d$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $4268b02e68a9196d$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
function $4268b02e68a9196d$export$6bf5487406289ae({ icon: icon, name: name, action: action, type: type }) {
    const defaultProps = {
        icon: icon
    };
    const Component = (0, $acw62.forwardRef)((props, ref)=>{
        const _a = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)(name, defaultProps, props), { icon: _icon } = _a, others = $4268b02e68a9196d$var$__objRest(_a, [
            "icon"
        ]);
        const Icon = _icon;
        const ctx = (0, $33075221da238fe6$export$983fe576d9f212b7)();
        const disabled = type === "next" ? ctx.active === ctx.total : ctx.active === 1;
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $18dc76bfac9cb274$export$a4805060b1c76e2b), $4268b02e68a9196d$var$__spreadValues({
            disabled: ctx.disabled || disabled,
            ref: ref,
            onClick: ctx[action],
            withPadding: false
        }, others), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
            style: {
                width: "calc(var(--pagination-control-size) / 1.8)",
                height: "calc(var(--pagination-control-size) / 1.8)"
            }
        }));
    });
    Component.displayName = `@mantine/core/${name}`;
    return (0, $1a5a3b9a879562b6$export$639b89ea563ec697)(Component);
}
const $4268b02e68a9196d$export$ef9c8bfc54489a24 = $4268b02e68a9196d$export$6bf5487406289ae({
    icon: (0, $16f38961ccff8e5c$export$dc180090659eda71),
    name: "PaginationNext",
    action: "onNext",
    type: "next"
});
const $4268b02e68a9196d$export$c38bddd65ea050e7 = $4268b02e68a9196d$export$6bf5487406289ae({
    icon: (0, $16f38961ccff8e5c$export$102e17a9fcf2c2c),
    name: "PaginationPrevious",
    action: "onPrevious",
    type: "previous"
});
const $4268b02e68a9196d$export$18f2b758cbe6b49c = $4268b02e68a9196d$export$6bf5487406289ae({
    icon: (0, $16f38961ccff8e5c$export$331f74485dba16cc),
    name: "PaginationFirst",
    action: "onFirst",
    type: "previous"
});
const $4268b02e68a9196d$export$daefe00f54b15eb4 = $4268b02e68a9196d$export$6bf5487406289ae({
    icon: (0, $16f38961ccff8e5c$export$5a55abde184ff64f),
    name: "PaginationLast",
    action: "onLast",
    type: "next"
});



var $acw62 = parcelRequire("acw62");



"use client";
var $937f5bbcb684738a$var$__defProp = Object.defineProperty;
var $937f5bbcb684738a$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $937f5bbcb684738a$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $937f5bbcb684738a$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $937f5bbcb684738a$var$__defNormalProp = (obj, key, value)=>key in obj ? $937f5bbcb684738a$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $937f5bbcb684738a$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($937f5bbcb684738a$var$__hasOwnProp.call(b, prop)) $937f5bbcb684738a$var$__defNormalProp(a, prop, b[prop]);
    if ($937f5bbcb684738a$var$__getOwnPropSymbols) {
        for (var prop of $937f5bbcb684738a$var$__getOwnPropSymbols(b))if ($937f5bbcb684738a$var$__propIsEnum.call(b, prop)) $937f5bbcb684738a$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
function $937f5bbcb684738a$export$8a33b1b6de270dde({ dotsIcon: dotsIcon }) {
    const ctx = (0, $33075221da238fe6$export$983fe576d9f212b7)();
    const items = ctx.range.map((page, index)=>{
        var _a;
        if (page === "dots") return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c7e8d4105784bd6a$export$fec1f421a303d41), {
            icon: dotsIcon,
            key: index
        });
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $18dc76bfac9cb274$export$a4805060b1c76e2b), $937f5bbcb684738a$var$__spreadValues({
            key: index,
            active: page === ctx.active,
            "aria-current": page === ctx.active ? "page" : void 0,
            onClick: ()=>ctx.onChange(page),
            disabled: ctx.disabled
        }, (_a = ctx.getItemProps) == null ? void 0 : _a.call(ctx, page)), page);
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, items);
}
$937f5bbcb684738a$export$8a33b1b6de270dde.displayName = "@mantine/core/PaginationItems";





"use client";
var $60b13507c53218f5$var$__defProp = Object.defineProperty;
var $60b13507c53218f5$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $60b13507c53218f5$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $60b13507c53218f5$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $60b13507c53218f5$var$__defNormalProp = (obj, key, value)=>key in obj ? $60b13507c53218f5$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $60b13507c53218f5$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($60b13507c53218f5$var$__hasOwnProp.call(b, prop)) $60b13507c53218f5$var$__defNormalProp(a, prop, b[prop]);
    if ($60b13507c53218f5$var$__getOwnPropSymbols) {
        for (var prop of $60b13507c53218f5$var$__getOwnPropSymbols(b))if ($60b13507c53218f5$var$__propIsEnum.call(b, prop)) $60b13507c53218f5$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $60b13507c53218f5$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($60b13507c53218f5$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $60b13507c53218f5$var$__getOwnPropSymbols) {
        for (var prop of $60b13507c53218f5$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $60b13507c53218f5$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $60b13507c53218f5$var$defaultProps = {
    withControls: true,
    siblings: 1,
    boundaries: 1,
    gap: 8
};
const $60b13507c53218f5$export$68f5e1453c188a82 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("Pagination", $60b13507c53218f5$var$defaultProps, _props);
    const _a = props, { withEdges: withEdges, withControls: withControls, getControlProps: getControlProps, nextIcon: nextIcon, previousIcon: previousIcon, lastIcon: lastIcon, firstIcon: firstIcon, dotsIcon: dotsIcon, total: total, gap: gap } = _a, others = $60b13507c53218f5$var$__objRest(_a, [
        "withEdges",
        "withControls",
        "getControlProps",
        "nextIcon",
        "previousIcon",
        "lastIcon",
        "firstIcon",
        "dotsIcon",
        "total",
        "gap"
    ]);
    if (total <= 0) return null;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6a720fa90a51f2dc$export$9254240822e521a5), $60b13507c53218f5$var$__spreadValues({
        ref: ref,
        total: total
    }, others), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4), {
        gap: gap
    }, withEdges && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4268b02e68a9196d$export$18f2b758cbe6b49c), $60b13507c53218f5$var$__spreadValues({
        icon: firstIcon
    }, getControlProps == null ? void 0 : getControlProps("first"))), withControls && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4268b02e68a9196d$export$c38bddd65ea050e7), $60b13507c53218f5$var$__spreadValues({
        icon: previousIcon
    }, getControlProps == null ? void 0 : getControlProps("previous"))), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $937f5bbcb684738a$export$8a33b1b6de270dde), {
        dotsIcon: dotsIcon
    }), withControls && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4268b02e68a9196d$export$ef9c8bfc54489a24), $60b13507c53218f5$var$__spreadValues({
        icon: nextIcon
    }, getControlProps == null ? void 0 : getControlProps("next"))), withEdges && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4268b02e68a9196d$export$daefe00f54b15eb4), $60b13507c53218f5$var$__spreadValues({
        icon: lastIcon
    }, getControlProps == null ? void 0 : getControlProps("last")))));
});
$60b13507c53218f5$export$68f5e1453c188a82.classes = (0, $1aee5de5663562ea$export$2e2bcd8739ae039);
$60b13507c53218f5$export$68f5e1453c188a82.displayName = "@mantine/core/Pagination";
$60b13507c53218f5$export$68f5e1453c188a82.Root = (0, $6a720fa90a51f2dc$export$9254240822e521a5);
$60b13507c53218f5$export$68f5e1453c188a82.Control = (0, $18dc76bfac9cb274$export$a4805060b1c76e2b);
$60b13507c53218f5$export$68f5e1453c188a82.Dots = (0, $c7e8d4105784bd6a$export$fec1f421a303d41);
$60b13507c53218f5$export$68f5e1453c188a82.First = (0, $4268b02e68a9196d$export$18f2b758cbe6b49c);
$60b13507c53218f5$export$68f5e1453c188a82.Last = (0, $4268b02e68a9196d$export$daefe00f54b15eb4);
$60b13507c53218f5$export$68f5e1453c188a82.Next = (0, $4268b02e68a9196d$export$ef9c8bfc54489a24);
$60b13507c53218f5$export$68f5e1453c188a82.Previous = (0, $4268b02e68a9196d$export$c38bddd65ea050e7);
$60b13507c53218f5$export$68f5e1453c188a82.Items = (0, $937f5bbcb684738a$export$8a33b1b6de270dde);



var $acw62 = parcelRequire("acw62");

var $5dc7470435fa9407$exports = {};
$5dc7470435fa9407$exports = new URL("discovery_prompt_has_interests.bd395f15.svg", import.meta.url).toString();


var $d5e4bba30610058b$exports = {};
$d5e4bba30610058b$exports = new URL("discovery_prompt_no_interests.2c39a848.svg", import.meta.url).toString();



var $acw62 = parcelRequire("acw62");

"use client";
var $b07e501f9fd3f876$var$classes = {
    "root": "m-849cf0da"
};
var $b07e501f9fd3f876$export$2e2bcd8739ae039 = $b07e501f9fd3f876$var$classes;





"use client";
var $7f444f4382bb0812$var$__defProp = Object.defineProperty;
var $7f444f4382bb0812$var$__defProps = Object.defineProperties;
var $7f444f4382bb0812$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $7f444f4382bb0812$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $7f444f4382bb0812$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $7f444f4382bb0812$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $7f444f4382bb0812$var$__defNormalProp = (obj, key, value)=>key in obj ? $7f444f4382bb0812$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $7f444f4382bb0812$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($7f444f4382bb0812$var$__hasOwnProp.call(b, prop)) $7f444f4382bb0812$var$__defNormalProp(a, prop, b[prop]);
    if ($7f444f4382bb0812$var$__getOwnPropSymbols) {
        for (var prop of $7f444f4382bb0812$var$__getOwnPropSymbols(b))if ($7f444f4382bb0812$var$__propIsEnum.call(b, prop)) $7f444f4382bb0812$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $7f444f4382bb0812$var$__spreadProps = (a, b)=>$7f444f4382bb0812$var$__defProps(a, $7f444f4382bb0812$var$__getOwnPropDescs(b));
var $7f444f4382bb0812$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($7f444f4382bb0812$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $7f444f4382bb0812$var$__getOwnPropSymbols) {
        for (var prop of $7f444f4382bb0812$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $7f444f4382bb0812$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $7f444f4382bb0812$var$defaultProps = {
    underline: "hover"
};
const $7f444f4382bb0812$export$b688253958b8dfe7 = (0, $dfead8eb7283bc39$export$197bdd704df40a29)((props, ref)=>{
    const _a = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("Anchor", $7f444f4382bb0812$var$defaultProps, props), { underline: underline, className: className, unstyled: unstyled } = _a, others = $7f444f4382bb0812$var$__objRest(_a, [
        "underline",
        "className",
        "unstyled"
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), $7f444f4382bb0812$var$__spreadProps($7f444f4382bb0812$var$__spreadValues({
        component: "a",
        ref: ref,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)({
            [(0, $b07e501f9fd3f876$export$2e2bcd8739ae039).root]: !unstyled
        }, className)
    }, others), {
        mod: {
            underline: underline
        },
        __staticSelector: "Anchor",
        unstyled: unstyled
    }));
});
$7f444f4382bb0812$export$b688253958b8dfe7.classes = (0, $b07e501f9fd3f876$export$2e2bcd8739ae039);
$7f444f4382bb0812$export$b688253958b8dfe7.displayName = "@mantine/core/Anchor";


var $acw62 = parcelRequire("acw62");
"use client";
var $1e5b0ce4792a9c4d$var$classes = {
    "root": "m-ddec01c0",
    "icon": "m-dde7bd57",
    "cite": "m-dde51a35"
};
var $1e5b0ce4792a9c4d$export$2e2bcd8739ae039 = $1e5b0ce4792a9c4d$var$classes;












"use client";
var $89f662fb61bfd50a$var$__defProp = Object.defineProperty;
var $89f662fb61bfd50a$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $89f662fb61bfd50a$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $89f662fb61bfd50a$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $89f662fb61bfd50a$var$__defNormalProp = (obj, key, value)=>key in obj ? $89f662fb61bfd50a$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $89f662fb61bfd50a$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($89f662fb61bfd50a$var$__hasOwnProp.call(b, prop)) $89f662fb61bfd50a$var$__defNormalProp(a, prop, b[prop]);
    if ($89f662fb61bfd50a$var$__getOwnPropSymbols) {
        for (var prop of $89f662fb61bfd50a$var$__getOwnPropSymbols(b))if ($89f662fb61bfd50a$var$__propIsEnum.call(b, prop)) $89f662fb61bfd50a$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $89f662fb61bfd50a$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($89f662fb61bfd50a$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $89f662fb61bfd50a$var$__getOwnPropSymbols) {
        for (var prop of $89f662fb61bfd50a$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $89f662fb61bfd50a$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $89f662fb61bfd50a$var$defaultProps = {
    iconSize: 48
};
const $89f662fb61bfd50a$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((theme, { color: color, iconSize: iconSize, radius: radius })=>{
    const darkParsed = (0, $33a822173b5f4b0f$export$83e0a426d2da8ac1)({
        color: color || theme.primaryColor,
        theme: theme,
        colorScheme: "dark"
    });
    const lightParsed = (0, $33a822173b5f4b0f$export$83e0a426d2da8ac1)({
        color: color || theme.primaryColor,
        theme: theme,
        colorScheme: "light"
    });
    return {
        root: {
            "--bq-bg-light": (0, $a29d51c1f7df5c7c$export$4e46ac54fc82cf3b)(lightParsed.value, 0.07),
            "--bq-bg-dark": (0, $a29d51c1f7df5c7c$export$4e46ac54fc82cf3b)(darkParsed.value, 0.06),
            "--bq-bd": (0, $0a9c57cec2a3e373$export$e22c5d06d177c3fa)(color, theme),
            "--bq-icon-size": (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(iconSize),
            "--bq-radius": (0, $fcab4af601ce7e99$export$35724d9c2979edc5)(radius)
        }
    };
});
const $89f662fb61bfd50a$export$29a7a275fe11687 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("Blockquote", $89f662fb61bfd50a$var$defaultProps, _props);
    const _a = props, { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, children: children, icon: icon, iconSize: iconSize, cite: cite } = _a, others = $89f662fb61bfd50a$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "children",
        "icon",
        "iconSize",
        "cite"
    ]);
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: "Blockquote",
        classes: $1e5b0ce4792a9c4d$export$2e2bcd8739ae039,
        props: props,
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        vars: vars,
        varsResolver: $89f662fb61bfd50a$var$varsResolver
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $89f662fb61bfd50a$var$__spreadValues($89f662fb61bfd50a$var$__spreadValues({
        component: "blockquote",
        ref: ref
    }, getStyles("root")), others), icon && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", $89f662fb61bfd50a$var$__spreadValues({}, getStyles("icon")), icon), children, cite && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("cite", $89f662fb61bfd50a$var$__spreadValues({}, getStyles("cite")), cite));
});
$89f662fb61bfd50a$export$29a7a275fe11687.classes = (0, $1e5b0ce4792a9c4d$export$2e2bcd8739ae039);
$89f662fb61bfd50a$export$29a7a275fe11687.displayName = "@mantine/core/Blockquote";


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

"use client";
const [$662d803739139aa1$export$4aacc92b34f48449, $662d803739139aa1$export$c1f1c27d8fe70f39] = (0, $0bf9cc213b4abd2e$export$97d0e477aacf9b7d)("Card component was not found in tree");


"use client";
var $c52e0fbc7e25ef70$var$classes = {
    "root": "m-e615b15f",
    "section": "m-599a2148"
};
var $c52e0fbc7e25ef70$export$2e2bcd8739ae039 = $c52e0fbc7e25ef70$var$classes;





"use client";
var $c6e87138a0ac44ca$var$__defProp = Object.defineProperty;
var $c6e87138a0ac44ca$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $c6e87138a0ac44ca$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $c6e87138a0ac44ca$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $c6e87138a0ac44ca$var$__defNormalProp = (obj, key, value)=>key in obj ? $c6e87138a0ac44ca$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $c6e87138a0ac44ca$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($c6e87138a0ac44ca$var$__hasOwnProp.call(b, prop)) $c6e87138a0ac44ca$var$__defNormalProp(a, prop, b[prop]);
    if ($c6e87138a0ac44ca$var$__getOwnPropSymbols) {
        for (var prop of $c6e87138a0ac44ca$var$__getOwnPropSymbols(b))if ($c6e87138a0ac44ca$var$__propIsEnum.call(b, prop)) $c6e87138a0ac44ca$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $c6e87138a0ac44ca$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($c6e87138a0ac44ca$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $c6e87138a0ac44ca$var$__getOwnPropSymbols) {
        for (var prop of $c6e87138a0ac44ca$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $c6e87138a0ac44ca$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $c6e87138a0ac44ca$var$defaultProps = {};
const $c6e87138a0ac44ca$export$408776bb88ffa78b = (0, $dfead8eb7283bc39$export$197bdd704df40a29)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("CardSection", $c6e87138a0ac44ca$var$defaultProps, _props);
    const _a = props, { classNames: classNames, className: className, style: style, styles: styles, vars: vars, withBorder: withBorder, inheritPadding: inheritPadding } = _a, others = $c6e87138a0ac44ca$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars",
        "withBorder",
        "inheritPadding"
    ]);
    const ctx = (0, $662d803739139aa1$export$c1f1c27d8fe70f39)();
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $c6e87138a0ac44ca$var$__spreadValues($c6e87138a0ac44ca$var$__spreadValues({
        ref: ref,
        mod: {
            "with-border": withBorder,
            "inherit-padding": inheritPadding
        }
    }, ctx.getStyles("section", {
        className: className,
        style: style,
        styles: styles,
        classNames: classNames
    })), others));
});
$c6e87138a0ac44ca$export$408776bb88ffa78b.classes = (0, $c52e0fbc7e25ef70$export$2e2bcd8739ae039);
$c6e87138a0ac44ca$export$408776bb88ffa78b.displayName = "@mantine/core/CardSection";





var $acw62 = parcelRequire("acw62");
"use client";
var $227c9ef646c028c4$var$classes = {
    "root": "m-1b7284a3"
};
var $227c9ef646c028c4$export$2e2bcd8739ae039 = $227c9ef646c028c4$var$classes;








"use client";
var $f9eedd3a1a3486ca$var$__defProp = Object.defineProperty;
var $f9eedd3a1a3486ca$var$__defProps = Object.defineProperties;
var $f9eedd3a1a3486ca$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $f9eedd3a1a3486ca$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $f9eedd3a1a3486ca$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $f9eedd3a1a3486ca$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $f9eedd3a1a3486ca$var$__defNormalProp = (obj, key, value)=>key in obj ? $f9eedd3a1a3486ca$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $f9eedd3a1a3486ca$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($f9eedd3a1a3486ca$var$__hasOwnProp.call(b, prop)) $f9eedd3a1a3486ca$var$__defNormalProp(a, prop, b[prop]);
    if ($f9eedd3a1a3486ca$var$__getOwnPropSymbols) {
        for (var prop of $f9eedd3a1a3486ca$var$__getOwnPropSymbols(b))if ($f9eedd3a1a3486ca$var$__propIsEnum.call(b, prop)) $f9eedd3a1a3486ca$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $f9eedd3a1a3486ca$var$__spreadProps = (a, b)=>$f9eedd3a1a3486ca$var$__defProps(a, $f9eedd3a1a3486ca$var$__getOwnPropDescs(b));
var $f9eedd3a1a3486ca$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($f9eedd3a1a3486ca$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $f9eedd3a1a3486ca$var$__getOwnPropSymbols) {
        for (var prop of $f9eedd3a1a3486ca$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $f9eedd3a1a3486ca$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $f9eedd3a1a3486ca$var$defaultProps = {};
const $f9eedd3a1a3486ca$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((_, { radius: radius, shadow: shadow })=>({
        root: {
            "--paper-radius": radius === void 0 ? void 0 : (0, $fcab4af601ce7e99$export$35724d9c2979edc5)(radius),
            "--paper-shadow": (0, $fcab4af601ce7e99$export$db93b77dbb14f011)(shadow)
        }
    }));
const $f9eedd3a1a3486ca$export$e01703dff029898a = (0, $dfead8eb7283bc39$export$197bdd704df40a29)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("Paper", $f9eedd3a1a3486ca$var$defaultProps, _props);
    const _a = props, { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, withBorder: withBorder, vars: vars, radius: radius, shadow: shadow, variant: variant } = _a, others = $f9eedd3a1a3486ca$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "withBorder",
        "vars",
        "radius",
        "shadow",
        "variant"
    ]);
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: "Paper",
        props: props,
        classes: $227c9ef646c028c4$export$2e2bcd8739ae039,
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        vars: vars,
        varsResolver: $f9eedd3a1a3486ca$var$varsResolver
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $f9eedd3a1a3486ca$var$__spreadValues($f9eedd3a1a3486ca$var$__spreadProps($f9eedd3a1a3486ca$var$__spreadValues({
        ref: ref,
        mod: {
            "data-with-border": withBorder
        }
    }, getStyles("root")), {
        variant: variant
    }), others));
});
$f9eedd3a1a3486ca$export$e01703dff029898a.classes = (0, $227c9ef646c028c4$export$2e2bcd8739ae039);
$f9eedd3a1a3486ca$export$e01703dff029898a.displayName = "@mantine/core/Paper";







"use client";
var $3e91b7d399f248d1$var$__defProp = Object.defineProperty;
var $3e91b7d399f248d1$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $3e91b7d399f248d1$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $3e91b7d399f248d1$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $3e91b7d399f248d1$var$__defNormalProp = (obj, key, value)=>key in obj ? $3e91b7d399f248d1$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $3e91b7d399f248d1$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($3e91b7d399f248d1$var$__hasOwnProp.call(b, prop)) $3e91b7d399f248d1$var$__defNormalProp(a, prop, b[prop]);
    if ($3e91b7d399f248d1$var$__getOwnPropSymbols) {
        for (var prop of $3e91b7d399f248d1$var$__getOwnPropSymbols(b))if ($3e91b7d399f248d1$var$__propIsEnum.call(b, prop)) $3e91b7d399f248d1$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $3e91b7d399f248d1$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($3e91b7d399f248d1$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $3e91b7d399f248d1$var$__getOwnPropSymbols) {
        for (var prop of $3e91b7d399f248d1$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $3e91b7d399f248d1$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $3e91b7d399f248d1$var$defaultProps = {};
const $3e91b7d399f248d1$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((_, { padding: padding })=>({
        root: {
            "--card-padding": (0, $fcab4af601ce7e99$export$f63796f8a9382bfb)(padding)
        }
    }));
const $3e91b7d399f248d1$export$60332b2344f7fe41 = (0, $dfead8eb7283bc39$export$197bdd704df40a29)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("Card", $3e91b7d399f248d1$var$defaultProps, _props);
    const _a = props, { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, children: children, padding: padding } = _a, others = $3e91b7d399f248d1$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "children",
        "padding"
    ]);
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: "Card",
        props: props,
        classes: $c52e0fbc7e25ef70$export$2e2bcd8739ae039,
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        vars: vars,
        varsResolver: $3e91b7d399f248d1$var$varsResolver
    });
    const _children = (0, $acw62.Children).toArray(children);
    const content = _children.map((child, index)=>{
        if (typeof child === "object" && child && "type" in child && child.type === (0, $c6e87138a0ac44ca$export$408776bb88ffa78b)) return (0, $acw62.cloneElement)(child, {
            "data-first-section": index === 0 || void 0,
            "data-last-section": index === _children.length - 1 || void 0
        });
        return child;
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $662d803739139aa1$export$4aacc92b34f48449), {
        value: {
            getStyles: getStyles
        }
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f9eedd3a1a3486ca$export$e01703dff029898a), $3e91b7d399f248d1$var$__spreadValues($3e91b7d399f248d1$var$__spreadValues({
        ref: ref,
        unstyled: unstyled
    }, getStyles("root")), others), content));
});
$3e91b7d399f248d1$export$60332b2344f7fe41.classes = (0, $c52e0fbc7e25ef70$export$2e2bcd8739ae039);
$3e91b7d399f248d1$export$60332b2344f7fe41.displayName = "@mantine/core/Card";
$3e91b7d399f248d1$export$60332b2344f7fe41.Section = (0, $c6e87138a0ac44ca$export$408776bb88ffa78b);


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

"use client";
const [$721b1134772bf440$export$9b0a72e5d41d62ec, $721b1134772bf440$export$b11084dc21db9fa4] = (0, $0bf9cc213b4abd2e$export$97d0e477aacf9b7d)("List component was not found in tree");


"use client";
var $c90c8251db4f64af$var$classes = {
    "root": "m-abbac491",
    "item": "m-abb6bec2",
    "itemWrapper": "m-75cd9f71",
    "itemIcon": "m-60f83e5b"
};
var $c90c8251db4f64af$export$2e2bcd8739ae039 = $c90c8251db4f64af$var$classes;





"use client";
var $3ce466757a1a01b4$var$__defProp = Object.defineProperty;
var $3ce466757a1a01b4$var$__defProps = Object.defineProperties;
var $3ce466757a1a01b4$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $3ce466757a1a01b4$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $3ce466757a1a01b4$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $3ce466757a1a01b4$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $3ce466757a1a01b4$var$__defNormalProp = (obj, key, value)=>key in obj ? $3ce466757a1a01b4$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $3ce466757a1a01b4$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($3ce466757a1a01b4$var$__hasOwnProp.call(b, prop)) $3ce466757a1a01b4$var$__defNormalProp(a, prop, b[prop]);
    if ($3ce466757a1a01b4$var$__getOwnPropSymbols) {
        for (var prop of $3ce466757a1a01b4$var$__getOwnPropSymbols(b))if ($3ce466757a1a01b4$var$__propIsEnum.call(b, prop)) $3ce466757a1a01b4$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $3ce466757a1a01b4$var$__spreadProps = (a, b)=>$3ce466757a1a01b4$var$__defProps(a, $3ce466757a1a01b4$var$__getOwnPropDescs(b));
var $3ce466757a1a01b4$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($3ce466757a1a01b4$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $3ce466757a1a01b4$var$__getOwnPropSymbols) {
        for (var prop of $3ce466757a1a01b4$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $3ce466757a1a01b4$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $3ce466757a1a01b4$var$defaultProps = {};
const $3ce466757a1a01b4$export$a7b06bfba60a8a78 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("ListItem", $3ce466757a1a01b4$var$defaultProps, _props);
    const _a = props, { classNames: classNames, className: className, style: style, styles: styles, vars: vars, icon: icon, children: children } = _a, others = $3ce466757a1a01b4$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars",
        "icon",
        "children"
    ]);
    const ctx = (0, $721b1134772bf440$export$b11084dc21db9fa4)();
    const _icon = icon || ctx.icon;
    const stylesApiProps = {
        classNames: classNames,
        styles: styles
    };
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $3ce466757a1a01b4$var$__spreadValues($3ce466757a1a01b4$var$__spreadProps($3ce466757a1a01b4$var$__spreadValues({}, ctx.getStyles("item", $3ce466757a1a01b4$var$__spreadProps($3ce466757a1a01b4$var$__spreadValues({}, stylesApiProps), {
        className: className,
        style: style
    }))), {
        component: "li",
        mod: {
            "with-icon": !!_icon,
            centered: ctx.center
        },
        ref: ref
    }), others), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $3ce466757a1a01b4$var$__spreadValues({}, ctx.getStyles("itemWrapper", stylesApiProps)), _icon && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", $3ce466757a1a01b4$var$__spreadValues({}, ctx.getStyles("itemIcon", stylesApiProps)), _icon), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", $3ce466757a1a01b4$var$__spreadValues({}, ctx.getStyles("itemLabel", stylesApiProps)), children)));
});
$3ce466757a1a01b4$export$a7b06bfba60a8a78.classes = (0, $c90c8251db4f64af$export$2e2bcd8739ae039);
$3ce466757a1a01b4$export$a7b06bfba60a8a78.displayName = "@mantine/core/ListItem";










"use client";
var $6a4218ccdfc87c17$var$__defProp = Object.defineProperty;
var $6a4218ccdfc87c17$var$__defProps = Object.defineProperties;
var $6a4218ccdfc87c17$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $6a4218ccdfc87c17$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $6a4218ccdfc87c17$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $6a4218ccdfc87c17$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $6a4218ccdfc87c17$var$__defNormalProp = (obj, key, value)=>key in obj ? $6a4218ccdfc87c17$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $6a4218ccdfc87c17$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($6a4218ccdfc87c17$var$__hasOwnProp.call(b, prop)) $6a4218ccdfc87c17$var$__defNormalProp(a, prop, b[prop]);
    if ($6a4218ccdfc87c17$var$__getOwnPropSymbols) {
        for (var prop of $6a4218ccdfc87c17$var$__getOwnPropSymbols(b))if ($6a4218ccdfc87c17$var$__propIsEnum.call(b, prop)) $6a4218ccdfc87c17$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $6a4218ccdfc87c17$var$__spreadProps = (a, b)=>$6a4218ccdfc87c17$var$__defProps(a, $6a4218ccdfc87c17$var$__getOwnPropDescs(b));
var $6a4218ccdfc87c17$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($6a4218ccdfc87c17$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $6a4218ccdfc87c17$var$__getOwnPropSymbols) {
        for (var prop of $6a4218ccdfc87c17$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $6a4218ccdfc87c17$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $6a4218ccdfc87c17$var$defaultProps = {
    type: "unordered"
};
const $6a4218ccdfc87c17$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((_, { size: size, spacing: spacing })=>({
        root: {
            "--list-fz": (0, $fcab4af601ce7e99$export$7d055c252aebca58)(size),
            "--list-lh": (0, $fcab4af601ce7e99$export$56204a27a2958a55)(size),
            "--list-spacing": (0, $fcab4af601ce7e99$export$f63796f8a9382bfb)(spacing)
        }
    }));
const $6a4218ccdfc87c17$export$54c2e3dc7acea9f5 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("List", $6a4218ccdfc87c17$var$defaultProps, _props);
    const _a = props, { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, children: children, type: type, withPadding: withPadding, icon: icon, spacing: spacing, center: center, listStyleType: listStyleType } = _a, others = $6a4218ccdfc87c17$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "children",
        "type",
        "withPadding",
        "icon",
        "spacing",
        "center",
        "listStyleType"
    ]);
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: "List",
        classes: $c90c8251db4f64af$export$2e2bcd8739ae039,
        props: props,
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        vars: vars,
        varsResolver: $6a4218ccdfc87c17$var$varsResolver
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $721b1134772bf440$export$9b0a72e5d41d62ec), {
        value: {
            center: center,
            icon: icon,
            getStyles: getStyles
        }
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $6a4218ccdfc87c17$var$__spreadValues($6a4218ccdfc87c17$var$__spreadProps($6a4218ccdfc87c17$var$__spreadValues({}, getStyles("root", {
        style: {
            listStyleType: listStyleType
        }
    })), {
        component: type === "unordered" ? "ul" : "ol",
        mod: {
            "with-padding": withPadding
        },
        ref: ref
    }), others), children));
});
$6a4218ccdfc87c17$export$54c2e3dc7acea9f5.classes = (0, $c90c8251db4f64af$export$2e2bcd8739ae039);
$6a4218ccdfc87c17$export$54c2e3dc7acea9f5.displayName = "@mantine/core/List";
$6a4218ccdfc87c17$export$54c2e3dc7acea9f5.Item = (0, $3ce466757a1a01b4$export$a7b06bfba60a8a78);


parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
"use client";
var $b3f0be63582d4bcd$var$classes = {
    "root": "m-347db0ec",
    "root--dot": "m-fbd81e3d",
    "label": "m-5add502a",
    "section": "m-91fdda9b"
};
var $b3f0be63582d4bcd$export$2e2bcd8739ae039 = $b3f0be63582d4bcd$var$classes;









"use client";
var $b24692670674b261$var$__defProp = Object.defineProperty;
var $b24692670674b261$var$__defProps = Object.defineProperties;
var $b24692670674b261$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $b24692670674b261$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $b24692670674b261$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $b24692670674b261$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $b24692670674b261$var$__defNormalProp = (obj, key, value)=>key in obj ? $b24692670674b261$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $b24692670674b261$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($b24692670674b261$var$__hasOwnProp.call(b, prop)) $b24692670674b261$var$__defNormalProp(a, prop, b[prop]);
    if ($b24692670674b261$var$__getOwnPropSymbols) {
        for (var prop of $b24692670674b261$var$__getOwnPropSymbols(b))if ($b24692670674b261$var$__propIsEnum.call(b, prop)) $b24692670674b261$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $b24692670674b261$var$__spreadProps = (a, b)=>$b24692670674b261$var$__defProps(a, $b24692670674b261$var$__getOwnPropDescs(b));
var $b24692670674b261$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($b24692670674b261$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $b24692670674b261$var$__getOwnPropSymbols) {
        for (var prop of $b24692670674b261$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $b24692670674b261$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $b24692670674b261$var$defaultProps = {};
const $b24692670674b261$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((theme, { radius: radius, color: color, gradient: gradient, variant: variant, size: size })=>{
    const colors = theme.variantColorResolver({
        color: color || theme.primaryColor,
        theme: theme,
        gradient: gradient,
        variant: variant || "filled"
    });
    return {
        root: {
            "--badge-height": (0, $fcab4af601ce7e99$export$31b21d0167753bb4)(size, "badge-height"),
            "--badge-padding-x": (0, $fcab4af601ce7e99$export$31b21d0167753bb4)(size, "badge-padding-x"),
            "--badge-fz": (0, $fcab4af601ce7e99$export$31b21d0167753bb4)(size, "badge-fz"),
            "--badge-radius": radius === void 0 ? void 0 : (0, $fcab4af601ce7e99$export$35724d9c2979edc5)(radius),
            "--badge-bg": color || variant ? colors.background : void 0,
            "--badge-color": color || variant ? colors.color : void 0,
            "--badge-bd": color || variant ? colors.border : void 0,
            "--badge-dot-color": variant === "dot" ? (0, $0a9c57cec2a3e373$export$e22c5d06d177c3fa)(color, theme) : void 0
        }
    };
});
const $b24692670674b261$export$37acb3580601e69a = (0, $dfead8eb7283bc39$export$197bdd704df40a29)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("Badge", $b24692670674b261$var$defaultProps, _props);
    const _a = props, { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, radius: radius, color: color, gradient: gradient, leftSection: leftSection, rightSection: rightSection, children: children, variant: variant, fullWidth: fullWidth } = _a, others = $b24692670674b261$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "radius",
        "color",
        "gradient",
        "leftSection",
        "rightSection",
        "children",
        "variant",
        "fullWidth"
    ]);
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: "Badge",
        props: props,
        classes: $b3f0be63582d4bcd$export$2e2bcd8739ae039,
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        vars: vars,
        varsResolver: $b24692670674b261$var$varsResolver
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $b24692670674b261$var$__spreadValues($b24692670674b261$var$__spreadProps($b24692670674b261$var$__spreadValues({
        variant: variant,
        mod: {
            block: fullWidth
        }
    }, getStyles("root", {
        variant: variant
    })), {
        ref: ref
    }), others), leftSection && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", $b24692670674b261$var$__spreadProps($b24692670674b261$var$__spreadValues({}, getStyles("section")), {
        "data-position": "left"
    }), leftSection), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", $b24692670674b261$var$__spreadValues({}, getStyles("label")), children), rightSection && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", $b24692670674b261$var$__spreadProps($b24692670674b261$var$__spreadValues({}, getStyles("section")), {
        "data-position": "right"
    }), rightSection));
});
$b24692670674b261$export$37acb3580601e69a.classes = (0, $b3f0be63582d4bcd$export$2e2bcd8739ae039);
$b24692670674b261$export$37acb3580601e69a.displayName = "@mantine/core/Badge";


/**
 * @tabler/icons-react v2.42.0 - MIT
 */ 
var $a142b354016863b4$export$2e2bcd8739ae039 = (0, $a86819fe50d185cb$export$2e2bcd8739ae039)("x", "IconX", [
    [
        "path",
        {
            d: "M18 6l-12 12",
            key: "svg-0"
        }
    ],
    [
        "path",
        {
            d: "M6 6l12 12",
            key: "svg-1"
        }
    ]
]);


parcelRequire("acw62");
const $7db4b5652a829202$export$bca14c5b3b88a9c9 = {
    colors: {
        blue: {
            1: "#A5D8FF",
            2: "#4DABF7",
            3: "#339AF0",
            4: "#228BE6",
            5: "#1C7ED6"
        },
        red: {
            1: "#FF8787",
            2: "#FA5252",
            3: "#F03E3E",
            4: "#E03131",
            5: "#C92A2A"
        },
        gray: {
            1: "#CED4DA",
            2: "#ADB5BD",
            3: "#868E96",
            4: "#828282",
            5: "#495057",
            6: "#343A40"
        },
        black: {
            1: "#212529"
        },
        purple: {
            1: "#9775FA",
            2: "#845EF7",
            3: "#7048E8"
        }
    },
    padding: {
        xs: "4px",
        sm: "8px",
        md: "12px",
        lg: "16px",
        xl: "32px",
        xxl: "64px"
    }
}; /*
Blue:
    - blue[3] for labels (Discovery, Sidebar etc)
    - blue[4] for buttons (plus, chat, etc) and tags to maintain continuity

Red:
    - red[4] for buttons (incomplete)
*/ 


var $7b02d682eb115277$exports = {};
"use strict";

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));


const $33ecc2b042884c60$var$TagList = ({ baseTags: baseTags = [], activeTopics: activeTopics = [], setActiveTopics: setActiveTopics, headerTags: headerTags = false, defaultOutline: defaultOutline = false, removableHint: removableHint = false, large: large = false, clickable: clickable = false, tagColor: tagColor = "", tagType: tagType = "", removeTag: removeTag })=>{
    const handleTagClick = (tag)=>{
        if (!setActiveTopics) return;
        if (activeTopics.includes(tag)) removeTag(tag, tagType);
        else setActiveTopics([
            ...activeTopics,
            tag
        ]);
    };
    const calculateBadgeVariant = (tag)=>{
        if (large || defaultOutline) return "light";
        return activeTopics.includes(tag) ? "filled" : "outline";
    };
    const renderXIcon = ()=>{
        if (headerTags || removableHint) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a142b354016863b4$export$2e2bcd8739ae039), {
            style: {
                marginLeft: "0.5rem"
            },
            size: 16
        });
        return null;
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4e00d137aa7b325a$export$f51f4c4ede09e011), {
        justify: "between",
        align: "center",
        wrap: "wrap",
        children: baseTags.map((tag, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b24692670674b261$export$37acb3580601e69a), {
                    ml: "0",
                    mr: "sm",
                    variant: calculateBadgeVariant(tag),
                    onClick: ()=>handleTagClick(tag),
                    style: {
                        cursor: clickable ? "pointer" : "text"
                    },
                    color: tagColor,
                    p: large ? (0, $7db4b5652a829202$export$bca14c5b3b88a9c9).padding.md : (0, $7db4b5652a829202$export$bca14c5b3b88a9c9).padding.sm,
                    tt: "none",
                    m: (0, $7db4b5652a829202$export$bca14c5b3b88a9c9).padding.xs,
                    lts: "0px",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: "inline-flex",
                            alignItems: "center",
                            fontSize: large ? "14px" : "12px"
                        },
                        children: [
                            tag,
                            renderXIcon()
                        ]
                    })
                })
            }, index))
    });
};
var $33ecc2b042884c60$export$2e2bcd8739ae039 = $33ecc2b042884c60$var$TagList;



/**
 * @tabler/icons-react v2.42.0 - MIT
 */ 
var $60d3b9bb6424de52$export$2e2bcd8739ae039 = (0, $a86819fe50d185cb$export$2e2bcd8739ae039)("info-circle", "IconInfoCircle", [
    [
        "path",
        {
            d: "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0",
            key: "svg-0"
        }
    ],
    [
        "path",
        {
            d: "M12 9h.01",
            key: "svg-1"
        }
    ],
    [
        "path",
        {
            d: "M11 12h1v4h1",
            key: "svg-2"
        }
    ]
]);

/**
 * @tabler/icons-react v2.42.0 - MIT
 */ 
var $a7a2d4747e01fe99$export$2e2bcd8739ae039 = (0, $a86819fe50d185cb$export$2e2bcd8739ae039)("link", "IconLink", [
    [
        "path",
        {
            d: "M9 15l6 -6",
            key: "svg-0"
        }
    ],
    [
        "path",
        {
            d: "M11 6l.463 -.536a5 5 0 0 1 7.071 7.072l-.534 .464",
            key: "svg-1"
        }
    ],
    [
        "path",
        {
            d: "M13 18l-.397 .534a5.068 5.068 0 0 1 -7.127 0a4.972 4.972 0 0 1 0 -7.071l.524 -.463",
            key: "svg-2"
        }
    ]
]);



function $cf9bcb6cbcae2c40$var$DiscoveryItem({ discovery: discovery, relatedInterest: relatedInterest, activeTopics: activeTopics, setActiveTopics: setActiveTopics, removeTag: removeTag, title: title }) {
    const { highlight: highlight, created: created, categories: categories, source: source, rationale: rationale, link: link, linktitle: linktitle = [] } = discovery;
    const datePattern = /\/(\d{4}-\d{2}-\d{2})\//;
    const match = link.match(datePattern);
    const dateString = match ? match[1] : created;
    const dateObject = new Date(dateString);
    const formattedDate = [
        dateObject.toISOString().split("T")[0],
        dateObject.toLocaleTimeString("en-US", {
            hour12: true
        })
    ];
    // support legacy analysis objects using old prompt
    const discoveryBody = rationale.startsWith("Yes, ") ? rationale.charAt(5).toUpperCase() + rationale.substring(6).trim() : rationale;
    const env = "production";
    const chatUrl = env === "development" ? `http://chat-local.consili.io:3000/?i=${discovery.id}` : `https://chat.consili.io?i=${discovery.id}`;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $3e91b7d399f248d1$export$60332b2344f7fe41), {
        shadow: "md",
        radius: "md",
        withBorder: true,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $082a1c451bb0006a$export$a766cd26d0d69044).Control, {
                style: {
                    backgroundColor: "transparent",
                    outlineColor: "transparent",
                    width: "102%"
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4), {
                    justify: "space-between",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                            size: "md",
                            fw: 600,
                            style: {
                                marginBottom: "0.5rem",
                                width: "80%"
                            },
                            children: title?.length ? title : highlight
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                            size: "sm",
                            c: (0, $7db4b5652a829202$export$bca14c5b3b88a9c9).colors.gray[3],
                            mr: "8px",
                            pos: "absolute",
                            right: 28,
                            top: 28,
                            children: formattedDate[0]
                        }),
                        " ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                            size: "sm",
                            c: (0, $7db4b5652a829202$export$bca14c5b3b88a9c9).colors.gray[3],
                            mr: "8px",
                            pos: "absolute",
                            right: 28,
                            top: 44,
                            children: formattedDate[1]
                        }),
                        " "
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $082a1c451bb0006a$export$a766cd26d0d69044).Panel, {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                        fw: 300,
                        pl: 0,
                        children: discoveryBody
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                        fw: 700,
                        mt: 16,
                        fs: "italic",
                        variant: "gradient",
                        gradient: {
                            from: "blue",
                            to: "cyan",
                            deg: 90
                        },
                        children: [
                            "(",
                            "Want to learn more?",
                            " ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                                href: chatUrl,
                                target: "_blank",
                                fs: "normal",
                                fw: 500,
                                children: "Chat with our assistant"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7a2d4747e01fe99$export$2e2bcd8739ae039), {
                                color: "blue",
                                size: 16
                            }),
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $89f662fb61bfd50a$export$29a7a275fe11687), {
                        color: "blue",
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $60d3b9bb6424de52$export$2e2bcd8739ae039), {}),
                        mt: "xl",
                        ml: "sm",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                fw: 600,
                                children: "Relevant research topics: "
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a4218ccdfc87c17$export$54c2e3dc7acea9f5), {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ce466757a1a01b4$export$a7b06bfba60a8a78), {
                                    children: relatedInterest
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4), {
                mb: (0, $7db4b5652a829202$export$bca14c5b3b88a9c9).padding.md,
                mt: (0, $7db4b5652a829202$export$bca14c5b3b88a9c9).padding.sm,
                pl: "md",
                children: source && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $33ecc2b042884c60$export$2e2bcd8739ae039), {
                    baseTags: [
                        source
                    ]?.map((source)=>source?.name),
                    activeTopics: [
                        source
                    ]?.map((source)=>source?.name),
                    defaultOutline: true,
                    large: true,
                    tagColor: (0, $7db4b5652a829202$export$bca14c5b3b88a9c9).colors.blue[3],
                    removeTag: removeTag
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4), {
                pl: "md",
                children: [
                    categories?.length && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
                        w: 800,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $33ecc2b042884c60$export$2e2bcd8739ae039), {
                            defaultOutline: true,
                            baseTags: categories?.map((category)=>category?.name),
                            activeTopics: activeTopics,
                            setActiveTopics: setActiveTopics,
                            clickable: true,
                            tagColor: (0, $7db4b5652a829202$export$bca14c5b3b88a9c9).colors.purple[3],
                            removeTag: removeTag
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4), {
                        ml: "auto",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                href: link,
                                target: "_blank",
                                rel: "noreferrer",
                                children: link && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4), {
                                    justify: "space-around",
                                    gap: 4,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7a2d4747e01fe99$export$2e2bcd8739ae039), {
                                            color: "gray",
                                            size: 20
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                            size: "sm",
                                            c: (0, $7db4b5652a829202$export$bca14c5b3b88a9c9).colors.gray[3],
                                            style: {
                                                translateX: "10px"
                                            },
                                            children: linktitle ? linktitle?.length <= 100 ? linktitle : linktitle?.slice(0, 50) + "..." : "No Link Title"
                                        })
                                    ]
                                })
                            }),
                            " "
                        ]
                    })
                ]
            }),
            " "
        ]
    });
}
var $cf9bcb6cbcae2c40$export$2e2bcd8739ae039 = $cf9bcb6cbcae2c40$var$DiscoveryItem;


parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
"use client";
var $6e6a76d9a24c3263$var$classes = {
    "root": "m-4451eb3a"
};
var $6e6a76d9a24c3263$export$2e2bcd8739ae039 = $6e6a76d9a24c3263$var$classes;






"use client";
var $76521bdbf0ca2f28$var$__defProp = Object.defineProperty;
var $76521bdbf0ca2f28$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $76521bdbf0ca2f28$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $76521bdbf0ca2f28$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $76521bdbf0ca2f28$var$__defNormalProp = (obj, key, value)=>key in obj ? $76521bdbf0ca2f28$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $76521bdbf0ca2f28$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($76521bdbf0ca2f28$var$__hasOwnProp.call(b, prop)) $76521bdbf0ca2f28$var$__defNormalProp(a, prop, b[prop]);
    if ($76521bdbf0ca2f28$var$__getOwnPropSymbols) {
        for (var prop of $76521bdbf0ca2f28$var$__getOwnPropSymbols(b))if ($76521bdbf0ca2f28$var$__propIsEnum.call(b, prop)) $76521bdbf0ca2f28$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $76521bdbf0ca2f28$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($76521bdbf0ca2f28$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $76521bdbf0ca2f28$var$__getOwnPropSymbols) {
        for (var prop of $76521bdbf0ca2f28$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $76521bdbf0ca2f28$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $76521bdbf0ca2f28$var$defaultProps = {};
const $76521bdbf0ca2f28$export$1f54913ccc4368b1 = (0, $dfead8eb7283bc39$export$197bdd704df40a29)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("Center", $76521bdbf0ca2f28$var$defaultProps, _props);
    const _a = props, { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, inline: inline } = _a, others = $76521bdbf0ca2f28$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "inline"
    ]);
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: "Center",
        props: props,
        classes: $6e6a76d9a24c3263$export$2e2bcd8739ae039,
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        vars: vars
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $76521bdbf0ca2f28$var$__spreadValues($76521bdbf0ca2f28$var$__spreadValues({
        ref: ref,
        mod: {
            inline: inline
        }
    }, getStyles("root")), others));
});
$76521bdbf0ca2f28$export$1f54913ccc4368b1.classes = (0, $6e6a76d9a24c3263$export$2e2bcd8739ae039);
$76521bdbf0ca2f28$export$1f54913ccc4368b1.displayName = "@mantine/core/Center";



const $99c68b09e9ea9061$var$DiscoveryPrompt = ({ svgLink: svgLink, description: description, onClick: onClick })=>{
    const descriptionsentencees = description.split(".");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
        onClick: onClick,
        style: {
            cursor: "pointer",
            left: "25%"
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $76521bdbf0ca2f28$export$1f54913ccc4368b1), {
                style: {
                    paddingTop: "10vh",
                    paddingBottom: "25px"
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: svgLink,
                    alt: "No items",
                    height: "20%",
                    width: "20%"
                })
            }),
            descriptionsentencees.map((string, index)=>{
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $76521bdbf0ca2f28$export$1f54913ccc4368b1), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                        size: "xl",
                        fw: 700,
                        c: "#669DF6",
                        children: [
                            string,
                            "."
                        ]
                    })
                }, index);
            })
        ]
    });
};
var $99c68b09e9ea9061$export$2e2bcd8739ae039 = $99c68b09e9ea9061$var$DiscoveryPrompt;





var $acw62 = parcelRequire("acw62");
const $c7f98cdafb13ea7d$var$Delay = ({ children: children, waitBeforeShow: waitBeforeShow })=>{
    const [isShown, setIsShown] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        const timer = setTimeout(()=>{
            setIsShown(true);
        }, waitBeforeShow);
        return ()=>clearTimeout(timer);
    }, [
        waitBeforeShow
    ]);
    return isShown ? children : null;
};
var $c7f98cdafb13ea7d$export$2e2bcd8739ae039 = $c7f98cdafb13ea7d$var$Delay;


// src/query/react/index.ts
// src/query/core/apiState.ts
// src/utils/formatProdErrorMessage.ts
function $669d9d4c4c7ccc3c$var$formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $669d9d4c4c7ccc3c$var$$$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var $669d9d4c4c7ccc3c$var$symbol_observable_default = $669d9d4c4c7ccc3c$var$$$observable;
// src/utils/actionTypes.ts
var $669d9d4c4c7ccc3c$var$randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var $669d9d4c4c7ccc3c$var$ActionTypes = {
    INIT: `@@redux/INIT${$669d9d4c4c7ccc3c$var$randomString()}`,
    REPLACE: `@@redux/REPLACE${$669d9d4c4c7ccc3c$var$randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${$669d9d4c4c7ccc3c$var$randomString()}`
};
var $669d9d4c4c7ccc3c$export$4219e499db7ca678 = $669d9d4c4c7ccc3c$var$ActionTypes;
// src/utils/isPlainObject.ts
function $669d9d4c4c7ccc3c$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $669d9d4c4c7ccc3c$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($669d9d4c4c7ccc3c$var$isDate(val)) return "date";
    if ($669d9d4c4c7ccc3c$var$isError(val)) return "error";
    const constructorName = $669d9d4c4c7ccc3c$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $669d9d4c4c7ccc3c$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $669d9d4c4c7ccc3c$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $669d9d4c4c7ccc3c$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $669d9d4c4c7ccc3c$var$kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function $669d9d4c4c7ccc3c$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($669d9d4c4c7ccc3c$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($669d9d4c4c7ccc3c$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($669d9d4c4c7ccc3c$var$formatProdErrorMessage(1));
        return enhancer($669d9d4c4c7ccc3c$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($669d9d4c4c7ccc3c$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($669d9d4c4c7ccc3c$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($669d9d4c4c7ccc3c$var$formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($669d9d4c4c7ccc3c$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$669d9d4c4c7ccc3c$export$53b83ca8eaab0383(action)) throw new Error($669d9d4c4c7ccc3c$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($669d9d4c4c7ccc3c$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($669d9d4c4c7ccc3c$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($669d9d4c4c7ccc3c$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($669d9d4c4c7ccc3c$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $669d9d4c4c7ccc3c$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($669d9d4c4c7ccc3c$var$formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            },
            [$669d9d4c4c7ccc3c$var$symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: $669d9d4c4c7ccc3c$export$4219e499db7ca678.INIT
    });
    const store = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer,
        [$669d9d4c4c7ccc3c$var$symbol_observable_default]: observable
    };
    return store;
}
function $669d9d4c4c7ccc3c$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $669d9d4c4c7ccc3c$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $669d9d4c4c7ccc3c$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $669d9d4c4c7ccc3c$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === $669d9d4c4c7ccc3c$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$669d9d4c4c7ccc3c$export$53b83ca8eaab0383(inputState)) return `The ${argumentName} has unexpected type of "${$669d9d4c4c7ccc3c$var$kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $669d9d4c4c7ccc3c$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function $669d9d4c4c7ccc3c$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: $669d9d4c4c7ccc3c$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($669d9d4c4c7ccc3c$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $669d9d4c4c7ccc3c$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($669d9d4c4c7ccc3c$var$formatProdErrorMessage(13));
    });
}
function $669d9d4c4c7ccc3c$export$66e4520cdb265d18(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        $669d9d4c4c7ccc3c$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error($669d9d4c4c7ccc3c$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $669d9d4c4c7ccc3c$var$bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function $669d9d4c4c7ccc3c$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $669d9d4c4c7ccc3c$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($669d9d4c4c7ccc3c$var$formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $669d9d4c4c7ccc3c$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $669d9d4c4c7ccc3c$export$f672e0b6f7222cd7(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function $669d9d4c4c7ccc3c$export$9ff26e0402cc7b7(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error($669d9d4c4c7ccc3c$var$formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = $669d9d4c4c7ccc3c$export$f672e0b6f7222cd7(...chain)(store.dispatch);
            return {
                ...store,
                dispatch: dispatch
            };
        };
}
// src/utils/isAction.ts
function $669d9d4c4c7ccc3c$export$b956e38827fca970(action) {
    return $669d9d4c4c7ccc3c$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}

// src/index.ts

var $5f9e38360d79f95a$var$__defProp = Object.defineProperty;
var $5f9e38360d79f95a$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $5f9e38360d79f95a$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $5f9e38360d79f95a$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $5f9e38360d79f95a$var$__defNormalProp = (obj, key, value)=>key in obj ? $5f9e38360d79f95a$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $5f9e38360d79f95a$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($5f9e38360d79f95a$var$__hasOwnProp.call(b, prop)) $5f9e38360d79f95a$var$__defNormalProp(a, prop, b[prop]);
    if ($5f9e38360d79f95a$var$__getOwnPropSymbols) {
        for (var prop of $5f9e38360d79f95a$var$__getOwnPropSymbols(b))if ($5f9e38360d79f95a$var$__propIsEnum.call(b, prop)) $5f9e38360d79f95a$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/utils/env.ts
var $5f9e38360d79f95a$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $5f9e38360d79f95a$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $5f9e38360d79f95a$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $5f9e38360d79f95a$var$errors = [];
function $5f9e38360d79f95a$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $5f9e38360d79f95a$var$getPrototypeOf = Object.getPrototypeOf;
function $5f9e38360d79f95a$export$541ac630993a4c84(value) {
    return !!value && !!value[$5f9e38360d79f95a$var$DRAFT_STATE];
}
function $5f9e38360d79f95a$export$16e3aed3edb85946(value) {
    var _a;
    if (!value) return false;
    return $5f9e38360d79f95a$var$isPlainObject(value) || Array.isArray(value) || !!value[$5f9e38360d79f95a$export$6ee2082928bcb0ee] || !!((_a = value.constructor) == null ? void 0 : _a[$5f9e38360d79f95a$export$6ee2082928bcb0ee]) || $5f9e38360d79f95a$var$isMap(value) || $5f9e38360d79f95a$var$isSet(value);
}
var $5f9e38360d79f95a$var$objectCtorString = Object.prototype.constructor.toString();
function $5f9e38360d79f95a$var$isPlainObject(value) {
    if (!value || typeof value !== "object") return false;
    const proto = $5f9e38360d79f95a$var$getPrototypeOf(value);
    if (proto === null) return true;
    const Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    if (Ctor === Object) return true;
    return typeof Ctor == "function" && Function.toString.call(Ctor) === $5f9e38360d79f95a$var$objectCtorString;
}
function $5f9e38360d79f95a$export$22e8af3f75a010e3(value) {
    if (!$5f9e38360d79f95a$export$541ac630993a4c84(value)) $5f9e38360d79f95a$var$die(15, value);
    return value[$5f9e38360d79f95a$var$DRAFT_STATE].base_;
}
function $5f9e38360d79f95a$var$each(obj, iter) {
    if ($5f9e38360d79f95a$var$getArchtype(obj) === 0 /* Object */ ) Object.entries(obj).forEach(([key, value])=>{
        iter(key, value, obj);
    });
    else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $5f9e38360d79f95a$var$getArchtype(thing) {
    const state = thing[$5f9e38360d79f95a$var$DRAFT_STATE];
    return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */  : $5f9e38360d79f95a$var$isMap(thing) ? 2 /* Map */  : $5f9e38360d79f95a$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
function $5f9e38360d79f95a$var$has(thing, prop) {
    return $5f9e38360d79f95a$var$getArchtype(thing) === 2 /* Map */  ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function $5f9e38360d79f95a$var$get(thing, prop) {
    return $5f9e38360d79f95a$var$getArchtype(thing) === 2 /* Map */  ? thing.get(prop) : thing[prop];
}
function $5f9e38360d79f95a$var$set(thing, propOrOldValue, value) {
    const t = $5f9e38360d79f95a$var$getArchtype(thing);
    if (t === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (t === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
}
function $5f9e38360d79f95a$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $5f9e38360d79f95a$var$isMap(target) {
    return target instanceof Map;
}
function $5f9e38360d79f95a$var$isSet(target) {
    return target instanceof Set;
}
function $5f9e38360d79f95a$var$latest(state) {
    return state.copy_ || state.base_;
}
function $5f9e38360d79f95a$var$shallowCopy(base, strict) {
    if ($5f9e38360d79f95a$var$isMap(base)) return new Map(base);
    if ($5f9e38360d79f95a$var$isSet(base)) return new Set(base);
    if (Array.isArray(base)) return Array.prototype.slice.call(base);
    if (!strict && $5f9e38360d79f95a$var$isPlainObject(base)) {
        if (!$5f9e38360d79f95a$var$getPrototypeOf(base)) {
            const obj = /* @__PURE__ */ Object.create(null);
            return Object.assign(obj, base);
        }
        return $5f9e38360d79f95a$var$__spreadValues({}, base);
    }
    const descriptors = Object.getOwnPropertyDescriptors(base);
    delete descriptors[$5f9e38360d79f95a$var$DRAFT_STATE];
    let keys = Reflect.ownKeys(descriptors);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const desc = descriptors[key];
        if (desc.writable === false) {
            desc.writable = true;
            desc.configurable = true;
        }
        if (desc.get || desc.set) descriptors[key] = {
            configurable: true,
            writable: true,
            // could live with !!desc.set as well here...
            enumerable: desc.enumerable,
            value: base[key]
        };
    }
    return Object.create($5f9e38360d79f95a$var$getPrototypeOf(base), descriptors);
}
function $5f9e38360d79f95a$export$792f3d81ea979f55(obj, deep = false) {
    if ($5f9e38360d79f95a$var$isFrozen(obj) || $5f9e38360d79f95a$export$541ac630993a4c84(obj) || !$5f9e38360d79f95a$export$16e3aed3edb85946(obj)) return obj;
    if ($5f9e38360d79f95a$var$getArchtype(obj) > 1) obj.set = obj.add = obj.clear = obj.delete = $5f9e38360d79f95a$var$dontMutateFrozenCollections;
    Object.freeze(obj);
    if (deep) $5f9e38360d79f95a$var$each(obj, (_key, value)=>$5f9e38360d79f95a$export$792f3d81ea979f55(value, true), true);
    return obj;
}
function $5f9e38360d79f95a$var$dontMutateFrozenCollections() {
    $5f9e38360d79f95a$var$die(2);
}
function $5f9e38360d79f95a$var$isFrozen(obj) {
    return Object.isFrozen(obj);
}
// src/utils/plugins.ts
var $5f9e38360d79f95a$var$plugins = {};
function $5f9e38360d79f95a$var$getPlugin(pluginKey) {
    const plugin = $5f9e38360d79f95a$var$plugins[pluginKey];
    if (!plugin) $5f9e38360d79f95a$var$die(0, pluginKey);
    return plugin;
}
function $5f9e38360d79f95a$var$loadPlugin(pluginKey, implementation) {
    if (!$5f9e38360d79f95a$var$plugins[pluginKey]) $5f9e38360d79f95a$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $5f9e38360d79f95a$var$currentScope;
function $5f9e38360d79f95a$var$getCurrentScope() {
    return $5f9e38360d79f95a$var$currentScope;
}
function $5f9e38360d79f95a$var$createScope(parent_, immer_) {
    return {
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0
    };
}
function $5f9e38360d79f95a$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        $5f9e38360d79f95a$var$getPlugin("Patches");
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $5f9e38360d79f95a$var$revokeScope(scope) {
    $5f9e38360d79f95a$var$leaveScope(scope);
    scope.drafts_.forEach($5f9e38360d79f95a$var$revokeDraft);
    scope.drafts_ = null;
}
function $5f9e38360d79f95a$var$leaveScope(scope) {
    if (scope === $5f9e38360d79f95a$var$currentScope) $5f9e38360d79f95a$var$currentScope = scope.parent_;
}
function $5f9e38360d79f95a$var$enterScope(immer2) {
    return $5f9e38360d79f95a$var$currentScope = $5f9e38360d79f95a$var$createScope($5f9e38360d79f95a$var$currentScope, immer2);
}
function $5f9e38360d79f95a$var$revokeDraft(draft) {
    const state = draft[$5f9e38360d79f95a$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $5f9e38360d79f95a$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$5f9e38360d79f95a$var$DRAFT_STATE].modified_) {
            $5f9e38360d79f95a$var$revokeScope(scope);
            $5f9e38360d79f95a$var$die(4);
        }
        if ($5f9e38360d79f95a$export$16e3aed3edb85946(result)) {
            result = $5f9e38360d79f95a$var$finalize(scope, result);
            if (!scope.parent_) $5f9e38360d79f95a$var$maybeFreeze(scope, result);
        }
        if (scope.patches_) $5f9e38360d79f95a$var$getPlugin("Patches").generateReplacementPatches_(baseDraft[$5f9e38360d79f95a$var$DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    } else result = $5f9e38360d79f95a$var$finalize(scope, baseDraft, []);
    $5f9e38360d79f95a$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $5f9e38360d79f95a$export$45b790e32b2810ee ? result : void 0;
}
function $5f9e38360d79f95a$var$finalize(rootScope, value, path) {
    if ($5f9e38360d79f95a$var$isFrozen(value)) return value;
    const state = value[$5f9e38360d79f95a$var$DRAFT_STATE];
    if (!state) {
        $5f9e38360d79f95a$var$each(value, (key, childValue)=>$5f9e38360d79f95a$var$finalizeProperty(rootScope, state, value, key, childValue, path), true);
        return value;
    }
    if (state.scope_ !== rootScope) return value;
    if (!state.modified_) {
        $5f9e38360d79f95a$var$maybeFreeze(rootScope, state.base_, true);
        return state.base_;
    }
    if (!state.finalized_) {
        state.finalized_ = true;
        state.scope_.unfinalizedDrafts_--;
        const result = state.copy_;
        let resultEach = result;
        let isSet2 = false;
        if (state.type_ === 3 /* Set */ ) {
            resultEach = new Set(result);
            result.clear();
            isSet2 = true;
        }
        $5f9e38360d79f95a$var$each(resultEach, (key, childValue)=>$5f9e38360d79f95a$var$finalizeProperty(rootScope, state, result, key, childValue, path, isSet2));
        $5f9e38360d79f95a$var$maybeFreeze(rootScope, result, false);
        if (path && rootScope.patches_) $5f9e38360d79f95a$var$getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
    return state.copy_;
}
function $5f9e38360d79f95a$var$finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
    if ($5f9e38360d79f95a$export$541ac630993a4c84(childValue)) {
        const path = rootPath && parentState && parentState.type_ !== 3 /* Set */  && // Set objects are atomic since they have no keys.
        !$5f9e38360d79f95a$var$has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
        const res = $5f9e38360d79f95a$var$finalize(rootScope, childValue, path);
        $5f9e38360d79f95a$var$set(targetObject, prop, res);
        if ($5f9e38360d79f95a$export$541ac630993a4c84(res)) rootScope.canAutoFreeze_ = false;
        else return;
    } else if (targetIsSet) targetObject.add(childValue);
    if ($5f9e38360d79f95a$export$16e3aed3edb85946(childValue) && !$5f9e38360d79f95a$var$isFrozen(childValue)) {
        if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return;
        $5f9e38360d79f95a$var$finalize(rootScope, childValue);
        if (!parentState || !parentState.scope_.parent_) $5f9e38360d79f95a$var$maybeFreeze(rootScope, childValue);
    }
}
function $5f9e38360d79f95a$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $5f9e38360d79f95a$export$792f3d81ea979f55(value, deep);
}
// src/core/proxy.ts
function $5f9e38360d79f95a$var$createProxyProxy(base, parent) {
    const isArray = Array.isArray(base);
    const state = {
        type_: isArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $5f9e38360d79f95a$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned_: {},
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false
    };
    let target = state;
    let traps = $5f9e38360d79f95a$var$objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = $5f9e38360d79f95a$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return proxy;
}
var $5f9e38360d79f95a$var$objectTraps = {
    get (state, prop) {
        if (prop === $5f9e38360d79f95a$var$DRAFT_STATE) return state;
        const source = $5f9e38360d79f95a$var$latest(state);
        if (!$5f9e38360d79f95a$var$has(source, prop)) return $5f9e38360d79f95a$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$5f9e38360d79f95a$export$16e3aed3edb85946(value)) return value;
        if (value === $5f9e38360d79f95a$var$peek(state.base_, prop)) {
            $5f9e38360d79f95a$var$prepareCopy(state);
            return state.copy_[prop] = $5f9e38360d79f95a$var$createProxy(value, state);
        }
        return value;
    },
    has (state, prop) {
        return prop in $5f9e38360d79f95a$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($5f9e38360d79f95a$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $5f9e38360d79f95a$var$getDescriptorFromProto($5f9e38360d79f95a$var$latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $5f9e38360d79f95a$var$peek($5f9e38360d79f95a$var$latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[$5f9e38360d79f95a$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_[prop] = false;
                return true;
            }
            if ($5f9e38360d79f95a$var$is(value, current2) && (value !== void 0 || $5f9e38360d79f95a$var$has(state.base_, prop))) return true;
            $5f9e38360d79f95a$var$prepareCopy(state);
            $5f9e38360d79f95a$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_[prop] = true;
        return true;
    },
    deleteProperty (state, prop) {
        if ($5f9e38360d79f95a$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_[prop] = false;
            $5f9e38360d79f95a$var$prepareCopy(state);
            $5f9e38360d79f95a$var$markChanged(state);
        } else delete state.assigned_[prop];
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $5f9e38360d79f95a$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            writable: true,
            configurable: state.type_ !== 1 /* Array */  || prop !== "length",
            enumerable: desc.enumerable,
            value: owner[prop]
        };
    },
    defineProperty () {
        $5f9e38360d79f95a$var$die(11);
    },
    getPrototypeOf (state) {
        return $5f9e38360d79f95a$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $5f9e38360d79f95a$var$die(12);
    }
};
var $5f9e38360d79f95a$var$arrayTraps = {};
$5f9e38360d79f95a$var$each($5f9e38360d79f95a$var$objectTraps, (key, fn)=>{
    $5f9e38360d79f95a$var$arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
$5f9e38360d79f95a$var$arrayTraps.deleteProperty = function(state, prop) {
    return $5f9e38360d79f95a$var$arrayTraps.set.call(this, state, prop, void 0);
};
$5f9e38360d79f95a$var$arrayTraps.set = function(state, prop, value) {
    return $5f9e38360d79f95a$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $5f9e38360d79f95a$var$peek(draft, prop) {
    const state = draft[$5f9e38360d79f95a$var$DRAFT_STATE];
    const source = state ? $5f9e38360d79f95a$var$latest(state) : draft;
    return source[prop];
}
function $5f9e38360d79f95a$var$readPropFromProto(state, source, prop) {
    var _a;
    const desc = $5f9e38360d79f95a$var$getDescriptorFromProto(source, prop);
    return desc ? `value` in desc ? desc.value : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function $5f9e38360d79f95a$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $5f9e38360d79f95a$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $5f9e38360d79f95a$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $5f9e38360d79f95a$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $5f9e38360d79f95a$var$markChanged(state.parent_);
    }
}
function $5f9e38360d79f95a$var$prepareCopy(state) {
    if (!state.copy_) state.copy_ = $5f9e38360d79f95a$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
}
// src/core/immerClass.ts
var $5f9e38360d79f95a$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if (typeof base === "function" && typeof recipe !== "function") {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (typeof recipe !== "function") $5f9e38360d79f95a$var$die(6);
            if (patchListener !== void 0 && typeof patchListener !== "function") $5f9e38360d79f95a$var$die(7);
            let result;
            if ($5f9e38360d79f95a$export$16e3aed3edb85946(base)) {
                const scope = $5f9e38360d79f95a$var$enterScope(this);
                const proxy = $5f9e38360d79f95a$var$createProxy(base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $5f9e38360d79f95a$var$revokeScope(scope);
                    else $5f9e38360d79f95a$var$leaveScope(scope);
                }
                $5f9e38360d79f95a$var$usePatchesInScope(scope, patchListener);
                return $5f9e38360d79f95a$var$processResult(result, scope);
            } else if (!base || typeof base !== "object") {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $5f9e38360d79f95a$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $5f9e38360d79f95a$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $5f9e38360d79f95a$var$getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
                    patchListener(p, ip);
                }
                return result;
            } else $5f9e38360d79f95a$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if (typeof base === "function") return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (typeof (config == null ? void 0 : config.autoFreeze) === "boolean") this.setAutoFreeze(config.autoFreeze);
        if (typeof (config == null ? void 0 : config.useStrictShallowCopy) === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
    }
    createDraft(base) {
        if (!$5f9e38360d79f95a$export$16e3aed3edb85946(base)) $5f9e38360d79f95a$var$die(8);
        if ($5f9e38360d79f95a$export$541ac630993a4c84(base)) base = $5f9e38360d79f95a$export$97aac956da55dae9(base);
        const scope = $5f9e38360d79f95a$var$enterScope(this);
        const proxy = $5f9e38360d79f95a$var$createProxy(base, void 0);
        proxy[$5f9e38360d79f95a$var$DRAFT_STATE].isManual_ = true;
        $5f9e38360d79f95a$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$5f9e38360d79f95a$var$DRAFT_STATE];
        if (!state || !state.isManual_) $5f9e38360d79f95a$var$die(9);
        const { scope_: scope } = state;
        $5f9e38360d79f95a$var$usePatchesInScope(scope, patchListener);
        return $5f9e38360d79f95a$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $5f9e38360d79f95a$var$getPlugin("Patches").applyPatches_;
        if ($5f9e38360d79f95a$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $5f9e38360d79f95a$var$createProxy(value, parent) {
    const draft = $5f9e38360d79f95a$var$isMap(value) ? $5f9e38360d79f95a$var$getPlugin("MapSet").proxyMap_(value, parent) : $5f9e38360d79f95a$var$isSet(value) ? $5f9e38360d79f95a$var$getPlugin("MapSet").proxySet_(value, parent) : $5f9e38360d79f95a$var$createProxyProxy(value, parent);
    const scope = parent ? parent.scope_ : $5f9e38360d79f95a$var$getCurrentScope();
    scope.drafts_.push(draft);
    return draft;
}
// src/core/current.ts
function $5f9e38360d79f95a$export$97aac956da55dae9(value) {
    if (!$5f9e38360d79f95a$export$541ac630993a4c84(value)) $5f9e38360d79f95a$var$die(10, value);
    return $5f9e38360d79f95a$var$currentImpl(value);
}
function $5f9e38360d79f95a$var$currentImpl(value) {
    if (!$5f9e38360d79f95a$export$16e3aed3edb85946(value) || $5f9e38360d79f95a$var$isFrozen(value)) return value;
    const state = value[$5f9e38360d79f95a$var$DRAFT_STATE];
    let copy;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $5f9e38360d79f95a$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
    } else copy = $5f9e38360d79f95a$var$shallowCopy(value, true);
    $5f9e38360d79f95a$var$each(copy, (key, childValue)=>{
        $5f9e38360d79f95a$var$set(copy, key, $5f9e38360d79f95a$var$currentImpl(childValue));
    });
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $5f9e38360d79f95a$export$d3a6659991a0696c() {
    const errorOffset = 16;
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, patches, inversePatches) {
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches, inversePatches);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches, inversePatches);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        for(let i = 0; i < base_.length; i++)if (assigned_[i] && copy_[i] !== base_[i]) {
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: REPLACE,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
            inversePatches.push({
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(base_[i])
            });
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_ } = state;
        $5f9e38360d79f95a$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $5f9e38360d79f95a$var$get(base_, key);
            const value = $5f9e38360d79f95a$var$get(copy_, key);
            const op = !assignedValue ? REMOVE : $5f9e38360d79f95a$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: value
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
        patches.push({
            op: REPLACE,
            path: [],
            value: replacement === $5f9e38360d79f95a$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $5f9e38360d79f95a$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === "constructor")) $5f9e38360d79f95a$var$die(errorOffset + 3);
                if (typeof base === "function" && p === "prototype") $5f9e38360d79f95a$var$die(errorOffset + 3);
                base = $5f9e38360d79f95a$var$get(base, p);
                if (typeof base !== "object") $5f9e38360d79f95a$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $5f9e38360d79f95a$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $5f9e38360d79f95a$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $5f9e38360d79f95a$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$5f9e38360d79f95a$export$16e3aed3edb85946(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
        if ($5f9e38360d79f95a$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($5f9e38360d79f95a$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($5f9e38360d79f95a$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($5f9e38360d79f95a$var$has(obj, $5f9e38360d79f95a$export$6ee2082928bcb0ee)) cloned[$5f9e38360d79f95a$export$6ee2082928bcb0ee] = obj[$5f9e38360d79f95a$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($5f9e38360d79f95a$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $5f9e38360d79f95a$var$loadPlugin("Patches", {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_
    });
}
// src/plugins/mapset.ts
function $5f9e38360d79f95a$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$5f9e38360d79f95a$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $5f9e38360d79f95a$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false
            };
        }
        get size() {
            return $5f9e38360d79f95a$var$latest(this[$5f9e38360d79f95a$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $5f9e38360d79f95a$var$latest(this[$5f9e38360d79f95a$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$5f9e38360d79f95a$var$latest(state).has(key) || $5f9e38360d79f95a$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $5f9e38360d79f95a$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $5f9e38360d79f95a$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($5f9e38360d79f95a$var$latest(state).size) {
                prepareMapCopy(state);
                $5f9e38360d79f95a$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $5f9e38360d79f95a$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            $5f9e38360d79f95a$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $5f9e38360d79f95a$var$latest(state).get(key);
            if (state.finalized_ || !$5f9e38360d79f95a$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $5f9e38360d79f95a$var$createProxy(value, state);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $5f9e38360d79f95a$var$latest(this[$5f9e38360d79f95a$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($5f9e38360d79f95a$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        return new DraftMap(target, parent);
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$5f9e38360d79f95a$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $5f9e38360d79f95a$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false
            };
        }
        get size() {
            return $5f9e38360d79f95a$var$latest(this[$5f9e38360d79f95a$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $5f9e38360d79f95a$var$markChanged(state);
                state.copy_.add(value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $5f9e38360d79f95a$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($5f9e38360d79f95a$var$latest(state).size) {
                prepareSetCopy(state);
                $5f9e38360d79f95a$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($5f9e38360d79f95a$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        return new DraftSet(target, parent);
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($5f9e38360d79f95a$export$16e3aed3edb85946(value)) {
                    const draft = $5f9e38360d79f95a$var$createProxy(value, state);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $5f9e38360d79f95a$var$die(3, JSON.stringify($5f9e38360d79f95a$var$latest(state)));
    }
    $5f9e38360d79f95a$var$loadPlugin("MapSet", {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_
    });
}
// src/immer.ts
var $5f9e38360d79f95a$var$immer = new $5f9e38360d79f95a$export$aaadc6ff0f822719();
var $5f9e38360d79f95a$export$b46cabe22e78bc00 = $5f9e38360d79f95a$var$immer.produce;
var $5f9e38360d79f95a$export$4da66d41c9492c78 = $5f9e38360d79f95a$var$immer.produceWithPatches.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$573f26f60825c493 = $5f9e38360d79f95a$var$immer.setAutoFreeze.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$333ce65961cbe047 = $5f9e38360d79f95a$var$immer.setUseStrictShallowCopy.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$a8b8e03e6bbe5473 = $5f9e38360d79f95a$var$immer.applyPatches.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$3c3214997190395f = $5f9e38360d79f95a$var$immer.createDraft.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$c60f5e69c521b528 = $5f9e38360d79f95a$var$immer.finishDraft.bind($5f9e38360d79f95a$var$immer);
function $5f9e38360d79f95a$export$c05b21e3257751e5(value) {
    return value;
}
function $5f9e38360d79f95a$export$20f911b3f8cf0b74(value) {
    return value;
}


var $375276bea32f9eda$var$__defProp = Object.defineProperty;
var $375276bea32f9eda$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $375276bea32f9eda$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $375276bea32f9eda$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $375276bea32f9eda$var$__defNormalProp = (obj, key, value)=>key in obj ? $375276bea32f9eda$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $375276bea32f9eda$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($375276bea32f9eda$var$__hasOwnProp.call(b, prop)) $375276bea32f9eda$var$__defNormalProp(a, prop, b[prop]);
    if ($375276bea32f9eda$var$__getOwnPropSymbols) {
        for (var prop of $375276bea32f9eda$var$__getOwnPropSymbols(b))if ($375276bea32f9eda$var$__propIsEnum.call(b, prop)) $375276bea32f9eda$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $375276bea32f9eda$var$__publicField = (obj, key, value)=>{
    $375276bea32f9eda$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var $375276bea32f9eda$var$runIdentityFunctionCheck = (resultFunc)=>{
    let isInputSameAsOutput = false;
    try {
        const emptyObject = {};
        if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
    } catch (e) {}
    if (isInputSameAsOutput) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
            stack: stack
        });
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $375276bea32f9eda$var$runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize: memoize, memoizeOptions: memoizeOptions } = options;
    const { inputSelectorResults: inputSelectorResults, inputSelectorResultsCopy: inputSelectorResultsCopy } = inputSelectorResultsObject;
    const createAnEmptyObject = memoize(()=>({}), ...memoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $375276bea32f9eda$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $375276bea32f9eda$export$1e290349de99e28c = (devModeChecks)=>{
    Object.assign($375276bea32f9eda$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $375276bea32f9eda$var$NOT_FOUND = "NOT_FOUND";
function $375276bea32f9eda$var$assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $375276bea32f9eda$var$assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $375276bea32f9eda$var$assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var $375276bea32f9eda$var$ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function $375276bea32f9eda$var$getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $375276bea32f9eda$var$assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function $375276bea32f9eda$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length: length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $375276bea32f9eda$var$getDevModeChecksExecutionInfo = (firstRun, devModeChecks)=>{
    const { identityFunctionCheck: identityFunctionCheck, inputStabilityCheck: inputStabilityCheck } = $375276bea32f9eda$var$__spreadValues($375276bea32f9eda$var$__spreadValues({}, $375276bea32f9eda$var$globalDevModeChecks), devModeChecks);
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $375276bea32f9eda$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $375276bea32f9eda$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $375276bea32f9eda$var$$REVISION = 0;
var $375276bea32f9eda$var$CURRENT_TRACKER = null;
var $375276bea32f9eda$var$Cell = class {
    constructor(initialValue, isEqual = $375276bea32f9eda$var$tripleEq){
        $375276bea32f9eda$var$__publicField(this, "revision", $375276bea32f9eda$var$$REVISION);
        $375276bea32f9eda$var$__publicField(this, "_value");
        $375276bea32f9eda$var$__publicField(this, "_lastValue");
        $375276bea32f9eda$var$__publicField(this, "_isEqual", $375276bea32f9eda$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    // Whenever a storage value is read, it'll add itself to the current tracker if
    // one exists, entangling its state with that cache.
    get value() {
        $375276bea32f9eda$var$CURRENT_TRACKER == null || $375276bea32f9eda$var$CURRENT_TRACKER.add(this);
        return this._value;
    }
    // Whenever a storage value is updated, we bump the global revision clock,
    // assign the revision for this storage to the new value, _and_ we schedule a
    // rerender. This is important, and it's what makes autotracking  _pull_
    // based. We don't actively tell the caches which depend on the storage that
    // anything has happened. Instead, we recompute the caches when needed.
    set value(newValue) {
        if (this.value === newValue) return;
        this._value = newValue;
        this.revision = ++$375276bea32f9eda$var$$REVISION;
    }
};
function $375276bea32f9eda$var$tripleEq(a, b) {
    return a === b;
}
var $375276bea32f9eda$var$TrackingCache = class {
    constructor(fn){
        $375276bea32f9eda$var$__publicField(this, "_cachedValue");
        $375276bea32f9eda$var$__publicField(this, "_cachedRevision", -1);
        $375276bea32f9eda$var$__publicField(this, "_deps", []);
        $375276bea32f9eda$var$__publicField(this, "hits", 0);
        $375276bea32f9eda$var$__publicField(this, "fn");
        this.fn = fn;
    }
    clear() {
        this._cachedValue = void 0;
        this._cachedRevision = -1;
        this._deps = [];
        this.hits = 0;
    }
    get value() {
        if (this.revision > this._cachedRevision) {
            const { fn: fn } = this;
            const currentTracker = /* @__PURE__ */ new Set();
            const prevTracker = $375276bea32f9eda$var$CURRENT_TRACKER;
            $375276bea32f9eda$var$CURRENT_TRACKER = currentTracker;
            this._cachedValue = fn();
            $375276bea32f9eda$var$CURRENT_TRACKER = prevTracker;
            this.hits++;
            this._deps = Array.from(currentTracker);
            this._cachedRevision = this.revision;
        }
        $375276bea32f9eda$var$CURRENT_TRACKER == null || $375276bea32f9eda$var$CURRENT_TRACKER.add(this);
        return this._cachedValue;
    }
    get revision() {
        return Math.max(...this._deps.map((d)=>d.revision), 0);
    }
};
function $375276bea32f9eda$var$getValue(cell) {
    if (!(cell instanceof $375276bea32f9eda$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $375276bea32f9eda$var$setValue(storage, value) {
    if (!(storage instanceof $375276bea32f9eda$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $375276bea32f9eda$var$createCell(initialValue, isEqual = $375276bea32f9eda$var$tripleEq) {
    return new $375276bea32f9eda$var$Cell(initialValue, isEqual);
}
function $375276bea32f9eda$var$createCache(fn) {
    $375276bea32f9eda$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $375276bea32f9eda$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $375276bea32f9eda$var$neverEq = (a, b)=>false;
function $375276bea32f9eda$var$createTag() {
    return $375276bea32f9eda$var$createCell(null, $375276bea32f9eda$var$neverEq);
}
function $375276bea32f9eda$var$dirtyTag(tag, value) {
    $375276bea32f9eda$var$setValue(tag, value);
}
var $375276bea32f9eda$var$consumeCollection = (node)=>{
    let tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $375276bea32f9eda$var$createTag();
    $375276bea32f9eda$var$getValue(tag);
};
var $375276bea32f9eda$var$dirtyCollection = (node)=>{
    const tag = node.collectionTag;
    if (tag !== null) $375276bea32f9eda$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $375276bea32f9eda$var$REDUX_PROXY_LABEL = Symbol();
var $375276bea32f9eda$var$nextId = 0;
var $375276bea32f9eda$var$proto = Object.getPrototypeOf({});
var $375276bea32f9eda$var$ObjectTreeNode = class {
    constructor(value){
        this.value = value;
        $375276bea32f9eda$var$__publicField(this, "proxy", new Proxy(this, $375276bea32f9eda$var$objectProxyHandler));
        $375276bea32f9eda$var$__publicField(this, "tag", $375276bea32f9eda$var$createTag());
        $375276bea32f9eda$var$__publicField(this, "tags", {});
        $375276bea32f9eda$var$__publicField(this, "children", {});
        $375276bea32f9eda$var$__publicField(this, "collectionTag", null);
        $375276bea32f9eda$var$__publicField(this, "id", $375276bea32f9eda$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $375276bea32f9eda$var$objectProxyHandler = {
    get (node, key) {
        function calculateResult() {
            const { value: value } = node;
            const childValue = Reflect.get(value, key);
            if (typeof key === "symbol") return childValue;
            if (key in $375276bea32f9eda$var$proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                let childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $375276bea32f9eda$var$createNode(childValue);
                if (childNode.tag) $375276bea32f9eda$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                let tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $375276bea32f9eda$var$createTag();
                    tag.value = childValue;
                }
                $375276bea32f9eda$var$getValue(tag);
                return childValue;
            }
        }
        const res = calculateResult();
        return res;
    },
    ownKeys (node) {
        $375276bea32f9eda$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor (node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has (node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $375276bea32f9eda$var$ArrayTreeNode = class {
    constructor(value){
        this.value = value;
        $375276bea32f9eda$var$__publicField(this, "proxy", new Proxy([
            this
        ], $375276bea32f9eda$var$arrayProxyHandler));
        $375276bea32f9eda$var$__publicField(this, "tag", $375276bea32f9eda$var$createTag());
        $375276bea32f9eda$var$__publicField(this, "tags", {});
        $375276bea32f9eda$var$__publicField(this, "children", {});
        $375276bea32f9eda$var$__publicField(this, "collectionTag", null);
        $375276bea32f9eda$var$__publicField(this, "id", $375276bea32f9eda$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $375276bea32f9eda$var$arrayProxyHandler = {
    get ([node], key) {
        if (key === "length") $375276bea32f9eda$var$consumeCollection(node);
        return $375276bea32f9eda$var$objectProxyHandler.get(node, key);
    },
    ownKeys ([node]) {
        return $375276bea32f9eda$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor ([node], prop) {
        return $375276bea32f9eda$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has ([node], prop) {
        return $375276bea32f9eda$var$objectProxyHandler.has(node, prop);
    }
};
function $375276bea32f9eda$var$createNode(value) {
    if (Array.isArray(value)) return new $375276bea32f9eda$var$ArrayTreeNode(value);
    return new $375276bea32f9eda$var$ObjectTreeNode(value);
}
function $375276bea32f9eda$var$updateNode(node, newValue) {
    const { value: value, tags: tags, children: children } = node;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $375276bea32f9eda$var$dirtyCollection(node);
    else if (value !== newValue) {
        let oldKeysSize = 0;
        let newKeysSize = 0;
        let anyKeysAdded = false;
        for(const _key in value)oldKeysSize++;
        for(const key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $375276bea32f9eda$var$dirtyCollection(node);
    }
    for(const key in tags){
        const childValue = value[key];
        const newChildValue = newValue[key];
        if (childValue !== newChildValue) {
            $375276bea32f9eda$var$dirtyCollection(node);
            $375276bea32f9eda$var$dirtyTag(tags[key], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key];
    }
    for(const key in children){
        const childNode = children[key];
        const newChildValue = newValue[key];
        const childValue = childNode.value;
        if (childValue === newChildValue) continue;
        else if (typeof newChildValue === "object" && newChildValue !== null) $375276bea32f9eda$var$updateNode(childNode, newChildValue);
        else {
            $375276bea32f9eda$var$deleteNode(childNode);
            delete children[key];
        }
    }
}
function $375276bea32f9eda$var$deleteNode(node) {
    if (node.tag) $375276bea32f9eda$var$dirtyTag(node.tag, null);
    $375276bea32f9eda$var$dirtyCollection(node);
    for(const key in node.tags)$375276bea32f9eda$var$dirtyTag(node.tags[key], null);
    for(const key in node.children)$375276bea32f9eda$var$deleteNode(node.children[key]);
}
// src/lruMemoize.ts
function $375276bea32f9eda$var$createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $375276bea32f9eda$var$NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries () {
            return entry ? [
                entry
            ] : [];
        },
        clear () {
            entry = void 0;
        }
    };
}
function $375276bea32f9eda$var$createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(key, entry.key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $375276bea32f9eda$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $375276bea32f9eda$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $375276bea32f9eda$export$3f025202a230c6dd = (a, b)=>a === b;
function $375276bea32f9eda$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length: length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $375276bea32f9eda$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck: equalityCheck = $375276bea32f9eda$export$3f025202a230c6dd, maxSize: maxSize = 1, resultEqualityCheck: resultEqualityCheck } = providedOptions;
    const comparator = $375276bea32f9eda$var$createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize === 1 ? $375276bea32f9eda$var$createSingletonCache(comparator) : $375276bea32f9eda$var$createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === $375276bea32f9eda$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const entries = cache.getEntries();
                const matchingEntry = entries.find((entry)=>resultEqualityCheck(entry.value, value));
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $375276bea32f9eda$export$c8f9cf88d9fdee55(func) {
    const node = $375276bea32f9eda$var$createNode([]);
    let lastArgs = null;
    const shallowEqual = $375276bea32f9eda$var$createCacheKeyComparator($375276bea32f9eda$export$3f025202a230c6dd);
    const cache = $375276bea32f9eda$var$createCache(()=>{
        const res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $375276bea32f9eda$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = ()=>{
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $375276bea32f9eda$var$StrongRef = class {
    constructor(value){
        this.value = value;
    }
    deref() {
        return this.value;
    }
};
var $375276bea32f9eda$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $375276bea32f9eda$var$StrongRef;
var $375276bea32f9eda$var$UNTERMINATED = 0;
var $375276bea32f9eda$var$TERMINATED = 1;
function $375276bea32f9eda$var$createCacheNode() {
    return {
        s: $375276bea32f9eda$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $375276bea32f9eda$export$8402dc26d96f6902(func, options = {}) {
    let fnNode = $375276bea32f9eda$var$createCacheNode();
    const { resultEqualityCheck: resultEqualityCheck } = options;
    let lastResult;
    let resultsCount = 0;
    function memoized() {
        var _a;
        let cacheNode = fnNode;
        const { length: length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $375276bea32f9eda$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $375276bea32f9eda$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        const terminatedNode = cacheNode;
        let result;
        if (cacheNode.s === $375276bea32f9eda$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
        }
        terminatedNode.s = $375276bea32f9eda$var$TERMINATED;
        if (resultEqualityCheck) {
            const lastResultValue = (_a = lastResult == null ? void 0 : lastResult.deref()) != null ? _a : lastResult;
            if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                result = lastResultValue;
                resultsCount !== 0 && resultsCount--;
            }
            const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
            lastResult = needsWeakRef ? new $375276bea32f9eda$var$Ref(result) : result;
        }
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = $375276bea32f9eda$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $375276bea32f9eda$export$5943f4447f6ef248(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $375276bea32f9eda$var$assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = $375276bea32f9eda$var$__spreadValues($375276bea32f9eda$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        const { memoize: memoize, memoizeOptions: memoizeOptions = [], argsMemoize: argsMemoize = $375276bea32f9eda$export$8402dc26d96f6902, argsMemoizeOptions: argsMemoizeOptions = [], devModeChecks: devModeChecks = {} } = combinedOptions;
        const finalMemoizeOptions = $375276bea32f9eda$var$ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = $375276bea32f9eda$var$ensureIsArray(argsMemoizeOptions);
        const dependencies = $375276bea32f9eda$var$getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const inputSelectorResults = $375276bea32f9eda$var$collectInputSelectorResults(dependencies, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    return createSelector2;
}
var $375276bea32f9eda$export$595d22ed68ca2841 = /* @__PURE__ */ $375276bea32f9eda$export$5943f4447f6ef248($375276bea32f9eda$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $375276bea32f9eda$export$75979cfcd91bf38f = (inputSelectorsObject, selectorCreator = $375276bea32f9eda$export$595d22ed68ca2841)=>{
    $375276bea32f9eda$var$assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
};


// src/index.ts
function $0908524e0b1c11af$var$createThunkMiddleware(extraArgument) {
    const middleware = ({ dispatch: dispatch, getState: getState })=>(next)=>(action)=>{
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
    return middleware;
}
var $0908524e0b1c11af$export$dd164f5517779f15 = $0908524e0b1c11af$var$createThunkMiddleware();
var $0908524e0b1c11af$export$16d06542a1949d9e = $0908524e0b1c11af$var$createThunkMiddleware;


var $cfae44f0dfdf62c0$exports = {};
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = $cfae44f0dfdf62c0$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};


var $d91034f47eb948f2$export$aab6de9e3dbb1473 = (...args)=>{
    const createSelector2 = (0, $375276bea32f9eda$export$5943f4447f6ef248)(...args);
    const createDraftSafeSelector2 = Object.assign((...args2)=>{
        const selector = createSelector2(...args2);
        const wrappedSelector = (value, ...rest)=>selector((0, $5f9e38360d79f95a$export$541ac630993a4c84)(value) ? (0, $5f9e38360d79f95a$export$97aac956da55dae9)(value) : value, ...rest);
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: ()=>createDraftSafeSelector2
    });
    return createDraftSafeSelector2;
};
var $d91034f47eb948f2$export$a5d3c27355e35910 = $d91034f47eb948f2$export$aab6de9e3dbb1473((0, $375276bea32f9eda$export$8402dc26d96f6902));
var $d91034f47eb948f2$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $669d9d4c4c7ccc3c$export$f672e0b6f7222cd7;
    return (0, $669d9d4c4c7ccc3c$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $d91034f47eb948f2$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var $d91034f47eb948f2$var$hasMatchFunction = (v)=>{
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $d91034f47eb948f2$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator(...args) {
        if (prepareAction) {
            let prepared = prepareAction(...args);
            if (!prepared) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(0));
            return {
                type: type,
                payload: prepared.payload,
                ..."meta" in prepared && {
                    meta: prepared.meta
                },
                ..."error" in prepared && {
                    error: prepared.error
                }
            };
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = ()=>`${type}`;
    actionCreator.type = type;
    actionCreator.match = (action)=>(0, $669d9d4c4c7ccc3c$export$b956e38827fca970)(action) && action.type === type;
    return actionCreator;
}
function $d91034f47eb948f2$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $d91034f47eb948f2$var$hasMatchFunction(action);
}
function $d91034f47eb948f2$export$ebd532f9034651f3(action) {
    return (0, $669d9d4c4c7ccc3c$export$b956e38827fca970)(action) && Object.keys(action).every($d91034f47eb948f2$var$isValidKey);
}
function $d91034f47eb948f2$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function $d91034f47eb948f2$var$getMessage(type) {
    const splitType = type ? `${type}`.split("/") : [];
    const actionName = splitType[splitType.length - 1] || "actionCreator";
    return `Detected an action creator with type "${type || "unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function $d91034f47eb948f2$export$6a1fcb4ceef578f(options = {}) {
    var next, action;
    return ()=>(next)=>(action)=>next(action);
}
function $d91034f47eb948f2$var$getTimeMeasureUtils(maxDelay, fnName) {
    let elapsed = 0;
    return {
        measureTime (fn) {
            const started = Date.now();
            try {
                return fn();
            } finally{
                const finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded () {
            if (elapsed > maxDelay) console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
        }
    };
}
function $d91034f47eb948f2$var$find(iterable, comparator) {
    for (const entry of iterable){
        if (comparator(entry)) return entry;
    }
    return void 0;
}
var $d91034f47eb948f2$export$1908877435b1d5e9 = class _Tuple extends Array {
    constructor(...items){
        super(...items);
        Object.setPrototypeOf(this, _Tuple.prototype);
    }
    static get [Symbol.species]() {
        return _Tuple;
    }
    concat(...arr) {
        return super.concat.apply(this, arr);
    }
    prepend(...arr) {
        if (arr.length === 1 && Array.isArray(arr[0])) return new _Tuple(...arr[0].concat(this));
        return new _Tuple(...arr.concat(this));
    }
};
function $d91034f47eb948f2$var$freezeDraftable(val) {
    return (0, $5f9e38360d79f95a$export$16e3aed3edb85946)(val) ? (0, $5f9e38360d79f95a$export$b46cabe22e78bc00)(val, ()=>{}) : val;
}
function $d91034f47eb948f2$var$emplace(map, key, handler) {
    if (map.has(key)) {
        let value = map.get(key);
        if (handler.update) {
            value = handler.update(value, key, map);
            map.set(key, value);
        }
        return value;
    }
    if (!handler.insert) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(10));
    const inserted = handler.insert(key, map);
    map.set(key, inserted);
    return inserted;
}
// src/immutableStateInvariantMiddleware.ts
function $d91034f47eb948f2$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $d91034f47eb948f2$var$trackForMutations(isImmutable, ignorePaths, obj) {
    const trackedProperties = $d91034f47eb948f2$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations () {
            return $d91034f47eb948f2$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $d91034f47eb948f2$var$trackProperties(isImmutable, ignorePaths = [], obj, path = "", checkedObjects = /* @__PURE__ */ new Set()) {
    const tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(const key in obj){
            const childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $d91034f47eb948f2$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $d91034f47eb948f2$var$detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "") {
    const prevObj = trackedProperty ? trackedProperty.value : void 0;
    const sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    const keysToDetect = {};
    for(let key in trackedProperty.children)keysToDetect[key] = true;
    for(let key in obj)keysToDetect[key] = true;
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for(let key in keysToDetect){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        const result = $d91034f47eb948f2$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return result;
    }
    return {
        wasMutated: false
    };
}
function $d91034f47eb948f2$export$9181bb1a5474289(options = {}) {
    var stringify, getSerialize, getState, next, action;
    return ()=>(next)=>(action)=>next(action);
}
function $d91034f47eb948f2$export$77670485918dab4e(val) {
    const type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $669d9d4c4c7ccc3c$export$53b83ca8eaab0383)(val);
}
function $d91034f47eb948f2$export$ada5dca0b571bc7(value, path = "", isSerializable = $d91034f47eb948f2$export$77670485918dab4e, getEntries, ignoredPaths = [], cache) {
    let foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache?.has(value)) return false;
    const entries = getEntries != null ? getEntries(value) : Object.entries(value);
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for (const [key, nestedValue] of entries){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        if (!isSerializable(nestedValue)) return {
            keyPath: nestedPath,
            value: nestedValue
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $d91034f47eb948f2$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return foundNestedSerializable;
        }
    }
    if (cache && $d91034f47eb948f2$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $d91034f47eb948f2$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for (const nestedValue of Object.values(value)){
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$d91034f47eb948f2$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $d91034f47eb948f2$export$6dea1aad6dac5ac2(options = {}) {
    var storeAPI, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/getDefaultMiddleware.ts
function $d91034f47eb948f2$var$isBoolean(x) {
    return typeof x === "boolean";
}
var $d91034f47eb948f2$var$buildGetDefaultMiddleware = ()=>function getDefaultMiddleware(options) {
        const { thunk: thunk = true, immutableCheck: immutableCheck = true, serializableCheck: serializableCheck = true, actionCreatorCheck: actionCreatorCheck = true } = options ?? {};
        let middlewareArray = new $d91034f47eb948f2$export$1908877435b1d5e9();
        if (thunk) {
            if ($d91034f47eb948f2$var$isBoolean(thunk)) middlewareArray.push((0, $0908524e0b1c11af$export$dd164f5517779f15));
            else middlewareArray.push((0, $0908524e0b1c11af$export$16d06542a1949d9e)(thunk.extraArgument));
        }
        return middlewareArray;
    };
// src/autoBatchEnhancer.ts
var $d91034f47eb948f2$export$8fb31c0f05df007b = "RTK_autoBatch";
var $d91034f47eb948f2$export$39fcd5145ec5e4e2 = ()=>(payload)=>({
            payload: payload,
            meta: {
                [$d91034f47eb948f2$export$8fb31c0f05df007b]: true
            }
        });
var $d91034f47eb948f2$var$createQueueWithTimer = (timeout)=>{
    return (notify)=>{
        setTimeout(notify, timeout);
    };
};
var $d91034f47eb948f2$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $d91034f47eb948f2$var$createQueueWithTimer(10);
var $d91034f47eb948f2$export$676277d7dca0f396 = (options = {
    type: "raf"
})=>(next)=>(...args)=>{
            const store = next(...args);
            let notifying = true;
            let shouldNotifyAtEndOfTick = false;
            let notificationQueued = false;
            const listeners = /* @__PURE__ */ new Set();
            const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? $d91034f47eb948f2$var$rAF : options.type === "callback" ? options.queueNotification : $d91034f47eb948f2$var$createQueueWithTimer(options.timeout);
            const notifyListeners = ()=>{
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach((l)=>l());
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe (listener2) {
                    const wrappedListener = ()=>notifying && listener2();
                    const unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return ()=>{
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch (action) {
                    try {
                        notifying = !action?.meta?.[$d91034f47eb948f2$export$8fb31c0f05df007b];
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
// src/getDefaultEnhancers.ts
var $d91034f47eb948f2$var$buildGetDefaultEnhancers = (middlewareEnhancer)=>function getDefaultEnhancers(options) {
        const { autoBatch: autoBatch = true } = options ?? {};
        let enhancerArray = new $d91034f47eb948f2$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($d91034f47eb948f2$export$676277d7dca0f396(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
// src/configureStore.ts
var $d91034f47eb948f2$var$IS_PRODUCTION = true;
function $d91034f47eb948f2$export$7d8a5b498da695ac(options) {
    const getDefaultMiddleware = $d91034f47eb948f2$var$buildGetDefaultMiddleware();
    const { reducer: reducer, middleware: middleware, devTools: devTools = true, preloadedState: preloadedState, enhancers: enhancers } = options || {};
    let rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $669d9d4c4c7ccc3c$export$53b83ca8eaab0383)(reducer)) rootReducer = (0, $669d9d4c4c7ccc3c$export$66e4520cdb265d18)(reducer);
    else throw new Error($d91034f47eb948f2$export$378fa86b259c0280(1));
    if (!$d91034f47eb948f2$var$IS_PRODUCTION && middleware && typeof middleware !== "function") throw new Error($d91034f47eb948f2$export$378fa86b259c0280(2));
    let finalMiddleware;
    if (typeof middleware === "function") {
        finalMiddleware = middleware(getDefaultMiddleware);
        if (!$d91034f47eb948f2$var$IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(3));
    } else finalMiddleware = getDefaultMiddleware();
    if (!$d91034f47eb948f2$var$IS_PRODUCTION && finalMiddleware.some((item)=>typeof item !== "function")) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(4));
    let finalCompose = (0, $669d9d4c4c7ccc3c$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $d91034f47eb948f2$var$composeWithDevTools({
        // Enable capture of stack traces for dispatched Redux actions
        trace: !$d91034f47eb948f2$var$IS_PRODUCTION,
        ...typeof devTools === "object" && devTools
    });
    const middlewareEnhancer = (0, $669d9d4c4c7ccc3c$export$9ff26e0402cc7b7)(...finalMiddleware);
    const getDefaultEnhancers = $d91034f47eb948f2$var$buildGetDefaultEnhancers(middlewareEnhancer);
    if (!$d91034f47eb948f2$var$IS_PRODUCTION && enhancers && typeof enhancers !== "function") throw new Error($d91034f47eb948f2$export$378fa86b259c0280(5));
    let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    if (!$d91034f47eb948f2$var$IS_PRODUCTION && !Array.isArray(storeEnhancers)) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(6));
    if (!$d91034f47eb948f2$var$IS_PRODUCTION && storeEnhancers.some((item)=>typeof item !== "function")) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(7));
    if (!$d91034f47eb948f2$var$IS_PRODUCTION && finalMiddleware.length && !storeEnhancers.includes(middlewareEnhancer)) console.error("middlewares were provided, but middleware enhancer was not included in final enhancers - make sure to call `getDefaultEnhancers`");
    const composedEnhancer = finalCompose(...storeEnhancers);
    return (0, $669d9d4c4c7ccc3c$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $d91034f47eb948f2$var$executeReducerBuilderCallback(builderCallback) {
    const actionsMap = {};
    const actionMatchers = [];
    let defaultCaseReducer;
    const builder = {
        addCase (typeOrActionCreator, reducer) {
            const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher (matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase (reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $d91034f47eb948f2$var$isStateFunction(x) {
    return typeof x === "function";
}
function $d91034f47eb948f2$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = $d91034f47eb948f2$var$executeReducerBuilderCallback(mapOrBuilderCallback);
    let getInitialState;
    if ($d91034f47eb948f2$var$isStateFunction(initialState)) getInitialState = ()=>$d91034f47eb948f2$var$freezeDraftable(initialState());
    else {
        const frozenInitialState = $d91034f47eb948f2$var$freezeDraftable(initialState);
        getInitialState = ()=>frozenInitialState;
    }
    function reducer(state = getInitialState(), action) {
        let caseReducers = [
            actionsMap[action.type],
            ...finalActionMatchers.filter(({ matcher: matcher })=>matcher(action)).map(({ reducer: reducer2 })=>reducer2)
        ];
        if (caseReducers.filter((cr)=>!!cr).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce((previousState, caseReducer)=>{
            if (caseReducer) {
                if ((0, $5f9e38360d79f95a$export$541ac630993a4c84)(previousState)) {
                    const draft = previousState;
                    const result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $5f9e38360d79f95a$export$16e3aed3edb85946)(previousState)) {
                    const result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw new Error($d91034f47eb948f2$export$378fa86b259c0280(9));
                    }
                    return result;
                } else return (0, $5f9e38360d79f95a$export$b46cabe22e78bc00)(previousState, (draft)=>{
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/nanoid.ts
var $d91034f47eb948f2$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $d91034f47eb948f2$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $d91034f47eb948f2$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/matchers.ts
var $d91034f47eb948f2$var$matches = (matcher, action)=>{
    if ($d91034f47eb948f2$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $d91034f47eb948f2$export$2c3435c7647f7b0d(...matchers) {
    return (action)=>{
        return matchers.some((matcher)=>$d91034f47eb948f2$var$matches(matcher, action));
    };
}
function $d91034f47eb948f2$export$9dd1fb32974da385(...matchers) {
    return (action)=>{
        return matchers.every((matcher)=>$d91034f47eb948f2$var$matches(matcher, action));
    };
}
function $d91034f47eb948f2$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    const hasValidRequestId = typeof action.meta.requestId === "string";
    const hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $d91034f47eb948f2$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $d91034f47eb948f2$export$872dec21e9a69476(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$d91034f47eb948f2$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$872dec21e9a69476()(asyncThunks[0]);
    return (action)=>{
        const matchers = asyncThunks.map((asyncThunk)=>asyncThunk.pending);
        const combinedMatcher = $d91034f47eb948f2$export$2c3435c7647f7b0d(...matchers);
        return combinedMatcher(action);
    };
}
function $d91034f47eb948f2$export$a5c5d27e3994c5be(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$d91034f47eb948f2$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return (action)=>{
        const matchers = asyncThunks.map((asyncThunk)=>asyncThunk.rejected);
        const combinedMatcher = $d91034f47eb948f2$export$2c3435c7647f7b0d(...matchers);
        return combinedMatcher(action);
    };
}
function $d91034f47eb948f2$export$fcc3388fb56de601(...asyncThunks) {
    const hasFlag = (action)=>{
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return (action)=>{
        const combinedMatcher = $d91034f47eb948f2$export$9dd1fb32974da385($d91034f47eb948f2$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$fcc3388fb56de601()(asyncThunks[0]);
    return (action)=>{
        const combinedMatcher = $d91034f47eb948f2$export$9dd1fb32974da385($d91034f47eb948f2$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function $d91034f47eb948f2$export$1da80a6ef1307441(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$d91034f47eb948f2$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$1da80a6ef1307441()(asyncThunks[0]);
    return (action)=>{
        const matchers = asyncThunks.map((asyncThunk)=>asyncThunk.fulfilled);
        const combinedMatcher = $d91034f47eb948f2$export$2c3435c7647f7b0d(...matchers);
        return combinedMatcher(action);
    };
}
function $d91034f47eb948f2$export$6aa4142d99c1abce(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$d91034f47eb948f2$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$6aa4142d99c1abce()(asyncThunks[0]);
    return (action)=>{
        const matchers = [];
        for (const asyncThunk of asyncThunks)matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        const combinedMatcher = $d91034f47eb948f2$export$2c3435c7647f7b0d(...matchers);
        return combinedMatcher(action);
    };
}
// src/createAsyncThunk.ts
var $d91034f47eb948f2$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $d91034f47eb948f2$var$RejectWithValue = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
    }
    /*
  type-only property to distinguish between RejectWithValue and FulfillWithMeta
  does not exist at runtime
  */ _type;
};
var $d91034f47eb948f2$var$FulfillWithMeta = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
    }
    /*
  type-only property to distinguish between RejectWithValue and FulfillWithMeta
  does not exist at runtime
  */ _type;
};
var $d91034f47eb948f2$export$c97c53d0b2d5d81e = (value)=>{
    if (typeof value === "object" && value !== null) {
        const simpleError = {};
        for (const property of $d91034f47eb948f2$var$commonProperties)if (typeof value[property] === "string") simpleError[property] = value[property];
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $d91034f47eb948f2$export$6abd22dc03e5063f = /* @__PURE__ */ (()=>{
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        const fulfilled = $d91034f47eb948f2$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", (payload, requestId, arg, meta)=>({
                payload: payload,
                meta: {
                    ...meta || {},
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                }
            }));
        const pending = $d91034f47eb948f2$export$309c7a02b0b0bc62(typePrefix + "/pending", (requestId, arg, meta)=>({
                payload: void 0,
                meta: {
                    ...meta || {},
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                }
            }));
        const rejected = $d91034f47eb948f2$export$309c7a02b0b0bc62(typePrefix + "/rejected", (error, requestId, arg, payload, meta)=>({
                payload: payload,
                error: (options && options.serializeError || $d91034f47eb948f2$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: {
                    ...meta || {},
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: error?.name === "AbortError",
                    condition: error?.name === "ConditionError"
                }
            }));
        function actionCreator(arg) {
            return (dispatch, getState, extra)=>{
                const requestId = options?.idGenerator ? options.idGenerator(arg) : $d91034f47eb948f2$export$ac4959f4f1338dfc();
                const abortController = new AbortController();
                let abortHandler;
                let abortReason;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                const promise = async function() {
                    let finalAction;
                    try {
                        let conditionResult = options?.condition?.(arg, {
                            getState: getState,
                            extra: extra
                        });
                        if ($d91034f47eb948f2$var$isThenable(conditionResult)) conditionResult = await conditionResult;
                        if (conditionResult === false || abortController.signal.aborted) throw {
                            name: "ConditionError",
                            message: "Aborted due to condition callback returning false."
                        };
                        const abortedPromise = new Promise((_, reject)=>{
                            abortHandler = ()=>{
                                reject({
                                    name: "AbortError",
                                    message: abortReason || "Aborted"
                                });
                            };
                            abortController.signal.addEventListener("abort", abortHandler);
                        });
                        dispatch(pending(requestId, arg, options?.getPendingMeta?.({
                            requestId: requestId,
                            arg: arg
                        }, {
                            getState: getState,
                            extra: extra
                        })));
                        finalAction = await Promise.race([
                            abortedPromise,
                            Promise.resolve(payloadCreator(arg, {
                                dispatch: dispatch,
                                getState: getState,
                                extra: extra,
                                requestId: requestId,
                                signal: abortController.signal,
                                abort: abort,
                                rejectWithValue: (value, meta)=>{
                                    return new $d91034f47eb948f2$var$RejectWithValue(value, meta);
                                },
                                fulfillWithValue: (value, meta)=>{
                                    return new $d91034f47eb948f2$var$FulfillWithMeta(value, meta);
                                }
                            })).then((result)=>{
                                if (result instanceof $d91034f47eb948f2$var$RejectWithValue) throw result;
                                if (result instanceof $d91034f47eb948f2$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                return fulfilled(result, requestId, arg);
                            })
                        ]);
                    } catch (err) {
                        finalAction = err instanceof $d91034f47eb948f2$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                    } finally{
                        if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                    }
                    const skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                    if (!skipDispatch) dispatch(finalAction);
                    return finalAction;
                }();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap () {
                        return promise.then($d91034f47eb948f2$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $d91034f47eb948f2$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = ()=>createAsyncThunk2;
    return createAsyncThunk2;
})();
function $d91034f47eb948f2$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $d91034f47eb948f2$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var $d91034f47eb948f2$var$asyncThunkSymbol = Symbol.for("rtk-slice-createasyncthunk");
var $d91034f47eb948f2$export$343355ed40c51c46 = {
    [$d91034f47eb948f2$var$asyncThunkSymbol]: $d91034f47eb948f2$export$6abd22dc03e5063f
};
var $d91034f47eb948f2$export$23a094319a4b586 = /* @__PURE__ */ ((ReducerType2)=>{
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
})($d91034f47eb948f2$export$23a094319a4b586 || {});
function $d91034f47eb948f2$var$getType(slice, actionKey) {
    return `${slice}/${actionKey}`;
}
function $d91034f47eb948f2$export$affdea4146de9cf5({ creators: creators } = {}) {
    const cAT = creators?.asyncThunk?.[$d91034f47eb948f2$var$asyncThunkSymbol];
    return function createSlice2(options) {
        const { name: name, reducerPath: reducerPath = name } = options;
        if (!name) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(11));
        typeof $cfae44f0dfdf62c0$exports;
        const reducers = (typeof options.reducers === "function" ? options.reducers($d91034f47eb948f2$var$buildReducerCreators()) : options.reducers) || {};
        const reducerNames = Object.keys(reducers);
        const context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        const contextMethods = {
            addCase (typeOrActionCreator, reducer2) {
                const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher (matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction (name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer (name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach((reducerName)=>{
            const reducerDefinition = reducers[reducerName];
            const reducerDetails = {
                reducerName: reducerName,
                type: $d91034f47eb948f2$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($d91034f47eb948f2$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $d91034f47eb948f2$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $d91034f47eb948f2$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            const [extraReducers = {}, actionMatchers = [], defaultCaseReducer] = typeof options.extraReducers === "function" ? $d91034f47eb948f2$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ];
            const finalCaseReducers = {
                ...extraReducers,
                ...context.sliceCaseReducersByType
            };
            return $d91034f47eb948f2$export$473eb76d322d0290(options.initialState, (builder)=>{
                for(let key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                for (let sM of context.sliceMatchers)builder.addMatcher(sM.matcher, sM.reducer);
                for (let m of actionMatchers)builder.addMatcher(m.matcher, m.reducer);
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        const selectSelf = (state)=>state;
        const injectedSelectorCache = /* @__PURE__ */ new Map();
        let _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2, injected = false) {
            function selectSlice(state) {
                let sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = getInitialState();
                }
                return sliceState;
            }
            function getSelectors(selectState = selectSelf) {
                const selectorCache = $d91034f47eb948f2$var$emplace(injectedSelectorCache, injected, {
                    insert: ()=>/* @__PURE__ */ new WeakMap()
                });
                return $d91034f47eb948f2$var$emplace(selectorCache, selectState, {
                    insert: ()=>{
                        const map = {};
                        for (const [name2, selector] of Object.entries(options.selectors ?? {}))map[name2] = $d91034f47eb948f2$var$wrapSelector(selector, selectState, getInitialState, injected);
                        return map;
                    }
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        const slice = {
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState,
            ...makeSelectorProps(reducerPath),
            injectInto (injectable, { reducerPath: pathOpt, ...config } = {}) {
                const newReducerPath = pathOpt ?? reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return {
                    ...slice,
                    ...makeSelectorProps(newReducerPath, true)
                };
            }
        };
        return slice;
    };
}
function $d91034f47eb948f2$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState, ...args) {
        let sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector(sliceState, ...args);
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var $d91034f47eb948f2$export$4d8d9bd83c24ae8b = $d91034f47eb948f2$export$affdea4146de9cf5();
function $d91034f47eb948f2$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return {
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator: payloadCreator,
            ...config
        };
    }
    asyncThunk.withTypes = ()=>asyncThunk;
    return {
        reducer (caseReducer) {
            return Object.assign({
                // hack so the wrapping function has the same name as the original
                // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
                [caseReducer.name] (...args) {
                    return caseReducer(...args);
                }
            }[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer (prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $d91034f47eb948f2$var$handleNormalReducerDefinition({ type: type, reducerName: reducerName, createNotation: createNotation }, maybeReducerWithPrepare, context) {
    let caseReducer;
    let prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$d91034f47eb948f2$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $d91034f47eb948f2$export$309c7a02b0b0bc62(type, prepareCallback) : $d91034f47eb948f2$export$309c7a02b0b0bc62(type));
}
function $d91034f47eb948f2$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function $d91034f47eb948f2$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function $d91034f47eb948f2$var$handleThunkCaseReducerDefinition({ type: type, reducerName: reducerName }, reducerDefinition, context, cAT) {
    if (!cAT) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(18));
    const { payloadCreator: payloadCreator, fulfilled: fulfilled, pending: pending, rejected: rejected, settled: settled, options: options } = reducerDefinition;
    const thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $d91034f47eb948f2$var$noop,
        pending: pending || $d91034f47eb948f2$var$noop,
        rejected: rejected || $d91034f47eb948f2$var$noop,
        settled: settled || $d91034f47eb948f2$var$noop
    });
}
function $d91034f47eb948f2$var$noop() {}
// src/entities/entity_state.ts
function $d91034f47eb948f2$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $d91034f47eb948f2$var$createInitialStateFactory() {
    function getInitialState(additionalState = {}) {
        return Object.assign($d91034f47eb948f2$var$getInitialEntityState(), additionalState);
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $d91034f47eb948f2$var$createSelectorsFactory() {
    function getSelectors(selectState, options = {}) {
        const { createSelector: createSelector2 = $d91034f47eb948f2$export$a5d3c27355e35910 } = options;
        const selectIds = (state)=>state.ids;
        const selectEntities = (state)=>state.entities;
        const selectAll = createSelector2(selectIds, selectEntities, (ids, entities)=>ids.map((id)=>entities[id]));
        const selectId = (_, id)=>id;
        const selectById = (entities, id)=>entities[id];
        const selectTotal = createSelector2(selectIds, (ids)=>ids.length);
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        const selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
var $d91034f47eb948f2$var$isDraftTyped = (0, $5f9e38360d79f95a$export$541ac630993a4c84);
function $d91034f47eb948f2$var$createSingleArgumentStateOperator(mutator) {
    const operator = $d91034f47eb948f2$var$createStateOperator((_, state)=>mutator(state));
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $d91034f47eb948f2$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $d91034f47eb948f2$export$ebd532f9034651f3(arg2);
        }
        const runMutator = (draft)=>{
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($d91034f47eb948f2$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $5f9e38360d79f95a$export$b46cabe22e78bc00)(state, runMutator);
    };
}
// src/entities/utils.ts
function $d91034f47eb948f2$var$selectIdValue(entity, selectId) {
    const key = selectId(entity);
    return key;
}
function $d91034f47eb948f2$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $d91034f47eb948f2$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
    const added = [];
    const updated = [];
    for (const entity of newEntities){
        const id = $d91034f47eb948f2$var$selectIdValue(entity, selectId);
        if (id in state.entities) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated
    ];
}
// src/entities/unsorted_state_adapter.ts
function $d91034f47eb948f2$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        const key = $d91034f47eb948f2$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)addOneMutably(entity, state);
    }
    function setOneMutably(entity, state) {
        const key = $d91034f47eb948f2$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)setOneMutably(entity, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        let didMutate = false;
        keys.forEach((key)=>{
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter((id)=>id in state.entities);
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        const original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        const updated = Object.assign({}, original3, update.changes);
        const newKey = $d91034f47eb948f2$var$selectIdValue(updated, selectId);
        const hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        const newKeys = {};
        const updatesPerEntity = {};
        updates.forEach((update)=>{
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: {
                    ...updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null,
                    ...update.changes
                }
            };
        });
        updates = Object.values(updatesPerEntity);
        const didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            const didMutateIds = updates.filter((update)=>takeNewKey(newKeys, update, state)).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map((e)=>$d91034f47eb948f2$var$selectIdValue(e, selectId));
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = $d91034f47eb948f2$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $d91034f47eb948f2$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $d91034f47eb948f2$var$createStateOperator(addOneMutably),
        addMany: $d91034f47eb948f2$var$createStateOperator(addManyMutably),
        setOne: $d91034f47eb948f2$var$createStateOperator(setOneMutably),
        setMany: $d91034f47eb948f2$var$createStateOperator(setManyMutably),
        setAll: $d91034f47eb948f2$var$createStateOperator(setAllMutably),
        updateOne: $d91034f47eb948f2$var$createStateOperator(updateOneMutably),
        updateMany: $d91034f47eb948f2$var$createStateOperator(updateManyMutably),
        upsertOne: $d91034f47eb948f2$var$createStateOperator(upsertOneMutably),
        upsertMany: $d91034f47eb948f2$var$createStateOperator(upsertManyMutably),
        removeOne: $d91034f47eb948f2$var$createStateOperator(removeOneMutably),
        removeMany: $d91034f47eb948f2$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $d91034f47eb948f2$var$createSortedStateAdapter(selectId, sort) {
    const { removeOne: removeOne, removeMany: removeMany, removeAll: removeAll } = $d91034f47eb948f2$var$createUnsortedStateAdapter(selectId);
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        const models = newEntities.filter((model)=>!($d91034f47eb948f2$var$selectIdValue(model, selectId) in state.entities));
        if (models.length !== 0) merge(models, state);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) merge(newEntities, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        let appliedUpdates = false;
        for (let update of updates){
            const entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            const newId = selectId(entity);
            if (update.id !== newId) {
                delete state.entities[update.id];
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) resortEntities(state);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = $d91034f47eb948f2$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length && i < b.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach((model)=>{
            state.entities[selectId(model)] = model;
        });
        resortEntities(state);
    }
    function resortEntities(state) {
        const allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        const newSortedIds = allEntities.map(selectId);
        const { ids: ids } = state;
        if (!areArraysEqual(ids, newSortedIds)) state.ids = newSortedIds;
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $d91034f47eb948f2$var$createStateOperator(addOneMutably),
        updateOne: $d91034f47eb948f2$var$createStateOperator(updateOneMutably),
        upsertOne: $d91034f47eb948f2$var$createStateOperator(upsertOneMutably),
        setOne: $d91034f47eb948f2$var$createStateOperator(setOneMutably),
        setMany: $d91034f47eb948f2$var$createStateOperator(setManyMutably),
        setAll: $d91034f47eb948f2$var$createStateOperator(setAllMutably),
        addMany: $d91034f47eb948f2$var$createStateOperator(addManyMutably),
        updateMany: $d91034f47eb948f2$var$createStateOperator(updateManyMutably),
        upsertMany: $d91034f47eb948f2$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $d91034f47eb948f2$export$abcf4037b41e0df(options = {}) {
    const { selectId: selectId, sortComparer: sortComparer } = {
        sortComparer: false,
        selectId: (instance)=>instance.id,
        ...options
    };
    const stateFactory = $d91034f47eb948f2$var$createInitialStateFactory();
    const selectorsFactory = $d91034f47eb948f2$var$createSelectorsFactory();
    const stateAdapter = sortComparer ? $d91034f47eb948f2$var$createSortedStateAdapter(selectId, sortComparer) : $d91034f47eb948f2$var$createUnsortedStateAdapter(selectId);
    return {
        selectId: selectId,
        sortComparer: sortComparer,
        ...stateFactory,
        ...selectorsFactory,
        ...stateAdapter
    };
}
// src/listenerMiddleware/exceptions.ts
var $d91034f47eb948f2$var$task = "task";
var $d91034f47eb948f2$var$listener = "listener";
var $d91034f47eb948f2$var$completed = "completed";
var $d91034f47eb948f2$var$cancelled = "cancelled";
var $d91034f47eb948f2$var$taskCancelled = `task-${$d91034f47eb948f2$var$cancelled}`;
var $d91034f47eb948f2$var$taskCompleted = `task-${$d91034f47eb948f2$var$completed}`;
var $d91034f47eb948f2$var$listenerCancelled = `${$d91034f47eb948f2$var$listener}-${$d91034f47eb948f2$var$cancelled}`;
var $d91034f47eb948f2$var$listenerCompleted = `${$d91034f47eb948f2$var$listener}-${$d91034f47eb948f2$var$completed}`;
var $d91034f47eb948f2$export$cb1bdac908fed7f = class {
    constructor(code){
        this.code = code;
        this.message = `${$d91034f47eb948f2$var$task} ${$d91034f47eb948f2$var$cancelled} (reason: ${code})`;
    }
    name = "TaskAbortError";
    message;
};
// src/listenerMiddleware/utils.ts
var $d91034f47eb948f2$var$assertFunction = (func, expected)=>{
    if (typeof func !== "function") throw new Error($d91034f47eb948f2$export$378fa86b259c0280(32));
};
var $d91034f47eb948f2$var$noop2 = ()=>{};
var $d91034f47eb948f2$var$catchRejection = (promise, onError = $d91034f47eb948f2$var$noop2)=>{
    promise.catch(onError);
    return promise;
};
var $d91034f47eb948f2$var$addAbortSignalListener = (abortSignal, callback)=>{
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return ()=>abortSignal.removeEventListener("abort", callback);
};
var $d91034f47eb948f2$var$abortControllerWithReason = (abortController, reason)=>{
    const signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/task.ts
var $d91034f47eb948f2$var$validateActive = (signal)=>{
    if (signal.aborted) {
        const { reason: reason } = signal;
        throw new $d91034f47eb948f2$export$cb1bdac908fed7f(reason);
    }
};
function $d91034f47eb948f2$var$raceWithSignal(signal, promise) {
    let cleanup = $d91034f47eb948f2$var$noop2;
    return new Promise((resolve, reject)=>{
        const notifyRejection = ()=>reject(new $d91034f47eb948f2$export$cb1bdac908fed7f(signal.reason));
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $d91034f47eb948f2$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(()=>cleanup()).then(resolve, reject);
    }).finally(()=>{
        cleanup = $d91034f47eb948f2$var$noop2;
    });
}
var $d91034f47eb948f2$var$runTask = async (task2, cleanUp)=>{
    try {
        await Promise.resolve();
        const value = await task2();
        return {
            status: "ok",
            value: value
        };
    } catch (error) {
        return {
            status: error instanceof $d91034f47eb948f2$export$cb1bdac908fed7f ? "cancelled" : "rejected",
            error: error
        };
    } finally{
        cleanUp?.();
    }
};
var $d91034f47eb948f2$var$createPause = (signal)=>{
    return (promise)=>{
        return $d91034f47eb948f2$var$catchRejection($d91034f47eb948f2$var$raceWithSignal(signal, promise).then((output)=>{
            $d91034f47eb948f2$var$validateActive(signal);
            return output;
        }));
    };
};
var $d91034f47eb948f2$var$createDelay = (signal)=>{
    const pause = $d91034f47eb948f2$var$createPause(signal);
    return (timeoutMs)=>{
        return pause(new Promise((resolve)=>setTimeout(resolve, timeoutMs)));
    };
};
// src/listenerMiddleware/index.ts
var { assign: $d91034f47eb948f2$var$assign } = Object;
var $d91034f47eb948f2$var$INTERNAL_NIL_TOKEN = {};
var $d91034f47eb948f2$var$alm = "listenerMiddleware";
var $d91034f47eb948f2$var$createFork = (parentAbortSignal, parentBlockingPromises)=>{
    const linkControllers = (controller)=>$d91034f47eb948f2$var$addAbortSignalListener(parentAbortSignal, ()=>$d91034f47eb948f2$var$abortControllerWithReason(controller, parentAbortSignal.reason));
    return (taskExecutor, opts)=>{
        $d91034f47eb948f2$var$assertFunction(taskExecutor, "taskExecutor");
        const childAbortController = new AbortController();
        linkControllers(childAbortController);
        const result = $d91034f47eb948f2$var$runTask(async ()=>{
            $d91034f47eb948f2$var$validateActive(parentAbortSignal);
            $d91034f47eb948f2$var$validateActive(childAbortController.signal);
            const result2 = await taskExecutor({
                pause: $d91034f47eb948f2$var$createPause(childAbortController.signal),
                delay: $d91034f47eb948f2$var$createDelay(childAbortController.signal),
                signal: childAbortController.signal
            });
            $d91034f47eb948f2$var$validateActive(childAbortController.signal);
            return result2;
        }, ()=>$d91034f47eb948f2$var$abortControllerWithReason(childAbortController, $d91034f47eb948f2$var$taskCompleted));
        if (opts?.autoJoin) parentBlockingPromises.push(result.catch($d91034f47eb948f2$var$noop2));
        return {
            result: $d91034f47eb948f2$var$createPause(parentAbortSignal)(result),
            cancel () {
                $d91034f47eb948f2$var$abortControllerWithReason(childAbortController, $d91034f47eb948f2$var$taskCancelled);
            }
        };
    };
};
var $d91034f47eb948f2$var$createTakePattern = (startListening, signal)=>{
    const take = async (predicate, timeout)=>{
        $d91034f47eb948f2$var$validateActive(signal);
        let unsubscribe = ()=>{};
        const tuplePromise = new Promise((resolve, reject)=>{
            let stopListening = startListening({
                predicate: predicate,
                effect: (action, listenerApi)=>{
                    listenerApi.unsubscribe();
                    resolve([
                        action,
                        listenerApi.getState(),
                        listenerApi.getOriginalState()
                    ]);
                }
            });
            unsubscribe = ()=>{
                stopListening();
                reject();
            };
        });
        const promises = [
            tuplePromise
        ];
        if (timeout != null) promises.push(new Promise((resolve)=>setTimeout(resolve, timeout, null)));
        try {
            const output = await $d91034f47eb948f2$var$raceWithSignal(signal, Promise.race(promises));
            $d91034f47eb948f2$var$validateActive(signal);
            return output;
        } finally{
            unsubscribe();
        }
    };
    return (predicate, timeout)=>$d91034f47eb948f2$var$catchRejection(take(predicate, timeout));
};
var $d91034f47eb948f2$var$getListenerEntryPropsFrom = (options)=>{
    let { type: type, actionCreator: actionCreator, matcher: matcher, predicate: predicate, effect: effect } = options;
    if (type) predicate = $d91034f47eb948f2$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($d91034f47eb948f2$export$378fa86b259c0280(21));
    $d91034f47eb948f2$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $d91034f47eb948f2$var$createListenerEntry = Object.assign((options)=>{
    const { type: type, predicate: predicate, effect: effect } = $d91034f47eb948f2$var$getListenerEntryPropsFrom(options);
    const id = $d91034f47eb948f2$export$ac4959f4f1338dfc();
    const entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: ()=>{
            throw new Error($d91034f47eb948f2$export$378fa86b259c0280(22));
        }
    };
    return entry;
}, {
    withTypes: ()=>$d91034f47eb948f2$var$createListenerEntry
});
var $d91034f47eb948f2$var$cancelActiveListeners = (entry)=>{
    entry.pending.forEach((controller)=>{
        $d91034f47eb948f2$var$abortControllerWithReason(controller, $d91034f47eb948f2$var$listenerCancelled);
    });
};
var $d91034f47eb948f2$var$createClearListenerMiddleware = (listenerMap)=>{
    return ()=>{
        listenerMap.forEach($d91034f47eb948f2$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $d91034f47eb948f2$var$safelyNotifyError = (errorHandler, errorToNotify, errorInfo)=>{
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(()=>{
            throw errorHandlerError;
        }, 0);
    }
};
var $d91034f47eb948f2$export$f03a6b845d3fb58b = Object.assign($d91034f47eb948f2$export$309c7a02b0b0bc62(`${$d91034f47eb948f2$var$alm}/add`), {
    withTypes: ()=>$d91034f47eb948f2$export$f03a6b845d3fb58b
});
var $d91034f47eb948f2$export$b1b8022855fb2b71 = $d91034f47eb948f2$export$309c7a02b0b0bc62(`${$d91034f47eb948f2$var$alm}/removeAll`);
var $d91034f47eb948f2$export$b03e9483f936dccb = Object.assign($d91034f47eb948f2$export$309c7a02b0b0bc62(`${$d91034f47eb948f2$var$alm}/remove`), {
    withTypes: ()=>$d91034f47eb948f2$export$b03e9483f936dccb
});
var $d91034f47eb948f2$var$defaultErrorHandler = (...args)=>{
    console.error(`${$d91034f47eb948f2$var$alm}/error`, ...args);
};
var $d91034f47eb948f2$export$1228acebbbcb485b = (middlewareOptions = {})=>{
    const listenerMap = /* @__PURE__ */ new Map();
    const { extra: extra, onError: onError = $d91034f47eb948f2$var$defaultErrorHandler } = middlewareOptions;
    $d91034f47eb948f2$var$assertFunction(onError, "onError");
    const insertEntry = (entry)=>{
        entry.unsubscribe = ()=>listenerMap.delete(entry.id);
        listenerMap.set(entry.id, entry);
        return (cancelOptions)=>{
            entry.unsubscribe();
            if (cancelOptions?.cancelActive) $d91034f47eb948f2$var$cancelActiveListeners(entry);
        };
    };
    const startListening = (options)=>{
        let entry = $d91034f47eb948f2$var$find(Array.from(listenerMap.values()), (existingEntry)=>existingEntry.effect === options.effect);
        if (!entry) entry = $d91034f47eb948f2$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    Object.assign(startListening, {
        withTypes: ()=>startListening
    });
    const stopListening = (options)=>{
        const { type: type, effect: effect, predicate: predicate } = $d91034f47eb948f2$var$getListenerEntryPropsFrom(options);
        const entry = $d91034f47eb948f2$var$find(Array.from(listenerMap.values()), (entry2)=>{
            const matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $d91034f47eb948f2$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    Object.assign(stopListening, {
        withTypes: ()=>stopListening
    });
    const notifyListener = async (entry, action, api, getOriginalState)=>{
        const internalTaskController = new AbortController();
        const take = $d91034f47eb948f2$var$createTakePattern(startListening, internalTaskController.signal);
        const autoJoinPromises = [];
        try {
            entry.pending.add(internalTaskController);
            await Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
            $d91034f47eb948f2$var$assign({}, api, {
                getOriginalState: getOriginalState,
                condition: (predicate, timeout)=>take(predicate, timeout).then(Boolean),
                take: take,
                delay: $d91034f47eb948f2$var$createDelay(internalTaskController.signal),
                pause: $d91034f47eb948f2$var$createPause(internalTaskController.signal),
                extra: extra,
                signal: internalTaskController.signal,
                fork: $d91034f47eb948f2$var$createFork(internalTaskController.signal, autoJoinPromises),
                unsubscribe: entry.unsubscribe,
                subscribe: ()=>{
                    listenerMap.set(entry.id, entry);
                },
                cancelActiveListeners: ()=>{
                    entry.pending.forEach((controller, _, set)=>{
                        if (controller !== internalTaskController) {
                            $d91034f47eb948f2$var$abortControllerWithReason(controller, $d91034f47eb948f2$var$listenerCancelled);
                            set.delete(controller);
                        }
                    });
                },
                cancel: ()=>{
                    $d91034f47eb948f2$var$abortControllerWithReason(internalTaskController, $d91034f47eb948f2$var$listenerCancelled);
                    entry.pending.delete(internalTaskController);
                },
                throwIfCancelled: ()=>{
                    $d91034f47eb948f2$var$validateActive(internalTaskController.signal);
                }
            })));
        } catch (listenerError) {
            if (!(listenerError instanceof $d91034f47eb948f2$export$cb1bdac908fed7f)) $d91034f47eb948f2$var$safelyNotifyError(onError, listenerError, {
                raisedBy: "effect"
            });
        } finally{
            await Promise.all(autoJoinPromises);
            $d91034f47eb948f2$var$abortControllerWithReason(internalTaskController, $d91034f47eb948f2$var$listenerCompleted);
            entry.pending.delete(internalTaskController);
        }
    };
    const clearListenerMiddleware = $d91034f47eb948f2$var$createClearListenerMiddleware(listenerMap);
    const middleware = (api)=>(next)=>(action)=>{
                if (!(0, $669d9d4c4c7ccc3c$export$b956e38827fca970)(action)) return next(action);
                if ($d91034f47eb948f2$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($d91034f47eb948f2$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($d91034f47eb948f2$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                let originalState = api.getState();
                const getOriginalState = ()=>{
                    if (originalState === $d91034f47eb948f2$var$INTERNAL_NIL_TOKEN) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(23));
                    return originalState;
                };
                let result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        const currentState = api.getState();
                        const listenerEntries = Array.from(listenerMap.values());
                        for (const entry of listenerEntries){
                            let runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $d91034f47eb948f2$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $d91034f47eb948f2$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
var $d91034f47eb948f2$var$createMiddlewareEntry = (middleware)=>({
        id: $d91034f47eb948f2$export$ac4959f4f1338dfc(),
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    });
var $d91034f47eb948f2$var$matchInstance = (instanceId)=>(action)=>action?.meta?.instanceId === instanceId;
var $d91034f47eb948f2$export$4bb1606a79445586 = ()=>{
    const instanceId = $d91034f47eb948f2$export$ac4959f4f1338dfc();
    const middlewareMap = /* @__PURE__ */ new Map();
    const withMiddleware = Object.assign($d91034f47eb948f2$export$309c7a02b0b0bc62("dynamicMiddleware/add", (...middlewares)=>({
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        })), {
        withTypes: ()=>withMiddleware
    });
    const addMiddleware = Object.assign(function addMiddleware2(...middlewares) {
        middlewares.forEach((middleware2)=>{
            let entry = $d91034f47eb948f2$var$find(Array.from(middlewareMap.values()), (entry2)=>entry2.middleware === middleware2);
            if (!entry) entry = $d91034f47eb948f2$var$createMiddlewareEntry(middleware2);
            middlewareMap.set(entry.id, entry);
        });
    }, {
        withTypes: ()=>addMiddleware
    });
    const getFinalMiddleware = (api)=>{
        const appliedMiddleware = Array.from(middlewareMap.values()).map((entry)=>$d91034f47eb948f2$var$emplace(entry.applied, api, {
                insert: ()=>entry.middleware(api)
            }));
        return (0, $669d9d4c4c7ccc3c$export$f672e0b6f7222cd7)(...appliedMiddleware);
    };
    const isWithMiddleware = $d91034f47eb948f2$export$9dd1fb32974da385(withMiddleware, $d91034f47eb948f2$var$matchInstance(instanceId));
    const middleware = (api)=>(next)=>(action)=>{
                if (isWithMiddleware(action)) {
                    addMiddleware(...action.payload);
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
var $d91034f47eb948f2$var$isSliceLike = (maybeSliceLike)=>"reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
var $d91034f47eb948f2$var$getReducers = (slices)=>slices.flatMap((sliceOrMap)=>$d91034f47eb948f2$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap));
var $d91034f47eb948f2$var$ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
var $d91034f47eb948f2$var$isStateProxy = (value)=>!!value && !!value[$d91034f47eb948f2$var$ORIGINAL_STATE];
var $d91034f47eb948f2$var$stateProxyMap = /* @__PURE__ */ new WeakMap();
var $d91034f47eb948f2$var$createStateProxy = (state, reducerMap)=>$d91034f47eb948f2$var$emplace($d91034f47eb948f2$var$stateProxyMap, state, {
        insert: ()=>new Proxy(state, {
                get: (target, prop, receiver)=>{
                    if (prop === $d91034f47eb948f2$var$ORIGINAL_STATE) return target;
                    const result = Reflect.get(target, prop, receiver);
                    if (typeof result === "undefined") {
                        const reducer = reducerMap[prop.toString()];
                        if (reducer) {
                            const reducerResult = reducer(void 0, {
                                type: $d91034f47eb948f2$export$ac4959f4f1338dfc()
                            });
                            if (typeof reducerResult === "undefined") throw new Error($d91034f47eb948f2$export$378fa86b259c0280(24));
                            return reducerResult;
                        }
                    }
                    return result;
                }
            })
    });
var $d91034f47eb948f2$var$original = (state)=>{
    if (!$d91034f47eb948f2$var$isStateProxy(state)) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(25));
    return state[$d91034f47eb948f2$var$ORIGINAL_STATE];
};
function $d91034f47eb948f2$export$a3734c7614660b9(...slices) {
    const reducerMap = Object.fromEntries($d91034f47eb948f2$var$getReducers(slices));
    const getReducer = ()=>(0, $669d9d4c4c7ccc3c$export$66e4520cdb265d18)(reducerMap);
    let reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = ()=>combinedReducer;
    const inject = (slice, config = {})=>{
        const { reducerPath: reducerPath, reducer: reducerToInject } = slice;
        const currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) {
            typeof $cfae44f0dfdf62c0$exports;
            return combinedReducer;
        }
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    const selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state, ...args) {
            return selectorFn($d91034f47eb948f2$var$createStateProxy(selectState ? selectState(state, ...args) : state, reducerMap), ...args);
        };
    }, {
        original: $d91034f47eb948f2$var$original
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
// src/formatProdErrorMessage.ts
function $d91034f47eb948f2$export$378fa86b259c0280(code) {
    return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}





var $66b21aa7bd8497fc$export$f4258b89f6bad1d6 = /* @__PURE__ */ ((QueryStatus2)=>{
    QueryStatus2["uninitialized"] = "uninitialized";
    QueryStatus2["pending"] = "pending";
    QueryStatus2["fulfilled"] = "fulfilled";
    QueryStatus2["rejected"] = "rejected";
    return QueryStatus2;
})($66b21aa7bd8497fc$export$f4258b89f6bad1d6 || {});
function $66b21aa7bd8497fc$var$getRequestStatusFlags(status) {
    return {
        status: status,
        isUninitialized: status === "uninitialized" /* uninitialized */ ,
        isLoading: status === "pending" /* pending */ ,
        isSuccess: status === "fulfilled" /* fulfilled */ ,
        isError: status === "rejected" /* rejected */ 
    };
}
// src/query/utils/isAbsoluteUrl.ts
function $66b21aa7bd8497fc$var$isAbsoluteUrl(url) {
    return new RegExp(`(^|:)//`).test(url);
}
// src/query/utils/joinUrls.ts
var $66b21aa7bd8497fc$var$withoutTrailingSlash = (url)=>url.replace(/\/$/, "");
var $66b21aa7bd8497fc$var$withoutLeadingSlash = (url)=>url.replace(/^\//, "");
function $66b21aa7bd8497fc$var$joinUrls(base, url) {
    if (!base) return url;
    if (!url) return base;
    if ($66b21aa7bd8497fc$var$isAbsoluteUrl(url)) return url;
    const delimiter = base.endsWith("/") || !url.startsWith("?") ? "/" : "";
    base = $66b21aa7bd8497fc$var$withoutTrailingSlash(base);
    url = $66b21aa7bd8497fc$var$withoutLeadingSlash(url);
    return `${base}${delimiter}${url}`;
}
// src/query/utils/flatten.ts
var $66b21aa7bd8497fc$var$flatten = (arr)=>[].concat(...arr);
// src/query/utils/isOnline.ts
function $66b21aa7bd8497fc$var$isOnline() {
    return typeof navigator === "undefined" ? true : navigator.onLine === void 0 ? true : navigator.onLine;
}
// src/query/utils/isDocumentVisible.ts
function $66b21aa7bd8497fc$var$isDocumentVisible() {
    if (typeof document === "undefined") return true;
    return document.visibilityState !== "hidden";
}
// src/query/utils/copyWithStructuralSharing.ts
var $66b21aa7bd8497fc$var$isPlainObject2 = (0, $669d9d4c4c7ccc3c$export$53b83ca8eaab0383);
function $66b21aa7bd8497fc$export$b64d4502a1c929bd(oldObj, newObj) {
    if (oldObj === newObj || !($66b21aa7bd8497fc$var$isPlainObject2(oldObj) && $66b21aa7bd8497fc$var$isPlainObject2(newObj) || Array.isArray(oldObj) && Array.isArray(newObj))) return newObj;
    const newKeys = Object.keys(newObj);
    const oldKeys = Object.keys(oldObj);
    let isSameObject = newKeys.length === oldKeys.length;
    const mergeObj = Array.isArray(newObj) ? [] : {};
    for (const key of newKeys){
        mergeObj[key] = $66b21aa7bd8497fc$export$b64d4502a1c929bd(oldObj[key], newObj[key]);
        if (isSameObject) isSameObject = oldObj[key] === mergeObj[key];
    }
    return isSameObject ? oldObj : mergeObj;
}
// src/query/fetchBaseQuery.ts
var $66b21aa7bd8497fc$var$defaultFetchFn = (...args)=>fetch(...args);
var $66b21aa7bd8497fc$var$defaultValidateStatus = (response)=>response.status >= 200 && response.status <= 299;
var $66b21aa7bd8497fc$var$defaultIsJsonContentType = (headers)=>/*applicat*/ /ion\/(vnd\.api\+)?json/.test(headers.get("content-type") || "");
function $66b21aa7bd8497fc$var$stripUndefined(obj) {
    if (!(0, $669d9d4c4c7ccc3c$export$53b83ca8eaab0383)(obj)) return obj;
    const copy = {
        ...obj
    };
    for (const [k, v] of Object.entries(copy))if (v === void 0) delete copy[k];
    return copy;
}
function $66b21aa7bd8497fc$export$adcf4c6133c49b4e({ baseUrl: baseUrl, prepareHeaders: prepareHeaders = (x)=>x, fetchFn: fetchFn = $66b21aa7bd8497fc$var$defaultFetchFn, paramsSerializer: paramsSerializer, isJsonContentType: isJsonContentType = $66b21aa7bd8497fc$var$defaultIsJsonContentType, jsonContentType: jsonContentType = "application/json", jsonReplacer: jsonReplacer, timeout: defaultTimeout, responseHandler: globalResponseHandler, validateStatus: globalValidateStatus, ...baseFetchOptions } = {}) {
    if (typeof fetch === "undefined" && fetchFn === $66b21aa7bd8497fc$var$defaultFetchFn) console.warn("Warning: `fetch` is not available. Please supply a custom `fetchFn` property to use `fetchBaseQuery` on SSR environments.");
    return async (arg, api)=>{
        const { signal: signal, getState: getState, extra: extra, endpoint: endpoint, forced: forced, type: type } = api;
        let meta;
        let { url: url, headers: headers = new Headers(baseFetchOptions.headers), params: params, responseHandler: responseHandler = globalResponseHandler ?? "json", validateStatus: validateStatus = globalValidateStatus ?? $66b21aa7bd8497fc$var$defaultValidateStatus, timeout: timeout = defaultTimeout, ...rest } = typeof arg == "string" ? {
            url: arg
        } : arg;
        let config = {
            ...baseFetchOptions,
            signal: signal,
            ...rest
        };
        headers = new Headers($66b21aa7bd8497fc$var$stripUndefined(headers));
        config.headers = await prepareHeaders(headers, {
            getState: getState,
            extra: extra,
            endpoint: endpoint,
            forced: forced,
            type: type
        }) || headers;
        const isJsonifiable = (body)=>typeof body === "object" && ((0, $669d9d4c4c7ccc3c$export$53b83ca8eaab0383)(body) || Array.isArray(body) || typeof body.toJSON === "function");
        if (!config.headers.has("content-type") && isJsonifiable(config.body)) config.headers.set("content-type", jsonContentType);
        if (isJsonifiable(config.body) && isJsonContentType(config.headers)) config.body = JSON.stringify(config.body, jsonReplacer);
        if (params) {
            const divider = ~url.indexOf("?") ? "&" : "?";
            const query = paramsSerializer ? paramsSerializer(params) : new URLSearchParams($66b21aa7bd8497fc$var$stripUndefined(params));
            url += divider + query;
        }
        url = $66b21aa7bd8497fc$var$joinUrls(baseUrl, url);
        const request = new Request(url, config);
        const requestClone = new Request(url, config);
        meta = {
            request: requestClone
        };
        let response, timedOut = false, timeoutId = timeout && setTimeout(()=>{
            timedOut = true;
            api.abort();
        }, timeout);
        try {
            response = await fetchFn(request);
        } catch (e) {
            return {
                error: {
                    status: timedOut ? "TIMEOUT_ERROR" : "FETCH_ERROR",
                    error: String(e)
                },
                meta: meta
            };
        } finally{
            if (timeoutId) clearTimeout(timeoutId);
        }
        const responseClone = response.clone();
        meta.response = responseClone;
        let resultData;
        let responseText = "";
        try {
            let handleResponseError;
            await Promise.all([
                handleResponse(response, responseHandler).then((r)=>resultData = r, (e)=>handleResponseError = e),
                // see https://github.com/node-fetch/node-fetch/issues/665#issuecomment-538995182
                // we *have* to "use up" both streams at the same time or they will stop running in node-fetch scenarios
                responseClone.text().then((r)=>responseText = r, ()=>{})
            ]);
            if (handleResponseError) throw handleResponseError;
        } catch (e) {
            return {
                error: {
                    status: "PARSING_ERROR",
                    originalStatus: response.status,
                    data: responseText,
                    error: String(e)
                },
                meta: meta
            };
        }
        return validateStatus(response, resultData) ? {
            data: resultData,
            meta: meta
        } : {
            error: {
                status: response.status,
                data: resultData
            },
            meta: meta
        };
    };
    async function handleResponse(response, responseHandler) {
        if (typeof responseHandler === "function") return responseHandler(response);
        if (responseHandler === "content-type") responseHandler = isJsonContentType(response.headers) ? "json" : "text";
        if (responseHandler === "json") {
            const text = await response.text();
            return text.length ? JSON.parse(text) : null;
        }
        return response.text();
    }
}
// src/query/HandledError.ts
var $66b21aa7bd8497fc$var$HandledError = class {
    constructor(value, meta){
        this.value = value;
        this.meta = meta;
    }
};
// src/query/retry.ts
async function $66b21aa7bd8497fc$var$defaultBackoff(attempt = 0, maxRetries = 5) {
    const attempts = Math.min(attempt, maxRetries);
    const timeout = ~~((Math.random() + 0.4) * (300 << attempts));
    await new Promise((resolve)=>setTimeout((res)=>resolve(res), timeout));
}
function $66b21aa7bd8497fc$var$fail(e) {
    throw Object.assign(new $66b21aa7bd8497fc$var$HandledError({
        error: e
    }), {
        throwImmediately: true
    });
}
var $66b21aa7bd8497fc$var$EMPTY_OPTIONS = {};
var $66b21aa7bd8497fc$var$retryWithBackoff = (baseQuery, defaultOptions)=>async (args, api, extraOptions)=>{
        const possibleMaxRetries = [
            5,
            (defaultOptions || $66b21aa7bd8497fc$var$EMPTY_OPTIONS).maxRetries,
            (extraOptions || $66b21aa7bd8497fc$var$EMPTY_OPTIONS).maxRetries
        ].filter((x)=>x !== void 0);
        const [maxRetries] = possibleMaxRetries.slice(-1);
        const defaultRetryCondition = (_, __, { attempt: attempt })=>attempt <= maxRetries;
        const options = {
            maxRetries: maxRetries,
            backoff: $66b21aa7bd8497fc$var$defaultBackoff,
            retryCondition: defaultRetryCondition,
            ...defaultOptions,
            ...extraOptions
        };
        let retry2 = 0;
        while(true)try {
            const result = await baseQuery(args, api, extraOptions);
            if (result.error) throw new $66b21aa7bd8497fc$var$HandledError(result);
            return result;
        } catch (e) {
            retry2++;
            if (e.throwImmediately) {
                if (e instanceof $66b21aa7bd8497fc$var$HandledError) return e.value;
                throw e;
            }
            if (e instanceof $66b21aa7bd8497fc$var$HandledError && !options.retryCondition(e.value.error, args, {
                attempt: retry2,
                baseQueryApi: api,
                extraOptions: extraOptions
            })) return e.value;
            await options.backoff(retry2, options.maxRetries);
        }
    };
var $66b21aa7bd8497fc$export$9369b12211e1fce4 = /* @__PURE__ */ Object.assign($66b21aa7bd8497fc$var$retryWithBackoff, {
    fail: $66b21aa7bd8497fc$var$fail
});
// src/query/core/setupListeners.ts
var $66b21aa7bd8497fc$var$onFocus = /* @__PURE__ */ (0, $d91034f47eb948f2$export$309c7a02b0b0bc62)("__rtkq/focused");
var $66b21aa7bd8497fc$var$onFocusLost = /* @__PURE__ */ (0, $d91034f47eb948f2$export$309c7a02b0b0bc62)("__rtkq/unfocused");
var $66b21aa7bd8497fc$var$onOnline = /* @__PURE__ */ (0, $d91034f47eb948f2$export$309c7a02b0b0bc62)("__rtkq/online");
var $66b21aa7bd8497fc$var$onOffline = /* @__PURE__ */ (0, $d91034f47eb948f2$export$309c7a02b0b0bc62)("__rtkq/offline");
var $66b21aa7bd8497fc$var$initialized = false;
function $66b21aa7bd8497fc$export$120c0dbb0351414c(dispatch, customHandler) {
    function defaultHandler() {
        const handleFocus = ()=>dispatch($66b21aa7bd8497fc$var$onFocus());
        const handleFocusLost = ()=>dispatch($66b21aa7bd8497fc$var$onFocusLost());
        const handleOnline = ()=>dispatch($66b21aa7bd8497fc$var$onOnline());
        const handleOffline = ()=>dispatch($66b21aa7bd8497fc$var$onOffline());
        const handleVisibilityChange = ()=>{
            if (window.document.visibilityState === "visible") handleFocus();
            else handleFocusLost();
        };
        if (!$66b21aa7bd8497fc$var$initialized) {
            if (typeof window !== "undefined" && window.addEventListener) {
                window.addEventListener("visibilitychange", handleVisibilityChange, false);
                window.addEventListener("focus", handleFocus, false);
                window.addEventListener("online", handleOnline, false);
                window.addEventListener("offline", handleOffline, false);
                $66b21aa7bd8497fc$var$initialized = true;
            }
        }
        const unsubscribe = ()=>{
            window.removeEventListener("focus", handleFocus);
            window.removeEventListener("visibilitychange", handleVisibilityChange);
            window.removeEventListener("online", handleOnline);
            window.removeEventListener("offline", handleOffline);
            $66b21aa7bd8497fc$var$initialized = false;
        };
        return unsubscribe;
    }
    return customHandler ? customHandler(dispatch, {
        onFocus: $66b21aa7bd8497fc$var$onFocus,
        onFocusLost: $66b21aa7bd8497fc$var$onFocusLost,
        onOffline: $66b21aa7bd8497fc$var$onOffline,
        onOnline: $66b21aa7bd8497fc$var$onOnline
    }) : defaultHandler();
}
// src/query/endpointDefinitions.ts
function $66b21aa7bd8497fc$var$isQueryDefinition(e) {
    return e.type === "query" /* query */ ;
}
function $66b21aa7bd8497fc$var$isMutationDefinition(e) {
    return e.type === "mutation" /* mutation */ ;
}
function $66b21aa7bd8497fc$var$calculateProvidedBy(description, result, error, queryArg, meta, assertTagTypes) {
    if ($66b21aa7bd8497fc$var$isFunction(description)) return description(result, error, queryArg, meta).map($66b21aa7bd8497fc$var$expandTagDescription).map(assertTagTypes);
    if (Array.isArray(description)) return description.map($66b21aa7bd8497fc$var$expandTagDescription).map(assertTagTypes);
    return [];
}
function $66b21aa7bd8497fc$var$isFunction(t) {
    return typeof t === "function";
}
function $66b21aa7bd8497fc$var$expandTagDescription(description) {
    return typeof description === "string" ? {
        type: description
    } : description;
}
// src/query/utils/isNotNullish.ts
function $66b21aa7bd8497fc$var$isNotNullish(v) {
    return v != null;
}
// src/query/utils/countObjectKeys.ts
function $66b21aa7bd8497fc$var$countObjectKeys(obj) {
    let count = 0;
    for(const _key in obj)count++;
    return count;
}
// src/tsHelpers.ts
function $66b21aa7bd8497fc$var$asSafePromise(promise, fallback) {
    return promise.catch(fallback);
}
// src/query/core/buildInitiate.ts
var $66b21aa7bd8497fc$var$forceQueryFnSymbol = Symbol("forceQueryFn");
var $66b21aa7bd8497fc$var$isUpsertQuery = (arg)=>typeof arg[$66b21aa7bd8497fc$var$forceQueryFnSymbol] === "function";
function $66b21aa7bd8497fc$var$buildInitiate({ serializeQueryArgs: serializeQueryArgs, queryThunk: queryThunk, mutationThunk: mutationThunk, api: api, context: context }) {
    const runningQueries = /* @__PURE__ */ new Map();
    const runningMutations = /* @__PURE__ */ new Map();
    const { unsubscribeQueryResult: unsubscribeQueryResult, removeMutationResult: removeMutationResult, updateSubscriptionOptions: updateSubscriptionOptions } = api.internalActions;
    return {
        buildInitiateQuery: buildInitiateQuery,
        buildInitiateMutation: buildInitiateMutation,
        getRunningQueryThunk: getRunningQueryThunk,
        getRunningMutationThunk: getRunningMutationThunk,
        getRunningQueriesThunk: getRunningQueriesThunk,
        getRunningMutationsThunk: getRunningMutationsThunk
    };
    function getRunningQueryThunk(endpointName, queryArgs) {
        return (dispatch)=>{
            const endpointDefinition = context.endpointDefinitions[endpointName];
            const queryCacheKey = serializeQueryArgs({
                queryArgs: queryArgs,
                endpointDefinition: endpointDefinition,
                endpointName: endpointName
            });
            return runningQueries.get(dispatch)?.[queryCacheKey];
        };
    }
    function getRunningMutationThunk(_endpointName, fixedCacheKeyOrRequestId) {
        return (dispatch)=>{
            return runningMutations.get(dispatch)?.[fixedCacheKeyOrRequestId];
        };
    }
    function getRunningQueriesThunk() {
        return (dispatch)=>Object.values(runningQueries.get(dispatch) || {}).filter($66b21aa7bd8497fc$var$isNotNullish);
    }
    function getRunningMutationsThunk() {
        return (dispatch)=>Object.values(runningMutations.get(dispatch) || {}).filter($66b21aa7bd8497fc$var$isNotNullish);
    }
    function middlewareWarning(dispatch) {}
    function buildInitiateQuery(endpointName, endpointDefinition) {
        const queryAction = (arg, { subscribe: subscribe = true, forceRefetch: forceRefetch, subscriptionOptions: subscriptionOptions, [$66b21aa7bd8497fc$var$forceQueryFnSymbol]: forceQueryFn } = {})=>(dispatch, getState)=>{
                const queryCacheKey = serializeQueryArgs({
                    queryArgs: arg,
                    endpointDefinition: endpointDefinition,
                    endpointName: endpointName
                });
                const thunk = queryThunk({
                    type: "query",
                    subscribe: subscribe,
                    forceRefetch: forceRefetch,
                    subscriptionOptions: subscriptionOptions,
                    endpointName: endpointName,
                    originalArgs: arg,
                    queryCacheKey: queryCacheKey,
                    [$66b21aa7bd8497fc$var$forceQueryFnSymbol]: forceQueryFn
                });
                const selector = api.endpoints[endpointName].select(arg);
                const thunkResult = dispatch(thunk);
                const stateAfter = selector(getState());
                middlewareWarning(dispatch);
                const { requestId: requestId, abort: abort } = thunkResult;
                const skippedSynchronously = stateAfter.requestId !== requestId;
                const runningQuery = runningQueries.get(dispatch)?.[queryCacheKey];
                const selectFromState = ()=>selector(getState());
                const statePromise = Object.assign(forceQueryFn ? // a query has been forced (upsertQueryData)
                // -> we want to resolve it once data has been written with the data that will be written
                thunkResult.then(selectFromState) : skippedSynchronously && !runningQuery ? // a query has been skipped due to a condition and we do not have any currently running query
                // -> we want to resolve it immediately with the current data
                Promise.resolve(stateAfter) : // query just started or one is already in flight
                // -> wait for the running query, then resolve with data from after that
                Promise.all([
                    runningQuery,
                    thunkResult
                ]).then(selectFromState), {
                    arg: arg,
                    requestId: requestId,
                    subscriptionOptions: subscriptionOptions,
                    queryCacheKey: queryCacheKey,
                    abort: abort,
                    async unwrap () {
                        const result = await statePromise;
                        if (result.isError) throw result.error;
                        return result.data;
                    },
                    refetch: ()=>dispatch(queryAction(arg, {
                            subscribe: false,
                            forceRefetch: true
                        })),
                    unsubscribe () {
                        if (subscribe) dispatch(unsubscribeQueryResult({
                            queryCacheKey: queryCacheKey,
                            requestId: requestId
                        }));
                    },
                    updateSubscriptionOptions (options) {
                        statePromise.subscriptionOptions = options;
                        dispatch(updateSubscriptionOptions({
                            endpointName: endpointName,
                            requestId: requestId,
                            queryCacheKey: queryCacheKey,
                            options: options
                        }));
                    }
                });
                if (!runningQuery && !skippedSynchronously && !forceQueryFn) {
                    const running = runningQueries.get(dispatch) || {};
                    running[queryCacheKey] = statePromise;
                    runningQueries.set(dispatch, running);
                    statePromise.then(()=>{
                        delete running[queryCacheKey];
                        if (!$66b21aa7bd8497fc$var$countObjectKeys(running)) runningQueries.delete(dispatch);
                    });
                }
                return statePromise;
            };
        return queryAction;
    }
    function buildInitiateMutation(endpointName) {
        return (arg, { track: track = true, fixedCacheKey: fixedCacheKey } = {})=>(dispatch, getState)=>{
                const thunk = mutationThunk({
                    type: "mutation",
                    endpointName: endpointName,
                    originalArgs: arg,
                    track: track,
                    fixedCacheKey: fixedCacheKey
                });
                const thunkResult = dispatch(thunk);
                middlewareWarning(dispatch);
                const { requestId: requestId, abort: abort, unwrap: unwrap } = thunkResult;
                const returnValuePromise = $66b21aa7bd8497fc$var$asSafePromise(thunkResult.unwrap().then((data)=>({
                        data: data
                    })), (error)=>({
                        error: error
                    }));
                const reset = ()=>{
                    dispatch(removeMutationResult({
                        requestId: requestId,
                        fixedCacheKey: fixedCacheKey
                    }));
                };
                const ret = Object.assign(returnValuePromise, {
                    arg: thunkResult.arg,
                    requestId: requestId,
                    abort: abort,
                    unwrap: unwrap,
                    reset: reset
                });
                const running = runningMutations.get(dispatch) || {};
                runningMutations.set(dispatch, running);
                running[requestId] = ret;
                ret.then(()=>{
                    delete running[requestId];
                    if (!$66b21aa7bd8497fc$var$countObjectKeys(running)) runningMutations.delete(dispatch);
                });
                if (fixedCacheKey) {
                    running[fixedCacheKey] = ret;
                    ret.then(()=>{
                        if (running[fixedCacheKey] === ret) {
                            delete running[fixedCacheKey];
                            if (!$66b21aa7bd8497fc$var$countObjectKeys(running)) runningMutations.delete(dispatch);
                        }
                    });
                }
                return ret;
            };
    }
}
function $66b21aa7bd8497fc$var$defaultTransformResponse(baseQueryReturnValue) {
    return baseQueryReturnValue;
}
function $66b21aa7bd8497fc$var$buildThunks({ reducerPath: reducerPath, baseQuery: baseQuery, context: { endpointDefinitions: endpointDefinitions }, serializeQueryArgs: serializeQueryArgs, api: api, assertTagType: assertTagType }) {
    const patchQueryData = (endpointName, args, patches, updateProvided)=>(dispatch, getState)=>{
            const endpointDefinition = endpointDefinitions[endpointName];
            const queryCacheKey = serializeQueryArgs({
                queryArgs: args,
                endpointDefinition: endpointDefinition,
                endpointName: endpointName
            });
            dispatch(api.internalActions.queryResultPatched({
                queryCacheKey: queryCacheKey,
                patches: patches
            }));
            if (!updateProvided) return;
            const newValue = api.endpoints[endpointName].select(args)(// Work around TS 4.1 mismatch
            getState());
            const providedTags = $66b21aa7bd8497fc$var$calculateProvidedBy(endpointDefinition.providesTags, newValue.data, void 0, args, {}, assertTagType);
            dispatch(api.internalActions.updateProvidedBy({
                queryCacheKey: queryCacheKey,
                providedTags: providedTags
            }));
        };
    const updateQueryData = (endpointName, args, updateRecipe, updateProvided = true)=>(dispatch, getState)=>{
            const endpointDefinition = api.endpoints[endpointName];
            const currentState = endpointDefinition.select(args)(// Work around TS 4.1 mismatch
            getState());
            let ret = {
                patches: [],
                inversePatches: [],
                undo: ()=>dispatch(api.util.patchQueryData(endpointName, args, ret.inversePatches, updateProvided))
            };
            if (currentState.status === "uninitialized" /* uninitialized */ ) return ret;
            let newValue;
            if ("data" in currentState) {
                if ((0, $5f9e38360d79f95a$export$16e3aed3edb85946)(currentState.data)) {
                    const [value, patches, inversePatches] = (0, $5f9e38360d79f95a$export$4da66d41c9492c78)(currentState.data, updateRecipe);
                    ret.patches.push(...patches);
                    ret.inversePatches.push(...inversePatches);
                    newValue = value;
                } else {
                    newValue = updateRecipe(currentState.data);
                    ret.patches.push({
                        op: "replace",
                        path: [],
                        value: newValue
                    });
                    ret.inversePatches.push({
                        op: "replace",
                        path: [],
                        value: currentState.data
                    });
                }
            }
            dispatch(api.util.patchQueryData(endpointName, args, ret.patches, updateProvided));
            return ret;
        };
    const upsertQueryData = (endpointName, args, value)=>(dispatch)=>{
            return dispatch(api.endpoints[endpointName].initiate(args, {
                subscribe: false,
                forceRefetch: true,
                [$66b21aa7bd8497fc$var$forceQueryFnSymbol]: ()=>({
                        data: value
                    })
            }));
        };
    const executeEndpoint = async (arg, { signal: signal, abort: abort, rejectWithValue: rejectWithValue, fulfillWithValue: fulfillWithValue, dispatch: dispatch, getState: getState, extra: extra })=>{
        const endpointDefinition = endpointDefinitions[arg.endpointName];
        try {
            let transformResponse = $66b21aa7bd8497fc$var$defaultTransformResponse;
            let result;
            const baseQueryApi = {
                signal: signal,
                abort: abort,
                dispatch: dispatch,
                getState: getState,
                extra: extra,
                endpoint: arg.endpointName,
                type: arg.type,
                forced: arg.type === "query" ? isForcedQuery(arg, getState()) : void 0
            };
            const forceQueryFn = arg.type === "query" ? arg[$66b21aa7bd8497fc$var$forceQueryFnSymbol] : void 0;
            if (forceQueryFn) result = forceQueryFn();
            else if (endpointDefinition.query) {
                result = await baseQuery(endpointDefinition.query(arg.originalArgs), baseQueryApi, endpointDefinition.extraOptions);
                if (endpointDefinition.transformResponse) transformResponse = endpointDefinition.transformResponse;
            } else result = await endpointDefinition.queryFn(arg.originalArgs, baseQueryApi, endpointDefinition.extraOptions, (arg2)=>baseQuery(arg2, baseQueryApi, endpointDefinition.extraOptions));
            typeof $cfae44f0dfdf62c0$exports;
            if (result.error) throw new $66b21aa7bd8497fc$var$HandledError(result.error, result.meta);
            return fulfillWithValue(await transformResponse(result.data, result.meta, arg.originalArgs), {
                fulfilledTimeStamp: Date.now(),
                baseQueryMeta: result.meta,
                [(0, $d91034f47eb948f2$export$8fb31c0f05df007b)]: true
            });
        } catch (error) {
            let catchedError = error;
            if (catchedError instanceof $66b21aa7bd8497fc$var$HandledError) {
                let transformErrorResponse = $66b21aa7bd8497fc$var$defaultTransformResponse;
                if (endpointDefinition.query && endpointDefinition.transformErrorResponse) transformErrorResponse = endpointDefinition.transformErrorResponse;
                try {
                    return rejectWithValue(await transformErrorResponse(catchedError.value, catchedError.meta, arg.originalArgs), {
                        baseQueryMeta: catchedError.meta,
                        [(0, $d91034f47eb948f2$export$8fb31c0f05df007b)]: true
                    });
                } catch (e) {
                    catchedError = e;
                }
            }
            typeof $cfae44f0dfdf62c0$exports;
            console.error(catchedError);
            throw catchedError;
        }
    };
    function isForcedQuery(arg, state) {
        const requestState = state[reducerPath]?.queries?.[arg.queryCacheKey];
        const baseFetchOnMountOrArgChange = state[reducerPath]?.config.refetchOnMountOrArgChange;
        const fulfilledVal = requestState?.fulfilledTimeStamp;
        const refetchVal = arg.forceRefetch ?? (arg.subscribe && baseFetchOnMountOrArgChange);
        if (refetchVal) return refetchVal === true || (Number(/* @__PURE__ */ new Date()) - Number(fulfilledVal)) / 1e3 >= refetchVal;
        return false;
    }
    const queryThunk = (0, $d91034f47eb948f2$export$6abd22dc03e5063f)(`${reducerPath}/executeQuery`, executeEndpoint, {
        getPendingMeta () {
            return {
                startedTimeStamp: Date.now(),
                [(0, $d91034f47eb948f2$export$8fb31c0f05df007b)]: true
            };
        },
        condition (queryThunkArgs, { getState: getState }) {
            const state = getState();
            const requestState = state[reducerPath]?.queries?.[queryThunkArgs.queryCacheKey];
            const fulfilledVal = requestState?.fulfilledTimeStamp;
            const currentArg = queryThunkArgs.originalArgs;
            const previousArg = requestState?.originalArgs;
            const endpointDefinition = endpointDefinitions[queryThunkArgs.endpointName];
            if ($66b21aa7bd8497fc$var$isUpsertQuery(queryThunkArgs)) return true;
            if (requestState?.status === "pending") return false;
            if (isForcedQuery(queryThunkArgs, state)) return true;
            if ($66b21aa7bd8497fc$var$isQueryDefinition(endpointDefinition) && endpointDefinition?.forceRefetch?.({
                currentArg: currentArg,
                previousArg: previousArg,
                endpointState: requestState,
                state: state
            })) return true;
            if (fulfilledVal) return false;
            return true;
        },
        dispatchConditionRejection: true
    });
    const mutationThunk = (0, $d91034f47eb948f2$export$6abd22dc03e5063f)(`${reducerPath}/executeMutation`, executeEndpoint, {
        getPendingMeta () {
            return {
                startedTimeStamp: Date.now(),
                [(0, $d91034f47eb948f2$export$8fb31c0f05df007b)]: true
            };
        }
    });
    const hasTheForce = (options)=>"force" in options;
    const hasMaxAge = (options)=>"ifOlderThan" in options;
    const prefetch = (endpointName, arg, options)=>(dispatch, getState)=>{
            const force = hasTheForce(options) && options.force;
            const maxAge = hasMaxAge(options) && options.ifOlderThan;
            const queryAction = (force2 = true)=>api.endpoints[endpointName].initiate(arg, {
                    forceRefetch: force2
                });
            const latestStateValue = api.endpoints[endpointName].select(arg)(getState());
            if (force) dispatch(queryAction());
            else if (maxAge) {
                const lastFulfilledTs = latestStateValue?.fulfilledTimeStamp;
                if (!lastFulfilledTs) {
                    dispatch(queryAction());
                    return;
                }
                const shouldRetrigger = (Number(/* @__PURE__ */ new Date()) - Number(new Date(lastFulfilledTs))) / 1e3 >= maxAge;
                if (shouldRetrigger) dispatch(queryAction());
            } else dispatch(queryAction(false));
        };
    function matchesEndpoint(endpointName) {
        return (action)=>action?.meta?.arg?.endpointName === endpointName;
    }
    function buildMatchThunkActions(thunk, endpointName) {
        return {
            matchPending: (0, $d91034f47eb948f2$export$9dd1fb32974da385)((0, $d91034f47eb948f2$export$872dec21e9a69476)(thunk), matchesEndpoint(endpointName)),
            matchFulfilled: (0, $d91034f47eb948f2$export$9dd1fb32974da385)((0, $d91034f47eb948f2$export$1da80a6ef1307441)(thunk), matchesEndpoint(endpointName)),
            matchRejected: (0, $d91034f47eb948f2$export$9dd1fb32974da385)((0, $d91034f47eb948f2$export$a5c5d27e3994c5be)(thunk), matchesEndpoint(endpointName))
        };
    }
    return {
        queryThunk: queryThunk,
        mutationThunk: mutationThunk,
        prefetch: prefetch,
        updateQueryData: updateQueryData,
        upsertQueryData: upsertQueryData,
        patchQueryData: patchQueryData,
        buildMatchThunkActions: buildMatchThunkActions
    };
}
function $66b21aa7bd8497fc$var$calculateProvidedByThunk(action, type, endpointDefinitions, assertTagType) {
    return $66b21aa7bd8497fc$var$calculateProvidedBy(endpointDefinitions[action.meta.arg.endpointName][type], (0, $d91034f47eb948f2$export$1da80a6ef1307441)(action) ? action.payload : void 0, (0, $d91034f47eb948f2$export$fcc3388fb56de601)(action) ? action.payload : void 0, action.meta.arg.originalArgs, "baseQueryMeta" in action.meta ? action.meta.baseQueryMeta : void 0, assertTagType);
}
function $66b21aa7bd8497fc$var$updateQuerySubstateIfExists(state, queryCacheKey, update) {
    const substate = state[queryCacheKey];
    if (substate) update(substate);
}
function $66b21aa7bd8497fc$var$getMutationCacheKey(id) {
    return ("arg" in id ? id.arg.fixedCacheKey : id.fixedCacheKey) ?? id.requestId;
}
function $66b21aa7bd8497fc$var$updateMutationSubstateIfExists(state, id, update) {
    const substate = state[$66b21aa7bd8497fc$var$getMutationCacheKey(id)];
    if (substate) update(substate);
}
var $66b21aa7bd8497fc$var$initialState = {};
function $66b21aa7bd8497fc$var$buildSlice({ reducerPath: reducerPath, queryThunk: queryThunk, mutationThunk: mutationThunk, context: { endpointDefinitions: definitions, apiUid: apiUid, extractRehydrationInfo: extractRehydrationInfo, hasRehydrationInfo: hasRehydrationInfo }, assertTagType: assertTagType, config: config }) {
    const resetApiState = (0, $d91034f47eb948f2$export$309c7a02b0b0bc62)(`${reducerPath}/resetApiState`);
    const querySlice = (0, $d91034f47eb948f2$export$4d8d9bd83c24ae8b)({
        name: `${reducerPath}/queries`,
        initialState: $66b21aa7bd8497fc$var$initialState,
        reducers: {
            removeQueryResult: {
                reducer (draft, { payload: { queryCacheKey: queryCacheKey } }) {
                    delete draft[queryCacheKey];
                },
                prepare: (0, $d91034f47eb948f2$export$39fcd5145ec5e4e2)()
            },
            queryResultPatched: {
                reducer (draft, { payload: { queryCacheKey: queryCacheKey, patches: patches } }) {
                    $66b21aa7bd8497fc$var$updateQuerySubstateIfExists(draft, queryCacheKey, (substate)=>{
                        substate.data = (0, $5f9e38360d79f95a$export$a8b8e03e6bbe5473)(substate.data, patches.concat());
                    });
                },
                prepare: (0, $d91034f47eb948f2$export$39fcd5145ec5e4e2)()
            }
        },
        extraReducers (builder) {
            builder.addCase(queryThunk.pending, (draft, { meta: meta, meta: { arg: arg } })=>{
                const upserting = $66b21aa7bd8497fc$var$isUpsertQuery(arg);
                draft[arg.queryCacheKey] ??= {
                    status: "uninitialized" /* uninitialized */ ,
                    endpointName: arg.endpointName
                };
                $66b21aa7bd8497fc$var$updateQuerySubstateIfExists(draft, arg.queryCacheKey, (substate)=>{
                    substate.status = "pending" /* pending */ ;
                    substate.requestId = upserting && substate.requestId ? // for `upsertQuery` **updates**, keep the current `requestId`
                    substate.requestId : // for normal queries or `upsertQuery` **inserts** always update the `requestId`
                    meta.requestId;
                    if (arg.originalArgs !== void 0) substate.originalArgs = arg.originalArgs;
                    substate.startedTimeStamp = meta.startedTimeStamp;
                });
            }).addCase(queryThunk.fulfilled, (draft, { meta: meta, payload: payload })=>{
                $66b21aa7bd8497fc$var$updateQuerySubstateIfExists(draft, meta.arg.queryCacheKey, (substate)=>{
                    if (substate.requestId !== meta.requestId && !$66b21aa7bd8497fc$var$isUpsertQuery(meta.arg)) return;
                    const { merge: merge } = definitions[meta.arg.endpointName];
                    substate.status = "fulfilled" /* fulfilled */ ;
                    if (merge) {
                        if (substate.data !== void 0) {
                            const { fulfilledTimeStamp: fulfilledTimeStamp, arg: arg, baseQueryMeta: baseQueryMeta, requestId: requestId } = meta;
                            let newData = (0, $5f9e38360d79f95a$export$b46cabe22e78bc00)(substate.data, (draftSubstateData)=>{
                                return merge(draftSubstateData, payload, {
                                    arg: arg.originalArgs,
                                    baseQueryMeta: baseQueryMeta,
                                    fulfilledTimeStamp: fulfilledTimeStamp,
                                    requestId: requestId
                                });
                            });
                            substate.data = newData;
                        } else substate.data = payload;
                    } else substate.data = definitions[meta.arg.endpointName].structuralSharing ?? true ? $66b21aa7bd8497fc$export$b64d4502a1c929bd((0, $5f9e38360d79f95a$export$541ac630993a4c84)(substate.data) ? (0, $5f9e38360d79f95a$export$22e8af3f75a010e3)(substate.data) : substate.data, payload) : payload;
                    delete substate.error;
                    substate.fulfilledTimeStamp = meta.fulfilledTimeStamp;
                });
            }).addCase(queryThunk.rejected, (draft, { meta: { condition: condition, arg: arg, requestId: requestId }, error: error, payload: payload })=>{
                $66b21aa7bd8497fc$var$updateQuerySubstateIfExists(draft, arg.queryCacheKey, (substate)=>{
                    if (condition) ;
                    else {
                        if (substate.requestId !== requestId) return;
                        substate.status = "rejected" /* rejected */ ;
                        substate.error = payload ?? error;
                    }
                });
            }).addMatcher(hasRehydrationInfo, (draft, action)=>{
                const { queries: queries } = extractRehydrationInfo(action);
                for (const [key, entry] of Object.entries(queries))if (// do not rehydrate entries that were currently in flight.
                entry?.status === "fulfilled" /* fulfilled */  || entry?.status === "rejected" /* rejected */ ) draft[key] = entry;
            });
        }
    });
    const mutationSlice = (0, $d91034f47eb948f2$export$4d8d9bd83c24ae8b)({
        name: `${reducerPath}/mutations`,
        initialState: $66b21aa7bd8497fc$var$initialState,
        reducers: {
            removeMutationResult: {
                reducer (draft, { payload: payload }) {
                    const cacheKey = $66b21aa7bd8497fc$var$getMutationCacheKey(payload);
                    if (cacheKey in draft) delete draft[cacheKey];
                },
                prepare: (0, $d91034f47eb948f2$export$39fcd5145ec5e4e2)()
            }
        },
        extraReducers (builder) {
            builder.addCase(mutationThunk.pending, (draft, { meta: meta, meta: { requestId: requestId, arg: arg, startedTimeStamp: startedTimeStamp } })=>{
                if (!arg.track) return;
                draft[$66b21aa7bd8497fc$var$getMutationCacheKey(meta)] = {
                    requestId: requestId,
                    status: "pending" /* pending */ ,
                    endpointName: arg.endpointName,
                    startedTimeStamp: startedTimeStamp
                };
            }).addCase(mutationThunk.fulfilled, (draft, { payload: payload, meta: meta })=>{
                if (!meta.arg.track) return;
                $66b21aa7bd8497fc$var$updateMutationSubstateIfExists(draft, meta, (substate)=>{
                    if (substate.requestId !== meta.requestId) return;
                    substate.status = "fulfilled" /* fulfilled */ ;
                    substate.data = payload;
                    substate.fulfilledTimeStamp = meta.fulfilledTimeStamp;
                });
            }).addCase(mutationThunk.rejected, (draft, { payload: payload, error: error, meta: meta })=>{
                if (!meta.arg.track) return;
                $66b21aa7bd8497fc$var$updateMutationSubstateIfExists(draft, meta, (substate)=>{
                    if (substate.requestId !== meta.requestId) return;
                    substate.status = "rejected" /* rejected */ ;
                    substate.error = payload ?? error;
                });
            }).addMatcher(hasRehydrationInfo, (draft, action)=>{
                const { mutations: mutations } = extractRehydrationInfo(action);
                for (const [key, entry] of Object.entries(mutations))if (// do not rehydrate entries that were currently in flight.
                (entry?.status === "fulfilled" /* fulfilled */  || entry?.status === "rejected" /* rejected */ ) && // only rehydrate endpoints that were persisted using a `fixedCacheKey`
                key !== entry?.requestId) draft[key] = entry;
            });
        }
    });
    const invalidationSlice = (0, $d91034f47eb948f2$export$4d8d9bd83c24ae8b)({
        name: `${reducerPath}/invalidation`,
        initialState: $66b21aa7bd8497fc$var$initialState,
        reducers: {
            updateProvidedBy: {
                reducer (draft, action) {
                    const { queryCacheKey: queryCacheKey, providedTags: providedTags } = action.payload;
                    for (const tagTypeSubscriptions of Object.values(draft))for (const idSubscriptions of Object.values(tagTypeSubscriptions)){
                        const foundAt = idSubscriptions.indexOf(queryCacheKey);
                        if (foundAt !== -1) idSubscriptions.splice(foundAt, 1);
                    }
                    for (const { type: type, id: id } of providedTags){
                        const subscribedQueries = (draft[type] ??= {})[id || "__internal_without_id"] ??= [];
                        const alreadySubscribed = subscribedQueries.includes(queryCacheKey);
                        if (!alreadySubscribed) subscribedQueries.push(queryCacheKey);
                    }
                },
                prepare: (0, $d91034f47eb948f2$export$39fcd5145ec5e4e2)()
            }
        },
        extraReducers (builder) {
            builder.addCase(querySlice.actions.removeQueryResult, (draft, { payload: { queryCacheKey: queryCacheKey } })=>{
                for (const tagTypeSubscriptions of Object.values(draft))for (const idSubscriptions of Object.values(tagTypeSubscriptions)){
                    const foundAt = idSubscriptions.indexOf(queryCacheKey);
                    if (foundAt !== -1) idSubscriptions.splice(foundAt, 1);
                }
            }).addMatcher(hasRehydrationInfo, (draft, action)=>{
                const { provided: provided } = extractRehydrationInfo(action);
                for (const [type, incomingTags] of Object.entries(provided))for (const [id, cacheKeys] of Object.entries(incomingTags)){
                    const subscribedQueries = (draft[type] ??= {})[id || "__internal_without_id"] ??= [];
                    for (const queryCacheKey of cacheKeys){
                        const alreadySubscribed = subscribedQueries.includes(queryCacheKey);
                        if (!alreadySubscribed) subscribedQueries.push(queryCacheKey);
                    }
                }
            }).addMatcher((0, $d91034f47eb948f2$export$2c3435c7647f7b0d)((0, $d91034f47eb948f2$export$1da80a6ef1307441)(queryThunk), (0, $d91034f47eb948f2$export$fcc3388fb56de601)(queryThunk)), (draft, action)=>{
                const providedTags = $66b21aa7bd8497fc$var$calculateProvidedByThunk(action, "providesTags", definitions, assertTagType);
                const { queryCacheKey: queryCacheKey } = action.meta.arg;
                invalidationSlice.caseReducers.updateProvidedBy(draft, invalidationSlice.actions.updateProvidedBy({
                    queryCacheKey: queryCacheKey,
                    providedTags: providedTags
                }));
            });
        }
    });
    const subscriptionSlice = (0, $d91034f47eb948f2$export$4d8d9bd83c24ae8b)({
        name: `${reducerPath}/subscriptions`,
        initialState: $66b21aa7bd8497fc$var$initialState,
        reducers: {
            updateSubscriptionOptions (d, a) {},
            unsubscribeQueryResult (d, a) {},
            internal_getRTKQSubscriptions () {}
        }
    });
    const internalSubscriptionsSlice = (0, $d91034f47eb948f2$export$4d8d9bd83c24ae8b)({
        name: `${reducerPath}/internalSubscriptions`,
        initialState: $66b21aa7bd8497fc$var$initialState,
        reducers: {
            subscriptionsUpdated: {
                reducer (state, action) {
                    return (0, $5f9e38360d79f95a$export$a8b8e03e6bbe5473)(state, action.payload);
                },
                prepare: (0, $d91034f47eb948f2$export$39fcd5145ec5e4e2)()
            }
        }
    });
    const configSlice = (0, $d91034f47eb948f2$export$4d8d9bd83c24ae8b)({
        name: `${reducerPath}/config`,
        initialState: {
            online: $66b21aa7bd8497fc$var$isOnline(),
            focused: $66b21aa7bd8497fc$var$isDocumentVisible(),
            middlewareRegistered: false,
            ...config
        },
        reducers: {
            middlewareRegistered (state, { payload: payload }) {
                state.middlewareRegistered = state.middlewareRegistered === "conflict" || apiUid !== payload ? "conflict" : true;
            }
        },
        extraReducers: (builder)=>{
            builder.addCase($66b21aa7bd8497fc$var$onOnline, (state)=>{
                state.online = true;
            }).addCase($66b21aa7bd8497fc$var$onOffline, (state)=>{
                state.online = false;
            }).addCase($66b21aa7bd8497fc$var$onFocus, (state)=>{
                state.focused = true;
            }).addCase($66b21aa7bd8497fc$var$onFocusLost, (state)=>{
                state.focused = false;
            }).addMatcher(hasRehydrationInfo, (draft)=>({
                    ...draft
                }));
        }
    });
    const combinedReducer = (0, $669d9d4c4c7ccc3c$export$66e4520cdb265d18)({
        queries: querySlice.reducer,
        mutations: mutationSlice.reducer,
        provided: invalidationSlice.reducer,
        subscriptions: internalSubscriptionsSlice.reducer,
        config: configSlice.reducer
    });
    const reducer = (state, action)=>combinedReducer(resetApiState.match(action) ? void 0 : state, action);
    const actions = {
        ...configSlice.actions,
        ...querySlice.actions,
        ...subscriptionSlice.actions,
        ...internalSubscriptionsSlice.actions,
        ...mutationSlice.actions,
        ...invalidationSlice.actions,
        resetApiState: resetApiState
    };
    return {
        reducer: reducer,
        actions: actions
    };
}
// src/query/core/buildSelectors.ts
var $66b21aa7bd8497fc$export$1aa5a89531b7670d = /* @__PURE__ */ Symbol.for("RTKQ/skipToken");
var $66b21aa7bd8497fc$var$initialSubState = {
    status: "uninitialized" /* uninitialized */ 
};
var $66b21aa7bd8497fc$var$defaultQuerySubState = /* @__PURE__ */ (0, $5f9e38360d79f95a$export$b46cabe22e78bc00)($66b21aa7bd8497fc$var$initialSubState, ()=>{});
var $66b21aa7bd8497fc$var$defaultMutationSubState = /* @__PURE__ */ (0, $5f9e38360d79f95a$export$b46cabe22e78bc00)($66b21aa7bd8497fc$var$initialSubState, ()=>{});
function $66b21aa7bd8497fc$var$buildSelectors({ serializeQueryArgs: serializeQueryArgs, reducerPath: reducerPath, createSelector: createSelector2 }) {
    const selectSkippedQuery = (state)=>$66b21aa7bd8497fc$var$defaultQuerySubState;
    const selectSkippedMutation = (state)=>$66b21aa7bd8497fc$var$defaultMutationSubState;
    return {
        buildQuerySelector: buildQuerySelector,
        buildMutationSelector: buildMutationSelector,
        selectInvalidatedBy: selectInvalidatedBy,
        selectCachedArgsForQuery: selectCachedArgsForQuery
    };
    function withRequestFlags(substate) {
        return {
            ...substate,
            ...$66b21aa7bd8497fc$var$getRequestStatusFlags(substate.status)
        };
    }
    function selectInternalState(rootState) {
        const state = rootState[reducerPath];
        return state;
    }
    function buildQuerySelector(endpointName, endpointDefinition) {
        return (queryArgs)=>{
            const serializedArgs = serializeQueryArgs({
                queryArgs: queryArgs,
                endpointDefinition: endpointDefinition,
                endpointName: endpointName
            });
            const selectQuerySubstate = (state)=>selectInternalState(state)?.queries?.[serializedArgs] ?? $66b21aa7bd8497fc$var$defaultQuerySubState;
            const finalSelectQuerySubState = queryArgs === $66b21aa7bd8497fc$export$1aa5a89531b7670d ? selectSkippedQuery : selectQuerySubstate;
            return createSelector2(finalSelectQuerySubState, withRequestFlags);
        };
    }
    function buildMutationSelector() {
        return (id)=>{
            let mutationId;
            if (typeof id === "object") mutationId = $66b21aa7bd8497fc$var$getMutationCacheKey(id) ?? $66b21aa7bd8497fc$export$1aa5a89531b7670d;
            else mutationId = id;
            const selectMutationSubstate = (state)=>selectInternalState(state)?.mutations?.[mutationId] ?? $66b21aa7bd8497fc$var$defaultMutationSubState;
            const finalSelectMutationSubstate = mutationId === $66b21aa7bd8497fc$export$1aa5a89531b7670d ? selectSkippedMutation : selectMutationSubstate;
            return createSelector2(finalSelectMutationSubstate, withRequestFlags);
        };
    }
    function selectInvalidatedBy(state, tags) {
        const apiState = state[reducerPath];
        const toInvalidate = /* @__PURE__ */ new Set();
        for (const tag of tags.map($66b21aa7bd8497fc$var$expandTagDescription)){
            const provided = apiState.provided[tag.type];
            if (!provided) continue;
            let invalidateSubscriptions = (tag.id !== void 0 ? // id given: invalidate all queries that provide this type & id
            provided[tag.id] : // no id: invalidate all queries that provide this type
            $66b21aa7bd8497fc$var$flatten(Object.values(provided))) ?? [];
            for (const invalidate of invalidateSubscriptions)toInvalidate.add(invalidate);
        }
        return $66b21aa7bd8497fc$var$flatten(Array.from(toInvalidate.values()).map((queryCacheKey)=>{
            const querySubState = apiState.queries[queryCacheKey];
            return querySubState ? [
                {
                    queryCacheKey: queryCacheKey,
                    endpointName: querySubState.endpointName,
                    originalArgs: querySubState.originalArgs
                }
            ] : [];
        }));
    }
    function selectCachedArgsForQuery(state, queryName) {
        return Object.values(state[reducerPath].queries).filter((entry)=>entry?.endpointName === queryName && entry.status !== "uninitialized" /* uninitialized */ ).map((entry)=>entry.originalArgs);
    }
}
// src/query/defaultSerializeQueryArgs.ts
var $66b21aa7bd8497fc$var$cache = WeakMap ? /* @__PURE__ */ new WeakMap() : void 0;
var $66b21aa7bd8497fc$export$db8e4edac9bbb67b = ({ endpointName: endpointName, queryArgs: queryArgs })=>{
    let serialized = "";
    const cached = $66b21aa7bd8497fc$var$cache?.get(queryArgs);
    if (typeof cached === "string") serialized = cached;
    else {
        const stringified = JSON.stringify(queryArgs, (key, value)=>(0, $669d9d4c4c7ccc3c$export$53b83ca8eaab0383)(value) ? Object.keys(value).sort().reduce((acc, key2)=>{
                acc[key2] = value[key2];
                return acc;
            }, {}) : value);
        if ((0, $669d9d4c4c7ccc3c$export$53b83ca8eaab0383)(queryArgs)) $66b21aa7bd8497fc$var$cache?.set(queryArgs, stringified);
        serialized = stringified;
    }
    return `${endpointName}(${serialized})`;
};
function $66b21aa7bd8497fc$export$f957748792d43646(...modules) {
    return function baseCreateApi(options) {
        const extractRehydrationInfo = (0, $375276bea32f9eda$export$8402dc26d96f6902)((action)=>options.extractRehydrationInfo?.(action, {
                reducerPath: options.reducerPath ?? "api"
            }));
        const optionsWithDefaults = {
            reducerPath: "api",
            keepUnusedDataFor: 60,
            refetchOnMountOrArgChange: false,
            refetchOnFocus: false,
            refetchOnReconnect: false,
            invalidationBehavior: "delayed",
            ...options,
            extractRehydrationInfo: extractRehydrationInfo,
            serializeQueryArgs (queryArgsApi) {
                let finalSerializeQueryArgs = $66b21aa7bd8497fc$export$db8e4edac9bbb67b;
                if ("serializeQueryArgs" in queryArgsApi.endpointDefinition) {
                    const endpointSQA = queryArgsApi.endpointDefinition.serializeQueryArgs;
                    finalSerializeQueryArgs = (queryArgsApi2)=>{
                        const initialResult = endpointSQA(queryArgsApi2);
                        if (typeof initialResult === "string") return initialResult;
                        else return $66b21aa7bd8497fc$export$db8e4edac9bbb67b({
                            ...queryArgsApi2,
                            queryArgs: initialResult
                        });
                    };
                } else if (options.serializeQueryArgs) finalSerializeQueryArgs = options.serializeQueryArgs;
                return finalSerializeQueryArgs(queryArgsApi);
            },
            tagTypes: [
                ...options.tagTypes || []
            ]
        };
        const context = {
            endpointDefinitions: {},
            batch (fn) {
                fn();
            },
            apiUid: (0, $d91034f47eb948f2$export$ac4959f4f1338dfc)(),
            extractRehydrationInfo: extractRehydrationInfo,
            hasRehydrationInfo: (0, $375276bea32f9eda$export$8402dc26d96f6902)((action)=>extractRehydrationInfo(action) != null)
        };
        const api = {
            injectEndpoints: injectEndpoints,
            enhanceEndpoints ({ addTagTypes: addTagTypes, endpoints: endpoints }) {
                if (addTagTypes) {
                    for (const eT of addTagTypes)if (!optionsWithDefaults.tagTypes.includes(eT)) optionsWithDefaults.tagTypes.push(eT);
                }
                if (endpoints) {
                    for (const [endpointName, partialDefinition] of Object.entries(endpoints))if (typeof partialDefinition === "function") partialDefinition(context.endpointDefinitions[endpointName]);
                    else Object.assign(context.endpointDefinitions[endpointName] || {}, partialDefinition);
                }
                return api;
            }
        };
        const initializedModules = modules.map((m)=>m.init(api, optionsWithDefaults, context));
        function injectEndpoints(inject) {
            const evaluatedEndpoints = inject.endpoints({
                query: (x)=>({
                        ...x,
                        type: "query" /* query */ 
                    }),
                mutation: (x)=>({
                        ...x,
                        type: "mutation" /* mutation */ 
                    })
            });
            for (const [endpointName, definition] of Object.entries(evaluatedEndpoints)){
                if (!inject.overrideExisting && endpointName in context.endpointDefinitions) {
                    typeof $cfae44f0dfdf62c0$exports;
                    continue;
                }
                context.endpointDefinitions[endpointName] = definition;
                for (const m of initializedModules)m.injectEndpoint(endpointName, definition);
            }
            return api;
        }
        return api.injectEndpoints({
            endpoints: options.endpoints
        });
    };
}
function $66b21aa7bd8497fc$export$f72b22d3ac378bae() {
    return function() {
        throw new Error((0, $d91034f47eb948f2$export$378fa86b259c0280)(33));
    };
}
// src/query/core/buildMiddleware/cacheCollection.ts
function $66b21aa7bd8497fc$var$isObjectEmpty(obj) {
    for(let k in obj)return false;
    return true;
}
var $66b21aa7bd8497fc$var$THIRTY_TWO_BIT_MAX_TIMER_SECONDS = 2147482.647;
var $66b21aa7bd8497fc$var$buildCacheCollectionHandler = ({ reducerPath: reducerPath, api: api, context: context, internalState: internalState })=>{
    const { removeQueryResult: removeQueryResult, unsubscribeQueryResult: unsubscribeQueryResult } = api.internalActions;
    function anySubscriptionsRemainingForKey(queryCacheKey) {
        const subscriptions = internalState.currentSubscriptions[queryCacheKey];
        return !!subscriptions && !$66b21aa7bd8497fc$var$isObjectEmpty(subscriptions);
    }
    const currentRemovalTimeouts = {};
    const handler = (action, mwApi, internalState2)=>{
        if (unsubscribeQueryResult.match(action)) {
            const state = mwApi.getState()[reducerPath];
            const { queryCacheKey: queryCacheKey } = action.payload;
            handleUnsubscribe(queryCacheKey, state.queries[queryCacheKey]?.endpointName, mwApi, state.config);
        }
        if (api.util.resetApiState.match(action)) for (const [key, timeout] of Object.entries(currentRemovalTimeouts)){
            if (timeout) clearTimeout(timeout);
            delete currentRemovalTimeouts[key];
        }
        if (context.hasRehydrationInfo(action)) {
            const state = mwApi.getState()[reducerPath];
            const { queries: queries } = context.extractRehydrationInfo(action);
            for (const [queryCacheKey, queryState] of Object.entries(queries))handleUnsubscribe(queryCacheKey, queryState?.endpointName, mwApi, state.config);
        }
    };
    function handleUnsubscribe(queryCacheKey, endpointName, api2, config) {
        const endpointDefinition = context.endpointDefinitions[endpointName];
        const keepUnusedDataFor = endpointDefinition?.keepUnusedDataFor ?? config.keepUnusedDataFor;
        if (keepUnusedDataFor === Infinity) return;
        const finalKeepUnusedDataFor = Math.max(0, Math.min(keepUnusedDataFor, $66b21aa7bd8497fc$var$THIRTY_TWO_BIT_MAX_TIMER_SECONDS));
        if (!anySubscriptionsRemainingForKey(queryCacheKey)) {
            const currentTimeout = currentRemovalTimeouts[queryCacheKey];
            if (currentTimeout) clearTimeout(currentTimeout);
            currentRemovalTimeouts[queryCacheKey] = setTimeout(()=>{
                if (!anySubscriptionsRemainingForKey(queryCacheKey)) api2.dispatch(removeQueryResult({
                    queryCacheKey: queryCacheKey
                }));
                delete currentRemovalTimeouts[queryCacheKey];
            }, finalKeepUnusedDataFor * 1e3);
        }
    }
    return handler;
};
// src/query/core/buildMiddleware/invalidationByTags.ts
var $66b21aa7bd8497fc$var$buildInvalidationByTagsHandler = ({ reducerPath: reducerPath, context: context, context: { endpointDefinitions: endpointDefinitions }, mutationThunk: mutationThunk, queryThunk: queryThunk, api: api, assertTagType: assertTagType, refetchQuery: refetchQuery, internalState: internalState })=>{
    const { removeQueryResult: removeQueryResult } = api.internalActions;
    const isThunkActionWithTags = (0, $d91034f47eb948f2$export$2c3435c7647f7b0d)((0, $d91034f47eb948f2$export$1da80a6ef1307441)(mutationThunk), (0, $d91034f47eb948f2$export$fcc3388fb56de601)(mutationThunk));
    const isQueryEnd = (0, $d91034f47eb948f2$export$2c3435c7647f7b0d)((0, $d91034f47eb948f2$export$1da80a6ef1307441)(mutationThunk, queryThunk), (0, $d91034f47eb948f2$export$a5c5d27e3994c5be)(mutationThunk, queryThunk));
    let pendingTagInvalidations = [];
    const handler = (action, mwApi)=>{
        if (isThunkActionWithTags(action)) invalidateTags($66b21aa7bd8497fc$var$calculateProvidedByThunk(action, "invalidatesTags", endpointDefinitions, assertTagType), mwApi);
        else if (isQueryEnd(action)) invalidateTags([], mwApi);
        else if (api.util.invalidateTags.match(action)) invalidateTags($66b21aa7bd8497fc$var$calculateProvidedBy(action.payload, void 0, void 0, void 0, void 0, assertTagType), mwApi);
    };
    function hasPendingRequests(state) {
        for(const key in state.queries){
            if (state.queries[key]?.status === "pending" /* pending */ ) return true;
        }
        for(const key in state.mutations){
            if (state.mutations[key]?.status === "pending" /* pending */ ) return true;
        }
        return false;
    }
    function invalidateTags(newTags, mwApi) {
        const rootState = mwApi.getState();
        const state = rootState[reducerPath];
        pendingTagInvalidations.push(...newTags);
        if (state.config.invalidationBehavior === "delayed" && hasPendingRequests(state)) return;
        const tags = pendingTagInvalidations;
        pendingTagInvalidations = [];
        if (tags.length === 0) return;
        const toInvalidate = api.util.selectInvalidatedBy(rootState, tags);
        context.batch(()=>{
            const valuesArray = Array.from(toInvalidate.values());
            for (const { queryCacheKey: queryCacheKey } of valuesArray){
                const querySubState = state.queries[queryCacheKey];
                const subscriptionSubState = internalState.currentSubscriptions[queryCacheKey] ?? {};
                if (querySubState) {
                    if ($66b21aa7bd8497fc$var$countObjectKeys(subscriptionSubState) === 0) mwApi.dispatch(removeQueryResult({
                        queryCacheKey: queryCacheKey
                    }));
                    else if (querySubState.status !== "uninitialized" /* uninitialized */ ) mwApi.dispatch(refetchQuery(querySubState, queryCacheKey));
                }
            }
        });
    }
    return handler;
};
// src/query/core/buildMiddleware/polling.ts
var $66b21aa7bd8497fc$var$buildPollingHandler = ({ reducerPath: reducerPath, queryThunk: queryThunk, api: api, refetchQuery: refetchQuery, internalState: internalState })=>{
    const currentPolls = {};
    const handler = (action, mwApi)=>{
        if (api.internalActions.updateSubscriptionOptions.match(action) || api.internalActions.unsubscribeQueryResult.match(action)) updatePollingInterval(action.payload, mwApi);
        if (queryThunk.pending.match(action) || queryThunk.rejected.match(action) && action.meta.condition) updatePollingInterval(action.meta.arg, mwApi);
        if (queryThunk.fulfilled.match(action) || queryThunk.rejected.match(action) && !action.meta.condition) startNextPoll(action.meta.arg, mwApi);
        if (api.util.resetApiState.match(action)) clearPolls();
    };
    function startNextPoll({ queryCacheKey: queryCacheKey }, api2) {
        const state = api2.getState()[reducerPath];
        const querySubState = state.queries[queryCacheKey];
        const subscriptions = internalState.currentSubscriptions[queryCacheKey];
        if (!querySubState || querySubState.status === "uninitialized" /* uninitialized */ ) return;
        const { lowestPollingInterval: lowestPollingInterval, skipPollingIfUnfocused: skipPollingIfUnfocused } = findLowestPollingInterval(subscriptions);
        if (!Number.isFinite(lowestPollingInterval)) return;
        const currentPoll = currentPolls[queryCacheKey];
        if (currentPoll?.timeout) {
            clearTimeout(currentPoll.timeout);
            currentPoll.timeout = void 0;
        }
        const nextPollTimestamp = Date.now() + lowestPollingInterval;
        currentPolls[queryCacheKey] = {
            nextPollTimestamp: nextPollTimestamp,
            pollingInterval: lowestPollingInterval,
            timeout: setTimeout(()=>{
                if (state.config.focused || !skipPollingIfUnfocused) api2.dispatch(refetchQuery(querySubState, queryCacheKey));
                startNextPoll({
                    queryCacheKey: queryCacheKey
                }, api2);
            }, lowestPollingInterval)
        };
    }
    function updatePollingInterval({ queryCacheKey: queryCacheKey }, api2) {
        const state = api2.getState()[reducerPath];
        const querySubState = state.queries[queryCacheKey];
        const subscriptions = internalState.currentSubscriptions[queryCacheKey];
        if (!querySubState || querySubState.status === "uninitialized" /* uninitialized */ ) return;
        const { lowestPollingInterval: lowestPollingInterval } = findLowestPollingInterval(subscriptions);
        if (!Number.isFinite(lowestPollingInterval)) {
            cleanupPollForKey(queryCacheKey);
            return;
        }
        const currentPoll = currentPolls[queryCacheKey];
        const nextPollTimestamp = Date.now() + lowestPollingInterval;
        if (!currentPoll || nextPollTimestamp < currentPoll.nextPollTimestamp) startNextPoll({
            queryCacheKey: queryCacheKey
        }, api2);
    }
    function cleanupPollForKey(key) {
        const existingPoll = currentPolls[key];
        if (existingPoll?.timeout) clearTimeout(existingPoll.timeout);
        delete currentPolls[key];
    }
    function clearPolls() {
        for (const key of Object.keys(currentPolls))cleanupPollForKey(key);
    }
    function findLowestPollingInterval(subscribers = {}) {
        let skipPollingIfUnfocused = false;
        let lowestPollingInterval = Number.POSITIVE_INFINITY;
        for(let key in subscribers)if (!!subscribers[key].pollingInterval) {
            lowestPollingInterval = Math.min(subscribers[key].pollingInterval, lowestPollingInterval);
            skipPollingIfUnfocused = subscribers[key].skipPollingIfUnfocused || skipPollingIfUnfocused;
        }
        return {
            lowestPollingInterval: lowestPollingInterval,
            skipPollingIfUnfocused: skipPollingIfUnfocused
        };
    }
    return handler;
};
// src/query/core/buildMiddleware/windowEventHandling.ts
var $66b21aa7bd8497fc$var$buildWindowEventHandler = ({ reducerPath: reducerPath, context: context, api: api, refetchQuery: refetchQuery, internalState: internalState })=>{
    const { removeQueryResult: removeQueryResult } = api.internalActions;
    const handler = (action, mwApi)=>{
        if ($66b21aa7bd8497fc$var$onFocus.match(action)) refetchValidQueries(mwApi, "refetchOnFocus");
        if ($66b21aa7bd8497fc$var$onOnline.match(action)) refetchValidQueries(mwApi, "refetchOnReconnect");
    };
    function refetchValidQueries(api2, type) {
        const state = api2.getState()[reducerPath];
        const queries = state.queries;
        const subscriptions = internalState.currentSubscriptions;
        context.batch(()=>{
            for (const queryCacheKey of Object.keys(subscriptions)){
                const querySubState = queries[queryCacheKey];
                const subscriptionSubState = subscriptions[queryCacheKey];
                if (!subscriptionSubState || !querySubState) continue;
                const shouldRefetch = Object.values(subscriptionSubState).some((sub)=>sub[type] === true) || Object.values(subscriptionSubState).every((sub)=>sub[type] === void 0) && state.config[type];
                if (shouldRefetch) {
                    if ($66b21aa7bd8497fc$var$countObjectKeys(subscriptionSubState) === 0) api2.dispatch(removeQueryResult({
                        queryCacheKey: queryCacheKey
                    }));
                    else if (querySubState.status !== "uninitialized" /* uninitialized */ ) api2.dispatch(refetchQuery(querySubState, queryCacheKey));
                }
            }
        });
    }
    return handler;
};
// src/query/core/buildMiddleware/cacheLifecycle.ts
var $66b21aa7bd8497fc$var$neverResolvedError = new Error("Promise never resolved before cacheEntryRemoved.");
var $66b21aa7bd8497fc$var$buildCacheLifecycleHandler = ({ api: api, reducerPath: reducerPath, context: context, queryThunk: queryThunk, mutationThunk: mutationThunk, internalState: internalState })=>{
    const isQueryThunk = (0, $d91034f47eb948f2$export$6aa4142d99c1abce)(queryThunk);
    const isMutationThunk = (0, $d91034f47eb948f2$export$6aa4142d99c1abce)(mutationThunk);
    const isFulfilledThunk = (0, $d91034f47eb948f2$export$1da80a6ef1307441)(queryThunk, mutationThunk);
    const lifecycleMap = {};
    const handler = (action, mwApi, stateBefore)=>{
        const cacheKey = getCacheKey(action);
        if (queryThunk.pending.match(action)) {
            const oldState = stateBefore[reducerPath].queries[cacheKey];
            const state = mwApi.getState()[reducerPath].queries[cacheKey];
            if (!oldState && state) handleNewKey(action.meta.arg.endpointName, action.meta.arg.originalArgs, cacheKey, mwApi, action.meta.requestId);
        } else if (mutationThunk.pending.match(action)) {
            const state = mwApi.getState()[reducerPath].mutations[cacheKey];
            if (state) handleNewKey(action.meta.arg.endpointName, action.meta.arg.originalArgs, cacheKey, mwApi, action.meta.requestId);
        } else if (isFulfilledThunk(action)) {
            const lifecycle = lifecycleMap[cacheKey];
            if (lifecycle?.valueResolved) {
                lifecycle.valueResolved({
                    data: action.payload,
                    meta: action.meta.baseQueryMeta
                });
                delete lifecycle.valueResolved;
            }
        } else if (api.internalActions.removeQueryResult.match(action) || api.internalActions.removeMutationResult.match(action)) {
            const lifecycle = lifecycleMap[cacheKey];
            if (lifecycle) {
                delete lifecycleMap[cacheKey];
                lifecycle.cacheEntryRemoved();
            }
        } else if (api.util.resetApiState.match(action)) for (const [cacheKey2, lifecycle] of Object.entries(lifecycleMap)){
            delete lifecycleMap[cacheKey2];
            lifecycle.cacheEntryRemoved();
        }
    };
    function getCacheKey(action) {
        if (isQueryThunk(action)) return action.meta.arg.queryCacheKey;
        if (isMutationThunk(action)) return action.meta.arg.fixedCacheKey ?? action.meta.requestId;
        if (api.internalActions.removeQueryResult.match(action)) return action.payload.queryCacheKey;
        if (api.internalActions.removeMutationResult.match(action)) return $66b21aa7bd8497fc$var$getMutationCacheKey(action.payload);
        return "";
    }
    function handleNewKey(endpointName, originalArgs, queryCacheKey, mwApi, requestId) {
        const endpointDefinition = context.endpointDefinitions[endpointName];
        const onCacheEntryAdded = endpointDefinition?.onCacheEntryAdded;
        if (!onCacheEntryAdded) return;
        let lifecycle = {};
        const cacheEntryRemoved = new Promise((resolve)=>{
            lifecycle.cacheEntryRemoved = resolve;
        });
        const cacheDataLoaded = Promise.race([
            new Promise((resolve)=>{
                lifecycle.valueResolved = resolve;
            }),
            cacheEntryRemoved.then(()=>{
                throw $66b21aa7bd8497fc$var$neverResolvedError;
            })
        ]);
        cacheDataLoaded.catch(()=>{});
        lifecycleMap[queryCacheKey] = lifecycle;
        const selector = api.endpoints[endpointName].select(endpointDefinition.type === "query" /* query */  ? originalArgs : queryCacheKey);
        const extra = mwApi.dispatch((_, __, extra2)=>extra2);
        const lifecycleApi = {
            ...mwApi,
            getCacheEntry: ()=>selector(mwApi.getState()),
            requestId: requestId,
            extra: extra,
            updateCachedData: endpointDefinition.type === "query" /* query */  ? (updateRecipe)=>mwApi.dispatch(api.util.updateQueryData(endpointName, originalArgs, updateRecipe)) : void 0,
            cacheDataLoaded: cacheDataLoaded,
            cacheEntryRemoved: cacheEntryRemoved
        };
        const runningHandler = onCacheEntryAdded(originalArgs, lifecycleApi);
        Promise.resolve(runningHandler).catch((e)=>{
            if (e === $66b21aa7bd8497fc$var$neverResolvedError) return;
            throw e;
        });
    }
    return handler;
};
// src/query/core/buildMiddleware/queryLifecycle.ts
var $66b21aa7bd8497fc$var$buildQueryLifecycleHandler = ({ api: api, context: context, queryThunk: queryThunk, mutationThunk: mutationThunk })=>{
    const isPendingThunk = (0, $d91034f47eb948f2$export$872dec21e9a69476)(queryThunk, mutationThunk);
    const isRejectedThunk = (0, $d91034f47eb948f2$export$a5c5d27e3994c5be)(queryThunk, mutationThunk);
    const isFullfilledThunk = (0, $d91034f47eb948f2$export$1da80a6ef1307441)(queryThunk, mutationThunk);
    const lifecycleMap = {};
    const handler = (action, mwApi)=>{
        if (isPendingThunk(action)) {
            const { requestId: requestId, arg: { endpointName: endpointName, originalArgs: originalArgs } } = action.meta;
            const endpointDefinition = context.endpointDefinitions[endpointName];
            const onQueryStarted = endpointDefinition?.onQueryStarted;
            if (onQueryStarted) {
                const lifecycle = {};
                const queryFulfilled = new Promise((resolve, reject)=>{
                    lifecycle.resolve = resolve;
                    lifecycle.reject = reject;
                });
                queryFulfilled.catch(()=>{});
                lifecycleMap[requestId] = lifecycle;
                const selector = api.endpoints[endpointName].select(endpointDefinition.type === "query" /* query */  ? originalArgs : requestId);
                const extra = mwApi.dispatch((_, __, extra2)=>extra2);
                const lifecycleApi = {
                    ...mwApi,
                    getCacheEntry: ()=>selector(mwApi.getState()),
                    requestId: requestId,
                    extra: extra,
                    updateCachedData: endpointDefinition.type === "query" /* query */  ? (updateRecipe)=>mwApi.dispatch(api.util.updateQueryData(endpointName, originalArgs, updateRecipe)) : void 0,
                    queryFulfilled: queryFulfilled
                };
                onQueryStarted(originalArgs, lifecycleApi);
            }
        } else if (isFullfilledThunk(action)) {
            const { requestId: requestId, baseQueryMeta: baseQueryMeta } = action.meta;
            lifecycleMap[requestId]?.resolve({
                data: action.payload,
                meta: baseQueryMeta
            });
            delete lifecycleMap[requestId];
        } else if (isRejectedThunk(action)) {
            const { requestId: requestId, rejectedWithValue: rejectedWithValue, baseQueryMeta: baseQueryMeta } = action.meta;
            lifecycleMap[requestId]?.reject({
                error: action.payload ?? action.error,
                isUnhandledError: !rejectedWithValue,
                meta: baseQueryMeta
            });
            delete lifecycleMap[requestId];
        }
    };
    return handler;
};
// src/query/core/buildMiddleware/devMiddleware.ts
var $66b21aa7bd8497fc$var$buildDevCheckHandler = ({ api: api, context: { apiUid: apiUid }, reducerPath: reducerPath })=>{
    return (action, mwApi)=>{
        if (api.util.resetApiState.match(action)) mwApi.dispatch(api.internalActions.middlewareRegistered(apiUid));
        typeof $cfae44f0dfdf62c0$exports;
    };
};
var $66b21aa7bd8497fc$var$buildBatchedActionsHandler = ({ api: api, queryThunk: queryThunk, internalState: internalState })=>{
    const subscriptionsPrefix = `${api.reducerPath}/subscriptions`;
    let previousSubscriptions = null;
    let updateSyncTimer = null;
    const { updateSubscriptionOptions: updateSubscriptionOptions, unsubscribeQueryResult: unsubscribeQueryResult } = api.internalActions;
    const actuallyMutateSubscriptions = (mutableState, action)=>{
        if (updateSubscriptionOptions.match(action)) {
            const { queryCacheKey: queryCacheKey, requestId: requestId, options: options } = action.payload;
            if (mutableState?.[queryCacheKey]?.[requestId]) mutableState[queryCacheKey][requestId] = options;
            return true;
        }
        if (unsubscribeQueryResult.match(action)) {
            const { queryCacheKey: queryCacheKey, requestId: requestId } = action.payload;
            if (mutableState[queryCacheKey]) delete mutableState[queryCacheKey][requestId];
            return true;
        }
        if (api.internalActions.removeQueryResult.match(action)) {
            delete mutableState[action.payload.queryCacheKey];
            return true;
        }
        if (queryThunk.pending.match(action)) {
            const { meta: { arg: arg, requestId: requestId } } = action;
            const substate = mutableState[arg.queryCacheKey] ??= {};
            substate[`${requestId}_running`] = {};
            if (arg.subscribe) substate[requestId] = arg.subscriptionOptions ?? substate[requestId] ?? {};
            return true;
        }
        let mutated = false;
        if (queryThunk.fulfilled.match(action) || queryThunk.rejected.match(action)) {
            const state = mutableState[action.meta.arg.queryCacheKey] || {};
            const key = `${action.meta.requestId}_running`;
            mutated ||= !!state[key];
            delete state[key];
        }
        if (queryThunk.rejected.match(action)) {
            const { meta: { condition: condition, arg: arg, requestId: requestId } } = action;
            if (condition && arg.subscribe) {
                const substate = mutableState[arg.queryCacheKey] ??= {};
                substate[requestId] = arg.subscriptionOptions ?? substate[requestId] ?? {};
                mutated = true;
            }
        }
        return mutated;
    };
    const getSubscriptions = ()=>internalState.currentSubscriptions;
    const getSubscriptionCount = (queryCacheKey)=>{
        const subscriptions = getSubscriptions();
        const subscriptionsForQueryArg = subscriptions[queryCacheKey] ?? {};
        return $66b21aa7bd8497fc$var$countObjectKeys(subscriptionsForQueryArg);
    };
    const isRequestSubscribed = (queryCacheKey, requestId)=>{
        const subscriptions = getSubscriptions();
        return !!subscriptions?.[queryCacheKey]?.[requestId];
    };
    const subscriptionSelectors = {
        getSubscriptions: getSubscriptions,
        getSubscriptionCount: getSubscriptionCount,
        isRequestSubscribed: isRequestSubscribed
    };
    return (action, mwApi)=>{
        if (!previousSubscriptions) previousSubscriptions = JSON.parse(JSON.stringify(internalState.currentSubscriptions));
        if (api.util.resetApiState.match(action)) {
            previousSubscriptions = internalState.currentSubscriptions = {};
            updateSyncTimer = null;
            return [
                true,
                false
            ];
        }
        if (api.internalActions.internal_getRTKQSubscriptions.match(action)) return [
            false,
            subscriptionSelectors
        ];
        const didMutate = actuallyMutateSubscriptions(internalState.currentSubscriptions, action);
        let actionShouldContinue = true;
        if (didMutate) {
            if (!updateSyncTimer) updateSyncTimer = setTimeout(()=>{
                const newSubscriptions = JSON.parse(JSON.stringify(internalState.currentSubscriptions));
                const [, patches] = (0, $5f9e38360d79f95a$export$4da66d41c9492c78)(previousSubscriptions, ()=>newSubscriptions);
                mwApi.next(api.internalActions.subscriptionsUpdated(patches));
                previousSubscriptions = newSubscriptions;
                updateSyncTimer = null;
            }, 500);
            const isSubscriptionSliceAction = typeof action.type == "string" && !!action.type.startsWith(subscriptionsPrefix);
            const isAdditionalSubscriptionAction = queryThunk.rejected.match(action) && action.meta.condition && !!action.meta.arg.subscribe;
            actionShouldContinue = !isSubscriptionSliceAction && !isAdditionalSubscriptionAction;
        }
        return [
            actionShouldContinue,
            false
        ];
    };
};
// src/query/core/buildMiddleware/index.ts
function $66b21aa7bd8497fc$var$buildMiddleware(input) {
    const { reducerPath: reducerPath, queryThunk: queryThunk, api: api, context: context } = input;
    const { apiUid: apiUid } = context;
    const actions = {
        invalidateTags: (0, $d91034f47eb948f2$export$309c7a02b0b0bc62)(`${reducerPath}/invalidateTags`)
    };
    const isThisApiSliceAction = (action)=>action.type.startsWith(`${reducerPath}/`);
    const handlerBuilders = [
        $66b21aa7bd8497fc$var$buildDevCheckHandler,
        $66b21aa7bd8497fc$var$buildCacheCollectionHandler,
        $66b21aa7bd8497fc$var$buildInvalidationByTagsHandler,
        $66b21aa7bd8497fc$var$buildPollingHandler,
        $66b21aa7bd8497fc$var$buildCacheLifecycleHandler,
        $66b21aa7bd8497fc$var$buildQueryLifecycleHandler
    ];
    const middleware = (mwApi)=>{
        let initialized2 = false;
        let internalState = {
            currentSubscriptions: {}
        };
        const builderArgs = {
            ...input,
            internalState: internalState,
            refetchQuery: refetchQuery,
            isThisApiSliceAction: isThisApiSliceAction
        };
        const handlers = handlerBuilders.map((build)=>build(builderArgs));
        const batchedActionsHandler = $66b21aa7bd8497fc$var$buildBatchedActionsHandler(builderArgs);
        const windowEventsHandler = $66b21aa7bd8497fc$var$buildWindowEventHandler(builderArgs);
        return (next)=>{
            return (action)=>{
                if (!(0, $669d9d4c4c7ccc3c$export$b956e38827fca970)(action)) return next(action);
                if (!initialized2) {
                    initialized2 = true;
                    mwApi.dispatch(api.internalActions.middlewareRegistered(apiUid));
                }
                const mwApiWithNext = {
                    ...mwApi,
                    next: next
                };
                const stateBefore = mwApi.getState();
                const [actionShouldContinue, internalProbeResult] = batchedActionsHandler(action, mwApiWithNext, stateBefore);
                let res;
                if (actionShouldContinue) res = next(action);
                else res = internalProbeResult;
                if (!!mwApi.getState()[reducerPath]) {
                    windowEventsHandler(action, mwApiWithNext, stateBefore);
                    if (isThisApiSliceAction(action) || context.hasRehydrationInfo(action)) for (let handler of handlers)handler(action, mwApiWithNext, stateBefore);
                }
                return res;
            };
        };
    };
    return {
        middleware: middleware,
        actions: actions
    };
    function refetchQuery(querySubState, queryCacheKey, override = {}) {
        return queryThunk({
            type: "query",
            endpointName: querySubState.endpointName,
            originalArgs: querySubState.originalArgs,
            subscribe: false,
            forceRefetch: true,
            queryCacheKey: queryCacheKey,
            ...override
        });
    }
}
// src/query/tsHelpers.ts
function $66b21aa7bd8497fc$var$assertCast(v) {}
function $66b21aa7bd8497fc$var$safeAssign(target, ...args) {
    return Object.assign(target, ...args);
}
var $66b21aa7bd8497fc$export$2902d0921e535c0 = /* @__PURE__ */ Symbol();
var $66b21aa7bd8497fc$export$eb718ff92afd6f9b = ({ createSelector: createSelector2 = (0, $375276bea32f9eda$export$595d22ed68ca2841) } = {})=>({
        name: $66b21aa7bd8497fc$export$2902d0921e535c0,
        init (api, { baseQuery: baseQuery, tagTypes: tagTypes, reducerPath: reducerPath, serializeQueryArgs: serializeQueryArgs, keepUnusedDataFor: keepUnusedDataFor, refetchOnMountOrArgChange: refetchOnMountOrArgChange, refetchOnFocus: refetchOnFocus, refetchOnReconnect: refetchOnReconnect, invalidationBehavior: invalidationBehavior }, context) {
            (0, $5f9e38360d79f95a$export$d3a6659991a0696c)();
            $66b21aa7bd8497fc$var$assertCast(serializeQueryArgs);
            const assertTagType = (tag)=>{
                typeof $cfae44f0dfdf62c0$exports;
                return tag;
            };
            Object.assign(api, {
                reducerPath: reducerPath,
                endpoints: {},
                internalActions: {
                    onOnline: $66b21aa7bd8497fc$var$onOnline,
                    onOffline: $66b21aa7bd8497fc$var$onOffline,
                    onFocus: $66b21aa7bd8497fc$var$onFocus,
                    onFocusLost: $66b21aa7bd8497fc$var$onFocusLost
                },
                util: {}
            });
            const { queryThunk: queryThunk, mutationThunk: mutationThunk, patchQueryData: patchQueryData, updateQueryData: updateQueryData, upsertQueryData: upsertQueryData, prefetch: prefetch, buildMatchThunkActions: buildMatchThunkActions } = $66b21aa7bd8497fc$var$buildThunks({
                baseQuery: baseQuery,
                reducerPath: reducerPath,
                context: context,
                api: api,
                serializeQueryArgs: serializeQueryArgs,
                assertTagType: assertTagType
            });
            const { reducer: reducer, actions: sliceActions } = $66b21aa7bd8497fc$var$buildSlice({
                context: context,
                queryThunk: queryThunk,
                mutationThunk: mutationThunk,
                reducerPath: reducerPath,
                assertTagType: assertTagType,
                config: {
                    refetchOnFocus: refetchOnFocus,
                    refetchOnReconnect: refetchOnReconnect,
                    refetchOnMountOrArgChange: refetchOnMountOrArgChange,
                    keepUnusedDataFor: keepUnusedDataFor,
                    reducerPath: reducerPath,
                    invalidationBehavior: invalidationBehavior
                }
            });
            $66b21aa7bd8497fc$var$safeAssign(api.util, {
                patchQueryData: patchQueryData,
                updateQueryData: updateQueryData,
                upsertQueryData: upsertQueryData,
                prefetch: prefetch,
                resetApiState: sliceActions.resetApiState
            });
            $66b21aa7bd8497fc$var$safeAssign(api.internalActions, sliceActions);
            const { middleware: middleware, actions: middlewareActions } = $66b21aa7bd8497fc$var$buildMiddleware({
                reducerPath: reducerPath,
                context: context,
                queryThunk: queryThunk,
                mutationThunk: mutationThunk,
                api: api,
                assertTagType: assertTagType
            });
            $66b21aa7bd8497fc$var$safeAssign(api.util, middlewareActions);
            $66b21aa7bd8497fc$var$safeAssign(api, {
                reducer: reducer,
                middleware: middleware
            });
            const { buildQuerySelector: buildQuerySelector, buildMutationSelector: buildMutationSelector, selectInvalidatedBy: selectInvalidatedBy, selectCachedArgsForQuery: selectCachedArgsForQuery } = $66b21aa7bd8497fc$var$buildSelectors({
                serializeQueryArgs: serializeQueryArgs,
                reducerPath: reducerPath,
                createSelector: createSelector2
            });
            $66b21aa7bd8497fc$var$safeAssign(api.util, {
                selectInvalidatedBy: selectInvalidatedBy,
                selectCachedArgsForQuery: selectCachedArgsForQuery
            });
            const { buildInitiateQuery: buildInitiateQuery, buildInitiateMutation: buildInitiateMutation, getRunningMutationThunk: getRunningMutationThunk, getRunningMutationsThunk: getRunningMutationsThunk, getRunningQueriesThunk: getRunningQueriesThunk, getRunningQueryThunk: getRunningQueryThunk } = $66b21aa7bd8497fc$var$buildInitiate({
                queryThunk: queryThunk,
                mutationThunk: mutationThunk,
                api: api,
                serializeQueryArgs: serializeQueryArgs,
                context: context
            });
            $66b21aa7bd8497fc$var$safeAssign(api.util, {
                getRunningMutationThunk: getRunningMutationThunk,
                getRunningMutationsThunk: getRunningMutationsThunk,
                getRunningQueryThunk: getRunningQueryThunk,
                getRunningQueriesThunk: getRunningQueriesThunk
            });
            return {
                name: $66b21aa7bd8497fc$export$2902d0921e535c0,
                injectEndpoint (endpointName, definition) {
                    const anyApi = api;
                    anyApi.endpoints[endpointName] ??= {};
                    if ($66b21aa7bd8497fc$var$isQueryDefinition(definition)) $66b21aa7bd8497fc$var$safeAssign(anyApi.endpoints[endpointName], {
                        name: endpointName,
                        select: buildQuerySelector(endpointName, definition),
                        initiate: buildInitiateQuery(endpointName, definition)
                    }, buildMatchThunkActions(queryThunk, endpointName));
                    else if ($66b21aa7bd8497fc$var$isMutationDefinition(definition)) $66b21aa7bd8497fc$var$safeAssign(anyApi.endpoints[endpointName], {
                        name: endpointName,
                        select: buildMutationSelector(),
                        initiate: buildInitiateMutation(endpointName)
                    }, buildMatchThunkActions(mutationThunk, endpointName));
                }
            };
        }
    });
// src/query/core/index.ts
var $66b21aa7bd8497fc$export$9cdc2b9a8d94c842 = /* @__PURE__ */ $66b21aa7bd8497fc$export$f957748792d43646($66b21aa7bd8497fc$export$eb718ff92afd6f9b());




var $acw62 = parcelRequire("acw62");



function $51cd259feff82e55$var$useStableQueryArgs(queryArgs, serialize, endpointDefinition, endpointName) {
    const incoming = (0, $acw62.useMemo)(()=>({
            queryArgs: queryArgs,
            serialized: typeof queryArgs == "object" ? serialize({
                queryArgs: queryArgs,
                endpointDefinition: endpointDefinition,
                endpointName: endpointName
            }) : queryArgs
        }), [
        queryArgs,
        serialize,
        endpointDefinition,
        endpointName
    ]);
    const cache2 = (0, $acw62.useRef)(incoming);
    (0, $acw62.useEffect)(()=>{
        if (cache2.current.serialized !== incoming.serialized) cache2.current = incoming;
    }, [
        incoming
    ]);
    return cache2.current.serialized === incoming.serialized ? cache2.current.queryArgs : queryArgs;
}
// src/query/react/constants.ts
var $51cd259feff82e55$var$UNINITIALIZED_VALUE = Symbol();
function $51cd259feff82e55$var$useShallowStableValue(value) {
    const cache2 = (0, $acw62.useRef)(value);
    (0, $acw62.useEffect)(()=>{
        if (!(0, $55388fc2f116d4d7$export$d36bdfa510afb180)(cache2.current, value)) cache2.current = value;
    }, [
        value
    ]);
    return (0, $55388fc2f116d4d7$export$d36bdfa510afb180)(cache2.current, value) ? cache2.current : value;
}
// src/query/defaultSerializeQueryArgs.ts
var $51cd259feff82e55$var$cache = WeakMap ? /* @__PURE__ */ new WeakMap() : void 0;
var $51cd259feff82e55$var$defaultSerializeQueryArgs = ({ endpointName: endpointName, queryArgs: queryArgs })=>{
    let serialized = "";
    const cached = $51cd259feff82e55$var$cache?.get(queryArgs);
    if (typeof cached === "string") serialized = cached;
    else {
        const stringified = JSON.stringify(queryArgs, (key, value)=>(0, $669d9d4c4c7ccc3c$export$53b83ca8eaab0383)(value) ? Object.keys(value).sort().reduce((acc, key2)=>{
                acc[key2] = value[key2];
                return acc;
            }, {}) : value);
        if ((0, $669d9d4c4c7ccc3c$export$53b83ca8eaab0383)(queryArgs)) $51cd259feff82e55$var$cache?.set(queryArgs, stringified);
        serialized = stringified;
    }
    return `${endpointName}(${serialized})`;
};
// src/query/react/buildHooks.ts
var $51cd259feff82e55$var$useIsomorphicLayoutEffect = typeof window !== "undefined" && !!window.document && !!window.document.createElement ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
var $51cd259feff82e55$var$noPendingQueryStateSelector = (selected)=>{
    if (selected.isUninitialized) return {
        ...selected,
        isUninitialized: false,
        isFetching: true,
        isLoading: selected.data !== void 0 ? false : true,
        status: (0, $66b21aa7bd8497fc$export$f4258b89f6bad1d6).pending
    };
    return selected;
};
function $51cd259feff82e55$var$buildHooks({ api: api, moduleOptions: { batch: batch, hooks: { useDispatch: useDispatch, useSelector: useSelector, useStore: useStore }, unstable__sideEffectsInRender: unstable__sideEffectsInRender, createSelector: createSelector2 }, serializeQueryArgs: serializeQueryArgs, context: context }) {
    const usePossiblyImmediateEffect = unstable__sideEffectsInRender ? (cb)=>cb() : (0, $acw62.useEffect);
    return {
        buildQueryHooks: buildQueryHooks,
        buildMutationHook: buildMutationHook,
        usePrefetch: usePrefetch
    };
    function queryStatePreSelector(currentState, lastResult, queryArgs) {
        if (lastResult?.endpointName && currentState.isUninitialized) {
            const { endpointName: endpointName } = lastResult;
            const endpointDefinition = context.endpointDefinitions[endpointName];
            if (serializeQueryArgs({
                queryArgs: lastResult.originalArgs,
                endpointDefinition: endpointDefinition,
                endpointName: endpointName
            }) === serializeQueryArgs({
                queryArgs: queryArgs,
                endpointDefinition: endpointDefinition,
                endpointName: endpointName
            })) lastResult = void 0;
        }
        let data = currentState.isSuccess ? currentState.data : lastResult?.data;
        if (data === void 0) data = currentState.data;
        const hasData = data !== void 0;
        const isFetching = currentState.isLoading;
        const isLoading = !hasData && isFetching;
        const isSuccess = currentState.isSuccess || isFetching && hasData;
        return {
            ...currentState,
            data: data,
            currentData: currentState.data,
            isFetching: isFetching,
            isLoading: isLoading,
            isSuccess: isSuccess
        };
    }
    function usePrefetch(endpointName, defaultOptions) {
        const dispatch = useDispatch();
        const stableDefaultOptions = $51cd259feff82e55$var$useShallowStableValue(defaultOptions);
        return (0, $acw62.useCallback)((arg, options)=>dispatch(api.util.prefetch(endpointName, arg, {
                ...stableDefaultOptions,
                ...options
            })), [
            endpointName,
            dispatch,
            stableDefaultOptions
        ]);
    }
    function buildQueryHooks(name) {
        const useQuerySubscription = (arg, { refetchOnReconnect: refetchOnReconnect, refetchOnFocus: refetchOnFocus, refetchOnMountOrArgChange: refetchOnMountOrArgChange, skip: skip = false, pollingInterval: pollingInterval = 0, skipPollingIfUnfocused: skipPollingIfUnfocused = false } = {})=>{
            const { initiate: initiate } = api.endpoints[name];
            const dispatch = useDispatch();
            const subscriptionSelectorsRef = (0, $acw62.useRef)();
            if (!subscriptionSelectorsRef.current) {
                const returnedValue = dispatch(api.internalActions.internal_getRTKQSubscriptions());
                subscriptionSelectorsRef.current = returnedValue;
            }
            const stableArg = $51cd259feff82e55$var$useStableQueryArgs(skip ? (0, $66b21aa7bd8497fc$export$1aa5a89531b7670d) : arg, // Even if the user provided a per-endpoint `serializeQueryArgs` with
            // a consistent return value, _here_ we want to use the default behavior
            // so we can tell if _anything_ actually changed. Otherwise, we can end up
            // with a case where the query args did change but the serialization doesn't,
            // and then we never try to initiate a refetch.
            $51cd259feff82e55$var$defaultSerializeQueryArgs, context.endpointDefinitions[name], name);
            const stableSubscriptionOptions = $51cd259feff82e55$var$useShallowStableValue({
                refetchOnReconnect: refetchOnReconnect,
                refetchOnFocus: refetchOnFocus,
                pollingInterval: pollingInterval,
                skipPollingIfUnfocused: skipPollingIfUnfocused
            });
            const lastRenderHadSubscription = (0, $acw62.useRef)(false);
            const promiseRef = (0, $acw62.useRef)();
            let { queryCacheKey: queryCacheKey, requestId: requestId } = promiseRef.current || {};
            let currentRenderHasSubscription = false;
            if (queryCacheKey && requestId) currentRenderHasSubscription = subscriptionSelectorsRef.current.isRequestSubscribed(queryCacheKey, requestId);
            const subscriptionRemoved = !currentRenderHasSubscription && lastRenderHadSubscription.current;
            usePossiblyImmediateEffect(()=>{
                lastRenderHadSubscription.current = currentRenderHasSubscription;
            });
            usePossiblyImmediateEffect(()=>{
                if (subscriptionRemoved) promiseRef.current = void 0;
            }, [
                subscriptionRemoved
            ]);
            usePossiblyImmediateEffect(()=>{
                const lastPromise = promiseRef.current;
                typeof $cfae44f0dfdf62c0$exports;
                if (stableArg === (0, $66b21aa7bd8497fc$export$1aa5a89531b7670d)) {
                    lastPromise?.unsubscribe();
                    promiseRef.current = void 0;
                    return;
                }
                const lastSubscriptionOptions = promiseRef.current?.subscriptionOptions;
                if (!lastPromise || lastPromise.arg !== stableArg) {
                    lastPromise?.unsubscribe();
                    const promise = dispatch(initiate(stableArg, {
                        subscriptionOptions: stableSubscriptionOptions,
                        forceRefetch: refetchOnMountOrArgChange
                    }));
                    promiseRef.current = promise;
                } else if (stableSubscriptionOptions !== lastSubscriptionOptions) lastPromise.updateSubscriptionOptions(stableSubscriptionOptions);
            }, [
                dispatch,
                initiate,
                refetchOnMountOrArgChange,
                stableArg,
                stableSubscriptionOptions,
                subscriptionRemoved
            ]);
            (0, $acw62.useEffect)(()=>{
                return ()=>{
                    promiseRef.current?.unsubscribe();
                    promiseRef.current = void 0;
                };
            }, []);
            return (0, $acw62.useMemo)(()=>({
                    /**
         * A method to manually refetch data for the query
         */ refetch: ()=>{
                        if (!promiseRef.current) throw new Error((0, $d91034f47eb948f2$export$378fa86b259c0280)(38));
                        return promiseRef.current?.refetch();
                    }
                }), []);
        };
        const useLazyQuerySubscription = ({ refetchOnReconnect: refetchOnReconnect, refetchOnFocus: refetchOnFocus, pollingInterval: pollingInterval = 0, skipPollingIfUnfocused: skipPollingIfUnfocused = false } = {})=>{
            const { initiate: initiate } = api.endpoints[name];
            const dispatch = useDispatch();
            const [arg, setArg] = (0, $acw62.useState)($51cd259feff82e55$var$UNINITIALIZED_VALUE);
            const promiseRef = (0, $acw62.useRef)();
            const stableSubscriptionOptions = $51cd259feff82e55$var$useShallowStableValue({
                refetchOnReconnect: refetchOnReconnect,
                refetchOnFocus: refetchOnFocus,
                pollingInterval: pollingInterval,
                skipPollingIfUnfocused: skipPollingIfUnfocused
            });
            usePossiblyImmediateEffect(()=>{
                const lastSubscriptionOptions = promiseRef.current?.subscriptionOptions;
                if (stableSubscriptionOptions !== lastSubscriptionOptions) promiseRef.current?.updateSubscriptionOptions(stableSubscriptionOptions);
            }, [
                stableSubscriptionOptions
            ]);
            const subscriptionOptionsRef = (0, $acw62.useRef)(stableSubscriptionOptions);
            usePossiblyImmediateEffect(()=>{
                subscriptionOptionsRef.current = stableSubscriptionOptions;
            }, [
                stableSubscriptionOptions
            ]);
            const trigger = (0, $acw62.useCallback)(function(arg2, preferCacheValue = false) {
                let promise;
                batch(()=>{
                    promiseRef.current?.unsubscribe();
                    promiseRef.current = promise = dispatch(initiate(arg2, {
                        subscriptionOptions: subscriptionOptionsRef.current,
                        forceRefetch: !preferCacheValue
                    }));
                    setArg(arg2);
                });
                return promise;
            }, [
                dispatch,
                initiate
            ]);
            (0, $acw62.useEffect)(()=>{
                return ()=>{
                    promiseRef?.current?.unsubscribe();
                };
            }, []);
            (0, $acw62.useEffect)(()=>{
                if (arg !== $51cd259feff82e55$var$UNINITIALIZED_VALUE && !promiseRef.current) trigger(arg, true);
            }, [
                arg,
                trigger
            ]);
            return (0, $acw62.useMemo)(()=>[
                    trigger,
                    arg
                ], [
                trigger,
                arg
            ]);
        };
        const useQueryState = (arg, { skip: skip = false, selectFromResult: selectFromResult } = {})=>{
            const { select: select } = api.endpoints[name];
            const stableArg = $51cd259feff82e55$var$useStableQueryArgs(skip ? (0, $66b21aa7bd8497fc$export$1aa5a89531b7670d) : arg, serializeQueryArgs, context.endpointDefinitions[name], name);
            const lastValue = (0, $acw62.useRef)();
            const selectDefaultResult = (0, $acw62.useMemo)(()=>createSelector2([
                    select(stableArg),
                    (_, lastResult)=>lastResult,
                    (_)=>stableArg
                ], queryStatePreSelector, {
                    memoizeOptions: {
                        resultEqualityCheck: (0, $55388fc2f116d4d7$export$d36bdfa510afb180)
                    }
                }), [
                select,
                stableArg
            ]);
            const querySelector = (0, $acw62.useMemo)(()=>selectFromResult ? createSelector2([
                    selectDefaultResult
                ], selectFromResult, {
                    devModeChecks: {
                        identityFunctionCheck: "never"
                    }
                }) : selectDefaultResult, [
                selectDefaultResult,
                selectFromResult
            ]);
            const currentState = useSelector((state)=>querySelector(state, lastValue.current), (0, $55388fc2f116d4d7$export$d36bdfa510afb180));
            const store = useStore();
            const newLastValue = selectDefaultResult(store.getState(), lastValue.current);
            $51cd259feff82e55$var$useIsomorphicLayoutEffect(()=>{
                lastValue.current = newLastValue;
            }, [
                newLastValue
            ]);
            return currentState;
        };
        return {
            useQueryState: useQueryState,
            useQuerySubscription: useQuerySubscription,
            useLazyQuerySubscription: useLazyQuerySubscription,
            useLazyQuery (options) {
                const [trigger, arg] = useLazyQuerySubscription(options);
                const queryStateResults = useQueryState(arg, {
                    ...options,
                    skip: arg === $51cd259feff82e55$var$UNINITIALIZED_VALUE
                });
                const info = (0, $acw62.useMemo)(()=>({
                        lastArg: arg
                    }), [
                    arg
                ]);
                return (0, $acw62.useMemo)(()=>[
                        trigger,
                        queryStateResults,
                        info
                    ], [
                    trigger,
                    queryStateResults,
                    info
                ]);
            },
            useQuery (arg, options) {
                const querySubscriptionResults = useQuerySubscription(arg, options);
                const queryStateResults = useQueryState(arg, {
                    selectFromResult: arg === (0, $66b21aa7bd8497fc$export$1aa5a89531b7670d) || options?.skip ? void 0 : $51cd259feff82e55$var$noPendingQueryStateSelector,
                    ...options
                });
                const { data: data, status: status, isLoading: isLoading, isSuccess: isSuccess, isError: isError, error: error } = queryStateResults;
                (0, $acw62.useDebugValue)({
                    data: data,
                    status: status,
                    isLoading: isLoading,
                    isSuccess: isSuccess,
                    isError: isError,
                    error: error
                });
                return (0, $acw62.useMemo)(()=>({
                        ...queryStateResults,
                        ...querySubscriptionResults
                    }), [
                    queryStateResults,
                    querySubscriptionResults
                ]);
            }
        };
    }
    function buildMutationHook(name) {
        return ({ selectFromResult: selectFromResult, fixedCacheKey: fixedCacheKey } = {})=>{
            const { select: select, initiate: initiate } = api.endpoints[name];
            const dispatch = useDispatch();
            const [promise, setPromise] = (0, $acw62.useState)();
            (0, $acw62.useEffect)(()=>()=>{
                    if (!promise?.arg.fixedCacheKey) promise?.reset();
                }, [
                promise
            ]);
            const triggerMutation = (0, $acw62.useCallback)(function(arg) {
                const promise2 = dispatch(initiate(arg, {
                    fixedCacheKey: fixedCacheKey
                }));
                setPromise(promise2);
                return promise2;
            }, [
                dispatch,
                initiate,
                fixedCacheKey
            ]);
            const { requestId: requestId } = promise || {};
            const selectDefaultResult = (0, $acw62.useMemo)(()=>select({
                    fixedCacheKey: fixedCacheKey,
                    requestId: promise?.requestId
                }), [
                fixedCacheKey,
                promise,
                select
            ]);
            const mutationSelector = (0, $acw62.useMemo)(()=>selectFromResult ? createSelector2([
                    selectDefaultResult
                ], selectFromResult) : selectDefaultResult, [
                selectFromResult,
                selectDefaultResult
            ]);
            const currentState = useSelector(mutationSelector, (0, $55388fc2f116d4d7$export$d36bdfa510afb180));
            const originalArgs = fixedCacheKey == null ? promise?.arg.originalArgs : void 0;
            const reset = (0, $acw62.useCallback)(()=>{
                batch(()=>{
                    if (promise) setPromise(void 0);
                    if (fixedCacheKey) dispatch(api.internalActions.removeMutationResult({
                        requestId: requestId,
                        fixedCacheKey: fixedCacheKey
                    }));
                });
            }, [
                dispatch,
                fixedCacheKey,
                promise,
                requestId
            ]);
            const { endpointName: endpointName, data: data, status: status, isLoading: isLoading, isSuccess: isSuccess, isError: isError, error: error } = currentState;
            (0, $acw62.useDebugValue)({
                endpointName: endpointName,
                data: data,
                status: status,
                isLoading: isLoading,
                isSuccess: isSuccess,
                isError: isError,
                error: error
            });
            const finalState = (0, $acw62.useMemo)(()=>({
                    ...currentState,
                    originalArgs: originalArgs,
                    reset: reset
                }), [
                currentState,
                originalArgs,
                reset
            ]);
            return (0, $acw62.useMemo)(()=>[
                    triggerMutation,
                    finalState
                ], [
                triggerMutation,
                finalState
            ]);
        };
    }
}
// src/query/endpointDefinitions.ts
function $51cd259feff82e55$var$isQueryDefinition(e) {
    return e.type === "query" /* query */ ;
}
function $51cd259feff82e55$var$isMutationDefinition(e) {
    return e.type === "mutation" /* mutation */ ;
}
// src/query/utils/capitalize.ts
function $51cd259feff82e55$var$capitalize(str) {
    return str.replace(str[0], str[0].toUpperCase());
}
// src/query/tsHelpers.ts
function $51cd259feff82e55$var$safeAssign(target, ...args) {
    return Object.assign(target, ...args);
}
// src/query/utils/countObjectKeys.ts
function $51cd259feff82e55$var$countObjectKeys(obj) {
    let count = 0;
    for(const _key in obj)count++;
    return count;
}
var $51cd259feff82e55$export$fba4c1b64338c09f = /* @__PURE__ */ Symbol();
var $51cd259feff82e55$export$8b98f9e72008ec90 = ({ batch: batch = (0, $55388fc2f116d4d7$export$712ea50be43a7858), hooks: hooks = {
    useDispatch: (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8),
    useSelector: (0, $55388fc2f116d4d7$export$2105062e25df4afe),
    useStore: (0, $55388fc2f116d4d7$export$6ccbb43953eebf8)
}, createSelector: createSelector2 = (0, $375276bea32f9eda$export$595d22ed68ca2841), unstable__sideEffectsInRender: unstable__sideEffectsInRender = false, ...rest } = {})=>{
    return {
        name: $51cd259feff82e55$export$fba4c1b64338c09f,
        init (api, { serializeQueryArgs: serializeQueryArgs }, context) {
            const anyApi = api;
            const { buildQueryHooks: buildQueryHooks, buildMutationHook: buildMutationHook, usePrefetch: usePrefetch } = $51cd259feff82e55$var$buildHooks({
                api: api,
                moduleOptions: {
                    batch: batch,
                    hooks: hooks,
                    unstable__sideEffectsInRender: unstable__sideEffectsInRender,
                    createSelector: createSelector2
                },
                serializeQueryArgs: serializeQueryArgs,
                context: context
            });
            $51cd259feff82e55$var$safeAssign(anyApi, {
                usePrefetch: usePrefetch
            });
            $51cd259feff82e55$var$safeAssign(context, {
                batch: batch
            });
            return {
                injectEndpoint (endpointName, definition) {
                    if ($51cd259feff82e55$var$isQueryDefinition(definition)) {
                        const { useQuery: useQuery, useLazyQuery: useLazyQuery, useLazyQuerySubscription: useLazyQuerySubscription, useQueryState: useQueryState, useQuerySubscription: useQuerySubscription } = buildQueryHooks(endpointName);
                        $51cd259feff82e55$var$safeAssign(anyApi.endpoints[endpointName], {
                            useQuery: useQuery,
                            useLazyQuery: useLazyQuery,
                            useLazyQuerySubscription: useLazyQuerySubscription,
                            useQueryState: useQueryState,
                            useQuerySubscription: useQuerySubscription
                        });
                        api[`use${$51cd259feff82e55$var$capitalize(endpointName)}Query`] = useQuery;
                        api[`useLazy${$51cd259feff82e55$var$capitalize(endpointName)}Query`] = useLazyQuery;
                    } else if ($51cd259feff82e55$var$isMutationDefinition(definition)) {
                        const useMutation = buildMutationHook(endpointName);
                        $51cd259feff82e55$var$safeAssign(anyApi.endpoints[endpointName], {
                            useMutation: useMutation
                        });
                        api[`use${$51cd259feff82e55$var$capitalize(endpointName)}Mutation`] = useMutation;
                    }
                }
            };
        }
    };
};
function $51cd259feff82e55$export$f4e57f6132f56752(props) {
    const context = props.context || (0, $55388fc2f116d4d7$export$cc80c08dc91f1c00);
    const existingContext = (0, $acw62.useContext)(context);
    if (existingContext) throw new Error((0, $d91034f47eb948f2$export$378fa86b259c0280)(35));
    const [store] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>(0, $d91034f47eb948f2$export$7d8a5b498da695ac)({
            reducer: {
                [props.api.reducerPath]: props.api.reducer
            },
            middleware: (gDM)=>gDM().concat(props.api.middleware)
        }));
    (0, $acw62.useEffect)(()=>props.setupListeners === false ? void 0 : (0, $66b21aa7bd8497fc$export$120c0dbb0351414c)(store.dispatch, props.setupListeners), [
        props.setupListeners,
        store.dispatch
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $55388fc2f116d4d7$export$2881499e37b75b9a), {
        store: store,
        context: context
    }, props.children);
}
// src/query/react/index.ts
var $51cd259feff82e55$export$9cdc2b9a8d94c842 = /* @__PURE__ */ (0, $66b21aa7bd8497fc$export$f957748792d43646)((0, $66b21aa7bd8497fc$export$eb718ff92afd6f9b)(), $51cd259feff82e55$export$8b98f9e72008ec90());


function $d3ab9ae1f203b599$var$getCookie(name) {
    const cookies = document.cookie.split(";");
    for (const cookie of cookies){
        const [cookieName, cookieValue] = cookie.trim().split("=");
        if (cookieName === name) return cookieValue;
    }
    return null;
}
function $d3ab9ae1f203b599$export$1e4d4724de7b199e() {
    const headers = {
        "X-CSRFToken": $d3ab9ae1f203b599$var$getCookie("csrftoken"),
        Accept: "application/json",
        "Content-Type": "application/json"
    };
    return headers;
}
const $d3ab9ae1f203b599$export$4d28219d42798a75 = ()=>{
    const env = "production";
    if (env === "production") return "https://api.consili.io";
    else if (env === "development") return "http://api-local.consili.io:8000";
    else return `http://api-${env}.consili.io`;
};
const $d3ab9ae1f203b599$export$1a808ff72027c699 = ()=>({
        Accept: "application/json",
        "Content-Type": "application/json"
    });



const $5cdc329eeebd56d0$export$923ea8233b386e99 = (0, $d3ab9ae1f203b599$export$4d28219d42798a75)();
const $5cdc329eeebd56d0$export$dea2465ef0480ab9 = [
    "Interest",
    "User",
    "Category",
    "Insight",
    "Source",
    "UserSettings",
    "SourceData",
    "Synthesis",
    "Chat"
];


const $0990d2137b3e0830$export$bcc8035e549759b4 = (0, $51cd259feff82e55$export$9cdc2b9a8d94c842)({
    baseQuery: (0, $66b21aa7bd8497fc$export$adcf4c6133c49b4e)({
        baseUrl: (0, $5cdc329eeebd56d0$export$923ea8233b386e99),
        credentials: "include"
    }),
    endpoints: ()=>({}),
    tagTypes: (0, $5cdc329eeebd56d0$export$dea2465ef0480ab9)
});
const { useLazyFunctionNameQuery: $0990d2137b3e0830$export$522f296e2325105e } = $0990d2137b3e0830$export$bcc8035e549759b4;
function $0990d2137b3e0830$export$65858239e7ec8811(functionName, queryURL, method, providesTags) {
    return $0990d2137b3e0830$export$bcc8035e549759b4.injectEndpoints({
        endpoints: (builder)=>({
                [functionName]: builder.query({
                    query: (credentials)=>({
                            url: queryURL,
                            method: method,
                            headers: (0, $d3ab9ae1f203b599$export$1e4d4724de7b199e)(),
                            body: credentials
                        }),
                    providesTags: providesTags
                })
            }),
        overrideExisting: false
    });
}
function $0990d2137b3e0830$export$e68afafd1fa92a9f(functionName, queryURL, method, invalidatedTags) {
    return $0990d2137b3e0830$export$bcc8035e549759b4.injectEndpoints({
        endpoints: (builder)=>({
                [functionName]: builder.mutation({
                    query: (data)=>({
                            url: queryURL(data),
                            method: method,
                            headers: (0, $d3ab9ae1f203b599$export$1e4d4724de7b199e)(),
                            body: data
                        }),
                    invalidatesTags: invalidatedTags
                })
            }),
        overrideExisting: false
    });
}
function $0990d2137b3e0830$export$f740d16e59bfb312(functionName, queryURL, method, invalidatedTags) {
    return $0990d2137b3e0830$export$bcc8035e549759b4.injectEndpoints({
        endpoints: (builder)=>({
                [functionName]: builder.query({
                    query: (data)=>({
                            url: queryURL,
                            method: method,
                            headers: (0, $d3ab9ae1f203b599$export$1e4d4724de7b199e)(),
                            body: data
                        }),
                    invalidatesTags: invalidatedTags
                })
            }),
        overrideExisting: false
    });
}


const $76c21c25e2dea0bd$export$1100d26eea251521 = (0, $0990d2137b3e0830$export$65858239e7ec8811)("getInsights", "/discovery/insight/", "GET", [
    "Insight"
]);
const { useGetInsightsQuery: $76c21c25e2dea0bd$export$e262b0a11fe43b20 } = $76c21c25e2dea0bd$export$1100d26eea251521;
const $76c21c25e2dea0bd$export$4853c9e4d70d8d2c = (0, $0990d2137b3e0830$export$bcc8035e549759b4).injectEndpoints({
    endpoints: (builder)=>({
            getInsightsByPage: builder.query({
                query: (page = 1)=>`/discovery/insight/?page=${page}`,
                providesTags: [
                    "Insight"
                ]
            })
        }),
    overrideExisting: false
});
const { useGetInsightsByPageQuery: $76c21c25e2dea0bd$export$ffc35cfbedb806d5 } = $76c21c25e2dea0bd$export$4853c9e4d70d8d2c;
const $76c21c25e2dea0bd$export$4dcd5f8a1f57aedd = (0, $0990d2137b3e0830$export$65858239e7ec8811)("getInterests", "/discovery/interest/", "GET", [
    "Interest"
]);
const { useGetInterestsQuery: $76c21c25e2dea0bd$export$678ba770cae0ed70 } = $76c21c25e2dea0bd$export$4dcd5f8a1f57aedd;
const $76c21c25e2dea0bd$export$1fcee7192b5e62bb = (0, $0990d2137b3e0830$export$e68afafd1fa92a9f)("createInterest", (data)=>`/discovery/interest/${data.id}/`, "POST", [
    "Interest"
]);
const { useCreateInterestMutation: $76c21c25e2dea0bd$export$b35899cf935ea146 } = $76c21c25e2dea0bd$export$1fcee7192b5e62bb;
const $76c21c25e2dea0bd$export$c7383c5105c06476 = (0, $0990d2137b3e0830$export$e68afafd1fa92a9f)("updateInterest", (data)=>`/discovery/interest/${data.id}/`, "PATCH", [
    "Interest"
]);
const { useUpdateInterestMutation: $76c21c25e2dea0bd$export$fc12de619300c96e } = $76c21c25e2dea0bd$export$c7383c5105c06476;
const $76c21c25e2dea0bd$export$ccef1bab3f03240e = (0, $0990d2137b3e0830$export$e68afafd1fa92a9f)("deleteInterest", (data)=>`/discovery/interest/${data.id}/`, "DELETE", [
    "Interest"
]);
const { useDeleteInterestMutation: $76c21c25e2dea0bd$export$33fe92a210a94b9d } = $76c21c25e2dea0bd$export$ccef1bab3f03240e;
const $76c21c25e2dea0bd$export$6da2c732f6e8b8b9 = (0, $0990d2137b3e0830$export$65858239e7ec8811)("getCategories", "/discovery/category/", "GET", [
    "Interest"
]);
const { useGetCategoriesQuery: $76c21c25e2dea0bd$export$4e2c17edb48925a8 } = $76c21c25e2dea0bd$export$6da2c732f6e8b8b9;
const $76c21c25e2dea0bd$export$d8f53a86522f42f3 = (0, $0990d2137b3e0830$export$e68afafd1fa92a9f)("createCategory", (data)=>`/discovery/category/${data.id}/`, "POST", [
    "Category"
]);
const { useCreateCategoryMutation: $76c21c25e2dea0bd$export$b8da3e59c773b24a } = $76c21c25e2dea0bd$export$d8f53a86522f42f3;
const $76c21c25e2dea0bd$export$df34689d30b9f87f = (0, $0990d2137b3e0830$export$65858239e7ec8811)("getSources", "/discovery/source/", "GET", [
    "Source"
]);
const { useGetSourcesQuery: $76c21c25e2dea0bd$export$62e1452b7d176285 } = $76c21c25e2dea0bd$export$df34689d30b9f87f;
const $76c21c25e2dea0bd$export$814970bfc49ec620 = (0, $0990d2137b3e0830$export$e68afafd1fa92a9f)("createChat", ()=>`/discovery/chat/initialize_chat/`, "POST", [
    "Chat"
]);
const { useCreateChatMutation: $76c21c25e2dea0bd$export$867ee1f20bbe11d6 } = $76c21c25e2dea0bd$export$814970bfc49ec620;
const $76c21c25e2dea0bd$export$dddf0bd33396cd7f = (0, $0990d2137b3e0830$export$e68afafd1fa92a9f)("addMessageToChat", (data)=>`/discovery/chat/${data.thread_id}/add_message/`, "POST", [
    "Chat"
]);
const { useAddMessageToChatMutation: $76c21c25e2dea0bd$export$23a966dcaf2c4b57 } = $76c21c25e2dea0bd$export$dddf0bd33396cd7f;


/**
 * @tabler/icons-react v2.42.0 - MIT
 */ 
var $49e1b8e696a04f00$export$2e2bcd8739ae039 = (0, $a86819fe50d185cb$export$2e2bcd8739ae039)("reload", "IconReload", [
    [
        "path",
        {
            d: "M19.933 13.041a8 8 0 1 1 -9.925 -8.788c3.899 -1 7.935 1.007 9.425 4.747",
            key: "svg-0"
        }
    ],
    [
        "path",
        {
            d: "M20 4v5h-5",
            key: "svg-1"
        }
    ]
]);



const $bb321abaf7cc4e30$var$DiscoveryManager = ({ setIsEditing: setIsEditing, setShowChatLogo: setShowChatLogo, firstOpen: firstOpen, interestsData: interestsData, isInterestsLoading: isInterestsLoading })=>{
    const [activePage, setPage] = (0, $acw62.useState)(1);
    const { data: insightsData, isLoading: isInsightsLoading, refetch: refetchInsights } = (0, $76c21c25e2dea0bd$export$ffc35cfbedb806d5)(activePage);
    const [localDiscoveries, setLocalDiscoveries] = (0, $acw62.useState)([]);
    const [activeTopics, setActiveTopics] = (0, $acw62.useState)([]);
    const beginDiscoveries = (interestsData?.length === 0 || !interestsData) && !isInsightsLoading && !isInterestsLoading;
    const analyzingInsights = !insightsData?.results?.length && interestsData?.length && !isInsightsLoading;
    const loadingInsights = isInsightsLoading;
    const defaultValue = localDiscoveries?.length ? `${localDiscoveries[0]?.body}-${localDiscoveries[0]?.id}` : undefined;
    const auth = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.auth);
    const [isDemo, setIsDemo] = (0, $acw62.useState)(auth.demoAnimation && firstOpen);
    (0, $acw62.useEffect)(()=>{
        if (insightsData?.results.length) setLocalDiscoveries(insightsData.results);
    }, [
        insightsData,
        interestsData
    ]);
    (0, $acw62.useEffect)(()=>{
        if (activeTopics && activeTopics.length > 0) {
            const filteredData = activeTopics.flatMap((tag)=>insightsData?.filter((insight)=>insight.categories.some((category)=>category.name === tag)));
            const combinedResults = filteredData.filter((value, index, self)=>index === self.findIndex((item)=>item.id === value.id));
            setLocalDiscoveries(combinedResults);
        } else setLocalDiscoveries(insightsData?.results);
    }, [
        activeTopics,
        insightsData
    ]);
    const handleGetStartedClick = ()=>{
        setIsEditing(true);
        setShowChatLogo();
    };
    const removeDiscoveryTag = (tag)=>{
        setActiveTopics(activeTopics.filter((activeTag)=>activeTag !== tag));
        setIsDemo(false);
    };
    const totalPages = insightsData?.count % 50 > 0 && insightsData?.count > 50 ? insightsData?.count / 50 + 1 : insightsData?.count / 50;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
        children: [
            activeTopics.length !== 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
                mb: (0, $7db4b5652a829202$export$bca14c5b3b88a9c9).padding.lg,
                ml: "sm",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $33ecc2b042884c60$export$2e2bcd8739ae039), {
                    baseTags: activeTopics,
                    activeTopics: activeTopics,
                    setActiveTopics: setActiveTopics,
                    headerTags: true,
                    clickable: true,
                    tagColor: (0, $7db4b5652a829202$export$bca14c5b3b88a9c9).colors.purple[3],
                    removeTag: (tag, tagType)=>removeDiscoveryTag(tag, tagType)
                })
            }),
            beginDiscoveries && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $99c68b09e9ea9061$export$2e2bcd8739ae039), {
                svgLink: (0, (/*@__PURE__*/$parcel$interopDefault($d5e4bba30610058b$exports))),
                description: "Click here to begin your knowledge discovery campaign",
                onClick: handleGetStartedClick
            }),
            analyzingInsights > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $99c68b09e9ea9061$export$2e2bcd8739ae039), {
                svgLink: (0, (/*@__PURE__*/$parcel$interopDefault($5dc7470435fa9407$exports))),
                description: "Consili is analyzing your sources for insights. You\u2019ll be notified of any new developments",
                onClick: handleGetStartedClick
            }),
            loadingInsights && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $99c68b09e9ea9061$export$2e2bcd8739ae039), {
                svgLink: (0, (/*@__PURE__*/$parcel$interopDefault($5dc7470435fa9407$exports))),
                description: "Consili is loading insights. Please wait.",
                onClick: handleGetStartedClick
            }),
            defaultValue && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    flexDirection: "column",
                    alignItems: "center"
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $082a1c451bb0006a$export$a766cd26d0d69044), {
                    chevronPosition: "right",
                    variant: "contained",
                    defaultValue: defaultValue,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4), {
                            style: {
                                justifyContent: "space-between"
                            },
                            children: [
                                totalPages > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $60b13507c53218f5$export$68f5e1453c188a82), {
                                    total: totalPages,
                                    value: activePage,
                                    onChange: (page)=>{
                                        setPage(page);
                                        setIsDemo(false);
                                    },
                                    mb: "sm",
                                    withEdges: totalPages > 10,
                                    size: "sm"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                                    leftSection: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $49e1b8e696a04f00$export$2e2bcd8739ae039), {
                                        size: 14
                                    }),
                                    ml: "auto",
                                    mb: 5,
                                    size: "xs",
                                    variant: "default",
                                    onClick: ()=>refetchInsights(activePage),
                                    children: "Refresh"
                                })
                            ]
                        }),
                        localDiscoveries?.length > 0 && interestsData?.length > 0 && localDiscoveries.map((discovery)=>{
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $082a1c451bb0006a$export$a766cd26d0d69044).Item, {
                                value: `${discovery.body}-${discovery.id}`,
                                style: {
                                    borderColor: "transparent"
                                },
                                mt: 10,
                                children: isDemo ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c7f98cdafb13ea7d$export$2e2bcd8739ae039), {
                                    waitBeforeShow: discovery === localDiscoveries[0] ? 100 : Math.floor(Math.random() * 901) + 1000,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf9bcb6cbcae2c40$export$2e2bcd8739ae039), {
                                        discovery: discovery,
                                        relatedInterest: interestsData.find((interest)=>interest.id === discovery.interest)?.subject,
                                        activeTopics: activeTopics,
                                        setActiveTopics: setActiveTopics,
                                        removeTag: ()=>{},
                                        title: discovery.highlight ? discovery.highlight : interestsData.find((interest)=>interest.id === discovery.interest)?.subject
                                    }, discovery.id)
                                }, discovery.id) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf9bcb6cbcae2c40$export$2e2bcd8739ae039), {
                                    discovery: discovery,
                                    relatedInterest: interestsData.find((interest)=>interest.id === discovery.interest)?.subject,
                                    activeTopics: activeTopics,
                                    setActiveTopics: setActiveTopics,
                                    removeTag: ()=>{},
                                    title: discovery.highlight ? discovery.highlight : interestsData.find((interest)=>interest.id === discovery.interest)?.subject
                                }, discovery.id)
                            }, discovery.id);
                        }),
                        totalPages > 1 && !isDemo && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $60b13507c53218f5$export$68f5e1453c188a82), {
                            total: totalPages,
                            value: activePage,
                            onChange: (page)=>{
                                setPage(page);
                                setIsDemo(false);
                            },
                            mt: "sm",
                            withEdges: totalPages > 10,
                            size: "sm"
                        })
                    ]
                })
            })
        ]
    });
};
var $bb321abaf7cc4e30$export$2e2bcd8739ae039 = $bb321abaf7cc4e30$var$DiscoveryManager;



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
function $49039568a86601cc$export$2e2bcd8739ae039() {
    $49039568a86601cc$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $49039568a86601cc$export$2e2bcd8739ae039.apply(this, arguments);
}


function $e4e2acfc38c0fd0e$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $e62b4578a0a2b358$var$index = (0, $acw62.useLayoutEffect);
var $e62b4578a0a2b358$export$2e2bcd8739ae039 = $e62b4578a0a2b358$var$index;


var $38ac1a7b92ec1912$export$2e2bcd8739ae039 = function useLatest(value) {
    var ref = $acw62.useRef(value);
    (0, $e62b4578a0a2b358$export$2e2bcd8739ae039)(function() {
        ref.current = value;
    });
    return ref;
};



var $acw62 = parcelRequire("acw62");
var $7662f217721ef745$var$updateRef = function updateRef(ref, value) {
    if (typeof ref === "function") {
        ref(value);
        return;
    }
    ref.current = value;
};
var $7662f217721ef745$var$useComposedRef = function useComposedRef(libRef, userRef) {
    var prevUserRef = (0, $acw62.useRef)();
    return (0, $acw62.useCallback)(function(instance) {
        libRef.current = instance;
        if (prevUserRef.current) $7662f217721ef745$var$updateRef(prevUserRef.current, null);
        prevUserRef.current = userRef;
        if (!userRef) return;
        $7662f217721ef745$var$updateRef(userRef, instance);
    }, [
        userRef
    ]);
};
var $7662f217721ef745$export$2e2bcd8739ae039 = $7662f217721ef745$var$useComposedRef;


var $8d208011843bf7ea$var$HIDDEN_TEXTAREA_STYLE = {
    "min-height": "0",
    "max-height": "none",
    height: "0",
    visibility: "hidden",
    overflow: "hidden",
    position: "absolute",
    "z-index": "-1000",
    top: "0",
    right: "0"
};
var $8d208011843bf7ea$var$forceHiddenStyles = function forceHiddenStyles(node) {
    Object.keys($8d208011843bf7ea$var$HIDDEN_TEXTAREA_STYLE).forEach(function(key) {
        node.style.setProperty(key, $8d208011843bf7ea$var$HIDDEN_TEXTAREA_STYLE[key], "important");
    });
};
var $8d208011843bf7ea$var$forceHiddenStyles$1 = $8d208011843bf7ea$var$forceHiddenStyles;
// TODO: use labelled tuples once they are avaiable:
//   export type CalculatedNodeHeights = [height: number, rowHeight: number];
// https://github.com/microsoft/TypeScript/issues/28259
var $8d208011843bf7ea$var$hiddenTextarea = null;
var $8d208011843bf7ea$var$getHeight = function getHeight(node, sizingData) {
    var height = node.scrollHeight;
    if (sizingData.sizingStyle.boxSizing === "border-box") // border-box: add border, since height = content + padding + border
    return height + sizingData.borderSize;
    // remove padding, since height = content
    return height - sizingData.paddingSize;
};
function $8d208011843bf7ea$var$calculateNodeHeight(sizingData, value, minRows, maxRows) {
    if (minRows === void 0) minRows = 1;
    if (maxRows === void 0) maxRows = Infinity;
    if (!$8d208011843bf7ea$var$hiddenTextarea) {
        $8d208011843bf7ea$var$hiddenTextarea = document.createElement("textarea");
        $8d208011843bf7ea$var$hiddenTextarea.setAttribute("tabindex", "-1");
        $8d208011843bf7ea$var$hiddenTextarea.setAttribute("aria-hidden", "true");
        $8d208011843bf7ea$var$forceHiddenStyles$1($8d208011843bf7ea$var$hiddenTextarea);
    }
    if ($8d208011843bf7ea$var$hiddenTextarea.parentNode === null) document.body.appendChild($8d208011843bf7ea$var$hiddenTextarea);
    var paddingSize = sizingData.paddingSize, borderSize = sizingData.borderSize, sizingStyle = sizingData.sizingStyle;
    var boxSizing = sizingStyle.boxSizing;
    Object.keys(sizingStyle).forEach(function(_key) {
        var key = _key;
        $8d208011843bf7ea$var$hiddenTextarea.style[key] = sizingStyle[key];
    });
    $8d208011843bf7ea$var$forceHiddenStyles$1($8d208011843bf7ea$var$hiddenTextarea);
    $8d208011843bf7ea$var$hiddenTextarea.value = value;
    var height = $8d208011843bf7ea$var$getHeight($8d208011843bf7ea$var$hiddenTextarea, sizingData);
    // Double set and calc due to Firefox bug: https://bugzilla.mozilla.org/show_bug.cgi?id=1795904
    $8d208011843bf7ea$var$hiddenTextarea.value = value;
    height = $8d208011843bf7ea$var$getHeight($8d208011843bf7ea$var$hiddenTextarea, sizingData);
    // measure height of a textarea with a single row
    $8d208011843bf7ea$var$hiddenTextarea.value = "x";
    var rowHeight = $8d208011843bf7ea$var$hiddenTextarea.scrollHeight - paddingSize;
    var minHeight = rowHeight * minRows;
    if (boxSizing === "border-box") minHeight = minHeight + paddingSize + borderSize;
    height = Math.max(minHeight, height);
    var maxHeight = rowHeight * maxRows;
    if (boxSizing === "border-box") maxHeight = maxHeight + paddingSize + borderSize;
    height = Math.min(maxHeight, height);
    return [
        height,
        rowHeight
    ];
}
var $8d208011843bf7ea$var$noop = function noop() {};
var $8d208011843bf7ea$var$pick = function pick(props, obj) {
    return props.reduce(function(acc, prop) {
        acc[prop] = obj[prop];
        return acc;
    }, {});
};
var $8d208011843bf7ea$var$SIZING_STYLE = [
    "borderBottomWidth",
    "borderLeftWidth",
    "borderRightWidth",
    "borderTopWidth",
    "boxSizing",
    "fontFamily",
    "fontSize",
    "fontStyle",
    "fontWeight",
    "letterSpacing",
    "lineHeight",
    "paddingBottom",
    "paddingLeft",
    "paddingRight",
    "paddingTop",
    // non-standard
    "tabSize",
    "textIndent",
    // non-standard
    "textRendering",
    "textTransform",
    "width",
    "wordBreak"
];
var $8d208011843bf7ea$var$isIE = !!document.documentElement.currentStyle;
var $8d208011843bf7ea$var$getSizingData = function getSizingData(node) {
    var style = window.getComputedStyle(node);
    if (style === null) return null;
    var sizingStyle = $8d208011843bf7ea$var$pick($8d208011843bf7ea$var$SIZING_STYLE, style);
    var boxSizing = sizingStyle.boxSizing;
    // probably node is detached from DOM, can't read computed dimensions
    if (boxSizing === "") return null;
    // IE (Edge has already correct behaviour) returns content width as computed width
    // so we need to add manually padding and border widths
    if ($8d208011843bf7ea$var$isIE && boxSizing === "border-box") sizingStyle.width = parseFloat(sizingStyle.width) + parseFloat(sizingStyle.borderRightWidth) + parseFloat(sizingStyle.borderLeftWidth) + parseFloat(sizingStyle.paddingRight) + parseFloat(sizingStyle.paddingLeft) + "px";
    var paddingSize = parseFloat(sizingStyle.paddingBottom) + parseFloat(sizingStyle.paddingTop);
    var borderSize = parseFloat(sizingStyle.borderBottomWidth) + parseFloat(sizingStyle.borderTopWidth);
    return {
        sizingStyle: sizingStyle,
        paddingSize: paddingSize,
        borderSize: borderSize
    };
};
var $8d208011843bf7ea$var$getSizingData$1 = $8d208011843bf7ea$var$getSizingData;
function $8d208011843bf7ea$var$useListener(target, type, listener) {
    var latestListener = (0, $38ac1a7b92ec1912$export$2e2bcd8739ae039)(listener);
    $acw62.useLayoutEffect(function() {
        var handler = function handler(ev) {
            return latestListener.current(ev);
        };
        // might happen if document.fonts is not defined, for instance
        if (!target) return;
        target.addEventListener(type, handler);
        return function() {
            return target.removeEventListener(type, handler);
        };
    }, []);
}
var $8d208011843bf7ea$var$useWindowResizeListener = function useWindowResizeListener(listener) {
    $8d208011843bf7ea$var$useListener(window, "resize", listener);
};
var $8d208011843bf7ea$var$useFontsLoadedListener = function useFontsLoadedListener(listener) {
    $8d208011843bf7ea$var$useListener(document.fonts, "loadingdone", listener);
};
var $8d208011843bf7ea$var$_excluded = [
    "cacheMeasurements",
    "maxRows",
    "minRows",
    "onChange",
    "onHeightChange"
];
var $8d208011843bf7ea$var$TextareaAutosize = function TextareaAutosize(_ref, userRef) {
    var cacheMeasurements = _ref.cacheMeasurements, maxRows = _ref.maxRows, minRows = _ref.minRows, _ref$onChange = _ref.onChange, onChange = _ref$onChange === void 0 ? $8d208011843bf7ea$var$noop : _ref$onChange, _ref$onHeightChange = _ref.onHeightChange, onHeightChange = _ref$onHeightChange === void 0 ? $8d208011843bf7ea$var$noop : _ref$onHeightChange, props = (0, $e4e2acfc38c0fd0e$export$2e2bcd8739ae039)(_ref, $8d208011843bf7ea$var$_excluded);
    var isControlled = props.value !== undefined;
    var libRef = $acw62.useRef(null);
    var ref = (0, $7662f217721ef745$export$2e2bcd8739ae039)(libRef, userRef);
    var heightRef = $acw62.useRef(0);
    var measurementsCacheRef = $acw62.useRef();
    var resizeTextarea = function resizeTextarea() {
        var node = libRef.current;
        var nodeSizingData = cacheMeasurements && measurementsCacheRef.current ? measurementsCacheRef.current : $8d208011843bf7ea$var$getSizingData$1(node);
        if (!nodeSizingData) return;
        measurementsCacheRef.current = nodeSizingData;
        var _calculateNodeHeight = $8d208011843bf7ea$var$calculateNodeHeight(nodeSizingData, node.value || node.placeholder || "x", minRows, maxRows), height = _calculateNodeHeight[0], rowHeight = _calculateNodeHeight[1];
        if (heightRef.current !== height) {
            heightRef.current = height;
            node.style.setProperty("height", height + "px", "important");
            onHeightChange(height, {
                rowHeight: rowHeight
            });
        }
    };
    var handleChange = function handleChange(event) {
        if (!isControlled) resizeTextarea();
        onChange(event);
    };
    $acw62.useLayoutEffect(resizeTextarea);
    $8d208011843bf7ea$var$useWindowResizeListener(resizeTextarea);
    $8d208011843bf7ea$var$useFontsLoadedListener(resizeTextarea);
    return /*#__PURE__*/ $acw62.createElement("textarea", (0, $49039568a86601cc$export$2e2bcd8739ae039)({}, props, {
        onChange: handleChange,
        ref: ref
    }));
};
var $8d208011843bf7ea$export$2e2bcd8739ae039 = /* #__PURE__ */ $acw62.forwardRef($8d208011843bf7ea$var$TextareaAutosize);



var $acw62 = parcelRequire("acw62");


"use client";
var $a8c37d27d093a1ae$var$__defProp = Object.defineProperty;
var $a8c37d27d093a1ae$var$__defProps = Object.defineProperties;
var $a8c37d27d093a1ae$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $a8c37d27d093a1ae$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $a8c37d27d093a1ae$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $a8c37d27d093a1ae$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $a8c37d27d093a1ae$var$__defNormalProp = (obj, key, value)=>key in obj ? $a8c37d27d093a1ae$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $a8c37d27d093a1ae$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($a8c37d27d093a1ae$var$__hasOwnProp.call(b, prop)) $a8c37d27d093a1ae$var$__defNormalProp(a, prop, b[prop]);
    if ($a8c37d27d093a1ae$var$__getOwnPropSymbols) {
        for (var prop of $a8c37d27d093a1ae$var$__getOwnPropSymbols(b))if ($a8c37d27d093a1ae$var$__propIsEnum.call(b, prop)) $a8c37d27d093a1ae$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $a8c37d27d093a1ae$var$__spreadProps = (a, b)=>$a8c37d27d093a1ae$var$__defProps(a, $a8c37d27d093a1ae$var$__getOwnPropDescs(b));
var $a8c37d27d093a1ae$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($a8c37d27d093a1ae$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $a8c37d27d093a1ae$var$__getOwnPropSymbols) {
        for (var prop of $a8c37d27d093a1ae$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $a8c37d27d093a1ae$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
function $a8c37d27d093a1ae$export$434ed5c8d5bb7eb5(component, defaultProps, _props) {
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)(component, defaultProps, _props);
    const _a = props, { label: label, description: description, error: error, required: required, classNames: classNames, styles: styles, className: className, unstyled: unstyled, __staticSelector: __staticSelector, __stylesApiProps: __stylesApiProps, errorProps: errorProps, labelProps: labelProps, descriptionProps: descriptionProps, wrapperProps: _wrapperProps, id: id, size: size, style: style, inputContainer: inputContainer, inputWrapperOrder: inputWrapperOrder, withAsterisk: withAsterisk, variant: variant, vars: vars } = _a, others = $a8c37d27d093a1ae$var$__objRest(_a, [
        "label",
        "description",
        "error",
        "required",
        "classNames",
        "styles",
        "className",
        "unstyled",
        "__staticSelector",
        "__stylesApiProps",
        "errorProps",
        "labelProps",
        "descriptionProps",
        "wrapperProps",
        "id",
        "size",
        "style",
        "inputContainer",
        "inputWrapperOrder",
        "withAsterisk",
        "variant",
        "vars"
    ]);
    const { styleProps: styleProps, rest: rest } = (0, $2e4262c949ef0e61$export$fbc67becbdd26fbf)(others);
    const wrapperProps = $a8c37d27d093a1ae$var$__spreadValues({
        label: label,
        description: description,
        error: error,
        required: required,
        classNames: classNames,
        className: className,
        __staticSelector: __staticSelector,
        __stylesApiProps: __stylesApiProps || props,
        errorProps: errorProps,
        labelProps: labelProps,
        descriptionProps: descriptionProps,
        unstyled: unstyled,
        styles: styles,
        size: size,
        style: style,
        inputContainer: inputContainer,
        inputWrapperOrder: inputWrapperOrder,
        withAsterisk: withAsterisk,
        variant: variant,
        id: id
    }, _wrapperProps);
    return $a8c37d27d093a1ae$var$__spreadProps($a8c37d27d093a1ae$var$__spreadValues({}, rest), {
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        wrapperProps: $a8c37d27d093a1ae$var$__spreadValues($a8c37d27d093a1ae$var$__spreadValues({}, wrapperProps), styleProps),
        inputProps: {
            required: required,
            classNames: classNames,
            styles: styles,
            unstyled: unstyled,
            size: size,
            __staticSelector: __staticSelector,
            __stylesApiProps: __stylesApiProps || props,
            error: error,
            variant: variant,
            id: id
        }
    });
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
"use client";
function $9c635db052037c0d$export$c56823b04757fc19(initialValue = null) {
    const Context = (0, $acw62.createContext)(initialValue);
    const useOptionalContext = ()=>(0, $acw62.useContext)(Context);
    const Provider = ({ children: children, value: value })=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Context.Provider, {
            value: value
        }, children);
    return [
        Provider,
        useOptionalContext
    ];
}


"use client";
const [$71cd98bbd243f876$export$bac4ebff2ddc1fe4, $71cd98bbd243f876$export$40fbe3aaaeb9dc6c] = (0, $9c635db052037c0d$export$c56823b04757fc19)({
    offsetBottom: false,
    offsetTop: false,
    describedBy: void 0,
    getStyles: null,
    inputId: void 0,
    labelId: void 0
});



var $acw62 = parcelRequire("acw62");

"use client";
var $68788066a3c963e6$var$classes = {
    "wrapper": "m-6c018570",
    "input": "m-8fb7ebe7",
    "section": "m-82577fc2",
    "placeholder": "m-88bacfd0",
    "root": "m-46b77525",
    "label": "m-8fdc1311",
    "required": "m-78a94662",
    "error": "m-8f816625",
    "description": "m-fe47ce59"
};
var $68788066a3c963e6$export$2e2bcd8739ae039 = $68788066a3c963e6$var$classes;








"use client";
var $7142f79830a0b6ab$var$__defProp = Object.defineProperty;
var $7142f79830a0b6ab$var$__defProps = Object.defineProperties;
var $7142f79830a0b6ab$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $7142f79830a0b6ab$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $7142f79830a0b6ab$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $7142f79830a0b6ab$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $7142f79830a0b6ab$var$__defNormalProp = (obj, key, value)=>key in obj ? $7142f79830a0b6ab$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $7142f79830a0b6ab$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($7142f79830a0b6ab$var$__hasOwnProp.call(b, prop)) $7142f79830a0b6ab$var$__defNormalProp(a, prop, b[prop]);
    if ($7142f79830a0b6ab$var$__getOwnPropSymbols) {
        for (var prop of $7142f79830a0b6ab$var$__getOwnPropSymbols(b))if ($7142f79830a0b6ab$var$__propIsEnum.call(b, prop)) $7142f79830a0b6ab$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $7142f79830a0b6ab$var$__spreadProps = (a, b)=>$7142f79830a0b6ab$var$__defProps(a, $7142f79830a0b6ab$var$__getOwnPropDescs(b));
var $7142f79830a0b6ab$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($7142f79830a0b6ab$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $7142f79830a0b6ab$var$__getOwnPropSymbols) {
        for (var prop of $7142f79830a0b6ab$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $7142f79830a0b6ab$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $7142f79830a0b6ab$var$defaultProps = {
    labelElement: "label"
};
const $7142f79830a0b6ab$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((_, { size: size })=>({
        label: {
            "--input-label-size": (0, $fcab4af601ce7e99$export$7d055c252aebca58)(size),
            "--input-asterisk-color": void 0
        }
    }));
const $7142f79830a0b6ab$export$76d3231fec538b73 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("InputLabel", $7142f79830a0b6ab$var$defaultProps, _props);
    const _a = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("InputLabel", $7142f79830a0b6ab$var$defaultProps, props), { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, labelElement: labelElement, size: size, required: required, htmlFor: htmlFor, onMouseDown: onMouseDown, children: children, __staticSelector: __staticSelector, variant: variant } = _a, others = $7142f79830a0b6ab$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "labelElement",
        "size",
        "required",
        "htmlFor",
        "onMouseDown",
        "children",
        "__staticSelector",
        "variant"
    ]);
    const _getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: [
            "InputWrapper",
            __staticSelector
        ],
        props: props,
        classes: $68788066a3c963e6$export$2e2bcd8739ae039,
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        rootSelector: "label",
        vars: vars,
        varsResolver: $7142f79830a0b6ab$var$varsResolver
    });
    const ctx = (0, $71cd98bbd243f876$export$40fbe3aaaeb9dc6c)();
    const getStyles = (ctx == null ? void 0 : ctx.getStyles) || _getStyles;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $7142f79830a0b6ab$var$__spreadValues($7142f79830a0b6ab$var$__spreadProps($7142f79830a0b6ab$var$__spreadValues({}, getStyles("label")), {
        component: labelElement,
        variant: variant,
        size: size,
        ref: ref,
        htmlFor: labelElement === "label" ? htmlFor : void 0,
        mod: {
            required: required
        },
        onMouseDown: (event)=>{
            onMouseDown == null || onMouseDown(event);
            if (!event.defaultPrevented && event.detail > 1) event.preventDefault();
        }
    }), others), children, required && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", $7142f79830a0b6ab$var$__spreadProps($7142f79830a0b6ab$var$__spreadValues({}, getStyles("required")), {
        "aria-hidden": true
    }), " *"));
});
$7142f79830a0b6ab$export$76d3231fec538b73.classes = (0, $68788066a3c963e6$export$2e2bcd8739ae039);
$7142f79830a0b6ab$export$76d3231fec538b73.displayName = "@mantine/core/InputLabel";



var $acw62 = parcelRequire("acw62");









"use client";
var $6fc8a9095ea9adf5$var$__defProp = Object.defineProperty;
var $6fc8a9095ea9adf5$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $6fc8a9095ea9adf5$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $6fc8a9095ea9adf5$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $6fc8a9095ea9adf5$var$__defNormalProp = (obj, key, value)=>key in obj ? $6fc8a9095ea9adf5$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $6fc8a9095ea9adf5$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($6fc8a9095ea9adf5$var$__hasOwnProp.call(b, prop)) $6fc8a9095ea9adf5$var$__defNormalProp(a, prop, b[prop]);
    if ($6fc8a9095ea9adf5$var$__getOwnPropSymbols) {
        for (var prop of $6fc8a9095ea9adf5$var$__getOwnPropSymbols(b))if ($6fc8a9095ea9adf5$var$__propIsEnum.call(b, prop)) $6fc8a9095ea9adf5$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $6fc8a9095ea9adf5$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($6fc8a9095ea9adf5$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $6fc8a9095ea9adf5$var$__getOwnPropSymbols) {
        for (var prop of $6fc8a9095ea9adf5$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $6fc8a9095ea9adf5$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $6fc8a9095ea9adf5$var$defaultProps = {};
const $6fc8a9095ea9adf5$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((_, { size: size })=>({
        error: {
            "--input-error-size": size === void 0 ? void 0 : `calc(${(0, $fcab4af601ce7e99$export$7d055c252aebca58)(size)} - ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(2)})`
        }
    }));
const $6fc8a9095ea9adf5$export$404cd3170eee2e81 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("InputError", $6fc8a9095ea9adf5$var$defaultProps, _props);
    const _a = props, { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, size: size, __staticSelector: __staticSelector, __inheritStyles: __inheritStyles = true, variant: variant } = _a, others = $6fc8a9095ea9adf5$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "size",
        "__staticSelector",
        "__inheritStyles",
        "variant"
    ]);
    const _getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: [
            "InputWrapper",
            __staticSelector
        ],
        props: props,
        classes: $68788066a3c963e6$export$2e2bcd8739ae039,
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        rootSelector: "error",
        vars: vars,
        varsResolver: $6fc8a9095ea9adf5$var$varsResolver
    });
    const ctx = (0, $71cd98bbd243f876$export$40fbe3aaaeb9dc6c)();
    const getStyles = __inheritStyles && (ctx == null ? void 0 : ctx.getStyles) || _getStyles;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $6fc8a9095ea9adf5$var$__spreadValues($6fc8a9095ea9adf5$var$__spreadValues({
        component: "p",
        ref: ref,
        variant: variant,
        size: size
    }, getStyles("error")), others));
});
$6fc8a9095ea9adf5$export$404cd3170eee2e81.classes = (0, $68788066a3c963e6$export$2e2bcd8739ae039);
$6fc8a9095ea9adf5$export$404cd3170eee2e81.displayName = "@mantine/core/InputError";



var $acw62 = parcelRequire("acw62");









"use client";
var $2250c0d6f2e006ef$var$__defProp = Object.defineProperty;
var $2250c0d6f2e006ef$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $2250c0d6f2e006ef$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $2250c0d6f2e006ef$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $2250c0d6f2e006ef$var$__defNormalProp = (obj, key, value)=>key in obj ? $2250c0d6f2e006ef$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $2250c0d6f2e006ef$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($2250c0d6f2e006ef$var$__hasOwnProp.call(b, prop)) $2250c0d6f2e006ef$var$__defNormalProp(a, prop, b[prop]);
    if ($2250c0d6f2e006ef$var$__getOwnPropSymbols) {
        for (var prop of $2250c0d6f2e006ef$var$__getOwnPropSymbols(b))if ($2250c0d6f2e006ef$var$__propIsEnum.call(b, prop)) $2250c0d6f2e006ef$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $2250c0d6f2e006ef$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($2250c0d6f2e006ef$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $2250c0d6f2e006ef$var$__getOwnPropSymbols) {
        for (var prop of $2250c0d6f2e006ef$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $2250c0d6f2e006ef$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $2250c0d6f2e006ef$var$defaultProps = {};
const $2250c0d6f2e006ef$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((_, { size: size })=>({
        description: {
            "--input-description-size": size === void 0 ? void 0 : `calc(${(0, $fcab4af601ce7e99$export$7d055c252aebca58)(size)} - ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(2)})`
        }
    }));
const $2250c0d6f2e006ef$export$416ae9045a33afd = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("InputDescription", $2250c0d6f2e006ef$var$defaultProps, _props);
    const _a = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("InputDescription", $2250c0d6f2e006ef$var$defaultProps, props), { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, size: size, __staticSelector: __staticSelector, __inheritStyles: __inheritStyles = true, variant: variant } = _a, others = $2250c0d6f2e006ef$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "size",
        "__staticSelector",
        "__inheritStyles",
        "variant"
    ]);
    const ctx = (0, $71cd98bbd243f876$export$40fbe3aaaeb9dc6c)();
    const _getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: [
            "InputWrapper",
            __staticSelector
        ],
        props: props,
        classes: $68788066a3c963e6$export$2e2bcd8739ae039,
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        rootSelector: "description",
        vars: vars,
        varsResolver: $2250c0d6f2e006ef$var$varsResolver
    });
    const getStyles = __inheritStyles && (ctx == null ? void 0 : ctx.getStyles) || _getStyles;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $2250c0d6f2e006ef$var$__spreadValues($2250c0d6f2e006ef$var$__spreadValues({
        component: "p",
        ref: ref,
        variant: variant,
        size: size
    }, getStyles("description")), others));
});
$2250c0d6f2e006ef$export$416ae9045a33afd.classes = (0, $68788066a3c963e6$export$2e2bcd8739ae039);
$2250c0d6f2e006ef$export$416ae9045a33afd.displayName = "@mantine/core/InputDescription";



var $acw62 = parcelRequire("acw62");





"use client";
var $15c2b8d80d4839cc$var$__defProp = Object.defineProperty;
var $15c2b8d80d4839cc$var$__defProps = Object.defineProperties;
var $15c2b8d80d4839cc$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $15c2b8d80d4839cc$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $15c2b8d80d4839cc$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $15c2b8d80d4839cc$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $15c2b8d80d4839cc$var$__defNormalProp = (obj, key, value)=>key in obj ? $15c2b8d80d4839cc$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $15c2b8d80d4839cc$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($15c2b8d80d4839cc$var$__hasOwnProp.call(b, prop)) $15c2b8d80d4839cc$var$__defNormalProp(a, prop, b[prop]);
    if ($15c2b8d80d4839cc$var$__getOwnPropSymbols) {
        for (var prop of $15c2b8d80d4839cc$var$__getOwnPropSymbols(b))if ($15c2b8d80d4839cc$var$__propIsEnum.call(b, prop)) $15c2b8d80d4839cc$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $15c2b8d80d4839cc$var$__spreadProps = (a, b)=>$15c2b8d80d4839cc$var$__defProps(a, $15c2b8d80d4839cc$var$__getOwnPropDescs(b));
var $15c2b8d80d4839cc$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($15c2b8d80d4839cc$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $15c2b8d80d4839cc$var$__getOwnPropSymbols) {
        for (var prop of $15c2b8d80d4839cc$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $15c2b8d80d4839cc$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $15c2b8d80d4839cc$var$defaultProps = {};
const $15c2b8d80d4839cc$export$1dcf0d4dcfd98808 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("InputPlaceholder", $15c2b8d80d4839cc$var$defaultProps, _props);
    const _a = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("InputPlaceholder", $15c2b8d80d4839cc$var$defaultProps, props), { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, __staticSelector: __staticSelector, variant: variant, error: error } = _a, others = $15c2b8d80d4839cc$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "__staticSelector",
        "variant",
        "error"
    ]);
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: [
            "InputPlaceholder",
            __staticSelector
        ],
        props: props,
        classes: $68788066a3c963e6$export$2e2bcd8739ae039,
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        rootSelector: "placeholder"
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $15c2b8d80d4839cc$var$__spreadValues($15c2b8d80d4839cc$var$__spreadProps($15c2b8d80d4839cc$var$__spreadValues({}, getStyles("placeholder")), {
        mod: {
            error: !!error
        },
        component: "span",
        variant: variant,
        ref: ref
    }), others));
});
$15c2b8d80d4839cc$export$1dcf0d4dcfd98808.classes = (0, $68788066a3c963e6$export$2e2bcd8739ae039);
$15c2b8d80d4839cc$export$1dcf0d4dcfd98808.displayName = "@mantine/core/InputPlaceholder";



var $acw62 = parcelRequire("acw62");





"use client";
function $7e1176cb96c17956$export$25327628fc2f4542(inputWrapperOrder, { hasDescription: hasDescription, hasError: hasError }) {
    const inputIndex = inputWrapperOrder.findIndex((part)=>part === "input");
    const aboveInput = inputWrapperOrder[inputIndex - 1];
    const belowInput = inputWrapperOrder[inputIndex + 1];
    const offsetTop = hasDescription && aboveInput === "description" || hasError && aboveInput === "error";
    const offsetBottom = hasDescription && belowInput === "description" || hasError && belowInput === "error";
    return {
        offsetBottom: offsetBottom,
        offsetTop: offsetTop
    };
}










"use client";
var $62cbf17611d1016d$var$__defProp = Object.defineProperty;
var $62cbf17611d1016d$var$__defProps = Object.defineProperties;
var $62cbf17611d1016d$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $62cbf17611d1016d$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $62cbf17611d1016d$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $62cbf17611d1016d$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $62cbf17611d1016d$var$__defNormalProp = (obj, key, value)=>key in obj ? $62cbf17611d1016d$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $62cbf17611d1016d$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($62cbf17611d1016d$var$__hasOwnProp.call(b, prop)) $62cbf17611d1016d$var$__defNormalProp(a, prop, b[prop]);
    if ($62cbf17611d1016d$var$__getOwnPropSymbols) {
        for (var prop of $62cbf17611d1016d$var$__getOwnPropSymbols(b))if ($62cbf17611d1016d$var$__propIsEnum.call(b, prop)) $62cbf17611d1016d$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $62cbf17611d1016d$var$__spreadProps = (a, b)=>$62cbf17611d1016d$var$__defProps(a, $62cbf17611d1016d$var$__getOwnPropDescs(b));
var $62cbf17611d1016d$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($62cbf17611d1016d$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $62cbf17611d1016d$var$__getOwnPropSymbols) {
        for (var prop of $62cbf17611d1016d$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $62cbf17611d1016d$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $62cbf17611d1016d$var$defaultProps = {
    labelElement: "label",
    inputContainer: (children)=>children,
    inputWrapperOrder: [
        "label",
        "description",
        "input",
        "error"
    ]
};
const $62cbf17611d1016d$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((_, { size: size })=>({
        label: {
            "--input-label-size": (0, $fcab4af601ce7e99$export$7d055c252aebca58)(size),
            "--input-asterisk-color": void 0
        },
        error: {
            "--input-error-size": size === void 0 ? void 0 : `calc(${(0, $fcab4af601ce7e99$export$7d055c252aebca58)(size)} - ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(2)})`
        },
        description: {
            "--input-description-size": size === void 0 ? void 0 : `calc(${(0, $fcab4af601ce7e99$export$7d055c252aebca58)(size)} - ${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(2)})`
        }
    }));
const $62cbf17611d1016d$export$fb9f58ebe9de6283 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("InputWrapper", $62cbf17611d1016d$var$defaultProps, _props);
    const _a = props, { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, size: size, variant: variant, __staticSelector: __staticSelector, inputContainer: inputContainer, inputWrapperOrder: inputWrapperOrder, label: label, error: error, description: description, labelProps: labelProps, descriptionProps: descriptionProps, errorProps: errorProps, labelElement: labelElement, children: children, withAsterisk: withAsterisk, id: id, required: required, __stylesApiProps: __stylesApiProps } = _a, others = $62cbf17611d1016d$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "size",
        "variant",
        "__staticSelector",
        "inputContainer",
        "inputWrapperOrder",
        "label",
        "error",
        "description",
        "labelProps",
        "descriptionProps",
        "errorProps",
        "labelElement",
        "children",
        "withAsterisk",
        "id",
        "required",
        "__stylesApiProps"
    ]);
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: [
            "InputWrapper",
            __staticSelector
        ],
        props: __stylesApiProps || props,
        classes: $68788066a3c963e6$export$2e2bcd8739ae039,
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        vars: vars,
        varsResolver: $62cbf17611d1016d$var$varsResolver
    });
    const sharedProps = {
        size: size,
        variant: variant,
        __staticSelector: __staticSelector
    };
    const idBase = (0, $cee42e5537afff93$export$f680877a34711e37)(id);
    const isRequired = typeof withAsterisk === "boolean" ? withAsterisk : required;
    const errorId = (errorProps == null ? void 0 : errorProps.id) || `${idBase}-error`;
    const descriptionId = (descriptionProps == null ? void 0 : descriptionProps.id) || `${idBase}-description`;
    const inputId = idBase;
    const hasError = !!error && typeof error !== "boolean";
    const hasDescription = !!description;
    const _describedBy = `${hasError ? errorId : ""} ${hasDescription ? descriptionId : ""}`;
    const describedBy = _describedBy.trim().length > 0 ? _describedBy.trim() : void 0;
    const labelId = (labelProps == null ? void 0 : labelProps.id) || `${idBase}-label`;
    const _label = label && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7142f79830a0b6ab$export$76d3231fec538b73), $62cbf17611d1016d$var$__spreadValues($62cbf17611d1016d$var$__spreadValues({
        key: "label",
        labelElement: labelElement,
        id: labelId,
        htmlFor: inputId,
        required: isRequired
    }, sharedProps), labelProps), label);
    const _description = hasDescription && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2250c0d6f2e006ef$export$416ae9045a33afd), $62cbf17611d1016d$var$__spreadProps($62cbf17611d1016d$var$__spreadValues($62cbf17611d1016d$var$__spreadValues({
        key: "description"
    }, descriptionProps), sharedProps), {
        size: (descriptionProps == null ? void 0 : descriptionProps.size) || sharedProps.size,
        id: (descriptionProps == null ? void 0 : descriptionProps.id) || descriptionId
    }), description);
    const _input = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
        key: "input"
    }, inputContainer(children));
    const _error = hasError && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6fc8a9095ea9adf5$export$404cd3170eee2e81), $62cbf17611d1016d$var$__spreadProps($62cbf17611d1016d$var$__spreadValues($62cbf17611d1016d$var$__spreadValues({}, errorProps), sharedProps), {
        size: (errorProps == null ? void 0 : errorProps.size) || sharedProps.size,
        key: "error",
        id: (errorProps == null ? void 0 : errorProps.id) || errorId
    }), error);
    const content = inputWrapperOrder.map((part)=>{
        switch(part){
            case "label":
                return _label;
            case "input":
                return _input;
            case "description":
                return _description;
            case "error":
                return _error;
            default:
                return null;
        }
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $71cd98bbd243f876$export$bac4ebff2ddc1fe4), {
        value: $62cbf17611d1016d$var$__spreadValues({
            getStyles: getStyles,
            describedBy: describedBy,
            inputId: inputId,
            labelId: labelId
        }, (0, $7e1176cb96c17956$export$25327628fc2f4542)(inputWrapperOrder, {
            hasDescription: hasDescription,
            hasError: hasError
        }))
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $62cbf17611d1016d$var$__spreadValues($62cbf17611d1016d$var$__spreadValues({
        ref: ref,
        variant: variant,
        size: size
    }, getStyles("root")), others), content));
});
$62cbf17611d1016d$export$fb9f58ebe9de6283.classes = (0, $68788066a3c963e6$export$2e2bcd8739ae039);
$62cbf17611d1016d$export$fb9f58ebe9de6283.displayName = "@mantine/core/InputWrapper";











"use client";
var $e2e9ff0d29bd408f$var$__defProp = Object.defineProperty;
var $e2e9ff0d29bd408f$var$__defProps = Object.defineProperties;
var $e2e9ff0d29bd408f$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $e2e9ff0d29bd408f$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $e2e9ff0d29bd408f$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $e2e9ff0d29bd408f$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $e2e9ff0d29bd408f$var$__defNormalProp = (obj, key, value)=>key in obj ? $e2e9ff0d29bd408f$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $e2e9ff0d29bd408f$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($e2e9ff0d29bd408f$var$__hasOwnProp.call(b, prop)) $e2e9ff0d29bd408f$var$__defNormalProp(a, prop, b[prop]);
    if ($e2e9ff0d29bd408f$var$__getOwnPropSymbols) {
        for (var prop of $e2e9ff0d29bd408f$var$__getOwnPropSymbols(b))if ($e2e9ff0d29bd408f$var$__propIsEnum.call(b, prop)) $e2e9ff0d29bd408f$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $e2e9ff0d29bd408f$var$__spreadProps = (a, b)=>$e2e9ff0d29bd408f$var$__defProps(a, $e2e9ff0d29bd408f$var$__getOwnPropDescs(b));
var $e2e9ff0d29bd408f$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($e2e9ff0d29bd408f$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $e2e9ff0d29bd408f$var$__getOwnPropSymbols) {
        for (var prop of $e2e9ff0d29bd408f$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $e2e9ff0d29bd408f$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $e2e9ff0d29bd408f$var$defaultProps = {
    variant: "default",
    leftSectionPointerEvents: "none",
    rightSectionPointerEvents: "none",
    withAria: true,
    withErrorStyles: true
};
const $e2e9ff0d29bd408f$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((_, props, ctx)=>({
        wrapper: {
            "--input-margin-top": ctx.offsetTop ? "calc(var(--mantine-spacing-xs) / 2)" : void 0,
            "--input-margin-bottom": ctx.offsetBottom ? "calc(var(--mantine-spacing-xs) / 2)" : void 0,
            "--input-height": (0, $fcab4af601ce7e99$export$31b21d0167753bb4)(props.size, "input-height"),
            "--input-fz": (0, $fcab4af601ce7e99$export$7d055c252aebca58)(props.size),
            "--input-radius": props.radius === void 0 ? void 0 : (0, $fcab4af601ce7e99$export$35724d9c2979edc5)(props.radius),
            "--input-left-section-width": props.leftSectionWidth !== void 0 ? (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(props.leftSectionWidth) : void 0,
            "--input-right-section-width": props.rightSectionWidth !== void 0 ? (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(props.rightSectionWidth) : void 0,
            "--input-padding-y": props.multiline ? (0, $fcab4af601ce7e99$export$31b21d0167753bb4)(props.size, "input-padding-y") : void 0,
            "--input-left-section-pointer-events": props.leftSectionPointerEvents,
            "--input-right-section-pointer-events": props.rightSectionPointerEvents
        }
    }));
const $e2e9ff0d29bd408f$export$f5b8910cec6cf069 = (0, $dfead8eb7283bc39$export$197bdd704df40a29)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("Input", $e2e9ff0d29bd408f$var$defaultProps, _props);
    const _a = props, { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, required: required, __staticSelector: __staticSelector, __stylesApiProps: __stylesApiProps, size: size, wrapperProps: wrapperProps, error: error, disabled: disabled, leftSection: leftSection, leftSectionProps: leftSectionProps, leftSectionWidth: leftSectionWidth, rightSection: rightSection, rightSectionProps: rightSectionProps, rightSectionWidth: rightSectionWidth, rightSectionPointerEvents: rightSectionPointerEvents, leftSectionPointerEvents: leftSectionPointerEvents, variant: variant, vars: vars, pointer: pointer, multiline: multiline, radius: radius, id: id, withAria: withAria, withErrorStyles: withErrorStyles } = _a, others = $e2e9ff0d29bd408f$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "required",
        "__staticSelector",
        "__stylesApiProps",
        "size",
        "wrapperProps",
        "error",
        "disabled",
        "leftSection",
        "leftSectionProps",
        "leftSectionWidth",
        "rightSection",
        "rightSectionProps",
        "rightSectionWidth",
        "rightSectionPointerEvents",
        "leftSectionPointerEvents",
        "variant",
        "vars",
        "pointer",
        "multiline",
        "radius",
        "id",
        "withAria",
        "withErrorStyles"
    ]);
    const { styleProps: styleProps, rest: rest } = (0, $2e4262c949ef0e61$export$fbc67becbdd26fbf)(others);
    const ctx = (0, $71cd98bbd243f876$export$40fbe3aaaeb9dc6c)();
    const stylesCtx = {
        offsetBottom: ctx == null ? void 0 : ctx.offsetBottom,
        offsetTop: ctx == null ? void 0 : ctx.offsetTop
    };
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: [
            "Input",
            __staticSelector
        ],
        props: __stylesApiProps || props,
        classes: $68788066a3c963e6$export$2e2bcd8739ae039,
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        stylesCtx: stylesCtx,
        rootSelector: "wrapper",
        vars: vars,
        varsResolver: $e2e9ff0d29bd408f$var$varsResolver
    });
    const ariaAttributes = withAria ? {
        required: required,
        disabled: disabled,
        "aria-invalid": !!error,
        "aria-describedby": ctx == null ? void 0 : ctx.describedBy,
        id: (ctx == null ? void 0 : ctx.inputId) || id
    } : {};
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $e2e9ff0d29bd408f$var$__spreadProps($e2e9ff0d29bd408f$var$__spreadValues($e2e9ff0d29bd408f$var$__spreadValues($e2e9ff0d29bd408f$var$__spreadValues({}, getStyles("wrapper")), styleProps), wrapperProps), {
        mod: {
            error: !!error && withErrorStyles,
            pointer: pointer,
            disabled: disabled,
            multiline: multiline,
            "data-with-right-section": !!rightSection,
            "data-with-left-section": !!leftSection
        },
        variant: variant,
        size: size
    }), leftSection && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $e2e9ff0d29bd408f$var$__spreadValues($e2e9ff0d29bd408f$var$__spreadProps($e2e9ff0d29bd408f$var$__spreadValues({}, leftSectionProps), {
        "data-position": "left"
    }), getStyles("section", {
        className: leftSectionProps == null ? void 0 : leftSectionProps.className,
        style: leftSectionProps == null ? void 0 : leftSectionProps.style
    })), leftSection), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $e2e9ff0d29bd408f$var$__spreadValues($e2e9ff0d29bd408f$var$__spreadProps($e2e9ff0d29bd408f$var$__spreadValues($e2e9ff0d29bd408f$var$__spreadValues({
        component: "input"
    }, rest), ariaAttributes), {
        ref: ref,
        required: required,
        mod: {
            disabled: disabled,
            error: !!error && withErrorStyles
        },
        variant: variant
    }), getStyles("input"))), rightSection && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $e2e9ff0d29bd408f$var$__spreadValues($e2e9ff0d29bd408f$var$__spreadProps($e2e9ff0d29bd408f$var$__spreadValues({}, rightSectionProps), {
        "data-position": "right"
    }), getStyles("section", {
        className: rightSectionProps == null ? void 0 : rightSectionProps.className,
        style: rightSectionProps == null ? void 0 : rightSectionProps.style
    })), rightSection));
});
$e2e9ff0d29bd408f$export$f5b8910cec6cf069.classes = (0, $68788066a3c963e6$export$2e2bcd8739ae039);
$e2e9ff0d29bd408f$export$f5b8910cec6cf069.Wrapper = (0, $62cbf17611d1016d$export$fb9f58ebe9de6283);
$e2e9ff0d29bd408f$export$f5b8910cec6cf069.Label = (0, $7142f79830a0b6ab$export$76d3231fec538b73);
$e2e9ff0d29bd408f$export$f5b8910cec6cf069.Error = (0, $6fc8a9095ea9adf5$export$404cd3170eee2e81);
$e2e9ff0d29bd408f$export$f5b8910cec6cf069.Description = (0, $2250c0d6f2e006ef$export$416ae9045a33afd);
$e2e9ff0d29bd408f$export$f5b8910cec6cf069.Placeholder = (0, $15c2b8d80d4839cc$export$1dcf0d4dcfd98808);
$e2e9ff0d29bd408f$export$f5b8910cec6cf069.displayName = "@mantine/core/Input";



"use client";
var $ebdc9ebef4cbe70e$var$__defProp = Object.defineProperty;
var $ebdc9ebef4cbe70e$var$__defProps = Object.defineProperties;
var $ebdc9ebef4cbe70e$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $ebdc9ebef4cbe70e$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $ebdc9ebef4cbe70e$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $ebdc9ebef4cbe70e$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $ebdc9ebef4cbe70e$var$__defNormalProp = (obj, key, value)=>key in obj ? $ebdc9ebef4cbe70e$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $ebdc9ebef4cbe70e$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($ebdc9ebef4cbe70e$var$__hasOwnProp.call(b, prop)) $ebdc9ebef4cbe70e$var$__defNormalProp(a, prop, b[prop]);
    if ($ebdc9ebef4cbe70e$var$__getOwnPropSymbols) {
        for (var prop of $ebdc9ebef4cbe70e$var$__getOwnPropSymbols(b))if ($ebdc9ebef4cbe70e$var$__propIsEnum.call(b, prop)) $ebdc9ebef4cbe70e$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $ebdc9ebef4cbe70e$var$__spreadProps = (a, b)=>$ebdc9ebef4cbe70e$var$__defProps(a, $ebdc9ebef4cbe70e$var$__getOwnPropDescs(b));
var $ebdc9ebef4cbe70e$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($ebdc9ebef4cbe70e$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $ebdc9ebef4cbe70e$var$__getOwnPropSymbols) {
        for (var prop of $ebdc9ebef4cbe70e$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $ebdc9ebef4cbe70e$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $ebdc9ebef4cbe70e$var$defaultProps = {
    __staticSelector: "InputBase",
    withAria: true
};
const $ebdc9ebef4cbe70e$export$36eab7f492831059 = (0, $dfead8eb7283bc39$export$197bdd704df40a29)((props, ref)=>{
    const _a = (0, $a8c37d27d093a1ae$export$434ed5c8d5bb7eb5)("InputBase", $ebdc9ebef4cbe70e$var$defaultProps, props), { inputProps: inputProps, wrapperProps: wrapperProps } = _a, others = $ebdc9ebef4cbe70e$var$__objRest(_a, [
        "inputProps",
        "wrapperProps"
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e2e9ff0d29bd408f$export$f5b8910cec6cf069).Wrapper, $ebdc9ebef4cbe70e$var$__spreadValues({}, wrapperProps), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e2e9ff0d29bd408f$export$f5b8910cec6cf069), $ebdc9ebef4cbe70e$var$__spreadProps($ebdc9ebef4cbe70e$var$__spreadValues($ebdc9ebef4cbe70e$var$__spreadValues({}, inputProps), others), {
        ref: ref
    })));
});
$ebdc9ebef4cbe70e$export$36eab7f492831059.classes = $ebdc9ebef4cbe70e$var$__spreadValues($ebdc9ebef4cbe70e$var$__spreadValues({}, (0, $e2e9ff0d29bd408f$export$f5b8910cec6cf069).classes), (0, $e2e9ff0d29bd408f$export$f5b8910cec6cf069).Wrapper.classes);
$ebdc9ebef4cbe70e$export$36eab7f492831059.displayName = "@mantine/core/InputBase";




"use client";
var $c782496b9d9d6645$var$__defProp = Object.defineProperty;
var $c782496b9d9d6645$var$__defProps = Object.defineProperties;
var $c782496b9d9d6645$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $c782496b9d9d6645$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $c782496b9d9d6645$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $c782496b9d9d6645$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $c782496b9d9d6645$var$__defNormalProp = (obj, key, value)=>key in obj ? $c782496b9d9d6645$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $c782496b9d9d6645$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($c782496b9d9d6645$var$__hasOwnProp.call(b, prop)) $c782496b9d9d6645$var$__defNormalProp(a, prop, b[prop]);
    if ($c782496b9d9d6645$var$__getOwnPropSymbols) {
        for (var prop of $c782496b9d9d6645$var$__getOwnPropSymbols(b))if ($c782496b9d9d6645$var$__propIsEnum.call(b, prop)) $c782496b9d9d6645$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $c782496b9d9d6645$var$__spreadProps = (a, b)=>$c782496b9d9d6645$var$__defProps(a, $c782496b9d9d6645$var$__getOwnPropDescs(b));
var $c782496b9d9d6645$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($c782496b9d9d6645$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $c782496b9d9d6645$var$__getOwnPropSymbols) {
        for (var prop of $c782496b9d9d6645$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $c782496b9d9d6645$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $c782496b9d9d6645$var$defaultProps = {};
const $c782496b9d9d6645$export$379139ebc1c2b235 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((props, ref)=>{
    const _a = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("Textarea", $c782496b9d9d6645$var$defaultProps, props), { autosize: autosize, maxRows: maxRows, minRows: minRows, __staticSelector: __staticSelector } = _a, others = $c782496b9d9d6645$var$__objRest(_a, [
        "autosize",
        "maxRows",
        "minRows",
        "__staticSelector"
    ]);
    const autosizeProps = autosize ? {
        maxRows: maxRows,
        minRows: minRows
    } : {};
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ebdc9ebef4cbe70e$export$36eab7f492831059), $c782496b9d9d6645$var$__spreadValues($c782496b9d9d6645$var$__spreadProps($c782496b9d9d6645$var$__spreadValues({
        component: autosize ? (0, $8d208011843bf7ea$export$2e2bcd8739ae039) : "textarea",
        ref: ref
    }, others), {
        __staticSelector: __staticSelector || "Textarea",
        multiline: true,
        "data-no-overflow": autosize && maxRows === void 0 || void 0
    }), autosizeProps));
});
$c782496b9d9d6645$export$379139ebc1c2b235.classes = (0, $ebdc9ebef4cbe70e$export$36eab7f492831059).classes;
$c782496b9d9d6645$export$379139ebc1c2b235.displayName = "@mantine/core/Textarea";


/**
 * @tabler/icons-react v2.42.0 - MIT
 */ 
var $e20178616c8cb80c$export$2e2bcd8739ae039 = (0, $a86819fe50d185cb$export$2e2bcd8739ae039)("trash", "IconTrash", [
    [
        "path",
        {
            d: "M4 7l16 0",
            key: "svg-0"
        }
    ],
    [
        "path",
        {
            d: "M10 11l0 6",
            key: "svg-1"
        }
    ],
    [
        "path",
        {
            d: "M14 11l0 6",
            key: "svg-2"
        }
    ],
    [
        "path",
        {
            d: "M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12",
            key: "svg-3"
        }
    ],
    [
        "path",
        {
            d: "M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3",
            key: "svg-4"
        }
    ]
]);



var $acw62 = parcelRequire("acw62");






const $1861b69a0d0c7fdf$export$2c8ff0cf56ad97c4 = (0, $0990d2137b3e0830$export$65858239e7ec8811)("login", "/login/", "POST", [
    "Interest",
    "User",
    "Category",
    "Insight"
]);
const { useLazyLoginQuery: $1861b69a0d0c7fdf$export$1226a2cd269ab2ae } = $1861b69a0d0c7fdf$export$2c8ff0cf56ad97c4;
const $1861b69a0d0c7fdf$export$93839588c4ddd79f = (0, $0990d2137b3e0830$export$f740d16e59bfb312)("logout", "/logout/", "POST", [
    "Interest",
    "User",
    "Category",
    "Insight",
    "Source"
]);
const { useLazyLogoutQuery: $1861b69a0d0c7fdf$export$c83e688d5b02651d } = $1861b69a0d0c7fdf$export$93839588c4ddd79f;
const $1861b69a0d0c7fdf$export$f1711d2e1cb51622 = (0, $0990d2137b3e0830$export$65858239e7ec8811)("user", "/me/", "GET");
const { useUserQuery: $1861b69a0d0c7fdf$export$68dae0b0cacaa18a } = $1861b69a0d0c7fdf$export$f1711d2e1cb51622;
const $1861b69a0d0c7fdf$export$df7d2c5898066948 = (0, $0990d2137b3e0830$export$65858239e7ec8811)("allUsers", "/user/", "GET");
const { useAllUsersQuery: $1861b69a0d0c7fdf$export$7ef2f7af32a216c1 } = $1861b69a0d0c7fdf$export$df7d2c5898066948;
const $1861b69a0d0c7fdf$export$b09eb23cb63687b = (0, $51cd259feff82e55$export$9cdc2b9a8d94c842)({
    reducerPath: "UserIdAPI",
    baseQuery: (0, $66b21aa7bd8497fc$export$adcf4c6133c49b4e)({
        baseUrl: (0, $5cdc329eeebd56d0$export$923ea8233b386e99),
        credentials: "include"
    }),
    endpoints: (builder)=>({
            userId: builder.query({
                query: (userId)=>({
                        url: `/user/${userId}/`,
                        headers: (0, $d3ab9ae1f203b599$export$1e4d4724de7b199e)(),
                        method: "GET"
                    })
            })
        })
});
const { useUserIdQuery: $1861b69a0d0c7fdf$export$a746ec634ba19ebe } = $1861b69a0d0c7fdf$export$b09eb23cb63687b;
const $1861b69a0d0c7fdf$export$e39163329013e439 = (0, $0990d2137b3e0830$export$f740d16e59bfb312)("userSettings", "/user/settings/", "GET", []);
const { useUserSettingsQuery: $1861b69a0d0c7fdf$export$875924c4a7bff0b2 } = $1861b69a0d0c7fdf$export$93839588c4ddd79f;
const $1861b69a0d0c7fdf$export$75de874eaaf0158c = (0, $0990d2137b3e0830$export$e68afafd1fa92a9f)("updateUserSettings", ()=>`/user/settings/`, "PATCH", [
    "User",
    "UserSettings"
]);
const { useUpdateUserSettingsMutation: $1861b69a0d0c7fdf$export$a732e0a2c1f828ff } = $1861b69a0d0c7fdf$export$75de874eaaf0158c;
const $1861b69a0d0c7fdf$export$b5c5f3f9613b4de0 = (0, $0990d2137b3e0830$export$f740d16e59bfb312)("constants", "/constants/", "GET", []);
const { useConstantsQuery: $1861b69a0d0c7fdf$export$f662a937f042d11d } = $1861b69a0d0c7fdf$export$b5c5f3f9613b4de0;
const $1861b69a0d0c7fdf$export$eae9ffc76a830f33 = (0, $0990d2137b3e0830$export$65858239e7ec8811)("register", "/register/", "POST", (0, $5cdc329eeebd56d0$export$dea2465ef0480ab9));
const { useLazyRegisterQuery: $1861b69a0d0c7fdf$export$841f8daf161b305c } = $1861b69a0d0c7fdf$export$eae9ffc76a830f33;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

"use client";
const [$1874173f3d3e2272$export$178405afcd8c5eb, $1874173f3d3e2272$export$4cc1699d46f42cae] = (0, $0bf9cc213b4abd2e$export$97d0e477aacf9b7d)("Modal component was not found in tree");


"use client";
var $94b0e478eaf03e0e$var$classes = {
    "root": "m-9df02822",
    "content": "m-54c44539",
    "inner": "m-1f958f16",
    "header": "m-d0e2b9cd"
};
var $94b0e478eaf03e0e$export$2e2bcd8739ae039 = $94b0e478eaf03e0e$var$classes;



var $acw62 = parcelRequire("acw62");


"use client";
const [$fe9617635751bdba$export$695854637ffea3cb, $fe9617635751bdba$export$48c4ab01c2900d2] = (0, $0bf9cc213b4abd2e$export$97d0e477aacf9b7d)("ModalBase component was not found in tree");



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

"use client";
function $f4823e3369c057aa$export$275f09232623ff6f({ opened: opened, shouldReturnFocus: shouldReturnFocus = true }) {
    const lastActiveElement = (0, $acw62.useRef)();
    const returnFocus = ()=>{
        var _a;
        if (lastActiveElement.current && "focus" in lastActiveElement.current && typeof lastActiveElement.current.focus === "function") (_a = lastActiveElement.current) == null || _a.focus({
            preventScroll: true
        });
    };
    (0, $d9273517323905a9$export$e34ed88fef4dc107)(()=>{
        let timeout = -1;
        const clearFocusTimeout = (event)=>{
            if (event.key === "Tab") window.clearTimeout(timeout);
        };
        document.addEventListener("keydown", clearFocusTimeout);
        if (opened) lastActiveElement.current = document.activeElement;
        else if (shouldReturnFocus) timeout = window.setTimeout(returnFocus, 10);
        return ()=>{
            window.clearTimeout(timeout);
            document.removeEventListener("keydown", clearFocusTimeout);
        };
    }, [
        opened,
        shouldReturnFocus
    ]);
    return returnFocus;
}



var $acw62 = parcelRequire("acw62");

"use client";
function $4d41452b7a78dc51$export$6be872921498f185({ opened: opened, transitionDuration: transitionDuration }) {
    const [shouldLockScroll, setShouldLockScroll] = (0, $acw62.useState)(opened);
    const timeout = (0, $acw62.useRef)();
    const reduceMotion = (0, $91a4302ee7795ed2$export$6a42007cf1e7b6f8)();
    const _transitionDuration = reduceMotion ? 0 : transitionDuration;
    (0, $acw62.useEffect)(()=>{
        if (opened) {
            setShouldLockScroll(true);
            window.clearTimeout(timeout.current);
        } else if (_transitionDuration === 0) setShouldLockScroll(false);
        else timeout.current = window.setTimeout(()=>setShouldLockScroll(false), _transitionDuration);
        return ()=>window.clearTimeout(timeout.current);
    }, [
        opened,
        _transitionDuration
    ]);
    return shouldLockScroll;
}


"use client";
function $077126358bce20dd$export$33ffd74ebf07f060({ id: id, transitionProps: transitionProps, opened: opened, trapFocus: trapFocus, closeOnEscape: closeOnEscape, onClose: onClose, returnFocus: returnFocus }) {
    const _id = (0, $cee42e5537afff93$export$f680877a34711e37)(id);
    const [titleMounted, setTitleMounted] = (0, $acw62.useState)(false);
    const [bodyMounted, setBodyMounted] = (0, $acw62.useState)(false);
    const transitionDuration = typeof (transitionProps == null ? void 0 : transitionProps.duration) === "number" ? transitionProps == null ? void 0 : transitionProps.duration : 200;
    const shouldLockScroll = (0, $4d41452b7a78dc51$export$6be872921498f185)({
        opened: opened,
        transitionDuration: transitionDuration
    });
    (0, $f73e1d55da1ebeeb$export$ee579bb285b8d4aa)("keydown", (event)=>{
        if (!trapFocus && event.key === "Escape" && closeOnEscape) onClose();
    });
    (0, $f4823e3369c057aa$export$275f09232623ff6f)({
        opened: opened,
        shouldReturnFocus: trapFocus && returnFocus
    });
    return {
        _id: _id,
        titleMounted: titleMounted,
        bodyMounted: bodyMounted,
        shouldLockScroll: shouldLockScroll,
        setTitleMounted: setTitleMounted,
        setBodyMounted: setBodyMounted
    };
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");



"use client";
var $8764181c19a03e13$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $8764181c19a03e13$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $8764181c19a03e13$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $8764181c19a03e13$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($8764181c19a03e13$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $8764181c19a03e13$var$__getOwnPropSymbols) {
        for (var prop of $8764181c19a03e13$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $8764181c19a03e13$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
function $8764181c19a03e13$var$createPortalNode(props) {
    const node = document.createElement("div");
    node.setAttribute("data-portal", "true");
    typeof props.className === "string" && node.classList.add(...props.className.split(" "));
    typeof props.style === "object" && Object.assign(node.style, props.style);
    typeof props.id === "string" && node.setAttribute("id", props.id);
    return node;
}
const $8764181c19a03e13$var$defaultProps = {};
const $8764181c19a03e13$export$602eac185826482c = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("Portal", $8764181c19a03e13$var$defaultProps, props), { children: children, target: target } = _a, others = $8764181c19a03e13$var$__objRest(_a, [
        "children",
        "target"
    ]);
    const [mounted, setMounted] = (0, $acw62.useState)(false);
    const nodeRef = (0, $acw62.useRef)(null);
    (0, $562774022e0ac3ca$export$363c9f3eb56bbdbe)(()=>{
        setMounted(true);
        nodeRef.current = !target ? $8764181c19a03e13$var$createPortalNode(others) : typeof target === "string" ? document.querySelector(target) : target;
        (0, $7034a45159125c0b$export$d734136a7b018efe)(ref, nodeRef.current);
        if (!target && nodeRef.current) document.body.appendChild(nodeRef.current);
        return ()=>{
            if (!target && nodeRef.current) document.body.removeChild(nodeRef.current);
        };
    }, [
        target
    ]);
    if (!mounted || !nodeRef.current) return null;
    return (0, $11492dca620dcaa5$exports.createPortal)(/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children), nodeRef.current);
});
$8764181c19a03e13$export$602eac185826482c.displayName = "@mantine/core/Portal";


"use client";
var $c40c05f34c6cea16$var$__defProp = Object.defineProperty;
var $c40c05f34c6cea16$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $c40c05f34c6cea16$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $c40c05f34c6cea16$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $c40c05f34c6cea16$var$__defNormalProp = (obj, key, value)=>key in obj ? $c40c05f34c6cea16$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $c40c05f34c6cea16$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($c40c05f34c6cea16$var$__hasOwnProp.call(b, prop)) $c40c05f34c6cea16$var$__defNormalProp(a, prop, b[prop]);
    if ($c40c05f34c6cea16$var$__getOwnPropSymbols) {
        for (var prop of $c40c05f34c6cea16$var$__getOwnPropSymbols(b))if ($c40c05f34c6cea16$var$__propIsEnum.call(b, prop)) $c40c05f34c6cea16$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $c40c05f34c6cea16$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($c40c05f34c6cea16$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $c40c05f34c6cea16$var$__getOwnPropSymbols) {
        for (var prop of $c40c05f34c6cea16$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $c40c05f34c6cea16$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
function $c40c05f34c6cea16$export$425106c5d6e6dc37(_a) {
    var _b = _a, { withinPortal: withinPortal = true, children: children } = _b, others = $c40c05f34c6cea16$var$__objRest(_b, [
        "withinPortal",
        "children"
    ]);
    if (withinPortal) return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8764181c19a03e13$export$602eac185826482c), $c40c05f34c6cea16$var$__spreadValues({}, others), children);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children);
}
$c40c05f34c6cea16$export$425106c5d6e6dc37.displayName = "@mantine/core/OptionalPortal";





"use client";
var $cf609d56b9141a65$var$__defProp = Object.defineProperty;
var $cf609d56b9141a65$var$__defProps = Object.defineProperties;
var $cf609d56b9141a65$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $cf609d56b9141a65$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $cf609d56b9141a65$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $cf609d56b9141a65$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $cf609d56b9141a65$var$__defNormalProp = (obj, key, value)=>key in obj ? $cf609d56b9141a65$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $cf609d56b9141a65$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($cf609d56b9141a65$var$__hasOwnProp.call(b, prop)) $cf609d56b9141a65$var$__defNormalProp(a, prop, b[prop]);
    if ($cf609d56b9141a65$var$__getOwnPropSymbols) {
        for (var prop of $cf609d56b9141a65$var$__getOwnPropSymbols(b))if ($cf609d56b9141a65$var$__propIsEnum.call(b, prop)) $cf609d56b9141a65$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $cf609d56b9141a65$var$__spreadProps = (a, b)=>$cf609d56b9141a65$var$__defProps(a, $cf609d56b9141a65$var$__getOwnPropDescs(b));
var $cf609d56b9141a65$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($cf609d56b9141a65$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $cf609d56b9141a65$var$__getOwnPropSymbols) {
        for (var prop of $cf609d56b9141a65$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $cf609d56b9141a65$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $cf609d56b9141a65$export$acabb5bd2b72d092 = (0, $acw62.forwardRef)((_a, ref)=>{
    var _b = _a, { keepMounted: keepMounted, opened: opened, onClose: onClose, id: id, transitionProps: transitionProps, trapFocus: trapFocus, closeOnEscape: closeOnEscape, returnFocus: returnFocus, closeOnClickOutside: closeOnClickOutside, withinPortal: withinPortal, portalProps: portalProps, lockScroll: lockScroll, children: children, zIndex: zIndex, shadow: shadow, padding: padding, __vars: __vars, unstyled: unstyled } = _b, others = $cf609d56b9141a65$var$__objRest(_b, [
        "keepMounted",
        "opened",
        "onClose",
        "id",
        "transitionProps",
        "trapFocus",
        "closeOnEscape",
        "returnFocus",
        "closeOnClickOutside",
        "withinPortal",
        "portalProps",
        "lockScroll",
        "children",
        "zIndex",
        "shadow",
        "padding",
        "__vars",
        "unstyled"
    ]);
    const { _id: _id, titleMounted: titleMounted, bodyMounted: bodyMounted, shouldLockScroll: shouldLockScroll, setTitleMounted: setTitleMounted, setBodyMounted: setBodyMounted } = (0, $077126358bce20dd$export$33ffd74ebf07f060)({
        id: id,
        transitionProps: transitionProps,
        opened: opened,
        trapFocus: trapFocus,
        closeOnEscape: closeOnEscape,
        onClose: onClose,
        returnFocus: returnFocus
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c40c05f34c6cea16$export$425106c5d6e6dc37), $cf609d56b9141a65$var$__spreadProps($cf609d56b9141a65$var$__spreadValues({}, portalProps), {
        withinPortal: withinPortal
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fe9617635751bdba$export$695854637ffea3cb), {
        value: {
            opened: opened,
            onClose: onClose,
            closeOnClickOutside: closeOnClickOutside,
            transitionProps: $cf609d56b9141a65$var$__spreadProps($cf609d56b9141a65$var$__spreadValues({}, transitionProps), {
                keepMounted: keepMounted
            }),
            getTitleId: ()=>`${_id}-title`,
            getBodyId: ()=>`${_id}-body`,
            titleMounted: titleMounted,
            bodyMounted: bodyMounted,
            setTitleMounted: setTitleMounted,
            setBodyMounted: setBodyMounted,
            trapFocus: trapFocus,
            closeOnEscape: closeOnEscape,
            zIndex: zIndex,
            unstyled: unstyled
        }
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cfb1c25e3ef3d3bc$export$2e2bcd8739ae039), {
        enabled: shouldLockScroll && lockScroll
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $cf609d56b9141a65$var$__spreadProps($cf609d56b9141a65$var$__spreadValues({
        ref: ref
    }, others), {
        __vars: $cf609d56b9141a65$var$__spreadProps($cf609d56b9141a65$var$__spreadValues({}, __vars), {
            "--mb-z-index": (zIndex || (0, $f4b868e08831abbf$export$65573e7d509c92dc)("modal")).toString(),
            "--mb-shadow": (0, $fcab4af601ce7e99$export$db93b77dbb14f011)(shadow),
            "--mb-padding": (0, $fcab4af601ce7e99$export$f63796f8a9382bfb)(padding)
        })
    }), children))));
});









"use client";
var $5c4afba21fad19e5$var$__defProp = Object.defineProperty;
var $5c4afba21fad19e5$var$__defProps = Object.defineProperties;
var $5c4afba21fad19e5$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $5c4afba21fad19e5$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $5c4afba21fad19e5$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $5c4afba21fad19e5$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $5c4afba21fad19e5$var$__defNormalProp = (obj, key, value)=>key in obj ? $5c4afba21fad19e5$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $5c4afba21fad19e5$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($5c4afba21fad19e5$var$__hasOwnProp.call(b, prop)) $5c4afba21fad19e5$var$__defNormalProp(a, prop, b[prop]);
    if ($5c4afba21fad19e5$var$__getOwnPropSymbols) {
        for (var prop of $5c4afba21fad19e5$var$__getOwnPropSymbols(b))if ($5c4afba21fad19e5$var$__propIsEnum.call(b, prop)) $5c4afba21fad19e5$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $5c4afba21fad19e5$var$__spreadProps = (a, b)=>$5c4afba21fad19e5$var$__defProps(a, $5c4afba21fad19e5$var$__getOwnPropDescs(b));
var $5c4afba21fad19e5$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($5c4afba21fad19e5$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $5c4afba21fad19e5$var$__getOwnPropSymbols) {
        for (var prop of $5c4afba21fad19e5$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $5c4afba21fad19e5$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $5c4afba21fad19e5$var$defaultProps = {
    __staticSelector: "Modal",
    closeOnClickOutside: true,
    withinPortal: true,
    lockScroll: true,
    trapFocus: true,
    returnFocus: true,
    closeOnEscape: true,
    keepMounted: false,
    zIndex: (0, $f4b868e08831abbf$export$65573e7d509c92dc)("modal"),
    transitionProps: {
        duration: 200,
        transition: "pop"
    }
};
const $5c4afba21fad19e5$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((_, { radius: radius, size: size, yOffset: yOffset, xOffset: xOffset })=>({
        root: {
            "--modal-radius": radius === void 0 ? void 0 : (0, $fcab4af601ce7e99$export$35724d9c2979edc5)(radius),
            "--modal-size": (0, $fcab4af601ce7e99$export$31b21d0167753bb4)(size, "modal-size"),
            "--modal-y-offset": (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(yOffset),
            "--modal-x-offset": (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(xOffset)
        }
    }));
const $5c4afba21fad19e5$export$76630a3be18d4dc4 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("ModalRoot", $5c4afba21fad19e5$var$defaultProps, _props);
    const _a = props, { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, yOffset: yOffset, scrollAreaComponent: scrollAreaComponent, radius: radius, fullScreen: fullScreen, centered: centered, xOffset: xOffset, __staticSelector: __staticSelector } = _a, others = $5c4afba21fad19e5$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "yOffset",
        "scrollAreaComponent",
        "radius",
        "fullScreen",
        "centered",
        "xOffset",
        "__staticSelector"
    ]);
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: __staticSelector,
        classes: $94b0e478eaf03e0e$export$2e2bcd8739ae039,
        props: props,
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        vars: vars,
        varsResolver: $5c4afba21fad19e5$var$varsResolver
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1874173f3d3e2272$export$178405afcd8c5eb), {
        value: {
            yOffset: yOffset,
            scrollAreaComponent: scrollAreaComponent,
            getStyles: getStyles
        }
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cf609d56b9141a65$export$acabb5bd2b72d092), $5c4afba21fad19e5$var$__spreadValues($5c4afba21fad19e5$var$__spreadProps($5c4afba21fad19e5$var$__spreadValues({
        ref: ref
    }, getStyles("root")), {
        "data-full-screen": fullScreen || void 0,
        "data-centered": centered || void 0,
        unstyled: unstyled
    }), others)));
});
$5c4afba21fad19e5$export$76630a3be18d4dc4.classes = (0, $94b0e478eaf03e0e$export$2e2bcd8739ae039);
$5c4afba21fad19e5$export$76630a3be18d4dc4.displayName = "@mantine/core/ModalRoot";



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

"use client";
function $e67eed789ceb9808$export$5e6569270cd12e2c() {
    const ctx = (0, $fe9617635751bdba$export$48c4ab01c2900d2)();
    (0, $acw62.useEffect)(()=>{
        ctx.setBodyMounted(true);
        return ()=>ctx.setBodyMounted(false);
    }, []);
    return ctx.getBodyId();
}


"use client";
var $ed1030d453965fd5$var$classes = {
    "title": "m-615af6c9",
    "header": "m-b5489c3c",
    "inner": "m-60c222c7",
    "content": "m-fd1ab0aa",
    "close": "m-606cb269",
    "body": "m-5df29311"
};
var $ed1030d453965fd5$export$2e2bcd8739ae039 = $ed1030d453965fd5$var$classes;




"use client";
var $d5fd70f91a4bdfcc$var$__defProp = Object.defineProperty;
var $d5fd70f91a4bdfcc$var$__defProps = Object.defineProperties;
var $d5fd70f91a4bdfcc$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $d5fd70f91a4bdfcc$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $d5fd70f91a4bdfcc$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $d5fd70f91a4bdfcc$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $d5fd70f91a4bdfcc$var$__defNormalProp = (obj, key, value)=>key in obj ? $d5fd70f91a4bdfcc$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $d5fd70f91a4bdfcc$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($d5fd70f91a4bdfcc$var$__hasOwnProp.call(b, prop)) $d5fd70f91a4bdfcc$var$__defNormalProp(a, prop, b[prop]);
    if ($d5fd70f91a4bdfcc$var$__getOwnPropSymbols) {
        for (var prop of $d5fd70f91a4bdfcc$var$__getOwnPropSymbols(b))if ($d5fd70f91a4bdfcc$var$__propIsEnum.call(b, prop)) $d5fd70f91a4bdfcc$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $d5fd70f91a4bdfcc$var$__spreadProps = (a, b)=>$d5fd70f91a4bdfcc$var$__defProps(a, $d5fd70f91a4bdfcc$var$__getOwnPropDescs(b));
var $d5fd70f91a4bdfcc$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($d5fd70f91a4bdfcc$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $d5fd70f91a4bdfcc$var$__getOwnPropSymbols) {
        for (var prop of $d5fd70f91a4bdfcc$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $d5fd70f91a4bdfcc$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $d5fd70f91a4bdfcc$export$d7aef95ad3794d3a = (0, $acw62.forwardRef)((_a, ref)=>{
    var _b = _a, { className: className } = _b, others = $d5fd70f91a4bdfcc$var$__objRest(_b, [
        "className"
    ]);
    const bodyId = (0, $e67eed789ceb9808$export$5e6569270cd12e2c)();
    const ctx = (0, $fe9617635751bdba$export$48c4ab01c2900d2)();
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $d5fd70f91a4bdfcc$var$__spreadProps($d5fd70f91a4bdfcc$var$__spreadValues({
        ref: ref
    }, others), {
        id: bodyId,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)({
            [(0, $ed1030d453965fd5$export$2e2bcd8739ae039).body]: !ctx.unstyled
        }, className)
    }));
});
$d5fd70f91a4bdfcc$export$d7aef95ad3794d3a.displayName = "@mantine/core/ModalBaseBody";




"use client";
var $5d2fa167359bcff9$var$__defProp = Object.defineProperty;
var $5d2fa167359bcff9$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $5d2fa167359bcff9$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $5d2fa167359bcff9$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $5d2fa167359bcff9$var$__defNormalProp = (obj, key, value)=>key in obj ? $5d2fa167359bcff9$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $5d2fa167359bcff9$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($5d2fa167359bcff9$var$__hasOwnProp.call(b, prop)) $5d2fa167359bcff9$var$__defNormalProp(a, prop, b[prop]);
    if ($5d2fa167359bcff9$var$__getOwnPropSymbols) {
        for (var prop of $5d2fa167359bcff9$var$__getOwnPropSymbols(b))if ($5d2fa167359bcff9$var$__propIsEnum.call(b, prop)) $5d2fa167359bcff9$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $5d2fa167359bcff9$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($5d2fa167359bcff9$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $5d2fa167359bcff9$var$__getOwnPropSymbols) {
        for (var prop of $5d2fa167359bcff9$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $5d2fa167359bcff9$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $5d2fa167359bcff9$var$defaultProps = {};
const $5d2fa167359bcff9$export$cb540d8b0ef7906c = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("ModalBody", $5d2fa167359bcff9$var$defaultProps, _props);
    const _a = props, { classNames: classNames, className: className, style: style, styles: styles, vars: vars } = _a, others = $5d2fa167359bcff9$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars"
    ]);
    const ctx = (0, $1874173f3d3e2272$export$4cc1699d46f42cae)();
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d5fd70f91a4bdfcc$export$d7aef95ad3794d3a), $5d2fa167359bcff9$var$__spreadValues($5d2fa167359bcff9$var$__spreadValues({
        ref: ref
    }, ctx.getStyles("body", {
        classNames: classNames,
        style: style,
        styles: styles,
        className: className
    })), others));
});
$5d2fa167359bcff9$export$cb540d8b0ef7906c.classes = (0, $94b0e478eaf03e0e$export$2e2bcd8739ae039);
$5d2fa167359bcff9$export$cb540d8b0ef7906c.displayName = "@mantine/core/ModalBody";



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
"use client";
var $85c9758eca14ab21$var$__defProp = Object.defineProperty;
var $85c9758eca14ab21$var$__defProps = Object.defineProperties;
var $85c9758eca14ab21$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $85c9758eca14ab21$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $85c9758eca14ab21$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $85c9758eca14ab21$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $85c9758eca14ab21$var$__defNormalProp = (obj, key, value)=>key in obj ? $85c9758eca14ab21$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $85c9758eca14ab21$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($85c9758eca14ab21$var$__hasOwnProp.call(b, prop)) $85c9758eca14ab21$var$__defNormalProp(a, prop, b[prop]);
    if ($85c9758eca14ab21$var$__getOwnPropSymbols) {
        for (var prop of $85c9758eca14ab21$var$__getOwnPropSymbols(b))if ($85c9758eca14ab21$var$__propIsEnum.call(b, prop)) $85c9758eca14ab21$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $85c9758eca14ab21$var$__spreadProps = (a, b)=>$85c9758eca14ab21$var$__defProps(a, $85c9758eca14ab21$var$__getOwnPropDescs(b));
var $85c9758eca14ab21$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($85c9758eca14ab21$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $85c9758eca14ab21$var$__getOwnPropSymbols) {
        for (var prop of $85c9758eca14ab21$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $85c9758eca14ab21$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $85c9758eca14ab21$export$cae179f078f4b4a4 = (0, $acw62.forwardRef)((_a, ref)=>{
    var _b = _a, { size: size = "var(--cb-icon-size, 70%)", style: style } = _b, others = $85c9758eca14ab21$var$__objRest(_b, [
        "size",
        "style"
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $85c9758eca14ab21$var$__spreadValues({
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: $85c9758eca14ab21$var$__spreadProps($85c9758eca14ab21$var$__spreadValues({}, style), {
            width: size,
            height: size
        }),
        ref: ref
    }, others), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.44295 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z",
        fill: "currentColor",
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
$85c9758eca14ab21$export$cae179f078f4b4a4.displayName = "@mantine/core/CloseIcon";


"use client";
var $53031e2e92844b02$var$classes = {
    "root": "m-86a44da5",
    "root--subtle": "m-220c80f2"
};
var $53031e2e92844b02$export$2e2bcd8739ae039 = $53031e2e92844b02$var$classes;









"use client";
var $30da360a5c87638a$var$__defProp = Object.defineProperty;
var $30da360a5c87638a$var$__defProps = Object.defineProperties;
var $30da360a5c87638a$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $30da360a5c87638a$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $30da360a5c87638a$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $30da360a5c87638a$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $30da360a5c87638a$var$__defNormalProp = (obj, key, value)=>key in obj ? $30da360a5c87638a$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $30da360a5c87638a$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($30da360a5c87638a$var$__hasOwnProp.call(b, prop)) $30da360a5c87638a$var$__defNormalProp(a, prop, b[prop]);
    if ($30da360a5c87638a$var$__getOwnPropSymbols) {
        for (var prop of $30da360a5c87638a$var$__getOwnPropSymbols(b))if ($30da360a5c87638a$var$__propIsEnum.call(b, prop)) $30da360a5c87638a$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $30da360a5c87638a$var$__spreadProps = (a, b)=>$30da360a5c87638a$var$__defProps(a, $30da360a5c87638a$var$__getOwnPropDescs(b));
var $30da360a5c87638a$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($30da360a5c87638a$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $30da360a5c87638a$var$__getOwnPropSymbols) {
        for (var prop of $30da360a5c87638a$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $30da360a5c87638a$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $30da360a5c87638a$var$defaultProps = {
    variant: "subtle"
};
const $30da360a5c87638a$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((_, { size: size, radius: radius, iconSize: iconSize })=>({
        root: {
            "--cb-size": (0, $fcab4af601ce7e99$export$31b21d0167753bb4)(size, "cb-size"),
            "--cb-radius": radius === void 0 ? void 0 : (0, $fcab4af601ce7e99$export$35724d9c2979edc5)(radius),
            "--cb-icon-size": (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(iconSize)
        }
    }));
const $30da360a5c87638a$export$de65de8213222d10 = (0, $dfead8eb7283bc39$export$197bdd704df40a29)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("CloseButton", $30da360a5c87638a$var$defaultProps, _props);
    const _a = props, { iconSize: iconSize, children: children, vars: vars, radius: radius, className: className, classNames: classNames, style: style, styles: styles, unstyled: unstyled, "data-disabled": dataDisabled, disabled: disabled, variant: variant } = _a, others = $30da360a5c87638a$var$__objRest(_a, [
        "iconSize",
        "children",
        "vars",
        "radius",
        "className",
        "classNames",
        "style",
        "styles",
        "unstyled",
        "data-disabled",
        "disabled",
        "variant"
    ]);
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: "CloseButton",
        props: props,
        className: className,
        style: style,
        classes: $53031e2e92844b02$export$2e2bcd8739ae039,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        vars: vars,
        varsResolver: $30da360a5c87638a$var$varsResolver
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b9babe59f8fa61e8$export$3167f6ecaaaa3457), $30da360a5c87638a$var$__spreadValues($30da360a5c87638a$var$__spreadProps($30da360a5c87638a$var$__spreadValues({
        ref: ref
    }, others), {
        unstyled: unstyled,
        variant: variant,
        disabled: disabled,
        mod: {
            disabled: disabled || dataDisabled
        }
    }), getStyles("root", {
        variant: variant,
        active: true
    })), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $85c9758eca14ab21$export$cae179f078f4b4a4), null), children);
});
$30da360a5c87638a$export$de65de8213222d10.classes = (0, $53031e2e92844b02$export$2e2bcd8739ae039);
$30da360a5c87638a$export$de65de8213222d10.displayName = "@mantine/core/CloseButton";


"use client";
var $4a8838dd16520833$var$__defProp = Object.defineProperty;
var $4a8838dd16520833$var$__defProps = Object.defineProperties;
var $4a8838dd16520833$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $4a8838dd16520833$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $4a8838dd16520833$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $4a8838dd16520833$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $4a8838dd16520833$var$__defNormalProp = (obj, key, value)=>key in obj ? $4a8838dd16520833$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $4a8838dd16520833$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($4a8838dd16520833$var$__hasOwnProp.call(b, prop)) $4a8838dd16520833$var$__defNormalProp(a, prop, b[prop]);
    if ($4a8838dd16520833$var$__getOwnPropSymbols) {
        for (var prop of $4a8838dd16520833$var$__getOwnPropSymbols(b))if ($4a8838dd16520833$var$__propIsEnum.call(b, prop)) $4a8838dd16520833$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $4a8838dd16520833$var$__spreadProps = (a, b)=>$4a8838dd16520833$var$__defProps(a, $4a8838dd16520833$var$__getOwnPropDescs(b));
var $4a8838dd16520833$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($4a8838dd16520833$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $4a8838dd16520833$var$__getOwnPropSymbols) {
        for (var prop of $4a8838dd16520833$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $4a8838dd16520833$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $4a8838dd16520833$export$cb6429a0eac3477a = (0, $acw62.forwardRef)((_a, ref)=>{
    var _b = _a, { className: className, onClick: onClick } = _b, others = $4a8838dd16520833$var$__objRest(_b, [
        "className",
        "onClick"
    ]);
    const ctx = (0, $fe9617635751bdba$export$48c4ab01c2900d2)();
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $30da360a5c87638a$export$de65de8213222d10), $4a8838dd16520833$var$__spreadProps($4a8838dd16520833$var$__spreadValues({
        ref: ref
    }, others), {
        onClick: (event)=>{
            ctx.onClose();
            onClick == null || onClick(event);
        },
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)({
            [(0, $ed1030d453965fd5$export$2e2bcd8739ae039).close]: !ctx.unstyled
        }, className),
        unstyled: ctx.unstyled
    }));
});
$4a8838dd16520833$export$cb6429a0eac3477a.displayName = "@mantine/core/ModalBaseCloseButton";




"use client";
var $35769c8ec5687fff$var$__defProp = Object.defineProperty;
var $35769c8ec5687fff$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $35769c8ec5687fff$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $35769c8ec5687fff$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $35769c8ec5687fff$var$__defNormalProp = (obj, key, value)=>key in obj ? $35769c8ec5687fff$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $35769c8ec5687fff$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($35769c8ec5687fff$var$__hasOwnProp.call(b, prop)) $35769c8ec5687fff$var$__defNormalProp(a, prop, b[prop]);
    if ($35769c8ec5687fff$var$__getOwnPropSymbols) {
        for (var prop of $35769c8ec5687fff$var$__getOwnPropSymbols(b))if ($35769c8ec5687fff$var$__propIsEnum.call(b, prop)) $35769c8ec5687fff$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $35769c8ec5687fff$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($35769c8ec5687fff$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $35769c8ec5687fff$var$__getOwnPropSymbols) {
        for (var prop of $35769c8ec5687fff$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $35769c8ec5687fff$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $35769c8ec5687fff$var$defaultProps = {};
const $35769c8ec5687fff$export$edf9108895ba774f = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("ModalCloseButton", $35769c8ec5687fff$var$defaultProps, _props);
    const _a = props, { classNames: classNames, className: className, style: style, styles: styles, vars: vars } = _a, others = $35769c8ec5687fff$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars"
    ]);
    const ctx = (0, $1874173f3d3e2272$export$4cc1699d46f42cae)();
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4a8838dd16520833$export$cb6429a0eac3477a), $35769c8ec5687fff$var$__spreadValues($35769c8ec5687fff$var$__spreadValues({
        ref: ref
    }, ctx.getStyles("close", {
        classNames: classNames,
        style: style,
        styles: styles,
        className: className
    })), others));
});
$35769c8ec5687fff$export$edf9108895ba774f.classes = (0, $94b0e478eaf03e0e$export$2e2bcd8739ae039);
$35769c8ec5687fff$export$edf9108895ba774f.displayName = "@mantine/core/ModalCloseButton";



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

"use client";
var $9c8a16c6280d87ab$var$__defProp = Object.defineProperty;
var $9c8a16c6280d87ab$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $9c8a16c6280d87ab$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $9c8a16c6280d87ab$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $9c8a16c6280d87ab$var$__defNormalProp = (obj, key, value)=>key in obj ? $9c8a16c6280d87ab$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $9c8a16c6280d87ab$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($9c8a16c6280d87ab$var$__hasOwnProp.call(b, prop)) $9c8a16c6280d87ab$var$__defNormalProp(a, prop, b[prop]);
    if ($9c8a16c6280d87ab$var$__getOwnPropSymbols) {
        for (var prop of $9c8a16c6280d87ab$var$__getOwnPropSymbols(b))if ($9c8a16c6280d87ab$var$__propIsEnum.call(b, prop)) $9c8a16c6280d87ab$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
const $9c8a16c6280d87ab$var$DEFAULT_TRANSITION = {
    duration: 200,
    timingFunction: "ease",
    transition: "fade"
};
function $9c8a16c6280d87ab$export$5df0a1c6e658f755(transitionOverride) {
    const ctx = (0, $fe9617635751bdba$export$48c4ab01c2900d2)();
    return $9c8a16c6280d87ab$var$__spreadValues($9c8a16c6280d87ab$var$__spreadValues($9c8a16c6280d87ab$var$__spreadValues({}, $9c8a16c6280d87ab$var$DEFAULT_TRANSITION), ctx.transitionProps), transitionOverride);
}




var $acw62 = parcelRequire("acw62");

"use client";
var $ff2b36baf316e392$var$__defProp = Object.defineProperty;
var $ff2b36baf316e392$var$__defProps = Object.defineProperties;
var $ff2b36baf316e392$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $ff2b36baf316e392$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $ff2b36baf316e392$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $ff2b36baf316e392$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $ff2b36baf316e392$var$__defNormalProp = (obj, key, value)=>key in obj ? $ff2b36baf316e392$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $ff2b36baf316e392$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($ff2b36baf316e392$var$__hasOwnProp.call(b, prop)) $ff2b36baf316e392$var$__defNormalProp(a, prop, b[prop]);
    if ($ff2b36baf316e392$var$__getOwnPropSymbols) {
        for (var prop of $ff2b36baf316e392$var$__getOwnPropSymbols(b))if ($ff2b36baf316e392$var$__propIsEnum.call(b, prop)) $ff2b36baf316e392$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $ff2b36baf316e392$var$__spreadProps = (a, b)=>$ff2b36baf316e392$var$__defProps(a, $ff2b36baf316e392$var$__getOwnPropDescs(b));
const $ff2b36baf316e392$var$popIn = (from)=>({
        in: {
            opacity: 1,
            transform: "scale(1)"
        },
        out: {
            opacity: 0,
            transform: `scale(.9) translateY(${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(from === "bottom" ? 10 : -10)})`
        },
        transitionProperty: "transform, opacity"
    });
const $ff2b36baf316e392$export$622eca585e740ed5 = {
    fade: {
        in: {
            opacity: 1
        },
        out: {
            opacity: 0
        },
        transitionProperty: "opacity"
    },
    scale: {
        in: {
            opacity: 1,
            transform: "scale(1)"
        },
        out: {
            opacity: 0,
            transform: "scale(0)"
        },
        common: {
            transformOrigin: "top"
        },
        transitionProperty: "transform, opacity"
    },
    "scale-y": {
        in: {
            opacity: 1,
            transform: "scaleY(1)"
        },
        out: {
            opacity: 0,
            transform: "scaleY(0)"
        },
        common: {
            transformOrigin: "top"
        },
        transitionProperty: "transform, opacity"
    },
    "scale-x": {
        in: {
            opacity: 1,
            transform: "scaleX(1)"
        },
        out: {
            opacity: 0,
            transform: "scaleX(0)"
        },
        common: {
            transformOrigin: "left"
        },
        transitionProperty: "transform, opacity"
    },
    "skew-up": {
        in: {
            opacity: 1,
            transform: "translateY(0) skew(0deg, 0deg)"
        },
        out: {
            opacity: 0,
            transform: `translateY(-${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(20)}) skew(-10deg, -5deg)`
        },
        common: {
            transformOrigin: "top"
        },
        transitionProperty: "transform, opacity"
    },
    "skew-down": {
        in: {
            opacity: 1,
            transform: "translateY(0) skew(0deg, 0deg)"
        },
        out: {
            opacity: 0,
            transform: `translateY(${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(20)}) skew(-10deg, -5deg)`
        },
        common: {
            transformOrigin: "bottom"
        },
        transitionProperty: "transform, opacity"
    },
    "rotate-left": {
        in: {
            opacity: 1,
            transform: "translateY(0) rotate(0deg)"
        },
        out: {
            opacity: 0,
            transform: `translateY(${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(20)}) rotate(-5deg)`
        },
        common: {
            transformOrigin: "bottom"
        },
        transitionProperty: "transform, opacity"
    },
    "rotate-right": {
        in: {
            opacity: 1,
            transform: "translateY(0) rotate(0deg)"
        },
        out: {
            opacity: 0,
            transform: `translateY(${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(20)}) rotate(5deg)`
        },
        common: {
            transformOrigin: "top"
        },
        transitionProperty: "transform, opacity"
    },
    "slide-down": {
        in: {
            opacity: 1,
            transform: "translateY(0)"
        },
        out: {
            opacity: 0,
            transform: "translateY(-100%)"
        },
        common: {
            transformOrigin: "top"
        },
        transitionProperty: "transform, opacity"
    },
    "slide-up": {
        in: {
            opacity: 1,
            transform: "translateY(0)"
        },
        out: {
            opacity: 0,
            transform: "translateY(100%)"
        },
        common: {
            transformOrigin: "bottom"
        },
        transitionProperty: "transform, opacity"
    },
    "slide-left": {
        in: {
            opacity: 1,
            transform: "translateX(0)"
        },
        out: {
            opacity: 0,
            transform: "translateX(100%)"
        },
        common: {
            transformOrigin: "left"
        },
        transitionProperty: "transform, opacity"
    },
    "slide-right": {
        in: {
            opacity: 1,
            transform: "translateX(0)"
        },
        out: {
            opacity: 0,
            transform: "translateX(-100%)"
        },
        common: {
            transformOrigin: "right"
        },
        transitionProperty: "transform, opacity"
    },
    pop: $ff2b36baf316e392$var$__spreadProps($ff2b36baf316e392$var$__spreadValues({}, $ff2b36baf316e392$var$popIn("bottom")), {
        common: {
            transformOrigin: "center center"
        }
    }),
    "pop-bottom-left": $ff2b36baf316e392$var$__spreadProps($ff2b36baf316e392$var$__spreadValues({}, $ff2b36baf316e392$var$popIn("bottom")), {
        common: {
            transformOrigin: "bottom left"
        }
    }),
    "pop-bottom-right": $ff2b36baf316e392$var$__spreadProps($ff2b36baf316e392$var$__spreadValues({}, $ff2b36baf316e392$var$popIn("bottom")), {
        common: {
            transformOrigin: "bottom right"
        }
    }),
    "pop-top-left": $ff2b36baf316e392$var$__spreadProps($ff2b36baf316e392$var$__spreadValues({}, $ff2b36baf316e392$var$popIn("top")), {
        common: {
            transformOrigin: "top left"
        }
    }),
    "pop-top-right": $ff2b36baf316e392$var$__spreadProps($ff2b36baf316e392$var$__spreadValues({}, $ff2b36baf316e392$var$popIn("top")), {
        common: {
            transformOrigin: "top right"
        }
    })
};


"use client";
var $ca5c1f0106cf02fa$var$__defProp = Object.defineProperty;
var $ca5c1f0106cf02fa$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $ca5c1f0106cf02fa$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $ca5c1f0106cf02fa$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $ca5c1f0106cf02fa$var$__defNormalProp = (obj, key, value)=>key in obj ? $ca5c1f0106cf02fa$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $ca5c1f0106cf02fa$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($ca5c1f0106cf02fa$var$__hasOwnProp.call(b, prop)) $ca5c1f0106cf02fa$var$__defNormalProp(a, prop, b[prop]);
    if ($ca5c1f0106cf02fa$var$__getOwnPropSymbols) {
        for (var prop of $ca5c1f0106cf02fa$var$__getOwnPropSymbols(b))if ($ca5c1f0106cf02fa$var$__propIsEnum.call(b, prop)) $ca5c1f0106cf02fa$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
const $ca5c1f0106cf02fa$var$transitionStatuses = {
    entering: "in",
    entered: "in",
    exiting: "out",
    exited: "out",
    "pre-exiting": "out",
    "pre-entering": "out"
};
function $ca5c1f0106cf02fa$export$cfbcd9a4c0ed32ac({ transition: transition, state: state, duration: duration, timingFunction: timingFunction }) {
    const shared = {
        transitionDuration: `${duration}ms`,
        transitionTimingFunction: timingFunction
    };
    if (typeof transition === "string") {
        if (!(transition in (0, $ff2b36baf316e392$export$622eca585e740ed5))) return {};
        return $ca5c1f0106cf02fa$var$__spreadValues($ca5c1f0106cf02fa$var$__spreadValues($ca5c1f0106cf02fa$var$__spreadValues({
            transitionProperty: (0, $ff2b36baf316e392$export$622eca585e740ed5)[transition].transitionProperty
        }, shared), (0, $ff2b36baf316e392$export$622eca585e740ed5)[transition].common), (0, $ff2b36baf316e392$export$622eca585e740ed5)[transition][$ca5c1f0106cf02fa$var$transitionStatuses[state]]);
    }
    return $ca5c1f0106cf02fa$var$__spreadValues($ca5c1f0106cf02fa$var$__spreadValues($ca5c1f0106cf02fa$var$__spreadValues({
        transitionProperty: transition.transitionProperty
    }, shared), transition.common), transition[$ca5c1f0106cf02fa$var$transitionStatuses[state]]);
}



var $acw62 = parcelRequire("acw62");


"use client";
function $c142579a0c1a5140$export$7b286972b8d8ccbf({ duration: duration, exitDuration: exitDuration, timingFunction: timingFunction, mounted: mounted, onEnter: onEnter, onExit: onExit, onEntered: onEntered, onExited: onExited }) {
    const theme = (0, $692af3391f7b0a55$export$5eb0e84f6418b457)();
    const shouldReduceMotion = (0, $91a4302ee7795ed2$export$6a42007cf1e7b6f8)();
    const reduceMotion = theme.respectReducedMotion ? shouldReduceMotion : false;
    const [transitionDuration, setTransitionDuration] = (0, $acw62.useState)(reduceMotion ? 0 : duration);
    const [transitionStatus, setStatus] = (0, $acw62.useState)(mounted ? "entered" : "exited");
    const timeoutRef = (0, $acw62.useRef)(-1);
    const handleStateChange = (shouldMount)=>{
        const preHandler = shouldMount ? onEnter : onExit;
        const handler = shouldMount ? onEntered : onExited;
        setStatus(shouldMount ? "pre-entering" : "pre-exiting");
        window.clearTimeout(timeoutRef.current);
        const newTransitionDuration = reduceMotion ? 0 : shouldMount ? duration : exitDuration;
        setTransitionDuration(newTransitionDuration);
        if (newTransitionDuration === 0) {
            typeof preHandler === "function" && preHandler();
            typeof handler === "function" && handler();
            setStatus(shouldMount ? "entered" : "exited");
        } else {
            const preStateTimeout = window.setTimeout(()=>{
                typeof preHandler === "function" && preHandler();
                setStatus(shouldMount ? "entering" : "exiting");
            }, 10);
            timeoutRef.current = window.setTimeout(()=>{
                window.clearTimeout(preStateTimeout);
                typeof handler === "function" && handler();
                setStatus(shouldMount ? "entered" : "exited");
            }, newTransitionDuration);
        }
    };
    (0, $d9273517323905a9$export$e34ed88fef4dc107)(()=>{
        handleStateChange(mounted);
    }, [
        mounted
    ]);
    (0, $acw62.useEffect)(()=>()=>window.clearTimeout(timeoutRef.current), []);
    return {
        transitionDuration: transitionDuration,
        transitionStatus: transitionStatus,
        transitionTimingFunction: timingFunction || "ease"
    };
}


"use client";
function $4e0d3c4af0891b98$export$be58926105124dd4({ keepMounted: keepMounted, transition: transition = "fade", duration: duration = 250, exitDuration: exitDuration = duration, mounted: mounted, children: children, timingFunction: timingFunction = "ease", onExit: onExit, onEntered: onEntered, onEnter: onEnter, onExited: onExited }) {
    const { transitionDuration: transitionDuration, transitionStatus: transitionStatus, transitionTimingFunction: transitionTimingFunction } = (0, $c142579a0c1a5140$export$7b286972b8d8ccbf)({
        mounted: mounted,
        exitDuration: exitDuration,
        duration: duration,
        timingFunction: timingFunction,
        onExit: onExit,
        onEntered: onEntered,
        onEnter: onEnter,
        onExited: onExited
    });
    if (transitionDuration === 0) return mounted ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children({})) : keepMounted ? children({
        display: "none"
    }) : null;
    return transitionStatus === "exited" ? keepMounted ? children({
        display: "none"
    }) : null : /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children((0, $ca5c1f0106cf02fa$export$cfbcd9a4c0ed32ac)({
        transition: transition,
        duration: transitionDuration,
        state: transitionStatus,
        timingFunction: transitionTimingFunction
    })));
}
$4e0d3c4af0891b98$export$be58926105124dd4.displayName = "@mantine/core/Transition";



var $acw62 = parcelRequire("acw62");
"use client";
var $a59458134950664f$var$classes = {
    "root": "m-9814e45f"
};
var $a59458134950664f$export$2e2bcd8739ae039 = $a59458134950664f$var$classes;











"use client";
var $8816b2889866f4a7$var$__defProp = Object.defineProperty;
var $8816b2889866f4a7$var$__defProps = Object.defineProperties;
var $8816b2889866f4a7$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $8816b2889866f4a7$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $8816b2889866f4a7$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $8816b2889866f4a7$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $8816b2889866f4a7$var$__defNormalProp = (obj, key, value)=>key in obj ? $8816b2889866f4a7$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $8816b2889866f4a7$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($8816b2889866f4a7$var$__hasOwnProp.call(b, prop)) $8816b2889866f4a7$var$__defNormalProp(a, prop, b[prop]);
    if ($8816b2889866f4a7$var$__getOwnPropSymbols) {
        for (var prop of $8816b2889866f4a7$var$__getOwnPropSymbols(b))if ($8816b2889866f4a7$var$__propIsEnum.call(b, prop)) $8816b2889866f4a7$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $8816b2889866f4a7$var$__spreadProps = (a, b)=>$8816b2889866f4a7$var$__defProps(a, $8816b2889866f4a7$var$__getOwnPropDescs(b));
var $8816b2889866f4a7$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($8816b2889866f4a7$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $8816b2889866f4a7$var$__getOwnPropSymbols) {
        for (var prop of $8816b2889866f4a7$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $8816b2889866f4a7$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $8816b2889866f4a7$var$defaultProps = {
    zIndex: (0, $f4b868e08831abbf$export$65573e7d509c92dc)("modal")
};
const $8816b2889866f4a7$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((_, { gradient: gradient, color: color, backgroundOpacity: backgroundOpacity, blur: blur, radius: radius, zIndex: zIndex })=>({
        root: {
            "--overlay-bg": gradient || (color !== void 0 || backgroundOpacity !== void 0) && (0, $a29d51c1f7df5c7c$export$4e46ac54fc82cf3b)(color || "#000", backgroundOpacity != null ? backgroundOpacity : 0.6) || void 0,
            "--overlay-filter": blur ? `blur(${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(blur)})` : void 0,
            "--overlay-radius": radius === void 0 ? void 0 : (0, $fcab4af601ce7e99$export$35724d9c2979edc5)(radius),
            "--overlay-z-index": zIndex == null ? void 0 : zIndex.toString()
        }
    }));
const $8816b2889866f4a7$export$c6fdb837b070b4ff = (0, $dfead8eb7283bc39$export$197bdd704df40a29)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("Overlay", $8816b2889866f4a7$var$defaultProps, _props);
    const _a = props, { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, fixed: fixed, center: center, children: children, radius: radius, zIndex: zIndex, gradient: gradient, blur: blur, color: color, backgroundOpacity: backgroundOpacity } = _a, others = $8816b2889866f4a7$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "fixed",
        "center",
        "children",
        "radius",
        "zIndex",
        "gradient",
        "blur",
        "color",
        "backgroundOpacity"
    ]);
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: "Overlay",
        props: props,
        classes: $a59458134950664f$export$2e2bcd8739ae039,
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        vars: vars,
        varsResolver: $8816b2889866f4a7$var$varsResolver
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $8816b2889866f4a7$var$__spreadValues($8816b2889866f4a7$var$__spreadProps($8816b2889866f4a7$var$__spreadValues({
        ref: ref
    }, getStyles("root")), {
        mod: {
            center: center,
            fixed: fixed
        }
    }), others), children);
});
$8816b2889866f4a7$export$c6fdb837b070b4ff.classes = (0, $a59458134950664f$export$2e2bcd8739ae039);
$8816b2889866f4a7$export$c6fdb837b070b4ff.displayName = "@mantine/core/Overlay";


"use client";
var $06d7d3a0bbd37bf0$var$__defProp = Object.defineProperty;
var $06d7d3a0bbd37bf0$var$__defProps = Object.defineProperties;
var $06d7d3a0bbd37bf0$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $06d7d3a0bbd37bf0$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $06d7d3a0bbd37bf0$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $06d7d3a0bbd37bf0$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $06d7d3a0bbd37bf0$var$__defNormalProp = (obj, key, value)=>key in obj ? $06d7d3a0bbd37bf0$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $06d7d3a0bbd37bf0$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($06d7d3a0bbd37bf0$var$__hasOwnProp.call(b, prop)) $06d7d3a0bbd37bf0$var$__defNormalProp(a, prop, b[prop]);
    if ($06d7d3a0bbd37bf0$var$__getOwnPropSymbols) {
        for (var prop of $06d7d3a0bbd37bf0$var$__getOwnPropSymbols(b))if ($06d7d3a0bbd37bf0$var$__propIsEnum.call(b, prop)) $06d7d3a0bbd37bf0$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $06d7d3a0bbd37bf0$var$__spreadProps = (a, b)=>$06d7d3a0bbd37bf0$var$__defProps(a, $06d7d3a0bbd37bf0$var$__getOwnPropDescs(b));
var $06d7d3a0bbd37bf0$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($06d7d3a0bbd37bf0$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $06d7d3a0bbd37bf0$var$__getOwnPropSymbols) {
        for (var prop of $06d7d3a0bbd37bf0$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $06d7d3a0bbd37bf0$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $06d7d3a0bbd37bf0$export$dfc81a5f853cf392 = (0, $acw62.forwardRef)((_a, ref)=>{
    var _b = _a, { onClick: onClick, transitionProps: transitionProps, style: style } = _b, others = $06d7d3a0bbd37bf0$var$__objRest(_b, [
        "onClick",
        "transitionProps",
        "style"
    ]);
    const ctx = (0, $fe9617635751bdba$export$48c4ab01c2900d2)();
    const transition = (0, $9c8a16c6280d87ab$export$5df0a1c6e658f755)(transitionProps);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4e0d3c4af0891b98$export$be58926105124dd4), $06d7d3a0bbd37bf0$var$__spreadProps($06d7d3a0bbd37bf0$var$__spreadValues({
        mounted: ctx.opened
    }, transition), {
        transition: "fade"
    }), (transitionStyles)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8816b2889866f4a7$export$c6fdb837b070b4ff), $06d7d3a0bbd37bf0$var$__spreadValues({
            ref: ref,
            fixed: true,
            style: [
                style,
                transitionStyles
            ],
            zIndex: ctx.zIndex,
            unstyled: ctx.unstyled,
            onClick: (event)=>{
                onClick == null || onClick(event);
                ctx.closeOnClickOutside && ctx.onClose();
            }
        }, others)));
});
$06d7d3a0bbd37bf0$export$dfc81a5f853cf392.displayName = "@mantine/core/ModalBaseOverlay";




"use client";
var $913f345f895164ed$var$__defProp = Object.defineProperty;
var $913f345f895164ed$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $913f345f895164ed$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $913f345f895164ed$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $913f345f895164ed$var$__defNormalProp = (obj, key, value)=>key in obj ? $913f345f895164ed$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $913f345f895164ed$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($913f345f895164ed$var$__hasOwnProp.call(b, prop)) $913f345f895164ed$var$__defNormalProp(a, prop, b[prop]);
    if ($913f345f895164ed$var$__getOwnPropSymbols) {
        for (var prop of $913f345f895164ed$var$__getOwnPropSymbols(b))if ($913f345f895164ed$var$__propIsEnum.call(b, prop)) $913f345f895164ed$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $913f345f895164ed$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($913f345f895164ed$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $913f345f895164ed$var$__getOwnPropSymbols) {
        for (var prop of $913f345f895164ed$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $913f345f895164ed$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $913f345f895164ed$var$defaultProps = {};
const $913f345f895164ed$export$8948f78d83984c69 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("ModalOverlay", $913f345f895164ed$var$defaultProps, _props);
    const _a = props, { classNames: classNames, className: className, style: style, styles: styles, vars: vars } = _a, others = $913f345f895164ed$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars"
    ]);
    const ctx = (0, $1874173f3d3e2272$export$4cc1699d46f42cae)();
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $06d7d3a0bbd37bf0$export$dfc81a5f853cf392), $913f345f895164ed$var$__spreadValues($913f345f895164ed$var$__spreadValues({
        ref: ref
    }, ctx.getStyles("overlay", {
        classNames: classNames,
        style: style,
        styles: styles,
        className: className
    })), others));
});
$913f345f895164ed$export$8948f78d83984c69.classes = (0, $94b0e478eaf03e0e$export$2e2bcd8739ae039);
$913f345f895164ed$export$8948f78d83984c69.displayName = "@mantine/core/ModalOverlay";



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
"use client";
function $382093e308c1e7d9$export$db1aa91c77c94e4c({ children: children }) {
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children);
}



var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
"use client";
const $f455481bb19aecdd$var$TABBABLE_NODES = /input|select|textarea|button|object/;
const $f455481bb19aecdd$export$1402e37c3ad71960 = "a, input, select, textarea, button, object, [tabindex]";
function $f455481bb19aecdd$var$hidden(element) {
    return element.style.display === "none";
}
function $f455481bb19aecdd$var$visible(element) {
    const isHidden = element.getAttribute("aria-hidden") || element.getAttribute("hidden") || element.getAttribute("type") === "hidden";
    if (isHidden) return false;
    let parentElement = element;
    while(parentElement){
        if (parentElement === document.body || parentElement.nodeType === 11) break;
        if ($f455481bb19aecdd$var$hidden(parentElement)) return false;
        parentElement = parentElement.parentNode;
    }
    return true;
}
function $f455481bb19aecdd$var$getElementTabIndex(element) {
    let tabIndex = element.getAttribute("tabindex");
    if (tabIndex === null) tabIndex = void 0;
    return parseInt(tabIndex, 10);
}
function $f455481bb19aecdd$export$ecc6d1fcdff4f700(element) {
    const nodeName = element.nodeName.toLowerCase();
    const isTabIndexNotNaN = !Number.isNaN($f455481bb19aecdd$var$getElementTabIndex(element));
    const res = // @ts-ignore
    $f455481bb19aecdd$var$TABBABLE_NODES.test(nodeName) && !element.disabled || (element instanceof HTMLAnchorElement ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
    return res && $f455481bb19aecdd$var$visible(element);
}
function $f455481bb19aecdd$export$17100aea90429aa7(element) {
    const tabIndex = $f455481bb19aecdd$var$getElementTabIndex(element);
    const isTabIndexNaN = Number.isNaN(tabIndex);
    return (isTabIndexNaN || tabIndex >= 0) && $f455481bb19aecdd$export$ecc6d1fcdff4f700(element);
}
function $f455481bb19aecdd$export$9add2e4db58062c(element) {
    return Array.from(element.querySelectorAll($f455481bb19aecdd$export$1402e37c3ad71960)).filter($f455481bb19aecdd$export$17100aea90429aa7);
}



"use client";
function $e497d06b12418905$export$a4ab3f53d4a6be9b(node, event) {
    const tabbable = (0, $f455481bb19aecdd$export$9add2e4db58062c)(node);
    if (!tabbable.length) {
        event.preventDefault();
        return;
    }
    const finalTabbable = tabbable[event.shiftKey ? 0 : tabbable.length - 1];
    const root = node.getRootNode();
    let leavingFinalTabbable = finalTabbable === root.activeElement || node === root.activeElement;
    const activeElement = root.activeElement;
    const activeElementIsRadio = activeElement.tagName === "INPUT" && activeElement.getAttribute("type") === "radio";
    if (activeElementIsRadio) {
        const activeRadioGroup = tabbable.filter((element)=>element.getAttribute("type") === "radio" && element.getAttribute("name") === activeElement.getAttribute("name"));
        leavingFinalTabbable = activeRadioGroup.includes(finalTabbable);
    }
    if (!leavingFinalTabbable) return;
    event.preventDefault();
    const target = tabbable[event.shiftKey ? tabbable.length - 1 : 0];
    if (target) target.focus();
}



"use client";
function $9f9e34191021736e$export$a1d7ca7bc7dc5023(containerNode, selector = "body > :not(script)") {
    const id = (0, $9e1d22b9666695e5$export$5e699d18035b41af)();
    const rootNodes = Array.from(document.querySelectorAll(selector)).map((node)=>{
        var _a;
        if (((_a = node == null ? void 0 : node.shadowRoot) == null ? void 0 : _a.contains(containerNode)) || node.contains(containerNode)) return void 0;
        const ariaHidden = node.getAttribute("aria-hidden");
        const prevAriaHidden = node.getAttribute("data-hidden");
        const prevFocusId = node.getAttribute("data-focus-id");
        node.setAttribute("data-focus-id", id);
        if (ariaHidden === null || ariaHidden === "false") node.setAttribute("aria-hidden", "true");
        else if (!prevAriaHidden && !prevFocusId) node.setAttribute("data-hidden", ariaHidden);
        return {
            node: node,
            ariaHidden: prevAriaHidden || null
        };
    });
    return ()=>{
        rootNodes.forEach((item)=>{
            if (!item || id !== item.node.getAttribute("data-focus-id")) return;
            if (item.ariaHidden === null) item.node.removeAttribute("aria-hidden");
            else item.node.setAttribute("aria-hidden", item.ariaHidden);
            item.node.removeAttribute("data-focus-id");
            item.node.removeAttribute("data-hidden");
        });
    };
}


"use client";
function $f0e5ce899b20f8cd$export$5562a1f223a0d314(active = true) {
    const ref = (0, $acw62.useRef)();
    const restoreAria = (0, $acw62.useRef)(null);
    const focusNode = (node)=>{
        let focusElement = node.querySelector("[data-autofocus]");
        if (!focusElement) {
            const children = Array.from(node.querySelectorAll((0, $f455481bb19aecdd$export$1402e37c3ad71960)));
            focusElement = children.find((0, $f455481bb19aecdd$export$17100aea90429aa7)) || children.find((0, $f455481bb19aecdd$export$ecc6d1fcdff4f700)) || null;
            if (!focusElement && (0, $f455481bb19aecdd$export$ecc6d1fcdff4f700)(node)) focusElement = node;
        }
        if (focusElement) focusElement.focus({
            preventScroll: true
        });
    };
    const setRef = (0, $acw62.useCallback)((node)=>{
        if (!active) return;
        if (node === null) {
            if (restoreAria.current) {
                restoreAria.current();
                restoreAria.current = null;
            }
            return;
        }
        restoreAria.current = (0, $9f9e34191021736e$export$a1d7ca7bc7dc5023)(node);
        if (ref.current === node) return;
        if (node) {
            setTimeout(()=>{
                if (node.getRootNode()) focusNode(node);
            });
            ref.current = node;
        } else ref.current = null;
    }, [
        active
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!active) return void 0;
        ref.current && setTimeout(()=>focusNode(ref.current));
        const handleKeyDown = (event)=>{
            if (event.key === "Tab" && ref.current) (0, $e497d06b12418905$export$a4ab3f53d4a6be9b)(ref.current, event);
        };
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
            if (restoreAria.current) restoreAria.current();
        };
    }, [
        active
    ]);
    return setRef;
}



var $acw62 = parcelRequire("acw62");
"use client";
function $65b68cae0fe4eb32$export$45a5e7f76e0caa8d(value) {
    if (Array.isArray(value) || value === null) return false;
    if (typeof value === "object") {
        if (value.type === (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment) return false;
        return true;
    }
    return false;
}


"use client";
function $78545dc889974525$export$34eba2437817a67b({ children: children, active: active = true, refProp: refProp = "ref" }) {
    const focusTrapRef = (0, $f0e5ce899b20f8cd$export$5562a1f223a0d314)(active);
    const ref = (0, $7034a45159125c0b$export$36a55fa7500f01f)(focusTrapRef, children == null ? void 0 : children.ref);
    if (!(0, $65b68cae0fe4eb32$export$45a5e7f76e0caa8d)(children)) return children;
    return (0, $acw62.cloneElement)(children, {
        [refProp]: ref
    });
}
$78545dc889974525$export$34eba2437817a67b.displayName = "@mantine/core/FocusTrap";



"use client";
var $de3968c572b3eca5$var$__defProp = Object.defineProperty;
var $de3968c572b3eca5$var$__defProps = Object.defineProperties;
var $de3968c572b3eca5$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $de3968c572b3eca5$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $de3968c572b3eca5$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $de3968c572b3eca5$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $de3968c572b3eca5$var$__defNormalProp = (obj, key, value)=>key in obj ? $de3968c572b3eca5$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $de3968c572b3eca5$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($de3968c572b3eca5$var$__hasOwnProp.call(b, prop)) $de3968c572b3eca5$var$__defNormalProp(a, prop, b[prop]);
    if ($de3968c572b3eca5$var$__getOwnPropSymbols) {
        for (var prop of $de3968c572b3eca5$var$__getOwnPropSymbols(b))if ($de3968c572b3eca5$var$__propIsEnum.call(b, prop)) $de3968c572b3eca5$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $de3968c572b3eca5$var$__spreadProps = (a, b)=>$de3968c572b3eca5$var$__defProps(a, $de3968c572b3eca5$var$__getOwnPropDescs(b));
var $de3968c572b3eca5$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($de3968c572b3eca5$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $de3968c572b3eca5$var$__getOwnPropSymbols) {
        for (var prop of $de3968c572b3eca5$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $de3968c572b3eca5$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $de3968c572b3eca5$export$a0b222e605967853 = (0, $acw62.forwardRef)((_a, ref)=>{
    var _b = _a, { transitionProps: transitionProps, className: className, innerProps: innerProps, onKeyDown: onKeyDown, style: style } = _b, others = $de3968c572b3eca5$var$__objRest(_b, [
        "transitionProps",
        "className",
        "innerProps",
        "onKeyDown",
        "style"
    ]);
    const ctx = (0, $fe9617635751bdba$export$48c4ab01c2900d2)();
    const handleKeyDown = (event)=>{
        var _a2;
        const shouldTrigger = ((_a2 = event.target) == null ? void 0 : _a2.getAttribute("data-mantine-stop-propagation")) !== "true";
        shouldTrigger && event.key === "Escape" && ctx.closeOnEscape && ctx.onClose();
        onKeyDown == null || onKeyDown(event);
    };
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4e0d3c4af0891b98$export$be58926105124dd4), $de3968c572b3eca5$var$__spreadValues($de3968c572b3eca5$var$__spreadValues({
        mounted: ctx.opened,
        transition: "pop"
    }, ctx.transitionProps), transitionProps), (transitionStyles)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $de3968c572b3eca5$var$__spreadProps($de3968c572b3eca5$var$__spreadValues({}, innerProps), {
            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)({
                [(0, $ed1030d453965fd5$export$2e2bcd8739ae039).inner]: !ctx.unstyled
            }, innerProps.className)
        }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78545dc889974525$export$34eba2437817a67b), {
            active: ctx.opened && ctx.trapFocus
        }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f9eedd3a1a3486ca$export$e01703dff029898a), $de3968c572b3eca5$var$__spreadProps($de3968c572b3eca5$var$__spreadValues({}, others), {
            component: "section",
            role: "dialog",
            tabIndex: -1,
            "aria-modal": true,
            "aria-describedby": ctx.bodyMounted ? ctx.getBodyId() : void 0,
            "aria-labelledby": ctx.titleMounted ? ctx.getTitleId() : void 0,
            onKeyDown: handleKeyDown,
            ref: ref,
            style: [
                style,
                transitionStyles
            ],
            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)({
                [(0, $ed1030d453965fd5$export$2e2bcd8739ae039).content]: !ctx.unstyled
            }, className),
            unstyled: ctx.unstyled
        }), others.children))));
});





"use client";
var $5a867aa53d8adb6b$var$__defProp = Object.defineProperty;
var $5a867aa53d8adb6b$var$__defProps = Object.defineProperties;
var $5a867aa53d8adb6b$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $5a867aa53d8adb6b$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $5a867aa53d8adb6b$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $5a867aa53d8adb6b$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $5a867aa53d8adb6b$var$__defNormalProp = (obj, key, value)=>key in obj ? $5a867aa53d8adb6b$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $5a867aa53d8adb6b$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($5a867aa53d8adb6b$var$__hasOwnProp.call(b, prop)) $5a867aa53d8adb6b$var$__defNormalProp(a, prop, b[prop]);
    if ($5a867aa53d8adb6b$var$__getOwnPropSymbols) {
        for (var prop of $5a867aa53d8adb6b$var$__getOwnPropSymbols(b))if ($5a867aa53d8adb6b$var$__propIsEnum.call(b, prop)) $5a867aa53d8adb6b$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $5a867aa53d8adb6b$var$__spreadProps = (a, b)=>$5a867aa53d8adb6b$var$__defProps(a, $5a867aa53d8adb6b$var$__getOwnPropDescs(b));
var $5a867aa53d8adb6b$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($5a867aa53d8adb6b$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $5a867aa53d8adb6b$var$__getOwnPropSymbols) {
        for (var prop of $5a867aa53d8adb6b$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $5a867aa53d8adb6b$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $5a867aa53d8adb6b$var$defaultProps = {};
const $5a867aa53d8adb6b$export$6da19a24bf249f17 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("ModalContent", $5a867aa53d8adb6b$var$defaultProps, _props);
    const _a = props, { classNames: classNames, className: className, style: style, styles: styles, vars: vars, children: children } = _a, others = $5a867aa53d8adb6b$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars",
        "children"
    ]);
    const ctx = (0, $1874173f3d3e2272$export$4cc1699d46f42cae)();
    const Scroll = ctx.scrollAreaComponent || (0, $382093e308c1e7d9$export$db1aa91c77c94e4c);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $de3968c572b3eca5$export$a0b222e605967853), $5a867aa53d8adb6b$var$__spreadValues($5a867aa53d8adb6b$var$__spreadProps($5a867aa53d8adb6b$var$__spreadValues({}, ctx.getStyles("content", {
        className: className,
        style: style,
        styles: styles,
        classNames: classNames
    })), {
        innerProps: ctx.getStyles("inner", {
            className: className,
            style: style,
            styles: styles,
            classNames: classNames
        }),
        ref: ref
    }), others), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Scroll, {
        style: {
            maxHeight: `calc(100vh - (${(0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(ctx.yOffset)} * 2))`
        }
    }, children));
});
$5a867aa53d8adb6b$export$6da19a24bf249f17.classes = (0, $94b0e478eaf03e0e$export$2e2bcd8739ae039);
$5a867aa53d8adb6b$export$6da19a24bf249f17.displayName = "@mantine/core/ModalContent";



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

"use client";
function $224fbbd1388458db$export$40f4ca977bb60074() {
    const ctx = (0, $fe9617635751bdba$export$48c4ab01c2900d2)();
    (0, $acw62.useEffect)(()=>{
        ctx.setTitleMounted(true);
        return ()=>ctx.setTitleMounted(false);
    }, []);
    return ctx.getTitleId();
}





"use client";
var $07ac7932ab612e37$var$__defProp = Object.defineProperty;
var $07ac7932ab612e37$var$__defProps = Object.defineProperties;
var $07ac7932ab612e37$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $07ac7932ab612e37$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $07ac7932ab612e37$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $07ac7932ab612e37$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $07ac7932ab612e37$var$__defNormalProp = (obj, key, value)=>key in obj ? $07ac7932ab612e37$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $07ac7932ab612e37$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($07ac7932ab612e37$var$__hasOwnProp.call(b, prop)) $07ac7932ab612e37$var$__defNormalProp(a, prop, b[prop]);
    if ($07ac7932ab612e37$var$__getOwnPropSymbols) {
        for (var prop of $07ac7932ab612e37$var$__getOwnPropSymbols(b))if ($07ac7932ab612e37$var$__propIsEnum.call(b, prop)) $07ac7932ab612e37$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $07ac7932ab612e37$var$__spreadProps = (a, b)=>$07ac7932ab612e37$var$__defProps(a, $07ac7932ab612e37$var$__getOwnPropDescs(b));
var $07ac7932ab612e37$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($07ac7932ab612e37$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $07ac7932ab612e37$var$__getOwnPropSymbols) {
        for (var prop of $07ac7932ab612e37$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $07ac7932ab612e37$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $07ac7932ab612e37$export$a1d3732afcf18148 = (0, $acw62.forwardRef)((_a, ref)=>{
    var _b = _a, { className: className } = _b, others = $07ac7932ab612e37$var$__objRest(_b, [
        "className"
    ]);
    const id = (0, $224fbbd1388458db$export$40f4ca977bb60074)();
    const ctx = (0, $fe9617635751bdba$export$48c4ab01c2900d2)();
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $07ac7932ab612e37$var$__spreadProps($07ac7932ab612e37$var$__spreadValues({
        component: "h2",
        ref: ref,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)({
            [(0, $ed1030d453965fd5$export$2e2bcd8739ae039).title]: !ctx.unstyled
        }, className)
    }, others), {
        id: id
    }));
});
$07ac7932ab612e37$export$a1d3732afcf18148.displayName = "@mantine/core/ModalBaseTitle";




"use client";
var $5e540156043d8c03$var$__defProp = Object.defineProperty;
var $5e540156043d8c03$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $5e540156043d8c03$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $5e540156043d8c03$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $5e540156043d8c03$var$__defNormalProp = (obj, key, value)=>key in obj ? $5e540156043d8c03$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $5e540156043d8c03$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($5e540156043d8c03$var$__hasOwnProp.call(b, prop)) $5e540156043d8c03$var$__defNormalProp(a, prop, b[prop]);
    if ($5e540156043d8c03$var$__getOwnPropSymbols) {
        for (var prop of $5e540156043d8c03$var$__getOwnPropSymbols(b))if ($5e540156043d8c03$var$__propIsEnum.call(b, prop)) $5e540156043d8c03$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $5e540156043d8c03$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($5e540156043d8c03$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $5e540156043d8c03$var$__getOwnPropSymbols) {
        for (var prop of $5e540156043d8c03$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $5e540156043d8c03$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $5e540156043d8c03$var$defaultProps = {};
const $5e540156043d8c03$export$b26fae16ba5468aa = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("ModalTitle", $5e540156043d8c03$var$defaultProps, _props);
    const _a = props, { classNames: classNames, className: className, style: style, styles: styles, vars: vars } = _a, others = $5e540156043d8c03$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars"
    ]);
    const ctx = (0, $1874173f3d3e2272$export$4cc1699d46f42cae)();
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $07ac7932ab612e37$export$a1d3732afcf18148), $5e540156043d8c03$var$__spreadValues($5e540156043d8c03$var$__spreadValues({
        ref: ref
    }, ctx.getStyles("title", {
        classNames: classNames,
        style: style,
        styles: styles,
        className: className
    })), others));
});
$5e540156043d8c03$export$b26fae16ba5468aa.classes = (0, $94b0e478eaf03e0e$export$2e2bcd8739ae039);
$5e540156043d8c03$export$b26fae16ba5468aa.displayName = "@mantine/core/ModalTitle";



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");




"use client";
var $36f14f6b2ad38d8c$var$__defProp = Object.defineProperty;
var $36f14f6b2ad38d8c$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $36f14f6b2ad38d8c$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $36f14f6b2ad38d8c$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $36f14f6b2ad38d8c$var$__defNormalProp = (obj, key, value)=>key in obj ? $36f14f6b2ad38d8c$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $36f14f6b2ad38d8c$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($36f14f6b2ad38d8c$var$__hasOwnProp.call(b, prop)) $36f14f6b2ad38d8c$var$__defNormalProp(a, prop, b[prop]);
    if ($36f14f6b2ad38d8c$var$__getOwnPropSymbols) {
        for (var prop of $36f14f6b2ad38d8c$var$__getOwnPropSymbols(b))if ($36f14f6b2ad38d8c$var$__propIsEnum.call(b, prop)) $36f14f6b2ad38d8c$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $36f14f6b2ad38d8c$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($36f14f6b2ad38d8c$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $36f14f6b2ad38d8c$var$__getOwnPropSymbols) {
        for (var prop of $36f14f6b2ad38d8c$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $36f14f6b2ad38d8c$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $36f14f6b2ad38d8c$export$6cdb8b1b385d5e98 = (0, $acw62.forwardRef)((_a, ref)=>{
    var _b = _a, { className: className } = _b, others = $36f14f6b2ad38d8c$var$__objRest(_b, [
        "className"
    ]);
    const ctx = (0, $fe9617635751bdba$export$48c4ab01c2900d2)();
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $36f14f6b2ad38d8c$var$__spreadValues({
        ref: ref,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)({
            [(0, $ed1030d453965fd5$export$2e2bcd8739ae039).header]: !ctx.unstyled
        }, className)
    }, others));
});
$36f14f6b2ad38d8c$export$6cdb8b1b385d5e98.displayName = "@mantine/core/ModalBaseHeader";




"use client";
var $33aea0631d2029a1$var$__defProp = Object.defineProperty;
var $33aea0631d2029a1$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $33aea0631d2029a1$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $33aea0631d2029a1$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $33aea0631d2029a1$var$__defNormalProp = (obj, key, value)=>key in obj ? $33aea0631d2029a1$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $33aea0631d2029a1$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($33aea0631d2029a1$var$__hasOwnProp.call(b, prop)) $33aea0631d2029a1$var$__defNormalProp(a, prop, b[prop]);
    if ($33aea0631d2029a1$var$__getOwnPropSymbols) {
        for (var prop of $33aea0631d2029a1$var$__getOwnPropSymbols(b))if ($33aea0631d2029a1$var$__propIsEnum.call(b, prop)) $33aea0631d2029a1$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $33aea0631d2029a1$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($33aea0631d2029a1$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $33aea0631d2029a1$var$__getOwnPropSymbols) {
        for (var prop of $33aea0631d2029a1$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $33aea0631d2029a1$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $33aea0631d2029a1$var$defaultProps = {};
const $33aea0631d2029a1$export$f50a68e3694789ee = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("ModalHeader", $33aea0631d2029a1$var$defaultProps, _props);
    const _a = props, { classNames: classNames, className: className, style: style, styles: styles, vars: vars } = _a, others = $33aea0631d2029a1$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars"
    ]);
    const ctx = (0, $1874173f3d3e2272$export$4cc1699d46f42cae)();
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $36f14f6b2ad38d8c$export$6cdb8b1b385d5e98), $33aea0631d2029a1$var$__spreadValues($33aea0631d2029a1$var$__spreadValues({
        ref: ref
    }, ctx.getStyles("header", {
        classNames: classNames,
        style: style,
        styles: styles,
        className: className
    })), others));
});
$33aea0631d2029a1$export$f50a68e3694789ee.classes = (0, $94b0e478eaf03e0e$export$2e2bcd8739ae039);
$33aea0631d2029a1$export$f50a68e3694789ee.displayName = "@mantine/core/ModalHeader";






"use client";
var $b1b81586258b47fb$var$__defProp = Object.defineProperty;
var $b1b81586258b47fb$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $b1b81586258b47fb$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $b1b81586258b47fb$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $b1b81586258b47fb$var$__defNormalProp = (obj, key, value)=>key in obj ? $b1b81586258b47fb$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $b1b81586258b47fb$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($b1b81586258b47fb$var$__hasOwnProp.call(b, prop)) $b1b81586258b47fb$var$__defNormalProp(a, prop, b[prop]);
    if ($b1b81586258b47fb$var$__getOwnPropSymbols) {
        for (var prop of $b1b81586258b47fb$var$__getOwnPropSymbols(b))if ($b1b81586258b47fb$var$__propIsEnum.call(b, prop)) $b1b81586258b47fb$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $b1b81586258b47fb$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($b1b81586258b47fb$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $b1b81586258b47fb$var$__getOwnPropSymbols) {
        for (var prop of $b1b81586258b47fb$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $b1b81586258b47fb$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $b1b81586258b47fb$var$defaultProps = {
    closeOnClickOutside: true,
    withinPortal: true,
    lockScroll: true,
    trapFocus: true,
    returnFocus: true,
    closeOnEscape: true,
    keepMounted: false,
    zIndex: (0, $f4b868e08831abbf$export$65573e7d509c92dc)("modal"),
    transitionProps: {
        duration: 200,
        transition: "pop"
    },
    withOverlay: true,
    withCloseButton: true
};
const $b1b81586258b47fb$export$2b77a92f1a5ad772 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props, ref)=>{
    const _a = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("Modal", $b1b81586258b47fb$var$defaultProps, _props), { title: title, withOverlay: withOverlay, overlayProps: overlayProps, withCloseButton: withCloseButton, closeButtonProps: closeButtonProps, children: children, radius: radius } = _a, others = $b1b81586258b47fb$var$__objRest(_a, [
        "title",
        "withOverlay",
        "overlayProps",
        "withCloseButton",
        "closeButtonProps",
        "children",
        "radius"
    ]);
    const hasHeader = !!title || withCloseButton;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5c4afba21fad19e5$export$76630a3be18d4dc4), $b1b81586258b47fb$var$__spreadValues({
        ref: ref,
        radius: radius
    }, others), withOverlay && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $913f345f895164ed$export$8948f78d83984c69), $b1b81586258b47fb$var$__spreadValues({}, overlayProps)), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5a867aa53d8adb6b$export$6da19a24bf249f17), {
        radius: radius
    }, hasHeader && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $33aea0631d2029a1$export$f50a68e3694789ee), null, title && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5e540156043d8c03$export$b26fae16ba5468aa), null, title), withCloseButton && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $35769c8ec5687fff$export$edf9108895ba774f), $b1b81586258b47fb$var$__spreadValues({}, closeButtonProps))), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5d2fa167359bcff9$export$cb540d8b0ef7906c), null, children)));
});
$b1b81586258b47fb$export$2b77a92f1a5ad772.classes = (0, $94b0e478eaf03e0e$export$2e2bcd8739ae039);
$b1b81586258b47fb$export$2b77a92f1a5ad772.displayName = "@mantine/core/Modal";
$b1b81586258b47fb$export$2b77a92f1a5ad772.Root = (0, $5c4afba21fad19e5$export$76630a3be18d4dc4);
$b1b81586258b47fb$export$2b77a92f1a5ad772.Overlay = (0, $913f345f895164ed$export$8948f78d83984c69);
$b1b81586258b47fb$export$2b77a92f1a5ad772.Content = (0, $5a867aa53d8adb6b$export$6da19a24bf249f17);
$b1b81586258b47fb$export$2b77a92f1a5ad772.Body = (0, $5d2fa167359bcff9$export$cb540d8b0ef7906c);
$b1b81586258b47fb$export$2b77a92f1a5ad772.Header = (0, $33aea0631d2029a1$export$f50a68e3694789ee);
$b1b81586258b47fb$export$2b77a92f1a5ad772.Title = (0, $5e540156043d8c03$export$b26fae16ba5468aa);
$b1b81586258b47fb$export$2b77a92f1a5ad772.CloseButton = (0, $35769c8ec5687fff$export$edf9108895ba774f);


var $acw62 = parcelRequire("acw62");

"use client";
function $0887c454ff4ce757$var$parseItem(item) {
    if (typeof item === "string") return {
        value: item,
        label: item
    };
    if (typeof item === "number") return {
        value: item.toString(),
        label: item.toString()
    };
    if ("group" in item) return {
        group: item.group,
        items: item.items.map((i)=>$0887c454ff4ce757$var$parseItem(i))
    };
    return item;
}
function $0887c454ff4ce757$export$4d4f0f9e22a4ec50(data) {
    if (!data) return [];
    return data.map($0887c454ff4ce757$var$parseItem);
}


"use client";
var $1ea5e49f796534b2$var$__defProp = Object.defineProperty;
var $1ea5e49f796534b2$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $1ea5e49f796534b2$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $1ea5e49f796534b2$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $1ea5e49f796534b2$var$__defNormalProp = (obj, key, value)=>key in obj ? $1ea5e49f796534b2$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $1ea5e49f796534b2$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($1ea5e49f796534b2$var$__hasOwnProp.call(b, prop)) $1ea5e49f796534b2$var$__defNormalProp(a, prop, b[prop]);
    if ($1ea5e49f796534b2$var$__getOwnPropSymbols) {
        for (var prop of $1ea5e49f796534b2$var$__getOwnPropSymbols(b))if ($1ea5e49f796534b2$var$__propIsEnum.call(b, prop)) $1ea5e49f796534b2$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
function $1ea5e49f796534b2$export$3ecc75716a884846(options) {
    return options.reduce((acc, item)=>{
        if ("group" in item) return $1ea5e49f796534b2$var$__spreadValues($1ea5e49f796534b2$var$__spreadValues({}, acc), $1ea5e49f796534b2$export$3ecc75716a884846(item.items));
        acc[item.value] = item;
        return acc;
    }, {});
}
function $1ea5e49f796534b2$export$adaeeae10ffef84a(options) {
    return options.reduce((acc, item)=>{
        if ("group" in item) return $1ea5e49f796534b2$var$__spreadValues($1ea5e49f796534b2$var$__spreadValues({}, acc), $1ea5e49f796534b2$export$adaeeae10ffef84a(item.items));
        acc[item.label] = item;
        return acc;
    }, {});
}



var $acw62 = parcelRequire("acw62");

"use client";
function $91b7da3024d7b671$export$65b1407ca3f33abd(currentIndex, elements, loop) {
    for(let i = currentIndex - 1; i >= 0; i -= 1){
        if (!elements[i].hasAttribute("data-combobox-disabled")) return i;
    }
    if (loop) for(let i = elements.length - 1; i > -1; i -= 1){
        if (!elements[i].hasAttribute("data-combobox-disabled")) return i;
    }
    return currentIndex;
}
function $91b7da3024d7b671$export$c42e0e80904d519(currentIndex, elements, loop) {
    for(let i = currentIndex + 1; i < elements.length; i += 1){
        if (!elements[i].hasAttribute("data-combobox-disabled")) return i;
    }
    if (loop) for(let i = 0; i < elements.length; i += 1){
        if (!elements[i].hasAttribute("data-combobox-disabled")) return i;
    }
    return currentIndex;
}
function $91b7da3024d7b671$export$9dcfcc459d76775f(elements) {
    for(let i = 0; i < elements.length; i += 1){
        if (!elements[i].hasAttribute("data-combobox-disabled")) return i;
    }
    return -1;
}


"use client";
function $ec685ef88b7ada0d$export$7a023a466c03eb3d({ defaultOpened: defaultOpened, opened: opened, onOpenedChange: onOpenedChange, onDropdownClose: onDropdownClose, onDropdownOpen: onDropdownOpen, loop: loop = true, scrollBehavior: scrollBehavior = "instant" } = {}) {
    const [dropdownOpened, setDropdownOpened] = (0, $4197894a742d9f84$export$ec55e9daaf703a7d)({
        value: opened,
        defaultValue: defaultOpened,
        finalValue: false,
        onChange: onOpenedChange
    });
    const listId = (0, $acw62.useRef)(null);
    const selectedOptionIndex = (0, $acw62.useRef)(-1);
    const searchRef = (0, $acw62.useRef)(null);
    const targetRef = (0, $acw62.useRef)(null);
    const focusSearchTimeout = (0, $acw62.useRef)(-1);
    const focusTargetTimeout = (0, $acw62.useRef)(-1);
    const selectedIndexUpdateTimeout = (0, $acw62.useRef)(-1);
    const openDropdown = (0, $acw62.useCallback)((eventSource = "unknown")=>{
        if (!dropdownOpened) {
            setDropdownOpened(true);
            onDropdownOpen == null || onDropdownOpen(eventSource);
        }
    }, [
        setDropdownOpened,
        onDropdownOpen,
        dropdownOpened
    ]);
    const closeDropdown = (0, $acw62.useCallback)((eventSource = "unknown")=>{
        if (dropdownOpened) {
            setDropdownOpened(false);
            onDropdownClose == null || onDropdownClose(eventSource);
        }
    }, [
        setDropdownOpened,
        onDropdownClose,
        dropdownOpened
    ]);
    const toggleDropdown = (0, $acw62.useCallback)((eventSource = "unknown")=>{
        if (dropdownOpened) closeDropdown(eventSource);
        else openDropdown(eventSource);
    }, [
        closeDropdown,
        openDropdown,
        dropdownOpened
    ]);
    const clearSelectedItem = (0, $acw62.useCallback)(()=>{
        const selected = document.querySelector(`#${listId.current} [data-combobox-selected]`);
        selected == null || selected.removeAttribute("data-combobox-selected");
        selected == null || selected.removeAttribute("aria-selected");
    }, []);
    const selectOption = (0, $acw62.useCallback)((index)=>{
        const list = document.getElementById(listId.current);
        const items = list == null ? void 0 : list.querySelectorAll("[data-combobox-option]");
        if (!items) return null;
        const nextIndex = index >= items.length ? 0 : index < 0 ? items.length - 1 : index;
        selectedOptionIndex.current = nextIndex;
        if ((items == null ? void 0 : items[nextIndex]) && !items[nextIndex].hasAttribute("data-combobox-disabled")) {
            clearSelectedItem();
            items[nextIndex].setAttribute("data-combobox-selected", "true");
            items[nextIndex].setAttribute("aria-selected", "true");
            items[nextIndex].scrollIntoView({
                block: "nearest",
                behavior: scrollBehavior
            });
            return items[nextIndex].id;
        }
        return null;
    }, [
        scrollBehavior,
        clearSelectedItem
    ]);
    const selectActiveOption = (0, $acw62.useCallback)(()=>{
        const activeOption = document.querySelector(`#${listId.current} [data-combobox-active]`);
        if (activeOption) {
            const items = document.querySelectorAll(`#${listId.current} [data-combobox-option]`);
            const index = Array.from(items).findIndex((option)=>option === activeOption);
            return selectOption(index);
        }
        return selectOption(0);
    }, [
        selectOption
    ]);
    const selectNextOption = (0, $acw62.useCallback)(()=>selectOption((0, $91b7da3024d7b671$export$c42e0e80904d519)(selectedOptionIndex.current, document.querySelectorAll(`#${listId.current} [data-combobox-option]`), loop)), [
        selectOption,
        loop
    ]);
    const selectPreviousOption = (0, $acw62.useCallback)(()=>selectOption((0, $91b7da3024d7b671$export$65b1407ca3f33abd)(selectedOptionIndex.current, document.querySelectorAll(`#${listId.current} [data-combobox-option]`), loop)), [
        selectOption,
        loop
    ]);
    const selectFirstOption = (0, $acw62.useCallback)(()=>selectOption((0, $91b7da3024d7b671$export$9dcfcc459d76775f)(document.querySelectorAll(`#${listId.current} [data-combobox-option]`))), [
        selectOption
    ]);
    const updateSelectedOptionIndex = (0, $acw62.useCallback)((target = "selected")=>{
        selectedIndexUpdateTimeout.current = window.setTimeout(()=>{
            const items = document.querySelectorAll(`#${listId.current} [data-combobox-option]`);
            const index = Array.from(items).findIndex((option)=>option.hasAttribute(`data-combobox-${target}`));
            selectedOptionIndex.current = index;
        }, 0);
    }, []);
    const resetSelectedOption = (0, $acw62.useCallback)(()=>{
        selectedOptionIndex.current = -1;
        clearSelectedItem();
    }, [
        clearSelectedItem
    ]);
    const clickSelectedOption = (0, $acw62.useCallback)(()=>{
        const items = document.querySelectorAll(`#${listId.current} [data-combobox-option]`);
        const item = items == null ? void 0 : items[selectedOptionIndex.current];
        item == null || item.click();
    }, []);
    const setListId = (0, $acw62.useCallback)((id)=>{
        listId.current = id;
    }, []);
    const focusSearchInput = (0, $acw62.useCallback)(()=>{
        focusSearchTimeout.current = window.setTimeout(()=>searchRef.current.focus(), 0);
    }, []);
    const focusTarget = (0, $acw62.useCallback)(()=>{
        focusTargetTimeout.current = window.setTimeout(()=>targetRef.current.focus(), 0);
    }, []);
    (0, $acw62.useEffect)(()=>()=>{
            window.clearTimeout(focusSearchTimeout.current);
            window.clearTimeout(focusTargetTimeout.current);
            window.clearTimeout(selectedIndexUpdateTimeout.current);
        }, []);
    return {
        dropdownOpened: dropdownOpened,
        openDropdown: openDropdown,
        closeDropdown: closeDropdown,
        toggleDropdown: toggleDropdown,
        selectedOptionIndex: selectedOptionIndex.current,
        selectOption: selectOption,
        selectFirstOption: selectFirstOption,
        selectActiveOption: selectActiveOption,
        selectNextOption: selectNextOption,
        selectPreviousOption: selectPreviousOption,
        resetSelectedOption: resetSelectedOption,
        updateSelectedOptionIndex: updateSelectedOptionIndex,
        listId: listId.current,
        setListId: setListId,
        clickSelectedOption: clickSelectedOption,
        searchRef: searchRef,
        focusSearchInput: focusSearchInput,
        targetRef: targetRef,
        focusTarget: focusTarget
    };
}



var $acw62 = parcelRequire("acw62");


"use client";
const [$f376d2b018786be2$export$f11a865534e57bfe, $f376d2b018786be2$export$a20838a54f9bb7c8] = (0, $0bf9cc213b4abd2e$export$97d0e477aacf9b7d)("Combobox component was not found in tree");



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

"use client";
var $b295bd7ffc5c275b$var$__defProp = Object.defineProperty;
var $b295bd7ffc5c275b$var$__defProps = Object.defineProperties;
var $b295bd7ffc5c275b$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $b295bd7ffc5c275b$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $b295bd7ffc5c275b$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $b295bd7ffc5c275b$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $b295bd7ffc5c275b$var$__defNormalProp = (obj, key, value)=>key in obj ? $b295bd7ffc5c275b$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $b295bd7ffc5c275b$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($b295bd7ffc5c275b$var$__hasOwnProp.call(b, prop)) $b295bd7ffc5c275b$var$__defNormalProp(a, prop, b[prop]);
    if ($b295bd7ffc5c275b$var$__getOwnPropSymbols) {
        for (var prop of $b295bd7ffc5c275b$var$__getOwnPropSymbols(b))if ($b295bd7ffc5c275b$var$__propIsEnum.call(b, prop)) $b295bd7ffc5c275b$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $b295bd7ffc5c275b$var$__spreadProps = (a, b)=>$b295bd7ffc5c275b$var$__defProps(a, $b295bd7ffc5c275b$var$__getOwnPropDescs(b));
function $b295bd7ffc5c275b$export$658025f4cf47e0bf({ onKeyDown: onKeyDown, withKeyboardNavigation: withKeyboardNavigation, withAriaAttributes: withAriaAttributes, withExpandedAttribute: withExpandedAttribute, targetType: targetType }) {
    const ctx = (0, $f376d2b018786be2$export$a20838a54f9bb7c8)();
    const [selectedOptionId, setSelectedOptionId] = (0, $acw62.useState)(null);
    const handleKeyDown = (event)=>{
        onKeyDown == null || onKeyDown(event);
        if (ctx.readOnly) return;
        if (withKeyboardNavigation) {
            if (event.nativeEvent.code === "ArrowDown") {
                event.preventDefault();
                if (!ctx.store.dropdownOpened) {
                    ctx.store.openDropdown("keyboard");
                    setSelectedOptionId(ctx.store.selectActiveOption());
                } else setSelectedOptionId(ctx.store.selectNextOption());
            }
            if (event.nativeEvent.code === "ArrowUp") {
                event.preventDefault();
                if (!ctx.store.dropdownOpened) {
                    ctx.store.openDropdown("keyboard");
                    setSelectedOptionId(ctx.store.selectActiveOption());
                } else setSelectedOptionId(ctx.store.selectPreviousOption());
            }
            if (event.nativeEvent.code === "Enter") {
                if (ctx.store.dropdownOpened) {
                    event.preventDefault();
                    ctx.store.clickSelectedOption();
                } else if (targetType === "button") {
                    event.preventDefault();
                    ctx.store.openDropdown("keyboard");
                }
            }
            if (event.nativeEvent.code === "Escape") ctx.store.closeDropdown("keyboard");
            if (event.nativeEvent.code === "Space") {
                if (targetType === "button") {
                    event.preventDefault();
                    ctx.store.toggleDropdown("keyboard");
                }
            }
        }
    };
    const ariaAttributes = withAriaAttributes ? {
        "aria-haspopup": "listbox",
        "aria-expanded": withExpandedAttribute && !!(ctx.store.listId && ctx.store.dropdownOpened) || void 0,
        "aria-controls": ctx.store.listId,
        "aria-activedescendant": ctx.store.dropdownOpened ? selectedOptionId || void 0 : void 0,
        autoComplete: "off",
        "data-expanded": ctx.store.dropdownOpened ? true : void 0
    } : {};
    return $b295bd7ffc5c275b$var$__spreadProps($b295bd7ffc5c275b$var$__spreadValues({}, ariaAttributes), {
        onKeyDown: handleKeyDown
    });
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
"use client";
const $cacf5a31c84dd481$var$DEFAULT_EVENTS = [
    "mousedown",
    "touchstart"
];
function $cacf5a31c84dd481$export$1896bab46732d207(handler, events, nodes) {
    const ref = (0, $acw62.useRef)();
    (0, $acw62.useEffect)(()=>{
        const listener = (event)=>{
            const { target: target } = event != null ? event : {};
            if (Array.isArray(nodes)) {
                const shouldIgnore = (target == null ? void 0 : target.hasAttribute("data-ignore-outside-clicks")) || !document.body.contains(target) && target.tagName !== "HTML";
                const shouldTrigger = nodes.every((node)=>!!node && !event.composedPath().includes(node));
                shouldTrigger && !shouldIgnore && handler();
            } else if (ref.current && !ref.current.contains(target)) handler();
        };
        (events || $cacf5a31c84dd481$var$DEFAULT_EVENTS).forEach((fn)=>document.addEventListener(fn, listener));
        return ()=>{
            (events || $cacf5a31c84dd481$var$DEFAULT_EVENTS).forEach((fn)=>document.removeEventListener(fn, listener));
        };
    }, [
        ref,
        handler,
        nodes
    ]);
    return ref;
}



const $10310cf078d13212$export$832b6fa47fa053d2 = [
    "top",
    "right",
    "bottom",
    "left"
];
const $10310cf078d13212$export$27b07d8a310ed8b5 = [
    "start",
    "end"
];
const $10310cf078d13212$export$803cd8101b6c182b = /*#__PURE__*/ $10310cf078d13212$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $10310cf078d13212$export$27b07d8a310ed8b5[0], side + "-" + $10310cf078d13212$export$27b07d8a310ed8b5[1]), []);
const $10310cf078d13212$export$96ec731ed4dcb222 = Math.min;
const $10310cf078d13212$export$8960430cfd85939f = Math.max;
const $10310cf078d13212$export$2077e0241d6afd3c = Math.round;
const $10310cf078d13212$export$a3fe094919f356fd = Math.floor;
const $10310cf078d13212$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $10310cf078d13212$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
const $10310cf078d13212$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $10310cf078d13212$export$7d15b64cf5a3a4c4(start, value, end) {
    return $10310cf078d13212$export$8960430cfd85939f(start, $10310cf078d13212$export$96ec731ed4dcb222(value, end));
}
function $10310cf078d13212$export$fef61f332f2c0afc(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function $10310cf078d13212$export$3c915306cb7fc97a(placement) {
    return placement.split("-")[0];
}
function $10310cf078d13212$export$f0989780f32bfcda(placement) {
    return placement.split("-")[1];
}
function $10310cf078d13212$export$8a000a963141ac32(axis) {
    return axis === "x" ? "y" : "x";
}
function $10310cf078d13212$export$320bd9d53520c68a(axis) {
    return axis === "y" ? "height" : "width";
}
function $10310cf078d13212$export$f28e8f882010718a(placement) {
    return [
        "top",
        "bottom"
    ].includes($10310cf078d13212$export$3c915306cb7fc97a(placement)) ? "y" : "x";
}
function $10310cf078d13212$export$2b57e0052a6d6d4c(placement) {
    return $10310cf078d13212$export$8a000a963141ac32($10310cf078d13212$export$f28e8f882010718a(placement));
}
function $10310cf078d13212$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $10310cf078d13212$export$f0989780f32bfcda(placement);
    const alignmentAxis = $10310cf078d13212$export$2b57e0052a6d6d4c(placement);
    const length = $10310cf078d13212$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $10310cf078d13212$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $10310cf078d13212$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $10310cf078d13212$export$496432a3699e50b1(placement) {
    const oppositePlacement = $10310cf078d13212$export$9c5e28bad23365fa(placement);
    return [
        $10310cf078d13212$export$2b182c584985588b(placement),
        oppositePlacement,
        $10310cf078d13212$export$2b182c584985588b(oppositePlacement)
    ];
}
function $10310cf078d13212$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$10310cf078d13212$var$oppositeAlignmentMap[alignment]);
}
function $10310cf078d13212$var$getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $10310cf078d13212$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $10310cf078d13212$export$f0989780f32bfcda(placement);
    let list = $10310cf078d13212$var$getSideList($10310cf078d13212$export$3c915306cb7fc97a(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($10310cf078d13212$export$2b182c584985588b));
    }
    return list;
}
function $10310cf078d13212$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$10310cf078d13212$var$oppositeSideMap[side]);
}
function $10310cf078d13212$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $10310cf078d13212$export$598c291c29bc2e71(padding) {
    return typeof padding !== "number" ? $10310cf078d13212$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $10310cf078d13212$export$ee05aea0aeecbad4(rect) {
    return {
        ...rect,
        top: rect.y,
        left: rect.x,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    };
}


function $973e4da43f2a375d$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $10310cf078d13212$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $10310cf078d13212$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $10310cf078d13212$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $10310cf078d13212$export$f0989780f32bfcda)(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain positioning strategy.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $973e4da43f2a375d$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $973e4da43f2a375d$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $973e4da43f2a375d$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
            continue;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $973e4da43f2a375d$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = "clippingAncestors", rootBoundary: rootBoundary = "viewport", elementContext: elementContext = "floating", altBoundary: altBoundary = false, padding: padding = 0 } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $10310cf078d13212$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $10310cf078d13212$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? {
        ...rects.floating,
        x: x,
        y: y
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $10310cf078d13212$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $973e4da43f2a375d$export$f2120bbfa5450bd2 = (options)=>({
        name: "arrow",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $10310cf078d13212$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $10310cf078d13212$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $10310cf078d13212$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === "y";
            const minProp = isYAxis ? "top" : "left";
            const maxProp = isYAxis ? "bottom" : "right";
            const clientProp = isYAxis ? "clientHeight" : "clientWidth";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $10310cf078d13212$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $10310cf078d13212$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $10310cf078d13212$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $10310cf078d13212$export$f0989780f32bfcda)(placement) != null && center != offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $973e4da43f2a375d$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $10310cf078d13212$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $10310cf078d13212$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $10310cf078d13212$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $10310cf078d13212$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $10310cf078d13212$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $973e4da43f2a375d$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $10310cf078d13212$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $10310cf078d13212$export$803cd8101b6c182b) ? $973e4da43f2a375d$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $10310cf078d13212$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $10310cf078d13212$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $10310cf078d13212$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $10310cf078d13212$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $973e4da43f2a375d$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = "bestFit", fallbackAxisSideDirection: fallbackAxisSideDirection = "none", flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement);
            const isBasePlacement = (0, $10310cf078d13212$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $10310cf078d13212$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $10310cf078d13212$export$496432a3699e50b1)(initialPlacement));
            if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== "none") fallbackPlacements.push(...(0, $10310cf078d13212$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $10310cf078d13212$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$map$so;
                            const placement = (_overflowsData$map$so = overflowsData.map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $973e4da43f2a375d$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $973e4da43f2a375d$var$isAnySideFullyClipped(overflow) {
    return (0, $10310cf078d13212$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $973e4da43f2a375d$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = "referenceHidden", ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: "reference"
                        });
                        const offsets = $973e4da43f2a375d$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $973e4da43f2a375d$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $973e4da43f2a375d$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $973e4da43f2a375d$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $973e4da43f2a375d$var$getBoundingRect(rects) {
    const minX = (0, $10310cf078d13212$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $10310cf078d13212$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $10310cf078d13212$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $10310cf078d13212$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $973e4da43f2a375d$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $10310cf078d13212$export$ee05aea0aeecbad4)($973e4da43f2a375d$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $973e4da43f2a375d$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $973e4da43f2a375d$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $10310cf078d13212$export$ee05aea0aeecbad4)($973e4da43f2a375d$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $10310cf078d13212$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $10310cf078d13212$export$f28e8f882010718a)(placement) === "y") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement) === "left";
                    const maxRight = (0, $10310cf078d13212$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $10310cf078d13212$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $973e4da43f2a375d$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $10310cf078d13212$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $10310cf078d13212$export$f28e8f882010718a)(placement) === "y";
    const mainAxisMulti = [
        "left",
        "top"
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: 0,
        crossAxis: 0,
        alignmentAxis: null,
        ...rawValue
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $973e4da43f2a375d$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        async fn (state) {
            const { x: x, y: y } = state;
            const diffCoords = await $973e4da43f2a375d$var$convertValueToCoords(state, options);
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: diffCoords
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $973e4da43f2a375d$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $10310cf078d13212$export$f28e8f882010718a)((0, $10310cf078d13212$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $10310cf078d13212$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $10310cf078d13212$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $10310cf078d13212$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $973e4da43f2a375d$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $10310cf078d13212$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $10310cf078d13212$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $10310cf078d13212$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = [
                    "top",
                    "left"
                ].includes((0, $10310cf078d13212$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $973e4da43f2a375d$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        async fn (state) {
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $10310cf078d13212$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $10310cf078d13212$export$f28e8f882010718a)(placement) === "y";
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const overflowAvailableHeight = height - overflow[heightSide];
            const overflowAvailableWidth = width - overflow[widthSide];
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (isYAxis) {
                const maximumClippingWidth = width - overflow.left - overflow.right;
                availableWidth = alignment || noShift ? (0, $10310cf078d13212$export$96ec731ed4dcb222)(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
            } else {
                const maximumClippingHeight = height - overflow.top - overflow.bottom;
                availableHeight = alignment || noShift ? (0, $10310cf078d13212$export$96ec731ed4dcb222)(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
            }
            if (noShift && !alignment) {
                const xMin = (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $071542918b64c1f1$export$651544f548703224(node) {
    if ($071542918b64c1f1$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || "").toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return "#document";
}
function $071542918b64c1f1$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null ? void 0 : (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $071542918b64c1f1$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($071542918b64c1f1$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $071542918b64c1f1$export$8ee0fc9ee280b4ee(value) {
    return value instanceof Node || value instanceof $071542918b64c1f1$export$38b2d434cce3ea22(value).Node;
}
function $071542918b64c1f1$export$45a5e7f76e0caa8d(value) {
    return value instanceof Element || value instanceof $071542918b64c1f1$export$38b2d434cce3ea22(value).Element;
}
function $071542918b64c1f1$export$1b3bfaa9684536aa(value) {
    return value instanceof HTMLElement || value instanceof $071542918b64c1f1$export$38b2d434cce3ea22(value).HTMLElement;
}
function $071542918b64c1f1$export$af51f0f06c0f328a(value) {
    // Browsers without `ShadowRoot` support.
    if (typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof $071542918b64c1f1$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $071542918b64c1f1$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $071542918b64c1f1$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function $071542918b64c1f1$export$71535ffaa902797f(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($071542918b64c1f1$export$651544f548703224(element));
}
function $071542918b64c1f1$export$d6c4e8150c35fed1(element) {
    const webkit = $071542918b64c1f1$export$78551043582a6a98();
    const css = $071542918b64c1f1$export$3735103072e4a80(element);
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective",
        "filter"
    ].some((value)=>(css.willChange || "").includes(value)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((value)=>(css.contain || "").includes(value));
}
function $071542918b64c1f1$export$940d8225183e1404(element) {
    let currentNode = $071542918b64c1f1$export$4e12058fc4d51d56(element);
    while($071542918b64c1f1$export$1b3bfaa9684536aa(currentNode) && !$071542918b64c1f1$export$d1162fb0b6d4cd51(currentNode)){
        if ($071542918b64c1f1$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else currentNode = $071542918b64c1f1$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $071542918b64c1f1$export$78551043582a6a98() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function $071542918b64c1f1$export$d1162fb0b6d4cd51(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($071542918b64c1f1$export$651544f548703224(node));
}
function $071542918b64c1f1$export$3735103072e4a80(element) {
    return $071542918b64c1f1$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $071542918b64c1f1$export$dc8fc79fa2800137(element) {
    if ($071542918b64c1f1$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.pageXOffset,
        scrollTop: element.pageYOffset
    };
}
function $071542918b64c1f1$export$4e12058fc4d51d56(node) {
    if ($071542918b64c1f1$export$651544f548703224(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $071542918b64c1f1$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $071542918b64c1f1$export$e495491855dc5418(node);
    return $071542918b64c1f1$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $071542918b64c1f1$export$7cd01a57c8ca906c(node) {
    const parentNode = $071542918b64c1f1$export$4e12058fc4d51d56(node);
    if ($071542918b64c1f1$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($071542918b64c1f1$export$1b3bfaa9684536aa(parentNode) && $071542918b64c1f1$export$989e911fa9af580a(parentNode)) return parentNode;
    return $071542918b64c1f1$export$7cd01a57c8ca906c(parentNode);
}
function $071542918b64c1f1$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $071542918b64c1f1$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $071542918b64c1f1$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) return list.concat(win, win.visualViewport || [], $071542918b64c1f1$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], win.frameElement && traverseIframes ? $071542918b64c1f1$export$3b57c1601291186b(win.frameElement) : []);
    return list.concat(scrollableAncestor, $071542918b64c1f1$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}


function $461947879dcdbcd4$var$getCssDimensions(element) {
    const css = (0, $071542918b64c1f1$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $071542918b64c1f1$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $10310cf078d13212$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $10310cf078d13212$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $461947879dcdbcd4$var$unwrapElement(element) {
    return !(0, $071542918b64c1f1$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $461947879dcdbcd4$var$getScale(element) {
    const domElement = $461947879dcdbcd4$var$unwrapElement(element);
    if (!(0, $071542918b64c1f1$export$1b3bfaa9684536aa)(domElement)) return (0, $10310cf078d13212$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $461947879dcdbcd4$var$getCssDimensions(domElement);
    let x = ($ ? (0, $10310cf078d13212$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $10310cf078d13212$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $461947879dcdbcd4$var$noOffsets = /*#__PURE__*/ (0, $10310cf078d13212$export$a397704b5e280835)(0);
function $461947879dcdbcd4$var$getVisualOffsets(element) {
    const win = (0, $071542918b64c1f1$export$38b2d434cce3ea22)(element);
    if (!(0, $071542918b64c1f1$export$78551043582a6a98)() || !win.visualViewport) return $461947879dcdbcd4$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $461947879dcdbcd4$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $071542918b64c1f1$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $461947879dcdbcd4$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $461947879dcdbcd4$var$unwrapElement(element);
    let scale = (0, $10310cf078d13212$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $071542918b64c1f1$export$45a5e7f76e0caa8d)(offsetParent)) scale = $461947879dcdbcd4$var$getScale(offsetParent);
        } else scale = $461947879dcdbcd4$var$getScale(element);
    }
    const visualOffsets = $461947879dcdbcd4$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $461947879dcdbcd4$var$getVisualOffsets(domElement) : (0, $10310cf078d13212$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $071542918b64c1f1$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $071542918b64c1f1$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $071542918b64c1f1$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentIFrame = win.frameElement;
        while(currentIFrame && offsetParent && offsetWin !== win){
            const iframeScale = $461947879dcdbcd4$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $071542918b64c1f1$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentIFrame = (0, $071542918b64c1f1$export$38b2d434cce3ea22)(currentIFrame).frameElement;
        }
    }
    return (0, $10310cf078d13212$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
function $461947879dcdbcd4$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isOffsetParentAnElement = (0, $071542918b64c1f1$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $071542918b64c1f1$export$e495491855dc5418)(offsetParent);
    if (offsetParent === documentElement) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $10310cf078d13212$export$a397704b5e280835)(1);
    const offsets = (0, $10310cf078d13212$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== "fixed") {
        if ((0, $071542918b64c1f1$export$651544f548703224)(offsetParent) !== "body" || (0, $071542918b64c1f1$export$989e911fa9af580a)(documentElement)) scroll = (0, $071542918b64c1f1$export$dc8fc79fa2800137)(offsetParent);
        if ((0, $071542918b64c1f1$export$1b3bfaa9684536aa)(offsetParent)) {
            const offsetRect = $461947879dcdbcd4$var$getBoundingClientRect(offsetParent);
            scale = $461947879dcdbcd4$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $461947879dcdbcd4$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
function $461947879dcdbcd4$var$getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    return $461947879dcdbcd4$var$getBoundingClientRect((0, $071542918b64c1f1$export$e495491855dc5418)(element)).left + (0, $071542918b64c1f1$export$dc8fc79fa2800137)(element).scrollLeft;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $461947879dcdbcd4$var$getDocumentRect(element) {
    const html = (0, $071542918b64c1f1$export$e495491855dc5418)(element);
    const scroll = (0, $071542918b64c1f1$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $10310cf078d13212$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $10310cf078d13212$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $461947879dcdbcd4$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $071542918b64c1f1$export$3735103072e4a80)(body).direction === "rtl") x += (0, $10310cf078d13212$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $461947879dcdbcd4$var$getViewportRect(element, strategy) {
    const win = (0, $071542918b64c1f1$export$38b2d434cce3ea22)(element);
    const html = (0, $071542918b64c1f1$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $071542918b64c1f1$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $461947879dcdbcd4$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $461947879dcdbcd4$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $071542918b64c1f1$export$1b3bfaa9684536aa)(element) ? $461947879dcdbcd4$var$getScale(element) : (0, $10310cf078d13212$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = $461947879dcdbcd4$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $461947879dcdbcd4$var$getDocumentRect((0, $071542918b64c1f1$export$e495491855dc5418)(element));
    else if ((0, $071542918b64c1f1$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $461947879dcdbcd4$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $461947879dcdbcd4$var$getVisualOffsets(element);
        rect = {
            ...clippingAncestor,
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        };
    }
    return (0, $10310cf078d13212$export$ee05aea0aeecbad4)(rect);
}
function $461947879dcdbcd4$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $071542918b64c1f1$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $071542918b64c1f1$export$45a5e7f76e0caa8d)(parentNode) || (0, $071542918b64c1f1$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $071542918b64c1f1$export$3735103072e4a80)(parentNode).position === "fixed" || $461947879dcdbcd4$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $461947879dcdbcd4$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $071542918b64c1f1$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $071542918b64c1f1$export$45a5e7f76e0caa8d)(el) && (0, $071542918b64c1f1$export$651544f548703224)(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $071542918b64c1f1$export$3735103072e4a80)(element).position === "fixed";
    let currentNode = elementIsFixed ? (0, $071542918b64c1f1$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $071542918b64c1f1$export$45a5e7f76e0caa8d)(currentNode) && !(0, $071542918b64c1f1$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $071542918b64c1f1$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $071542918b64c1f1$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || (0, $071542918b64c1f1$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $461947879dcdbcd4$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $071542918b64c1f1$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $461947879dcdbcd4$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? $461947879dcdbcd4$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $10310cf078d13212$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $10310cf078d13212$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $10310cf078d13212$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $10310cf078d13212$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $461947879dcdbcd4$var$getDimensions(element) {
    return $461947879dcdbcd4$var$getCssDimensions(element);
}
function $461947879dcdbcd4$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $071542918b64c1f1$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $071542918b64c1f1$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = $461947879dcdbcd4$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $10310cf078d13212$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $071542918b64c1f1$export$651544f548703224)(offsetParent) !== "body" || (0, $071542918b64c1f1$export$989e911fa9af580a)(documentElement)) scroll = (0, $071542918b64c1f1$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $461947879dcdbcd4$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = $461947879dcdbcd4$var$getWindowScrollBarX(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}
function $461947879dcdbcd4$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $071542918b64c1f1$export$1b3bfaa9684536aa)(element) || (0, $071542918b64c1f1$export$3735103072e4a80)(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    return element.offsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $461947879dcdbcd4$var$getOffsetParent(element, polyfill) {
    const window = (0, $071542918b64c1f1$export$38b2d434cce3ea22)(element);
    if (!(0, $071542918b64c1f1$export$1b3bfaa9684536aa)(element)) return window;
    let offsetParent = $461947879dcdbcd4$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $071542918b64c1f1$export$71535ffaa902797f)(offsetParent) && (0, $071542918b64c1f1$export$3735103072e4a80)(offsetParent).position === "static")offsetParent = $461947879dcdbcd4$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && ((0, $071542918b64c1f1$export$651544f548703224)(offsetParent) === "html" || (0, $071542918b64c1f1$export$651544f548703224)(offsetParent) === "body" && (0, $071542918b64c1f1$export$3735103072e4a80)(offsetParent).position === "static" && !(0, $071542918b64c1f1$export$d6c4e8150c35fed1)(offsetParent))) return window;
    return offsetParent || (0, $071542918b64c1f1$export$940d8225183e1404)(element) || window;
}
const $461947879dcdbcd4$var$getElementRects = async function(_ref) {
    let { reference: reference, floating: floating, strategy: strategy } = _ref;
    const getOffsetParentFn = this.getOffsetParent || $461947879dcdbcd4$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    return {
        reference: $461947879dcdbcd4$var$getRectRelativeToOffsetParent(reference, await getOffsetParentFn(floating), strategy),
        floating: {
            x: 0,
            y: 0,
            ...await getDimensionsFn(floating)
        }
    };
};
function $461947879dcdbcd4$var$isRTL(element) {
    return (0, $071542918b64c1f1$export$3735103072e4a80)(element).direction === "rtl";
}
const $461947879dcdbcd4$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $461947879dcdbcd4$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $071542918b64c1f1$export$e495491855dc5418,
    getClippingRect: $461947879dcdbcd4$var$getClippingRect,
    getOffsetParent: $461947879dcdbcd4$var$getOffsetParent,
    getElementRects: $461947879dcdbcd4$var$getElementRects,
    getClientRects: $461947879dcdbcd4$var$getClientRects,
    getDimensions: $461947879dcdbcd4$var$getDimensions,
    getScale: $461947879dcdbcd4$var$getScale,
    isElement: $071542918b64c1f1$export$45a5e7f76e0caa8d,
    isRTL: $461947879dcdbcd4$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $461947879dcdbcd4$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $071542918b64c1f1$export$e495491855dc5418)(element);
    function cleanup() {
        clearTimeout(timeoutId);
        io && io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $10310cf078d13212$export$a3fe094919f356fd)(top);
        const insetRight = (0, $10310cf078d13212$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $10310cf078d13212$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $10310cf078d13212$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $10310cf078d13212$export$8960430cfd85939f)(0, (0, $10310cf078d13212$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 100);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $461947879dcdbcd4$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === "function", layoutShift: layoutShift = typeof IntersectionObserver === "function", animationFrame: animationFrame = false } = options;
    const referenceEl = $461947879dcdbcd4$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $071542918b64c1f1$export$3b57c1601291186b)(referenceEl) : [],
        ...(0, $071542918b64c1f1$export$3b57c1601291186b)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    const cleanupIo = referenceEl && layoutShift ? $461947879dcdbcd4$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    resizeObserver && resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $461947879dcdbcd4$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $461947879dcdbcd4$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo && cleanupIo();
        resizeObserver && resizeObserver.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain CSS positioning
 * strategy.
 */ const $461947879dcdbcd4$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $461947879dcdbcd4$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $973e4da43f2a375d$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



var $acw62 = parcelRequire("acw62");

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $23a8f689f1d4c3be$export$f2120bbfa5450bd2 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, "current");
    }
    return {
        name: "arrow",
        options: options,
        fn (state) {
            const { element: element, padding: padding } = typeof options === "function" ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, $973e4da43f2a375d$export$f2120bbfa5450bd2)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            } else if (element) return (0, $973e4da43f2a375d$export$f2120bbfa5450bd2)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
var $23a8f689f1d4c3be$var$index = typeof document !== "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $23a8f689f1d4c3be$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === "function" && a.toString() === b.toString()) return true;
    let length, i, keys;
    if (a && b && typeof a == "object") {
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$23a8f689f1d4c3be$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === "_owner" && a.$$typeof) continue;
            if (!$23a8f689f1d4c3be$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $23a8f689f1d4c3be$var$getDPR(element) {
    if (typeof window === "undefined") return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $23a8f689f1d4c3be$var$roundByDPR(element, value) {
    const dpr = $23a8f689f1d4c3be$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $23a8f689f1d4c3be$var$useLatestRef(value) {
    const ref = $acw62.useRef(value);
    $23a8f689f1d4c3be$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/react
 */ function $23a8f689f1d4c3be$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform, elements: { reference: externalReference, floating: externalFloating } = {}, transform: transform = true, whileElementsMounted: whileElementsMounted, open: open } = options;
    const [data, setData] = $acw62.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = $acw62.useState(middleware);
    if (!$23a8f689f1d4c3be$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = $acw62.useState(null);
    const [_floating, _setFloating] = $acw62.useState(null);
    const setReference = $acw62.useCallback((node)=>{
        if (node != referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, [
        _setReference
    ]);
    const setFloating = $acw62.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, [
        _setFloating
    ]);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = $acw62.useRef(null);
    const floatingRef = $acw62.useRef(null);
    const dataRef = $acw62.useRef(data);
    const whileElementsMountedRef = $23a8f689f1d4c3be$var$useLatestRef(whileElementsMounted);
    const platformRef = $23a8f689f1d4c3be$var$useLatestRef(platform);
    const update = $acw62.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $461947879dcdbcd4$export$48a53dcb22e581d0)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                isPositioned: true
            };
            if (isMountedRef.current && !$23a8f689f1d4c3be$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $11492dca620dcaa5$exports.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef
    ]);
    $23a8f689f1d4c3be$var$index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = $acw62.useRef(false);
    $23a8f689f1d4c3be$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    $23a8f689f1d4c3be$var$index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            else update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef
    ]);
    const refs = $acw62.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = $acw62.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = $acw62.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = $23a8f689f1d4c3be$var$roundByDPR(elements.floating, data.x);
        const y = $23a8f689f1d4c3be$var$roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...$23a8f689f1d4c3be$var$getDPR(elements.floating) >= 1.5 && {
                willChange: "transform"
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return $acw62.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}



var $acw62 = parcelRequire("acw62");
var $4a7537e072260c10$var$getDefaultParent = function(originalTarget) {
    if (typeof document === "undefined") return null;
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var $4a7537e072260c10$var$counterMap = new WeakMap();
var $4a7537e072260c10$var$uncontrolledNodes = new WeakMap();
var $4a7537e072260c10$var$markerMap = {};
var $4a7537e072260c10$var$lockCount = 0;
var $4a7537e072260c10$var$unwrapHost = function(node) {
    return node && (node.host || $4a7537e072260c10$var$unwrapHost(node.parentNode));
};
var $4a7537e072260c10$var$correctTargets = function(parent, targets) {
    return targets.map(function(target) {
        if (parent.contains(target)) return target;
        var correctedTarget = $4a7537e072260c10$var$unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) return correctedTarget;
        console.error("aria-hidden", target, "in not contained inside", parent, ". Doing nothing");
        return null;
    }).filter(function(x) {
        return Boolean(x);
    });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */ var $4a7537e072260c10$var$applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
    var targets = $4a7537e072260c10$var$correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    if (!$4a7537e072260c10$var$markerMap[markerName]) $4a7537e072260c10$var$markerMap[markerName] = new WeakMap();
    var markerCounter = $4a7537e072260c10$var$markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        Array.prototype.forEach.call(parent.children, function(node) {
            if (elementsToKeep.has(node)) deep(node);
            else {
                var attr = node.getAttribute(controlAttribute);
                var alreadyHidden = attr !== null && attr !== "false";
                var counterValue = ($4a7537e072260c10$var$counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                $4a7537e072260c10$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenNodes.push(node);
                if (counterValue === 1 && alreadyHidden) $4a7537e072260c10$var$uncontrolledNodes.set(node, true);
                if (markerValue === 1) node.setAttribute(markerName, "true");
                if (!alreadyHidden) node.setAttribute(controlAttribute, "true");
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    $4a7537e072260c10$var$lockCount++;
    return function() {
        hiddenNodes.forEach(function(node) {
            var counterValue = $4a7537e072260c10$var$counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            $4a7537e072260c10$var$counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!$4a7537e072260c10$var$uncontrolledNodes.has(node)) node.removeAttribute(controlAttribute);
                $4a7537e072260c10$var$uncontrolledNodes.delete(node);
            }
            if (!markerValue) node.removeAttribute(markerName);
        });
        $4a7537e072260c10$var$lockCount--;
        if (!$4a7537e072260c10$var$lockCount) {
            // clear
            $4a7537e072260c10$var$counterMap = new WeakMap();
            $4a7537e072260c10$var$counterMap = new WeakMap();
            $4a7537e072260c10$var$uncontrolledNodes = new WeakMap();
            $4a7537e072260c10$var$markerMap = {};
        }
    };
};
var $4a7537e072260c10$export$6e33d16126ed003c = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-aria-hidden";
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    var activeParentNode = parentNode || $4a7537e072260c10$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    // we should not hide ariaLive elements - https://github.com/theKashey/aria-hidden/issues/10
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll("[aria-live]")));
    return $4a7537e072260c10$var$applyAttributeToOthers(targets, activeParentNode, markerName, "aria-hidden");
};
var $4a7537e072260c10$export$59151cc8db999a24 = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-inert-ed";
    var activeParentNode = parentNode || $4a7537e072260c10$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    return $4a7537e072260c10$var$applyAttributeToOthers(originalTarget, activeParentNode, markerName, "inert");
};
var $4a7537e072260c10$export$cc95fea82d705fca = function() {
    return typeof HTMLElement !== "undefined" && HTMLElement.prototype.hasOwnProperty("inert");
};
var $4a7537e072260c10$export$9845d4b6bdad192b = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-suppressed";
    return ($4a7537e072260c10$export$cc95fea82d705fca() ? $4a7537e072260c10$export$59151cc8db999a24 : $4a7537e072260c10$export$6e33d16126ed003c)(originalTarget, parentNode, markerName);
};


/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/ // NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
// CAREFUL: JSDom does not support `:not([inert] *)` as a selector; using it causes
//  the entire query to fail, resulting in no nodes found, which will break a lot
//  of things... so we have to rely on JS to identify nodes inside an inert container
var $a4b3b7902c9a987d$var$candidateSelectors = [
    "input:not([inert])",
    "select:not([inert])",
    "textarea:not([inert])",
    "a[href]:not([inert])",
    "button:not([inert])",
    "[tabindex]:not(slot):not([inert])",
    "audio[controls]:not([inert])",
    "video[controls]:not([inert])",
    '[contenteditable]:not([contenteditable="false"]):not([inert])',
    "details>summary:first-of-type:not([inert])",
    "details:not([inert])"
];
var $a4b3b7902c9a987d$var$candidateSelector = /* #__PURE__ */ $a4b3b7902c9a987d$var$candidateSelectors.join(",");
var $a4b3b7902c9a987d$var$NoElement = typeof Element === "undefined";
var $a4b3b7902c9a987d$var$matches = $a4b3b7902c9a987d$var$NoElement ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var $a4b3b7902c9a987d$var$getRootNode = !$a4b3b7902c9a987d$var$NoElement && Element.prototype.getRootNode ? function(element) {
    var _element$getRootNode;
    return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function(element) {
    return element === null || element === void 0 ? void 0 : element.ownerDocument;
};
/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Element} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */ var $a4b3b7902c9a987d$var$isInert = function isInert(node, lookUp) {
    var _node$getAttribute;
    if (lookUp === void 0) lookUp = true;
    // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
    //  JS API property; we have to check the attribute, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's an active element
    var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, "inert");
    var inert = inertAtt === "" || inertAtt === "true";
    // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
    //  if it weren't for `matches()` not being a function on shadow roots; the following
    //  code works for any kind of node
    // CAREFUL: JSDom does not appear to support certain selectors like `:not([inert] *)`
    //  so it likely would not support `:is([inert] *)` either...
    var result = inert || lookUp && node && isInert(node.parentNode); // recursive
    return result;
};
/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */ var $a4b3b7902c9a987d$var$isContentEditable = function isContentEditable(node) {
    var _node$getAttribute2;
    // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
    //  to use the attribute directly to check for this, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's a non-editable element
    var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, "contenteditable");
    return attValue === "" || attValue === "true";
};
/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */ var $a4b3b7902c9a987d$var$getCandidates = function getCandidates(el, includeContainer, filter) {
    // even if `includeContainer=false`, we still have to check it for inertness because
    //  if it's inert, all its children are inert
    if ($a4b3b7902c9a987d$var$isInert(el)) return [];
    var candidates = Array.prototype.slice.apply(el.querySelectorAll($a4b3b7902c9a987d$var$candidateSelector));
    if (includeContainer && $a4b3b7902c9a987d$var$matches.call(el, $a4b3b7902c9a987d$var$candidateSelector)) candidates.unshift(el);
    candidates = candidates.filter(filter);
    return candidates;
};
/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */ /**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */ /**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */ /**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */ /**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */ var $a4b3b7902c9a987d$var$getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while(elementsToCheck.length){
        var element = elementsToCheck.shift();
        if ($a4b3b7902c9a987d$var$isInert(element, false)) continue;
        if (element.tagName === "SLOT") {
            // add shadow dom slot scope (slot itself cannot be focusable)
            var assigned = element.assignedElements();
            var content = assigned.length ? assigned : element.children;
            var nestedCandidates = getCandidatesIteratively(content, true, options);
            if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
            else candidates.push({
                scopeParent: element,
                candidates: nestedCandidates
            });
        } else {
            // check candidate element
            var validCandidate = $a4b3b7902c9a987d$var$matches.call(element, $a4b3b7902c9a987d$var$candidateSelector);
            if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
            // iterate over shadow content if possible
            var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
            typeof options.getShadowRoot === "function" && options.getShadowRoot(element);
            // no inert look up because we're already drilling down and checking for inertness
            //  on the way down, so all containers to this root node should have already been
            //  vetted as non-inert
            var validShadowRoot = !$a4b3b7902c9a987d$var$isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
            if (shadowRoot && validShadowRoot) {
                // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
                //  shadow exists, so look at light dom children as fallback BUT create a scope for any
                //  child candidates found because they're likely slotted elements (elements that are
                //  children of the web component element (which has the shadow), in the light dom, but
                //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
                //  _after_ we return from this recursive call
                var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                else candidates.push({
                    scopeParent: element,
                    candidates: _nestedCandidates
                });
            } else // there's not shadow so just dig into the element's (light dom) children
            //  __without__ giving the element special scope treatment
            elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
    }
    return candidates;
};
/**
 * @private
 * Determines if the node has an explicitly specified `tabindex` attribute.
 * @param {HTMLElement} node
 * @returns {boolean} True if so; false if not.
 */ var $a4b3b7902c9a987d$var$hasTabIndex = function hasTabIndex(node) {
    return !isNaN(parseInt(node.getAttribute("tabindex"), 10));
};
/**
 * Determine the tab index of a given node.
 * @param {HTMLElement} node
 * @returns {number} Tab order (negative, 0, or positive number).
 * @throws {Error} If `node` is falsy.
 */ var $a4b3b7902c9a987d$export$a4672efddb4181b8 = function getTabIndex(node) {
    if (!node) throw new Error("No node provided");
    if (node.tabIndex < 0) {
        // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
        // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
        // yet they are still part of the regular tab order; in FF, they get a default
        // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
        // order, consider their tab index to be 0.
        // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
        // so if they don't have a tabindex attribute specifically set, assume it's 0.
        if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || $a4b3b7902c9a987d$var$isContentEditable(node)) && !$a4b3b7902c9a987d$var$hasTabIndex(node)) return 0;
    }
    return node.tabIndex;
};
/**
 * Determine the tab index of a given node __for sort order purposes__.
 * @param {HTMLElement} node
 * @param {boolean} [isScope] True for a custom element with shadow root or slot that, by default,
 *  has tabIndex -1, but needs to be sorted by document order in order for its content to be
 *  inserted into the correct sort position.
 * @returns {number} Tab order (negative, 0, or positive number).
 */ var $a4b3b7902c9a987d$var$getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
    var tabIndex = $a4b3b7902c9a987d$export$a4672efddb4181b8(node);
    if (tabIndex < 0 && isScope && !$a4b3b7902c9a987d$var$hasTabIndex(node)) return 0;
    return tabIndex;
};
var $a4b3b7902c9a987d$var$sortOrderedTabbables = function sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var $a4b3b7902c9a987d$var$isInput = function isInput(node) {
    return node.tagName === "INPUT";
};
var $a4b3b7902c9a987d$var$isHiddenInput = function isHiddenInput(node) {
    return $a4b3b7902c9a987d$var$isInput(node) && node.type === "hidden";
};
var $a4b3b7902c9a987d$var$isDetailsWithSummary = function isDetailsWithSummary(node) {
    var r = node.tagName === "DETAILS" && Array.prototype.slice.apply(node.children).some(function(child) {
        return child.tagName === "SUMMARY";
    });
    return r;
};
var $a4b3b7902c9a987d$var$getCheckedRadio = function getCheckedRadio(nodes, form) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked && nodes[i].form === form) return nodes[i];
    }
};
var $a4b3b7902c9a987d$var$isTabbableRadio = function isTabbableRadio(node) {
    if (!node.name) return true;
    var radioScope = node.form || $a4b3b7902c9a987d$var$getRootNode(node);
    var queryRadios = function queryRadios(name) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== "undefined" && typeof window.CSS !== "undefined" && typeof window.CSS.escape === "function") radioSet = queryRadios(window.CSS.escape(node.name));
    else try {
        radioSet = queryRadios(node.name);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", err.message);
        return false;
    }
    var checked = $a4b3b7902c9a987d$var$getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
};
var $a4b3b7902c9a987d$var$isRadio = function isRadio(node) {
    return $a4b3b7902c9a987d$var$isInput(node) && node.type === "radio";
};
var $a4b3b7902c9a987d$var$isNonTabbableRadio = function isNonTabbableRadio(node) {
    return $a4b3b7902c9a987d$var$isRadio(node) && !$a4b3b7902c9a987d$var$isTabbableRadio(node);
};
// determines if a node is ultimately attached to the window's document
var $a4b3b7902c9a987d$var$isNodeAttached = function isNodeAttached(node) {
    var _nodeRoot;
    // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
    //  (but NOT _the_ document; see second 'If' comment below for more).
    // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
    //  is attached, and the one we need to check if it's in the document or not (because the
    //  shadow, and all nodes it contains, is never considered in the document since shadows
    //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
    //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
    //  visibility, including all the nodes it contains). The host could be any normal node,
    //  or a custom element (i.e. web component). Either way, that's the one that is considered
    //  part of the document, not the shadow root, nor any of its children (i.e. the node being
    //  tested).
    // To further complicate things, we have to look all the way up until we find a shadow HOST
    //  that is attached (or find none) because the node might be in nested shadows...
    // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
    //  document (per the docs) and while it's a Document-type object, that document does not
    //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
    //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
    //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
    //  node is actually detached.
    // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
    //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
    //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
    //  `ownerDocument` will be `null`, hence the optional chaining on it.
    var nodeRoot = node && $a4b3b7902c9a987d$var$getRootNode(node);
    var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
    // in some cases, a detached node will return itself as the root instead of a document or
    //  shadow root object, in which case, we shouldn't try to look further up the host chain
    var attached = false;
    if (nodeRoot && nodeRoot !== node) {
        var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
        attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
        while(!attached && nodeRootHost){
            var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
            // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
            //  which means we need to get the host's host and check if that parent host is contained
            //  in (i.e. attached to) the document
            nodeRoot = $a4b3b7902c9a987d$var$getRootNode(nodeRootHost);
            nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
            attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
        }
    }
    return attached;
};
var $a4b3b7902c9a987d$var$isZeroArea = function isZeroArea(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
};
var $a4b3b7902c9a987d$var$isHidden = function isHidden(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    // NOTE: visibility will be `undefined` if node is detached from the document
    //  (see notes about this further down), which means we will consider it visible
    //  (this is legacy behavior from a very long way back)
    // NOTE: we check this regardless of `displayCheck="none"` because this is a
    //  _visibility_ check, not a _display_ check
    if (getComputedStyle(node).visibility === "hidden") return true;
    var isDirectSummary = $a4b3b7902c9a987d$var$matches.call(node, "details>summary:first-of-type");
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if ($a4b3b7902c9a987d$var$matches.call(nodeUnderDetails, "details:not([open]) *")) return true;
    if (!displayCheck || displayCheck === "full" || displayCheck === "legacy-full") {
        if (typeof getShadowRoot === "function") {
            // figure out if we should consider the node to be in an undisclosed shadow and use the
            //  'non-zero-area' fallback
            var originalNode = node;
            while(node){
                var parentElement = node.parentElement;
                var rootNode = $a4b3b7902c9a987d$var$getRootNode(node);
                if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
                ) // node has an undisclosed shadow which means we can only treat it as a black box, so we
                //  fall back to a non-zero-area test
                return $a4b3b7902c9a987d$var$isZeroArea(node);
                else if (node.assignedSlot) // iterate up slot
                node = node.assignedSlot;
                else if (!parentElement && rootNode !== node.ownerDocument) // cross shadow boundary
                node = rootNode.host;
                else // iterate up normal dom
                node = parentElement;
            }
            node = originalNode;
        }
        // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
        //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
        //  it might be a falsy value, which means shadow DOM support is disabled
        // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
        //  now we can just test to see if it would normally be visible or not, provided it's
        //  attached to the main document.
        // NOTE: We must consider case where node is inside a shadow DOM and given directly to
        //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.
        if ($a4b3b7902c9a987d$var$isNodeAttached(node)) // this works wherever the node is: if there's at least one client rect, it's
        //  somehow displayed; it also covers the CSS 'display: contents' case where the
        //  node itself is hidden in place of its contents; and there's no need to search
        //  up the hierarchy either
        return !node.getClientRects().length;
        // Else, the node isn't attached to the document, which means the `getClientRects()`
        //  API will __always__ return zero rects (this can happen, for example, if React
        //  is used to render nodes onto a detached tree, as confirmed in this thread:
        //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
        //
        // It also means that even window.getComputedStyle(node).display will return `undefined`
        //  because styles are only computed for nodes that are in the document.
        //
        // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
        //  somehow. Though it was never stated officially, anyone who has ever used tabbable
        //  APIs on nodes in detached containers has actually implicitly used tabbable in what
        //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
        //  considering __everything__ to be visible because of the innability to determine styles.
        //
        // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
        //  nodes as visible with the 'none' fallback.__
        if (displayCheck !== "legacy-full") return true; // hidden
    // else, fallback to 'none' mode and consider the node visible
    } else if (displayCheck === "non-zero-area") // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return $a4b3b7902c9a987d$var$isZeroArea(node);
    // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
    //  it's visible
    return false;
};
// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var $a4b3b7902c9a987d$var$isDisabledFromFieldset = function isDisabledFromFieldset(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
        var parentNode = node.parentElement;
        // check if `node` is contained in a disabled <fieldset>
        while(parentNode){
            if (parentNode.tagName === "FIELDSET" && parentNode.disabled) {
                // look for the first <legend> among the children of the disabled <fieldset>
                for(var i = 0; i < parentNode.children.length; i++){
                    var child = parentNode.children.item(i);
                    // when the first <legend> (in document order) is found
                    if (child.tagName === "LEGEND") // if its parent <fieldset> is not nested in another disabled <fieldset>,
                    // return whether `node` is a descendant of its first <legend>
                    return $a4b3b7902c9a987d$var$matches.call(parentNode, "fieldset[disabled] *") ? true : !child.contains(node);
                }
                // the disabled <fieldset> containing `node` has no <legend>
                return true;
            }
            parentNode = parentNode.parentElement;
        }
    }
    // else, node's tabbable/focusable state should not be affected by a fieldset's
    //  enabled/disabled state
    return false;
};
var $a4b3b7902c9a987d$var$isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
    if (node.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
    //  because we're limited in the type of selectors we can use in JSDom (see related
    //  note related to `candidateSelectors`)
    $a4b3b7902c9a987d$var$isInert(node) || $a4b3b7902c9a987d$var$isHiddenInput(node) || $a4b3b7902c9a987d$var$isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    $a4b3b7902c9a987d$var$isDetailsWithSummary(node) || $a4b3b7902c9a987d$var$isDisabledFromFieldset(node)) return false;
    return true;
};
var $a4b3b7902c9a987d$var$isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
    if ($a4b3b7902c9a987d$var$isNonTabbableRadio(node) || $a4b3b7902c9a987d$export$a4672efddb4181b8(node) < 0 || !$a4b3b7902c9a987d$var$isNodeMatchingSelectorFocusable(options, node)) return false;
    return true;
};
var $a4b3b7902c9a987d$var$isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute("tabindex"), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) return true;
    // If a custom element has an explicit negative tabindex,
    // browsers will not allow tab targeting said element's children.
    return false;
};
/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */ var $a4b3b7902c9a987d$var$sortByOrder = function sortByOrder(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item, i) {
        var isScope = !!item.scopeParent;
        var element = isScope ? item.scopeParent : item;
        var candidateTabindex = $a4b3b7902c9a987d$var$getSortOrderTabIndex(element, isScope);
        var elements = isScope ? sortByOrder(item.candidates) : element;
        if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            item: item,
            isScope: isScope,
            content: elements
        });
    });
    return orderedTabbables.sort($a4b3b7902c9a987d$var$sortOrderedTabbables).reduce(function(acc, sortable) {
        sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
        return acc;
    }, []).concat(regularTabbables);
};
var $a4b3b7902c9a987d$export$17100aea90429aa7 = function tabbable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $a4b3b7902c9a987d$var$getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $a4b3b7902c9a987d$var$isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: $a4b3b7902c9a987d$var$isValidShadowRootTabbable
    });
    else candidates = $a4b3b7902c9a987d$var$getCandidates(container, options.includeContainer, $a4b3b7902c9a987d$var$isNodeMatchingSelectorTabbable.bind(null, options));
    return $a4b3b7902c9a987d$var$sortByOrder(candidates);
};
var $a4b3b7902c9a987d$export$ecc6d1fcdff4f700 = function focusable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $a4b3b7902c9a987d$var$getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $a4b3b7902c9a987d$var$isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
    });
    else candidates = $a4b3b7902c9a987d$var$getCandidates(container, options.includeContainer, $a4b3b7902c9a987d$var$isNodeMatchingSelectorFocusable.bind(null, options));
    return candidates;
};
var $a4b3b7902c9a987d$export$bebd5a1431fec25d = function isTabbable(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if ($a4b3b7902c9a987d$var$matches.call(node, $a4b3b7902c9a987d$var$candidateSelector) === false) return false;
    return $a4b3b7902c9a987d$var$isNodeMatchingSelectorTabbable(options, node);
};
var $a4b3b7902c9a987d$var$focusableCandidateSelector = /* #__PURE__ */ $a4b3b7902c9a987d$var$candidateSelectors.concat("iframe").join(",");
var $a4b3b7902c9a987d$export$4c063cf1350e6fed = function isFocusable(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if ($a4b3b7902c9a987d$var$matches.call(node, $a4b3b7902c9a987d$var$focusableCandidateSelector) === false) return false;
    return $a4b3b7902c9a987d$var$isNodeMatchingSelectorFocusable(options, node);
};



function $3f69993268aa5b7a$var$_extends() {
    $3f69993268aa5b7a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3f69993268aa5b7a$var$_extends.apply(this, arguments);
}
var $3f69993268aa5b7a$var$index = typeof document !== "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
let $3f69993268aa5b7a$var$serverHandoffComplete = false;
let $3f69993268aa5b7a$var$count = 0;
const $3f69993268aa5b7a$var$genId = ()=>"floating-ui-" + $3f69993268aa5b7a$var$count++;
function $3f69993268aa5b7a$var$useFloatingId() {
    const [id, setId] = $acw62.useState(()=>$3f69993268aa5b7a$var$serverHandoffComplete ? $3f69993268aa5b7a$var$genId() : undefined);
    $3f69993268aa5b7a$var$index(()=>{
        if (id == null) setId($3f69993268aa5b7a$var$genId());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $acw62.useEffect(()=>{
        if (!$3f69993268aa5b7a$var$serverHandoffComplete) $3f69993268aa5b7a$var$serverHandoffComplete = true;
    }, []);
    return id;
}
// `toString()` prevents bundlers from trying to `import { useId } from 'react'`
const $3f69993268aa5b7a$var$useReactId = $acw62[/*#__PURE__*/ "useId".toString()];
/**
 * Uses React 18's built-in `useId()` when available, or falls back to a
 * slightly less performant (requiring a double render) implementation for
 * earlier React versions.
 * @see https://floating-ui.com/docs/useId
 */ const $3f69993268aa5b7a$export$f680877a34711e37 = $3f69993268aa5b7a$var$useReactId || $3f69993268aa5b7a$var$useFloatingId;
/**
 * Renders a pointing arrow triangle.
 * @see https://floating-ui.com/docs/FloatingArrow
 */ const $3f69993268aa5b7a$export$33511391554732bc = /*#__PURE__*/ $acw62.forwardRef(function FloatingArrow(_ref, ref) {
    let { context: { placement: placement, elements: { floating: floating }, middlewareData: { arrow: arrow } }, width: width = 14, height: height = 7, tipRadius: tipRadius = 0, strokeWidth: strokeWidth = 0, staticOffset: staticOffset, stroke: stroke, d: d, style: { transform: transform, ...restStyle } = {}, ...rest } = _ref;
    const clipPathId = $3f69993268aa5b7a$export$f680877a34711e37();
    if (!floating) return null;
    // Strokes must be double the border width, this ensures the stroke's width
    // works as you'd expect.
    strokeWidth *= 2;
    const halfStrokeWidth = strokeWidth / 2;
    const svgX = width / 2 * (tipRadius / -8 + 1);
    const svgY = height / 2 * tipRadius / 4;
    const [side, alignment] = placement.split("-");
    const isRTL = (0, $461947879dcdbcd4$export$722a64dea1b767dc).isRTL(floating);
    const isCustomShape = !!d;
    const isVerticalSide = side === "top" || side === "bottom";
    const yOffsetProp = staticOffset && alignment === "end" ? "bottom" : "top";
    let xOffsetProp = staticOffset && alignment === "end" ? "right" : "left";
    if (staticOffset && isRTL) xOffsetProp = alignment === "end" ? "left" : "right";
    const arrowX = (arrow == null ? void 0 : arrow.x) != null ? staticOffset || arrow.x : "";
    const arrowY = (arrow == null ? void 0 : arrow.y) != null ? staticOffset || arrow.y : "";
    const dValue = d || "M0,0" + (" H" + width) + (" L" + (width - svgX) + "," + (height - svgY)) + (" Q" + width / 2 + "," + height + " " + svgX + "," + (height - svgY)) + " Z";
    const rotation = {
        top: isCustomShape ? "rotate(180deg)" : "",
        left: isCustomShape ? "rotate(90deg)" : "rotate(-90deg)",
        bottom: isCustomShape ? "" : "rotate(180deg)",
        right: isCustomShape ? "rotate(-90deg)" : "rotate(90deg)"
    }[side];
    return /*#__PURE__*/ $acw62.createElement("svg", $3f69993268aa5b7a$var$_extends({}, rest, {
        "aria-hidden": true,
        ref: ref,
        width: isCustomShape ? width : width + strokeWidth,
        height: width,
        viewBox: "0 0 " + width + " " + (height > width ? height : width),
        style: {
            position: "absolute",
            pointerEvents: "none",
            [xOffsetProp]: arrowX,
            [yOffsetProp]: arrowY,
            [side]: isVerticalSide || isCustomShape ? "100%" : "calc(100% - " + strokeWidth / 2 + "px)",
            transform: "" + rotation + (transform != null ? transform : ""),
            ...restStyle
        }
    }), strokeWidth > 0 && /*#__PURE__*/ $acw62.createElement("path", {
        clipPath: "url(#" + clipPathId + ")",
        fill: "none",
        stroke: stroke,
        strokeWidth: strokeWidth + (d ? 0 : 1),
        d: dValue
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: strokeWidth && !d ? rest.fill : "none",
        d: dValue
    }), /*#__PURE__*/ $acw62.createElement("clipPath", {
        id: clipPathId
    }, /*#__PURE__*/ $acw62.createElement("rect", {
        x: -halfStrokeWidth,
        y: halfStrokeWidth * (isCustomShape ? -1 : 1),
        width: width + strokeWidth,
        height: width
    })));
});
function $3f69993268aa5b7a$var$createPubSub() {
    const map = new Map();
    return {
        emit (event, data) {
            var _map$get;
            (_map$get = map.get(event)) == null || _map$get.forEach((handler)=>handler(data));
        },
        on (event, listener) {
            map.set(event, [
                ...map.get(event) || [],
                listener
            ]);
        },
        off (event, listener) {
            var _map$get2;
            map.set(event, ((_map$get2 = map.get(event)) == null ? void 0 : _map$get2.filter((l)=>l !== listener)) || []);
        }
    };
}
const $3f69993268aa5b7a$var$FloatingNodeContext = /*#__PURE__*/ $acw62.createContext(null);
const $3f69993268aa5b7a$var$FloatingTreeContext = /*#__PURE__*/ $acw62.createContext(null);
const $3f69993268aa5b7a$export$165209eae06d3488 = ()=>{
    var _React$useContext;
    return ((_React$useContext = $acw62.useContext($3f69993268aa5b7a$var$FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};
const $3f69993268aa5b7a$export$db0c2a7c7a2a4f69 = ()=>$acw62.useContext($3f69993268aa5b7a$var$FloatingTreeContext);
/**
 * Registers a node into the floating tree, returning its id.
 */ function $3f69993268aa5b7a$export$9b136e0e758a42f4(customParentId) {
    const id = $3f69993268aa5b7a$export$f680877a34711e37();
    const tree = $3f69993268aa5b7a$export$db0c2a7c7a2a4f69();
    const reactParentId = $3f69993268aa5b7a$export$165209eae06d3488();
    const parentId = customParentId || reactParentId;
    $3f69993268aa5b7a$var$index(()=>{
        const node = {
            id: id,
            parentId: parentId
        };
        tree == null || tree.addNode(node);
        return ()=>{
            tree == null || tree.removeNode(node);
        };
    }, [
        tree,
        id,
        parentId
    ]);
    return id;
}
/**
 * Provides parent node context for nested floating elements.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $3f69993268aa5b7a$export$ca00a83b5b253862(_ref) {
    let { children: children, id: id } = _ref;
    const parentId = $3f69993268aa5b7a$export$165209eae06d3488();
    return /*#__PURE__*/ $acw62.createElement($3f69993268aa5b7a$var$FloatingNodeContext.Provider, {
        value: $acw62.useMemo(()=>({
                id: id,
                parentId: parentId
            }), [
            id,
            parentId
        ])
    }, children);
}
/**
 * Provides context for nested floating elements when they are not children of
 * each other on the DOM (i.e. portalled to a common node, rather than their
 * respective parent).
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $3f69993268aa5b7a$export$587b60129641c4c8(_ref2) {
    let { children: children } = _ref2;
    const nodesRef = $acw62.useRef([]);
    const addNode = $acw62.useCallback((node)=>{
        nodesRef.current = [
            ...nodesRef.current,
            node
        ];
    }, []);
    const removeNode = $acw62.useCallback((node)=>{
        nodesRef.current = nodesRef.current.filter((n)=>n !== node);
    }, []);
    const events = $acw62.useState(()=>$3f69993268aa5b7a$var$createPubSub())[0];
    return /*#__PURE__*/ $acw62.createElement($3f69993268aa5b7a$var$FloatingTreeContext.Provider, {
        value: $acw62.useMemo(()=>({
                nodesRef: nodesRef,
                addNode: addNode,
                removeNode: removeNode,
                events: events
            }), [
            nodesRef,
            addNode,
            removeNode,
            events
        ])
    }, children);
}
function $3f69993268aa5b7a$var$getDocument(node) {
    return (node == null ? void 0 : node.ownerDocument) || document;
}
// Avoid Chrome DevTools blue warning.
function $3f69993268aa5b7a$var$getPlatform() {
    const uaData = navigator.userAgentData;
    if (uaData != null && uaData.platform) return uaData.platform;
    return navigator.platform;
}
function $3f69993268aa5b7a$var$getUserAgent() {
    const uaData = navigator.userAgentData;
    if (uaData && Array.isArray(uaData.brands)) return uaData.brands.map((_ref)=>{
        let { brand: brand, version: version } = _ref;
        return brand + "/" + version;
    }).join(" ");
    return navigator.userAgent;
}
function $3f69993268aa5b7a$var$getWindow(value) {
    return $3f69993268aa5b7a$var$getDocument(value).defaultView || window;
}
function $3f69993268aa5b7a$var$isElement(value) {
    return value ? value instanceof Element || value instanceof $3f69993268aa5b7a$var$getWindow(value).Element : false;
}
function $3f69993268aa5b7a$var$isHTMLElement(value) {
    return value ? value instanceof HTMLElement || value instanceof $3f69993268aa5b7a$var$getWindow(value).HTMLElement : false;
}
function $3f69993268aa5b7a$var$isShadowRoot(node) {
    // Browsers without `ShadowRoot` support
    if (typeof ShadowRoot === "undefined") return false;
    const OwnElement = $3f69993268aa5b7a$var$getWindow(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}
// License: https://github.com/adobe/react-spectrum/blob/b35d5c02fe900badccd0cf1a8f23bb593419f238/packages/@react-aria/utils/src/isVirtualEvent.ts
function $3f69993268aa5b7a$var$isVirtualClick(event) {
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    const androidRe = /Android/i;
    if ((androidRe.test($3f69993268aa5b7a$var$getPlatform()) || androidRe.test($3f69993268aa5b7a$var$getUserAgent())) && event.pointerType) return event.type === "click" && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function $3f69993268aa5b7a$var$isVirtualPointerEvent(event) {
    return event.width === 0 && event.height === 0 || event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType !== "mouse" || // iOS VoiceOver returns 0.333• for width/height.
    event.width < 1 && event.height < 1 && event.pressure === 0 && event.detail === 0;
}
function $3f69993268aa5b7a$var$isSafari() {
    // Chrome DevTools does not complain about navigator.vendor
    return /apple/i.test(navigator.vendor);
}
function $3f69993268aa5b7a$var$isMac() {
    return $3f69993268aa5b7a$var$getPlatform().toLowerCase().startsWith("mac") && !navigator.maxTouchPoints;
}
function $3f69993268aa5b7a$var$isMouseLikePointerType(pointerType, strict) {
    // On some Linux machines with Chromium, mouse inputs return a `pointerType`
    // of "pen": https://github.com/floating-ui/floating-ui/issues/2015
    const values = [
        "mouse",
        "pen"
    ];
    if (!strict) values.push("", undefined);
    return values.includes(pointerType);
}
function $3f69993268aa5b7a$var$isReactEvent(event) {
    return "nativeEvent" in event;
}
function $3f69993268aa5b7a$var$contains(parent, child) {
    if (!parent || !child) return false;
    const rootNode = child.getRootNode && child.getRootNode();
    // First, attempt with faster native method
    if (parent.contains(child)) return true;
    // then fallback to custom implementation with Shadow DOM support
    if (rootNode && $3f69993268aa5b7a$var$isShadowRoot(rootNode)) {
        let next = child;
        while(next){
            if (parent === next) return true;
            // @ts-ignore
            next = next.parentNode || next.host;
        }
    }
    // Give up, the result is false
    return false;
}
function $3f69993268aa5b7a$var$createAttribute(name) {
    return "data-floating-ui-" + name;
}
function $3f69993268aa5b7a$var$useLatestRef(value) {
    const ref = (0, $acw62.useRef)(value);
    $3f69993268aa5b7a$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
const $3f69993268aa5b7a$var$safePolygonIdentifier = /*#__PURE__*/ $3f69993268aa5b7a$var$createAttribute("safe-polygon");
function $3f69993268aa5b7a$var$getDelay(value, prop, pointerType) {
    if (pointerType && !$3f69993268aa5b7a$var$isMouseLikePointerType(pointerType)) return 0;
    if (typeof value === "number") return value;
    return value == null ? void 0 : value[prop];
}
/**
 * Opens the floating element while hovering over the reference element, like
 * CSS `:hover`.
 * @see https://floating-ui.com/docs/useHover
 */ function $3f69993268aa5b7a$export$ae780daf29e6d456(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, dataRef: dataRef, events: events, elements: { domReference: domReference, floating: floating }, refs: refs } = context;
    const { enabled: enabled = true, delay: delay = 0, handleClose: handleClose = null, mouseOnly: mouseOnly = false, restMs: restMs = 0, move: move = true } = props;
    const tree = $3f69993268aa5b7a$export$db0c2a7c7a2a4f69();
    const parentId = $3f69993268aa5b7a$export$165209eae06d3488();
    const handleCloseRef = $3f69993268aa5b7a$var$useLatestRef(handleClose);
    const delayRef = $3f69993268aa5b7a$var$useLatestRef(delay);
    const pointerTypeRef = $acw62.useRef();
    const timeoutRef = $acw62.useRef();
    const handlerRef = $acw62.useRef();
    const restTimeoutRef = $acw62.useRef();
    const blockMouseMoveRef = $acw62.useRef(true);
    const performedPointerEventsMutationRef = $acw62.useRef(false);
    const unbindMouseMoveRef = $acw62.useRef(()=>{});
    const isHoverOpen = $acw62.useCallback(()=>{
        var _dataRef$current$open;
        const type = (_dataRef$current$open = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open.type;
        return (type == null ? void 0 : type.includes("mouse")) && type !== "mousedown";
    }, [
        dataRef
    ]);
    // When dismissing before opening, clear the delay timeouts to cancel it
    // from showing.
    $acw62.useEffect(()=>{
        if (!enabled) return;
        function onDismiss() {
            clearTimeout(timeoutRef.current);
            clearTimeout(restTimeoutRef.current);
            blockMouseMoveRef.current = true;
        }
        events.on("dismiss", onDismiss);
        return ()=>{
            events.off("dismiss", onDismiss);
        };
    }, [
        enabled,
        events
    ]);
    $acw62.useEffect(()=>{
        if (!enabled || !handleCloseRef.current || !open) return;
        function onLeave(event) {
            if (isHoverOpen()) onOpenChange(false, event);
        }
        const html = $3f69993268aa5b7a$var$getDocument(floating).documentElement;
        html.addEventListener("mouseleave", onLeave);
        return ()=>{
            html.removeEventListener("mouseleave", onLeave);
        };
    }, [
        floating,
        open,
        onOpenChange,
        enabled,
        handleCloseRef,
        dataRef,
        isHoverOpen
    ]);
    const closeWithDelay = $acw62.useCallback(function(event, runElseBranch) {
        if (runElseBranch === void 0) runElseBranch = true;
        const closeDelay = $3f69993268aa5b7a$var$getDelay(delayRef.current, "close", pointerTypeRef.current);
        if (closeDelay && !handlerRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = setTimeout(()=>onOpenChange(false, event), closeDelay);
        } else if (runElseBranch) {
            clearTimeout(timeoutRef.current);
            onOpenChange(false, event);
        }
    }, [
        delayRef,
        onOpenChange
    ]);
    const cleanupMouseMoveHandler = $acw62.useCallback(()=>{
        unbindMouseMoveRef.current();
        handlerRef.current = undefined;
    }, []);
    const clearPointerEvents = $acw62.useCallback(()=>{
        if (performedPointerEventsMutationRef.current) {
            const body = $3f69993268aa5b7a$var$getDocument(refs.floating.current).body;
            body.style.pointerEvents = "";
            body.removeAttribute($3f69993268aa5b7a$var$safePolygonIdentifier);
            performedPointerEventsMutationRef.current = false;
        }
    }, [
        refs
    ]);
    // Registering the mouse events on the reference directly to bypass React's
    // delegation system. If the cursor was on a disabled element and then entered
    // the reference (no gap), `mouseenter` doesn't fire in the delegation system.
    $acw62.useEffect(()=>{
        if (!enabled) return;
        function isClickLikeOpenEvent() {
            return dataRef.current.openEvent ? [
                "click",
                "mousedown"
            ].includes(dataRef.current.openEvent.type) : false;
        }
        function onMouseEnter(event) {
            clearTimeout(timeoutRef.current);
            blockMouseMoveRef.current = false;
            if (mouseOnly && !$3f69993268aa5b7a$var$isMouseLikePointerType(pointerTypeRef.current) || restMs > 0 && $3f69993268aa5b7a$var$getDelay(delayRef.current, "open") === 0) return;
            const openDelay = $3f69993268aa5b7a$var$getDelay(delayRef.current, "open", pointerTypeRef.current);
            if (openDelay) timeoutRef.current = setTimeout(()=>{
                onOpenChange(true, event);
            }, openDelay);
            else onOpenChange(true, event);
        }
        function onMouseLeave(event) {
            if (isClickLikeOpenEvent()) return;
            unbindMouseMoveRef.current();
            const doc = $3f69993268aa5b7a$var$getDocument(floating);
            clearTimeout(restTimeoutRef.current);
            if (handleCloseRef.current) {
                // Prevent clearing `onScrollMouseLeave` timeout.
                if (!open) clearTimeout(timeoutRef.current);
                handlerRef.current = handleCloseRef.current({
                    ...context,
                    tree: tree,
                    x: event.clientX,
                    y: event.clientY,
                    onClose () {
                        clearPointerEvents();
                        cleanupMouseMoveHandler();
                        // Should the event expose that it was closed by `safePolygon`?
                        closeWithDelay(event);
                    }
                });
                const handler = handlerRef.current;
                doc.addEventListener("mousemove", handler);
                unbindMouseMoveRef.current = ()=>{
                    doc.removeEventListener("mousemove", handler);
                };
                return;
            }
            // Allow interactivity without `safePolygon` on touch devices. With a
            // pointer, a short close delay is an alternative, so it should work
            // consistently.
            const shouldClose = pointerTypeRef.current === "touch" ? !$3f69993268aa5b7a$var$contains(floating, event.relatedTarget) : true;
            if (shouldClose) closeWithDelay(event);
        }
        // Ensure the floating element closes after scrolling even if the pointer
        // did not move.
        // https://github.com/floating-ui/floating-ui/discussions/1692
        function onScrollMouseLeave(event) {
            if (isClickLikeOpenEvent()) return;
            handleCloseRef.current == null || handleCloseRef.current({
                ...context,
                tree: tree,
                x: event.clientX,
                y: event.clientY,
                onClose () {
                    clearPointerEvents();
                    cleanupMouseMoveHandler();
                    closeWithDelay(event);
                }
            })(event);
        }
        if ($3f69993268aa5b7a$var$isElement(domReference)) {
            const ref = domReference;
            open && ref.addEventListener("mouseleave", onScrollMouseLeave);
            floating == null || floating.addEventListener("mouseleave", onScrollMouseLeave);
            move && ref.addEventListener("mousemove", onMouseEnter, {
                once: true
            });
            ref.addEventListener("mouseenter", onMouseEnter);
            ref.addEventListener("mouseleave", onMouseLeave);
            return ()=>{
                open && ref.removeEventListener("mouseleave", onScrollMouseLeave);
                floating == null || floating.removeEventListener("mouseleave", onScrollMouseLeave);
                move && ref.removeEventListener("mousemove", onMouseEnter);
                ref.removeEventListener("mouseenter", onMouseEnter);
                ref.removeEventListener("mouseleave", onMouseLeave);
            };
        }
    }, [
        domReference,
        floating,
        enabled,
        context,
        mouseOnly,
        restMs,
        move,
        closeWithDelay,
        cleanupMouseMoveHandler,
        clearPointerEvents,
        onOpenChange,
        open,
        tree,
        delayRef,
        handleCloseRef,
        dataRef
    ]);
    // Block pointer-events of every element other than the reference and floating
    // while the floating element is open and has a `handleClose` handler. Also
    // handles nested floating elements.
    // https://github.com/floating-ui/floating-ui/issues/1722
    $3f69993268aa5b7a$var$index(()=>{
        var _handleCloseRef$curre;
        if (!enabled) return;
        if (open && (_handleCloseRef$curre = handleCloseRef.current) != null && _handleCloseRef$curre.__options.blockPointerEvents && isHoverOpen()) {
            const body = $3f69993268aa5b7a$var$getDocument(floating).body;
            body.setAttribute($3f69993268aa5b7a$var$safePolygonIdentifier, "");
            body.style.pointerEvents = "none";
            performedPointerEventsMutationRef.current = true;
            if ($3f69993268aa5b7a$var$isElement(domReference) && floating) {
                var _tree$nodesRef$curren, _tree$nodesRef$curren2;
                const ref = domReference;
                const parentFloating = tree == null ? void 0 : (_tree$nodesRef$curren = tree.nodesRef.current.find((node)=>node.id === parentId)) == null ? void 0 : (_tree$nodesRef$curren2 = _tree$nodesRef$curren.context) == null ? void 0 : _tree$nodesRef$curren2.elements.floating;
                if (parentFloating) parentFloating.style.pointerEvents = "";
                ref.style.pointerEvents = "auto";
                floating.style.pointerEvents = "auto";
                return ()=>{
                    ref.style.pointerEvents = "";
                    floating.style.pointerEvents = "";
                };
            }
        }
    }, [
        enabled,
        open,
        parentId,
        floating,
        domReference,
        tree,
        handleCloseRef,
        dataRef,
        isHoverOpen
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        if (!open) {
            pointerTypeRef.current = undefined;
            cleanupMouseMoveHandler();
            clearPointerEvents();
        }
    }, [
        open,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    $acw62.useEffect(()=>{
        return ()=>{
            cleanupMouseMoveHandler();
            clearTimeout(timeoutRef.current);
            clearTimeout(restTimeoutRef.current);
            clearPointerEvents();
        };
    }, [
        enabled,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    return $acw62.useMemo(()=>{
        if (!enabled) return {};
        function setPointerRef(event) {
            pointerTypeRef.current = event.pointerType;
        }
        return {
            reference: {
                onPointerDown: setPointerRef,
                onPointerEnter: setPointerRef,
                onMouseMove (event) {
                    if (open || restMs === 0) return;
                    clearTimeout(restTimeoutRef.current);
                    restTimeoutRef.current = setTimeout(()=>{
                        if (!blockMouseMoveRef.current) onOpenChange(true, event.nativeEvent);
                    }, restMs);
                }
            },
            floating: {
                onMouseEnter () {
                    clearTimeout(timeoutRef.current);
                },
                onMouseLeave (event) {
                    events.emit("dismiss", {
                        type: "mouseLeave",
                        data: {
                            returnFocus: false
                        }
                    });
                    closeWithDelay(event.nativeEvent, false);
                }
            }
        };
    }, [
        events,
        enabled,
        restMs,
        open,
        onOpenChange,
        closeWithDelay
    ]);
}
const $3f69993268aa5b7a$var$FloatingDelayGroupContext = /*#__PURE__*/ $acw62.createContext({
    delay: 0,
    initialDelay: 0,
    timeoutMs: 0,
    currentId: null,
    setCurrentId: ()=>{},
    setState: ()=>{},
    isInstantPhase: false
});
const $3f69993268aa5b7a$export$e2411914b150383d = ()=>$acw62.useContext($3f69993268aa5b7a$var$FloatingDelayGroupContext);
/**
 * Provides context for a group of floating elements that should share a
 * `delay`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ const $3f69993268aa5b7a$export$718279509ff1e241 = (_ref)=>{
    let { children: children, delay: delay, timeoutMs: timeoutMs = 0 } = _ref;
    const [state, setState] = $acw62.useReducer((prev, next)=>({
            ...prev,
            ...next
        }), {
        delay: delay,
        timeoutMs: timeoutMs,
        initialDelay: delay,
        currentId: null,
        isInstantPhase: false
    });
    const initialCurrentIdRef = $acw62.useRef(null);
    const setCurrentId = $acw62.useCallback((currentId)=>{
        setState({
            currentId: currentId
        });
    }, []);
    $3f69993268aa5b7a$var$index(()=>{
        if (state.currentId) {
            if (initialCurrentIdRef.current === null) initialCurrentIdRef.current = state.currentId;
            else setState({
                isInstantPhase: true
            });
        } else {
            setState({
                isInstantPhase: false
            });
            initialCurrentIdRef.current = null;
        }
    }, [
        state.currentId
    ]);
    return /*#__PURE__*/ $acw62.createElement($3f69993268aa5b7a$var$FloatingDelayGroupContext.Provider, {
        value: $acw62.useMemo(()=>({
                ...state,
                setState: setState,
                setCurrentId: setCurrentId
            }), [
            state,
            setState,
            setCurrentId
        ])
    }, children);
};
const $3f69993268aa5b7a$export$560fc8be89c8b4a8 = (_ref2, _ref3)=>{
    let { open: open, onOpenChange: onOpenChange } = _ref2;
    let { id: id } = _ref3;
    const { currentId: currentId, setCurrentId: setCurrentId, initialDelay: initialDelay, setState: setState, timeoutMs: timeoutMs } = $3f69993268aa5b7a$export$e2411914b150383d();
    $3f69993268aa5b7a$var$index(()=>{
        if (currentId) {
            setState({
                delay: {
                    open: 1,
                    close: $3f69993268aa5b7a$var$getDelay(initialDelay, "close")
                }
            });
            if (currentId !== id) onOpenChange(false);
        }
    }, [
        id,
        onOpenChange,
        setState,
        currentId,
        initialDelay
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        function unset() {
            onOpenChange(false);
            setState({
                delay: initialDelay,
                currentId: null
            });
        }
        if (!open && currentId === id) {
            if (timeoutMs) {
                const timeout = window.setTimeout(unset, timeoutMs);
                return ()=>{
                    clearTimeout(timeout);
                };
            } else unset();
        }
    }, [
        open,
        setState,
        currentId,
        id,
        onOpenChange,
        initialDelay,
        timeoutMs
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        if (open) setCurrentId(id);
    }, [
        open,
        setCurrentId,
        id
    ]);
};
/**
 * Find the real active element. Traverses into shadowRoots.
 */ function $3f69993268aa5b7a$var$activeElement(doc) {
    let activeElement = doc.activeElement;
    while(((_activeElement = activeElement) == null ? void 0 : (_activeElement$shadow = _activeElement.shadowRoot) == null ? void 0 : _activeElement$shadow.activeElement) != null){
        var _activeElement, _activeElement$shadow;
        activeElement = activeElement.shadowRoot.activeElement;
    }
    return activeElement;
}
let $3f69993268aa5b7a$var$rafId = 0;
function $3f69993268aa5b7a$var$enqueueFocus(el, options) {
    if (options === void 0) options = {};
    const { preventScroll: preventScroll = false, cancelPrevious: cancelPrevious = true, sync: sync = false } = options;
    cancelPrevious && cancelAnimationFrame($3f69993268aa5b7a$var$rafId);
    const exec = ()=>el == null ? void 0 : el.focus({
            preventScroll: preventScroll
        });
    if (sync) exec();
    else $3f69993268aa5b7a$var$rafId = requestAnimationFrame(exec);
}
function $3f69993268aa5b7a$var$getAncestors(nodes, id) {
    var _nodes$find;
    let allAncestors = [];
    let currentParentId = (_nodes$find = nodes.find((node)=>node.id === id)) == null ? void 0 : _nodes$find.parentId;
    while(currentParentId){
        const currentNode = nodes.find((node)=>node.id === currentParentId);
        currentParentId = currentNode == null ? void 0 : currentNode.parentId;
        if (currentNode) allAncestors = allAncestors.concat(currentNode);
    }
    return allAncestors;
}
function $3f69993268aa5b7a$var$getChildren(nodes, id) {
    let allChildren = nodes.filter((node)=>{
        var _node$context;
        return node.parentId === id && ((_node$context = node.context) == null ? void 0 : _node$context.open);
    });
    let currentChildren = allChildren;
    while(currentChildren.length){
        currentChildren = nodes.filter((node)=>{
            var _currentChildren;
            return (_currentChildren = currentChildren) == null ? void 0 : _currentChildren.some((n)=>{
                var _node$context2;
                return node.parentId === n.id && ((_node$context2 = node.context) == null ? void 0 : _node$context2.open);
            });
        });
        allChildren = allChildren.concat(currentChildren);
    }
    return allChildren;
}
function $3f69993268aa5b7a$var$getTarget(event) {
    if ("composedPath" in event) return event.composedPath()[0];
    // TS thinks `event` is of type never as it assumes all browsers support
    // `composedPath()`, but browsers without shadow DOM don't.
    return event.target;
}
const $3f69993268aa5b7a$var$TYPEABLE_SELECTOR = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function $3f69993268aa5b7a$var$isTypeableElement(element) {
    return $3f69993268aa5b7a$var$isHTMLElement(element) && element.matches($3f69993268aa5b7a$var$TYPEABLE_SELECTOR);
}
function $3f69993268aa5b7a$var$stopEvent(event) {
    event.preventDefault();
    event.stopPropagation();
}
const $3f69993268aa5b7a$var$getTabbableOptions = ()=>({
        getShadowRoot: true,
        displayCheck: // JSDOM does not support the `tabbable` library. To solve this we can
        // check if `ResizeObserver` is a real function (not polyfilled), which
        // determines if the current environment is JSDOM-like.
        typeof ResizeObserver === "function" && ResizeObserver.toString().includes("[native code]") ? "full" : "none"
    });
function $3f69993268aa5b7a$var$getTabbableIn(container, direction) {
    const allTabbable = (0, $a4b3b7902c9a987d$export$17100aea90429aa7)(container, $3f69993268aa5b7a$var$getTabbableOptions());
    if (direction === "prev") allTabbable.reverse();
    const activeIndex = allTabbable.indexOf($3f69993268aa5b7a$var$activeElement($3f69993268aa5b7a$var$getDocument(container)));
    const nextTabbableElements = allTabbable.slice(activeIndex + 1);
    return nextTabbableElements[0];
}
function $3f69993268aa5b7a$var$getNextTabbable() {
    return $3f69993268aa5b7a$var$getTabbableIn(document.body, "next");
}
function $3f69993268aa5b7a$var$getPreviousTabbable() {
    return $3f69993268aa5b7a$var$getTabbableIn(document.body, "prev");
}
function $3f69993268aa5b7a$var$isOutsideEvent(event, container) {
    const containerElement = container || event.currentTarget;
    const relatedTarget = event.relatedTarget;
    return !relatedTarget || !$3f69993268aa5b7a$var$contains(containerElement, relatedTarget);
}
function $3f69993268aa5b7a$var$disableFocusInside(container) {
    const tabbableElements = (0, $a4b3b7902c9a987d$export$17100aea90429aa7)(container, $3f69993268aa5b7a$var$getTabbableOptions());
    tabbableElements.forEach((element)=>{
        element.dataset.tabindex = element.getAttribute("tabindex") || "";
        element.setAttribute("tabindex", "-1");
    });
}
function $3f69993268aa5b7a$var$enableFocusInside(container) {
    const elements = container.querySelectorAll("[data-tabindex]");
    elements.forEach((element)=>{
        const tabindex = element.dataset.tabindex;
        delete element.dataset.tabindex;
        if (tabindex) element.setAttribute("tabindex", tabindex);
        else element.removeAttribute("tabindex");
    });
}
// See Diego Haz's Sandbox for making this logic work well on Safari/iOS:
// https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/FocusTrap.tsx
const $3f69993268aa5b7a$var$HIDDEN_STYLES = {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: 0,
    position: "fixed",
    whiteSpace: "nowrap",
    width: "1px",
    top: 0,
    left: 0
};
let $3f69993268aa5b7a$var$timeoutId;
function $3f69993268aa5b7a$var$setActiveElementOnTab(event) {
    if (event.key === "Tab") {
        event.target;
        clearTimeout($3f69993268aa5b7a$var$timeoutId);
    }
}
const $3f69993268aa5b7a$var$FocusGuard = /*#__PURE__*/ $acw62.forwardRef(function FocusGuard(props, ref) {
    const [role, setRole] = $acw62.useState();
    $3f69993268aa5b7a$var$index(()=>{
        if ($3f69993268aa5b7a$var$isSafari()) // Unlike other screen readers such as NVDA and JAWS, the virtual cursor
        // on VoiceOver does trigger the onFocus event, so we can use the focus
        // trap element. On Safari, only buttons trigger the onFocus event.
        // NB: "group" role in the Sandbox no longer appears to work, must be a
        // button role.
        setRole("button");
        document.addEventListener("keydown", $3f69993268aa5b7a$var$setActiveElementOnTab);
        return ()=>{
            document.removeEventListener("keydown", $3f69993268aa5b7a$var$setActiveElementOnTab);
        };
    }, []);
    const restProps = {
        ref: ref,
        tabIndex: 0,
        role: // Role is only for VoiceOver
        role,
        "aria-hidden": role ? undefined : true,
        [$3f69993268aa5b7a$var$createAttribute("focus-guard")]: "",
        style: $3f69993268aa5b7a$var$HIDDEN_STYLES
    };
    return /*#__PURE__*/ $acw62.createElement("span", $3f69993268aa5b7a$var$_extends({}, props, restProps));
});
const $3f69993268aa5b7a$var$PortalContext = /*#__PURE__*/ $acw62.createContext(null);
function $3f69993268aa5b7a$export$ac107512f3c5cca6(_temp) {
    let { id: id, root: root } = _temp === void 0 ? {} : _temp;
    const [portalNode, setPortalNode] = $acw62.useState(null);
    const uniqueId = $3f69993268aa5b7a$export$f680877a34711e37();
    const portalContext = $3f69993268aa5b7a$var$usePortalContext();
    const data = $acw62.useMemo(()=>({
            id: id,
            root: root,
            portalContext: portalContext,
            uniqueId: uniqueId
        }), [
        id,
        root,
        portalContext,
        uniqueId
    ]);
    const dataRef = $acw62.useRef();
    $3f69993268aa5b7a$var$index(()=>{
        return ()=>{
            portalNode == null || portalNode.remove();
        };
    }, [
        portalNode,
        data
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        if (dataRef.current === data) return;
        dataRef.current = data;
        const { id: id, root: root, portalContext: portalContext, uniqueId: uniqueId } = data;
        const existingIdRoot = id ? document.getElementById(id) : null;
        const attr = $3f69993268aa5b7a$var$createAttribute("portal");
        if (existingIdRoot) {
            const subRoot = document.createElement("div");
            subRoot.id = uniqueId;
            subRoot.setAttribute(attr, "");
            existingIdRoot.appendChild(subRoot);
            setPortalNode(subRoot);
        } else {
            let container = root || (portalContext == null ? void 0 : portalContext.portalNode);
            if (container && !$3f69993268aa5b7a$var$isElement(container)) container = container.current;
            container = container || document.body;
            let idWrapper = null;
            if (id) {
                idWrapper = document.createElement("div");
                idWrapper.id = id;
                container.appendChild(idWrapper);
            }
            const subRoot = document.createElement("div");
            subRoot.id = uniqueId;
            subRoot.setAttribute(attr, "");
            container = idWrapper || container;
            container.appendChild(subRoot);
            setPortalNode(subRoot);
        }
    }, [
        data
    ]);
    return portalNode;
}
/**
 * Portals the floating element into a given container element — by default,
 * outside of the app root and into the body.
 * @see https://floating-ui.com/docs/FloatingPortal
 */ function $3f69993268aa5b7a$export$31fa5d718fa2ac09(_ref) {
    let { children: children, id: id, root: root = null, preserveTabOrder: preserveTabOrder = true } = _ref;
    const portalNode = $3f69993268aa5b7a$export$ac107512f3c5cca6({
        id: id,
        root: root
    });
    const [focusManagerState, setFocusManagerState] = $acw62.useState(null);
    const beforeOutsideRef = $acw62.useRef(null);
    const afterOutsideRef = $acw62.useRef(null);
    const beforeInsideRef = $acw62.useRef(null);
    const afterInsideRef = $acw62.useRef(null);
    const shouldRenderGuards = // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!focusManagerState && // Guards are only for non-modal focus management.
    !focusManagerState.modal && // Don't render if unmount is transitioning.
    focusManagerState.open && preserveTabOrder && !!(root || portalNode);
    // https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/TabbablePortal.tsx
    $acw62.useEffect(()=>{
        if (!portalNode || !preserveTabOrder || focusManagerState != null && focusManagerState.modal) return;
        // Make sure elements inside the portal element are tabbable only when the
        // portal has already been focused, either by tabbing into a focus trap
        // element outside or using the mouse.
        function onFocus(event) {
            if (portalNode && $3f69993268aa5b7a$var$isOutsideEvent(event)) {
                const focusing = event.type === "focusin";
                const manageFocus = focusing ? $3f69993268aa5b7a$var$enableFocusInside : $3f69993268aa5b7a$var$disableFocusInside;
                manageFocus(portalNode);
            }
        }
        // Listen to the event on the capture phase so they run before the focus
        // trap elements onFocus prop is called.
        portalNode.addEventListener("focusin", onFocus, true);
        portalNode.addEventListener("focusout", onFocus, true);
        return ()=>{
            portalNode.removeEventListener("focusin", onFocus, true);
            portalNode.removeEventListener("focusout", onFocus, true);
        };
    }, [
        portalNode,
        preserveTabOrder,
        focusManagerState == null ? void 0 : focusManagerState.modal
    ]);
    return /*#__PURE__*/ $acw62.createElement($3f69993268aa5b7a$var$PortalContext.Provider, {
        value: $acw62.useMemo(()=>({
                preserveTabOrder: preserveTabOrder,
                beforeOutsideRef: beforeOutsideRef,
                afterOutsideRef: afterOutsideRef,
                beforeInsideRef: beforeInsideRef,
                afterInsideRef: afterInsideRef,
                portalNode: portalNode,
                setFocusManagerState: setFocusManagerState
            }), [
            preserveTabOrder,
            portalNode
        ])
    }, shouldRenderGuards && portalNode && /*#__PURE__*/ $acw62.createElement($3f69993268aa5b7a$var$FocusGuard, {
        "data-type": "outside",
        ref: beforeOutsideRef,
        onFocus: (event)=>{
            if ($3f69993268aa5b7a$var$isOutsideEvent(event, portalNode)) {
                var _beforeInsideRef$curr;
                (_beforeInsideRef$curr = beforeInsideRef.current) == null || _beforeInsideRef$curr.focus();
            } else {
                const prevTabbable = $3f69993268aa5b7a$var$getPreviousTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
                prevTabbable == null || prevTabbable.focus();
            }
        }
    }), shouldRenderGuards && portalNode && /*#__PURE__*/ $acw62.createElement("span", {
        "aria-owns": portalNode.id,
        style: $3f69993268aa5b7a$var$HIDDEN_STYLES
    }), portalNode && /*#__PURE__*/ (0, $11492dca620dcaa5$exports.createPortal)(children, portalNode), shouldRenderGuards && portalNode && /*#__PURE__*/ $acw62.createElement($3f69993268aa5b7a$var$FocusGuard, {
        "data-type": "outside",
        ref: afterOutsideRef,
        onFocus: (event)=>{
            if ($3f69993268aa5b7a$var$isOutsideEvent(event, portalNode)) {
                var _afterInsideRef$curre;
                (_afterInsideRef$curre = afterInsideRef.current) == null || _afterInsideRef$curre.focus();
            } else {
                const nextTabbable = $3f69993268aa5b7a$var$getNextTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
                nextTabbable == null || nextTabbable.focus();
                (focusManagerState == null ? void 0 : focusManagerState.closeOnFocusOut) && (focusManagerState == null || focusManagerState.onOpenChange(false, event.nativeEvent));
            }
        }
    }));
}
const $3f69993268aa5b7a$var$usePortalContext = ()=>$acw62.useContext($3f69993268aa5b7a$var$PortalContext);
const $3f69993268aa5b7a$var$VisuallyHiddenDismiss = /*#__PURE__*/ $acw62.forwardRef(function VisuallyHiddenDismiss(props, ref) {
    return /*#__PURE__*/ $acw62.createElement("button", $3f69993268aa5b7a$var$_extends({}, props, {
        type: "button",
        ref: ref,
        tabIndex: -1,
        style: $3f69993268aa5b7a$var$HIDDEN_STYLES
    }));
});
/**
 * Provides focus management for the floating element.
 * @see https://floating-ui.com/docs/FloatingFocusManager
 */ function $3f69993268aa5b7a$export$8aeee49171ded61a(props) {
    const { context: context, children: children, disabled: disabled = false, order: order = [
        "content"
    ], guards: _guards = true, initialFocus: initialFocus = 0, returnFocus: returnFocus = true, modal: modal = true, visuallyHiddenDismiss: visuallyHiddenDismiss = false, closeOnFocusOut: closeOnFocusOut = true } = props;
    const { open: open, refs: refs, nodeId: nodeId, onOpenChange: onOpenChange, events: events, dataRef: dataRef, elements: { domReference: domReference, floating: floating } } = context;
    // Force the guards to be rendered if the `inert` attribute is not supported.
    const guards = (0, $4a7537e072260c10$export$cc95fea82d705fca)() ? _guards : true;
    const orderRef = $3f69993268aa5b7a$var$useLatestRef(order);
    const initialFocusRef = $3f69993268aa5b7a$var$useLatestRef(initialFocus);
    const returnFocusRef = $3f69993268aa5b7a$var$useLatestRef(returnFocus);
    const tree = $3f69993268aa5b7a$export$db0c2a7c7a2a4f69();
    const portalContext = $3f69993268aa5b7a$var$usePortalContext();
    // Controlled by `useListNavigation`.
    const ignoreInitialFocus = typeof initialFocus === "number" && initialFocus < 0;
    const startDismissButtonRef = $acw62.useRef(null);
    const endDismissButtonRef = $acw62.useRef(null);
    const preventReturnFocusRef = $acw62.useRef(false);
    const previouslyFocusedElementRef = $acw62.useRef(null);
    const isPointerDownRef = $acw62.useRef(false);
    const isInsidePortal = portalContext != null;
    // If the reference is a combobox and is typeable (e.g. input/textarea),
    // there are different focus semantics. The guards should not be rendered, but
    // aria-hidden should be applied to all nodes still. Further, the visually
    // hidden dismiss button should only appear at the end of the list, not the
    // start.
    const isTypeableCombobox = domReference && domReference.getAttribute("role") === "combobox" && $3f69993268aa5b7a$var$isTypeableElement(domReference);
    const getTabbableContent = $acw62.useCallback(function(container) {
        if (container === void 0) container = floating;
        return container ? (0, $a4b3b7902c9a987d$export$17100aea90429aa7)(container, $3f69993268aa5b7a$var$getTabbableOptions()) : [];
    }, [
        floating
    ]);
    const getTabbableElements = $acw62.useCallback((container)=>{
        const content = getTabbableContent(container);
        return orderRef.current.map((type)=>{
            if (domReference && type === "reference") return domReference;
            if (floating && type === "floating") return floating;
            return content;
        }).filter(Boolean).flat();
    }, [
        domReference,
        floating,
        orderRef,
        getTabbableContent
    ]);
    $acw62.useEffect(()=>{
        if (disabled || !modal) return;
        function onKeyDown(event) {
            if (event.key === "Tab") {
                // The focus guards have nothing to focus, so we need to stop the event.
                if ($3f69993268aa5b7a$var$contains(floating, $3f69993268aa5b7a$var$activeElement($3f69993268aa5b7a$var$getDocument(floating))) && getTabbableContent().length === 0 && !isTypeableCombobox) $3f69993268aa5b7a$var$stopEvent(event);
                const els = getTabbableElements();
                const target = $3f69993268aa5b7a$var$getTarget(event);
                if (orderRef.current[0] === "reference" && target === domReference) {
                    $3f69993268aa5b7a$var$stopEvent(event);
                    if (event.shiftKey) $3f69993268aa5b7a$var$enqueueFocus(els[els.length - 1]);
                    else $3f69993268aa5b7a$var$enqueueFocus(els[1]);
                }
                if (orderRef.current[1] === "floating" && target === floating && event.shiftKey) {
                    $3f69993268aa5b7a$var$stopEvent(event);
                    $3f69993268aa5b7a$var$enqueueFocus(els[0]);
                }
            }
        }
        const doc = $3f69993268aa5b7a$var$getDocument(floating);
        doc.addEventListener("keydown", onKeyDown);
        return ()=>{
            doc.removeEventListener("keydown", onKeyDown);
        };
    }, [
        disabled,
        domReference,
        floating,
        modal,
        orderRef,
        refs,
        isTypeableCombobox,
        getTabbableContent,
        getTabbableElements
    ]);
    $acw62.useEffect(()=>{
        if (disabled || !closeOnFocusOut) return;
        // In Safari, buttons lose focus when pressing them.
        function handlePointerDown() {
            isPointerDownRef.current = true;
            setTimeout(()=>{
                isPointerDownRef.current = false;
            });
        }
        function handleFocusOutside(event) {
            const relatedTarget = event.relatedTarget;
            queueMicrotask(()=>{
                const movedToUnrelatedNode = !($3f69993268aa5b7a$var$contains(domReference, relatedTarget) || $3f69993268aa5b7a$var$contains(floating, relatedTarget) || $3f69993268aa5b7a$var$contains(relatedTarget, floating) || $3f69993268aa5b7a$var$contains(portalContext == null ? void 0 : portalContext.portalNode, relatedTarget) || relatedTarget != null && relatedTarget.hasAttribute($3f69993268aa5b7a$var$createAttribute("focus-guard")) || tree && ($3f69993268aa5b7a$var$getChildren(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context, _node$context2;
                    return $3f69993268aa5b7a$var$contains((_node$context = node.context) == null ? void 0 : _node$context.elements.floating, relatedTarget) || $3f69993268aa5b7a$var$contains((_node$context2 = node.context) == null ? void 0 : _node$context2.elements.domReference, relatedTarget);
                }) || $3f69993268aa5b7a$var$getAncestors(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context3, _node$context4;
                    return ((_node$context3 = node.context) == null ? void 0 : _node$context3.elements.floating) === relatedTarget || ((_node$context4 = node.context) == null ? void 0 : _node$context4.elements.domReference) === relatedTarget;
                })));
                // Focus did not move inside the floating tree, and there are no tabbable
                // portal guards to handle closing.
                if (relatedTarget && movedToUnrelatedNode && !isPointerDownRef.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
                relatedTarget !== previouslyFocusedElementRef.current) {
                    preventReturnFocusRef.current = true;
                    onOpenChange(false, event);
                }
            });
        }
        if (floating && $3f69993268aa5b7a$var$isHTMLElement(domReference)) {
            domReference.addEventListener("focusout", handleFocusOutside);
            domReference.addEventListener("pointerdown", handlePointerDown);
            !modal && floating.addEventListener("focusout", handleFocusOutside);
            return ()=>{
                domReference.removeEventListener("focusout", handleFocusOutside);
                domReference.removeEventListener("pointerdown", handlePointerDown);
                !modal && floating.removeEventListener("focusout", handleFocusOutside);
            };
        }
    }, [
        disabled,
        domReference,
        floating,
        modal,
        nodeId,
        tree,
        portalContext,
        onOpenChange,
        closeOnFocusOut
    ]);
    $acw62.useEffect(()=>{
        var _portalContext$portal;
        if (disabled) return;
        // Don't hide portals nested within the parent portal.
        const portalNodes = Array.from((portalContext == null ? void 0 : (_portalContext$portal = portalContext.portalNode) == null ? void 0 : _portalContext$portal.querySelectorAll("[" + $3f69993268aa5b7a$var$createAttribute("portal") + "]")) || []);
        if (floating && modal) {
            const insideNodes = [
                floating,
                ...portalNodes,
                startDismissButtonRef.current,
                endDismissButtonRef.current
            ].filter((x)=>x != null);
            const suppressorFn = guards ? (0, $4a7537e072260c10$export$6e33d16126ed003c) : (0, $4a7537e072260c10$export$9845d4b6bdad192b);
            const cleanup = suppressorFn(orderRef.current.includes("reference") || isTypeableCombobox ? insideNodes.concat(domReference || []) : insideNodes, undefined, $3f69993268aa5b7a$var$createAttribute("inert"));
            return ()=>{
                cleanup();
            };
        }
    }, [
        disabled,
        domReference,
        floating,
        modal,
        orderRef,
        portalContext,
        isTypeableCombobox,
        guards
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        if (disabled || !floating) return;
        const doc = $3f69993268aa5b7a$var$getDocument(floating);
        const previouslyFocusedElement = $3f69993268aa5b7a$var$activeElement(doc);
        // Wait for any layout effect state setters to execute to set `tabIndex`.
        queueMicrotask(()=>{
            const focusableElements = getTabbableElements(floating);
            const initialFocusValue = initialFocusRef.current;
            const elToFocus = (typeof initialFocusValue === "number" ? focusableElements[initialFocusValue] : initialFocusValue.current) || floating;
            const focusAlreadyInsideFloatingEl = $3f69993268aa5b7a$var$contains(floating, previouslyFocusedElement);
            if (!ignoreInitialFocus && !focusAlreadyInsideFloatingEl && open) $3f69993268aa5b7a$var$enqueueFocus(elToFocus, {
                preventScroll: elToFocus === floating
            });
        });
    }, [
        disabled,
        open,
        floating,
        ignoreInitialFocus,
        getTabbableElements,
        initialFocusRef
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        if (disabled || !floating) return;
        let preventReturnFocusScroll = false;
        const doc = $3f69993268aa5b7a$var$getDocument(floating);
        const previouslyFocusedElement = $3f69993268aa5b7a$var$activeElement(doc);
        const contextData = dataRef.current;
        previouslyFocusedElementRef.current = previouslyFocusedElement;
        // Dismissing via outside press should always ignore `returnFocus` to
        // prevent unwanted scrolling.
        function onDismiss(payload) {
            if (payload.type === "escapeKey" && refs.domReference.current) previouslyFocusedElementRef.current = refs.domReference.current;
            if ([
                "referencePress",
                "escapeKey"
            ].includes(payload.type)) return;
            const returnFocus = payload.data.returnFocus;
            if (typeof returnFocus === "object") {
                preventReturnFocusRef.current = false;
                preventReturnFocusScroll = returnFocus.preventScroll;
            } else preventReturnFocusRef.current = !returnFocus;
        }
        events.on("dismiss", onDismiss);
        return ()=>{
            events.off("dismiss", onDismiss);
            const activeEl = $3f69993268aa5b7a$var$activeElement(doc);
            const shouldFocusReference = $3f69993268aa5b7a$var$contains(floating, activeEl) || tree && $3f69993268aa5b7a$var$getChildren(tree.nodesRef.current, nodeId).some((node)=>{
                var _node$context5;
                return $3f69993268aa5b7a$var$contains((_node$context5 = node.context) == null ? void 0 : _node$context5.elements.floating, activeEl);
            }) || contextData.openEvent && [
                "click",
                "mousedown"
            ].includes(contextData.openEvent.type);
            if (shouldFocusReference && refs.domReference.current) previouslyFocusedElementRef.current = refs.domReference.current;
            if (// eslint-disable-next-line react-hooks/exhaustive-deps
            returnFocusRef.current && $3f69993268aa5b7a$var$isHTMLElement(previouslyFocusedElementRef.current) && !preventReturnFocusRef.current) $3f69993268aa5b7a$var$enqueueFocus(previouslyFocusedElementRef.current, {
                // When dismissing nested floating elements, by the time the rAF has
                // executed, the menus will all have been unmounted. When they try
                // to get focused, the calls get ignored — leaving the root
                // reference focused as desired.
                cancelPrevious: false,
                preventScroll: preventReturnFocusScroll
            });
        };
    }, [
        disabled,
        floating,
        returnFocusRef,
        dataRef,
        refs,
        events,
        tree,
        nodeId
    ]);
    // Synchronize the `context` & `modal` value to the FloatingPortal context.
    // It will decide whether or not it needs to render its own guards.
    $3f69993268aa5b7a$var$index(()=>{
        if (disabled || !portalContext) return;
        portalContext.setFocusManagerState({
            ...context,
            modal: modal,
            closeOnFocusOut: closeOnFocusOut,
            open: open
        });
        return ()=>{
            portalContext.setFocusManagerState(null);
        };
    }, [
        disabled,
        portalContext,
        modal,
        open,
        closeOnFocusOut,
        context
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        if (disabled) return;
        if (floating && typeof MutationObserver === "function") {
            const handleMutation = ()=>{
                const tabIndex = floating.getAttribute("tabindex");
                if (orderRef.current.includes("floating") || $3f69993268aa5b7a$var$activeElement($3f69993268aa5b7a$var$getDocument(floating)) !== refs.domReference.current && getTabbableContent().length === 0) {
                    if (tabIndex !== "0") floating.setAttribute("tabindex", "0");
                } else if (tabIndex !== "-1") floating.setAttribute("tabindex", "-1");
            };
            handleMutation();
            const observer = new MutationObserver(handleMutation);
            observer.observe(floating, {
                childList: true,
                subtree: true,
                attributes: true
            });
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        disabled,
        floating,
        refs,
        orderRef,
        getTabbableContent
    ]);
    function renderDismissButton(location) {
        if (disabled || !visuallyHiddenDismiss || !modal) return null;
        return /*#__PURE__*/ $acw62.createElement($3f69993268aa5b7a$var$VisuallyHiddenDismiss, {
            ref: location === "start" ? startDismissButtonRef : endDismissButtonRef,
            onClick: (event)=>onOpenChange(false, event.nativeEvent)
        }, typeof visuallyHiddenDismiss === "string" ? visuallyHiddenDismiss : "Dismiss");
    }
    const shouldRenderGuards = !disabled && guards && !isTypeableCombobox && (isInsidePortal || modal);
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, shouldRenderGuards && /*#__PURE__*/ $acw62.createElement($3f69993268aa5b7a$var$FocusGuard, {
        "data-type": "inside",
        ref: portalContext == null ? void 0 : portalContext.beforeInsideRef,
        onFocus: (event)=>{
            if (modal) {
                const els = getTabbableElements();
                $3f69993268aa5b7a$var$enqueueFocus(order[0] === "reference" ? els[0] : els[els.length - 1]);
            } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                preventReturnFocusRef.current = false;
                if ($3f69993268aa5b7a$var$isOutsideEvent(event, portalContext.portalNode)) {
                    const nextTabbable = $3f69993268aa5b7a$var$getNextTabbable() || domReference;
                    nextTabbable == null || nextTabbable.focus();
                } else {
                    var _portalContext$before;
                    (_portalContext$before = portalContext.beforeOutsideRef.current) == null || _portalContext$before.focus();
                }
            }
        }
    }), !isTypeableCombobox && renderDismissButton("start"), children, renderDismissButton("end"), shouldRenderGuards && /*#__PURE__*/ $acw62.createElement($3f69993268aa5b7a$var$FocusGuard, {
        "data-type": "inside",
        ref: portalContext == null ? void 0 : portalContext.afterInsideRef,
        onFocus: (event)=>{
            if (modal) $3f69993268aa5b7a$var$enqueueFocus(getTabbableElements()[0]);
            else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                if (closeOnFocusOut) preventReturnFocusRef.current = true;
                if ($3f69993268aa5b7a$var$isOutsideEvent(event, portalContext.portalNode)) {
                    const prevTabbable = $3f69993268aa5b7a$var$getPreviousTabbable() || domReference;
                    prevTabbable == null || prevTabbable.focus();
                } else {
                    var _portalContext$afterO;
                    (_portalContext$afterO = portalContext.afterOutsideRef.current) == null || _portalContext$afterO.focus();
                }
            }
        }
    }));
}
function $3f69993268aa5b7a$var$sortByDocumentPosition(a, b) {
    const position = a.compareDocumentPosition(b);
    if (position & Node.DOCUMENT_POSITION_FOLLOWING || position & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
    if (position & Node.DOCUMENT_POSITION_PRECEDING || position & Node.DOCUMENT_POSITION_CONTAINS) return 1;
    return 0;
}
function $3f69993268aa5b7a$var$areMapsEqual(map1, map2) {
    if (map1.size !== map2.size) return false;
    for (const [key, value] of map1.entries()){
        if (value !== map2.get(key)) return false;
    }
    return true;
}
const $3f69993268aa5b7a$var$FloatingListContext = /*#__PURE__*/ $acw62.createContext({
    register: ()=>{},
    unregister: ()=>{},
    map: /*#__PURE__*/ new Map(),
    elementsRef: {
        current: []
    }
});
/**
 * Provides context for a list of items within the floating element.
 * @see https://floating-ui.com/docs/FloatingList
 */ function $3f69993268aa5b7a$export$ffe15b0e64951704(_ref) {
    let { children: children, elementsRef: elementsRef, labelsRef: labelsRef } = _ref;
    const [map, setMap] = $acw62.useState(()=>new Map());
    const register = $acw62.useCallback((node)=>{
        setMap((prevMap)=>new Map(prevMap).set(node, null));
    }, []);
    const unregister = $acw62.useCallback((node)=>{
        setMap((prevMap)=>{
            const map = new Map(prevMap);
            map.delete(node);
            return map;
        });
    }, []);
    $3f69993268aa5b7a$var$index(()=>{
        const newMap = new Map(map);
        const nodes = Array.from(newMap.keys()).sort($3f69993268aa5b7a$var$sortByDocumentPosition);
        nodes.forEach((node, index)=>{
            newMap.set(node, index);
        });
        if (!$3f69993268aa5b7a$var$areMapsEqual(map, newMap)) setMap(newMap);
    }, [
        map
    ]);
    return /*#__PURE__*/ $acw62.createElement($3f69993268aa5b7a$var$FloatingListContext.Provider, {
        value: $acw62.useMemo(()=>({
                register: register,
                unregister: unregister,
                map: map,
                elementsRef: elementsRef,
                labelsRef: labelsRef
            }), [
            register,
            unregister,
            map,
            elementsRef,
            labelsRef
        ])
    }, children);
}
function $3f69993268aa5b7a$export$dcdc7ff5149f7d1a(_temp) {
    let { label: label } = _temp === void 0 ? {} : _temp;
    const [index$1, setIndex] = $acw62.useState(null);
    const componentRef = $acw62.useRef(null);
    const { register: register, unregister: unregister, map: map, elementsRef: elementsRef, labelsRef: labelsRef } = $acw62.useContext($3f69993268aa5b7a$var$FloatingListContext);
    const ref = $acw62.useCallback((node)=>{
        componentRef.current = node;
        if (index$1 !== null) {
            elementsRef.current[index$1] = node;
            if (labelsRef) {
                var _node$textContent;
                const isLabelDefined = label !== undefined;
                labelsRef.current[index$1] = isLabelDefined ? label : (_node$textContent = node == null ? void 0 : node.textContent) != null ? _node$textContent : null;
            }
        }
    }, [
        index$1,
        elementsRef,
        labelsRef,
        label
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        const node = componentRef.current;
        if (node) {
            register(node);
            return ()=>{
                unregister(node);
            };
        }
    }, [
        register,
        unregister
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        const index = componentRef.current ? map.get(componentRef.current) : null;
        if (index != null) setIndex(index);
    }, [
        map
    ]);
    return $acw62.useMemo(()=>({
            ref: ref,
            index: index$1 == null ? -1 : index$1
        }), [
        index$1,
        ref
    ]);
}
const $3f69993268aa5b7a$var$identifier = /*#__PURE__*/ $3f69993268aa5b7a$var$createAttribute("scroll-lock");
/**
 * Provides base styling for a fixed overlay element to dim content or block
 * pointer events behind a floating element.
 * It's a regular `<div>`, so it can be styled via any CSS solution you prefer.
 * @see https://floating-ui.com/docs/FloatingOverlay
 */ const $3f69993268aa5b7a$export$a35954495955337b = /*#__PURE__*/ $acw62.forwardRef(function FloatingOverlay(_ref, ref) {
    let { lockScroll: lockScroll = false, ...rest } = _ref;
    $3f69993268aa5b7a$var$index(()=>{
        var _window$visualViewpor, _window$visualViewpor2;
        if (!lockScroll) return;
        const alreadyLocked = document.body.hasAttribute($3f69993268aa5b7a$var$identifier);
        if (alreadyLocked) return;
        document.body.setAttribute($3f69993268aa5b7a$var$identifier, "");
        // RTL <body> scrollbar
        const scrollbarX = Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft;
        const paddingProp = scrollbarX ? "paddingLeft" : "paddingRight";
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        // Only iOS doesn't respect `overflow: hidden` on document.body, and this
        // technique has fewer side effects.
        if (!/iP(hone|ad|od)|iOS/.test($3f69993268aa5b7a$var$getPlatform())) {
            Object.assign(document.body.style, {
                overflow: "hidden",
                [paddingProp]: scrollbarWidth + "px"
            });
            return ()=>{
                document.body.removeAttribute($3f69993268aa5b7a$var$identifier);
                Object.assign(document.body.style, {
                    overflow: "",
                    [paddingProp]: ""
                });
            };
        }
        // iOS 12 does not support `visualViewport`.
        const offsetLeft = ((_window$visualViewpor = window.visualViewport) == null ? void 0 : _window$visualViewpor.offsetLeft) || 0;
        const offsetTop = ((_window$visualViewpor2 = window.visualViewport) == null ? void 0 : _window$visualViewpor2.offsetTop) || 0;
        const scrollX = window.pageXOffset;
        const scrollY = window.pageYOffset;
        Object.assign(document.body.style, {
            position: "fixed",
            overflow: "hidden",
            top: -(scrollY - Math.floor(offsetTop)) + "px",
            left: -(scrollX - Math.floor(offsetLeft)) + "px",
            right: "0",
            [paddingProp]: scrollbarWidth + "px"
        });
        return ()=>{
            Object.assign(document.body.style, {
                position: "",
                overflow: "",
                top: "",
                left: "",
                right: "",
                [paddingProp]: ""
            });
            document.body.removeAttribute($3f69993268aa5b7a$var$identifier);
            window.scrollTo(scrollX, scrollY);
        };
    }, [
        lockScroll
    ]);
    return /*#__PURE__*/ $acw62.createElement("div", $3f69993268aa5b7a$var$_extends({
        ref: ref
    }, rest, {
        style: {
            position: "fixed",
            overflow: "auto",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...rest.style
        }
    }));
});
function $3f69993268aa5b7a$var$isButtonTarget(event) {
    return $3f69993268aa5b7a$var$isHTMLElement(event.target) && event.target.tagName === "BUTTON";
}
function $3f69993268aa5b7a$var$isSpaceIgnored(element) {
    return $3f69993268aa5b7a$var$isTypeableElement(element);
}
/**
 * Opens or closes the floating element when clicking the reference element.
 * @see https://floating-ui.com/docs/useClick
 */ function $3f69993268aa5b7a$export$98524f11226063fc(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, dataRef: dataRef, elements: { domReference: domReference } } = context;
    const { enabled: enabled = true, event: eventOption = "click", toggle: toggle = true, ignoreMouse: ignoreMouse = false, keyboardHandlers: keyboardHandlers = true } = props;
    const pointerTypeRef = $acw62.useRef();
    const didKeyDownRef = $acw62.useRef(false);
    return $acw62.useMemo(()=>{
        if (!enabled) return {};
        return {
            reference: {
                onPointerDown (event) {
                    pointerTypeRef.current = event.pointerType;
                },
                onMouseDown (event) {
                    // Ignore all buttons except for the "main" button.
                    // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
                    if (event.button !== 0) return;
                    if ($3f69993268aa5b7a$var$isMouseLikePointerType(pointerTypeRef.current, true) && ignoreMouse) return;
                    if (eventOption === "click") return;
                    if (open && toggle && (dataRef.current.openEvent ? dataRef.current.openEvent.type === "mousedown" : true)) onOpenChange(false, event.nativeEvent);
                    else {
                        // Prevent stealing focus from the floating element
                        event.preventDefault();
                        onOpenChange(true, event.nativeEvent);
                    }
                },
                onClick (event) {
                    if (eventOption === "mousedown" && pointerTypeRef.current) {
                        pointerTypeRef.current = undefined;
                        return;
                    }
                    if ($3f69993268aa5b7a$var$isMouseLikePointerType(pointerTypeRef.current, true) && ignoreMouse) return;
                    if (open && toggle && (dataRef.current.openEvent ? dataRef.current.openEvent.type === "click" : true)) onOpenChange(false, event.nativeEvent);
                    else onOpenChange(true, event.nativeEvent);
                },
                onKeyDown (event) {
                    pointerTypeRef.current = undefined;
                    if (event.defaultPrevented || !keyboardHandlers || $3f69993268aa5b7a$var$isButtonTarget(event)) return;
                    if (event.key === " " && !$3f69993268aa5b7a$var$isSpaceIgnored(domReference)) {
                        // Prevent scrolling
                        event.preventDefault();
                        didKeyDownRef.current = true;
                    }
                    if (event.key === "Enter") {
                        if (open && toggle) onOpenChange(false, event.nativeEvent);
                        else onOpenChange(true, event.nativeEvent);
                    }
                },
                onKeyUp (event) {
                    if (event.defaultPrevented || !keyboardHandlers || $3f69993268aa5b7a$var$isButtonTarget(event) || $3f69993268aa5b7a$var$isSpaceIgnored(domReference)) return;
                    if (event.key === " " && didKeyDownRef.current) {
                        didKeyDownRef.current = false;
                        if (open && toggle) onOpenChange(false, event.nativeEvent);
                        else onOpenChange(true, event.nativeEvent);
                    }
                }
            }
        };
    }, [
        enabled,
        dataRef,
        eventOption,
        ignoreMouse,
        keyboardHandlers,
        domReference,
        toggle,
        open,
        onOpenChange
    ]);
}
// `toString()` prevents bundlers from trying to `import { useInsertionEffect } from 'react'`
const $3f69993268aa5b7a$var$useInsertionEffect = $acw62[/*#__PURE__*/ "useInsertionEffect".toString()];
const $3f69993268aa5b7a$var$useSafeInsertionEffect = $3f69993268aa5b7a$var$useInsertionEffect || ((fn)=>fn());
function $3f69993268aa5b7a$var$useEffectEvent(callback) {
    const ref = $acw62.useRef(()=>{});
    $3f69993268aa5b7a$var$useSafeInsertionEffect(()=>{
        ref.current = callback;
    });
    return $acw62.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current == null ? void 0 : ref.current(...args);
    }, []);
}
function $3f69993268aa5b7a$var$createVirtualElement(domRef, data) {
    let offsetX = null;
    let offsetY = null;
    let isAutoUpdateEvent = false;
    return {
        contextElement: domRef.current || undefined,
        getBoundingClientRect () {
            var _domRef$current, _data$dataRef$current;
            const domRect = ((_domRef$current = domRef.current) == null ? void 0 : _domRef$current.getBoundingClientRect()) || {
                width: 0,
                height: 0,
                x: 0,
                y: 0
            };
            const isXAxis = data.axis === "x" || data.axis === "both";
            const isYAxis = data.axis === "y" || data.axis === "both";
            const canTrackCursorOnAutoUpdate = [
                "mouseenter",
                "mousemove"
            ].includes(((_data$dataRef$current = data.dataRef.current.openEvent) == null ? void 0 : _data$dataRef$current.type) || "") && data.pointerType !== "touch";
            let width = domRect.width;
            let height = domRect.height;
            let x = domRect.x;
            let y = domRect.y;
            if (offsetX == null && data.x && isXAxis) offsetX = domRect.x - data.x;
            if (offsetY == null && data.y && isYAxis) offsetY = domRect.y - data.y;
            x -= offsetX || 0;
            y -= offsetY || 0;
            width = 0;
            height = 0;
            if (!isAutoUpdateEvent || canTrackCursorOnAutoUpdate) {
                width = data.axis === "y" ? domRect.width : 0;
                height = data.axis === "x" ? domRect.height : 0;
                x = isXAxis && data.x != null ? data.x : x;
                y = isYAxis && data.y != null ? data.y : y;
            } else if (isAutoUpdateEvent && !canTrackCursorOnAutoUpdate) {
                height = data.axis === "x" ? domRect.height : height;
                width = data.axis === "y" ? domRect.width : width;
            }
            isAutoUpdateEvent = true;
            return {
                width: width,
                height: height,
                x: x,
                y: y,
                top: y,
                right: x + width,
                bottom: y + height,
                left: x
            };
        }
    };
}
function $3f69993268aa5b7a$var$isMouseBasedEvent(event) {
    return event != null && event.clientX != null;
}
/**
 * Positions the floating element relative to a client point (in the viewport),
 * such as the mouse position. By default, it follows the mouse cursor.
 * @see https://floating-ui.com/docs/useClientPoint
 */ function $3f69993268aa5b7a$export$7fe170a73a621816(context, props) {
    if (props === void 0) props = {};
    const { open: open, refs: refs, dataRef: dataRef, elements: { floating: floating } } = context;
    const { enabled: enabled = true, axis: axis = "both", x: x = null, y: y = null } = props;
    const initialRef = $acw62.useRef(false);
    const cleanupListenerRef = $acw62.useRef(null);
    const [pointerType, setPointerType] = $acw62.useState();
    const [reactive, setReactive] = $acw62.useState([]);
    const setReference = $3f69993268aa5b7a$var$useEffectEvent((x, y)=>{
        if (initialRef.current) return;
        // Prevent setting if the open event was not a mouse-like one
        // (e.g. focus to open, then hover over the reference element).
        // Only apply if the event exists.
        if (dataRef.current.openEvent && !$3f69993268aa5b7a$var$isMouseBasedEvent(dataRef.current.openEvent)) return;
        refs.setPositionReference($3f69993268aa5b7a$var$createVirtualElement(refs.domReference, {
            x: x,
            y: y,
            axis: axis,
            dataRef: dataRef,
            pointerType: pointerType
        }));
    });
    const handleReferenceEnterOrMove = $3f69993268aa5b7a$var$useEffectEvent((event)=>{
        if (x != null || y != null) return;
        if (!open) setReference(event.clientX, event.clientY);
        else if (!cleanupListenerRef.current) // If there's no cleanup, there's no listener, but we want to ensure
        // we add the listener if the cursor landed on the floating element and
        // then back on the reference (i.e. it's interactive).
        setReactive([]);
    });
    // If the pointer is a mouse-like pointer, we want to continue following the
    // mouse even if the floating element is transitioning out. On touch
    // devices, this is undesirable because the floating element will move to
    // the dismissal touch point.
    const openCheck = $3f69993268aa5b7a$var$isMouseLikePointerType(pointerType) ? floating : open;
    const addListener = $acw62.useCallback(()=>{
        // Explicitly specified `x`/`y` coordinates shouldn't add a listener.
        if (!openCheck || !enabled || x != null || y != null) return;
        const win = $3f69993268aa5b7a$var$getWindow(refs.floating.current);
        function handleMouseMove(event) {
            const target = $3f69993268aa5b7a$var$getTarget(event);
            if (!$3f69993268aa5b7a$var$contains(refs.floating.current, target)) setReference(event.clientX, event.clientY);
            else {
                win.removeEventListener("mousemove", handleMouseMove);
                cleanupListenerRef.current = null;
            }
        }
        if (!dataRef.current.openEvent || $3f69993268aa5b7a$var$isMouseBasedEvent(dataRef.current.openEvent)) {
            win.addEventListener("mousemove", handleMouseMove);
            const cleanup = ()=>{
                win.removeEventListener("mousemove", handleMouseMove);
                cleanupListenerRef.current = null;
            };
            cleanupListenerRef.current = cleanup;
            return cleanup;
        }
        refs.setPositionReference(refs.domReference.current);
    }, [
        dataRef,
        enabled,
        openCheck,
        refs,
        setReference,
        x,
        y
    ]);
    $acw62.useEffect(()=>{
        return addListener();
    }, [
        addListener,
        reactive
    ]);
    $acw62.useEffect(()=>{
        if (enabled && !floating) initialRef.current = false;
    }, [
        enabled,
        floating
    ]);
    $acw62.useEffect(()=>{
        if (!enabled && open) initialRef.current = true;
    }, [
        enabled,
        open
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        if (enabled && (x != null || y != null)) {
            initialRef.current = false;
            setReference(x, y);
        }
    }, [
        enabled,
        x,
        y,
        setReference
    ]);
    return $acw62.useMemo(()=>{
        if (!enabled) return {};
        function setPointerTypeRef(_ref) {
            let { pointerType: pointerType } = _ref;
            setPointerType(pointerType);
        }
        return {
            reference: {
                onPointerDown: setPointerTypeRef,
                onPointerEnter: setPointerTypeRef,
                onMouseMove: handleReferenceEnterOrMove,
                onMouseEnter: handleReferenceEnterOrMove
            }
        };
    }, [
        enabled,
        handleReferenceEnterOrMove
    ]);
}
/**
 * Check whether the event.target is within the provided node. Uses event.composedPath if available for custom element support.
 *
 * @param event The event whose target/composedPath to check
 * @param node The node to check against
 * @returns Whether the event.target/composedPath is within the node.
 */ function $3f69993268aa5b7a$var$isEventTargetWithin(event, node) {
    if (node == null) return false;
    if ("composedPath" in event) return event.composedPath().includes(node);
    // TS thinks `event` is of type never as it assumes all browsers support composedPath, but browsers without shadow dom don't
    const e = event;
    return e.target != null && node.contains(e.target);
}
const $3f69993268aa5b7a$var$bubbleHandlerKeys = {
    pointerdown: "onPointerDown",
    mousedown: "onMouseDown",
    click: "onClick"
};
const $3f69993268aa5b7a$var$captureHandlerKeys = {
    pointerdown: "onPointerDownCapture",
    mousedown: "onMouseDownCapture",
    click: "onClickCapture"
};
const $3f69993268aa5b7a$var$normalizeBubblesProp = (bubbles)=>{
    var _bubbles$escapeKey, _bubbles$outsidePress;
    return {
        escapeKeyBubbles: typeof bubbles === "boolean" ? bubbles : (_bubbles$escapeKey = bubbles == null ? void 0 : bubbles.escapeKey) != null ? _bubbles$escapeKey : false,
        outsidePressBubbles: typeof bubbles === "boolean" ? bubbles : (_bubbles$outsidePress = bubbles == null ? void 0 : bubbles.outsidePress) != null ? _bubbles$outsidePress : true
    };
};
/**
 * Closes the floating element when a dismissal is requested — by default, when
 * the user presses the `escape` key or outside of the floating element.
 * @see https://floating-ui.com/docs/useDismiss
 */ function $3f69993268aa5b7a$export$fcdf1ba5fafc089b(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, events: events, nodeId: nodeId, elements: { reference: reference, domReference: domReference, floating: floating }, dataRef: dataRef } = context;
    const { enabled: enabled = true, escapeKey: escapeKey = true, outsidePress: unstable_outsidePress = true, outsidePressEvent: outsidePressEvent = "pointerdown", referencePress: referencePress = false, referencePressEvent: referencePressEvent = "pointerdown", ancestorScroll: ancestorScroll = false, bubbles: bubbles } = props;
    const tree = $3f69993268aa5b7a$export$db0c2a7c7a2a4f69();
    const nested = $3f69993268aa5b7a$export$165209eae06d3488() != null;
    const outsidePressFn = $3f69993268aa5b7a$var$useEffectEvent(typeof unstable_outsidePress === "function" ? unstable_outsidePress : ()=>false);
    const outsidePress = typeof unstable_outsidePress === "function" ? outsidePressFn : unstable_outsidePress;
    const insideReactTreeRef = $acw62.useRef(false);
    const { escapeKeyBubbles: escapeKeyBubbles, outsidePressBubbles: outsidePressBubbles } = $3f69993268aa5b7a$var$normalizeBubblesProp(bubbles);
    const closeOnEscapeKeyDown = $3f69993268aa5b7a$var$useEffectEvent((event)=>{
        if (!open || !enabled || !escapeKey || event.key !== "Escape") return;
        const children = tree ? $3f69993268aa5b7a$var$getChildren(tree.nodesRef.current, nodeId) : [];
        if (!escapeKeyBubbles) {
            event.stopPropagation();
            if (children.length > 0) {
                let shouldDismiss = true;
                children.forEach((child)=>{
                    var _child$context;
                    if ((_child$context = child.context) != null && _child$context.open && !child.context.dataRef.current.__escapeKeyBubbles) {
                        shouldDismiss = false;
                        return;
                    }
                });
                if (!shouldDismiss) return;
            }
        }
        events.emit("dismiss", {
            type: "escapeKey",
            data: {
                returnFocus: {
                    preventScroll: false
                }
            }
        });
        onOpenChange(false, $3f69993268aa5b7a$var$isReactEvent(event) ? event.nativeEvent : event);
    });
    const closeOnPressOutside = $3f69993268aa5b7a$var$useEffectEvent((event)=>{
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = insideReactTreeRef.current;
        insideReactTreeRef.current = false;
        if (insideReactTree) return;
        if (typeof outsidePress === "function" && !outsidePress(event)) return;
        const target = $3f69993268aa5b7a$var$getTarget(event);
        // Check if the click occurred on the scrollbar
        if ($3f69993268aa5b7a$var$isHTMLElement(target) && floating) {
            // In Firefox, `target.scrollWidth > target.clientWidth` for inline
            // elements.
            const canScrollX = target.clientWidth > 0 && target.scrollWidth > target.clientWidth;
            const canScrollY = target.clientHeight > 0 && target.scrollHeight > target.clientHeight;
            let xCond = canScrollY && event.offsetX > target.clientWidth;
            // In some browsers it is possible to change the <body> (or window)
            // scrollbar to the left side, but is very rare and is difficult to
            // check for. Plus, for modal dialogs with backdrops, it is more
            // important that the backdrop is checked but not so much the window.
            if (canScrollY) {
                const isRTL = $3f69993268aa5b7a$var$getWindow(floating).getComputedStyle(target).direction === "rtl";
                if (isRTL) xCond = event.offsetX <= target.offsetWidth - target.clientWidth;
            }
            if (xCond || canScrollX && event.offsetY > target.clientHeight) return;
        }
        const targetIsInsideChildren = tree && $3f69993268aa5b7a$var$getChildren(tree.nodesRef.current, nodeId).some((node)=>{
            var _node$context;
            return $3f69993268aa5b7a$var$isEventTargetWithin(event, (_node$context = node.context) == null ? void 0 : _node$context.elements.floating);
        });
        if ($3f69993268aa5b7a$var$isEventTargetWithin(event, floating) || $3f69993268aa5b7a$var$isEventTargetWithin(event, domReference) || targetIsInsideChildren) return;
        const children = tree ? $3f69993268aa5b7a$var$getChildren(tree.nodesRef.current, nodeId) : [];
        if (children.length > 0) {
            let shouldDismiss = true;
            children.forEach((child)=>{
                var _child$context2;
                if ((_child$context2 = child.context) != null && _child$context2.open && !child.context.dataRef.current.__outsidePressBubbles) {
                    shouldDismiss = false;
                    return;
                }
            });
            if (!shouldDismiss) return;
        }
        events.emit("dismiss", {
            type: "outsidePress",
            data: {
                returnFocus: nested ? {
                    preventScroll: true
                } : $3f69993268aa5b7a$var$isVirtualClick(event) || $3f69993268aa5b7a$var$isVirtualPointerEvent(event)
            }
        });
        onOpenChange(false, event);
    });
    $acw62.useEffect(()=>{
        if (!open || !enabled) return;
        dataRef.current.__escapeKeyBubbles = escapeKeyBubbles;
        dataRef.current.__outsidePressBubbles = outsidePressBubbles;
        function onScroll(event) {
            onOpenChange(false, event);
        }
        const doc = $3f69993268aa5b7a$var$getDocument(floating);
        escapeKey && doc.addEventListener("keydown", closeOnEscapeKeyDown);
        outsidePress && doc.addEventListener(outsidePressEvent, closeOnPressOutside);
        let ancestors = [];
        if (ancestorScroll) {
            if ($3f69993268aa5b7a$var$isElement(domReference)) ancestors = (0, $071542918b64c1f1$export$3b57c1601291186b)(domReference);
            if ($3f69993268aa5b7a$var$isElement(floating)) ancestors = ancestors.concat((0, $071542918b64c1f1$export$3b57c1601291186b)(floating));
            if (!$3f69993268aa5b7a$var$isElement(reference) && reference && reference.contextElement) ancestors = ancestors.concat((0, $071542918b64c1f1$export$3b57c1601291186b)(reference.contextElement));
        }
        // Ignore the visual viewport for scrolling dismissal (allow pinch-zoom)
        ancestors = ancestors.filter((ancestor)=>{
            var _doc$defaultView;
            return ancestor !== ((_doc$defaultView = doc.defaultView) == null ? void 0 : _doc$defaultView.visualViewport);
        });
        ancestors.forEach((ancestor)=>{
            ancestor.addEventListener("scroll", onScroll, {
                passive: true
            });
        });
        return ()=>{
            escapeKey && doc.removeEventListener("keydown", closeOnEscapeKeyDown);
            outsidePress && doc.removeEventListener(outsidePressEvent, closeOnPressOutside);
            ancestors.forEach((ancestor)=>{
                ancestor.removeEventListener("scroll", onScroll);
            });
        };
    }, [
        dataRef,
        floating,
        domReference,
        reference,
        escapeKey,
        outsidePress,
        outsidePressEvent,
        open,
        onOpenChange,
        ancestorScroll,
        enabled,
        escapeKeyBubbles,
        outsidePressBubbles,
        closeOnEscapeKeyDown,
        closeOnPressOutside
    ]);
    $acw62.useEffect(()=>{
        insideReactTreeRef.current = false;
    }, [
        outsidePress,
        outsidePressEvent
    ]);
    return $acw62.useMemo(()=>{
        if (!enabled) return {};
        return {
            reference: {
                onKeyDown: closeOnEscapeKeyDown,
                [$3f69993268aa5b7a$var$bubbleHandlerKeys[referencePressEvent]]: (event)=>{
                    if (referencePress) {
                        events.emit("dismiss", {
                            type: "referencePress",
                            data: {
                                returnFocus: false
                            }
                        });
                        onOpenChange(false, event.nativeEvent);
                    }
                }
            },
            floating: {
                onKeyDown: closeOnEscapeKeyDown,
                [$3f69993268aa5b7a$var$captureHandlerKeys[outsidePressEvent]]: ()=>{
                    insideReactTreeRef.current = true;
                }
            }
        };
    }, [
        enabled,
        events,
        referencePress,
        outsidePressEvent,
        referencePressEvent,
        onOpenChange,
        closeOnEscapeKeyDown
    ]);
}
/**
 * Provides data to position a floating element and context to add interactions.
 * @see https://floating-ui.com/docs/react
 */ function $3f69993268aa5b7a$export$4e02a5c1d08bac65(options) {
    var _options$elements;
    if (options === void 0) options = {};
    const { open: open = false, onOpenChange: unstable_onOpenChange, nodeId: nodeId } = options;
    const [_domReference, setDomReference] = $acw62.useState(null);
    const domReference = ((_options$elements = options.elements) == null ? void 0 : _options$elements.reference) || _domReference;
    const position = (0, $23a8f689f1d4c3be$export$4e02a5c1d08bac65)(options);
    const tree = $3f69993268aa5b7a$export$db0c2a7c7a2a4f69();
    const onOpenChange = $3f69993268aa5b7a$var$useEffectEvent((open, event)=>{
        if (open) dataRef.current.openEvent = event;
        unstable_onOpenChange == null || unstable_onOpenChange(open, event);
    });
    const domReferenceRef = $acw62.useRef(null);
    const dataRef = $acw62.useRef({});
    const events = $acw62.useState(()=>$3f69993268aa5b7a$var$createPubSub())[0];
    const floatingId = $3f69993268aa5b7a$export$f680877a34711e37();
    const setPositionReference = $acw62.useCallback((node)=>{
        const positionReference = $3f69993268aa5b7a$var$isElement(node) ? {
            getBoundingClientRect: ()=>node.getBoundingClientRect(),
            contextElement: node
        } : node;
        position.refs.setReference(positionReference);
    }, [
        position.refs
    ]);
    const setReference = $acw62.useCallback((node)=>{
        if ($3f69993268aa5b7a$var$isElement(node) || node === null) {
            domReferenceRef.current = node;
            setDomReference(node);
        }
        // Backwards-compatibility for passing a virtual element to `reference`
        // after it has set the DOM reference.
        if ($3f69993268aa5b7a$var$isElement(position.refs.reference.current) || position.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
        // `null` to support `positionReference` + an unstable `reference`
        // callback ref.
        node !== null && !$3f69993268aa5b7a$var$isElement(node)) position.refs.setReference(node);
    }, [
        position.refs
    ]);
    const refs = $acw62.useMemo(()=>({
            ...position.refs,
            setReference: setReference,
            setPositionReference: setPositionReference,
            domReference: domReferenceRef
        }), [
        position.refs,
        setReference,
        setPositionReference
    ]);
    const elements = $acw62.useMemo(()=>({
            ...position.elements,
            domReference: domReference
        }), [
        position.elements,
        domReference
    ]);
    const context = $acw62.useMemo(()=>({
            ...position,
            refs: refs,
            elements: elements,
            dataRef: dataRef,
            nodeId: nodeId,
            floatingId: floatingId,
            events: events,
            open: open,
            onOpenChange: onOpenChange
        }), [
        position,
        nodeId,
        floatingId,
        events,
        open,
        onOpenChange,
        refs,
        elements
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        const node = tree == null ? void 0 : tree.nodesRef.current.find((node)=>node.id === nodeId);
        if (node) node.context = context;
    });
    return $acw62.useMemo(()=>({
            ...position,
            context: context,
            refs: refs,
            elements: elements
        }), [
        position,
        refs,
        elements,
        context
    ]);
}
/**
 * Opens the floating element while the reference element has focus, like CSS
 * `:focus`.
 * @see https://floating-ui.com/docs/useFocus
 */ function $3f69993268aa5b7a$export$f8168d8dd8fd66e6(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, dataRef: dataRef, events: events, refs: refs, elements: { floating: floating, domReference: domReference } } = context;
    const { enabled: enabled = true, keyboardOnly: keyboardOnly = true } = props;
    const pointerTypeRef = $acw62.useRef("");
    const blockFocusRef = $acw62.useRef(false);
    const timeoutRef = $acw62.useRef();
    $acw62.useEffect(()=>{
        if (!enabled) return;
        const doc = $3f69993268aa5b7a$var$getDocument(floating);
        const win = doc.defaultView || window;
        // If the reference was focused and the user left the tab/window, and the
        // floating element was not open, the focus should be blocked when they
        // return to the tab/window.
        function onBlur() {
            if (!open && $3f69993268aa5b7a$var$isHTMLElement(domReference) && domReference === $3f69993268aa5b7a$var$activeElement($3f69993268aa5b7a$var$getDocument(domReference))) blockFocusRef.current = true;
        }
        win.addEventListener("blur", onBlur);
        return ()=>{
            win.removeEventListener("blur", onBlur);
        };
    }, [
        floating,
        domReference,
        open,
        enabled
    ]);
    $acw62.useEffect(()=>{
        if (!enabled) return;
        function onDismiss(payload) {
            if (payload.type === "referencePress" || payload.type === "escapeKey") blockFocusRef.current = true;
        }
        events.on("dismiss", onDismiss);
        return ()=>{
            events.off("dismiss", onDismiss);
        };
    }, [
        events,
        enabled
    ]);
    $acw62.useEffect(()=>{
        return ()=>{
            clearTimeout(timeoutRef.current);
        };
    }, []);
    return $acw62.useMemo(()=>{
        if (!enabled) return {};
        return {
            reference: {
                onPointerDown (_ref) {
                    let { pointerType: pointerType } = _ref;
                    pointerTypeRef.current = pointerType;
                    blockFocusRef.current = !!(pointerType && keyboardOnly);
                },
                onMouseLeave () {
                    blockFocusRef.current = false;
                },
                onFocus (event) {
                    var _dataRef$current$open;
                    if (blockFocusRef.current) return;
                    // Dismiss with click should ignore the subsequent `focus` trigger,
                    // but only if the click originated inside the reference element.
                    if (event.type === "focus" && ((_dataRef$current$open = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open.type) === "mousedown" && $3f69993268aa5b7a$var$isEventTargetWithin(dataRef.current.openEvent, domReference)) return;
                    onOpenChange(true, event.nativeEvent);
                },
                onBlur (event) {
                    blockFocusRef.current = false;
                    const relatedTarget = event.relatedTarget;
                    // Hit the non-modal focus management portal guard. Focus will be
                    // moved into the floating element immediately after.
                    const movedToFocusGuard = $3f69993268aa5b7a$var$isElement(relatedTarget) && relatedTarget.hasAttribute($3f69993268aa5b7a$var$createAttribute("focus-guard")) && relatedTarget.getAttribute("data-type") === "outside";
                    // Wait for the window blur listener to fire.
                    timeoutRef.current = setTimeout(()=>{
                        // When focusing the reference element (e.g. regular click), then
                        // clicking into the floating element, prevent it from hiding.
                        // Note: it must be focusable, e.g. `tabindex="-1"`.
                        if ($3f69993268aa5b7a$var$contains(refs.floating.current, relatedTarget) || $3f69993268aa5b7a$var$contains(domReference, relatedTarget) || movedToFocusGuard) return;
                        onOpenChange(false, event.nativeEvent);
                    });
                }
            }
        };
    }, [
        enabled,
        keyboardOnly,
        domReference,
        refs,
        dataRef,
        onOpenChange
    ]);
}
function $3f69993268aa5b7a$var$mergeProps(userProps, propsList, elementKey) {
    const map = new Map();
    return {
        ...elementKey === "floating" && {
            tabIndex: -1
        },
        ...userProps,
        ...propsList.map((value)=>value ? value[elementKey] : null).concat(userProps).reduce((acc, props)=>{
            if (!props) return acc;
            Object.entries(props).forEach((_ref)=>{
                let [key, value] = _ref;
                if (key.indexOf("on") === 0) {
                    if (!map.has(key)) map.set(key, []);
                    if (typeof value === "function") {
                        var _map$get;
                        (_map$get = map.get(key)) == null || _map$get.push(value);
                        acc[key] = function() {
                            var _map$get2;
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                            return (_map$get2 = map.get(key)) == null ? void 0 : _map$get2.map((fn)=>fn(...args)).find((val)=>val !== undefined);
                        };
                    }
                } else acc[key] = value;
            });
            return acc;
        }, {})
    };
}
/**
 * Merges an array of interaction hooks' props into prop getters, allowing
 * event handler functions to be composed together without overwriting one
 * another.
 * @see https://floating-ui.com/docs/react#interaction-hooks
 */ function $3f69993268aa5b7a$export$a519f7794e446ddd(propsList) {
    if (propsList === void 0) propsList = [];
    // The dependencies are a dynamic array, so we can't use the linter's
    // suggestion to add it to the deps array.
    const deps = propsList;
    const getReferenceProps = $acw62.useCallback((userProps)=>$3f69993268aa5b7a$var$mergeProps(userProps, propsList, "reference"), // eslint-disable-next-line react-hooks/exhaustive-deps
    deps);
    const getFloatingProps = $acw62.useCallback((userProps)=>$3f69993268aa5b7a$var$mergeProps(userProps, propsList, "floating"), // eslint-disable-next-line react-hooks/exhaustive-deps
    deps);
    const getItemProps = $acw62.useCallback((userProps)=>$3f69993268aa5b7a$var$mergeProps(userProps, propsList, "item"), // Granularly check for `item` changes, because the `getItemProps` getter
    // should be as referentially stable as possible since it may be passed as
    // a prop to many components. All `item` key values must therefore be
    // memoized.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    propsList.map((key)=>key == null ? void 0 : key.item));
    return $acw62.useMemo(()=>({
            getReferenceProps: getReferenceProps,
            getFloatingProps: getFloatingProps,
            getItemProps: getItemProps
        }), [
        getReferenceProps,
        getFloatingProps,
        getItemProps
    ]);
}
let $3f69993268aa5b7a$var$isPreventScrollSupported = false;
const $3f69993268aa5b7a$var$ARROW_UP = "ArrowUp";
const $3f69993268aa5b7a$var$ARROW_DOWN = "ArrowDown";
const $3f69993268aa5b7a$var$ARROW_LEFT = "ArrowLeft";
const $3f69993268aa5b7a$var$ARROW_RIGHT = "ArrowRight";
function $3f69993268aa5b7a$var$isDifferentRow(index, cols, prevRow) {
    return Math.floor(index / cols) !== prevRow;
}
function $3f69993268aa5b7a$var$isIndexOutOfBounds(listRef, index) {
    return index < 0 || index >= listRef.current.length;
}
function $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, _temp) {
    let { startingIndex: startingIndex = -1, decrement: decrement = false, disabledIndices: disabledIndices, amount: amount = 1 } = _temp === void 0 ? {} : _temp;
    const list = listRef.current;
    let index = startingIndex;
    do {
        var _list$index, _list$index2;
        index = index + (decrement ? -amount : amount);
    }while (index >= 0 && index <= list.length - 1 && (disabledIndices ? disabledIndices.includes(index) : list[index] == null || ((_list$index = list[index]) == null ? void 0 : _list$index.hasAttribute("disabled")) || ((_list$index2 = list[index]) == null ? void 0 : _list$index2.getAttribute("aria-disabled")) === "true"));
    return index;
}
function $3f69993268aa5b7a$var$doSwitch(orientation, vertical, horizontal) {
    switch(orientation){
        case "vertical":
            return vertical;
        case "horizontal":
            return horizontal;
        default:
            return vertical || horizontal;
    }
}
function $3f69993268aa5b7a$var$isMainOrientationKey(key, orientation) {
    const vertical = key === $3f69993268aa5b7a$var$ARROW_UP || key === $3f69993268aa5b7a$var$ARROW_DOWN;
    const horizontal = key === $3f69993268aa5b7a$var$ARROW_LEFT || key === $3f69993268aa5b7a$var$ARROW_RIGHT;
    return $3f69993268aa5b7a$var$doSwitch(orientation, vertical, horizontal);
}
function $3f69993268aa5b7a$var$isMainOrientationToEndKey(key, orientation, rtl) {
    const vertical = key === $3f69993268aa5b7a$var$ARROW_DOWN;
    const horizontal = rtl ? key === $3f69993268aa5b7a$var$ARROW_LEFT : key === $3f69993268aa5b7a$var$ARROW_RIGHT;
    return $3f69993268aa5b7a$var$doSwitch(orientation, vertical, horizontal) || key === "Enter" || key == " " || key === "";
}
function $3f69993268aa5b7a$var$isCrossOrientationOpenKey(key, orientation, rtl) {
    const vertical = rtl ? key === $3f69993268aa5b7a$var$ARROW_LEFT : key === $3f69993268aa5b7a$var$ARROW_RIGHT;
    const horizontal = key === $3f69993268aa5b7a$var$ARROW_DOWN;
    return $3f69993268aa5b7a$var$doSwitch(orientation, vertical, horizontal);
}
function $3f69993268aa5b7a$var$isCrossOrientationCloseKey(key, orientation, rtl) {
    const vertical = rtl ? key === $3f69993268aa5b7a$var$ARROW_RIGHT : key === $3f69993268aa5b7a$var$ARROW_LEFT;
    const horizontal = key === $3f69993268aa5b7a$var$ARROW_UP;
    return $3f69993268aa5b7a$var$doSwitch(orientation, vertical, horizontal);
}
function $3f69993268aa5b7a$var$getMinIndex(listRef, disabledIndices) {
    return $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
        disabledIndices: disabledIndices
    });
}
function $3f69993268aa5b7a$var$getMaxIndex(listRef, disabledIndices) {
    return $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
        decrement: true,
        startingIndex: listRef.current.length,
        disabledIndices: disabledIndices
    });
}
/**
 * Adds arrow key-based navigation of a list of items, either using real DOM
 * focus or virtual focus.
 * @see https://floating-ui.com/docs/useListNavigation
 */ function $3f69993268aa5b7a$export$b5d22cac4ad33f40(context, props) {
    const { open: open, onOpenChange: onOpenChange, refs: refs, elements: { domReference: domReference, floating: floating } } = context;
    const { listRef: listRef, activeIndex: activeIndex, onNavigate: unstable_onNavigate = ()=>{}, enabled: enabled = true, selectedIndex: selectedIndex = null, allowEscape: allowEscape = false, loop: loop = false, nested: nested = false, rtl: rtl = false, virtual: virtual = false, focusItemOnOpen: focusItemOnOpen = "auto", focusItemOnHover: focusItemOnHover = true, openOnArrowKeyDown: openOnArrowKeyDown = true, disabledIndices: disabledIndices, orientation: orientation = "vertical", cols: cols = 1, scrollItemIntoView: scrollItemIntoView = true } = props;
    const parentId = $3f69993268aa5b7a$export$165209eae06d3488();
    const tree = $3f69993268aa5b7a$export$db0c2a7c7a2a4f69();
    const onNavigate = $3f69993268aa5b7a$var$useEffectEvent(unstable_onNavigate);
    const focusItemOnOpenRef = $acw62.useRef(focusItemOnOpen);
    const indexRef = $acw62.useRef(selectedIndex != null ? selectedIndex : -1);
    const keyRef = $acw62.useRef(null);
    const isPointerModalityRef = $acw62.useRef(true);
    const previousOnNavigateRef = $acw62.useRef(onNavigate);
    const previousMountedRef = $acw62.useRef(!!floating);
    const forceSyncFocus = $acw62.useRef(false);
    const forceScrollIntoViewRef = $acw62.useRef(false);
    const disabledIndicesRef = $3f69993268aa5b7a$var$useLatestRef(disabledIndices);
    const latestOpenRef = $3f69993268aa5b7a$var$useLatestRef(open);
    const scrollItemIntoViewRef = $3f69993268aa5b7a$var$useLatestRef(scrollItemIntoView);
    const [activeId, setActiveId] = $acw62.useState();
    const focusItem = $3f69993268aa5b7a$var$useEffectEvent(function(listRef, indexRef, forceScrollIntoView) {
        if (forceScrollIntoView === void 0) forceScrollIntoView = false;
        const item = listRef.current[indexRef.current];
        if (!item) return;
        if (virtual) setActiveId(item.id);
        else $3f69993268aa5b7a$var$enqueueFocus(item, {
            preventScroll: true,
            // Mac Safari does not move the virtual cursor unless the focus call
            // is sync. However, for the very first focus call, we need to wait
            // for the position to be ready in order to prevent unwanted
            // scrolling. This means the virtual cursor will not move to the first
            // item when first opening the floating element, but will on
            // subsequent calls. `preventScroll` is supported in modern Safari,
            // so we can use that instead.
            // iOS Safari must be async or the first item will not be focused.
            sync: $3f69993268aa5b7a$var$isMac() && $3f69993268aa5b7a$var$isSafari() ? $3f69993268aa5b7a$var$isPreventScrollSupported || forceSyncFocus.current : false
        });
        requestAnimationFrame(()=>{
            const scrollIntoViewOptions = scrollItemIntoViewRef.current;
            const shouldScrollIntoView = scrollIntoViewOptions && item && (forceScrollIntoView || !isPointerModalityRef.current);
            if (shouldScrollIntoView) // JSDOM doesn't support `.scrollIntoView()` but it's widely supported
            // by all browsers.
            item.scrollIntoView == null || item.scrollIntoView(typeof scrollIntoViewOptions === "boolean" ? {
                block: "nearest",
                inline: "nearest"
            } : scrollIntoViewOptions);
        });
    });
    $3f69993268aa5b7a$var$index(()=>{
        document.createElement("div").focus({
            get preventScroll () {
                $3f69993268aa5b7a$var$isPreventScrollSupported = true;
                return false;
            }
        });
    }, []);
    // Sync `selectedIndex` to be the `activeIndex` upon opening the floating
    // element. Also, reset `activeIndex` upon closing the floating element.
    $3f69993268aa5b7a$var$index(()=>{
        if (!enabled) return;
        if (open && floating) {
            if (focusItemOnOpenRef.current && selectedIndex != null) {
                // Regardless of the pointer modality, we want to ensure the selected
                // item comes into view when the floating element is opened.
                forceScrollIntoViewRef.current = true;
                onNavigate(selectedIndex);
            }
        } else if (previousMountedRef.current) {
            // Since the user can specify `onNavigate` conditionally
            // (onNavigate: open ? setActiveIndex : setSelectedIndex),
            // we store and call the previous function.
            indexRef.current = -1;
            previousOnNavigateRef.current(null);
        }
    }, [
        enabled,
        open,
        floating,
        selectedIndex,
        onNavigate
    ]);
    // Sync `activeIndex` to be the focused item while the floating element is
    // open.
    $3f69993268aa5b7a$var$index(()=>{
        if (!enabled) return;
        if (open && floating) {
            if (activeIndex == null) {
                forceSyncFocus.current = false;
                if (selectedIndex != null) return;
                // Reset while the floating element was open (e.g. the list changed).
                if (previousMountedRef.current) {
                    indexRef.current = -1;
                    focusItem(listRef, indexRef);
                }
                // Initial sync.
                if (!previousMountedRef.current && focusItemOnOpenRef.current && (keyRef.current != null || focusItemOnOpenRef.current === true && keyRef.current == null)) {
                    let runs = 0;
                    const waitForListPopulated = ()=>{
                        if (listRef.current[0] == null) {
                            // Avoid letting the browser paint if possible on the first try,
                            // otherwise use rAF. Don't try more than twice, since something
                            // is wrong otherwise.
                            if (runs < 2) {
                                const scheduler = runs ? requestAnimationFrame : queueMicrotask;
                                scheduler(waitForListPopulated);
                            }
                            runs++;
                        } else {
                            indexRef.current = keyRef.current == null || $3f69993268aa5b7a$var$isMainOrientationToEndKey(keyRef.current, orientation, rtl) || nested ? $3f69993268aa5b7a$var$getMinIndex(listRef, disabledIndicesRef.current) : $3f69993268aa5b7a$var$getMaxIndex(listRef, disabledIndicesRef.current);
                            keyRef.current = null;
                            onNavigate(indexRef.current);
                        }
                    };
                    waitForListPopulated();
                }
            } else if (!$3f69993268aa5b7a$var$isIndexOutOfBounds(listRef, activeIndex)) {
                indexRef.current = activeIndex;
                focusItem(listRef, indexRef, forceScrollIntoViewRef.current);
                forceScrollIntoViewRef.current = false;
            }
        }
    }, [
        enabled,
        open,
        floating,
        activeIndex,
        selectedIndex,
        nested,
        listRef,
        orientation,
        rtl,
        onNavigate,
        focusItem,
        disabledIndicesRef
    ]);
    // Ensure the parent floating element has focus when a nested child closes
    // to allow arrow key navigation to work after the pointer leaves the child.
    $3f69993268aa5b7a$var$index(()=>{
        if (!enabled) return;
        if (previousMountedRef.current && !floating && tree) {
            var _nodes$find, _nodes$find$context;
            const nodes = tree.nodesRef.current;
            const parent = (_nodes$find = nodes.find((node)=>node.id === parentId)) == null ? void 0 : (_nodes$find$context = _nodes$find.context) == null ? void 0 : _nodes$find$context.elements.floating;
            const activeEl = $3f69993268aa5b7a$var$activeElement($3f69993268aa5b7a$var$getDocument(floating));
            const treeContainsActiveEl = nodes.some((node)=>node.context && $3f69993268aa5b7a$var$contains(node.context.elements.floating, activeEl));
            if (parent && !treeContainsActiveEl) parent.focus({
                preventScroll: true
            });
        }
    }, [
        enabled,
        floating,
        tree,
        parentId
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        previousOnNavigateRef.current = onNavigate;
        previousMountedRef.current = !!floating;
    });
    $3f69993268aa5b7a$var$index(()=>{
        if (!open) keyRef.current = null;
    }, [
        open
    ]);
    const hasActiveIndex = activeIndex != null;
    const item = $acw62.useMemo(()=>{
        function syncCurrentTarget(currentTarget) {
            if (!open) return;
            const index = listRef.current.indexOf(currentTarget);
            if (index !== -1) onNavigate(index);
        }
        const props = {
            onFocus (_ref) {
                let { currentTarget: currentTarget } = _ref;
                syncCurrentTarget(currentTarget);
            },
            onClick: (_ref2)=>{
                let { currentTarget: currentTarget } = _ref2;
                return currentTarget.focus({
                    preventScroll: true
                });
            },
            // Safari
            ...focusItemOnHover && {
                onMouseMove (_ref3) {
                    let { currentTarget: currentTarget } = _ref3;
                    syncCurrentTarget(currentTarget);
                },
                onPointerLeave (_ref4) {
                    let { pointerType: pointerType } = _ref4;
                    if (!isPointerModalityRef.current || pointerType === "touch") return;
                    indexRef.current = -1;
                    focusItem(listRef, indexRef);
                    onNavigate(null);
                    if (!virtual) $3f69993268aa5b7a$var$enqueueFocus(refs.floating.current, {
                        preventScroll: true
                    });
                }
            }
        };
        return props;
    }, [
        open,
        refs,
        focusItem,
        focusItemOnHover,
        listRef,
        onNavigate,
        virtual
    ]);
    return $acw62.useMemo(()=>{
        if (!enabled) return {};
        const disabledIndices = disabledIndicesRef.current;
        function onKeyDown(event) {
            isPointerModalityRef.current = false;
            forceSyncFocus.current = true;
            // If the floating element is animating out, ignore navigation. Otherwise,
            // the `activeIndex` gets set to 0 despite not being open so the next time
            // the user ArrowDowns, the first item won't be focused.
            if (!latestOpenRef.current && event.currentTarget === refs.floating.current) return;
            if (nested && $3f69993268aa5b7a$var$isCrossOrientationCloseKey(event.key, orientation, rtl)) {
                $3f69993268aa5b7a$var$stopEvent(event);
                onOpenChange(false, event.nativeEvent);
                if ($3f69993268aa5b7a$var$isHTMLElement(domReference)) domReference.focus();
                return;
            }
            const currentIndex = indexRef.current;
            const minIndex = $3f69993268aa5b7a$var$getMinIndex(listRef, disabledIndices);
            const maxIndex = $3f69993268aa5b7a$var$getMaxIndex(listRef, disabledIndices);
            if (event.key === "Home") {
                $3f69993268aa5b7a$var$stopEvent(event);
                indexRef.current = minIndex;
                onNavigate(indexRef.current);
            }
            if (event.key === "End") {
                $3f69993268aa5b7a$var$stopEvent(event);
                indexRef.current = maxIndex;
                onNavigate(indexRef.current);
            }
            // Grid navigation.
            if (cols > 1) {
                const prevIndex = indexRef.current;
                if (event.key === $3f69993268aa5b7a$var$ARROW_UP) {
                    $3f69993268aa5b7a$var$stopEvent(event);
                    if (prevIndex === -1) indexRef.current = maxIndex;
                    else {
                        indexRef.current = $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
                            startingIndex: prevIndex,
                            amount: cols,
                            decrement: true,
                            disabledIndices: disabledIndices
                        });
                        if (loop && (prevIndex - cols < minIndex || indexRef.current < 0)) {
                            const col = prevIndex % cols;
                            const maxCol = maxIndex % cols;
                            const offset = maxIndex - (maxCol - col);
                            if (maxCol === col) indexRef.current = maxIndex;
                            else indexRef.current = maxCol > col ? offset : offset - cols;
                        }
                    }
                    if ($3f69993268aa5b7a$var$isIndexOutOfBounds(listRef, indexRef.current)) indexRef.current = prevIndex;
                    onNavigate(indexRef.current);
                }
                if (event.key === $3f69993268aa5b7a$var$ARROW_DOWN) {
                    $3f69993268aa5b7a$var$stopEvent(event);
                    if (prevIndex === -1) indexRef.current = minIndex;
                    else {
                        indexRef.current = $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
                            startingIndex: prevIndex,
                            amount: cols,
                            disabledIndices: disabledIndices
                        });
                        if (loop && prevIndex + cols > maxIndex) indexRef.current = $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
                            startingIndex: prevIndex % cols - cols,
                            amount: cols,
                            disabledIndices: disabledIndices
                        });
                    }
                    if ($3f69993268aa5b7a$var$isIndexOutOfBounds(listRef, indexRef.current)) indexRef.current = prevIndex;
                    onNavigate(indexRef.current);
                }
                // Remains on the same row/column.
                if (orientation === "both") {
                    const prevRow = Math.floor(prevIndex / cols);
                    if (event.key === $3f69993268aa5b7a$var$ARROW_RIGHT) {
                        $3f69993268aa5b7a$var$stopEvent(event);
                        if (prevIndex % cols !== cols - 1) {
                            indexRef.current = $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
                                startingIndex: prevIndex,
                                disabledIndices: disabledIndices
                            });
                            if (loop && $3f69993268aa5b7a$var$isDifferentRow(indexRef.current, cols, prevRow)) indexRef.current = $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
                                startingIndex: prevIndex - prevIndex % cols - 1,
                                disabledIndices: disabledIndices
                            });
                        } else if (loop) indexRef.current = $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
                            startingIndex: prevIndex - prevIndex % cols - 1,
                            disabledIndices: disabledIndices
                        });
                        if ($3f69993268aa5b7a$var$isDifferentRow(indexRef.current, cols, prevRow)) indexRef.current = prevIndex;
                    }
                    if (event.key === $3f69993268aa5b7a$var$ARROW_LEFT) {
                        $3f69993268aa5b7a$var$stopEvent(event);
                        if (prevIndex % cols !== 0) {
                            indexRef.current = $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
                                startingIndex: prevIndex,
                                disabledIndices: disabledIndices,
                                decrement: true
                            });
                            if (loop && $3f69993268aa5b7a$var$isDifferentRow(indexRef.current, cols, prevRow)) indexRef.current = $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
                                startingIndex: prevIndex + (cols - prevIndex % cols),
                                decrement: true,
                                disabledIndices: disabledIndices
                            });
                        } else if (loop) indexRef.current = $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
                            startingIndex: prevIndex + (cols - prevIndex % cols),
                            decrement: true,
                            disabledIndices: disabledIndices
                        });
                        if ($3f69993268aa5b7a$var$isDifferentRow(indexRef.current, cols, prevRow)) indexRef.current = prevIndex;
                    }
                    const lastRow = Math.floor(maxIndex / cols) === prevRow;
                    if ($3f69993268aa5b7a$var$isIndexOutOfBounds(listRef, indexRef.current)) {
                        if (loop && lastRow) indexRef.current = event.key === $3f69993268aa5b7a$var$ARROW_LEFT ? maxIndex : $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
                            startingIndex: prevIndex - prevIndex % cols - 1,
                            disabledIndices: disabledIndices
                        });
                        else indexRef.current = prevIndex;
                    }
                    onNavigate(indexRef.current);
                    return;
                }
            }
            if ($3f69993268aa5b7a$var$isMainOrientationKey(event.key, orientation)) {
                $3f69993268aa5b7a$var$stopEvent(event);
                // Reset the index if no item is focused.
                if (open && !virtual && $3f69993268aa5b7a$var$activeElement(event.currentTarget.ownerDocument) === event.currentTarget) {
                    indexRef.current = $3f69993268aa5b7a$var$isMainOrientationToEndKey(event.key, orientation, rtl) ? minIndex : maxIndex;
                    onNavigate(indexRef.current);
                    return;
                }
                if ($3f69993268aa5b7a$var$isMainOrientationToEndKey(event.key, orientation, rtl)) {
                    if (loop) indexRef.current = currentIndex >= maxIndex ? allowEscape && currentIndex !== listRef.current.length ? -1 : minIndex : $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
                        startingIndex: currentIndex,
                        disabledIndices: disabledIndices
                    });
                    else indexRef.current = Math.min(maxIndex, $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
                        startingIndex: currentIndex,
                        disabledIndices: disabledIndices
                    }));
                } else if (loop) indexRef.current = currentIndex <= minIndex ? allowEscape && currentIndex !== -1 ? listRef.current.length : maxIndex : $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
                    startingIndex: currentIndex,
                    decrement: true,
                    disabledIndices: disabledIndices
                });
                else indexRef.current = Math.max(minIndex, $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
                    startingIndex: currentIndex,
                    decrement: true,
                    disabledIndices: disabledIndices
                }));
                if ($3f69993268aa5b7a$var$isIndexOutOfBounds(listRef, indexRef.current)) onNavigate(null);
                else onNavigate(indexRef.current);
            }
        }
        function checkVirtualMouse(event) {
            if (focusItemOnOpen === "auto" && $3f69993268aa5b7a$var$isVirtualClick(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        function checkVirtualPointer(event) {
            // `pointerdown` fires first, reset the state then perform the checks.
            focusItemOnOpenRef.current = focusItemOnOpen;
            if (focusItemOnOpen === "auto" && $3f69993268aa5b7a$var$isVirtualPointerEvent(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        const ariaActiveDescendantProp = virtual && open && hasActiveIndex && {
            "aria-activedescendant": activeId
        };
        return {
            reference: {
                ...ariaActiveDescendantProp,
                onKeyDown (event) {
                    isPointerModalityRef.current = false;
                    const isArrowKey = event.key.indexOf("Arrow") === 0;
                    if (virtual && open) return onKeyDown(event);
                    // If a floating element should not open on arrow key down, avoid
                    // setting `activeIndex` while it's closed.
                    if (!open && !openOnArrowKeyDown && isArrowKey) return;
                    const isNavigationKey = isArrowKey || event.key === "Enter" || event.key.trim() === "";
                    const isMainKey = $3f69993268aa5b7a$var$isMainOrientationKey(event.key, orientation);
                    const isCrossKey = $3f69993268aa5b7a$var$isCrossOrientationOpenKey(event.key, orientation, rtl);
                    if (isNavigationKey) keyRef.current = nested && isMainKey ? null : event.key;
                    if (nested) {
                        if (isCrossKey) {
                            $3f69993268aa5b7a$var$stopEvent(event);
                            if (open) {
                                indexRef.current = $3f69993268aa5b7a$var$getMinIndex(listRef, disabledIndices);
                                onNavigate(indexRef.current);
                            } else onOpenChange(true, event.nativeEvent);
                        }
                        return;
                    }
                    if (isMainKey) {
                        if (selectedIndex != null) indexRef.current = selectedIndex;
                        $3f69993268aa5b7a$var$stopEvent(event);
                        if (!open && openOnArrowKeyDown) onOpenChange(true, event.nativeEvent);
                        else onKeyDown(event);
                        if (open) onNavigate(indexRef.current);
                    }
                },
                onFocus () {
                    if (open) onNavigate(null);
                },
                onPointerDown: checkVirtualPointer,
                onMouseDown: checkVirtualMouse,
                onClick: checkVirtualMouse
            },
            floating: {
                "aria-orientation": orientation === "both" ? undefined : orientation,
                ...ariaActiveDescendantProp,
                onKeyDown: onKeyDown,
                onPointerMove () {
                    isPointerModalityRef.current = true;
                }
            },
            item: item
        };
    }, [
        domReference,
        refs,
        activeId,
        disabledIndicesRef,
        latestOpenRef,
        listRef,
        enabled,
        orientation,
        rtl,
        virtual,
        open,
        hasActiveIndex,
        nested,
        selectedIndex,
        openOnArrowKeyDown,
        allowEscape,
        cols,
        loop,
        focusItemOnOpen,
        onNavigate,
        onOpenChange,
        item
    ]);
}
/**
 * Merges an array of refs into a single memoized callback ref or `null`.
 * @see https://floating-ui.com/docs/useMergeRefs
 */ function $3f69993268aa5b7a$export$74665b213cb5c4cf(refs) {
    return $acw62.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            refs.forEach((ref)=>{
                if (typeof ref === "function") ref(value);
                else if (ref != null) ref.current = value;
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}
/**
 * Adds base screen reader props to the reference and floating elements for a
 * given floating element `role`.
 * @see https://floating-ui.com/docs/useRole
 */ function $3f69993268aa5b7a$export$f66572793fa256a1(context, props) {
    if (props === void 0) props = {};
    const { open: open, floatingId: floatingId } = context;
    const { enabled: enabled = true, role: role = "dialog" } = props;
    const referenceId = $3f69993268aa5b7a$export$f680877a34711e37();
    return $acw62.useMemo(()=>{
        const floatingProps = {
            id: floatingId,
            role: role
        };
        if (!enabled) return {};
        if (role === "tooltip") return {
            reference: {
                "aria-describedby": open ? floatingId : undefined
            },
            floating: floatingProps
        };
        return {
            reference: {
                "aria-expanded": open ? "true" : "false",
                "aria-haspopup": role === "alertdialog" ? "dialog" : role,
                "aria-controls": open ? floatingId : undefined,
                ...role === "listbox" && {
                    role: "combobox"
                },
                ...role === "menu" && {
                    id: referenceId
                }
            },
            floating: {
                ...floatingProps,
                ...role === "menu" && {
                    "aria-labelledby": referenceId
                }
            }
        };
    }, [
        enabled,
        role,
        open,
        floatingId,
        referenceId
    ]);
}
// Converts a JS style key like `backgroundColor` to a CSS transition-property
// like `background-color`.
const $3f69993268aa5b7a$var$camelCaseToKebabCase = (str)=>str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs)=>(ofs ? "-" : "") + $.toLowerCase());
function $3f69993268aa5b7a$var$execWithArgsOrReturn(valueOrFn, args) {
    return typeof valueOrFn === "function" ? valueOrFn(args) : valueOrFn;
}
function $3f69993268aa5b7a$var$useDelayUnmount(open, durationMs) {
    const [isMounted, setIsMounted] = $acw62.useState(open);
    if (open && !isMounted) setIsMounted(true);
    $acw62.useEffect(()=>{
        if (!open) {
            const timeout = setTimeout(()=>setIsMounted(false), durationMs);
            return ()=>clearTimeout(timeout);
        }
    }, [
        open,
        durationMs
    ]);
    return isMounted;
}
/**
 * Provides a status string to apply CSS transitions to a floating element,
 * correctly handling placement-aware transitions.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstatus
 */ function $3f69993268aa5b7a$export$b2ef21706733f7e5(context, props) {
    if (props === void 0) props = {};
    const { open: open, elements: { floating: floating } } = context;
    const { duration: duration = 250 } = props;
    const isNumberDuration = typeof duration === "number";
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    const [initiated, setInitiated] = $acw62.useState(false);
    const [status, setStatus] = $acw62.useState("unmounted");
    const isMounted = $3f69993268aa5b7a$var$useDelayUnmount(open, closeDuration);
    // `initiated` check prevents this `setState` call from breaking
    // <FloatingPortal />. This call is necessary to ensure subsequent opens
    // after the initial one allows the correct side animation to play when the
    // placement has changed.
    $3f69993268aa5b7a$var$index(()=>{
        if (initiated && !isMounted) setStatus("unmounted");
    }, [
        initiated,
        isMounted
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        if (!floating) return;
        if (open) {
            setStatus("initial");
            const frame = requestAnimationFrame(()=>{
                setStatus("open");
            });
            return ()=>{
                cancelAnimationFrame(frame);
            };
        } else {
            setInitiated(true);
            setStatus("close");
        }
    }, [
        open,
        floating
    ]);
    return {
        isMounted: isMounted,
        status: status
    };
}
/**
 * Provides styles to apply CSS transitions to a floating element, correctly
 * handling placement-aware transitions. Wrapper around `useTransitionStatus`.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstyles
 */ function $3f69993268aa5b7a$export$769fba13884bc2f4(context, props) {
    if (props === void 0) props = {};
    const { initial: unstable_initial = {
        opacity: 0
    }, open: unstable_open, close: unstable_close, common: unstable_common, duration: duration = 250 } = props;
    const placement = context.placement;
    const side = placement.split("-")[0];
    const fnArgs = $acw62.useMemo(()=>({
            side: side,
            placement: placement
        }), [
        side,
        placement
    ]);
    const isNumberDuration = typeof duration === "number";
    const openDuration = (isNumberDuration ? duration : duration.open) || 0;
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    const [styles, setStyles] = $acw62.useState(()=>({
            ...$3f69993268aa5b7a$var$execWithArgsOrReturn(unstable_common, fnArgs),
            ...$3f69993268aa5b7a$var$execWithArgsOrReturn(unstable_initial, fnArgs)
        }));
    const { isMounted: isMounted, status: status } = $3f69993268aa5b7a$export$b2ef21706733f7e5(context, {
        duration: duration
    });
    const initialRef = $3f69993268aa5b7a$var$useLatestRef(unstable_initial);
    const openRef = $3f69993268aa5b7a$var$useLatestRef(unstable_open);
    const closeRef = $3f69993268aa5b7a$var$useLatestRef(unstable_close);
    const commonRef = $3f69993268aa5b7a$var$useLatestRef(unstable_common);
    $3f69993268aa5b7a$var$index(()=>{
        const initialStyles = $3f69993268aa5b7a$var$execWithArgsOrReturn(initialRef.current, fnArgs);
        const closeStyles = $3f69993268aa5b7a$var$execWithArgsOrReturn(closeRef.current, fnArgs);
        const commonStyles = $3f69993268aa5b7a$var$execWithArgsOrReturn(commonRef.current, fnArgs);
        const openStyles = $3f69993268aa5b7a$var$execWithArgsOrReturn(openRef.current, fnArgs) || Object.keys(initialStyles).reduce((acc, key)=>{
            acc[key] = "";
            return acc;
        }, {});
        if (status === "initial") setStyles((styles)=>({
                transitionProperty: styles.transitionProperty,
                ...commonStyles,
                ...initialStyles
            }));
        if (status === "open") setStyles({
            transitionProperty: Object.keys(openStyles).map($3f69993268aa5b7a$var$camelCaseToKebabCase).join(","),
            transitionDuration: openDuration + "ms",
            ...commonStyles,
            ...openStyles
        });
        if (status === "close") {
            const styles = closeStyles || initialStyles;
            setStyles({
                transitionProperty: Object.keys(styles).map($3f69993268aa5b7a$var$camelCaseToKebabCase).join(","),
                transitionDuration: closeDuration + "ms",
                ...commonStyles,
                ...styles
            });
        }
    }, [
        closeDuration,
        closeRef,
        initialRef,
        openRef,
        commonRef,
        openDuration,
        status,
        fnArgs
    ]);
    return {
        isMounted: isMounted,
        styles: styles
    };
}
/**
 * Provides a matching callback that can be used to focus an item as the user
 * types, often used in tandem with `useListNavigation()`.
 * @see https://floating-ui.com/docs/useTypeahead
 */ function $3f69993268aa5b7a$export$d8d674d50b73ba93(context, props) {
    var _ref;
    const { open: open, dataRef: dataRef } = context;
    const { listRef: listRef, activeIndex: activeIndex, onMatch: unstable_onMatch, onTypingChange: unstable_onTypingChange, enabled: enabled = true, findMatch: findMatch = null, resetMs: resetMs = 750, ignoreKeys: ignoreKeys = [], selectedIndex: selectedIndex = null } = props;
    const timeoutIdRef = $acw62.useRef();
    const stringRef = $acw62.useRef("");
    const prevIndexRef = $acw62.useRef((_ref = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref : -1);
    const matchIndexRef = $acw62.useRef(null);
    const onMatch = $3f69993268aa5b7a$var$useEffectEvent(unstable_onMatch);
    const onTypingChange = $3f69993268aa5b7a$var$useEffectEvent(unstable_onTypingChange);
    const findMatchRef = $3f69993268aa5b7a$var$useLatestRef(findMatch);
    const ignoreKeysRef = $3f69993268aa5b7a$var$useLatestRef(ignoreKeys);
    $3f69993268aa5b7a$var$index(()=>{
        if (open) {
            clearTimeout(timeoutIdRef.current);
            matchIndexRef.current = null;
            stringRef.current = "";
        }
    }, [
        open
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        // Sync arrow key navigation but not typeahead navigation.
        if (open && stringRef.current === "") {
            var _ref2;
            prevIndexRef.current = (_ref2 = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref2 : -1;
        }
    }, [
        open,
        selectedIndex,
        activeIndex
    ]);
    return $acw62.useMemo(()=>{
        if (!enabled) return {};
        function setTypingChange(value) {
            if (value) {
                if (!dataRef.current.typing) {
                    dataRef.current.typing = value;
                    onTypingChange(value);
                }
            } else if (dataRef.current.typing) {
                dataRef.current.typing = value;
                onTypingChange(value);
            }
        }
        function getMatchingIndex(list, orderedList, string) {
            const str = findMatchRef.current ? findMatchRef.current(orderedList, string) : orderedList.find((text)=>(text == null ? void 0 : text.toLocaleLowerCase().indexOf(string.toLocaleLowerCase())) === 0);
            return str ? list.indexOf(str) : -1;
        }
        function onKeyDown(event) {
            const listContent = listRef.current;
            if (stringRef.current.length > 0 && stringRef.current[0] !== " ") {
                if (getMatchingIndex(listContent, listContent, stringRef.current) === -1) setTypingChange(false);
                else if (event.key === " ") $3f69993268aa5b7a$var$stopEvent(event);
            }
            if (listContent == null || ignoreKeysRef.current.includes(event.key) || // Character key.
            event.key.length !== 1 || // Modifier key.
            event.ctrlKey || event.metaKey || event.altKey) return;
            if (open && event.key !== " ") {
                $3f69993268aa5b7a$var$stopEvent(event);
                setTypingChange(true);
            }
            // Bail out if the list contains a word like "llama" or "aaron". TODO:
            // allow it in this case, too.
            const allowRapidSuccessionOfFirstLetter = listContent.every((text)=>{
                var _text$, _text$2;
                return text ? ((_text$ = text[0]) == null ? void 0 : _text$.toLocaleLowerCase()) !== ((_text$2 = text[1]) == null ? void 0 : _text$2.toLocaleLowerCase()) : true;
            });
            // Allows the user to cycle through items that start with the same letter
            // in rapid succession.
            if (allowRapidSuccessionOfFirstLetter && stringRef.current === event.key) {
                stringRef.current = "";
                prevIndexRef.current = matchIndexRef.current;
            }
            stringRef.current += event.key;
            clearTimeout(timeoutIdRef.current);
            timeoutIdRef.current = setTimeout(()=>{
                stringRef.current = "";
                prevIndexRef.current = matchIndexRef.current;
                setTypingChange(false);
            }, resetMs);
            const prevIndex = prevIndexRef.current;
            const index = getMatchingIndex(listContent, [
                ...listContent.slice((prevIndex || 0) + 1),
                ...listContent.slice(0, (prevIndex || 0) + 1)
            ], stringRef.current);
            if (index !== -1) {
                onMatch(index);
                matchIndexRef.current = index;
            } else if (event.key !== " ") {
                stringRef.current = "";
                setTypingChange(false);
            }
        }
        return {
            reference: {
                onKeyDown: onKeyDown
            },
            floating: {
                onKeyDown: onKeyDown,
                onKeyUp (event) {
                    if (event.key === " ") setTypingChange(false);
                }
            }
        };
    }, [
        enabled,
        open,
        dataRef,
        listRef,
        resetMs,
        ignoreKeysRef,
        findMatchRef,
        onMatch,
        onTypingChange
    ]);
}
function $3f69993268aa5b7a$var$getArgsWithCustomFloatingHeight(state, height) {
    return {
        ...state,
        rects: {
            ...state.rects,
            floating: {
                ...state.rects.floating,
                height: height
            }
        }
    };
}
/**
 * Positions the floating element such that an inner element inside
 * of it is anchored to the reference element.
 * @see https://floating-ui.com/docs/inner
 */ const $3f69993268aa5b7a$export$4ae363f1d88fb658 = (props)=>({
        name: "inner",
        options: props,
        async fn (state) {
            const { listRef: listRef, overflowRef: overflowRef, onFallbackChange: onFallbackChange, offset: innerOffset = 0, index: index = 0, minItemsVisible: minItemsVisible = 4, referenceOverflowThreshold: referenceOverflowThreshold = 0, scrollRef: scrollRef, ...detectOverflowOptions } = props;
            const { rects: rects, elements: { floating: floating } } = state;
            const item = listRef.current[index];
            if (!item) return {};
            const nextArgs = {
                ...state,
                ...await (0, $973e4da43f2a375d$export$cc800923e997bb8)(-item.offsetTop - floating.clientTop - rects.reference.height / 2 - item.offsetHeight / 2 - innerOffset).fn(state)
            };
            const el = (scrollRef == null ? void 0 : scrollRef.current) || floating;
            const overflow = await (0, $973e4da43f2a375d$export$37b6bde19b108ecc)($3f69993268aa5b7a$var$getArgsWithCustomFloatingHeight(nextArgs, el.scrollHeight), detectOverflowOptions);
            const refOverflow = await (0, $973e4da43f2a375d$export$37b6bde19b108ecc)(nextArgs, {
                ...detectOverflowOptions,
                elementContext: "reference"
            });
            const diffY = Math.max(0, overflow.top);
            const nextY = nextArgs.y + diffY;
            const maxHeight = Math.max(0, el.scrollHeight - diffY - Math.max(0, overflow.bottom));
            el.style.maxHeight = maxHeight + "px";
            el.scrollTop = diffY;
            // There is not enough space, fallback to standard anchored positioning
            if (onFallbackChange) {
                if (el.offsetHeight < item.offsetHeight * Math.min(minItemsVisible, listRef.current.length - 1) - 1 || refOverflow.top >= -referenceOverflowThreshold || refOverflow.bottom >= -referenceOverflowThreshold) (0, $11492dca620dcaa5$exports.flushSync)(()=>onFallbackChange(true));
                else (0, $11492dca620dcaa5$exports.flushSync)(()=>onFallbackChange(false));
            }
            if (overflowRef) overflowRef.current = await (0, $973e4da43f2a375d$export$37b6bde19b108ecc)($3f69993268aa5b7a$var$getArgsWithCustomFloatingHeight({
                ...nextArgs,
                y: nextY
            }, el.offsetHeight), detectOverflowOptions);
            return {
                y: nextY
            };
        }
    });
/**
 * Changes the `inner` middleware's `offset` upon a `wheel` event to
 * expand the floating element's height, revealing more list items.
 * @see https://floating-ui.com/docs/inner
 */ function $3f69993268aa5b7a$export$3d74b0dda7cc82ff(context, props) {
    const { open: open, elements: elements } = context;
    const { enabled: enabled = true, overflowRef: overflowRef, scrollRef: scrollRef, onChange: unstable_onChange } = props;
    const onChange = $3f69993268aa5b7a$var$useEffectEvent(unstable_onChange);
    const controlledScrollingRef = $acw62.useRef(false);
    const prevScrollTopRef = $acw62.useRef(null);
    const initialOverflowRef = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (!enabled) return;
        function onWheel(e) {
            if (e.ctrlKey || !el || overflowRef.current == null) return;
            const dY = e.deltaY;
            const isAtTop = overflowRef.current.top >= -0.5;
            const isAtBottom = overflowRef.current.bottom >= -0.5;
            const remainingScroll = el.scrollHeight - el.clientHeight;
            const sign = dY < 0 ? -1 : 1;
            const method = dY < 0 ? "max" : "min";
            if (el.scrollHeight <= el.clientHeight) return;
            if (!isAtTop && dY > 0 || !isAtBottom && dY < 0) {
                e.preventDefault();
                (0, $11492dca620dcaa5$exports.flushSync)(()=>{
                    onChange((d)=>d + Math[method](dY, remainingScroll * sign));
                });
            } else if (/firefox/i.test($3f69993268aa5b7a$var$getUserAgent())) // Needed to propagate scrolling during momentum scrolling phase once
            // it gets limited by the boundary. UX improvement, not critical.
            el.scrollTop += dY;
        }
        const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
        if (open && el) {
            el.addEventListener("wheel", onWheel);
            // Wait for the position to be ready.
            requestAnimationFrame(()=>{
                prevScrollTopRef.current = el.scrollTop;
                if (overflowRef.current != null) initialOverflowRef.current = {
                    ...overflowRef.current
                };
            });
            return ()=>{
                prevScrollTopRef.current = null;
                initialOverflowRef.current = null;
                el.removeEventListener("wheel", onWheel);
            };
        }
    }, [
        enabled,
        open,
        elements.floating,
        overflowRef,
        scrollRef,
        onChange
    ]);
    return $acw62.useMemo(()=>{
        if (!enabled) return {};
        return {
            floating: {
                onKeyDown () {
                    controlledScrollingRef.current = true;
                },
                onWheel () {
                    controlledScrollingRef.current = false;
                },
                onPointerMove () {
                    controlledScrollingRef.current = false;
                },
                onScroll () {
                    const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
                    if (!overflowRef.current || !el || !controlledScrollingRef.current) return;
                    if (prevScrollTopRef.current !== null) {
                        const scrollDiff = el.scrollTop - prevScrollTopRef.current;
                        if (overflowRef.current.bottom < -0.5 && scrollDiff < -1 || overflowRef.current.top < -0.5 && scrollDiff > 1) (0, $11492dca620dcaa5$exports.flushSync)(()=>onChange((d)=>d + scrollDiff));
                    }
                    // [Firefox] Wait for the height change to have been applied.
                    requestAnimationFrame(()=>{
                        prevScrollTopRef.current = el.scrollTop;
                    });
                }
            }
        };
    }, [
        enabled,
        overflowRef,
        elements.floating,
        scrollRef,
        onChange
    ]);
}
function $3f69993268aa5b7a$var$isPointInPolygon(point, polygon) {
    const [x, y] = point;
    let isInside = false;
    const length = polygon.length;
    for(let i = 0, j = length - 1; i < length; j = i++){
        const [xi, yi] = polygon[i] || [
            0,
            0
        ];
        const [xj, yj] = polygon[j] || [
            0,
            0
        ];
        const intersect = yi >= y !== yj >= y && x <= (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) isInside = !isInside;
    }
    return isInside;
}
function $3f69993268aa5b7a$var$isInside(point, rect) {
    return point[0] >= rect.x && point[0] <= rect.x + rect.width && point[1] >= rect.y && point[1] <= rect.y + rect.height;
}
/**
 * Generates a safe polygon area that the user can traverse without closing the
 * floating element once leaving the reference element.
 * @see https://floating-ui.com/docs/useHover#safePolygon
 */ function $3f69993268aa5b7a$export$7484214ab62358d2(options) {
    if (options === void 0) options = {};
    const { buffer: buffer = 0.5, blockPointerEvents: blockPointerEvents = false, requireIntent: requireIntent = true } = options;
    let timeoutId;
    let hasLanded = false;
    let lastX = null;
    let lastY = null;
    let lastCursorTime = performance.now();
    function getCursorSpeed(x, y) {
        const currentTime = performance.now();
        const elapsedTime = currentTime - lastCursorTime;
        if (lastX === null || lastY === null || elapsedTime === 0) {
            lastX = x;
            lastY = y;
            lastCursorTime = currentTime;
            return null;
        }
        const deltaX = x - lastX;
        const deltaY = y - lastY;
        const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
        const speed = distance / elapsedTime; // px / ms
        lastX = x;
        lastY = y;
        lastCursorTime = currentTime;
        return speed;
    }
    const fn = (_ref)=>{
        let { x: x, y: y, placement: placement, elements: elements, onClose: onClose, nodeId: nodeId, tree: tree } = _ref;
        return function onMouseMove(event) {
            function close() {
                clearTimeout(timeoutId);
                onClose();
            }
            clearTimeout(timeoutId);
            if (!elements.domReference || !elements.floating || placement == null || x == null || y == null) return;
            const { clientX: clientX, clientY: clientY } = event;
            const clientPoint = [
                clientX,
                clientY
            ];
            const target = $3f69993268aa5b7a$var$getTarget(event);
            const isLeave = event.type === "mouseleave";
            const isOverFloatingEl = $3f69993268aa5b7a$var$contains(elements.floating, target);
            const isOverReferenceEl = $3f69993268aa5b7a$var$contains(elements.domReference, target);
            const refRect = elements.domReference.getBoundingClientRect();
            const rect = elements.floating.getBoundingClientRect();
            const side = placement.split("-")[0];
            const cursorLeaveFromRight = x > rect.right - rect.width / 2;
            const cursorLeaveFromBottom = y > rect.bottom - rect.height / 2;
            const isOverReferenceRect = $3f69993268aa5b7a$var$isInside(clientPoint, refRect);
            const isFloatingWider = rect.width > refRect.width;
            const isFloatingTaller = rect.height > refRect.height;
            const left = (isFloatingWider ? refRect : rect).left;
            const right = (isFloatingWider ? refRect : rect).right;
            const top = (isFloatingTaller ? refRect : rect).top;
            const bottom = (isFloatingTaller ? refRect : rect).bottom;
            if (isOverFloatingEl) {
                hasLanded = true;
                if (!isLeave) return;
            }
            if (isOverReferenceEl) hasLanded = false;
            if (isOverReferenceEl && !isLeave) {
                hasLanded = true;
                return;
            }
            // Prevent overlapping floating element from being stuck in an open-close
            // loop: https://github.com/floating-ui/floating-ui/issues/1910
            if (isLeave && $3f69993268aa5b7a$var$isElement(event.relatedTarget) && $3f69993268aa5b7a$var$contains(elements.floating, event.relatedTarget)) return;
            // If any nested child is open, abort.
            if (tree && $3f69993268aa5b7a$var$getChildren(tree.nodesRef.current, nodeId).some((_ref2)=>{
                let { context: context } = _ref2;
                return context == null ? void 0 : context.open;
            })) return;
            // If the pointer is leaving from the opposite side, the "buffer" logic
            // creates a point where the floating element remains open, but should be
            // ignored.
            // A constant of 1 handles floating point rounding errors.
            if (side === "top" && y >= refRect.bottom - 1 || side === "bottom" && y <= refRect.top + 1 || side === "left" && x >= refRect.right - 1 || side === "right" && x <= refRect.left + 1) return close();
            // Ignore when the cursor is within the rectangular trough between the
            // two elements. Since the triangle is created from the cursor point,
            // which can start beyond the ref element's edge, traversing back and
            // forth from the ref to the floating element can cause it to close. This
            // ensures it always remains open in that case.
            let rectPoly = [];
            switch(side){
                case "top":
                    rectPoly = [
                        [
                            left,
                            refRect.top + 1
                        ],
                        [
                            left,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            refRect.top + 1
                        ]
                    ];
                    break;
                case "bottom":
                    rectPoly = [
                        [
                            left,
                            rect.top + 1
                        ],
                        [
                            left,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            rect.top + 1
                        ]
                    ];
                    break;
                case "left":
                    rectPoly = [
                        [
                            rect.right - 1,
                            bottom
                        ],
                        [
                            rect.right - 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            bottom
                        ]
                    ];
                    break;
                case "right":
                    rectPoly = [
                        [
                            refRect.right - 1,
                            bottom
                        ],
                        [
                            refRect.right - 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            bottom
                        ]
                    ];
                    break;
            }
            function getPolygon(_ref3) {
                let [x, y] = _ref3;
                switch(side){
                    case "top":
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.bottom - buffer : isFloatingWider ? rect.bottom - buffer : rect.top
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.bottom - buffer : rect.top : rect.bottom - buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case "bottom":
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.top + buffer : isFloatingWider ? rect.top + buffer : rect.bottom
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.top + buffer : rect.bottom : rect.top + buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case "left":
                        {
                            const cursorPointOne = [
                                x + buffer + 1,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x + buffer + 1,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.right - buffer : isFloatingTaller ? rect.right - buffer : rect.left,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.right - buffer : rect.left : rect.right - buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                ...commonPoints,
                                cursorPointOne,
                                cursorPointTwo
                            ];
                        }
                    case "right":
                        {
                            const cursorPointOne = [
                                x - buffer,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x - buffer,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.left + buffer : isFloatingTaller ? rect.left + buffer : rect.right,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.left + buffer : rect.right : rect.left + buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                }
            }
            if ($3f69993268aa5b7a$var$isPointInPolygon([
                clientX,
                clientY
            ], rectPoly)) return;
            else if (hasLanded && !isOverReferenceRect) return close();
            if (!isLeave && requireIntent) {
                const cursorSpeed = getCursorSpeed(event.clientX, event.clientY);
                const cursorSpeedThreshold = 0.1;
                if (cursorSpeed !== null && cursorSpeed < cursorSpeedThreshold) return close();
            }
            if (!$3f69993268aa5b7a$var$isPointInPolygon([
                clientX,
                clientY
            ], getPolygon([
                x,
                y
            ]))) close();
            else if (!hasLanded && requireIntent) timeoutId = window.setTimeout(close, 40);
        };
    };
    fn.__options = {
        blockPointerEvents: blockPointerEvents
    };
    return fn;
}



var $acw62 = parcelRequire("acw62");


"use client";
function $bae95681bbef75a9$export$221e6d278ea24455({ opened: opened, floating: floating, position: position, positionDependencies: positionDependencies }) {
    const [delayedUpdate, setDelayedUpdate] = (0, $acw62.useState)(0);
    (0, $acw62.useEffect)(()=>{
        if (floating.refs.reference.current && floating.refs.floating.current) return (0, $461947879dcdbcd4$export$deee3a793edee05f)(floating.refs.reference.current, floating.refs.floating.current, floating.update);
        return void 0;
    }, [
        floating.refs.reference.current,
        floating.refs.floating.current,
        opened,
        delayedUpdate,
        position
    ]);
    (0, $d9273517323905a9$export$e34ed88fef4dc107)(()=>{
        floating.update();
    }, positionDependencies);
    (0, $d9273517323905a9$export$e34ed88fef4dc107)(()=>{
        setDelayedUpdate((c)=>c + 1);
    }, [
        opened
    ]);
}


"use client";
function $c63cfc7636e0b51f$var$getPopoverMiddlewares(options) {
    var _a, _b, _c;
    const middlewares = [
        (0, $973e4da43f2a375d$export$cc800923e997bb8)(options.offset)
    ];
    if ((_a = options.middlewares) == null ? void 0 : _a.shift) middlewares.push((0, $973e4da43f2a375d$export$fba63a578e423eb)({
        limiter: (0, $973e4da43f2a375d$export$7bf07e38f3dc4b69)()
    }));
    if ((_b = options.middlewares) == null ? void 0 : _b.flip) middlewares.push((0, $973e4da43f2a375d$export$8a83211c878a3f1f)());
    if ((_c = options.middlewares) == null ? void 0 : _c.inline) middlewares.push((0, $973e4da43f2a375d$export$18c8ad048e32c7d5)());
    middlewares.push((0, $23a8f689f1d4c3be$export$f2120bbfa5450bd2)({
        element: options.arrowRef,
        padding: options.arrowOffset
    }));
    return middlewares;
}
function $c63cfc7636e0b51f$export$542a6fd13ac93354(options) {
    const [_opened, setOpened] = (0, $4197894a742d9f84$export$ec55e9daaf703a7d)({
        value: options.opened,
        defaultValue: options.defaultOpened,
        finalValue: false,
        onChange: options.onChange
    });
    const onClose = ()=>{
        var _a;
        if (_opened) {
            (_a = options.onClose) == null || _a.call(options);
            setOpened(false);
        }
    };
    const onToggle = ()=>{
        var _a, _b;
        if (_opened) {
            (_a = options.onClose) == null || _a.call(options);
            setOpened(false);
        } else {
            (_b = options.onOpen) == null || _b.call(options);
            setOpened(true);
        }
    };
    const floating = (0, $3f69993268aa5b7a$export$4e02a5c1d08bac65)({
        placement: options.position,
        middleware: [
            ...$c63cfc7636e0b51f$var$getPopoverMiddlewares(options),
            ...options.width === "target" ? [
                (0, $973e4da43f2a375d$export$346677f925de839c)({
                    apply ({ rects: rects }) {
                        var _a, _b;
                        Object.assign((_b = (_a = floating.refs.floating.current) == null ? void 0 : _a.style) != null ? _b : {}, {
                            width: `${rects.reference.width}px`
                        });
                    }
                })
            ] : []
        ]
    });
    (0, $bae95681bbef75a9$export$221e6d278ea24455)({
        opened: options.opened,
        position: options.position,
        positionDependencies: options.positionDependencies || [],
        floating: floating
    });
    (0, $d9273517323905a9$export$e34ed88fef4dc107)(()=>{
        var _a;
        (_a = options.onPositionChange) == null || _a.call(options, floating.placement);
    }, [
        floating.placement
    ]);
    (0, $d9273517323905a9$export$e34ed88fef4dc107)(()=>{
        var _a, _b;
        if (!options.opened) (_a = options.onClose) == null || _a.call(options);
        else (_b = options.onOpen) == null || _b.call(options);
    }, [
        options.opened
    ]);
    return {
        floating: floating,
        controlled: typeof options.opened === "boolean",
        opened: _opened,
        onClose: onClose,
        onToggle: onToggle
    };
}



"use client";
const [$74f44c98474c2c98$export$f5300fbf692a63ec, $74f44c98474c2c98$export$1468d0761b26e6c8] = (0, $0bf9cc213b4abd2e$export$97d0e477aacf9b7d)("Popover component was not found in the tree");



var $acw62 = parcelRequire("acw62");






"use client";
var $a8854574e99469aa$var$__defProp = Object.defineProperty;
var $a8854574e99469aa$var$__defProps = Object.defineProperties;
var $a8854574e99469aa$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $a8854574e99469aa$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $a8854574e99469aa$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $a8854574e99469aa$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $a8854574e99469aa$var$__defNormalProp = (obj, key, value)=>key in obj ? $a8854574e99469aa$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $a8854574e99469aa$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($a8854574e99469aa$var$__hasOwnProp.call(b, prop)) $a8854574e99469aa$var$__defNormalProp(a, prop, b[prop]);
    if ($a8854574e99469aa$var$__getOwnPropSymbols) {
        for (var prop of $a8854574e99469aa$var$__getOwnPropSymbols(b))if ($a8854574e99469aa$var$__propIsEnum.call(b, prop)) $a8854574e99469aa$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $a8854574e99469aa$var$__spreadProps = (a, b)=>$a8854574e99469aa$var$__defProps(a, $a8854574e99469aa$var$__getOwnPropDescs(b));
var $a8854574e99469aa$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($a8854574e99469aa$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $a8854574e99469aa$var$__getOwnPropSymbols) {
        for (var prop of $a8854574e99469aa$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $a8854574e99469aa$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $a8854574e99469aa$var$defaultProps = {
    refProp: "ref",
    popupType: "dialog"
};
const $a8854574e99469aa$export$5ad0c0856b469f13 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((props, ref)=>{
    const _a = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("PopoverTarget", $a8854574e99469aa$var$defaultProps, props), { children: children, refProp: refProp, popupType: popupType } = _a, others = $a8854574e99469aa$var$__objRest(_a, [
        "children",
        "refProp",
        "popupType"
    ]);
    if (!(0, $65b68cae0fe4eb32$export$45a5e7f76e0caa8d)(children)) throw new Error("Popover.Target component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported");
    const forwardedProps = others;
    const ctx = (0, $74f44c98474c2c98$export$1468d0761b26e6c8)();
    const targetRef = (0, $7034a45159125c0b$export$36a55fa7500f01f)(ctx.reference, children.ref, ref);
    const accessibleProps = ctx.withRoles ? {
        "aria-haspopup": popupType,
        "aria-expanded": ctx.opened,
        "aria-controls": ctx.getDropdownId(),
        id: ctx.getTargetId()
    } : {};
    return (0, $acw62.cloneElement)(children, $a8854574e99469aa$var$__spreadValues($a8854574e99469aa$var$__spreadProps($a8854574e99469aa$var$__spreadValues($a8854574e99469aa$var$__spreadValues($a8854574e99469aa$var$__spreadValues({}, forwardedProps), accessibleProps), ctx.targetProps), {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(ctx.targetProps.className, forwardedProps.className, children.props.className),
        [refProp]: targetRef
    }), !ctx.controlled ? {
        onClick: ctx.onToggle
    } : null));
});
$a8854574e99469aa$export$5ad0c0856b469f13.displayName = "@mantine/core/PopoverTarget";



var $acw62 = parcelRequire("acw62");


"use client";
var $ddfa993246a665fb$var$classes = {
    "dropdown": "m-38a85659",
    "arrow": "m-a31dc6c1"
};
var $ddfa993246a665fb$export$2e2bcd8739ae039 = $ddfa993246a665fb$var$classes;





"use client";
const $203042273dcf69c8$export$8793edee2d425525 = ()=>{};


"use client";
function $f9102fe801bfca5d$export$902efad8ff1933eb(callback, options = {
    active: true
}) {
    if (typeof callback !== "function" || !options.active) return options.onKeyDown || (0, $203042273dcf69c8$export$8793edee2d425525);
    return (event)=>{
        var _a;
        if (event.key === "Escape") {
            callback(event);
            (_a = options.onTrigger) == null || _a.call(options);
        }
    };
}



var $acw62 = parcelRequire("acw62");

"use client";
var $0215b0d1ca397b39$var$__defProp = Object.defineProperty;
var $0215b0d1ca397b39$var$__defProps = Object.defineProperties;
var $0215b0d1ca397b39$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $0215b0d1ca397b39$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $0215b0d1ca397b39$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $0215b0d1ca397b39$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $0215b0d1ca397b39$var$__defNormalProp = (obj, key, value)=>key in obj ? $0215b0d1ca397b39$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $0215b0d1ca397b39$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($0215b0d1ca397b39$var$__hasOwnProp.call(b, prop)) $0215b0d1ca397b39$var$__defNormalProp(a, prop, b[prop]);
    if ($0215b0d1ca397b39$var$__getOwnPropSymbols) {
        for (var prop of $0215b0d1ca397b39$var$__getOwnPropSymbols(b))if ($0215b0d1ca397b39$var$__propIsEnum.call(b, prop)) $0215b0d1ca397b39$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $0215b0d1ca397b39$var$__spreadProps = (a, b)=>$0215b0d1ca397b39$var$__defProps(a, $0215b0d1ca397b39$var$__getOwnPropDescs(b));
function $0215b0d1ca397b39$var$horizontalSide(placement, arrowY, arrowOffset, arrowPosition) {
    if (placement === "center" || arrowPosition === "center") return {
        top: arrowY
    };
    if (placement === "end") return {
        bottom: arrowOffset
    };
    if (placement === "start") return {
        top: arrowOffset
    };
    return {};
}
function $0215b0d1ca397b39$var$verticalSide(placement, arrowX, arrowOffset, arrowPosition, dir) {
    if (placement === "center" || arrowPosition === "center") return {
        left: arrowX
    };
    if (placement === "end") return {
        [dir === "ltr" ? "right" : "left"]: arrowOffset
    };
    if (placement === "start") return {
        [dir === "ltr" ? "left" : "right"]: arrowOffset
    };
    return {};
}
const $0215b0d1ca397b39$var$radiusByFloatingSide = {
    bottom: "borderTopLeftRadius",
    left: "borderTopRightRadius",
    right: "borderBottomLeftRadius",
    top: "borderBottomRightRadius"
};
function $0215b0d1ca397b39$export$1b8d75826ae84e20({ position: position, arrowSize: arrowSize, arrowOffset: arrowOffset, arrowRadius: arrowRadius, arrowPosition: arrowPosition, arrowX: arrowX, arrowY: arrowY, dir: dir }) {
    const [side, placement = "center"] = position.split("-");
    const baseStyles = {
        width: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(arrowSize),
        height: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(arrowSize),
        transform: "rotate(45deg)",
        position: "absolute",
        [$0215b0d1ca397b39$var$radiusByFloatingSide[side]]: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(arrowRadius)
    };
    const arrowPlacement = (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(-arrowSize / 2);
    if (side === "left") return $0215b0d1ca397b39$var$__spreadProps($0215b0d1ca397b39$var$__spreadValues($0215b0d1ca397b39$var$__spreadValues({}, baseStyles), $0215b0d1ca397b39$var$horizontalSide(placement, arrowY, arrowOffset, arrowPosition)), {
        right: arrowPlacement,
        borderLeftColor: "transparent",
        borderBottomColor: "transparent"
    });
    if (side === "right") return $0215b0d1ca397b39$var$__spreadProps($0215b0d1ca397b39$var$__spreadValues($0215b0d1ca397b39$var$__spreadValues({}, baseStyles), $0215b0d1ca397b39$var$horizontalSide(placement, arrowY, arrowOffset, arrowPosition)), {
        left: arrowPlacement,
        borderRightColor: "transparent",
        borderTopColor: "transparent"
    });
    if (side === "top") return $0215b0d1ca397b39$var$__spreadProps($0215b0d1ca397b39$var$__spreadValues($0215b0d1ca397b39$var$__spreadValues({}, baseStyles), $0215b0d1ca397b39$var$verticalSide(placement, arrowX, arrowOffset, arrowPosition, dir)), {
        bottom: arrowPlacement,
        borderTopColor: "transparent",
        borderLeftColor: "transparent"
    });
    if (side === "bottom") return $0215b0d1ca397b39$var$__spreadProps($0215b0d1ca397b39$var$__spreadValues($0215b0d1ca397b39$var$__spreadValues({}, baseStyles), $0215b0d1ca397b39$var$verticalSide(placement, arrowX, arrowOffset, arrowPosition, dir)), {
        top: arrowPlacement,
        borderBottomColor: "transparent",
        borderRightColor: "transparent"
    });
    return {};
}



var $acw62 = parcelRequire("acw62");

"use client";
const $35c57ac18e24a61d$export$46f936cc30cb9075 = (0, $acw62.createContext)({
    dir: "ltr",
    toggleDirection: ()=>{},
    setDirection: ()=>{}
});
function $35c57ac18e24a61d$export$b39126d51d94e6f3() {
    return (0, $acw62.useContext)($35c57ac18e24a61d$export$46f936cc30cb9075);
}
function $35c57ac18e24a61d$export$c760c09fdd558351({ children: children, initialDirection: initialDirection = "ltr", detectDirection: detectDirection = true }) {
    const [dir, setDir] = (0, $acw62.useState)(initialDirection);
    const setDirection = (direction)=>{
        setDir(direction);
        document.documentElement.setAttribute("dir", direction);
    };
    const toggleDirection = ()=>setDirection(dir === "ltr" ? "rtl" : "ltr");
    (0, $562774022e0ac3ca$export$363c9f3eb56bbdbe)(()=>{
        if (detectDirection) {
            const direction = document.documentElement.getAttribute("dir");
            if (direction === "rtl" || direction === "ltr") setDirection(direction);
        }
    }, []);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($35c57ac18e24a61d$export$46f936cc30cb9075.Provider, {
        value: {
            dir: dir,
            toggleDirection: toggleDirection,
            setDirection: setDirection
        }
    }, children);
}


"use client";
var $097c89337c87083a$var$__defProp = Object.defineProperty;
var $097c89337c87083a$var$__defProps = Object.defineProperties;
var $097c89337c87083a$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $097c89337c87083a$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $097c89337c87083a$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $097c89337c87083a$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $097c89337c87083a$var$__defNormalProp = (obj, key, value)=>key in obj ? $097c89337c87083a$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $097c89337c87083a$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($097c89337c87083a$var$__hasOwnProp.call(b, prop)) $097c89337c87083a$var$__defNormalProp(a, prop, b[prop]);
    if ($097c89337c87083a$var$__getOwnPropSymbols) {
        for (var prop of $097c89337c87083a$var$__getOwnPropSymbols(b))if ($097c89337c87083a$var$__propIsEnum.call(b, prop)) $097c89337c87083a$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $097c89337c87083a$var$__spreadProps = (a, b)=>$097c89337c87083a$var$__defProps(a, $097c89337c87083a$var$__getOwnPropDescs(b));
var $097c89337c87083a$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($097c89337c87083a$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $097c89337c87083a$var$__getOwnPropSymbols) {
        for (var prop of $097c89337c87083a$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $097c89337c87083a$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $097c89337c87083a$export$33511391554732bc = (0, $acw62.forwardRef)((_a, ref)=>{
    var _b = _a, { position: position, arrowSize: arrowSize, arrowOffset: arrowOffset, arrowRadius: arrowRadius, arrowPosition: arrowPosition, visible: visible, arrowX: arrowX, arrowY: arrowY, style: style } = _b, others = $097c89337c87083a$var$__objRest(_b, [
        "position",
        "arrowSize",
        "arrowOffset",
        "arrowRadius",
        "arrowPosition",
        "visible",
        "arrowX",
        "arrowY",
        "style"
    ]);
    const { dir: dir } = (0, $35c57ac18e24a61d$export$b39126d51d94e6f3)();
    if (!visible) return null;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $097c89337c87083a$var$__spreadProps($097c89337c87083a$var$__spreadValues({}, others), {
        ref: ref,
        style: $097c89337c87083a$var$__spreadValues($097c89337c87083a$var$__spreadValues({}, style), (0, $0215b0d1ca397b39$export$1b8d75826ae84e20)({
            position: position,
            arrowSize: arrowSize,
            arrowOffset: arrowOffset,
            arrowRadius: arrowRadius,
            arrowPosition: arrowPosition,
            dir: dir,
            arrowX: arrowX,
            arrowY: arrowY
        }))
    }));
});
$097c89337c87083a$export$33511391554732bc.displayName = "@mantine/core/FloatingArrow";






"use client";
var $c6c02060e092d07e$var$__defProp = Object.defineProperty;
var $c6c02060e092d07e$var$__defProps = Object.defineProperties;
var $c6c02060e092d07e$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $c6c02060e092d07e$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $c6c02060e092d07e$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $c6c02060e092d07e$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $c6c02060e092d07e$var$__defNormalProp = (obj, key, value)=>key in obj ? $c6c02060e092d07e$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $c6c02060e092d07e$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($c6c02060e092d07e$var$__hasOwnProp.call(b, prop)) $c6c02060e092d07e$var$__defNormalProp(a, prop, b[prop]);
    if ($c6c02060e092d07e$var$__getOwnPropSymbols) {
        for (var prop of $c6c02060e092d07e$var$__getOwnPropSymbols(b))if ($c6c02060e092d07e$var$__propIsEnum.call(b, prop)) $c6c02060e092d07e$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $c6c02060e092d07e$var$__spreadProps = (a, b)=>$c6c02060e092d07e$var$__defProps(a, $c6c02060e092d07e$var$__getOwnPropDescs(b));
var $c6c02060e092d07e$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($c6c02060e092d07e$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $c6c02060e092d07e$var$__getOwnPropSymbols) {
        for (var prop of $c6c02060e092d07e$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $c6c02060e092d07e$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $c6c02060e092d07e$var$defaultProps = {};
const $c6c02060e092d07e$export$bc4cee0d3f11c45d = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props, ref)=>{
    var _b, _c, _d, _e, _f;
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("PopoverDropdown", $c6c02060e092d07e$var$defaultProps, _props);
    const _a = props, { className: className, style: style, vars: vars, children: children, onKeyDownCapture: onKeyDownCapture, variant: variant, classNames: classNames, styles: styles } = _a, others = $c6c02060e092d07e$var$__objRest(_a, [
        "className",
        "style",
        "vars",
        "children",
        "onKeyDownCapture",
        "variant",
        "classNames",
        "styles"
    ]);
    const ctx = (0, $74f44c98474c2c98$export$1468d0761b26e6c8)();
    const returnFocus = (0, $f4823e3369c057aa$export$275f09232623ff6f)({
        opened: ctx.opened,
        shouldReturnFocus: ctx.returnFocus
    });
    const accessibleProps = ctx.withRoles ? {
        "aria-labelledby": ctx.getTargetId(),
        id: ctx.getDropdownId(),
        role: "dialog",
        tabIndex: -1
    } : {};
    const mergedRef = (0, $7034a45159125c0b$export$36a55fa7500f01f)(ref, ctx.floating);
    if (ctx.disabled) return null;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c40c05f34c6cea16$export$425106c5d6e6dc37), $c6c02060e092d07e$var$__spreadProps($c6c02060e092d07e$var$__spreadValues({}, ctx.portalProps), {
        withinPortal: ctx.withinPortal
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4e0d3c4af0891b98$export$be58926105124dd4), $c6c02060e092d07e$var$__spreadProps($c6c02060e092d07e$var$__spreadValues({
        mounted: ctx.opened
    }, ctx.transitionProps), {
        transition: ((_b = ctx.transitionProps) == null ? void 0 : _b.transition) || "fade",
        duration: (_d = (_c = ctx.transitionProps) == null ? void 0 : _c.duration) != null ? _d : 150,
        keepMounted: ctx.keepMounted,
        exitDuration: typeof ((_e = ctx.transitionProps) == null ? void 0 : _e.exitDuration) === "number" ? ctx.transitionProps.exitDuration : (_f = ctx.transitionProps) == null ? void 0 : _f.duration
    }), (transitionStyles)=>{
        var _a2, _b2;
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $78545dc889974525$export$34eba2437817a67b), {
            active: ctx.trapFocus
        }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $c6c02060e092d07e$var$__spreadValues($c6c02060e092d07e$var$__spreadProps($c6c02060e092d07e$var$__spreadValues($c6c02060e092d07e$var$__spreadValues({}, accessibleProps), others), {
            variant: variant,
            ref: mergedRef,
            onKeyDownCapture: (0, $f9102fe801bfca5d$export$902efad8ff1933eb)(ctx.onClose, {
                active: ctx.closeOnEscape,
                onTrigger: returnFocus,
                onKeyDown: onKeyDownCapture
            }),
            "data-position": ctx.placement
        }), ctx.getStyles("dropdown", {
            className: className,
            props: props,
            classNames: classNames,
            styles: styles,
            style: [
                $c6c02060e092d07e$var$__spreadProps($c6c02060e092d07e$var$__spreadValues({}, transitionStyles), {
                    zIndex: ctx.zIndex,
                    top: (_a2 = ctx.y) != null ? _a2 : 0,
                    left: (_b2 = ctx.x) != null ? _b2 : 0,
                    width: ctx.width === "target" ? void 0 : (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(ctx.width)
                }),
                style
            ]
        })), children, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $097c89337c87083a$export$33511391554732bc), $c6c02060e092d07e$var$__spreadValues({
            ref: ctx.arrowRef,
            arrowX: ctx.arrowX,
            arrowY: ctx.arrowY,
            visible: ctx.withArrow,
            position: ctx.placement,
            arrowSize: ctx.arrowSize,
            arrowRadius: ctx.arrowRadius,
            arrowOffset: ctx.arrowOffset,
            arrowPosition: ctx.arrowPosition
        }, ctx.getStyles("arrow", {
            props: props,
            classNames: classNames,
            styles: styles
        })))));
    }));
});
$c6c02060e092d07e$export$bc4cee0d3f11c45d.classes = (0, $ddfa993246a665fb$export$2e2bcd8739ae039);
$c6c02060e092d07e$export$bc4cee0d3f11c45d.displayName = "@mantine/core/PopoverDropdown";



"use client";
function $f12f1b971db8bc42$export$950b4922bb2f6bc6(dir, position) {
    if (dir === "rtl" && (position.includes("right") || position.includes("left"))) {
        const [side, placement] = position.split("-");
        const flippedPosition = side === "right" ? "left" : "right";
        return placement === void 0 ? flippedPosition : `${flippedPosition}-${placement}`;
    }
    return position;
}








"use client";
var $4c321a5e1b48bbbf$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $4c321a5e1b48bbbf$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $4c321a5e1b48bbbf$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $4c321a5e1b48bbbf$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($4c321a5e1b48bbbf$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $4c321a5e1b48bbbf$var$__getOwnPropSymbols) {
        for (var prop of $4c321a5e1b48bbbf$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $4c321a5e1b48bbbf$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $4c321a5e1b48bbbf$var$defaultProps = {
    position: "bottom",
    offset: 8,
    positionDependencies: [],
    transitionProps: {
        transition: "fade",
        duration: 150
    },
    middlewares: {
        flip: true,
        shift: true,
        inline: false
    },
    arrowSize: 7,
    arrowOffset: 5,
    arrowRadius: 0,
    arrowPosition: "side",
    closeOnClickOutside: true,
    withinPortal: true,
    closeOnEscape: true,
    trapFocus: false,
    withRoles: true,
    returnFocus: false,
    clickOutsideEvents: [
        "mousedown",
        "touchstart"
    ],
    zIndex: (0, $f4b868e08831abbf$export$65573e7d509c92dc)("popover"),
    __staticSelector: "Popover",
    width: "max-content"
};
const $4c321a5e1b48bbbf$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((_, { radius: radius, shadow: shadow })=>({
        dropdown: {
            "--popover-radius": radius === void 0 ? void 0 : (0, $fcab4af601ce7e99$export$35724d9c2979edc5)(radius),
            "--popover-shadow": (0, $fcab4af601ce7e99$export$db93b77dbb14f011)(shadow)
        }
    }));
function $4c321a5e1b48bbbf$export$5b6b19405a83ff9d(_props) {
    var _b, _c, _d, _e, _f, _g;
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("Popover", $4c321a5e1b48bbbf$var$defaultProps, _props);
    const _a = props, { children: children, position: position, offset: offset, onPositionChange: onPositionChange, positionDependencies: positionDependencies, opened: opened, transitionProps: transitionProps, width: width, middlewares: middlewares, withArrow: withArrow, arrowSize: arrowSize, arrowOffset: arrowOffset, arrowRadius: arrowRadius, arrowPosition: arrowPosition, unstyled: unstyled, classNames: classNames, styles: styles, closeOnClickOutside: closeOnClickOutside, withinPortal: withinPortal, portalProps: portalProps, closeOnEscape: closeOnEscape, clickOutsideEvents: clickOutsideEvents, trapFocus: trapFocus, onClose: onClose, onOpen: onOpen, onChange: onChange, zIndex: zIndex, radius: radius, shadow: shadow, id: id, defaultOpened: defaultOpened, __staticSelector: __staticSelector, withRoles: withRoles, disabled: disabled, returnFocus: returnFocus, variant: variant, keepMounted: keepMounted, vars: vars } = _a, others = $4c321a5e1b48bbbf$var$__objRest(_a, [
        "children",
        "position",
        "offset",
        "onPositionChange",
        "positionDependencies",
        "opened",
        "transitionProps",
        "width",
        "middlewares",
        "withArrow",
        "arrowSize",
        "arrowOffset",
        "arrowRadius",
        "arrowPosition",
        "unstyled",
        "classNames",
        "styles",
        "closeOnClickOutside",
        "withinPortal",
        "portalProps",
        "closeOnEscape",
        "clickOutsideEvents",
        "trapFocus",
        "onClose",
        "onOpen",
        "onChange",
        "zIndex",
        "radius",
        "shadow",
        "id",
        "defaultOpened",
        "__staticSelector",
        "withRoles",
        "disabled",
        "returnFocus",
        "variant",
        "keepMounted",
        "vars"
    ]);
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: __staticSelector,
        props: props,
        classes: $ddfa993246a665fb$export$2e2bcd8739ae039,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        rootSelector: "dropdown",
        vars: vars,
        varsResolver: $4c321a5e1b48bbbf$var$varsResolver
    });
    const arrowRef = (0, $acw62.useRef)(null);
    const [targetNode, setTargetNode] = (0, $acw62.useState)(null);
    const [dropdownNode, setDropdownNode] = (0, $acw62.useState)(null);
    const { dir: dir } = (0, $35c57ac18e24a61d$export$b39126d51d94e6f3)();
    const uid = (0, $cee42e5537afff93$export$f680877a34711e37)(id);
    const popover = (0, $c63cfc7636e0b51f$export$542a6fd13ac93354)({
        middlewares: middlewares,
        width: width,
        position: (0, $f12f1b971db8bc42$export$950b4922bb2f6bc6)(dir, position),
        offset: typeof offset === "number" ? offset + (withArrow ? arrowSize / 2 : 0) : offset,
        arrowRef: arrowRef,
        arrowOffset: arrowOffset,
        onPositionChange: onPositionChange,
        positionDependencies: positionDependencies,
        opened: opened,
        defaultOpened: defaultOpened,
        onChange: onChange,
        onOpen: onOpen,
        onClose: onClose
    });
    (0, $cacf5a31c84dd481$export$1896bab46732d207)(()=>closeOnClickOutside && popover.onClose(), clickOutsideEvents, [
        targetNode,
        dropdownNode
    ]);
    const reference = (0, $acw62.useCallback)((node)=>{
        setTargetNode(node);
        popover.floating.refs.setReference(node);
    }, [
        popover.floating.refs.setReference
    ]);
    const floating = (0, $acw62.useCallback)((node)=>{
        setDropdownNode(node);
        popover.floating.refs.setFloating(node);
    }, [
        popover.floating.refs.setFloating
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $74f44c98474c2c98$export$f5300fbf692a63ec), {
        value: {
            returnFocus: returnFocus,
            disabled: disabled,
            controlled: popover.controlled,
            reference: reference,
            floating: floating,
            x: popover.floating.x,
            y: popover.floating.y,
            arrowX: (_d = (_c = (_b = popover.floating) == null ? void 0 : _b.middlewareData) == null ? void 0 : _c.arrow) == null ? void 0 : _d.x,
            arrowY: (_g = (_f = (_e = popover.floating) == null ? void 0 : _e.middlewareData) == null ? void 0 : _f.arrow) == null ? void 0 : _g.y,
            opened: popover.opened,
            arrowRef: arrowRef,
            transitionProps: transitionProps,
            width: width,
            withArrow: withArrow,
            arrowSize: arrowSize,
            arrowOffset: arrowOffset,
            arrowRadius: arrowRadius,
            arrowPosition: arrowPosition,
            placement: popover.floating.placement,
            trapFocus: trapFocus,
            withinPortal: withinPortal,
            portalProps: portalProps,
            zIndex: zIndex,
            radius: radius,
            shadow: shadow,
            closeOnEscape: closeOnEscape,
            onClose: popover.onClose,
            onToggle: popover.onToggle,
            getTargetId: ()=>`${uid}-target`,
            getDropdownId: ()=>`${uid}-dropdown`,
            withRoles: withRoles,
            targetProps: others,
            __staticSelector: __staticSelector,
            classNames: classNames,
            styles: styles,
            unstyled: unstyled,
            variant: variant,
            keepMounted: keepMounted,
            getStyles: getStyles
        }
    }, children);
}
$4c321a5e1b48bbbf$export$5b6b19405a83ff9d.Target = (0, $a8854574e99469aa$export$5ad0c0856b469f13);
$4c321a5e1b48bbbf$export$5b6b19405a83ff9d.Dropdown = (0, $c6c02060e092d07e$export$bc4cee0d3f11c45d);
$4c321a5e1b48bbbf$export$5b6b19405a83ff9d.displayName = "@mantine/core/Popover";
$4c321a5e1b48bbbf$export$5b6b19405a83ff9d.extend = (input)=>input;





"use client";
var $0d4411a241549540$var$__defProp = Object.defineProperty;
var $0d4411a241549540$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $0d4411a241549540$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $0d4411a241549540$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $0d4411a241549540$var$__defNormalProp = (obj, key, value)=>key in obj ? $0d4411a241549540$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $0d4411a241549540$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($0d4411a241549540$var$__hasOwnProp.call(b, prop)) $0d4411a241549540$var$__defNormalProp(a, prop, b[prop]);
    if ($0d4411a241549540$var$__getOwnPropSymbols) {
        for (var prop of $0d4411a241549540$var$__getOwnPropSymbols(b))if ($0d4411a241549540$var$__propIsEnum.call(b, prop)) $0d4411a241549540$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $0d4411a241549540$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($0d4411a241549540$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $0d4411a241549540$var$__getOwnPropSymbols) {
        for (var prop of $0d4411a241549540$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $0d4411a241549540$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $0d4411a241549540$var$defaultProps = {
    refProp: "ref",
    targetType: "input",
    withKeyboardNavigation: true,
    withAriaAttributes: true,
    withExpandedAttribute: false
};
const $0d4411a241549540$export$c8f6ffdc92ed1c6b = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((props, ref)=>{
    const _a = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("ComboboxTarget", $0d4411a241549540$var$defaultProps, props), { children: children, refProp: refProp, withKeyboardNavigation: withKeyboardNavigation, withAriaAttributes: withAriaAttributes, withExpandedAttribute: withExpandedAttribute, targetType: targetType } = _a, others = $0d4411a241549540$var$__objRest(_a, [
        "children",
        "refProp",
        "withKeyboardNavigation",
        "withAriaAttributes",
        "withExpandedAttribute",
        "targetType"
    ]);
    if (!(0, $65b68cae0fe4eb32$export$45a5e7f76e0caa8d)(children)) throw new Error("Combobox.Target component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported");
    const ctx = (0, $f376d2b018786be2$export$a20838a54f9bb7c8)();
    const targetProps = (0, $b295bd7ffc5c275b$export$658025f4cf47e0bf)({
        targetType: targetType,
        withAriaAttributes: withAriaAttributes,
        withKeyboardNavigation: withKeyboardNavigation,
        withExpandedAttribute: withExpandedAttribute,
        onKeyDown: children.props.onKeyDown
    });
    const clonedElement = (0, $acw62.cloneElement)(children, $0d4411a241549540$var$__spreadValues($0d4411a241549540$var$__spreadValues({}, targetProps), others));
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c321a5e1b48bbbf$export$5b6b19405a83ff9d).Target, {
        ref: (0, $7034a45159125c0b$export$36a55fa7500f01f)(ref, ctx.store.targetRef)
    }, clonedElement);
});
$0d4411a241549540$export$c8f6ffdc92ed1c6b.displayName = "@mantine/core/ComboboxTarget";



var $acw62 = parcelRequire("acw62");

"use client";
var $bc4a4e3a2a9d5b76$var$classes = {
    "dropdown": "m-88b62a41",
    "options": "m-b2821a6e",
    "option": "m-92253aa5",
    "search": "m-985517d8",
    "empty": "m-2530cd1d",
    "header": "m-858f94bd",
    "footer": "m-82b967cb",
    "group": "m-254f3e4f",
    "groupLabel": "m-2bb2e9e5",
    "chevron": "m-2943220b",
    "optionsDropdownScrollArea": "m-71d052f9",
    "optionsDropdownOption": "m-390b5f4",
    "optionsDropdownCheckIcon": "m-8ee53fc2"
};
var $bc4a4e3a2a9d5b76$export$2e2bcd8739ae039 = $bc4a4e3a2a9d5b76$var$classes;





"use client";
var $be635d57c5c07df1$var$__defProp = Object.defineProperty;
var $be635d57c5c07df1$var$__defProps = Object.defineProperties;
var $be635d57c5c07df1$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $be635d57c5c07df1$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $be635d57c5c07df1$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $be635d57c5c07df1$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $be635d57c5c07df1$var$__defNormalProp = (obj, key, value)=>key in obj ? $be635d57c5c07df1$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $be635d57c5c07df1$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($be635d57c5c07df1$var$__hasOwnProp.call(b, prop)) $be635d57c5c07df1$var$__defNormalProp(a, prop, b[prop]);
    if ($be635d57c5c07df1$var$__getOwnPropSymbols) {
        for (var prop of $be635d57c5c07df1$var$__getOwnPropSymbols(b))if ($be635d57c5c07df1$var$__propIsEnum.call(b, prop)) $be635d57c5c07df1$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $be635d57c5c07df1$var$__spreadProps = (a, b)=>$be635d57c5c07df1$var$__defProps(a, $be635d57c5c07df1$var$__getOwnPropDescs(b));
var $be635d57c5c07df1$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($be635d57c5c07df1$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $be635d57c5c07df1$var$__getOwnPropSymbols) {
        for (var prop of $be635d57c5c07df1$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $be635d57c5c07df1$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $be635d57c5c07df1$var$defaultProps = {};
const $be635d57c5c07df1$export$46f7e665841a142b = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((props, ref)=>{
    const _a = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("ComboboxDropdown", $be635d57c5c07df1$var$defaultProps, props), { classNames: classNames, styles: styles, className: className, style: style, hidden: hidden } = _a, others = $be635d57c5c07df1$var$__objRest(_a, [
        "classNames",
        "styles",
        "className",
        "style",
        "hidden"
    ]);
    const ctx = (0, $f376d2b018786be2$export$a20838a54f9bb7c8)();
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c321a5e1b48bbbf$export$5b6b19405a83ff9d).Dropdown, $be635d57c5c07df1$var$__spreadValues($be635d57c5c07df1$var$__spreadProps($be635d57c5c07df1$var$__spreadValues({}, others), {
        ref: ref,
        role: "presentation",
        "data-hidden": hidden || void 0
    }), ctx.getStyles("dropdown", {
        className: className,
        style: style,
        classNames: classNames,
        styles: styles
    })));
});
$be635d57c5c07df1$export$46f7e665841a142b.classes = (0, $bc4a4e3a2a9d5b76$export$2e2bcd8739ae039);
$be635d57c5c07df1$export$46f7e665841a142b.displayName = "@mantine/core/ComboboxDropdown";



var $acw62 = parcelRequire("acw62");






"use client";
var $9f1a46b7f38dafb9$var$__defProp = Object.defineProperty;
var $9f1a46b7f38dafb9$var$__defProps = Object.defineProperties;
var $9f1a46b7f38dafb9$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $9f1a46b7f38dafb9$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $9f1a46b7f38dafb9$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $9f1a46b7f38dafb9$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $9f1a46b7f38dafb9$var$__defNormalProp = (obj, key, value)=>key in obj ? $9f1a46b7f38dafb9$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $9f1a46b7f38dafb9$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($9f1a46b7f38dafb9$var$__hasOwnProp.call(b, prop)) $9f1a46b7f38dafb9$var$__defNormalProp(a, prop, b[prop]);
    if ($9f1a46b7f38dafb9$var$__getOwnPropSymbols) {
        for (var prop of $9f1a46b7f38dafb9$var$__getOwnPropSymbols(b))if ($9f1a46b7f38dafb9$var$__propIsEnum.call(b, prop)) $9f1a46b7f38dafb9$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $9f1a46b7f38dafb9$var$__spreadProps = (a, b)=>$9f1a46b7f38dafb9$var$__defProps(a, $9f1a46b7f38dafb9$var$__getOwnPropDescs(b));
var $9f1a46b7f38dafb9$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($9f1a46b7f38dafb9$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $9f1a46b7f38dafb9$var$__getOwnPropSymbols) {
        for (var prop of $9f1a46b7f38dafb9$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $9f1a46b7f38dafb9$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $9f1a46b7f38dafb9$var$defaultProps = {};
const $9f1a46b7f38dafb9$export$47929aa3fb52fca2 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("ComboboxOptions", $9f1a46b7f38dafb9$var$defaultProps, _props);
    const _a = props, { classNames: classNames, className: className, style: style, styles: styles, id: id, onMouseDown: onMouseDown, labelledBy: labelledBy } = _a, others = $9f1a46b7f38dafb9$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "id",
        "onMouseDown",
        "labelledBy"
    ]);
    const ctx = (0, $f376d2b018786be2$export$a20838a54f9bb7c8)();
    const _id = (0, $cee42e5537afff93$export$f680877a34711e37)(id);
    (0, $acw62.useEffect)(()=>{
        ctx.store.setListId(_id);
    }, [
        _id
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $9f1a46b7f38dafb9$var$__spreadProps($9f1a46b7f38dafb9$var$__spreadValues($9f1a46b7f38dafb9$var$__spreadValues({
        ref: ref
    }, ctx.getStyles("options", {
        className: className,
        style: style,
        classNames: classNames,
        styles: styles
    })), others), {
        id: _id,
        role: "listbox",
        "aria-labelledby": labelledBy,
        onMouseDown: (event)=>{
            event.preventDefault();
            onMouseDown == null || onMouseDown(event);
        }
    }));
});
$9f1a46b7f38dafb9$export$47929aa3fb52fca2.classes = (0, $bc4a4e3a2a9d5b76$export$2e2bcd8739ae039);
$9f1a46b7f38dafb9$export$47929aa3fb52fca2.displayName = "@mantine/core/ComboboxOptions";



var $acw62 = parcelRequire("acw62");





"use client";
var $22366f40ac005da8$var$__defProp = Object.defineProperty;
var $22366f40ac005da8$var$__defProps = Object.defineProperties;
var $22366f40ac005da8$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $22366f40ac005da8$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $22366f40ac005da8$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $22366f40ac005da8$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $22366f40ac005da8$var$__defNormalProp = (obj, key, value)=>key in obj ? $22366f40ac005da8$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $22366f40ac005da8$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($22366f40ac005da8$var$__hasOwnProp.call(b, prop)) $22366f40ac005da8$var$__defNormalProp(a, prop, b[prop]);
    if ($22366f40ac005da8$var$__getOwnPropSymbols) {
        for (var prop of $22366f40ac005da8$var$__getOwnPropSymbols(b))if ($22366f40ac005da8$var$__propIsEnum.call(b, prop)) $22366f40ac005da8$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $22366f40ac005da8$var$__spreadProps = (a, b)=>$22366f40ac005da8$var$__defProps(a, $22366f40ac005da8$var$__getOwnPropDescs(b));
var $22366f40ac005da8$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($22366f40ac005da8$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $22366f40ac005da8$var$__getOwnPropSymbols) {
        for (var prop of $22366f40ac005da8$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $22366f40ac005da8$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $22366f40ac005da8$var$defaultProps = {};
const $22366f40ac005da8$export$7ce8df7790337ff4 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("ComboboxOption", $22366f40ac005da8$var$defaultProps, _props);
    const _a = props, { classNames: classNames, className: className, style: style, styles: styles, vars: vars, onClick: onClick, id: id, active: active, onMouseDown: onMouseDown, onMouseOver: onMouseOver, disabled: disabled, selected: selected } = _a, others = $22366f40ac005da8$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars",
        "onClick",
        "id",
        "active",
        "onMouseDown",
        "onMouseOver",
        "disabled",
        "selected"
    ]);
    const ctx = (0, $f376d2b018786be2$export$a20838a54f9bb7c8)();
    const uuid = (0, $acw62.useId)();
    const _id = id || uuid;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $22366f40ac005da8$var$__spreadProps($22366f40ac005da8$var$__spreadValues($22366f40ac005da8$var$__spreadValues({}, ctx.getStyles("option", {
        className: className,
        classNames: classNames,
        styles: styles,
        style: style
    })), others), {
        ref: ref,
        id: _id,
        mod: [
            "combobox-option",
            {
                "combobox-active": active,
                "combobox-disabled": disabled,
                "combobox-selected": selected
            }
        ],
        role: "option",
        onClick: (event)=>{
            var _a2;
            if (!disabled) {
                (_a2 = ctx.onOptionSubmit) == null || _a2.call(ctx, props.value, props);
                onClick == null || onClick(event);
            } else event.preventDefault();
        },
        onMouseDown: (event)=>{
            event.preventDefault();
            onMouseDown == null || onMouseDown(event);
        },
        onMouseOver: (event)=>{
            if (ctx.resetSelectionOnOptionHover) ctx.store.resetSelectedOption();
            onMouseOver == null || onMouseOver(event);
        }
    }));
});
$22366f40ac005da8$export$7ce8df7790337ff4.classes = (0, $bc4a4e3a2a9d5b76$export$2e2bcd8739ae039);
$22366f40ac005da8$export$7ce8df7790337ff4.displayName = "@mantine/core/ComboboxOption";



var $acw62 = parcelRequire("acw62");







"use client";
var $78346897be04ca6c$var$__defProp = Object.defineProperty;
var $78346897be04ca6c$var$__defProps = Object.defineProperties;
var $78346897be04ca6c$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $78346897be04ca6c$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $78346897be04ca6c$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $78346897be04ca6c$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $78346897be04ca6c$var$__defNormalProp = (obj, key, value)=>key in obj ? $78346897be04ca6c$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $78346897be04ca6c$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($78346897be04ca6c$var$__hasOwnProp.call(b, prop)) $78346897be04ca6c$var$__defNormalProp(a, prop, b[prop]);
    if ($78346897be04ca6c$var$__getOwnPropSymbols) {
        for (var prop of $78346897be04ca6c$var$__getOwnPropSymbols(b))if ($78346897be04ca6c$var$__propIsEnum.call(b, prop)) $78346897be04ca6c$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $78346897be04ca6c$var$__spreadProps = (a, b)=>$78346897be04ca6c$var$__defProps(a, $78346897be04ca6c$var$__getOwnPropDescs(b));
var $78346897be04ca6c$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($78346897be04ca6c$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $78346897be04ca6c$var$__getOwnPropSymbols) {
        for (var prop of $78346897be04ca6c$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $78346897be04ca6c$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $78346897be04ca6c$var$defaultProps = {
    withAriaAttributes: true,
    withKeyboardNavigation: true
};
const $78346897be04ca6c$export$6d4484b55d5b7980 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("ComboboxSearch", $78346897be04ca6c$var$defaultProps, _props);
    const _a = props, { classNames: classNames, styles: styles, unstyled: unstyled, vars: vars, withAriaAttributes: withAriaAttributes, onKeyDown: onKeyDown, withKeyboardNavigation: withKeyboardNavigation, size: size } = _a, others = $78346897be04ca6c$var$__objRest(_a, [
        "classNames",
        "styles",
        "unstyled",
        "vars",
        "withAriaAttributes",
        "onKeyDown",
        "withKeyboardNavigation",
        "size"
    ]);
    const ctx = (0, $f376d2b018786be2$export$a20838a54f9bb7c8)();
    const _styles = ctx.getStyles("search");
    const targetProps = (0, $b295bd7ffc5c275b$export$658025f4cf47e0bf)({
        targetType: "input",
        withAriaAttributes: withAriaAttributes,
        withKeyboardNavigation: withKeyboardNavigation,
        withExpandedAttribute: false,
        onKeyDown: onKeyDown
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e2e9ff0d29bd408f$export$f5b8910cec6cf069), $78346897be04ca6c$var$__spreadProps($78346897be04ca6c$var$__spreadValues($78346897be04ca6c$var$__spreadValues({
        ref: (0, $7034a45159125c0b$export$36a55fa7500f01f)(ref, ctx.store.searchRef),
        classNames: [
            {
                input: _styles.className
            },
            classNames
        ],
        styles: [
            {
                input: _styles.style
            },
            styles
        ],
        size: size || ctx.size
    }, targetProps), others), {
        __staticSelector: "Combobox"
    }));
});
$78346897be04ca6c$export$6d4484b55d5b7980.classes = (0, $bc4a4e3a2a9d5b76$export$2e2bcd8739ae039);
$78346897be04ca6c$export$6d4484b55d5b7980.displayName = "@mantine/core/ComboboxSearch";



var $acw62 = parcelRequire("acw62");





"use client";
var $00d7c82baf8527a5$var$__defProp = Object.defineProperty;
var $00d7c82baf8527a5$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $00d7c82baf8527a5$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $00d7c82baf8527a5$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $00d7c82baf8527a5$var$__defNormalProp = (obj, key, value)=>key in obj ? $00d7c82baf8527a5$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $00d7c82baf8527a5$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($00d7c82baf8527a5$var$__hasOwnProp.call(b, prop)) $00d7c82baf8527a5$var$__defNormalProp(a, prop, b[prop]);
    if ($00d7c82baf8527a5$var$__getOwnPropSymbols) {
        for (var prop of $00d7c82baf8527a5$var$__getOwnPropSymbols(b))if ($00d7c82baf8527a5$var$__propIsEnum.call(b, prop)) $00d7c82baf8527a5$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $00d7c82baf8527a5$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($00d7c82baf8527a5$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $00d7c82baf8527a5$var$__getOwnPropSymbols) {
        for (var prop of $00d7c82baf8527a5$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $00d7c82baf8527a5$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $00d7c82baf8527a5$var$defaultProps = {};
const $00d7c82baf8527a5$export$496c750611f10ca2 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((props, ref)=>{
    const _a = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("ComboboxEmpty", $00d7c82baf8527a5$var$defaultProps, props), { classNames: classNames, className: className, style: style, styles: styles, vars: vars } = _a, others = $00d7c82baf8527a5$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars"
    ]);
    const ctx = (0, $f376d2b018786be2$export$a20838a54f9bb7c8)();
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $00d7c82baf8527a5$var$__spreadValues($00d7c82baf8527a5$var$__spreadValues({
        ref: ref
    }, ctx.getStyles("empty", {
        className: className,
        classNames: classNames,
        styles: styles,
        style: style
    })), others));
});
$00d7c82baf8527a5$export$496c750611f10ca2.classes = (0, $bc4a4e3a2a9d5b76$export$2e2bcd8739ae039);
$00d7c82baf8527a5$export$496c750611f10ca2.displayName = "@mantine/core/ComboboxEmpty";



var $acw62 = parcelRequire("acw62");







"use client";
var $d65c6edeadfca253$var$__defProp = Object.defineProperty;
var $d65c6edeadfca253$var$__defProps = Object.defineProperties;
var $d65c6edeadfca253$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $d65c6edeadfca253$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $d65c6edeadfca253$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $d65c6edeadfca253$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $d65c6edeadfca253$var$__defNormalProp = (obj, key, value)=>key in obj ? $d65c6edeadfca253$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $d65c6edeadfca253$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($d65c6edeadfca253$var$__hasOwnProp.call(b, prop)) $d65c6edeadfca253$var$__defNormalProp(a, prop, b[prop]);
    if ($d65c6edeadfca253$var$__getOwnPropSymbols) {
        for (var prop of $d65c6edeadfca253$var$__getOwnPropSymbols(b))if ($d65c6edeadfca253$var$__propIsEnum.call(b, prop)) $d65c6edeadfca253$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $d65c6edeadfca253$var$__spreadProps = (a, b)=>$d65c6edeadfca253$var$__defProps(a, $d65c6edeadfca253$var$__getOwnPropDescs(b));
var $d65c6edeadfca253$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($d65c6edeadfca253$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $d65c6edeadfca253$var$__getOwnPropSymbols) {
        for (var prop of $d65c6edeadfca253$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $d65c6edeadfca253$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $d65c6edeadfca253$var$defaultProps = {
    error: null
};
const $d65c6edeadfca253$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((_, { size: size })=>({
        chevron: {
            "--combobox-chevron-size": (0, $fcab4af601ce7e99$export$31b21d0167753bb4)(size, "combobox-chevron-size")
        }
    }));
const $d65c6edeadfca253$export$ad0f9dc19973f01e = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("ComboboxChevron", $d65c6edeadfca253$var$defaultProps, _props);
    const _a = props, { size: size, error: error, style: style, className: className, classNames: classNames, styles: styles, unstyled: unstyled, vars: vars } = _a, others = $d65c6edeadfca253$var$__objRest(_a, [
        "size",
        "error",
        "style",
        "className",
        "classNames",
        "styles",
        "unstyled",
        "vars"
    ]);
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: "ComboboxChevron",
        classes: $bc4a4e3a2a9d5b76$export$2e2bcd8739ae039,
        props: props,
        style: style,
        className: className,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        vars: vars,
        varsResolver: $d65c6edeadfca253$var$varsResolver,
        rootSelector: "chevron"
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $d65c6edeadfca253$var$__spreadProps($d65c6edeadfca253$var$__spreadValues($d65c6edeadfca253$var$__spreadValues({
        component: "svg"
    }, others), getStyles("chevron")), {
        size: size,
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        mod: [
            "combobox-chevron",
            {
                error: error
            }
        ],
        ref: ref
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M4.93179 5.43179C4.75605 5.60753 4.75605 5.89245 4.93179 6.06819C5.10753 6.24392 5.39245 6.24392 5.56819 6.06819L7.49999 4.13638L9.43179 6.06819C9.60753 6.24392 9.89245 6.24392 10.0682 6.06819C10.2439 5.89245 10.2439 5.60753 10.0682 5.43179L7.81819 3.18179C7.73379 3.0974 7.61933 3.04999 7.49999 3.04999C7.38064 3.04999 7.26618 3.0974 7.18179 3.18179L4.93179 5.43179ZM10.0682 9.56819C10.2439 9.39245 10.2439 9.10753 10.0682 8.93179C9.89245 8.75606 9.60753 8.75606 9.43179 8.93179L7.49999 10.8636L5.56819 8.93179C5.39245 8.75606 5.10753 8.75606 4.93179 8.93179C4.75605 9.10753 4.75605 9.39245 4.93179 9.56819L7.18179 11.8182C7.35753 11.9939 7.64245 11.9939 7.81819 11.8182L10.0682 9.56819Z",
        fill: "currentColor",
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
$d65c6edeadfca253$export$ad0f9dc19973f01e.classes = (0, $bc4a4e3a2a9d5b76$export$2e2bcd8739ae039);
$d65c6edeadfca253$export$ad0f9dc19973f01e.displayName = "@mantine/core/ComboboxChevron";



var $acw62 = parcelRequire("acw62");





"use client";
var $354a11466b43f483$var$__defProp = Object.defineProperty;
var $354a11466b43f483$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $354a11466b43f483$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $354a11466b43f483$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $354a11466b43f483$var$__defNormalProp = (obj, key, value)=>key in obj ? $354a11466b43f483$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $354a11466b43f483$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($354a11466b43f483$var$__hasOwnProp.call(b, prop)) $354a11466b43f483$var$__defNormalProp(a, prop, b[prop]);
    if ($354a11466b43f483$var$__getOwnPropSymbols) {
        for (var prop of $354a11466b43f483$var$__getOwnPropSymbols(b))if ($354a11466b43f483$var$__propIsEnum.call(b, prop)) $354a11466b43f483$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $354a11466b43f483$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($354a11466b43f483$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $354a11466b43f483$var$__getOwnPropSymbols) {
        for (var prop of $354a11466b43f483$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $354a11466b43f483$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $354a11466b43f483$var$defaultProps = {};
const $354a11466b43f483$export$bafd4c39d0112309 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((props, ref)=>{
    const _a = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("ComboboxFooter", $354a11466b43f483$var$defaultProps, props), { classNames: classNames, className: className, style: style, styles: styles, vars: vars } = _a, others = $354a11466b43f483$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars"
    ]);
    const ctx = (0, $f376d2b018786be2$export$a20838a54f9bb7c8)();
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $354a11466b43f483$var$__spreadValues($354a11466b43f483$var$__spreadValues({
        ref: ref
    }, ctx.getStyles("footer", {
        className: className,
        classNames: classNames,
        style: style,
        styles: styles
    })), others));
});
$354a11466b43f483$export$bafd4c39d0112309.classes = (0, $bc4a4e3a2a9d5b76$export$2e2bcd8739ae039);
$354a11466b43f483$export$bafd4c39d0112309.displayName = "@mantine/core/ComboboxFooter";



var $acw62 = parcelRequire("acw62");





"use client";
var $5b349a8086436ba3$var$__defProp = Object.defineProperty;
var $5b349a8086436ba3$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $5b349a8086436ba3$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $5b349a8086436ba3$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $5b349a8086436ba3$var$__defNormalProp = (obj, key, value)=>key in obj ? $5b349a8086436ba3$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $5b349a8086436ba3$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($5b349a8086436ba3$var$__hasOwnProp.call(b, prop)) $5b349a8086436ba3$var$__defNormalProp(a, prop, b[prop]);
    if ($5b349a8086436ba3$var$__getOwnPropSymbols) {
        for (var prop of $5b349a8086436ba3$var$__getOwnPropSymbols(b))if ($5b349a8086436ba3$var$__propIsEnum.call(b, prop)) $5b349a8086436ba3$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $5b349a8086436ba3$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($5b349a8086436ba3$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $5b349a8086436ba3$var$__getOwnPropSymbols) {
        for (var prop of $5b349a8086436ba3$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $5b349a8086436ba3$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $5b349a8086436ba3$var$defaultProps = {};
const $5b349a8086436ba3$export$9e051a65397489f5 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((props, ref)=>{
    const _a = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("ComboboxHeader", $5b349a8086436ba3$var$defaultProps, props), { classNames: classNames, className: className, style: style, styles: styles, vars: vars } = _a, others = $5b349a8086436ba3$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars"
    ]);
    const ctx = (0, $f376d2b018786be2$export$a20838a54f9bb7c8)();
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $5b349a8086436ba3$var$__spreadValues($5b349a8086436ba3$var$__spreadValues({
        ref: ref
    }, ctx.getStyles("header", {
        className: className,
        classNames: classNames,
        style: style,
        styles: styles
    })), others));
});
$5b349a8086436ba3$export$9e051a65397489f5.classes = (0, $bc4a4e3a2a9d5b76$export$2e2bcd8739ae039);
$5b349a8086436ba3$export$9e051a65397489f5.displayName = "@mantine/core/ComboboxHeader";



var $acw62 = parcelRequire("acw62");






"use client";
var $60f09fc49f947a41$var$__defProp = Object.defineProperty;
var $60f09fc49f947a41$var$__defProps = Object.defineProperties;
var $60f09fc49f947a41$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $60f09fc49f947a41$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $60f09fc49f947a41$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $60f09fc49f947a41$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $60f09fc49f947a41$var$__defNormalProp = (obj, key, value)=>key in obj ? $60f09fc49f947a41$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $60f09fc49f947a41$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($60f09fc49f947a41$var$__hasOwnProp.call(b, prop)) $60f09fc49f947a41$var$__defNormalProp(a, prop, b[prop]);
    if ($60f09fc49f947a41$var$__getOwnPropSymbols) {
        for (var prop of $60f09fc49f947a41$var$__getOwnPropSymbols(b))if ($60f09fc49f947a41$var$__propIsEnum.call(b, prop)) $60f09fc49f947a41$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $60f09fc49f947a41$var$__spreadProps = (a, b)=>$60f09fc49f947a41$var$__defProps(a, $60f09fc49f947a41$var$__getOwnPropDescs(b));
var $60f09fc49f947a41$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($60f09fc49f947a41$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $60f09fc49f947a41$var$__getOwnPropSymbols) {
        for (var prop of $60f09fc49f947a41$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $60f09fc49f947a41$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $60f09fc49f947a41$var$defaultProps = {
    refProp: "ref",
    targetType: "input",
    withKeyboardNavigation: true,
    withAriaAttributes: true,
    withExpandedAttribute: false
};
const $60f09fc49f947a41$export$6334353494a326b3 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((props, ref)=>{
    const _a = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("ComboboxEventsTarget", $60f09fc49f947a41$var$defaultProps, props), { children: children, refProp: refProp, withKeyboardNavigation: withKeyboardNavigation, withAriaAttributes: withAriaAttributes, withExpandedAttribute: withExpandedAttribute, targetType: targetType } = _a, others = $60f09fc49f947a41$var$__objRest(_a, [
        "children",
        "refProp",
        "withKeyboardNavigation",
        "withAriaAttributes",
        "withExpandedAttribute",
        "targetType"
    ]);
    if (!(0, $65b68cae0fe4eb32$export$45a5e7f76e0caa8d)(children)) throw new Error("Combobox.EventsTarget component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported");
    const ctx = (0, $f376d2b018786be2$export$a20838a54f9bb7c8)();
    const targetProps = (0, $b295bd7ffc5c275b$export$658025f4cf47e0bf)({
        targetType: targetType,
        withAriaAttributes: withAriaAttributes,
        withKeyboardNavigation: withKeyboardNavigation,
        withExpandedAttribute: withExpandedAttribute,
        onKeyDown: children.props.onKeyDown
    });
    return (0, $acw62.cloneElement)(children, $60f09fc49f947a41$var$__spreadProps($60f09fc49f947a41$var$__spreadValues($60f09fc49f947a41$var$__spreadValues({}, targetProps), others), {
        [refProp]: (0, $7034a45159125c0b$export$36a55fa7500f01f)(ref, ctx.store.targetRef, children == null ? void 0 : children.ref)
    }));
});
$60f09fc49f947a41$export$6334353494a326b3.displayName = "@mantine/core/ComboboxEventsTarget";



var $acw62 = parcelRequire("acw62");





"use client";
const $543ba02f3749d1ab$var$defaultProps = {
    refProp: "ref"
};
const $543ba02f3749d1ab$export$367d377becfc72b8 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((props, ref)=>{
    const { children: children, refProp: refProp } = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("ComboboxDropdownTarget", $543ba02f3749d1ab$var$defaultProps, props);
    (0, $f376d2b018786be2$export$a20838a54f9bb7c8)();
    if (!(0, $65b68cae0fe4eb32$export$45a5e7f76e0caa8d)(children)) throw new Error("Combobox.DropdownTarget component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported");
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c321a5e1b48bbbf$export$5b6b19405a83ff9d).Target, {
        ref: ref,
        refProp: refProp
    }, children);
});
$543ba02f3749d1ab$export$367d377becfc72b8.displayName = "@mantine/core/ComboboxDropdownTarget";



var $acw62 = parcelRequire("acw62");





"use client";
var $e07e4b7256f031f0$var$__defProp = Object.defineProperty;
var $e07e4b7256f031f0$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $e07e4b7256f031f0$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $e07e4b7256f031f0$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $e07e4b7256f031f0$var$__defNormalProp = (obj, key, value)=>key in obj ? $e07e4b7256f031f0$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $e07e4b7256f031f0$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($e07e4b7256f031f0$var$__hasOwnProp.call(b, prop)) $e07e4b7256f031f0$var$__defNormalProp(a, prop, b[prop]);
    if ($e07e4b7256f031f0$var$__getOwnPropSymbols) {
        for (var prop of $e07e4b7256f031f0$var$__getOwnPropSymbols(b))if ($e07e4b7256f031f0$var$__propIsEnum.call(b, prop)) $e07e4b7256f031f0$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $e07e4b7256f031f0$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($e07e4b7256f031f0$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $e07e4b7256f031f0$var$__getOwnPropSymbols) {
        for (var prop of $e07e4b7256f031f0$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $e07e4b7256f031f0$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $e07e4b7256f031f0$var$defaultProps = {};
const $e07e4b7256f031f0$export$794db46f91afd158 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((props, ref)=>{
    const _a = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("ComboboxGroup", $e07e4b7256f031f0$var$defaultProps, props), { classNames: classNames, className: className, style: style, styles: styles, vars: vars, children: children, label: label } = _a, others = $e07e4b7256f031f0$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars",
        "children",
        "label"
    ]);
    const ctx = (0, $f376d2b018786be2$export$a20838a54f9bb7c8)();
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $e07e4b7256f031f0$var$__spreadValues($e07e4b7256f031f0$var$__spreadValues({
        ref: ref
    }, ctx.getStyles("group", {
        className: className,
        classNames: classNames,
        style: style,
        styles: styles
    })), others), label && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $e07e4b7256f031f0$var$__spreadValues({}, ctx.getStyles("groupLabel", {
        classNames: classNames,
        styles: styles
    })), label), children);
});
$e07e4b7256f031f0$export$794db46f91afd158.classes = (0, $bc4a4e3a2a9d5b76$export$2e2bcd8739ae039);
$e07e4b7256f031f0$export$794db46f91afd158.displayName = "@mantine/core/ComboboxGroup";



var $acw62 = parcelRequire("acw62");

"use client";
var $1f27f656e96118a6$var$__defProp = Object.defineProperty;
var $1f27f656e96118a6$var$__defProps = Object.defineProperties;
var $1f27f656e96118a6$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $1f27f656e96118a6$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $1f27f656e96118a6$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $1f27f656e96118a6$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $1f27f656e96118a6$var$__defNormalProp = (obj, key, value)=>key in obj ? $1f27f656e96118a6$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $1f27f656e96118a6$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($1f27f656e96118a6$var$__hasOwnProp.call(b, prop)) $1f27f656e96118a6$var$__defNormalProp(a, prop, b[prop]);
    if ($1f27f656e96118a6$var$__getOwnPropSymbols) {
        for (var prop of $1f27f656e96118a6$var$__getOwnPropSymbols(b))if ($1f27f656e96118a6$var$__propIsEnum.call(b, prop)) $1f27f656e96118a6$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $1f27f656e96118a6$var$__spreadProps = (a, b)=>$1f27f656e96118a6$var$__defProps(a, $1f27f656e96118a6$var$__getOwnPropDescs(b));
var $1f27f656e96118a6$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($1f27f656e96118a6$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $1f27f656e96118a6$var$__getOwnPropSymbols) {
        for (var prop of $1f27f656e96118a6$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $1f27f656e96118a6$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $1f27f656e96118a6$export$9f95a933acace2c3 = (0, $acw62.forwardRef)((_a, ref)=>{
    var _b = _a, { size: size, onMouseDown: onMouseDown, onClick: onClick, onClear: onClear } = _b, others = $1f27f656e96118a6$var$__objRest(_b, [
        "size",
        "onMouseDown",
        "onClick",
        "onClear"
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $30da360a5c87638a$export$de65de8213222d10), $1f27f656e96118a6$var$__spreadProps($1f27f656e96118a6$var$__spreadValues({
        ref: ref,
        size: size || "sm",
        variant: "transparent",
        tabIndex: -1,
        "aria-hidden": true
    }, others), {
        onMouseDown: (event)=>{
            event.preventDefault();
            onMouseDown == null || onMouseDown(event);
        },
        onClick: (event)=>{
            onClear();
            onClick == null || onClick(event);
        }
    }));
});
$1f27f656e96118a6$export$9f95a933acace2c3.displayName = "@mantine/core/ComboboxClearButton";









"use client";
var $924916f5dbd1d3eb$var$__defProp = Object.defineProperty;
var $924916f5dbd1d3eb$var$__defProps = Object.defineProperties;
var $924916f5dbd1d3eb$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $924916f5dbd1d3eb$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $924916f5dbd1d3eb$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $924916f5dbd1d3eb$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $924916f5dbd1d3eb$var$__defNormalProp = (obj, key, value)=>key in obj ? $924916f5dbd1d3eb$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $924916f5dbd1d3eb$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($924916f5dbd1d3eb$var$__hasOwnProp.call(b, prop)) $924916f5dbd1d3eb$var$__defNormalProp(a, prop, b[prop]);
    if ($924916f5dbd1d3eb$var$__getOwnPropSymbols) {
        for (var prop of $924916f5dbd1d3eb$var$__getOwnPropSymbols(b))if ($924916f5dbd1d3eb$var$__propIsEnum.call(b, prop)) $924916f5dbd1d3eb$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $924916f5dbd1d3eb$var$__spreadProps = (a, b)=>$924916f5dbd1d3eb$var$__defProps(a, $924916f5dbd1d3eb$var$__getOwnPropDescs(b));
var $924916f5dbd1d3eb$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($924916f5dbd1d3eb$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $924916f5dbd1d3eb$var$__getOwnPropSymbols) {
        for (var prop of $924916f5dbd1d3eb$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $924916f5dbd1d3eb$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $924916f5dbd1d3eb$var$defaultProps = {
    keepMounted: true,
    withinPortal: true,
    resetSelectionOnOptionHover: false,
    width: "target",
    transitionProps: {
        transition: "fade",
        duration: 0
    }
};
const $924916f5dbd1d3eb$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((_, { size: size, dropdownPadding: dropdownPadding })=>({
        options: {
            "--combobox-option-fz": (0, $fcab4af601ce7e99$export$7d055c252aebca58)(size),
            "--combobox-option-padding": (0, $fcab4af601ce7e99$export$31b21d0167753bb4)(size, "combobox-option-padding")
        },
        dropdown: {
            "--combobox-padding": dropdownPadding === void 0 ? void 0 : (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(dropdownPadding),
            "--combobox-option-fz": (0, $fcab4af601ce7e99$export$7d055c252aebca58)(size),
            "--combobox-option-padding": (0, $fcab4af601ce7e99$export$31b21d0167753bb4)(size, "combobox-option-padding")
        }
    }));
function $924916f5dbd1d3eb$export$27957ad87354dd7e(_props) {
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("Combobox", $924916f5dbd1d3eb$var$defaultProps, _props);
    const _a = props, { classNames: classNames, styles: styles, unstyled: unstyled, children: children, store: controlledStore, vars: vars, onOptionSubmit: onOptionSubmit, size: size, dropdownPadding: dropdownPadding, resetSelectionOnOptionHover: resetSelectionOnOptionHover, __staticSelector: __staticSelector, readOnly: readOnly } = _a, others = $924916f5dbd1d3eb$var$__objRest(_a, [
        "classNames",
        "styles",
        "unstyled",
        "children",
        "store",
        "vars",
        "onOptionSubmit",
        "size",
        "dropdownPadding",
        "resetSelectionOnOptionHover",
        "__staticSelector",
        "readOnly"
    ]);
    const uncontrolledStore = (0, $ec685ef88b7ada0d$export$7a023a466c03eb3d)();
    const store = controlledStore || uncontrolledStore;
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: __staticSelector || "Combobox",
        classes: $bc4a4e3a2a9d5b76$export$2e2bcd8739ae039,
        props: props,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        vars: vars,
        varsResolver: $924916f5dbd1d3eb$var$varsResolver
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f376d2b018786be2$export$f11a865534e57bfe), {
        value: {
            getStyles: getStyles,
            store: store,
            onOptionSubmit: onOptionSubmit,
            size: size,
            resetSelectionOnOptionHover: resetSelectionOnOptionHover,
            readOnly: readOnly
        }
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c321a5e1b48bbbf$export$5b6b19405a83ff9d), $924916f5dbd1d3eb$var$__spreadProps($924916f5dbd1d3eb$var$__spreadValues({
        opened: store.dropdownOpened
    }, others), {
        onClose: store.closeDropdown,
        withRoles: false,
        unstyled: unstyled
    }), children));
}
const $924916f5dbd1d3eb$var$extendCombobox = (c)=>c;
$924916f5dbd1d3eb$export$27957ad87354dd7e.extend = $924916f5dbd1d3eb$var$extendCombobox;
$924916f5dbd1d3eb$export$27957ad87354dd7e.classes = (0, $bc4a4e3a2a9d5b76$export$2e2bcd8739ae039);
$924916f5dbd1d3eb$export$27957ad87354dd7e.displayName = "@mantine/core/Combobox";
$924916f5dbd1d3eb$export$27957ad87354dd7e.Target = (0, $0d4411a241549540$export$c8f6ffdc92ed1c6b);
$924916f5dbd1d3eb$export$27957ad87354dd7e.Dropdown = (0, $be635d57c5c07df1$export$46f7e665841a142b);
$924916f5dbd1d3eb$export$27957ad87354dd7e.Options = (0, $9f1a46b7f38dafb9$export$47929aa3fb52fca2);
$924916f5dbd1d3eb$export$27957ad87354dd7e.Option = (0, $22366f40ac005da8$export$7ce8df7790337ff4);
$924916f5dbd1d3eb$export$27957ad87354dd7e.Search = (0, $78346897be04ca6c$export$6d4484b55d5b7980);
$924916f5dbd1d3eb$export$27957ad87354dd7e.Empty = (0, $00d7c82baf8527a5$export$496c750611f10ca2);
$924916f5dbd1d3eb$export$27957ad87354dd7e.Chevron = (0, $d65c6edeadfca253$export$ad0f9dc19973f01e);
$924916f5dbd1d3eb$export$27957ad87354dd7e.Footer = (0, $354a11466b43f483$export$bafd4c39d0112309);
$924916f5dbd1d3eb$export$27957ad87354dd7e.Header = (0, $5b349a8086436ba3$export$9e051a65397489f5);
$924916f5dbd1d3eb$export$27957ad87354dd7e.EventsTarget = (0, $60f09fc49f947a41$export$6334353494a326b3);
$924916f5dbd1d3eb$export$27957ad87354dd7e.DropdownTarget = (0, $543ba02f3749d1ab$export$367d377becfc72b8);
$924916f5dbd1d3eb$export$27957ad87354dd7e.Group = (0, $e07e4b7256f031f0$export$794db46f91afd158);
$924916f5dbd1d3eb$export$27957ad87354dd7e.ClearButton = (0, $1f27f656e96118a6$export$9f95a933acace2c3);




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

"use client";
const [$79f911f27c208c7e$export$ea262e38353a259a, $79f911f27c208c7e$export$6f5f1e779aff6cfb] = (0, $0bf9cc213b4abd2e$export$97d0e477aacf9b7d)("ScrollArea.Root component was not found in tree");



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
"use client";
function $c0a208301a628af8$export$25bec8c6f54ee79a(callback) {
    const callbackRef = (0, $acw62.useRef)(callback);
    (0, $acw62.useEffect)(()=>{
        callbackRef.current = callback;
    });
    return (0, $acw62.useMemo)(()=>(...args)=>{
            var _a;
            return (_a = callbackRef.current) == null ? void 0 : _a.call(callbackRef, ...args);
        }, []);
}


var $acw62 = parcelRequire("acw62");

"use client";
function $4919278891a7db8a$export$40ae01be0011c1e6(callback, delay) {
    const handleCallback = (0, $c0a208301a628af8$export$25bec8c6f54ee79a)(callback);
    const debounceTimerRef = (0, $acw62.useRef)(0);
    (0, $acw62.useEffect)(()=>()=>window.clearTimeout(debounceTimerRef.current), []);
    return (0, $acw62.useCallback)(()=>{
        window.clearTimeout(debounceTimerRef.current);
        debounceTimerRef.current = window.setTimeout(handleCallback, delay);
    }, [
        handleCallback,
        delay
    ]);
}



"use client";
function $132fa50acb2babc6$export$683480f191c0e3ea(element, onResize) {
    const handleResize = (0, $c0a208301a628af8$export$25bec8c6f54ee79a)(onResize);
    (0, $562774022e0ac3ca$export$363c9f3eb56bbdbe)(()=>{
        let rAF = 0;
        if (element) {
            const resizeObserver = new ResizeObserver(()=>{
                cancelAnimationFrame(rAF);
                rAF = window.requestAnimationFrame(handleResize);
            });
            resizeObserver.observe(element);
            return ()=>{
                window.cancelAnimationFrame(rAF);
                resizeObserver.unobserve(element);
            };
        }
        return void 0;
    }, [
        element,
        handleResize
    ]);
}




"use client";
const [$e66ab2864f33f4cb$export$9ab4af0f5675598e, $e66ab2864f33f4cb$export$9eae1e0809562d06] = (0, $0bf9cc213b4abd2e$export$97d0e477aacf9b7d)("ScrollAreaScrollbar was not found in tree");


"use client";
function $1c9ccee2f3ecd168$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true } = {}) {
    return (event)=>{
        originalEventHandler == null || originalEventHandler(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) ourEventHandler == null || ourEventHandler(event);
    };
}


"use client";
var $3a6eef7319454adf$var$__defProp = Object.defineProperty;
var $3a6eef7319454adf$var$__defProps = Object.defineProperties;
var $3a6eef7319454adf$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $3a6eef7319454adf$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $3a6eef7319454adf$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $3a6eef7319454adf$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $3a6eef7319454adf$var$__defNormalProp = (obj, key, value)=>key in obj ? $3a6eef7319454adf$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $3a6eef7319454adf$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($3a6eef7319454adf$var$__hasOwnProp.call(b, prop)) $3a6eef7319454adf$var$__defNormalProp(a, prop, b[prop]);
    if ($3a6eef7319454adf$var$__getOwnPropSymbols) {
        for (var prop of $3a6eef7319454adf$var$__getOwnPropSymbols(b))if ($3a6eef7319454adf$var$__propIsEnum.call(b, prop)) $3a6eef7319454adf$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $3a6eef7319454adf$var$__spreadProps = (a, b)=>$3a6eef7319454adf$var$__defProps(a, $3a6eef7319454adf$var$__getOwnPropDescs(b));
var $3a6eef7319454adf$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($3a6eef7319454adf$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $3a6eef7319454adf$var$__getOwnPropSymbols) {
        for (var prop of $3a6eef7319454adf$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $3a6eef7319454adf$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $3a6eef7319454adf$export$9a4e88b92edfce6b = (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const _a = props, { sizes: sizes, hasThumb: hasThumb, onThumbChange: onThumbChange, onThumbPointerUp: onThumbPointerUp, onThumbPointerDown: onThumbPointerDown, onThumbPositionChange: onThumbPositionChange, onDragScroll: onDragScroll, onWheelScroll: onWheelScroll, onResize: onResize } = _a, scrollbarProps = $3a6eef7319454adf$var$__objRest(_a, [
        "sizes",
        "hasThumb",
        "onThumbChange",
        "onThumbPointerUp",
        "onThumbPointerDown",
        "onThumbPositionChange",
        "onDragScroll",
        "onWheelScroll",
        "onResize"
    ]);
    const context = (0, $79f911f27c208c7e$export$6f5f1e779aff6cfb)();
    const [scrollbar, setScrollbar] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const composeRefs = (0, $7034a45159125c0b$export$36a55fa7500f01f)(forwardedRef, (node)=>setScrollbar(node));
    const rectRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const prevWebkitUserSelectRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef("");
    const { viewport: viewport } = context;
    const maxScrollPos = sizes.content - sizes.viewport;
    const handleWheelScroll = (0, $c0a208301a628af8$export$25bec8c6f54ee79a)(onWheelScroll);
    const handleThumbPositionChange = (0, $c0a208301a628af8$export$25bec8c6f54ee79a)(onThumbPositionChange);
    const handleResize = (0, $4919278891a7db8a$export$40ae01be0011c1e6)(onResize, 10);
    const handleDragScroll = (event)=>{
        if (rectRef.current) {
            const x = event.clientX - rectRef.current.left;
            const y = event.clientY - rectRef.current.top;
            onDragScroll({
                x: x,
                y: y
            });
        }
    };
    (0, $acw62.useEffect)(()=>{
        const handleWheel = (event)=>{
            const element = event.target;
            const isScrollbarWheel = scrollbar == null ? void 0 : scrollbar.contains(element);
            if (isScrollbarWheel) handleWheelScroll(event, maxScrollPos);
        };
        document.addEventListener("wheel", handleWheel, {
            passive: false
        });
        return ()=>document.removeEventListener("wheel", handleWheel, {
                passive: false
            });
    }, [
        viewport,
        scrollbar,
        maxScrollPos,
        handleWheelScroll
    ]);
    (0, $acw62.useEffect)(handleThumbPositionChange, [
        sizes,
        handleThumbPositionChange
    ]);
    (0, $132fa50acb2babc6$export$683480f191c0e3ea)(scrollbar, handleResize);
    (0, $132fa50acb2babc6$export$683480f191c0e3ea)(context.content, handleResize);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e66ab2864f33f4cb$export$9ab4af0f5675598e), {
        value: {
            scrollbar: scrollbar,
            hasThumb: hasThumb,
            onThumbChange: (0, $c0a208301a628af8$export$25bec8c6f54ee79a)(onThumbChange),
            onThumbPointerUp: (0, $c0a208301a628af8$export$25bec8c6f54ee79a)(onThumbPointerUp),
            onThumbPositionChange: handleThumbPositionChange,
            onThumbPointerDown: (0, $c0a208301a628af8$export$25bec8c6f54ee79a)(onThumbPointerDown)
        }
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $3a6eef7319454adf$var$__spreadProps($3a6eef7319454adf$var$__spreadValues({}, scrollbarProps), {
        ref: composeRefs,
        style: $3a6eef7319454adf$var$__spreadValues({
            position: "absolute"
        }, scrollbarProps.style),
        onPointerDown: (0, $1c9ccee2f3ecd168$export$b9ecd428b558ff10)(props.onPointerDown, (event)=>{
            const mainPointer = 0;
            if (event.button === mainPointer) {
                const element = event.target;
                element.setPointerCapture(event.pointerId);
                rectRef.current = scrollbar.getBoundingClientRect();
                prevWebkitUserSelectRef.current = document.body.style.webkitUserSelect;
                document.body.style.webkitUserSelect = "none";
                handleDragScroll(event);
            }
        }),
        onPointerMove: (0, $1c9ccee2f3ecd168$export$b9ecd428b558ff10)(props.onPointerMove, handleDragScroll),
        onPointerUp: (0, $1c9ccee2f3ecd168$export$b9ecd428b558ff10)(props.onPointerUp, (event)=>{
            const element = event.target;
            if (element.hasPointerCapture(event.pointerId)) element.releasePointerCapture(event.pointerId);
            document.body.style.webkitUserSelect = prevWebkitUserSelectRef.current;
            rectRef.current = null;
        })
    })));
});



"use client";
function $e40829f322f41fa9$export$cf7769cb1c49cedf(viewportSize, contentSize) {
    const ratio = viewportSize / contentSize;
    return Number.isNaN(ratio) ? 0 : ratio;
}


"use client";
function $ad769dbbdef0d7a6$export$7b14c3f3cc4d1eca(sizes) {
    const ratio = (0, $e40829f322f41fa9$export$cf7769cb1c49cedf)(sizes.viewport, sizes.content);
    const scrollbarPadding = sizes.scrollbar.paddingStart + sizes.scrollbar.paddingEnd;
    const thumbSize = (sizes.scrollbar.size - scrollbarPadding) * ratio;
    return Math.max(thumbSize, 18);
}


"use client";
function $3bc502b82e5dc37a$export$3dd2cb87ed130ea5(scrollPos, maxScrollPos) {
    return scrollPos > 0 && scrollPos < maxScrollPos;
}


"use client";
function $d6ccc87a85e73501$export$e7a1baa2fae31f0f(value) {
    return value ? parseInt(value, 10) : 0;
}


"use client";
var $a93a46694e11b218$var$__defProp = Object.defineProperty;
var $a93a46694e11b218$var$__defProps = Object.defineProperties;
var $a93a46694e11b218$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $a93a46694e11b218$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $a93a46694e11b218$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $a93a46694e11b218$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $a93a46694e11b218$var$__defNormalProp = (obj, key, value)=>key in obj ? $a93a46694e11b218$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $a93a46694e11b218$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($a93a46694e11b218$var$__hasOwnProp.call(b, prop)) $a93a46694e11b218$var$__defNormalProp(a, prop, b[prop]);
    if ($a93a46694e11b218$var$__getOwnPropSymbols) {
        for (var prop of $a93a46694e11b218$var$__getOwnPropSymbols(b))if ($a93a46694e11b218$var$__propIsEnum.call(b, prop)) $a93a46694e11b218$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $a93a46694e11b218$var$__spreadProps = (a, b)=>$a93a46694e11b218$var$__defProps(a, $a93a46694e11b218$var$__getOwnPropDescs(b));
var $a93a46694e11b218$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($a93a46694e11b218$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $a93a46694e11b218$var$__getOwnPropSymbols) {
        for (var prop of $a93a46694e11b218$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $a93a46694e11b218$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $a93a46694e11b218$export$5e2b1ec78aa559bf = (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const _a = props, { sizes: sizes, onSizesChange: onSizesChange, style: style } = _a, others = $a93a46694e11b218$var$__objRest(_a, [
        "sizes",
        "onSizesChange",
        "style"
    ]);
    const ctx = (0, $79f911f27c208c7e$export$6f5f1e779aff6cfb)();
    const [computedStyle, setComputedStyle] = (0, $acw62.useState)();
    const ref = (0, $acw62.useRef)(null);
    const composeRefs = (0, $7034a45159125c0b$export$36a55fa7500f01f)(forwardedRef, ref, ctx.onScrollbarXChange);
    (0, $acw62.useEffect)(()=>{
        if (ref.current) setComputedStyle(getComputedStyle(ref.current));
    }, [
        ref
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3a6eef7319454adf$export$9a4e88b92edfce6b), $a93a46694e11b218$var$__spreadProps($a93a46694e11b218$var$__spreadValues({
        "data-orientation": "horizontal"
    }, others), {
        ref: composeRefs,
        sizes: sizes,
        style: $a93a46694e11b218$var$__spreadProps($a93a46694e11b218$var$__spreadValues({}, style), {
            ["--sa-thumb-width"]: `${(0, $ad769dbbdef0d7a6$export$7b14c3f3cc4d1eca)(sizes)}px`
        }),
        onThumbPointerDown: (pointerPos)=>props.onThumbPointerDown(pointerPos.x),
        onDragScroll: (pointerPos)=>props.onDragScroll(pointerPos.x),
        onWheelScroll: (event, maxScrollPos)=>{
            if (ctx.viewport) {
                const scrollPos = ctx.viewport.scrollLeft + event.deltaX;
                props.onWheelScroll(scrollPos);
                if ((0, $3bc502b82e5dc37a$export$3dd2cb87ed130ea5)(scrollPos, maxScrollPos)) event.preventDefault();
            }
        },
        onResize: ()=>{
            if (ref.current && ctx.viewport && computedStyle) onSizesChange({
                content: ctx.viewport.scrollWidth,
                viewport: ctx.viewport.offsetWidth,
                scrollbar: {
                    size: ref.current.clientWidth,
                    paddingStart: (0, $d6ccc87a85e73501$export$e7a1baa2fae31f0f)(computedStyle.paddingLeft),
                    paddingEnd: (0, $d6ccc87a85e73501$export$e7a1baa2fae31f0f)(computedStyle.paddingRight)
                }
            });
        }
    }));
});



var $acw62 = parcelRequire("acw62");






"use client";
var $9a5b2de3367badec$var$__defProp = Object.defineProperty;
var $9a5b2de3367badec$var$__defProps = Object.defineProperties;
var $9a5b2de3367badec$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $9a5b2de3367badec$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $9a5b2de3367badec$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $9a5b2de3367badec$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $9a5b2de3367badec$var$__defNormalProp = (obj, key, value)=>key in obj ? $9a5b2de3367badec$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $9a5b2de3367badec$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($9a5b2de3367badec$var$__hasOwnProp.call(b, prop)) $9a5b2de3367badec$var$__defNormalProp(a, prop, b[prop]);
    if ($9a5b2de3367badec$var$__getOwnPropSymbols) {
        for (var prop of $9a5b2de3367badec$var$__getOwnPropSymbols(b))if ($9a5b2de3367badec$var$__propIsEnum.call(b, prop)) $9a5b2de3367badec$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $9a5b2de3367badec$var$__spreadProps = (a, b)=>$9a5b2de3367badec$var$__defProps(a, $9a5b2de3367badec$var$__getOwnPropDescs(b));
var $9a5b2de3367badec$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($9a5b2de3367badec$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $9a5b2de3367badec$var$__getOwnPropSymbols) {
        for (var prop of $9a5b2de3367badec$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $9a5b2de3367badec$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $9a5b2de3367badec$export$e7c703d55d1ec9c0 = (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const _a = props, { sizes: sizes, onSizesChange: onSizesChange, style: style } = _a, others = $9a5b2de3367badec$var$__objRest(_a, [
        "sizes",
        "onSizesChange",
        "style"
    ]);
    const context = (0, $79f911f27c208c7e$export$6f5f1e779aff6cfb)();
    const [computedStyle, setComputedStyle] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState();
    const ref = (0, $acw62.useRef)(null);
    const composeRefs = (0, $7034a45159125c0b$export$36a55fa7500f01f)(forwardedRef, ref, context.onScrollbarYChange);
    (0, $acw62.useEffect)(()=>{
        if (ref.current) setComputedStyle(getComputedStyle(ref.current));
    }, [
        ref
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3a6eef7319454adf$export$9a4e88b92edfce6b), $9a5b2de3367badec$var$__spreadProps($9a5b2de3367badec$var$__spreadValues({}, others), {
        "data-orientation": "vertical",
        ref: composeRefs,
        sizes: sizes,
        style: $9a5b2de3367badec$var$__spreadValues({
            ["--sa-thumb-height"]: `${(0, $ad769dbbdef0d7a6$export$7b14c3f3cc4d1eca)(sizes)}px`
        }, style),
        onThumbPointerDown: (pointerPos)=>props.onThumbPointerDown(pointerPos.y),
        onDragScroll: (pointerPos)=>props.onDragScroll(pointerPos.y),
        onWheelScroll: (event, maxScrollPos)=>{
            if (context.viewport) {
                const scrollPos = context.viewport.scrollTop + event.deltaY;
                props.onWheelScroll(scrollPos);
                if ((0, $3bc502b82e5dc37a$export$3dd2cb87ed130ea5)(scrollPos, maxScrollPos)) event.preventDefault();
            }
        },
        onResize: ()=>{
            if (ref.current && context.viewport && computedStyle) onSizesChange({
                content: context.viewport.scrollHeight,
                viewport: context.viewport.offsetHeight,
                scrollbar: {
                    size: ref.current.clientHeight,
                    paddingStart: (0, $d6ccc87a85e73501$export$e7a1baa2fae31f0f)(computedStyle.paddingTop),
                    paddingEnd: (0, $d6ccc87a85e73501$export$e7a1baa2fae31f0f)(computedStyle.paddingBottom)
                }
            });
        }
    }));
});





"use client";
function $3d9580bad10edfae$export$fefe9507ec0904ed(input, output) {
    return (value)=>{
        if (input[0] === input[1] || output[0] === output[1]) return output[0];
        const ratio = (output[1] - output[0]) / (input[1] - input[0]);
        return output[0] + ratio * (value - input[0]);
    };
}


"use client";
function $48a05505b367dbd3$var$clamp(value, [min, max]) {
    return Math.min(max, Math.max(min, value));
}
function $48a05505b367dbd3$export$ed4bbb745ec92b4f(scrollPos, sizes, dir = "ltr") {
    const thumbSizePx = (0, $ad769dbbdef0d7a6$export$7b14c3f3cc4d1eca)(sizes);
    const scrollbarPadding = sizes.scrollbar.paddingStart + sizes.scrollbar.paddingEnd;
    const scrollbar = sizes.scrollbar.size - scrollbarPadding;
    const maxScrollPos = sizes.content - sizes.viewport;
    const maxThumbPos = scrollbar - thumbSizePx;
    const scrollClampRange = dir === "ltr" ? [
        0,
        maxScrollPos
    ] : [
        maxScrollPos * -1,
        0
    ];
    const scrollWithoutMomentum = $48a05505b367dbd3$var$clamp(scrollPos, scrollClampRange);
    const interpolate = (0, $3d9580bad10edfae$export$fefe9507ec0904ed)([
        0,
        maxScrollPos
    ], [
        0,
        maxThumbPos
    ]);
    return interpolate(scrollWithoutMomentum);
}




"use client";
function $33809556927fa4c1$export$8bf262e596ba0cb9(pointerPos, pointerOffset, sizes, dir = "ltr") {
    const thumbSizePx = (0, $ad769dbbdef0d7a6$export$7b14c3f3cc4d1eca)(sizes);
    const thumbCenter = thumbSizePx / 2;
    const offset = pointerOffset || thumbCenter;
    const thumbOffsetFromEnd = thumbSizePx - offset;
    const minPointerPos = sizes.scrollbar.paddingStart + offset;
    const maxPointerPos = sizes.scrollbar.size - sizes.scrollbar.paddingEnd - thumbOffsetFromEnd;
    const maxScrollPos = sizes.content - sizes.viewport;
    const scrollRange = dir === "ltr" ? [
        0,
        maxScrollPos
    ] : [
        maxScrollPos * -1,
        0
    ];
    const interpolate = (0, $3d9580bad10edfae$export$fefe9507ec0904ed)([
        minPointerPos,
        maxPointerPos
    ], scrollRange);
    return interpolate(pointerPos);
}


"use client";
var $710585c028a94153$var$__defProp = Object.defineProperty;
var $710585c028a94153$var$__defProps = Object.defineProperties;
var $710585c028a94153$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $710585c028a94153$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $710585c028a94153$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $710585c028a94153$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $710585c028a94153$var$__defNormalProp = (obj, key, value)=>key in obj ? $710585c028a94153$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $710585c028a94153$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($710585c028a94153$var$__hasOwnProp.call(b, prop)) $710585c028a94153$var$__defNormalProp(a, prop, b[prop]);
    if ($710585c028a94153$var$__getOwnPropSymbols) {
        for (var prop of $710585c028a94153$var$__getOwnPropSymbols(b))if ($710585c028a94153$var$__propIsEnum.call(b, prop)) $710585c028a94153$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $710585c028a94153$var$__spreadProps = (a, b)=>$710585c028a94153$var$__defProps(a, $710585c028a94153$var$__getOwnPropDescs(b));
var $710585c028a94153$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($710585c028a94153$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $710585c028a94153$var$__getOwnPropSymbols) {
        for (var prop of $710585c028a94153$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $710585c028a94153$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $710585c028a94153$export$8be42cbd47985943 = (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const _a = props, { orientation: orientation = "vertical" } = _a, scrollbarProps = $710585c028a94153$var$__objRest(_a, [
        "orientation"
    ]);
    const { dir: dir } = (0, $35c57ac18e24a61d$export$b39126d51d94e6f3)();
    const context = (0, $79f911f27c208c7e$export$6f5f1e779aff6cfb)();
    const thumbRef = (0, $acw62.useRef)(null);
    const pointerOffsetRef = (0, $acw62.useRef)(0);
    const [sizes, setSizes] = (0, $acw62.useState)({
        content: 0,
        viewport: 0,
        scrollbar: {
            size: 0,
            paddingStart: 0,
            paddingEnd: 0
        }
    });
    const thumbRatio = (0, $e40829f322f41fa9$export$cf7769cb1c49cedf)(sizes.viewport, sizes.content);
    const commonProps = $710585c028a94153$var$__spreadProps($710585c028a94153$var$__spreadValues({}, scrollbarProps), {
        sizes: sizes,
        onSizesChange: setSizes,
        hasThumb: Boolean(thumbRatio > 0 && thumbRatio < 1),
        onThumbChange: (thumb)=>{
            thumbRef.current = thumb;
        },
        onThumbPointerUp: ()=>{
            pointerOffsetRef.current = 0;
        },
        onThumbPointerDown: (pointerPos)=>{
            pointerOffsetRef.current = pointerPos;
        }
    });
    const getScrollPosition = (pointerPos, direction)=>(0, $33809556927fa4c1$export$8bf262e596ba0cb9)(pointerPos, pointerOffsetRef.current, sizes, direction);
    if (orientation === "horizontal") return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a93a46694e11b218$export$5e2b1ec78aa559bf), $710585c028a94153$var$__spreadProps($710585c028a94153$var$__spreadValues({}, commonProps), {
        ref: forwardedRef,
        onThumbPositionChange: ()=>{
            if (context.viewport && thumbRef.current) {
                const scrollPos = context.viewport.scrollLeft;
                const offset = (0, $48a05505b367dbd3$export$ed4bbb745ec92b4f)(scrollPos, sizes, dir);
                thumbRef.current.style.transform = `translate3d(${offset}px, 0, 0)`;
            }
        },
        onWheelScroll: (scrollPos)=>{
            if (context.viewport) context.viewport.scrollLeft = scrollPos;
        },
        onDragScroll: (pointerPos)=>{
            if (context.viewport) context.viewport.scrollLeft = getScrollPosition(pointerPos, dir);
        }
    }));
    if (orientation === "vertical") return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9a5b2de3367badec$export$e7c703d55d1ec9c0), $710585c028a94153$var$__spreadProps($710585c028a94153$var$__spreadValues({}, commonProps), {
        ref: forwardedRef,
        onThumbPositionChange: ()=>{
            if (context.viewport && thumbRef.current) {
                const scrollPos = context.viewport.scrollTop;
                const offset = (0, $48a05505b367dbd3$export$ed4bbb745ec92b4f)(scrollPos, sizes);
                thumbRef.current.style.transform = `translate3d(0, ${offset}px, 0)`;
            }
        },
        onWheelScroll: (scrollPos)=>{
            if (context.viewport) context.viewport.scrollTop = scrollPos;
        },
        onDragScroll: (pointerPos)=>{
            if (context.viewport) context.viewport.scrollTop = getScrollPosition(pointerPos);
        }
    }));
    return null;
});



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");




"use client";
var $2cce3ee594976e59$var$__defProp = Object.defineProperty;
var $2cce3ee594976e59$var$__defProps = Object.defineProperties;
var $2cce3ee594976e59$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $2cce3ee594976e59$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $2cce3ee594976e59$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $2cce3ee594976e59$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $2cce3ee594976e59$var$__defNormalProp = (obj, key, value)=>key in obj ? $2cce3ee594976e59$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $2cce3ee594976e59$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($2cce3ee594976e59$var$__hasOwnProp.call(b, prop)) $2cce3ee594976e59$var$__defNormalProp(a, prop, b[prop]);
    if ($2cce3ee594976e59$var$__getOwnPropSymbols) {
        for (var prop of $2cce3ee594976e59$var$__getOwnPropSymbols(b))if ($2cce3ee594976e59$var$__propIsEnum.call(b, prop)) $2cce3ee594976e59$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $2cce3ee594976e59$var$__spreadProps = (a, b)=>$2cce3ee594976e59$var$__defProps(a, $2cce3ee594976e59$var$__getOwnPropDescs(b));
var $2cce3ee594976e59$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($2cce3ee594976e59$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $2cce3ee594976e59$var$__getOwnPropSymbols) {
        for (var prop of $2cce3ee594976e59$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $2cce3ee594976e59$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $2cce3ee594976e59$export$122d1fc0e42a83be = (0, $acw62.forwardRef)((props, ref)=>{
    const context = (0, $79f911f27c208c7e$export$6f5f1e779aff6cfb)();
    const _a = props, { forceMount: forceMount } = _a, scrollbarProps = $2cce3ee594976e59$var$__objRest(_a, [
        "forceMount"
    ]);
    const [visible, setVisible] = (0, $acw62.useState)(false);
    const isHorizontal = props.orientation === "horizontal";
    const handleResize = (0, $4919278891a7db8a$export$40ae01be0011c1e6)(()=>{
        if (context.viewport) {
            const isOverflowX = context.viewport.offsetWidth < context.viewport.scrollWidth;
            const isOverflowY = context.viewport.offsetHeight < context.viewport.scrollHeight;
            setVisible(isHorizontal ? isOverflowX : isOverflowY);
        }
    }, 10);
    (0, $132fa50acb2babc6$export$683480f191c0e3ea)(context.viewport, handleResize);
    (0, $132fa50acb2babc6$export$683480f191c0e3ea)(context.content, handleResize);
    if (forceMount || visible) return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $710585c028a94153$export$8be42cbd47985943), $2cce3ee594976e59$var$__spreadProps($2cce3ee594976e59$var$__spreadValues({
        "data-state": visible ? "visible" : "hidden"
    }, scrollbarProps), {
        ref: ref
    }));
    return null;
});


"use client";
var $5500c318d003fdf6$var$__defProp = Object.defineProperty;
var $5500c318d003fdf6$var$__defProps = Object.defineProperties;
var $5500c318d003fdf6$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $5500c318d003fdf6$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $5500c318d003fdf6$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $5500c318d003fdf6$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $5500c318d003fdf6$var$__defNormalProp = (obj, key, value)=>key in obj ? $5500c318d003fdf6$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $5500c318d003fdf6$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($5500c318d003fdf6$var$__hasOwnProp.call(b, prop)) $5500c318d003fdf6$var$__defNormalProp(a, prop, b[prop]);
    if ($5500c318d003fdf6$var$__getOwnPropSymbols) {
        for (var prop of $5500c318d003fdf6$var$__getOwnPropSymbols(b))if ($5500c318d003fdf6$var$__propIsEnum.call(b, prop)) $5500c318d003fdf6$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $5500c318d003fdf6$var$__spreadProps = (a, b)=>$5500c318d003fdf6$var$__defProps(a, $5500c318d003fdf6$var$__getOwnPropDescs(b));
var $5500c318d003fdf6$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($5500c318d003fdf6$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $5500c318d003fdf6$var$__getOwnPropSymbols) {
        for (var prop of $5500c318d003fdf6$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $5500c318d003fdf6$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $5500c318d003fdf6$export$76ee0a6492d8f1d0 = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = props, { forceMount: forceMount } = _a, scrollbarProps = $5500c318d003fdf6$var$__objRest(_a, [
        "forceMount"
    ]);
    const context = (0, $79f911f27c208c7e$export$6f5f1e779aff6cfb)();
    const [visible, setVisible] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        const { scrollArea: scrollArea } = context;
        let hideTimer = 0;
        if (scrollArea) {
            const handlePointerEnter = ()=>{
                window.clearTimeout(hideTimer);
                setVisible(true);
            };
            const handlePointerLeave = ()=>{
                hideTimer = window.setTimeout(()=>setVisible(false), context.scrollHideDelay);
            };
            scrollArea.addEventListener("pointerenter", handlePointerEnter);
            scrollArea.addEventListener("pointerleave", handlePointerLeave);
            return ()=>{
                window.clearTimeout(hideTimer);
                scrollArea.removeEventListener("pointerenter", handlePointerEnter);
                scrollArea.removeEventListener("pointerleave", handlePointerLeave);
            };
        }
        return void 0;
    }, [
        context.scrollArea,
        context.scrollHideDelay
    ]);
    if (forceMount || visible) return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2cce3ee594976e59$export$122d1fc0e42a83be), $5500c318d003fdf6$var$__spreadProps($5500c318d003fdf6$var$__spreadValues({
        "data-state": visible ? "visible" : "hidden"
    }, scrollbarProps), {
        ref: ref
    }));
    return null;
});



var $acw62 = parcelRequire("acw62");




"use client";
var $203200efe7525cee$var$__defProp = Object.defineProperty;
var $203200efe7525cee$var$__defProps = Object.defineProperties;
var $203200efe7525cee$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $203200efe7525cee$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $203200efe7525cee$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $203200efe7525cee$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $203200efe7525cee$var$__defNormalProp = (obj, key, value)=>key in obj ? $203200efe7525cee$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $203200efe7525cee$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($203200efe7525cee$var$__hasOwnProp.call(b, prop)) $203200efe7525cee$var$__defNormalProp(a, prop, b[prop]);
    if ($203200efe7525cee$var$__getOwnPropSymbols) {
        for (var prop of $203200efe7525cee$var$__getOwnPropSymbols(b))if ($203200efe7525cee$var$__propIsEnum.call(b, prop)) $203200efe7525cee$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $203200efe7525cee$var$__spreadProps = (a, b)=>$203200efe7525cee$var$__defProps(a, $203200efe7525cee$var$__getOwnPropDescs(b));
var $203200efe7525cee$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($203200efe7525cee$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $203200efe7525cee$var$__getOwnPropSymbols) {
        for (var prop of $203200efe7525cee$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $203200efe7525cee$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $203200efe7525cee$export$c35aa02e701a23ad = (0, $acw62.forwardRef)((props, red)=>{
    const _a = props, { forceMount: forceMount } = _a, scrollbarProps = $203200efe7525cee$var$__objRest(_a, [
        "forceMount"
    ]);
    const context = (0, $79f911f27c208c7e$export$6f5f1e779aff6cfb)();
    const isHorizontal = props.orientation === "horizontal";
    const [state, setState] = (0, $acw62.useState)("hidden");
    const debounceScrollEnd = (0, $4919278891a7db8a$export$40ae01be0011c1e6)(()=>setState("idle"), 100);
    (0, $acw62.useEffect)(()=>{
        if (state === "idle") {
            const hideTimer = window.setTimeout(()=>setState("hidden"), context.scrollHideDelay);
            return ()=>window.clearTimeout(hideTimer);
        }
        return void 0;
    }, [
        state,
        context.scrollHideDelay
    ]);
    (0, $acw62.useEffect)(()=>{
        const { viewport: viewport } = context;
        const scrollDirection = isHorizontal ? "scrollLeft" : "scrollTop";
        if (viewport) {
            let prevScrollPos = viewport[scrollDirection];
            const handleScroll = ()=>{
                const scrollPos = viewport[scrollDirection];
                const hasScrollInDirectionChanged = prevScrollPos !== scrollPos;
                if (hasScrollInDirectionChanged) {
                    setState("scrolling");
                    debounceScrollEnd();
                }
                prevScrollPos = scrollPos;
            };
            viewport.addEventListener("scroll", handleScroll);
            return ()=>viewport.removeEventListener("scroll", handleScroll);
        }
        return void 0;
    }, [
        context.viewport,
        isHorizontal,
        debounceScrollEnd
    ]);
    if (forceMount || state !== "hidden") return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $710585c028a94153$export$8be42cbd47985943), $203200efe7525cee$var$__spreadProps($203200efe7525cee$var$__spreadValues({
        "data-state": state === "hidden" ? "hidden" : "visible"
    }, scrollbarProps), {
        ref: red,
        onPointerEnter: (0, $1c9ccee2f3ecd168$export$b9ecd428b558ff10)(props.onPointerEnter, ()=>setState("interacting")),
        onPointerLeave: (0, $1c9ccee2f3ecd168$export$b9ecd428b558ff10)(props.onPointerLeave, ()=>setState("idle"))
    }));
    return null;
});



"use client";
var $11b5067cafb406ae$var$__defProp = Object.defineProperty;
var $11b5067cafb406ae$var$__defProps = Object.defineProperties;
var $11b5067cafb406ae$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $11b5067cafb406ae$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $11b5067cafb406ae$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $11b5067cafb406ae$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $11b5067cafb406ae$var$__defNormalProp = (obj, key, value)=>key in obj ? $11b5067cafb406ae$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $11b5067cafb406ae$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($11b5067cafb406ae$var$__hasOwnProp.call(b, prop)) $11b5067cafb406ae$var$__defNormalProp(a, prop, b[prop]);
    if ($11b5067cafb406ae$var$__getOwnPropSymbols) {
        for (var prop of $11b5067cafb406ae$var$__getOwnPropSymbols(b))if ($11b5067cafb406ae$var$__propIsEnum.call(b, prop)) $11b5067cafb406ae$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $11b5067cafb406ae$var$__spreadProps = (a, b)=>$11b5067cafb406ae$var$__defProps(a, $11b5067cafb406ae$var$__getOwnPropDescs(b));
var $11b5067cafb406ae$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($11b5067cafb406ae$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $11b5067cafb406ae$var$__getOwnPropSymbols) {
        for (var prop of $11b5067cafb406ae$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $11b5067cafb406ae$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $11b5067cafb406ae$export$2fabd85d0eba3c57 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, forwardedRef)=>{
    const _a = props, { forceMount: forceMount } = _a, scrollbarProps = $11b5067cafb406ae$var$__objRest(_a, [
        "forceMount"
    ]);
    const context = (0, $79f911f27c208c7e$export$6f5f1e779aff6cfb)();
    const { onScrollbarXEnabledChange: onScrollbarXEnabledChange, onScrollbarYEnabledChange: onScrollbarYEnabledChange } = context;
    const isHorizontal = props.orientation === "horizontal";
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        isHorizontal ? onScrollbarXEnabledChange(true) : onScrollbarYEnabledChange(true);
        return ()=>{
            isHorizontal ? onScrollbarXEnabledChange(false) : onScrollbarYEnabledChange(false);
        };
    }, [
        isHorizontal,
        onScrollbarXEnabledChange,
        onScrollbarYEnabledChange
    ]);
    return context.type === "hover" ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5500c318d003fdf6$export$76ee0a6492d8f1d0), $11b5067cafb406ae$var$__spreadProps($11b5067cafb406ae$var$__spreadValues({}, scrollbarProps), {
        ref: forwardedRef,
        forceMount: forceMount
    })) : context.type === "scroll" ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $203200efe7525cee$export$c35aa02e701a23ad), $11b5067cafb406ae$var$__spreadProps($11b5067cafb406ae$var$__spreadValues({}, scrollbarProps), {
        ref: forwardedRef,
        forceMount: forceMount
    })) : context.type === "auto" ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2cce3ee594976e59$export$122d1fc0e42a83be), $11b5067cafb406ae$var$__spreadProps($11b5067cafb406ae$var$__spreadValues({}, scrollbarProps), {
        ref: forwardedRef,
        forceMount: forceMount
    })) : context.type === "always" ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $710585c028a94153$export$8be42cbd47985943), $11b5067cafb406ae$var$__spreadProps($11b5067cafb406ae$var$__spreadValues({}, scrollbarProps), {
        ref: forwardedRef
    })) : null;
});



var $acw62 = parcelRequire("acw62");


"use client";
var $f537e37f6c0b850a$var$__defProp = Object.defineProperty;
var $f537e37f6c0b850a$var$__defProps = Object.defineProperties;
var $f537e37f6c0b850a$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $f537e37f6c0b850a$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $f537e37f6c0b850a$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $f537e37f6c0b850a$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $f537e37f6c0b850a$var$__defNormalProp = (obj, key, value)=>key in obj ? $f537e37f6c0b850a$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $f537e37f6c0b850a$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($f537e37f6c0b850a$var$__hasOwnProp.call(b, prop)) $f537e37f6c0b850a$var$__defNormalProp(a, prop, b[prop]);
    if ($f537e37f6c0b850a$var$__getOwnPropSymbols) {
        for (var prop of $f537e37f6c0b850a$var$__getOwnPropSymbols(b))if ($f537e37f6c0b850a$var$__propIsEnum.call(b, prop)) $f537e37f6c0b850a$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $f537e37f6c0b850a$var$__spreadProps = (a, b)=>$f537e37f6c0b850a$var$__defProps(a, $f537e37f6c0b850a$var$__getOwnPropDescs(b));
var $f537e37f6c0b850a$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($f537e37f6c0b850a$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $f537e37f6c0b850a$var$__getOwnPropSymbols) {
        for (var prop of $f537e37f6c0b850a$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $f537e37f6c0b850a$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $f537e37f6c0b850a$export$ac61190d9fc311a9 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>{
    const _a = props, { style: style } = _a, others = $f537e37f6c0b850a$var$__objRest(_a, [
        "style"
    ]);
    const ctx = (0, $79f911f27c208c7e$export$6f5f1e779aff6cfb)();
    const [width, setWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    const [height, setHeight] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    const hasSize = Boolean(width && height);
    (0, $132fa50acb2babc6$export$683480f191c0e3ea)(ctx.scrollbarX, ()=>{
        var _a2;
        const h = ((_a2 = ctx.scrollbarX) == null ? void 0 : _a2.offsetHeight) || 0;
        ctx.onCornerHeightChange(h);
        setHeight(h);
    });
    (0, $132fa50acb2babc6$export$683480f191c0e3ea)(ctx.scrollbarY, ()=>{
        var _a2;
        const w = ((_a2 = ctx.scrollbarY) == null ? void 0 : _a2.offsetWidth) || 0;
        ctx.onCornerWidthChange(w);
        setWidth(w);
    });
    return hasSize ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $f537e37f6c0b850a$var$__spreadProps($f537e37f6c0b850a$var$__spreadValues({}, others), {
        ref: ref,
        style: $f537e37f6c0b850a$var$__spreadProps($f537e37f6c0b850a$var$__spreadValues({}, style), {
            width: width,
            height: height
        })
    })) : null;
});
const $f537e37f6c0b850a$export$56969d565df7cc4b = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>{
    const ctx = (0, $79f911f27c208c7e$export$6f5f1e779aff6cfb)();
    const hasBothScrollbarsVisible = Boolean(ctx.scrollbarX && ctx.scrollbarY);
    const hasCorner = ctx.type !== "scroll" && hasBothScrollbarsVisible;
    return hasCorner ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f537e37f6c0b850a$export$ac61190d9fc311a9, $f537e37f6c0b850a$var$__spreadProps($f537e37f6c0b850a$var$__spreadValues({}, props), {
        ref: ref
    })) : null;
});



var $acw62 = parcelRequire("acw62");




"use client";
var $e2df1435548fd2cc$var$__defProp = Object.defineProperty;
var $e2df1435548fd2cc$var$__defProps = Object.defineProperties;
var $e2df1435548fd2cc$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $e2df1435548fd2cc$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $e2df1435548fd2cc$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $e2df1435548fd2cc$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $e2df1435548fd2cc$var$__defNormalProp = (obj, key, value)=>key in obj ? $e2df1435548fd2cc$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $e2df1435548fd2cc$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($e2df1435548fd2cc$var$__hasOwnProp.call(b, prop)) $e2df1435548fd2cc$var$__defNormalProp(a, prop, b[prop]);
    if ($e2df1435548fd2cc$var$__getOwnPropSymbols) {
        for (var prop of $e2df1435548fd2cc$var$__getOwnPropSymbols(b))if ($e2df1435548fd2cc$var$__propIsEnum.call(b, prop)) $e2df1435548fd2cc$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $e2df1435548fd2cc$var$__spreadProps = (a, b)=>$e2df1435548fd2cc$var$__defProps(a, $e2df1435548fd2cc$var$__getOwnPropDescs(b));
var $e2df1435548fd2cc$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($e2df1435548fd2cc$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $e2df1435548fd2cc$var$__getOwnPropSymbols) {
        for (var prop of $e2df1435548fd2cc$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $e2df1435548fd2cc$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $e2df1435548fd2cc$var$defaultProps = {
    scrollHideDelay: 1e3,
    type: "hover"
};
const $e2df1435548fd2cc$export$f2a893fcd08ef34d = (0, $acw62.forwardRef)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("ScrollAreaRoot", $e2df1435548fd2cc$var$defaultProps, _props);
    const _a = props, { type: type, scrollHideDelay: scrollHideDelay } = _a, others = $e2df1435548fd2cc$var$__objRest(_a, [
        "type",
        "scrollHideDelay"
    ]);
    const [scrollArea, setScrollArea] = (0, $acw62.useState)(null);
    const [viewport, setViewport] = (0, $acw62.useState)(null);
    const [content, setContent] = (0, $acw62.useState)(null);
    const [scrollbarX, setScrollbarX] = (0, $acw62.useState)(null);
    const [scrollbarY, setScrollbarY] = (0, $acw62.useState)(null);
    const [cornerWidth, setCornerWidth] = (0, $acw62.useState)(0);
    const [cornerHeight, setCornerHeight] = (0, $acw62.useState)(0);
    const [scrollbarXEnabled, setScrollbarXEnabled] = (0, $acw62.useState)(false);
    const [scrollbarYEnabled, setScrollbarYEnabled] = (0, $acw62.useState)(false);
    const rootRef = (0, $7034a45159125c0b$export$36a55fa7500f01f)(ref, (node)=>setScrollArea(node));
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $79f911f27c208c7e$export$ea262e38353a259a), {
        value: {
            type: type,
            scrollHideDelay: scrollHideDelay,
            scrollArea: scrollArea,
            viewport: viewport,
            onViewportChange: setViewport,
            content: content,
            onContentChange: setContent,
            scrollbarX: scrollbarX,
            onScrollbarXChange: setScrollbarX,
            scrollbarXEnabled: scrollbarXEnabled,
            onScrollbarXEnabledChange: setScrollbarXEnabled,
            scrollbarY: scrollbarY,
            onScrollbarYChange: setScrollbarY,
            scrollbarYEnabled: scrollbarYEnabled,
            onScrollbarYEnabledChange: setScrollbarYEnabled,
            onCornerWidthChange: setCornerWidth,
            onCornerHeightChange: setCornerHeight
        }
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $e2df1435548fd2cc$var$__spreadProps($e2df1435548fd2cc$var$__spreadValues({}, others), {
        ref: rootRef,
        __vars: {
            "--sa-corner-width": `${cornerWidth}px`,
            "--sa-corner-height": `${cornerHeight}px`
        }
    })));
});
$e2df1435548fd2cc$export$f2a893fcd08ef34d.displayName = "@mantine/core/ScrollAreaRoot";



var $acw62 = parcelRequire("acw62");



"use client";
var $6cec10d0bcac6dc0$var$__defProp = Object.defineProperty;
var $6cec10d0bcac6dc0$var$__defProps = Object.defineProperties;
var $6cec10d0bcac6dc0$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $6cec10d0bcac6dc0$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $6cec10d0bcac6dc0$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $6cec10d0bcac6dc0$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $6cec10d0bcac6dc0$var$__defNormalProp = (obj, key, value)=>key in obj ? $6cec10d0bcac6dc0$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $6cec10d0bcac6dc0$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($6cec10d0bcac6dc0$var$__hasOwnProp.call(b, prop)) $6cec10d0bcac6dc0$var$__defNormalProp(a, prop, b[prop]);
    if ($6cec10d0bcac6dc0$var$__getOwnPropSymbols) {
        for (var prop of $6cec10d0bcac6dc0$var$__getOwnPropSymbols(b))if ($6cec10d0bcac6dc0$var$__propIsEnum.call(b, prop)) $6cec10d0bcac6dc0$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $6cec10d0bcac6dc0$var$__spreadProps = (a, b)=>$6cec10d0bcac6dc0$var$__defProps(a, $6cec10d0bcac6dc0$var$__getOwnPropDescs(b));
var $6cec10d0bcac6dc0$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($6cec10d0bcac6dc0$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $6cec10d0bcac6dc0$var$__getOwnPropSymbols) {
        for (var prop of $6cec10d0bcac6dc0$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $6cec10d0bcac6dc0$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $6cec10d0bcac6dc0$export$a21cbf9f11fca853 = (0, $acw62.forwardRef)((_a, ref)=>{
    var _b = _a, { children: children, style: style } = _b, others = $6cec10d0bcac6dc0$var$__objRest(_b, [
        "children",
        "style"
    ]);
    const ctx = (0, $79f911f27c208c7e$export$6f5f1e779aff6cfb)();
    const rootRef = (0, $7034a45159125c0b$export$36a55fa7500f01f)(ref, ctx.onViewportChange);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $6cec10d0bcac6dc0$var$__spreadProps($6cec10d0bcac6dc0$var$__spreadValues({}, others), {
        ref: rootRef,
        style: $6cec10d0bcac6dc0$var$__spreadValues({
            overflowX: ctx.scrollbarXEnabled ? "scroll" : "hidden",
            overflowY: ctx.scrollbarYEnabled ? "scroll" : "hidden"
        }, style)
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            minWidth: "100%",
            display: "table"
        },
        ref: ctx.onContentChange
    }, children));
});
$6cec10d0bcac6dc0$export$a21cbf9f11fca853.displayName = "@mantine/core/ScrollAreaViewport";


"use client";
var $580479a53fd6266c$var$classes = {
    "root": "m-d57069b5",
    "viewport": "m-c0783ff9",
    "viewportInner": "m-f8f631dd",
    "scrollbar": "m-c44ba933",
    "thumb": "m-d8b5e363",
    "corner": "m-21657268"
};
var $580479a53fd6266c$export$2e2bcd8739ae039 = $580479a53fd6266c$var$classes;



var $acw62 = parcelRequire("acw62");




"use client";
function $0be43da0068dce4d$export$7a2fcd0d3a006438(node, handler = ()=>{}) {
    let prevPosition = {
        left: node.scrollLeft,
        top: node.scrollTop
    };
    let rAF = 0;
    (function loop() {
        const position = {
            left: node.scrollLeft,
            top: node.scrollTop
        };
        const isHorizontalScroll = prevPosition.left !== position.left;
        const isVerticalScroll = prevPosition.top !== position.top;
        if (isHorizontalScroll || isVerticalScroll) handler();
        prevPosition = position;
        rAF = window.requestAnimationFrame(loop);
    })();
    return ()=>window.cancelAnimationFrame(rAF);
}


"use client";
var $81f0525478ce18ce$var$__defProp = Object.defineProperty;
var $81f0525478ce18ce$var$__defProps = Object.defineProperties;
var $81f0525478ce18ce$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $81f0525478ce18ce$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $81f0525478ce18ce$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $81f0525478ce18ce$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $81f0525478ce18ce$var$__defNormalProp = (obj, key, value)=>key in obj ? $81f0525478ce18ce$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $81f0525478ce18ce$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($81f0525478ce18ce$var$__hasOwnProp.call(b, prop)) $81f0525478ce18ce$var$__defNormalProp(a, prop, b[prop]);
    if ($81f0525478ce18ce$var$__getOwnPropSymbols) {
        for (var prop of $81f0525478ce18ce$var$__getOwnPropSymbols(b))if ($81f0525478ce18ce$var$__propIsEnum.call(b, prop)) $81f0525478ce18ce$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $81f0525478ce18ce$var$__spreadProps = (a, b)=>$81f0525478ce18ce$var$__defProps(a, $81f0525478ce18ce$var$__getOwnPropDescs(b));
var $81f0525478ce18ce$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($81f0525478ce18ce$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $81f0525478ce18ce$var$__getOwnPropSymbols) {
        for (var prop of $81f0525478ce18ce$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $81f0525478ce18ce$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $81f0525478ce18ce$export$6521433ed15a34db = (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const _a = props, { style: style } = _a, others = $81f0525478ce18ce$var$__objRest(_a, [
        "style"
    ]);
    const scrollAreaContext = (0, $79f911f27c208c7e$export$6f5f1e779aff6cfb)();
    const scrollbarContext = (0, $e66ab2864f33f4cb$export$9eae1e0809562d06)();
    const { onThumbPositionChange: onThumbPositionChange } = scrollbarContext;
    const composedRef = (0, $7034a45159125c0b$export$36a55fa7500f01f)(forwardedRef, (node)=>scrollbarContext.onThumbChange(node));
    const removeUnlinkedScrollListenerRef = (0, $acw62.useRef)();
    const debounceScrollEnd = (0, $4919278891a7db8a$export$40ae01be0011c1e6)(()=>{
        if (removeUnlinkedScrollListenerRef.current) {
            removeUnlinkedScrollListenerRef.current();
            removeUnlinkedScrollListenerRef.current = void 0;
        }
    }, 100);
    (0, $acw62.useEffect)(()=>{
        const { viewport: viewport } = scrollAreaContext;
        if (viewport) {
            const handleScroll = ()=>{
                debounceScrollEnd();
                if (!removeUnlinkedScrollListenerRef.current) {
                    const listener = (0, $0be43da0068dce4d$export$7a2fcd0d3a006438)(viewport, onThumbPositionChange);
                    removeUnlinkedScrollListenerRef.current = listener;
                    onThumbPositionChange();
                }
            };
            onThumbPositionChange();
            viewport.addEventListener("scroll", handleScroll);
            return ()=>viewport.removeEventListener("scroll", handleScroll);
        }
        return void 0;
    }, [
        scrollAreaContext.viewport,
        debounceScrollEnd,
        onThumbPositionChange
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $81f0525478ce18ce$var$__spreadProps($81f0525478ce18ce$var$__spreadValues({
        "data-state": scrollbarContext.hasThumb ? "visible" : "hidden"
    }, others), {
        ref: composedRef,
        style: $81f0525478ce18ce$var$__spreadValues({
            width: "var(--sa-thumb-width)",
            height: "var(--sa-thumb-height)"
        }, style),
        onPointerDownCapture: (0, $1c9ccee2f3ecd168$export$b9ecd428b558ff10)(props.onPointerDownCapture, (event)=>{
            const thumb = event.target;
            const thumbRect = thumb.getBoundingClientRect();
            const x = event.clientX - thumbRect.left;
            const y = event.clientY - thumbRect.top;
            scrollbarContext.onThumbPointerDown({
                x: x,
                y: y
            });
        }),
        onPointerUp: (0, $1c9ccee2f3ecd168$export$b9ecd428b558ff10)(props.onPointerUp, scrollbarContext.onThumbPointerUp)
    }));
});
const $81f0525478ce18ce$export$9fba1154677d7cd2 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, forwardedRef)=>{
    const _a = props, { forceMount: forceMount } = _a, thumbProps = $81f0525478ce18ce$var$__objRest(_a, [
        "forceMount"
    ]);
    const scrollbarContext = (0, $e66ab2864f33f4cb$export$9eae1e0809562d06)();
    if (forceMount || scrollbarContext.hasThumb) return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($81f0525478ce18ce$export$6521433ed15a34db, $81f0525478ce18ce$var$__spreadValues({
        ref: forwardedRef
    }, thumbProps));
    return null;
});








"use client";
var $dffe8bd53d7188f1$var$__defProp = Object.defineProperty;
var $dffe8bd53d7188f1$var$__defProps = Object.defineProperties;
var $dffe8bd53d7188f1$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $dffe8bd53d7188f1$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $dffe8bd53d7188f1$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $dffe8bd53d7188f1$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $dffe8bd53d7188f1$var$__defNormalProp = (obj, key, value)=>key in obj ? $dffe8bd53d7188f1$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $dffe8bd53d7188f1$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($dffe8bd53d7188f1$var$__hasOwnProp.call(b, prop)) $dffe8bd53d7188f1$var$__defNormalProp(a, prop, b[prop]);
    if ($dffe8bd53d7188f1$var$__getOwnPropSymbols) {
        for (var prop of $dffe8bd53d7188f1$var$__getOwnPropSymbols(b))if ($dffe8bd53d7188f1$var$__propIsEnum.call(b, prop)) $dffe8bd53d7188f1$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $dffe8bd53d7188f1$var$__spreadProps = (a, b)=>$dffe8bd53d7188f1$var$__defProps(a, $dffe8bd53d7188f1$var$__getOwnPropDescs(b));
var $dffe8bd53d7188f1$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($dffe8bd53d7188f1$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $dffe8bd53d7188f1$var$__getOwnPropSymbols) {
        for (var prop of $dffe8bd53d7188f1$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $dffe8bd53d7188f1$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $dffe8bd53d7188f1$var$defaultProps = {
    scrollHideDelay: 1e3,
    type: "hover"
};
const $dffe8bd53d7188f1$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((_, { scrollbarSize: scrollbarSize })=>({
        root: {
            "--scrollarea-scrollbar-size": (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(scrollbarSize)
        }
    }));
const $dffe8bd53d7188f1$export$ccf8d8d7bbf3c2cc = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("ScrollArea", $dffe8bd53d7188f1$var$defaultProps, _props);
    const _a = props, { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, scrollbarSize: scrollbarSize, vars: vars, type: type, scrollHideDelay: scrollHideDelay, viewportProps: viewportProps, viewportRef: viewportRef, onScrollPositionChange: onScrollPositionChange, children: children, offsetScrollbars: offsetScrollbars } = _a, others = $dffe8bd53d7188f1$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "scrollbarSize",
        "vars",
        "type",
        "scrollHideDelay",
        "viewportProps",
        "viewportRef",
        "onScrollPositionChange",
        "children",
        "offsetScrollbars"
    ]);
    const [scrollbarHovered, setScrollbarHovered] = (0, $acw62.useState)(false);
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: "ScrollArea",
        props: props,
        classes: $580479a53fd6266c$export$2e2bcd8739ae039,
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        vars: vars,
        varsResolver: $dffe8bd53d7188f1$var$varsResolver
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e2df1435548fd2cc$export$f2a893fcd08ef34d), $dffe8bd53d7188f1$var$__spreadValues($dffe8bd53d7188f1$var$__spreadValues({
        type: type === "never" ? "always" : type,
        scrollHideDelay: scrollHideDelay,
        ref: ref
    }, getStyles("root")), others), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6cec10d0bcac6dc0$export$a21cbf9f11fca853), $dffe8bd53d7188f1$var$__spreadProps($dffe8bd53d7188f1$var$__spreadValues($dffe8bd53d7188f1$var$__spreadValues({}, viewportProps), getStyles("viewport")), {
        ref: viewportRef,
        "data-offset-scrollbars": offsetScrollbars === true ? "xy" : offsetScrollbars || void 0,
        onScroll: typeof onScrollPositionChange === "function" ? ({ currentTarget: currentTarget })=>onScrollPositionChange({
                x: currentTarget.scrollLeft,
                y: currentTarget.scrollTop
            }) : void 0
    }), children), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $11b5067cafb406ae$export$2fabd85d0eba3c57), $dffe8bd53d7188f1$var$__spreadProps($dffe8bd53d7188f1$var$__spreadValues({}, getStyles("scrollbar")), {
        orientation: "horizontal",
        "data-hidden": type === "never" || void 0,
        forceMount: true,
        onMouseEnter: ()=>setScrollbarHovered(true),
        onMouseLeave: ()=>setScrollbarHovered(false)
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $81f0525478ce18ce$export$9fba1154677d7cd2), $dffe8bd53d7188f1$var$__spreadValues({}, getStyles("thumb")))), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $11b5067cafb406ae$export$2fabd85d0eba3c57), $dffe8bd53d7188f1$var$__spreadProps($dffe8bd53d7188f1$var$__spreadValues({}, getStyles("scrollbar")), {
        orientation: "vertical",
        "data-hidden": type === "never" || void 0,
        forceMount: true,
        onMouseEnter: ()=>setScrollbarHovered(true),
        onMouseLeave: ()=>setScrollbarHovered(false)
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $81f0525478ce18ce$export$9fba1154677d7cd2), $dffe8bd53d7188f1$var$__spreadValues({}, getStyles("thumb")))), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f537e37f6c0b850a$export$56969d565df7cc4b), $dffe8bd53d7188f1$var$__spreadProps($dffe8bd53d7188f1$var$__spreadValues({}, getStyles("corner")), {
        "data-hovered": scrollbarHovered || void 0,
        "data-hidden": type === "never" || void 0
    })));
});
$dffe8bd53d7188f1$export$ccf8d8d7bbf3c2cc.displayName = "@mantine/core/ScrollArea";
const $dffe8bd53d7188f1$export$a7a962e3bd12ae1d = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((props, ref)=>{
    const _a = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("ScrollAreaAutosize", $dffe8bd53d7188f1$var$defaultProps, props), { children: children, classNames: classNames, styles: styles, scrollbarSize: scrollbarSize, scrollHideDelay: scrollHideDelay, type: type, dir: dir, offsetScrollbars: offsetScrollbars, viewportRef: viewportRef, onScrollPositionChange: onScrollPositionChange, unstyled: unstyled, variant: variant, viewportProps: viewportProps, style: style, vars: vars } = _a, others = $dffe8bd53d7188f1$var$__objRest(_a, [
        "children",
        "classNames",
        "styles",
        "scrollbarSize",
        "scrollHideDelay",
        "type",
        "dir",
        "offsetScrollbars",
        "viewportRef",
        "onScrollPositionChange",
        "unstyled",
        "variant",
        "viewportProps",
        "style",
        "vars"
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $dffe8bd53d7188f1$var$__spreadProps($dffe8bd53d7188f1$var$__spreadValues({}, others), {
        ref: ref,
        style: [
            {
                display: "flex"
            },
            style
        ]
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
        style: {
            display: "flex",
            flexDirection: "column",
            flex: 1
        }
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($dffe8bd53d7188f1$export$ccf8d8d7bbf3c2cc, {
        classNames: classNames,
        styles: styles,
        scrollHideDelay: scrollHideDelay,
        scrollbarSize: scrollbarSize,
        type: type,
        dir: dir,
        offsetScrollbars: offsetScrollbars,
        viewportRef: viewportRef,
        onScrollPositionChange: onScrollPositionChange,
        unstyled: unstyled,
        variant: variant,
        viewportProps: viewportProps,
        vars: vars
    }, children)));
});
$dffe8bd53d7188f1$export$ccf8d8d7bbf3c2cc.classes = (0, $580479a53fd6266c$export$2e2bcd8739ae039);
$dffe8bd53d7188f1$export$a7a962e3bd12ae1d.displayName = "@mantine/core/ScrollAreaAutosize";
$dffe8bd53d7188f1$export$a7a962e3bd12ae1d.classes = (0, $580479a53fd6266c$export$2e2bcd8739ae039);
$dffe8bd53d7188f1$export$ccf8d8d7bbf3c2cc.Autosize = $dffe8bd53d7188f1$export$a7a962e3bd12ae1d;



"use client";
function $98cffb7fc7e5a3d3$export$8ac6dab353fd1a02(item) {
    return "group" in item;
}


"use client";
function $5c1288cd7192d71b$export$88cd1b3d086e7198({ options: options, search: search, limit: limit }) {
    const parsedSearch = search.trim().toLowerCase();
    const result = [];
    for(let i = 0; i < options.length; i += 1){
        const item = options[i];
        if (result.length === limit) return result;
        if ((0, $98cffb7fc7e5a3d3$export$8ac6dab353fd1a02)(item)) result.push({
            group: item.group,
            items: $5c1288cd7192d71b$export$88cd1b3d086e7198({
                options: item.items,
                search: search,
                limit: limit - result.length
            })
        });
        if (!(0, $98cffb7fc7e5a3d3$export$8ac6dab353fd1a02)(item)) {
            if (item.label.toLowerCase().includes(parsedSearch)) result.push(item);
        }
    }
    return result;
}


"use client";
function $71cf1272376e7135$export$a30aedf31dd7c476(data) {
    if (data.length === 0) return true;
    for (const item of data){
        if (!("group" in item)) return false;
        if (item.items.length > 0) return false;
    }
    return true;
}




"use client";
function $0416a692594799e6$export$1dd09873c1bdd0fc(options, valuesSet = /* @__PURE__ */ new Set()) {
    if (!Array.isArray(options)) return;
    for (const option of options)if ((0, $98cffb7fc7e5a3d3$export$8ac6dab353fd1a02)(option)) $0416a692594799e6$export$1dd09873c1bdd0fc(option.items, valuesSet);
    else {
        if (typeof option.value === "undefined") throw new Error("[@mantine/core] Each option must have value property");
        if (typeof option.value !== "string") throw new Error(`[@mantine/core] Option value must be a string, other data formats are not supported, got ${typeof option.value}`);
        if (valuesSet.has(option.value)) throw new Error(`[@mantine/core] Duplicate options are not supported. Option with value "${option.value}" was provided more than once`);
        valuesSet.add(option.value);
    }
}




var $acw62 = parcelRequire("acw62");

"use client";
var $5513f088f1bc8bdf$var$__defProp = Object.defineProperty;
var $5513f088f1bc8bdf$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $5513f088f1bc8bdf$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $5513f088f1bc8bdf$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $5513f088f1bc8bdf$var$__defNormalProp = (obj, key, value)=>key in obj ? $5513f088f1bc8bdf$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $5513f088f1bc8bdf$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($5513f088f1bc8bdf$var$__hasOwnProp.call(b, prop)) $5513f088f1bc8bdf$var$__defNormalProp(a, prop, b[prop]);
    if ($5513f088f1bc8bdf$var$__getOwnPropSymbols) {
        for (var prop of $5513f088f1bc8bdf$var$__getOwnPropSymbols(b))if ($5513f088f1bc8bdf$var$__propIsEnum.call(b, prop)) $5513f088f1bc8bdf$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $5513f088f1bc8bdf$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($5513f088f1bc8bdf$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $5513f088f1bc8bdf$var$__getOwnPropSymbols) {
        for (var prop of $5513f088f1bc8bdf$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $5513f088f1bc8bdf$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
function $5513f088f1bc8bdf$export$7dd004358974b05d(_a) {
    var _b = _a, { size: size, style: style } = _b, others = $5513f088f1bc8bdf$var$__objRest(_b, [
        "size",
        "style"
    ]);
    const _style = size !== void 0 ? $5513f088f1bc8bdf$var$__spreadValues({
        width: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(size),
        height: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(size)
    }, style) : style;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $5513f088f1bc8bdf$var$__spreadValues({
        viewBox: "0 0 10 7",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: _style
    }, others), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M4 4.586L1.707 2.293A1 1 0 1 0 .293 3.707l3 3a.997.997 0 0 0 1.414 0l5-5A1 1 0 1 0 8.293.293L4 4.586z",
        fill: "currentColor",
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
}
function $5513f088f1bc8bdf$export$c0a1936901b0e55(_c) {
    var _d = _c, { indeterminate: indeterminate } = _d, others = $5513f088f1bc8bdf$var$__objRest(_d, [
        "indeterminate"
    ]);
    if (indeterminate) return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $5513f088f1bc8bdf$var$__spreadValues({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 32 6"
    }, others), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        width: "32",
        height: "6",
        fill: "currentColor",
        rx: "3"
    }));
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($5513f088f1bc8bdf$export$7dd004358974b05d, $5513f088f1bc8bdf$var$__spreadValues({}, others));
}


"use client";
function $d5f4394ae8297fa0$var$isValueChecked(value, optionValue) {
    return Array.isArray(value) ? value.includes(optionValue) : value === optionValue;
}
function $d5f4394ae8297fa0$var$Option({ data: data, withCheckIcon: withCheckIcon, value: value, checkIconPosition: checkIconPosition, unstyled: unstyled }) {
    if (!(0, $98cffb7fc7e5a3d3$export$8ac6dab353fd1a02)(data)) {
        const check = withCheckIcon && $d5f4394ae8297fa0$var$isValueChecked(value, data.value) && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5513f088f1bc8bdf$export$7dd004358974b05d), {
            className: (0, $bc4a4e3a2a9d5b76$export$2e2bcd8739ae039).optionsDropdownCheckIcon
        });
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $924916f5dbd1d3eb$export$27957ad87354dd7e).Option, {
            value: data.value,
            disabled: data.disabled,
            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)({
                [(0, $bc4a4e3a2a9d5b76$export$2e2bcd8739ae039).optionsDropdownOption]: !unstyled
            }),
            "data-reverse": checkIconPosition === "right" || void 0,
            "data-checked": $d5f4394ae8297fa0$var$isValueChecked(value, data.value) || void 0,
            "aria-selected": $d5f4394ae8297fa0$var$isValueChecked(value, data.value)
        }, checkIconPosition === "left" && check, data.label, checkIconPosition === "right" && check);
    }
    const options = data.items.map((item)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d5f4394ae8297fa0$var$Option, {
            data: item,
            value: value,
            key: item.value,
            unstyled: unstyled,
            withCheckIcon: withCheckIcon,
            checkIconPosition: checkIconPosition
        }));
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $924916f5dbd1d3eb$export$27957ad87354dd7e).Group, {
        label: data.group
    }, options);
}
function $d5f4394ae8297fa0$export$3192d9ee15a8463b({ data: data, hidden: hidden, hiddenWhenEmpty: hiddenWhenEmpty, filter: filter, search: search, limit: limit, maxDropdownHeight: maxDropdownHeight, withScrollArea: withScrollArea = true, filterOptions: filterOptions = true, withCheckIcon: withCheckIcon = false, value: value, checkIconPosition: checkIconPosition, nothingFoundMessage: nothingFoundMessage, unstyled: unstyled, labelId: labelId }) {
    (0, $0416a692594799e6$export$1dd09873c1bdd0fc)(data);
    const shouldFilter = typeof search === "string";
    const filteredData = shouldFilter ? (filter || (0, $5c1288cd7192d71b$export$88cd1b3d086e7198))({
        options: data,
        search: filterOptions ? search : "",
        limit: limit != null ? limit : Infinity
    }) : data;
    const isEmpty = (0, $71cf1272376e7135$export$a30aedf31dd7c476)(filteredData);
    const options = filteredData.map((item)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d5f4394ae8297fa0$var$Option, {
            data: item,
            key: (0, $98cffb7fc7e5a3d3$export$8ac6dab353fd1a02)(item) ? item.group : item.value,
            withCheckIcon: withCheckIcon,
            value: value,
            checkIconPosition: checkIconPosition,
            unstyled: unstyled
        }));
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $924916f5dbd1d3eb$export$27957ad87354dd7e).Dropdown, {
        hidden: hidden || hiddenWhenEmpty && isEmpty
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $924916f5dbd1d3eb$export$27957ad87354dd7e).Options, {
        labelledBy: labelId
    }, withScrollArea ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dffe8bd53d7188f1$export$ccf8d8d7bbf3c2cc).Autosize, {
        mah: maxDropdownHeight != null ? maxDropdownHeight : 220,
        type: "scroll",
        scrollbarSize: "var(--_combobox-padding)",
        offsetScrollbars: "y",
        className: (0, $bc4a4e3a2a9d5b76$export$2e2bcd8739ae039).optionsDropdownScrollArea
    }, options) : options, isEmpty && nothingFoundMessage && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $924916f5dbd1d3eb$export$27957ad87354dd7e).Empty, null, nothingFoundMessage)));
}







"use client";
function $3da94ce37793f66c$export$92dc9b0c0bd35ec0({ classNames: classNames, styles: styles, props: props, stylesCtx: stylesCtx }) {
    const theme = (0, $692af3391f7b0a55$export$5eb0e84f6418b457)();
    return {
        resolvedClassNames: (0, $ba12a721d32e28d3$export$7df0003ea9a4d3a4)({
            theme: theme,
            classNames: classNames,
            props: props,
            stylesCtx: stylesCtx || void 0
        }),
        resolvedStyles: (0, $d9501d38e7649221$export$5376e124e9154c53)({
            theme: theme,
            styles: styles,
            props: props,
            stylesCtx: stylesCtx || void 0
        })
    };
}


"use client";
var $339474aa0c55627b$var$__defProp = Object.defineProperty;
var $339474aa0c55627b$var$__defProps = Object.defineProperties;
var $339474aa0c55627b$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $339474aa0c55627b$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $339474aa0c55627b$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $339474aa0c55627b$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $339474aa0c55627b$var$__defNormalProp = (obj, key, value)=>key in obj ? $339474aa0c55627b$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $339474aa0c55627b$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($339474aa0c55627b$var$__hasOwnProp.call(b, prop)) $339474aa0c55627b$var$__defNormalProp(a, prop, b[prop]);
    if ($339474aa0c55627b$var$__getOwnPropSymbols) {
        for (var prop of $339474aa0c55627b$var$__getOwnPropSymbols(b))if ($339474aa0c55627b$var$__propIsEnum.call(b, prop)) $339474aa0c55627b$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $339474aa0c55627b$var$__spreadProps = (a, b)=>$339474aa0c55627b$var$__defProps(a, $339474aa0c55627b$var$__getOwnPropDescs(b));
var $339474aa0c55627b$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($339474aa0c55627b$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $339474aa0c55627b$var$__getOwnPropSymbols) {
        for (var prop of $339474aa0c55627b$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $339474aa0c55627b$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $339474aa0c55627b$var$defaultProps = {
    searchable: false,
    withCheckIcon: true,
    allowDeselect: true,
    checkIconPosition: "left"
};
const $339474aa0c55627b$export$ef9b1a59e592288f = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("Select", $339474aa0c55627b$var$defaultProps, _props);
    const _a = props, { classNames: classNames, styles: styles, unstyled: unstyled, vars: vars, dropdownOpened: dropdownOpened, defaultDropdownOpened: defaultDropdownOpened, onDropdownClose: onDropdownClose, onDropdownOpen: onDropdownOpen, onFocus: onFocus, onBlur: onBlur, onClick: onClick, onChange: onChange, data: data, value: value, defaultValue: defaultValue, selectFirstOptionOnChange: selectFirstOptionOnChange, onOptionSubmit: onOptionSubmit, comboboxProps: comboboxProps, readOnly: readOnly, disabled: disabled, filter: filter, limit: limit, withScrollArea: withScrollArea, maxDropdownHeight: maxDropdownHeight, size: size, searchable: searchable, rightSection: rightSection, checkIconPosition: checkIconPosition, withCheckIcon: withCheckIcon, nothingFoundMessage: nothingFoundMessage, name: name, form: form, searchValue: searchValue, defaultSearchValue: defaultSearchValue, onSearchChange: onSearchChange, allowDeselect: allowDeselect, error: error, rightSectionPointerEvents: rightSectionPointerEvents, id: id, clearable: clearable, clearButtonProps: clearButtonProps, hiddenInputProps: hiddenInputProps } = _a, others = $339474aa0c55627b$var$__objRest(_a, [
        "classNames",
        "styles",
        "unstyled",
        "vars",
        "dropdownOpened",
        "defaultDropdownOpened",
        "onDropdownClose",
        "onDropdownOpen",
        "onFocus",
        "onBlur",
        "onClick",
        "onChange",
        "data",
        "value",
        "defaultValue",
        "selectFirstOptionOnChange",
        "onOptionSubmit",
        "comboboxProps",
        "readOnly",
        "disabled",
        "filter",
        "limit",
        "withScrollArea",
        "maxDropdownHeight",
        "size",
        "searchable",
        "rightSection",
        "checkIconPosition",
        "withCheckIcon",
        "nothingFoundMessage",
        "name",
        "form",
        "searchValue",
        "defaultSearchValue",
        "onSearchChange",
        "allowDeselect",
        "error",
        "rightSectionPointerEvents",
        "id",
        "clearable",
        "clearButtonProps",
        "hiddenInputProps"
    ]);
    const parsedData = (0, $acw62.useMemo)(()=>(0, $0887c454ff4ce757$export$4d4f0f9e22a4ec50)(data), [
        data
    ]);
    const optionsLockup = (0, $acw62.useMemo)(()=>(0, $1ea5e49f796534b2$export$3ecc75716a884846)(parsedData), [
        parsedData
    ]);
    const _id = (0, $cee42e5537afff93$export$f680877a34711e37)(id);
    const [_value, setValue] = (0, $4197894a742d9f84$export$ec55e9daaf703a7d)({
        value: value,
        defaultValue: defaultValue,
        finalValue: null,
        onChange: onChange
    });
    const selectedOption = _value ? optionsLockup[_value] : void 0;
    const [search, setSearch] = (0, $4197894a742d9f84$export$ec55e9daaf703a7d)({
        value: searchValue,
        defaultValue: defaultSearchValue,
        finalValue: selectedOption ? selectedOption.label : "",
        onChange: onSearchChange
    });
    const combobox = (0, $ec685ef88b7ada0d$export$7a023a466c03eb3d)({
        opened: dropdownOpened,
        defaultOpened: defaultDropdownOpened,
        onDropdownOpen: onDropdownOpen,
        onDropdownClose: ()=>{
            onDropdownClose == null || onDropdownClose();
            combobox.resetSelectedOption();
        }
    });
    const { resolvedClassNames: resolvedClassNames, resolvedStyles: resolvedStyles } = (0, $3da94ce37793f66c$export$92dc9b0c0bd35ec0)({
        props: props,
        styles: styles,
        classNames: classNames
    });
    (0, $acw62.useEffect)(()=>{
        if (selectFirstOptionOnChange) combobox.selectFirstOption();
    }, [
        selectFirstOptionOnChange,
        _value
    ]);
    (0, $acw62.useEffect)(()=>{
        if (value === null) setSearch("");
        if (typeof value === "string" && selectedOption) setSearch(selectedOption.label);
    }, [
        value,
        selectedOption
    ]);
    const clearButton = clearable && !!_value && !disabled && !readOnly && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $924916f5dbd1d3eb$export$27957ad87354dd7e).ClearButton, $339474aa0c55627b$var$__spreadProps($339474aa0c55627b$var$__spreadValues({
        size: size
    }, clearButtonProps), {
        onClear: ()=>{
            setValue(null);
            setSearch("");
        }
    }));
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $924916f5dbd1d3eb$export$27957ad87354dd7e), $339474aa0c55627b$var$__spreadValues({
        store: combobox,
        __staticSelector: "Select",
        classNames: resolvedClassNames,
        styles: resolvedStyles,
        unstyled: unstyled,
        readOnly: readOnly,
        onOptionSubmit: (val)=>{
            onOptionSubmit == null || onOptionSubmit(val);
            const nextValue = allowDeselect ? optionsLockup[val].value === _value ? null : optionsLockup[val].value : optionsLockup[val].value;
            setValue(nextValue);
            setSearch(nextValue ? optionsLockup[val].label : "");
            combobox.closeDropdown();
        },
        size: size
    }, comboboxProps), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $924916f5dbd1d3eb$export$27957ad87354dd7e).Target, {
        targetType: searchable ? "input" : "button"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ebdc9ebef4cbe70e$export$36eab7f492831059), $339474aa0c55627b$var$__spreadProps($339474aa0c55627b$var$__spreadValues({
        id: _id,
        ref: ref,
        rightSection: rightSection || clearButton || /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $924916f5dbd1d3eb$export$27957ad87354dd7e).Chevron, {
            size: size,
            error: error,
            unstyled: unstyled
        }),
        rightSectionPointerEvents: rightSectionPointerEvents || clearButton ? "all" : "none"
    }, others), {
        size: size,
        __staticSelector: "Select",
        disabled: disabled,
        readOnly: readOnly || !searchable,
        value: search,
        onChange: (event)=>{
            setSearch(event.currentTarget.value);
            combobox.openDropdown();
            selectFirstOptionOnChange && combobox.selectFirstOption();
        },
        onFocus: (event)=>{
            searchable && combobox.openDropdown();
            onFocus == null || onFocus(event);
        },
        onBlur: (event)=>{
            var _a2;
            searchable && combobox.closeDropdown();
            setSearch(_value ? ((_a2 = optionsLockup[_value]) == null ? void 0 : _a2.label) || "" : "");
            onBlur == null || onBlur(event);
        },
        onClick: (event)=>{
            searchable ? combobox.openDropdown() : combobox.toggleDropdown();
            onClick == null || onClick(event);
        },
        classNames: resolvedClassNames,
        styles: resolvedStyles,
        unstyled: unstyled,
        pointer: !searchable,
        error: error
    }))), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d5f4394ae8297fa0$export$3192d9ee15a8463b), {
        data: parsedData,
        hidden: readOnly || disabled,
        filter: filter,
        search: search,
        limit: limit,
        hiddenWhenEmpty: !searchable || !nothingFoundMessage,
        withScrollArea: withScrollArea,
        maxDropdownHeight: maxDropdownHeight,
        filterOptions: searchable && (selectedOption == null ? void 0 : selectedOption.label) !== search,
        value: _value,
        checkIconPosition: checkIconPosition,
        withCheckIcon: withCheckIcon,
        nothingFoundMessage: nothingFoundMessage,
        unstyled: unstyled,
        labelId: `${_id}-label`
    })), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", $339474aa0c55627b$var$__spreadValues({
        type: "hidden",
        name: name,
        value: _value || "",
        form: form,
        disabled: disabled
    }, hiddenInputProps)));
});
$339474aa0c55627b$export$ef9b1a59e592288f.classes = $339474aa0c55627b$var$__spreadValues($339474aa0c55627b$var$__spreadValues({}, (0, $ebdc9ebef4cbe70e$export$36eab7f492831059).classes), (0, $924916f5dbd1d3eb$export$27957ad87354dd7e).classes);
$339474aa0c55627b$export$ef9b1a59e592288f.displayName = "@mantine/core/Select";


var $acw62 = parcelRequire("acw62");



"use client";
var $bcbc0ad084559bc5$var$__defProp = Object.defineProperty;
var $bcbc0ad084559bc5$var$__defProps = Object.defineProperties;
var $bcbc0ad084559bc5$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $bcbc0ad084559bc5$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $bcbc0ad084559bc5$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $bcbc0ad084559bc5$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $bcbc0ad084559bc5$var$__defNormalProp = (obj, key, value)=>key in obj ? $bcbc0ad084559bc5$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $bcbc0ad084559bc5$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($bcbc0ad084559bc5$var$__hasOwnProp.call(b, prop)) $bcbc0ad084559bc5$var$__defNormalProp(a, prop, b[prop]);
    if ($bcbc0ad084559bc5$var$__getOwnPropSymbols) {
        for (var prop of $bcbc0ad084559bc5$var$__getOwnPropSymbols(b))if ($bcbc0ad084559bc5$var$__propIsEnum.call(b, prop)) $bcbc0ad084559bc5$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $bcbc0ad084559bc5$var$__spreadProps = (a, b)=>$bcbc0ad084559bc5$var$__defProps(a, $bcbc0ad084559bc5$var$__getOwnPropDescs(b));
const $bcbc0ad084559bc5$var$defaultProps = {};
const $bcbc0ad084559bc5$export$c86715117507e8e5 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((props, ref)=>{
    const _props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("TextInput", $bcbc0ad084559bc5$var$defaultProps, props);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ebdc9ebef4cbe70e$export$36eab7f492831059), $bcbc0ad084559bc5$var$__spreadProps($bcbc0ad084559bc5$var$__spreadValues({
        component: "input",
        ref: ref
    }, _props), {
        __staticSelector: "TextInput"
    }));
});
$bcbc0ad084559bc5$export$c86715117507e8e5.classes = (0, $ebdc9ebef4cbe70e$export$36eab7f492831059).classes;
$bcbc0ad084559bc5$export$c86715117507e8e5.displayName = "@mantine/core/TextInput";


parcelRequire("acw62");



const $3af20f54a79a0a09$var$SourceSelector = ({ isEditMode: isEditMode, hasSource: hasSource, selectedSource: selectedSource, sourcesData: sourcesData, handleSubmit: handleSubmit, isModalOpen: isModalOpen, interest: interest, setIsModalOpen: setIsModalOpen, customSource: customSource, setCustomSource: setCustomSource, handleCustomSourceSubmit: handleCustomSourceSubmit, setSources: setSources, removeTag: removeTag })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            " ",
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4), {
                align: "flex-end",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
                        sx: {
                            flexGrow: 1
                        },
                        children: [
                            " ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                size: "md",
                                fw: 600,
                                children: "Sources"
                            }),
                            !hasSource && isEditMode && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                size: "sm",
                                fw: 500,
                                mb: (0, $7db4b5652a829202$export$bca14c5b3b88a9c9).padding.xs,
                                c: (0, $7db4b5652a829202$export$bca14c5b3b88a9c9).colors.red[3],
                                children: "Add a source to continue."
                            }),
                            isEditMode ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $339474aa0c55627b$export$ef9b1a59e592288f), {
                                mt: (0, $7db4b5652a829202$export$bca14c5b3b88a9c9).padding.xs,
                                disabled: !isEditMode,
                                placeholder: "Select source",
                                value: selectedSource,
                                data: sourcesData?.map((source)=>source.name),
                                onChange: handleSubmit
                            }) : interest?.sources?.length == 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                size: "sm",
                                c: "gray",
                                children: "Click edit to add a source and get started."
                            })
                        ]
                    }),
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $b1b81586258b47fb$export$2b77a92f1a5ad772), {
                        opened: isModalOpen,
                        onClose: ()=>setIsModalOpen(false),
                        title: "Add Custom Source",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bcbc0ad084559bc5$export$c86715117507e8e5), {
                                value: customSource,
                                onChange: (e)=>setCustomSource(e.target.value),
                                placeholder: "Enter custom source name",
                                onKeyDown: (e)=>{
                                    if (e.key === "Enter") handleCustomSourceSubmit();
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                                onClick: handleCustomSourceSubmit,
                                mt: "sm",
                                children: "Add Source"
                            })
                        ]
                    })
                ]
            }),
            interest?.sources?.length !== 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
                mb: (0, $7db4b5652a829202$export$bca14c5b3b88a9c9).padding.md,
                mt: (0, $7db4b5652a829202$export$bca14c5b3b88a9c9).padding.xs,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $33ecc2b042884c60$export$2e2bcd8739ae039), {
                    baseTags: interest.sources?.map((source)=>source?.name),
                    activeTopics: interest.sources?.map((source)=>source?.name),
                    setActiveTopics: isEditMode ? setSources : undefined,
                    removableHint: isEditMode,
                    defaultOutline: true,
                    large: true,
                    clickable: isEditMode,
                    tagColor: (0, $7db4b5652a829202$export$bca14c5b3b88a9c9).colors.blue[3],
                    tagType: "source",
                    removeTag: (tag, tagType)=>removeTag(tag, tagType)
                })
            })
        ]
    });
};
var $3af20f54a79a0a09$export$2e2bcd8739ae039 = $3af20f54a79a0a09$var$SourceSelector;




parcelRequire("acw62");



const $3d4b4e235b388977$var$CategorySelector = ({ isEditMode: isEditMode, hasSource: hasSource, newTopic: newTopic, setNewTopic: setNewTopic, addTopic: addTopic, hasTopics: hasTopics, isComplete: isComplete, handleEnableEdit: handleEnableEdit, interest: interest, removeTag: removeTag, setTags: setTags })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4), {
                align: "flex-end",
                justify: "space",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
                        sx: {
                            flexGrow: 1
                        },
                        mt: (0, $7db4b5652a829202$export$bca14c5b3b88a9c9).padding.md,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                size: "md",
                                fw: 600,
                                children: "Categories"
                            }),
                            isEditMode ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bcbc0ad084559bc5$export$c86715117507e8e5), {
                                mt: (0, $7db4b5652a829202$export$bca14c5b3b88a9c9).padding.xs,
                                disabled: !isEditMode || !hasSource,
                                value: newTopic,
                                onChange: (e)=>setNewTopic(e.target.value),
                                onKeyDown: (e)=>{
                                    if (e.key === "Enter") addTopic();
                                },
                                placeholder: "Add a category"
                            }) : !hasTopics && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4), {
                                justify: "space-between",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                    size: "sm",
                                    c: "gray",
                                    mt: (0, $7db4b5652a829202$export$bca14c5b3b88a9c9).padding.sm,
                                    children: "Click edit to add a category and get started."
                                })
                            })
                        ]
                    }),
                    " ",
                    !isComplete && !hasTopics && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                        variant: "outline",
                        color: (0, $7db4b5652a829202$export$bca14c5b3b88a9c9).colors.red[4],
                        radius: "md",
                        size: "xs",
                        right: "16px",
                        bottom: "16px",
                        pos: "absolute",
                        onClick: handleEnableEdit,
                        children: "Incomplete"
                    }),
                    isEditMode && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                        onClick: addTopic,
                        style: {
                            background: (0, $7db4b5652a829202$export$bca14c5b3b88a9c9).colors.blue[4]
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $96c0311e1348944b$export$2e2bcd8739ae039), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4), {
                justify: "space-between",
                children: [
                    hasTopics && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
                        mt: (0, $7db4b5652a829202$export$bca14c5b3b88a9c9).padding.sm,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $33ecc2b042884c60$export$2e2bcd8739ae039), {
                            baseTags: interest.categories?.map((category)=>category?.name),
                            activeTopics: interest.categories?.map((category)=>category?.name),
                            setActiveTopics: isEditMode ? setTags : undefined,
                            removableHint: isEditMode,
                            defaultOutline: true,
                            clickable: isEditMode,
                            tagColor: (0, $7db4b5652a829202$export$bca14c5b3b88a9c9).colors.purple[3],
                            tagType: "category",
                            removeTag: (tag, tagType)=>removeTag(tag, tagType),
                            large: true
                        })
                    }),
                    " ",
                    !isComplete && hasTopics && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                        variant: "outline",
                        color: (0, $7db4b5652a829202$export$bca14c5b3b88a9c9).colors.red[4],
                        radius: "md",
                        size: "xs",
                        onClick: handleEnableEdit,
                        children: "Incomplete"
                    })
                ]
            })
        ]
    });
};
var $3d4b4e235b388977$export$2e2bcd8739ae039 = $3d4b4e235b388977$var$CategorySelector;



const $1bdabd5902a4bb7e$var$InterestItem = ({ item: item, onDelete: onDelete, onEdit: onEdit })=>{
    const [interest, setInterest] = (0, $acw62.useState)(item);
    const [newTopic, setNewTopic] = (0, $acw62.useState)("");
    const [selectedSource, setSelectedSource] = (0, $acw62.useState)("");
    const [isModalOpen, setIsModalOpen] = (0, $acw62.useState)(false);
    const [customSource, setCustomSource] = (0, $acw62.useState)("");
    const [isEditMode, setIsEditMode] = (0, $acw62.useState)(item.edit);
    const [userId, setUserId] = (0, $acw62.useState)(false);
    const [sourceOptions, setSourceOptions] = (0, $acw62.useState)([]);
    const isComplete = interest?.subject && interest?.sources?.length;
    const hasSource = interest?.sources?.length;
    const hasTopics = interest?.categories?.length !== 0;
    const user = (0, $1861b69a0d0c7fdf$export$68dae0b0cacaa18a)();
    const { data: sourcesData } = (0, $76c21c25e2dea0bd$export$62e1452b7d176285)();
    const [createCategoryByName] = (0, $76c21c25e2dea0bd$export$b8da3e59c773b24a)();
    (0, $acw62.useEffect)(()=>{
        setUserId(user.data ? user.data[0].id : null);
    }, [
        user
    ]);
    (0, $acw62.useEffect)(()=>{
        setSourceOptions(sourcesData?.filter((source)=>!interest?.sources?.some((interestSource)=>source.id === interestSource.id)) ?? []);
    }, [
        sourcesData
    ]);
    const addTopic = async ()=>{
        if (newTopic) try {
            const response = await createCategoryByName({
                name: newTopic,
                owner: userId
            });
            setInterest({
                ...interest,
                categories: [
                    ...interest.categories,
                    response.data
                ]
            });
            setNewTopic("");
        } catch (error) {
            console.error("Error creating interest:", error);
        }
    };
    const handleSubmit = (value)=>{
        setSelectedSource(value);
        if (value === "other") setIsModalOpen(true);
        if (value && value !== "other" && !interest.sources.includes(value)) {
            setInterest({
                ...interest,
                sources: [
                    ...interest.sources,
                    sourceOptions.find((source)=>source.name === value)
                ]
            });
            setSourceOptions(sourceOptions.filter((source)=>source.name !== value));
            setSelectedSource("");
        }
    };
    const handleCustomSourceSubmit = ()=>{
        if (customSource && !interest.source.includes(customSource)) {
            setInterest({
                ...interest,
                sources: [
                    ...interest.sources,
                    customSource
                ]
            });
            setCustomSource("");
        }
        setIsModalOpen(false);
        setSelectedSource("");
    };
    const setTags = (newTags)=>{
        setInterest({
            ...interest,
            categories: newTags
        });
    };
    const setSources = (newsource)=>{
        setInterest({
            ...interest,
            sources: newsource
        });
    };
    const handleEdit = ()=>{
        onEdit(item.id, interest);
        setIsEditMode(false);
    };
    const handleEnableEdit = ()=>{
        setIsEditMode(true);
    };
    const removeTag = (tag, tagType)=>{
        if (tagType === "category") setTags(interest.categories.filter((activeTag)=>activeTag.name !== tag));
        else if (tagType === "source") {
            setSources(interest.sources.filter((activeTag)=>activeTag.name !== tag));
            setSourceOptions([
                ...sourceOptions,
                interest.sources.filter((activeTag)=>activeTag.name === tag)[0]
            ]);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $3e91b7d399f248d1$export$60332b2344f7fe41), {
        shadow: "md",
        radius: "md",
        mt: "10",
        withBorder: true,
        pos: "relative",
        p: "xl",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4e00d137aa7b325a$export$f51f4c4ede09e011), {
                align: "start",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3af20f54a79a0a09$export$2e2bcd8739ae039), {
                        isEditMode: isEditMode,
                        hasSource: hasSource,
                        selectedSource: selectedSource,
                        sourcesData: sourceOptions,
                        handleSubmit: (value)=>handleSubmit(value),
                        isModalOpen: isModalOpen,
                        interest: interest,
                        setIsModalOpen: (value)=>setIsModalOpen(value),
                        customSource: customSource,
                        setCustomSource: (source)=>setCustomSource(source),
                        handleCustomSourceSubmit: ()=>handleCustomSourceSubmit(),
                        setSources: (newsource)=>setSources(newsource),
                        removeTag: (tag, tagType)=>removeTag(tag, tagType)
                    }),
                    !isEditMode && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                        onClick: handleEnableEdit,
                        leftSection: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e254d1424d005608$export$2e2bcd8739ae039), {
                            size: "14"
                        }),
                        size: "xs",
                        variant: "default",
                        ml: "auto",
                        children: "Edit"
                    }),
                    isEditMode && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4), {
                        ml: "auto",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                                onClick: ()=>onDelete(item.id),
                                style: {
                                    background: (0, $7db4b5652a829202$export$bca14c5b3b88a9c9).colors.red[3],
                                    color: "white"
                                },
                                leftSection: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e20178616c8cb80c$export$2e2bcd8739ae039), {
                                    size: "14"
                                }),
                                size: "xs",
                                variant: "light",
                                children: "Delete"
                            }),
                            interest?.subject?.length && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                                onClick: handleEdit,
                                disabled: !hasSource || !isComplete,
                                leftSection: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $058c864623b900db$export$2e2bcd8739ae039), {
                                    size: "14"
                                }),
                                size: "xs",
                                variant: "default",
                                children: "Save"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                size: "md",
                fw: 600,
                mb: (0, $7db4b5652a829202$export$bca14c5b3b88a9c9).padding.xs,
                children: "Research Topic"
            }),
            isEditMode ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c782496b9d9d6645$export$379139ebc1c2b235), {
                disabled: !isEditMode || !hasSource,
                value: interest.subject ?? "",
                onChange: (e)=>setInterest({
                        ...interest,
                        subject: e.target.value
                    }),
                placeholder: "Describe the insight you\u2019re after in as much detail as you require",
                autosize: true,
                minRows: 1,
                maxRows: 5,
                size: "md"
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: !interest.subject ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                    size: "md",
                    c: "gray",
                    children: "Describe the insight you\u2019re after in as much detail as you require"
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                    size: "md",
                    children: interest.subject
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3d4b4e235b388977$export$2e2bcd8739ae039), {
                isEditMode: isEditMode,
                hasSource: hasSource,
                newTopic: newTopic,
                setNewTopic: (topic)=>setNewTopic(topic),
                addTopic: ()=>addTopic(),
                hasTopics: hasTopics,
                isComplete: isComplete,
                handleEnableEdit: ()=>handleEnableEdit(),
                interest: interest,
                removeTag: (tag, tagType)=>removeTag(tag, tagType),
                setTags: (newTags)=>setTags(newTags)
            })
        ]
    }, `${interest.id}`);
};
var $1bdabd5902a4bb7e$export$2e2bcd8739ae039 = $1bdabd5902a4bb7e$var$InterestItem;






const $95b8a7811494f41d$var$InterestManager = ({ discoveryItems: discoveryItems, setDiscoveryItems: setDiscoveryItems, editInterest: editInterest, interestsData: interestsData, isInterestsLoading: isInterestsLoading })=>{
    const auth = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.auth);
    const [deleteInterestById] = (0, $76c21c25e2dea0bd$export$33fe92a210a94b9d)();
    (0, $acw62.useEffect)(()=>{
        setDiscoveryItems(interestsData?.map((item)=>({
                ...item
            })));
    }, [
        isInterestsLoading,
        interestsData
    ]);
    const deleteInterest = (itemId)=>{
        deleteInterestById({
            id: itemId
        });
        setDiscoveryItems(discoveryItems.filter((item)=>item.id !== itemId));
    };
    if (isInterestsLoading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $99c68b09e9ea9061$export$2e2bcd8739ae039), {
        svgLink: (0, (/*@__PURE__*/$parcel$interopDefault($d5e4bba30610058b$exports))),
        description: "Please wait while Consili finds your insights..."
    });
    if (!auth.demo && !discoveryItems?.length) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $99c68b09e9ea9061$export$2e2bcd8739ae039), {
        svgLink: (0, (/*@__PURE__*/$parcel$interopDefault($d5e4bba30610058b$exports))),
        description: "Add your interests to get started"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: discoveryItems?.slice().sort((a, b)=>b.id - a.id).map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1bdabd5902a4bb7e$export$2e2bcd8739ae039), {
                item: item,
                onDelete: deleteInterest,
                onEdit: (itemId, updatedInterest)=>editInterest(itemId, updatedInterest),
                updateEdit: (itemId, updatedInterest)=>editInterest(itemId, updatedInterest)
            }, item.id))
    });
};
var $95b8a7811494f41d$export$2e2bcd8739ae039 = $95b8a7811494f41d$var$InterestManager;






var $45fvw = parcelRequire("45fvw");

const $444b5dceb35062a9$var$DiscoveryPanel = ({ setShowChatLogo: setShowChatLogo, firstOpen: firstOpen, setFirstOpen: setFirstOpen })=>{
    const [discoveryItems, setDiscoveryItems] = (0, $acw62.useState)([]);
    const [isEditing, setIsEditing] = (0, $acw62.useState)(false);
    const [userId, setUserId] = (0, $acw62.useState)(false);
    const [createInterestById] = (0, $76c21c25e2dea0bd$export$b35899cf935ea146)();
    const user = (0, $1861b69a0d0c7fdf$export$68dae0b0cacaa18a)();
    const { data: interestsData, isLoading: isInterestsLoading } = (0, $76c21c25e2dea0bd$export$678ba770cae0ed70)();
    const [updateInterestById] = (0, $76c21c25e2dea0bd$export$fc12de619300c96e)();
    (0, $acw62.useEffect)(()=>{
        setDiscoveryItems(interestsData);
    }, [
        interestsData
    ]);
    (0, $acw62.useEffect)(()=>{
        setUserId(user.data ? user.data[0].id : null);
    }, [
        user
    ]);
    const addNewInterest = ()=>{
        setDiscoveryItems([
            ...discoveryItems,
            {
                categories: [],
                sources: [],
                subject: "",
                id: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().valueOf(),
                edit: true
            }
        ]);
    };
    const handleDiscoveryClick = ()=>{
        setFirstOpen(false);
        setIsEditing(!isEditing);
        setShowChatLogo();
    };
    const updateEdit = (updatedInterest)=>{
        return {
            ...updatedInterest,
            edit: !updatedInterest.edit
        };
    };
    const editInterest = async (itemId, updatedInterest)=>{
        try {
            const updateResponse = await updateInterestById({
                ...updatedInterest,
                created: undefined,
                modified: undefined
            });
            if (updateResponse.error) {
                const createResponse = await createInterestById({
                    ...updatedInterest,
                    owner: userId
                });
                const newDiscoveryItems = discoveryItems.length ? discoveryItems.slice(0, -1) : discoveryItems;
                setDiscoveryItems([
                    ...newDiscoveryItems,
                    {
                        ...createResponse.data,
                        edit: false
                    }
                ]);
                return;
            }
            updatedInterest = updateEdit(updatedInterest);
            const newItems = discoveryItems.map((item)=>item.id === itemId ? updatedInterest : item);
            setDiscoveryItems(newItems);
        } catch (error) {
            console.error("Error creating interest:", error);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2903b8a25a65807a$export$42a852a2b6b56249), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4e00d137aa7b325a$export$f51f4c4ede09e011), {
                align: "center",
                mb: (0, $7db4b5652a829202$export$bca14c5b3b88a9c9).padding.xs,
                pt: (0, $7db4b5652a829202$export$bca14c5b3b88a9c9).padding.md,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                        fw: 700,
                        className: "panel-title",
                        mb: (0, $7db4b5652a829202$export$bca14c5b3b88a9c9).padding.sm,
                        children: "Knowledge Discovery"
                    }),
                    isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                        leftSection: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $96c0311e1348944b$export$2e2bcd8739ae039), {
                            size: 14
                        }),
                        size: "xs",
                        ml: "auto",
                        variant: "default",
                        onClick: addNewInterest,
                        children: "Add Interest"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                        leftSection: isEditing ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $058c864623b900db$export$2e2bcd8739ae039), {
                            size: 14
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e254d1424d005608$export$2e2bcd8739ae039), {
                            size: 14
                        }),
                        ml: isEditing ? "5px" : "auto",
                        size: "xs",
                        variant: "default",
                        onClick: handleDiscoveryClick,
                        children: isEditing ? "Save" : "Edit"
                    })
                ]
            }),
            isEditing ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $95b8a7811494f41d$export$2e2bcd8739ae039), {
                discoveryItems: discoveryItems,
                setDiscoveryItems: setDiscoveryItems,
                editInterest: (itemId, updatedInterest)=>editInterest(itemId, updatedInterest),
                interestsData: interestsData,
                isInterestsLoading: isInterestsLoading
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bb321abaf7cc4e30$export$2e2bcd8739ae039), {
                setIsEditing: setIsEditing,
                setShowChatLogo: setShowChatLogo,
                firstOpen: firstOpen,
                interestsData: interestsData,
                isInterestsLoading: isInterestsLoading
            })
        ]
    });
};
var $444b5dceb35062a9$export$2e2bcd8739ae039 = $444b5dceb35062a9$var$DiscoveryPanel;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
"use client";
const $b04d70519e70cd21$var$AvatarGroupContext = (0, $acw62.createContext)(null);
const $b04d70519e70cd21$export$d4d383acb7146194 = $b04d70519e70cd21$var$AvatarGroupContext.Provider;
function $b04d70519e70cd21$export$df4312aa52e73e7b() {
    const ctx = (0, $acw62.useContext)($b04d70519e70cd21$var$AvatarGroupContext);
    return {
        withinGroup: !!ctx
    };
}


"use client";
var $629e2eeea3181147$var$classes = {
    "root": "m-f85678b6",
    "image": "m-11f8ac07",
    "placeholder": "m-104cd71f",
    "group": "m-11def92b"
};
var $629e2eeea3181147$export$2e2bcd8739ae039 = $629e2eeea3181147$var$classes;








"use client";
var $e5be6f6f74ee8e60$var$__defProp = Object.defineProperty;
var $e5be6f6f74ee8e60$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $e5be6f6f74ee8e60$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $e5be6f6f74ee8e60$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $e5be6f6f74ee8e60$var$__defNormalProp = (obj, key, value)=>key in obj ? $e5be6f6f74ee8e60$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $e5be6f6f74ee8e60$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($e5be6f6f74ee8e60$var$__hasOwnProp.call(b, prop)) $e5be6f6f74ee8e60$var$__defNormalProp(a, prop, b[prop]);
    if ($e5be6f6f74ee8e60$var$__getOwnPropSymbols) {
        for (var prop of $e5be6f6f74ee8e60$var$__getOwnPropSymbols(b))if ($e5be6f6f74ee8e60$var$__propIsEnum.call(b, prop)) $e5be6f6f74ee8e60$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $e5be6f6f74ee8e60$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($e5be6f6f74ee8e60$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $e5be6f6f74ee8e60$var$__getOwnPropSymbols) {
        for (var prop of $e5be6f6f74ee8e60$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $e5be6f6f74ee8e60$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $e5be6f6f74ee8e60$var$defaultProps = {};
const $e5be6f6f74ee8e60$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((_, { spacing: spacing })=>({
        group: {
            "--ag-spacing": (0, $fcab4af601ce7e99$export$f63796f8a9382bfb)(spacing)
        }
    }));
const $e5be6f6f74ee8e60$export$5b26ebaf2b105908 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("AvatarGroup", $e5be6f6f74ee8e60$var$defaultProps, _props);
    const _a = props, { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, spacing: spacing } = _a, others = $e5be6f6f74ee8e60$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "spacing"
    ]);
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: "AvatarGroup",
        classes: $629e2eeea3181147$export$2e2bcd8739ae039,
        props: props,
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        vars: vars,
        varsResolver: $e5be6f6f74ee8e60$var$varsResolver,
        rootSelector: "group"
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b04d70519e70cd21$export$d4d383acb7146194), {
        value: true
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $e5be6f6f74ee8e60$var$__spreadValues($e5be6f6f74ee8e60$var$__spreadValues({
        ref: ref
    }, getStyles("group")), others)));
});
$e5be6f6f74ee8e60$export$5b26ebaf2b105908.classes = (0, $629e2eeea3181147$export$2e2bcd8739ae039);
$e5be6f6f74ee8e60$export$5b26ebaf2b105908.displayName = "@mantine/core/AvatarGroup";




var $acw62 = parcelRequire("acw62");
"use client";
var $01d1ecae77899d22$var$__defProp = Object.defineProperty;
var $01d1ecae77899d22$var$__defProps = Object.defineProperties;
var $01d1ecae77899d22$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $01d1ecae77899d22$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $01d1ecae77899d22$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $01d1ecae77899d22$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $01d1ecae77899d22$var$__defNormalProp = (obj, key, value)=>key in obj ? $01d1ecae77899d22$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $01d1ecae77899d22$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($01d1ecae77899d22$var$__hasOwnProp.call(b, prop)) $01d1ecae77899d22$var$__defNormalProp(a, prop, b[prop]);
    if ($01d1ecae77899d22$var$__getOwnPropSymbols) {
        for (var prop of $01d1ecae77899d22$var$__getOwnPropSymbols(b))if ($01d1ecae77899d22$var$__propIsEnum.call(b, prop)) $01d1ecae77899d22$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $01d1ecae77899d22$var$__spreadProps = (a, b)=>$01d1ecae77899d22$var$__defProps(a, $01d1ecae77899d22$var$__getOwnPropDescs(b));
function $01d1ecae77899d22$export$4f8c9e9a340d2335(props) {
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $01d1ecae77899d22$var$__spreadProps($01d1ecae77899d22$var$__spreadValues({}, props), {
        "data-avatar-placeholder-icon": true,
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0.877014 7.49988C0.877014 3.84219 3.84216 0.877045 7.49985 0.877045C11.1575 0.877045 14.1227 3.84219 14.1227 7.49988C14.1227 11.1575 11.1575 14.1227 7.49985 14.1227C3.84216 14.1227 0.877014 11.1575 0.877014 7.49988ZM7.49985 1.82704C4.36683 1.82704 1.82701 4.36686 1.82701 7.49988C1.82701 8.97196 2.38774 10.3131 3.30727 11.3213C4.19074 9.94119 5.73818 9.02499 7.50023 9.02499C9.26206 9.02499 10.8093 9.94097 11.6929 11.3208C12.6121 10.3127 13.1727 8.97172 13.1727 7.49988C13.1727 4.36686 10.6328 1.82704 7.49985 1.82704ZM10.9818 11.9787C10.2839 10.7795 8.9857 9.97499 7.50023 9.97499C6.01458 9.97499 4.71624 10.7797 4.01845 11.9791C4.97952 12.7272 6.18765 13.1727 7.49985 13.1727C8.81227 13.1727 10.0206 12.727 10.9818 11.9787ZM5.14999 6.50487C5.14999 5.207 6.20212 4.15487 7.49999 4.15487C8.79786 4.15487 9.84999 5.207 9.84999 6.50487C9.84999 7.80274 8.79786 8.85487 7.49999 8.85487C6.20212 8.85487 5.14999 7.80274 5.14999 6.50487ZM7.49999 5.10487C6.72679 5.10487 6.09999 5.73167 6.09999 6.50487C6.09999 7.27807 6.72679 7.90487 7.49999 7.90487C8.27319 7.90487 8.89999 7.27807 8.89999 6.50487C8.89999 5.73167 8.27319 5.10487 7.49999 5.10487Z",
        fill: "currentColor",
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
}









"use client";
var $1c1d4661523e5510$var$__defProp = Object.defineProperty;
var $1c1d4661523e5510$var$__defProps = Object.defineProperties;
var $1c1d4661523e5510$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $1c1d4661523e5510$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $1c1d4661523e5510$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $1c1d4661523e5510$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $1c1d4661523e5510$var$__defNormalProp = (obj, key, value)=>key in obj ? $1c1d4661523e5510$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $1c1d4661523e5510$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($1c1d4661523e5510$var$__hasOwnProp.call(b, prop)) $1c1d4661523e5510$var$__defNormalProp(a, prop, b[prop]);
    if ($1c1d4661523e5510$var$__getOwnPropSymbols) {
        for (var prop of $1c1d4661523e5510$var$__getOwnPropSymbols(b))if ($1c1d4661523e5510$var$__propIsEnum.call(b, prop)) $1c1d4661523e5510$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $1c1d4661523e5510$var$__spreadProps = (a, b)=>$1c1d4661523e5510$var$__defProps(a, $1c1d4661523e5510$var$__getOwnPropDescs(b));
var $1c1d4661523e5510$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($1c1d4661523e5510$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $1c1d4661523e5510$var$__getOwnPropSymbols) {
        for (var prop of $1c1d4661523e5510$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $1c1d4661523e5510$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $1c1d4661523e5510$var$defaultProps = {};
const $1c1d4661523e5510$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((theme, { size: size, radius: radius, variant: variant, gradient: gradient, color: color })=>{
    const colors = theme.variantColorResolver({
        color: color || "gray",
        theme: theme,
        gradient: gradient,
        variant: variant || "light"
    });
    return {
        root: {
            "--avatar-size": (0, $fcab4af601ce7e99$export$31b21d0167753bb4)(size, "avatar-size"),
            "--avatar-radius": radius === void 0 ? void 0 : (0, $fcab4af601ce7e99$export$35724d9c2979edc5)(radius),
            "--avatar-bg": color || variant ? colors.background : void 0,
            "--avatar-color": color || variant ? colors.color : void 0,
            "--avatar-bd": color || variant ? colors.border : void 0
        }
    };
});
const $1c1d4661523e5510$export$e2255cf6045e8d47 = (0, $dfead8eb7283bc39$export$197bdd704df40a29)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("Avatar", $1c1d4661523e5510$var$defaultProps, _props);
    const _a = props, { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, src: src, alt: alt, radius: radius, color: color, gradient: gradient, imageProps: imageProps, children: children } = _a, others = $1c1d4661523e5510$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "src",
        "alt",
        "radius",
        "color",
        "gradient",
        "imageProps",
        "children"
    ]);
    const ctx = (0, $b04d70519e70cd21$export$df4312aa52e73e7b)();
    const [error, setError] = (0, $acw62.useState)(!src);
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: "Avatar",
        props: props,
        classes: $629e2eeea3181147$export$2e2bcd8739ae039,
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        vars: vars,
        varsResolver: $1c1d4661523e5510$var$varsResolver
    });
    (0, $acw62.useEffect)(()=>setError(!src), [
        src
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $1c1d4661523e5510$var$__spreadValues($1c1d4661523e5510$var$__spreadProps($1c1d4661523e5510$var$__spreadValues({}, getStyles("root")), {
        mod: {
            "within-group": ctx.withinGroup
        },
        ref: ref
    }), others), error ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", $1c1d4661523e5510$var$__spreadProps($1c1d4661523e5510$var$__spreadValues({}, getStyles("placeholder")), {
        title: alt
    }), children || /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $01d1ecae77899d22$export$4f8c9e9a340d2335), null)) : /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", $1c1d4661523e5510$var$__spreadProps($1c1d4661523e5510$var$__spreadValues($1c1d4661523e5510$var$__spreadValues({}, imageProps), getStyles("image")), {
        src: src,
        alt: alt,
        onError: (event)=>{
            var _a2;
            setError(true);
            (_a2 = imageProps == null ? void 0 : imageProps.onError) == null || _a2.call(imageProps, event);
        }
    })));
});
$1c1d4661523e5510$export$e2255cf6045e8d47.classes = (0, $629e2eeea3181147$export$2e2bcd8739ae039);
$1c1d4661523e5510$export$e2255cf6045e8d47.displayName = "@mantine/core/Avatar";
$1c1d4661523e5510$export$e2255cf6045e8d47.Group = (0, $e5be6f6f74ee8e60$export$5b26ebaf2b105908);


var $acw62 = parcelRequire("acw62");
"use client";
var $7dbdc4eb4f81fb98$var$classes = {
    "root": "m-fea6bf1a",
    "burger": "m-d4fb9cad"
};
var $7dbdc4eb4f81fb98$export$2e2bcd8739ae039 = $7dbdc4eb4f81fb98$var$classes;










"use client";
var $9ff5b9fe3a78c7ce$var$__defProp = Object.defineProperty;
var $9ff5b9fe3a78c7ce$var$__defProps = Object.defineProperties;
var $9ff5b9fe3a78c7ce$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $9ff5b9fe3a78c7ce$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $9ff5b9fe3a78c7ce$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $9ff5b9fe3a78c7ce$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $9ff5b9fe3a78c7ce$var$__defNormalProp = (obj, key, value)=>key in obj ? $9ff5b9fe3a78c7ce$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $9ff5b9fe3a78c7ce$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($9ff5b9fe3a78c7ce$var$__hasOwnProp.call(b, prop)) $9ff5b9fe3a78c7ce$var$__defNormalProp(a, prop, b[prop]);
    if ($9ff5b9fe3a78c7ce$var$__getOwnPropSymbols) {
        for (var prop of $9ff5b9fe3a78c7ce$var$__getOwnPropSymbols(b))if ($9ff5b9fe3a78c7ce$var$__propIsEnum.call(b, prop)) $9ff5b9fe3a78c7ce$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $9ff5b9fe3a78c7ce$var$__spreadProps = (a, b)=>$9ff5b9fe3a78c7ce$var$__defProps(a, $9ff5b9fe3a78c7ce$var$__getOwnPropDescs(b));
var $9ff5b9fe3a78c7ce$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($9ff5b9fe3a78c7ce$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $9ff5b9fe3a78c7ce$var$__getOwnPropSymbols) {
        for (var prop of $9ff5b9fe3a78c7ce$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $9ff5b9fe3a78c7ce$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $9ff5b9fe3a78c7ce$var$defaultProps = {};
const $9ff5b9fe3a78c7ce$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((theme, { color: color, size: size, transitionDuration: transitionDuration, transitionTimingFunction: transitionTimingFunction })=>({
        root: {
            "--burger-color": color ? (0, $0a9c57cec2a3e373$export$e22c5d06d177c3fa)(color, theme) : void 0,
            "--burger-size": (0, $fcab4af601ce7e99$export$31b21d0167753bb4)(size, "burger-size"),
            "--burger-transition-duration": transitionDuration === void 0 ? void 0 : `${transitionDuration}ms`,
            "--burger-transition-timing-function": transitionTimingFunction
        }
    }));
const $9ff5b9fe3a78c7ce$export$3990fdb7137d85ae = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("Burger", $9ff5b9fe3a78c7ce$var$defaultProps, _props);
    const _a = props, { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, opened: opened, children: children, transitionDuration: transitionDuration, transitionTimingFunction: transitionTimingFunction } = _a, others = $9ff5b9fe3a78c7ce$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "opened",
        "children",
        "transitionDuration",
        "transitionTimingFunction"
    ]);
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: "Burger",
        classes: $7dbdc4eb4f81fb98$export$2e2bcd8739ae039,
        props: props,
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        vars: vars,
        varsResolver: $9ff5b9fe3a78c7ce$var$varsResolver
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b9babe59f8fa61e8$export$3167f6ecaaaa3457), $9ff5b9fe3a78c7ce$var$__spreadValues($9ff5b9fe3a78c7ce$var$__spreadProps($9ff5b9fe3a78c7ce$var$__spreadValues({}, getStyles("root")), {
        ref: ref
    }), others), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $9ff5b9fe3a78c7ce$var$__spreadValues({
        mod: [
            "reduce-motion",
            {
                opened: opened
            }
        ]
    }, getStyles("burger"))), children);
});
$9ff5b9fe3a78c7ce$export$3990fdb7137d85ae.classes = (0, $7dbdc4eb4f81fb98$export$2e2bcd8739ae039);
$9ff5b9fe3a78c7ce$export$3990fdb7137d85ae.displayName = "@mantine/core/Burger";


var $acw62 = parcelRequire("acw62");
"use client";
var $d673717bc5724c9d$var$classes = {
    "root": "m-9e117634"
};
var $d673717bc5724c9d$export$2e2bcd8739ae039 = $d673717bc5724c9d$var$classes;








"use client";
var $95f3644217e6673d$var$__defProp = Object.defineProperty;
var $95f3644217e6673d$var$__defProps = Object.defineProperties;
var $95f3644217e6673d$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $95f3644217e6673d$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $95f3644217e6673d$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $95f3644217e6673d$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $95f3644217e6673d$var$__defNormalProp = (obj, key, value)=>key in obj ? $95f3644217e6673d$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $95f3644217e6673d$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($95f3644217e6673d$var$__hasOwnProp.call(b, prop)) $95f3644217e6673d$var$__defNormalProp(a, prop, b[prop]);
    if ($95f3644217e6673d$var$__getOwnPropSymbols) {
        for (var prop of $95f3644217e6673d$var$__getOwnPropSymbols(b))if ($95f3644217e6673d$var$__propIsEnum.call(b, prop)) $95f3644217e6673d$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $95f3644217e6673d$var$__spreadProps = (a, b)=>$95f3644217e6673d$var$__defProps(a, $95f3644217e6673d$var$__getOwnPropDescs(b));
var $95f3644217e6673d$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($95f3644217e6673d$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $95f3644217e6673d$var$__getOwnPropSymbols) {
        for (var prop of $95f3644217e6673d$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $95f3644217e6673d$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $95f3644217e6673d$var$defaultProps = {};
const $95f3644217e6673d$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((_, { radius: radius, fit: fit })=>({
        root: {
            "--image-radius": radius === void 0 ? void 0 : (0, $fcab4af601ce7e99$export$35724d9c2979edc5)(radius),
            "--image-object-fit": fit
        }
    }));
const $95f3644217e6673d$export$3e431a229df88919 = (0, $dfead8eb7283bc39$export$197bdd704df40a29)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("Image", $95f3644217e6673d$var$defaultProps, _props);
    const _a = props, { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, onError: onError, src: src, radius: radius, fit: fit, fallbackSrc: fallbackSrc } = _a, others = $95f3644217e6673d$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "onError",
        "src",
        "radius",
        "fit",
        "fallbackSrc"
    ]);
    const [error, setError] = (0, $acw62.useState)(!src);
    (0, $acw62.useEffect)(()=>setError(!src), [
        src
    ]);
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: "Image",
        classes: $d673717bc5724c9d$export$2e2bcd8739ae039,
        props: props,
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        vars: vars,
        varsResolver: $95f3644217e6673d$var$varsResolver
    });
    if (error && fallbackSrc) return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $95f3644217e6673d$var$__spreadValues($95f3644217e6673d$var$__spreadProps($95f3644217e6673d$var$__spreadValues({
        component: "img",
        src: fallbackSrc
    }, getStyles("root")), {
        onError: onError,
        mod: "fallback"
    }), others));
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $95f3644217e6673d$var$__spreadValues($95f3644217e6673d$var$__spreadProps($95f3644217e6673d$var$__spreadValues({
        component: "img",
        ref: ref
    }, getStyles("root")), {
        src: src,
        onError: (event)=>{
            onError == null || onError(event);
            setError(true);
        }
    }), others));
});
$95f3644217e6673d$export$3e431a229df88919.classes = (0, $d673717bc5724c9d$export$2e2bcd8739ae039);
$95f3644217e6673d$export$3e431a229df88919.displayName = "@mantine/core/Image";


var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
"use client";
var $a9cf29074e66a7d4$var$classes = {
    "dropdown": "m-dc9b7c9f",
    "label": "m-9bfac126",
    "divider": "m-efdf90cb",
    "item": "m-99ac2aa1",
    "itemLabel": "m-5476e0d3",
    "itemSection": "m-8b75e504"
};
var $a9cf29074e66a7d4$export$2e2bcd8739ae039 = $a9cf29074e66a7d4$var$classes;



"use client";
const [$1a88617e76f04480$export$2cad3fd48ac06579, $1a88617e76f04480$export$21c7ab35b39f78ec] = (0, $0bf9cc213b4abd2e$export$97d0e477aacf9b7d)("Menu component was not found in the tree");





"use client";
var $0e186a6eac2a78c1$var$__defProp = Object.defineProperty;
var $0e186a6eac2a78c1$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $0e186a6eac2a78c1$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $0e186a6eac2a78c1$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $0e186a6eac2a78c1$var$__defNormalProp = (obj, key, value)=>key in obj ? $0e186a6eac2a78c1$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $0e186a6eac2a78c1$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($0e186a6eac2a78c1$var$__hasOwnProp.call(b, prop)) $0e186a6eac2a78c1$var$__defNormalProp(a, prop, b[prop]);
    if ($0e186a6eac2a78c1$var$__getOwnPropSymbols) {
        for (var prop of $0e186a6eac2a78c1$var$__getOwnPropSymbols(b))if ($0e186a6eac2a78c1$var$__propIsEnum.call(b, prop)) $0e186a6eac2a78c1$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $0e186a6eac2a78c1$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($0e186a6eac2a78c1$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $0e186a6eac2a78c1$var$__getOwnPropSymbols) {
        for (var prop of $0e186a6eac2a78c1$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $0e186a6eac2a78c1$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $0e186a6eac2a78c1$var$defaultProps = {};
const $0e186a6eac2a78c1$export$acb07b4664ac227c = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((props, ref)=>{
    const _a = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("MenuDivider", $0e186a6eac2a78c1$var$defaultProps, props), { classNames: classNames, className: className, style: style, styles: styles, vars: vars } = _a, others = $0e186a6eac2a78c1$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars"
    ]);
    const ctx = (0, $1a88617e76f04480$export$21c7ab35b39f78ec)();
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $0e186a6eac2a78c1$var$__spreadValues($0e186a6eac2a78c1$var$__spreadValues({
        ref: ref
    }, ctx.getStyles("divider", {
        className: className,
        style: style,
        styles: styles,
        classNames: classNames
    })), others));
});
$0e186a6eac2a78c1$export$acb07b4664ac227c.classes = (0, $a9cf29074e66a7d4$export$2e2bcd8739ae039);
$0e186a6eac2a78c1$export$acb07b4664ac227c.displayName = "@mantine/core/MenuDivider";



var $acw62 = parcelRequire("acw62");






"use client";
var $f3829f8ad9101183$var$__defProp = Object.defineProperty;
var $f3829f8ad9101183$var$__defProps = Object.defineProperties;
var $f3829f8ad9101183$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $f3829f8ad9101183$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $f3829f8ad9101183$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $f3829f8ad9101183$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $f3829f8ad9101183$var$__defNormalProp = (obj, key, value)=>key in obj ? $f3829f8ad9101183$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $f3829f8ad9101183$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($f3829f8ad9101183$var$__hasOwnProp.call(b, prop)) $f3829f8ad9101183$var$__defNormalProp(a, prop, b[prop]);
    if ($f3829f8ad9101183$var$__getOwnPropSymbols) {
        for (var prop of $f3829f8ad9101183$var$__getOwnPropSymbols(b))if ($f3829f8ad9101183$var$__propIsEnum.call(b, prop)) $f3829f8ad9101183$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $f3829f8ad9101183$var$__spreadProps = (a, b)=>$f3829f8ad9101183$var$__defProps(a, $f3829f8ad9101183$var$__getOwnPropDescs(b));
var $f3829f8ad9101183$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($f3829f8ad9101183$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $f3829f8ad9101183$var$__getOwnPropSymbols) {
        for (var prop of $f3829f8ad9101183$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $f3829f8ad9101183$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $f3829f8ad9101183$var$defaultProps = {};
const $f3829f8ad9101183$export$c7794ca2de686af4 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((props, ref)=>{
    const _a = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("MenuDropdown", $f3829f8ad9101183$var$defaultProps, props), { classNames: classNames, className: className, style: style, styles: styles, vars: vars, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, children: children } = _a, others = $f3829f8ad9101183$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars",
        "onMouseEnter",
        "onMouseLeave",
        "children"
    ]);
    const wrapperRef = (0, $acw62.useRef)(null);
    const ctx = (0, $1a88617e76f04480$export$21c7ab35b39f78ec)();
    const handleKeyDown = (event)=>{
        var _a2, _b;
        if (event.key === "ArrowUp" || event.key === "ArrowDown") {
            event.preventDefault();
            (_b = (_a2 = wrapperRef.current) == null ? void 0 : _a2.querySelectorAll("[data-menu-item]:not(:disabled)")[0]) == null || _b.focus();
        }
    };
    const handleMouseEnter = (0, $528465f85c56cc6b$export$48d1ea6320830260)(onMouseEnter, ()=>ctx.trigger === "hover" && ctx.openDropdown());
    const handleMouseLeave = (0, $528465f85c56cc6b$export$48d1ea6320830260)(onMouseLeave, ()=>ctx.trigger === "hover" && ctx.closeDropdown());
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c321a5e1b48bbbf$export$5b6b19405a83ff9d).Dropdown, $f3829f8ad9101183$var$__spreadValues($f3829f8ad9101183$var$__spreadProps($f3829f8ad9101183$var$__spreadValues({}, others), {
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        role: "menu",
        "aria-orientation": "vertical",
        ref: ref
    }), ctx.getStyles("dropdown", {
        className: className,
        style: style,
        styles: styles,
        classNames: classNames
    })), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        tabIndex: -1,
        "data-menu-dropdown": true,
        "data-autofocus": true,
        onKeyDown: handleKeyDown,
        ref: wrapperRef,
        style: {
            outline: 0
        }
    }, children));
});
$f3829f8ad9101183$export$c7794ca2de686af4.classes = (0, $a9cf29074e66a7d4$export$2e2bcd8739ae039);
$f3829f8ad9101183$export$c7794ca2de686af4.displayName = "@mantine/core/MenuDropdown";



var $acw62 = parcelRequire("acw62");










"use client";
var $a0cdadc3699aa402$var$__defProp = Object.defineProperty;
var $a0cdadc3699aa402$var$__defProps = Object.defineProperties;
var $a0cdadc3699aa402$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $a0cdadc3699aa402$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $a0cdadc3699aa402$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $a0cdadc3699aa402$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $a0cdadc3699aa402$var$__defNormalProp = (obj, key, value)=>key in obj ? $a0cdadc3699aa402$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $a0cdadc3699aa402$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($a0cdadc3699aa402$var$__hasOwnProp.call(b, prop)) $a0cdadc3699aa402$var$__defNormalProp(a, prop, b[prop]);
    if ($a0cdadc3699aa402$var$__getOwnPropSymbols) {
        for (var prop of $a0cdadc3699aa402$var$__getOwnPropSymbols(b))if ($a0cdadc3699aa402$var$__propIsEnum.call(b, prop)) $a0cdadc3699aa402$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $a0cdadc3699aa402$var$__spreadProps = (a, b)=>$a0cdadc3699aa402$var$__defProps(a, $a0cdadc3699aa402$var$__getOwnPropDescs(b));
var $a0cdadc3699aa402$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($a0cdadc3699aa402$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $a0cdadc3699aa402$var$__getOwnPropSymbols) {
        for (var prop of $a0cdadc3699aa402$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $a0cdadc3699aa402$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $a0cdadc3699aa402$var$defaultProps = {};
const $a0cdadc3699aa402$export$2ce376c2cc3355c8 = (0, $dfead8eb7283bc39$export$197bdd704df40a29)((props, ref)=>{
    const _a = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("MenuItem", $a0cdadc3699aa402$var$defaultProps, props), { classNames: classNames, className: className, style: style, styles: styles, vars: vars, color: color, closeMenuOnClick: closeMenuOnClick, leftSection: leftSection, rightSection: rightSection, children: children, disabled: disabled } = _a, others = $a0cdadc3699aa402$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars",
        "color",
        "closeMenuOnClick",
        "leftSection",
        "rightSection",
        "children",
        "disabled"
    ]);
    const ctx = (0, $1a88617e76f04480$export$21c7ab35b39f78ec)();
    const theme = (0, $692af3391f7b0a55$export$5eb0e84f6418b457)();
    const { dir: dir } = (0, $35c57ac18e24a61d$export$b39126d51d94e6f3)();
    const itemRef = (0, $acw62.useRef)();
    const itemIndex = ctx.getItemIndex(itemRef.current);
    const _others = others;
    const handleMouseLeave = (0, $528465f85c56cc6b$export$48d1ea6320830260)(_others.onMouseLeave, ()=>ctx.setHovered(-1));
    const handleMouseEnter = (0, $528465f85c56cc6b$export$48d1ea6320830260)(_others.onMouseEnter, ()=>ctx.setHovered(ctx.getItemIndex(itemRef.current)));
    const handleClick = (0, $528465f85c56cc6b$export$48d1ea6320830260)(_others.onClick, ()=>{
        if (typeof closeMenuOnClick === "boolean") closeMenuOnClick && ctx.closeDropdownImmediately();
        else ctx.closeOnItemClick && ctx.closeDropdownImmediately();
    });
    const handleFocus = (0, $528465f85c56cc6b$export$48d1ea6320830260)(_others.onFocus, ()=>ctx.setHovered(ctx.getItemIndex(itemRef.current)));
    const colors = color ? theme.variantColorResolver({
        color: color,
        theme: theme,
        variant: "light"
    }) : void 0;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b9babe59f8fa61e8$export$3167f6ecaaaa3457), $a0cdadc3699aa402$var$__spreadProps($a0cdadc3699aa402$var$__spreadValues($a0cdadc3699aa402$var$__spreadProps($a0cdadc3699aa402$var$__spreadValues({}, others), {
        unstyled: ctx.unstyled,
        tabIndex: -1,
        onFocus: handleFocus
    }), ctx.getStyles("item", {
        className: className,
        style: style,
        styles: styles,
        classNames: classNames
    })), {
        ref: (0, $7034a45159125c0b$export$36a55fa7500f01f)(itemRef, ref),
        role: "menuitem",
        disabled: disabled,
        "data-menu-item": true,
        "data-disabled": disabled || void 0,
        "data-hovered": ctx.hovered === itemIndex ? true : void 0,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onClick: handleClick,
        onKeyDown: (0, $afa38183edceda99$export$5b1acc7188190893)({
            siblingSelector: "[data-menu-item]",
            parentSelector: "[data-menu-dropdown]",
            activateOnFocus: false,
            loop: ctx.loop,
            dir: dir,
            orientation: "vertical",
            onKeyDown: _others.onKeydown
        }),
        __vars: {
            "--menu-item-color": colors == null ? void 0 : colors.color,
            "--menu-item-hover": colors == null ? void 0 : colors.hover
        }
    }), leftSection && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $a0cdadc3699aa402$var$__spreadProps($a0cdadc3699aa402$var$__spreadValues({}, ctx.getStyles("itemSection", {
        styles: styles,
        classNames: classNames
    })), {
        "data-position": "left"
    }), leftSection), children && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $a0cdadc3699aa402$var$__spreadValues({}, ctx.getStyles("itemLabel", {
        styles: styles,
        classNames: classNames
    })), children), rightSection && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $a0cdadc3699aa402$var$__spreadProps($a0cdadc3699aa402$var$__spreadValues({}, ctx.getStyles("itemSection", {
        styles: styles,
        classNames: classNames
    })), {
        "data-position": "right"
    }), rightSection));
});
$a0cdadc3699aa402$export$2ce376c2cc3355c8.classes = (0, $a9cf29074e66a7d4$export$2e2bcd8739ae039);
$a0cdadc3699aa402$export$2ce376c2cc3355c8.displayName = "@mantine/core/MenuItem";



var $acw62 = parcelRequire("acw62");





"use client";
var $4b566499fd345957$var$__defProp = Object.defineProperty;
var $4b566499fd345957$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $4b566499fd345957$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $4b566499fd345957$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $4b566499fd345957$var$__defNormalProp = (obj, key, value)=>key in obj ? $4b566499fd345957$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $4b566499fd345957$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($4b566499fd345957$var$__hasOwnProp.call(b, prop)) $4b566499fd345957$var$__defNormalProp(a, prop, b[prop]);
    if ($4b566499fd345957$var$__getOwnPropSymbols) {
        for (var prop of $4b566499fd345957$var$__getOwnPropSymbols(b))if ($4b566499fd345957$var$__propIsEnum.call(b, prop)) $4b566499fd345957$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $4b566499fd345957$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($4b566499fd345957$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $4b566499fd345957$var$__getOwnPropSymbols) {
        for (var prop of $4b566499fd345957$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $4b566499fd345957$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $4b566499fd345957$var$defaultProps = {};
const $4b566499fd345957$export$dd37bec0e8a99143 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((props, ref)=>{
    const _a = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("MenuLabel", $4b566499fd345957$var$defaultProps, props), { classNames: classNames, className: className, style: style, styles: styles, vars: vars } = _a, others = $4b566499fd345957$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars"
    ]);
    const ctx = (0, $1a88617e76f04480$export$21c7ab35b39f78ec)();
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $4b566499fd345957$var$__spreadValues($4b566499fd345957$var$__spreadValues({
        ref: ref
    }, ctx.getStyles("label", {
        className: className,
        style: style,
        styles: styles,
        classNames: classNames
    })), others));
});
$4b566499fd345957$export$dd37bec0e8a99143.classes = (0, $a9cf29074e66a7d4$export$2e2bcd8739ae039);
$4b566499fd345957$export$dd37bec0e8a99143.displayName = "@mantine/core/MenuLabel";



var $acw62 = parcelRequire("acw62");





"use client";
var $7f217aaf04b867eb$var$__defProp = Object.defineProperty;
var $7f217aaf04b867eb$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $7f217aaf04b867eb$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $7f217aaf04b867eb$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $7f217aaf04b867eb$var$__defNormalProp = (obj, key, value)=>key in obj ? $7f217aaf04b867eb$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $7f217aaf04b867eb$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($7f217aaf04b867eb$var$__hasOwnProp.call(b, prop)) $7f217aaf04b867eb$var$__defNormalProp(a, prop, b[prop]);
    if ($7f217aaf04b867eb$var$__getOwnPropSymbols) {
        for (var prop of $7f217aaf04b867eb$var$__getOwnPropSymbols(b))if ($7f217aaf04b867eb$var$__propIsEnum.call(b, prop)) $7f217aaf04b867eb$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $7f217aaf04b867eb$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($7f217aaf04b867eb$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $7f217aaf04b867eb$var$__getOwnPropSymbols) {
        for (var prop of $7f217aaf04b867eb$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $7f217aaf04b867eb$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $7f217aaf04b867eb$var$defaultProps = {
    refProp: "ref"
};
const $7f217aaf04b867eb$export$4907565bcbceec95 = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("MenuTarget", $7f217aaf04b867eb$var$defaultProps, props), { children: children, refProp: refProp } = _a, others = $7f217aaf04b867eb$var$__objRest(_a, [
        "children",
        "refProp"
    ]);
    if (!(0, $65b68cae0fe4eb32$export$45a5e7f76e0caa8d)(children)) throw new Error("Menu.Target component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported");
    const ctx = (0, $1a88617e76f04480$export$21c7ab35b39f78ec)();
    const onClick = (0, $528465f85c56cc6b$export$48d1ea6320830260)(children.props.onClick, ()=>ctx.trigger === "click" && ctx.toggleDropdown());
    const onMouseEnter = (0, $528465f85c56cc6b$export$48d1ea6320830260)(children.props.onMouseEnter, ()=>ctx.trigger === "hover" && ctx.openDropdown());
    const onMouseLeave = (0, $528465f85c56cc6b$export$48d1ea6320830260)(children.props.onMouseLeave, ()=>ctx.trigger === "hover" && ctx.closeDropdown());
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c321a5e1b48bbbf$export$5b6b19405a83ff9d).Target, $7f217aaf04b867eb$var$__spreadValues({
        refProp: refProp,
        popupType: "menu",
        ref: ref
    }, others), (0, $acw62.cloneElement)(children, {
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        "data-expanded": ctx.opened ? true : void 0
    }));
});
$7f217aaf04b867eb$export$4907565bcbceec95.displayName = "@mantine/core/MenuTarget";





var $acw62 = parcelRequire("acw62");
"use client";
function $6c2e5d849f4cd364$export$727aed1917ab7924() {
    const [hovered, setHovered] = (0, $acw62.useState)(-1);
    const resetHovered = ()=>setHovered(-1);
    return [
        hovered,
        {
            setHovered: setHovered,
            resetHovered: resetHovered
        }
    ];
}



var $acw62 = parcelRequire("acw62");
"use client";
function $820ef30e73af04c7$export$7771a820816ce7f1({ open: open, close: close, openDelay: openDelay, closeDelay: closeDelay }) {
    const openTimeout = (0, $acw62.useRef)(-1);
    const closeTimeout = (0, $acw62.useRef)(-1);
    const clearTimeouts = ()=>{
        window.clearTimeout(openTimeout.current);
        window.clearTimeout(closeTimeout.current);
    };
    const openDropdown = ()=>{
        clearTimeouts();
        if (openDelay === 0 || openDelay === void 0) open();
        else openTimeout.current = window.setTimeout(open, openDelay);
    };
    const closeDropdown = ()=>{
        clearTimeouts();
        if (closeDelay === 0 || closeDelay === void 0) close();
        else closeTimeout.current = window.setTimeout(close, closeDelay);
    };
    (0, $acw62.useEffect)(()=>clearTimeouts, []);
    return {
        openDropdown: openDropdown,
        closeDropdown: closeDropdown
    };
}




"use client";
function $ec739097b6605e9b$export$b6cd2ea9779a9a9a(elementSelector, parentSelector, node) {
    var _a;
    if (!node) return null;
    return Array.from(((_a = (0, $2c8b9d23474a2600$export$3d0f3f5781bcdc48)(node, parentSelector)) == null ? void 0 : _a.querySelectorAll(elementSelector)) || []).findIndex((element)=>element === node);
}





"use client";
var $80a28427109ce9ef$var$__defProp = Object.defineProperty;
var $80a28427109ce9ef$var$__defProps = Object.defineProperties;
var $80a28427109ce9ef$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $80a28427109ce9ef$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $80a28427109ce9ef$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $80a28427109ce9ef$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $80a28427109ce9ef$var$__defNormalProp = (obj, key, value)=>key in obj ? $80a28427109ce9ef$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $80a28427109ce9ef$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($80a28427109ce9ef$var$__hasOwnProp.call(b, prop)) $80a28427109ce9ef$var$__defNormalProp(a, prop, b[prop]);
    if ($80a28427109ce9ef$var$__getOwnPropSymbols) {
        for (var prop of $80a28427109ce9ef$var$__getOwnPropSymbols(b))if ($80a28427109ce9ef$var$__propIsEnum.call(b, prop)) $80a28427109ce9ef$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $80a28427109ce9ef$var$__spreadProps = (a, b)=>$80a28427109ce9ef$var$__defProps(a, $80a28427109ce9ef$var$__getOwnPropDescs(b));
var $80a28427109ce9ef$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($80a28427109ce9ef$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $80a28427109ce9ef$var$__getOwnPropSymbols) {
        for (var prop of $80a28427109ce9ef$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $80a28427109ce9ef$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $80a28427109ce9ef$var$defaultProps = {
    closeOnItemClick: true,
    loop: true,
    trigger: "click",
    openDelay: 0,
    closeDelay: 100
};
function $80a28427109ce9ef$export$d9b273488cd8ce6f(_props) {
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("Menu", $80a28427109ce9ef$var$defaultProps, _props);
    const _a = props, { children: children, onOpen: onOpen, onClose: onClose, opened: opened, defaultOpened: defaultOpened, onChange: onChange, closeOnItemClick: closeOnItemClick, loop: loop, closeOnEscape: closeOnEscape, trigger: trigger, openDelay: openDelay, closeDelay: closeDelay, classNames: classNames, styles: styles, unstyled: unstyled, variant: variant, vars: vars } = _a, others = $80a28427109ce9ef$var$__objRest(_a, [
        "children",
        "onOpen",
        "onClose",
        "opened",
        "defaultOpened",
        "onChange",
        "closeOnItemClick",
        "loop",
        "closeOnEscape",
        "trigger",
        "openDelay",
        "closeDelay",
        "classNames",
        "styles",
        "unstyled",
        "variant",
        "vars"
    ]);
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: "Menu",
        classes: $a9cf29074e66a7d4$export$2e2bcd8739ae039,
        props: props,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled
    });
    const [hovered, { setHovered: setHovered, resetHovered: resetHovered }] = (0, $6c2e5d849f4cd364$export$727aed1917ab7924)();
    const [_opened, setOpened] = (0, $4197894a742d9f84$export$ec55e9daaf703a7d)({
        value: opened,
        defaultValue: defaultOpened,
        finalValue: false,
        onChange: onChange
    });
    const close = ()=>{
        setOpened(false);
        _opened && (onClose == null || onClose());
    };
    const open = ()=>{
        setOpened(true);
        !_opened && (onOpen == null || onOpen());
    };
    const toggleDropdown = ()=>{
        _opened ? close() : open();
    };
    const { openDropdown: openDropdown, closeDropdown: closeDropdown } = (0, $820ef30e73af04c7$export$7771a820816ce7f1)({
        open: open,
        close: close,
        closeDelay: closeDelay,
        openDelay: openDelay
    });
    const getItemIndex = (node)=>(0, $ec739097b6605e9b$export$b6cd2ea9779a9a9a)("[data-menu-item]", "[data-menu-dropdown]", node);
    const { resolvedClassNames: resolvedClassNames, resolvedStyles: resolvedStyles } = (0, $3da94ce37793f66c$export$92dc9b0c0bd35ec0)({
        classNames: classNames,
        styles: styles,
        props: props
    });
    (0, $d9273517323905a9$export$e34ed88fef4dc107)(()=>{
        resetHovered();
    }, [
        _opened
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1a88617e76f04480$export$2cad3fd48ac06579), {
        value: {
            getStyles: getStyles,
            opened: _opened,
            toggleDropdown: toggleDropdown,
            getItemIndex: getItemIndex,
            hovered: hovered,
            setHovered: setHovered,
            closeOnItemClick: closeOnItemClick,
            closeDropdown: trigger === "click" ? close : closeDropdown,
            openDropdown: trigger === "click" ? open : openDropdown,
            closeDropdownImmediately: close,
            loop: loop,
            trigger: trigger,
            unstyled: unstyled
        }
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c321a5e1b48bbbf$export$5b6b19405a83ff9d), $80a28427109ce9ef$var$__spreadProps($80a28427109ce9ef$var$__spreadValues({}, others), {
        opened: _opened,
        onChange: toggleDropdown,
        defaultOpened: defaultOpened,
        trapFocus: trigger === "click",
        closeOnEscape: closeOnEscape && trigger === "click",
        __staticSelector: "Menu",
        classNames: resolvedClassNames,
        styles: resolvedStyles,
        unstyled: unstyled,
        variant: variant
    }), children));
}
$80a28427109ce9ef$export$d9b273488cd8ce6f.extend = (input)=>input;
$80a28427109ce9ef$export$d9b273488cd8ce6f.classes = (0, $a9cf29074e66a7d4$export$2e2bcd8739ae039);
$80a28427109ce9ef$export$d9b273488cd8ce6f.displayName = "@mantine/core/Menu";
$80a28427109ce9ef$export$d9b273488cd8ce6f.Item = (0, $a0cdadc3699aa402$export$2ce376c2cc3355c8);
$80a28427109ce9ef$export$d9b273488cd8ce6f.Label = (0, $4b566499fd345957$export$dd37bec0e8a99143);
$80a28427109ce9ef$export$d9b273488cd8ce6f.Dropdown = (0, $f3829f8ad9101183$export$c7794ca2de686af4);
$80a28427109ce9ef$export$d9b273488cd8ce6f.Target = (0, $7f217aaf04b867eb$export$4907565bcbceec95);
$80a28427109ce9ef$export$d9b273488cd8ce6f.Divider = (0, $0e186a6eac2a78c1$export$acb07b4664ac227c);



var $acw62 = parcelRequire("acw62");
var $905e4315ff26cf28$exports = {};
$905e4315ff26cf28$exports = new URL("Logo_Consili18.b355edea.svg", import.meta.url).toString();


/**
 * @tabler/icons-react v2.42.0 - MIT
 */ 
var $b65b8f0c565e6a2a$export$2e2bcd8739ae039 = (0, $a86819fe50d185cb$export$2e2bcd8739ae039)("logout-2", "IconLogout2", [
    [
        "path",
        {
            d: "M10 8v-2a2 2 0 0 1 2 -2h7a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-7a2 2 0 0 1 -2 -2v-2",
            key: "svg-0"
        }
    ],
    [
        "path",
        {
            d: "M15 12h-12l3 -3",
            key: "svg-1"
        }
    ],
    [
        "path",
        {
            d: "M6 15l-3 -3",
            key: "svg-2"
        }
    ]
]);

/**
 * @tabler/icons-react v2.42.0 - MIT
 */ 
var $49d94d9b99e66094$export$2e2bcd8739ae039 = (0, $a86819fe50d185cb$export$2e2bcd8739ae039)("settings", "IconSettings", [
    [
        "path",
        {
            d: "M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z",
            key: "svg-0"
        }
    ],
    [
        "path",
        {
            d: "M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0",
            key: "svg-1"
        }
    ]
]);







const $e9bd92b954fbb741$var$Header = ({ user: user, mobileOpened: mobileOpened, toggleMobile: toggleMobile })=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const [getLogout] = (0, $1861b69a0d0c7fdf$export$c83e688d5b02651d)();
    const [isModalOpen, setIsModalOpen] = (0, $acw62.useState)(false);
    const [value, setValue] = (0, $acw62.useState)("All insights");
    const [analysisNotifications, setAnalysisNotifications] = (0, $acw62.useState)([]);
    const [updateUserSettings] = (0, $1861b69a0d0c7fdf$export$a732e0a2c1f828ff)();
    const { data: constantsData, isLoading: isConstantsLoading } = (0, $1861b69a0d0c7fdf$export$f662a937f042d11d)();
    const { data: settingsData, isLoading: isSettingsLoading } = (0, $1861b69a0d0c7fdf$export$875924c4a7bff0b2)();
    const handleSignOut = ()=>{
        getLogout();
        dispatch((0, $0990d2137b3e0830$export$bcc8035e549759b4).util.resetApiState());
        navigate("/login");
        window.scrollTo(0, 0);
    };
    const data = user?.data;
    const regexPattern = /([a-zA-Z]).*?([a-zA-Z])/;
    (0, $acw62.useEffect)(()=>{
        setValue(constantsData?.analysis_notify_type[settingsData?.analysis_notifications] || "All insights");
    }, [
        settingsData,
        isSettingsLoading,
        constantsData,
        isConstantsLoading
    ]);
    (0, $acw62.useEffect)(()=>{
        setAnalysisNotifications(Object.values(constantsData?.analysis_notify_type ?? {}));
    }, [
        constantsData,
        isConstantsLoading
    ]);
    const updateSettings = ()=>{
        updateUserSettings({
            ...user.data[0],
            analysis_notifications: Object.keys(constantsData?.analysis_notify_type ?? {}).find((key)=>constantsData?.analysis_notify_type[key] === value) || "A"
        });
    };
    const getUsername = ()=>{
        if (user.isSuccess) {
            if (user.data?.[0]?.first_name && user.data?.[0]?.last_name) {
                const firstName = data?.[0]?.first_name;
                const lastName = data?.[0]?.last_name;
                const username = `${firstName} ${lastName}`;
                return username;
            } else return user.data?.[0].username;
        }
        return "Unknown User";
    };
    const firstName = data?.[0]?.first_name;
    const lastName = data?.[0]?.last_name;
    const username = firstName && lastName ? `${firstName} ${lastName}` : undefined;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4e00d137aa7b325a$export$f51f4c4ede09e011), {
        h: "100%",
        px: "md",
        align: "center",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ff5b9fe3a78c7ce$export$3990fdb7137d85ae), {
                opened: mobileOpened,
                onClick: toggleMobile,
                hiddenFrom: "sm",
                size: "sm"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $95f3644217e6673d$export$3e431a229df88919), {
                radius: "md",
                w: `calc(200px - ${(0, $7a68b0670ce0ab52$export$c63c6f932822f543)(32)})`,
                ml: "sm",
                fit: "contain",
                padding: "md",
                src: (0, (/*@__PURE__*/$parcel$interopDefault($905e4315ff26cf28$exports)))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
                ml: "auto",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4e00d137aa7b325a$export$f51f4c4ede09e011), {
                    gap: "md",
                    direction: "row",
                    align: "center",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $80a28427109ce9ef$export$d9b273488cd8ce6f), {
                            shadow: "md",
                            width: 200,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $80a28427109ce9ef$export$d9b273488cd8ce6f).Target, {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4), {
                                        style: {
                                            cursor: "pointer"
                                        },
                                        children: [
                                            " ",
                                            user.isSuccess && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                                fw: 500,
                                                size: "sm",
                                                visibleFrom: "sm",
                                                children: username ? username : user?.data[0]?.username
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1c1d4661523e5510$export$e2255cf6045e8d47), {
                                                alt: getUsername(),
                                                email: user?.data?.username,
                                                round: "25px",
                                                size: "md",
                                                children: [
                                                    getUsername().match(regexPattern)[1].toUpperCase(),
                                                    getUsername().match(regexPattern)[2].toUpperCase()
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $80a28427109ce9ef$export$d9b273488cd8ce6f).Dropdown, {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $80a28427109ce9ef$export$d9b273488cd8ce6f).Label, {
                                            children: "Profile"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $80a28427109ce9ef$export$d9b273488cd8ce6f).Item, {
                                            leftSection: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $49d94d9b99e66094$export$2e2bcd8739ae039), {
                                                style: {
                                                    width: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(14),
                                                    height: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(14)
                                                }
                                            }),
                                            onClick: ()=>setIsModalOpen(true),
                                            children: "User Settings"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $80a28427109ce9ef$export$d9b273488cd8ce6f).Item, {
                                            c: "red",
                                            leftSection: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b65b8f0c565e6a2a$export$2e2bcd8739ae039), {
                                                style: {
                                                    width: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(14),
                                                    height: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(14)
                                                }
                                            }),
                                            onClick: handleSignOut,
                                            children: "Sign Out"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $b1b81586258b47fb$export$2b77a92f1a5ad772), {
                            opened: isModalOpen,
                            onClose: ()=>{
                                setIsModalOpen(false);
                                updateSettings();
                            },
                            size: "auto",
                            withCloseButton: false,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4), {
                                    style: {
                                        justifyContent: "space-between",
                                        alignItems: "center"
                                    },
                                    mb: "md",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                            fw: 700,
                                            children: "Settings "
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4), {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                                                onClick: ()=>{
                                                    updateSettings();
                                                    setIsModalOpen(false);
                                                },
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $058c864623b900db$export$2e2bcd8739ae039), {})
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4), {
                                    style: {
                                        justifyContent: "space-between",
                                        alignItems: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                            children: "Analysis Notifications: "
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $339474aa0c55627b$export$ef9b1a59e592288f), {
                                            data: analysisNotifications,
                                            defaultValue: "All insights",
                                            value: value,
                                            onChange: setValue,
                                            allowDeselect: false
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $e9bd92b954fbb741$export$2e2bcd8739ae039 = $e9bd92b954fbb741$var$Header;



var $acw62 = parcelRequire("acw62");

"use client";
var $e8a55004e6e02a3a$var$classes = {
    "root": "m-f0824112",
    "description": "m-57492dcc",
    "section": "m-690090b5",
    "label": "m-1f6ac4c4",
    "body": "m-f07af9d2",
    "children": "m-e17b862f",
    "chevron": "m-1fd8a00b"
};
var $e8a55004e6e02a3a$export$2e2bcd8739ae039 = $e8a55004e6e02a3a$var$classes;











"use client";
var $dd8771267479a0b3$var$__defProp = Object.defineProperty;
var $dd8771267479a0b3$var$__defProps = Object.defineProperties;
var $dd8771267479a0b3$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $dd8771267479a0b3$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $dd8771267479a0b3$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $dd8771267479a0b3$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $dd8771267479a0b3$var$__defNormalProp = (obj, key, value)=>key in obj ? $dd8771267479a0b3$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $dd8771267479a0b3$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($dd8771267479a0b3$var$__hasOwnProp.call(b, prop)) $dd8771267479a0b3$var$__defNormalProp(a, prop, b[prop]);
    if ($dd8771267479a0b3$var$__getOwnPropSymbols) {
        for (var prop of $dd8771267479a0b3$var$__getOwnPropSymbols(b))if ($dd8771267479a0b3$var$__propIsEnum.call(b, prop)) $dd8771267479a0b3$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $dd8771267479a0b3$var$__spreadProps = (a, b)=>$dd8771267479a0b3$var$__defProps(a, $dd8771267479a0b3$var$__getOwnPropDescs(b));
var $dd8771267479a0b3$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($dd8771267479a0b3$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $dd8771267479a0b3$var$__getOwnPropSymbols) {
        for (var prop of $dd8771267479a0b3$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $dd8771267479a0b3$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $dd8771267479a0b3$var$defaultProps = {};
const $dd8771267479a0b3$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((theme, { variant: variant, color: color, childrenOffset: childrenOffset })=>{
    const colors = theme.variantColorResolver({
        color: color || theme.primaryColor,
        theme: theme,
        variant: variant || "light"
    });
    return {
        root: {
            "--nl-bg": color || variant ? colors.background : void 0,
            "--nl-hover": color || variant ? colors.hover : void 0,
            "--nl-color": color || variant ? colors.color : void 0
        },
        children: {
            "--nl-offset": (0, $fcab4af601ce7e99$export$f63796f8a9382bfb)(childrenOffset)
        }
    };
});
const $dd8771267479a0b3$export$b0d92dbee9b5b60d = (0, $dfead8eb7283bc39$export$197bdd704df40a29)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("NavLink", $dd8771267479a0b3$var$defaultProps, _props);
    const _a = props, { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, opened: opened, defaultOpened: defaultOpened, onChange: onChange, children: children, onClick: onClick, active: active, disabled: disabled, leftSection: leftSection, rightSection: rightSection, label: label, description: description, disableRightSectionRotation: disableRightSectionRotation, noWrap: noWrap, childrenOffset: childrenOffset } = _a, others = $dd8771267479a0b3$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "opened",
        "defaultOpened",
        "onChange",
        "children",
        "onClick",
        "active",
        "disabled",
        "leftSection",
        "rightSection",
        "label",
        "description",
        "disableRightSectionRotation",
        "noWrap",
        "childrenOffset"
    ]);
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: "NavLink",
        props: props,
        classes: $e8a55004e6e02a3a$export$2e2bcd8739ae039,
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        vars: vars,
        varsResolver: $dd8771267479a0b3$var$varsResolver
    });
    const [_opened, setOpened] = (0, $4197894a742d9f84$export$ec55e9daaf703a7d)({
        value: opened,
        defaultValue: defaultOpened,
        finalValue: false,
        onChange: onChange
    });
    const withChildren = !!children;
    const handleClick = (event)=>{
        if (withChildren) {
            event.preventDefault();
            onClick == null || onClick(event);
            setOpened(!_opened);
        } else onClick == null || onClick(event);
    };
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b9babe59f8fa61e8$export$3167f6ecaaaa3457), $dd8771267479a0b3$var$__spreadValues($dd8771267479a0b3$var$__spreadProps($dd8771267479a0b3$var$__spreadValues({}, getStyles("root")), {
        component: "a",
        ref: ref,
        onClick: handleClick,
        unstyled: unstyled,
        mod: {
            disabled: disabled,
            active: active,
            expanded: _opened
        }
    }), others), leftSection && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $dd8771267479a0b3$var$__spreadProps($dd8771267479a0b3$var$__spreadValues({
        component: "span"
    }, getStyles("section")), {
        mod: {
            position: "left"
        }
    }), leftSection), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $dd8771267479a0b3$var$__spreadProps($dd8771267479a0b3$var$__spreadValues({}, getStyles("body")), {
        mod: {
            "no-wrap": noWrap
        }
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $dd8771267479a0b3$var$__spreadValues({
        component: "span"
    }, getStyles("label")), label), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $dd8771267479a0b3$var$__spreadValues({
        component: "span",
        mod: {
            active: active
        }
    }, getStyles("description")), description)), (withChildren || rightSection) && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $dd8771267479a0b3$var$__spreadProps($dd8771267479a0b3$var$__spreadValues({}, getStyles("section")), {
        component: "span",
        mod: {
            rotate: _opened && !disableRightSectionRotation,
            position: "right"
        }
    }), withChildren ? rightSection || /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4e38105621a976b3$export$507d1a3a571ba3b7), $dd8771267479a0b3$var$__spreadValues({}, getStyles("chevron"))) : rightSection)), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8f2ec29da821ca87$export$78768a9af065a7b), {
        in: _opened
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $dd8771267479a0b3$var$__spreadValues({}, getStyles("children")), children)));
});
$dd8771267479a0b3$export$b0d92dbee9b5b60d.classes = (0, $e8a55004e6e02a3a$export$2e2bcd8739ae039);
$dd8771267479a0b3$export$b0d92dbee9b5b60d.displayName = "@mantine/core/NavLink";


parcelRequire("acw62");


const $01c485f3d0343c1a$var$SidePanel = ({ handlePanelChange: handlePanelChange, panelNumber: panelNumber, isStaffUser: isStaffUser })=>{
    const panelNames = isStaffUser ? [
        "Discovery",
        "Synthesis",
        "Triggers",
        "Support",
        "Operations"
    ] : [
        "Discovery",
        "Synthesis",
        "Triggers",
        "Support"
    ];
    const buttonProps = {
        fullWidth: true,
        size: "xl",
        variant: "default",
        className: "side-panel-button",
        width: "100%",
        height: "2.8rem"
    };
    const isPanelActive = (num)=>{
        return num === panelNumber;
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: panelNames.map((panelName, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dd8771267479a0b3$export$b0d92dbee9b5b60d), {
                onClick: ()=>handlePanelChange(index),
                leftSection: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                    fw: 500,
                    children: panelName
                }),
                c: isPanelActive(index) ? (0, $7db4b5652a829202$export$bca14c5b3b88a9c9).colors.blue[4] : (0, $7db4b5652a829202$export$bca14c5b3b88a9c9).colors.black[1],
                style: buttonProps,
                active: isPanelActive(index)
            }, index))
    });
};
var $01c485f3d0343c1a$export$2e2bcd8739ae039 = $01c485f3d0343c1a$var$SidePanel;



var $acw62 = parcelRequire("acw62");
var $099aedb85c366131$exports = {};
$099aedb85c366131$exports = new URL("ai-platform-unified-svgrepo-com.c3f55570.svg", import.meta.url).toString();







const $b5949519849ab230$export$935725e5db2ad080 = (0, $0990d2137b3e0830$export$65858239e7ec8811)("getSynthesis", "/synthesis/synthesis/", "GET", [
    "Synthesis"
]);
const { useGetSynthesisQuery: $b5949519849ab230$export$aa5e0ae5ba54b6fb } = $b5949519849ab230$export$935725e5db2ad080;
const $b5949519849ab230$export$ef9229cfc0e61ad5 = (0, $0990d2137b3e0830$export$65858239e7ec8811)("getSourceData", "/synthesis/source_data/", "GET", [
    "SourceData"
]);
const { useGetSourceDataQuery: $b5949519849ab230$export$bed858dbc195e71f } = $b5949519849ab230$export$ef9229cfc0e61ad5;
const $b5949519849ab230$export$8e5dcfb444cbd30c = (0, $0990d2137b3e0830$export$bcc8035e549759b4).injectEndpoints({
    endpoints: (builder)=>({
            getUserSourceData: builder.query({
                query: (data)=>({
                        url: `/synthesis/source_data/?userid=${data.userid}`,
                        method: "GET",
                        headers: (0, $d3ab9ae1f203b599$export$1e4d4724de7b199e)()
                    }),
                invalidatesTags: [
                    "SourceData"
                ]
            })
        }),
    overrideExisting: false
});
const { useGetUserSourceDataQuery: $b5949519849ab230$export$8cf58282b30b665b } = $b5949519849ab230$export$8e5dcfb444cbd30c;
const $b5949519849ab230$export$8ee3f08c43e9501 = (0, $0990d2137b3e0830$export$e68afafd1fa92a9f)("rerunAnalysis", ()=>"/synthesis/rerun_analysis/", "POST", [
    "SourceData"
]);
const { useRerunAnalysisMutation: $b5949519849ab230$export$b0aaa60cef02693d } = $b5949519849ab230$export$8ee3f08c43e9501;



parcelRequire("acw62");


const $6fb8c9ac3c56e201$var$SynthesisItem = ({ synthesis: synthesis })=>{
    const datePattern = /\/(\d{4}-\d{2}-\d{2})\//;
    const match = synthesis.s3_path.match(datePattern);
    const dateString = match ? match[1] : synthesis.created;
    const dateObject = new Date(dateString);
    const formattedDate = [
        dateObject.toISOString().split("T")[0],
        dateObject.toLocaleTimeString("en-US", {
            hour12: true
        })
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3e91b7d399f248d1$export$60332b2344f7fe41), {
        shadow: "md",
        radius: "md",
        withBorder: true,
        style: {
            cursor: "pointer"
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $082a1c451bb0006a$export$a766cd26d0d69044).Control, {
            style: {
                backgroundColor: "transparent",
                outlineColor: "transparent",
                width: "101%"
            },
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4), {
                    justify: "space-between",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                            size: "md",
                            fw: 600,
                            style: {
                                marginBottom: "0.5rem",
                                width: "80%"
                            },
                            children: synthesis.title ?? "No title available"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                            size: "sm",
                            c: (0, $7db4b5652a829202$export$bca14c5b3b88a9c9).colors.gray[3],
                            mr: "16px",
                            pos: "absolute",
                            right: 28,
                            top: 28,
                            children: formattedDate[0]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                            size: "sm",
                            c: (0, $7db4b5652a829202$export$bca14c5b3b88a9c9).colors.gray[3],
                            mr: "16px",
                            pos: "absolute",
                            right: 28,
                            top: 44,
                            children: formattedDate[1]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $082a1c451bb0006a$export$a766cd26d0d69044).Panel, {
                    ml: -16,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                        fw: 300,
                        pl: 0,
                        style: {
                            whiteSpace: "pre-line"
                        },
                        children: synthesis.summary ?? "No summary available"
                    })
                })
            ]
        })
    });
};
var $6fb8c9ac3c56e201$export$2e2bcd8739ae039 = $6fb8c9ac3c56e201$var$SynthesisItem;



var $acw62 = parcelRequire("acw62");

var $d06f17efb06faf2f$var$et = {}, $d06f17efb06faf2f$var$Zr = {
    get exports () {
        return $d06f17efb06faf2f$var$et;
    },
    set exports (e){
        $d06f17efb06faf2f$var$et = e;
    }
}, $d06f17efb06faf2f$var$Be = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d06f17efb06faf2f$var$Wt;
function $d06f17efb06faf2f$var$qr() {
    if ($d06f17efb06faf2f$var$Wt) return $d06f17efb06faf2f$var$Be;
    $d06f17efb06faf2f$var$Wt = 1;
    var e1 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))), t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, o = e1.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
    };
    function a(c, l, f) {
        var d, h = {}, y = null, w = null;
        f !== void 0 && (y = "" + f), l.key !== void 0 && (y = "" + l.key), l.ref !== void 0 && (w = l.ref);
        for(d in l)n.call(l, d) && !i.hasOwnProperty(d) && (h[d] = l[d]);
        if (c && c.defaultProps) for(d in l = c.defaultProps, l)h[d] === void 0 && (h[d] = l[d]);
        return {
            $$typeof: t,
            type: c,
            key: y,
            ref: w,
            props: h,
            _owner: o.current
        };
    }
    return $d06f17efb06faf2f$var$Be.Fragment = r, $d06f17efb06faf2f$var$Be.jsx = a, $d06f17efb06faf2f$var$Be.jsxs = a, $d06f17efb06faf2f$var$Be;
}
var $d06f17efb06faf2f$var$Ue = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d06f17efb06faf2f$var$Bt;
function $d06f17efb06faf2f$var$en() {
    return $d06f17efb06faf2f$var$Bt || ($d06f17efb06faf2f$var$Bt = 1), $d06f17efb06faf2f$var$Ue;
}
(function(e1) {
    e1.exports = $d06f17efb06faf2f$var$qr();
})($d06f17efb06faf2f$var$Zr);
const $d06f17efb06faf2f$var$ke = $d06f17efb06faf2f$var$et.jsx, $d06f17efb06faf2f$var$ur = $d06f17efb06faf2f$var$et.jsxs;
function $d06f17efb06faf2f$var$Te(e1) {
    return Array.isArray ? Array.isArray(e1) : $d06f17efb06faf2f$var$hr(e1) === "[object Array]";
}
const $d06f17efb06faf2f$var$tn = 1 / 0;
function $d06f17efb06faf2f$var$rn(e1) {
    if (typeof e1 == "string") return e1;
    let t = e1 + "";
    return t == "0" && 1 / e1 == -$d06f17efb06faf2f$var$tn ? "-0" : t;
}
function $d06f17efb06faf2f$var$nn(e1) {
    return e1 == null ? "" : $d06f17efb06faf2f$var$rn(e1);
}
function $d06f17efb06faf2f$var$_e(e1) {
    return typeof e1 == "string";
}
function $d06f17efb06faf2f$var$fr(e1) {
    return typeof e1 == "number";
}
function $d06f17efb06faf2f$var$on(e1) {
    return e1 === !0 || e1 === !1 || $d06f17efb06faf2f$var$sn(e1) && $d06f17efb06faf2f$var$hr(e1) == "[object Boolean]";
}
function $d06f17efb06faf2f$var$dr(e1) {
    return typeof e1 == "object";
}
function $d06f17efb06faf2f$var$sn(e1) {
    return $d06f17efb06faf2f$var$dr(e1) && e1 !== null;
}
function $d06f17efb06faf2f$var$ge(e1) {
    return e1 != null;
}
function $d06f17efb06faf2f$var$dt(e1) {
    return !e1.trim().length;
}
function $d06f17efb06faf2f$var$hr(e1) {
    return e1 == null ? e1 === void 0 ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(e1);
}
const $d06f17efb06faf2f$var$an = "Incorrect 'index' type", $d06f17efb06faf2f$var$cn = (e1)=>`Invalid value for key ${e1}`, $d06f17efb06faf2f$var$ln = (e1)=>`Pattern length exceeds max of ${e1}.`, $d06f17efb06faf2f$var$un = (e1)=>`Missing ${e1} property in key`, $d06f17efb06faf2f$var$fn = (e1)=>`Property 'weight' in key '${e1}' must be a positive integer`, $d06f17efb06faf2f$var$Ut = Object.prototype.hasOwnProperty;
class $d06f17efb06faf2f$var$dn {
    constructor(t){
        this._keys = [], this._keyMap = {};
        let r = 0;
        t.forEach((n)=>{
            let o = $d06f17efb06faf2f$var$pr(n);
            r += o.weight, this._keys.push(o), this._keyMap[o.id] = o, r += o.weight;
        }), this._keys.forEach((n)=>{
            n.weight /= r;
        });
    }
    get(t) {
        return this._keyMap[t];
    }
    keys() {
        return this._keys;
    }
    toJSON() {
        return JSON.stringify(this._keys);
    }
}
function $d06f17efb06faf2f$var$pr(e1) {
    let t = null, r = null, n = null, o = 1, i = null;
    if ($d06f17efb06faf2f$var$_e(e1) || $d06f17efb06faf2f$var$Te(e1)) n = e1, t = $d06f17efb06faf2f$var$Gt(e1), r = $d06f17efb06faf2f$var$mt(e1);
    else {
        if (!$d06f17efb06faf2f$var$Ut.call(e1, "name")) throw new Error($d06f17efb06faf2f$var$un("name"));
        const a = e1.name;
        if (n = a, $d06f17efb06faf2f$var$Ut.call(e1, "weight") && (o = e1.weight, o <= 0)) throw new Error($d06f17efb06faf2f$var$fn(a));
        t = $d06f17efb06faf2f$var$Gt(a), r = $d06f17efb06faf2f$var$mt(a), i = e1.getFn;
    }
    return {
        path: t,
        id: r,
        weight: o,
        src: n,
        getFn: i
    };
}
function $d06f17efb06faf2f$var$Gt(e1) {
    return $d06f17efb06faf2f$var$Te(e1) ? e1 : e1.split(".");
}
function $d06f17efb06faf2f$var$mt(e1) {
    return $d06f17efb06faf2f$var$Te(e1) ? e1.join(".") : e1;
}
function $d06f17efb06faf2f$var$hn(e1, t) {
    let r = [], n = !1;
    const o = (i, a, c)=>{
        if ($d06f17efb06faf2f$var$ge(i)) {
            if (!a[c]) r.push(i);
            else {
                let l = a[c];
                const f = i[l];
                if (!$d06f17efb06faf2f$var$ge(f)) return;
                if (c === a.length - 1 && ($d06f17efb06faf2f$var$_e(f) || $d06f17efb06faf2f$var$fr(f) || $d06f17efb06faf2f$var$on(f))) r.push($d06f17efb06faf2f$var$nn(f));
                else if ($d06f17efb06faf2f$var$Te(f)) {
                    n = !0;
                    for(let d = 0, h = f.length; d < h; d += 1)o(f[d], a, c + 1);
                } else a.length && o(f, a, c + 1);
            }
        }
    };
    return o(e1, $d06f17efb06faf2f$var$_e(t) ? t.split(".") : t, 0), n ? r : r[0];
}
const $d06f17efb06faf2f$var$pn = {
    // Whether the matches should be included in the result set. When `true`, each record in the result
    // set will include the indices of the matched characters.
    // These can consequently be used for highlighting purposes.
    includeMatches: !1,
    // When `true`, the matching function will continue to the end of a search pattern even if
    // a perfect match has already been located in the string.
    findAllMatches: !1,
    // Minimum number of characters that must be matched before a result is considered a match
    minMatchCharLength: 1
}, $d06f17efb06faf2f$var$mn = {
    // When `true`, the algorithm continues searching to the end of the input even if a perfect
    // match is found before the end of the same input.
    isCaseSensitive: !1,
    // When true, the matching function will continue to the end of a search pattern even if
    includeScore: !1,
    // List of properties that will be searched. This also supports nested properties.
    keys: [],
    // Whether to sort the result list, by score
    shouldSort: !0,
    // Default sort function: sort by ascending score, ascending index
    sortFn: (e1, t)=>e1.score === t.score ? e1.idx < t.idx ? -1 : 1 : e1.score < t.score ? -1 : 1
}, $d06f17efb06faf2f$var$gn = {
    // Approximately where in the text is the pattern expected to be found?
    location: 0,
    // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
    // (of both letters and location), a threshold of '1.0' would match anything.
    threshold: 0.6,
    // Determines how close the match must be to the fuzzy location (specified above).
    // An exact letter match which is 'distance' characters away from the fuzzy location
    // would score as a complete mismatch. A distance of '0' requires the match be at
    // the exact location specified, a threshold of '1000' would require a perfect match
    // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
    distance: 100
}, $d06f17efb06faf2f$var$vn = {
    // When `true`, it enables the use of unix-like search commands
    useExtendedSearch: !1,
    // The get function to use when fetching an object's properties.
    // The default will search nested paths *ie foo.bar.baz*
    getFn: $d06f17efb06faf2f$var$hn,
    // When `true`, search will ignore `location` and `distance`, so it won't matter
    // where in the string the pattern appears.
    // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
    ignoreLocation: !1,
    // When `true`, the calculation for the relevance score (used for sorting) will
    // ignore the field-length norm.
    // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
    ignoreFieldNorm: !1,
    // The weight to determine how much field length norm effects scoring.
    fieldNormWeight: 1
};
var $d06f17efb06faf2f$var$N = {
    ...$d06f17efb06faf2f$var$mn,
    ...$d06f17efb06faf2f$var$pn,
    ...$d06f17efb06faf2f$var$gn,
    ...$d06f17efb06faf2f$var$vn
};
const $d06f17efb06faf2f$var$yn = /[^ ]+/g;
function $d06f17efb06faf2f$var$bn(e1 = 1, t = 3) {
    const r = /* @__PURE__ */ new Map(), n = Math.pow(10, t);
    return {
        get (o) {
            const i = o.match($d06f17efb06faf2f$var$yn).length;
            if (r.has(i)) return r.get(i);
            const a = 1 / Math.pow(i, 0.5 * e1), c = parseFloat(Math.round(a * n) / n);
            return r.set(i, c), c;
        },
        clear () {
            r.clear();
        }
    };
}
class $d06f17efb06faf2f$var$At {
    constructor({ getFn: t = $d06f17efb06faf2f$var$N.getFn, fieldNormWeight: r = $d06f17efb06faf2f$var$N.fieldNormWeight } = {}){
        this.norm = $d06f17efb06faf2f$var$bn(r, 3), this.getFn = t, this.isCreated = !1, this.setIndexRecords();
    }
    setSources(t = []) {
        this.docs = t;
    }
    setIndexRecords(t = []) {
        this.records = t;
    }
    setKeys(t = []) {
        this.keys = t, this._keysMap = {}, t.forEach((r, n)=>{
            this._keysMap[r.id] = n;
        });
    }
    create() {
        this.isCreated || !this.docs.length || (this.isCreated = !0, $d06f17efb06faf2f$var$_e(this.docs[0]) ? this.docs.forEach((t, r)=>{
            this._addString(t, r);
        }) : this.docs.forEach((t, r)=>{
            this._addObject(t, r);
        }), this.norm.clear());
    }
    // Adds a doc to the end of the index
    add(t) {
        const r = this.size();
        $d06f17efb06faf2f$var$_e(t) ? this._addString(t, r) : this._addObject(t, r);
    }
    // Removes the doc at the specified index of the index
    removeAt(t) {
        this.records.splice(t, 1);
        for(let r = t, n = this.size(); r < n; r += 1)this.records[r].i -= 1;
    }
    getValueForItemAtKeyId(t, r) {
        return t[this._keysMap[r]];
    }
    size() {
        return this.records.length;
    }
    _addString(t, r) {
        if (!$d06f17efb06faf2f$var$ge(t) || $d06f17efb06faf2f$var$dt(t)) return;
        let n = {
            v: t,
            i: r,
            n: this.norm.get(t)
        };
        this.records.push(n);
    }
    _addObject(t, r) {
        let n = {
            i: r,
            $: {}
        };
        this.keys.forEach((o, i)=>{
            let a = o.getFn ? o.getFn(t) : this.getFn(t, o.path);
            if ($d06f17efb06faf2f$var$ge(a)) {
                if ($d06f17efb06faf2f$var$Te(a)) {
                    let c = [];
                    const l = [
                        {
                            nestedArrIndex: -1,
                            value: a
                        }
                    ];
                    for(; l.length;){
                        const { nestedArrIndex: f, value: d } = l.pop();
                        if ($d06f17efb06faf2f$var$ge(d)) {
                            if ($d06f17efb06faf2f$var$_e(d) && !$d06f17efb06faf2f$var$dt(d)) {
                                let h = {
                                    v: d,
                                    i: f,
                                    n: this.norm.get(d)
                                };
                                c.push(h);
                            } else $d06f17efb06faf2f$var$Te(d) && d.forEach((h, y)=>{
                                l.push({
                                    nestedArrIndex: y,
                                    value: h
                                });
                            });
                        }
                    }
                    n.$[i] = c;
                } else if ($d06f17efb06faf2f$var$_e(a) && !$d06f17efb06faf2f$var$dt(a)) {
                    let c = {
                        v: a,
                        n: this.norm.get(a)
                    };
                    n.$[i] = c;
                }
            }
        }), this.records.push(n);
    }
    toJSON() {
        return {
            keys: this.keys,
            records: this.records
        };
    }
}
function $d06f17efb06faf2f$var$mr(e1, t, { getFn: r = $d06f17efb06faf2f$var$N.getFn, fieldNormWeight: n = $d06f17efb06faf2f$var$N.fieldNormWeight } = {}) {
    const o = new $d06f17efb06faf2f$var$At({
        getFn: r,
        fieldNormWeight: n
    });
    return o.setKeys(e1.map($d06f17efb06faf2f$var$pr)), o.setSources(t), o.create(), o;
}
function $d06f17efb06faf2f$var$Sn(e1, { getFn: t = $d06f17efb06faf2f$var$N.getFn, fieldNormWeight: r = $d06f17efb06faf2f$var$N.fieldNormWeight } = {}) {
    const { keys: n, records: o } = e1, i = new $d06f17efb06faf2f$var$At({
        getFn: t,
        fieldNormWeight: r
    });
    return i.setKeys(n), i.setIndexRecords(o), i;
}
function $d06f17efb06faf2f$var$Xe(e1, { errors: t = 0, currentLocation: r = 0, expectedLocation: n = 0, distance: o = $d06f17efb06faf2f$var$N.distance, ignoreLocation: i = $d06f17efb06faf2f$var$N.ignoreLocation } = {}) {
    const a = t / e1.length;
    if (i) return a;
    const c = Math.abs(n - r);
    return o ? a + c / o : c ? 1 : a;
}
function $d06f17efb06faf2f$var$En(e1 = [], t = $d06f17efb06faf2f$var$N.minMatchCharLength) {
    let r = [], n = -1, o = -1, i = 0;
    for(let a = e1.length; i < a; i += 1){
        let c = e1[i];
        c && n === -1 ? n = i : !c && n !== -1 && (o = i - 1, o - n + 1 >= t && r.push([
            n,
            o
        ]), n = -1);
    }
    return e1[i - 1] && i - n >= t && r.push([
        n,
        i - 1
    ]), r;
}
const $d06f17efb06faf2f$var$Me = 32;
function $d06f17efb06faf2f$var$wn(e1, t, r, { location: n = $d06f17efb06faf2f$var$N.location, distance: o = $d06f17efb06faf2f$var$N.distance, threshold: i = $d06f17efb06faf2f$var$N.threshold, findAllMatches: a = $d06f17efb06faf2f$var$N.findAllMatches, minMatchCharLength: c = $d06f17efb06faf2f$var$N.minMatchCharLength, includeMatches: l = $d06f17efb06faf2f$var$N.includeMatches, ignoreLocation: f = $d06f17efb06faf2f$var$N.ignoreLocation } = {}) {
    if (t.length > $d06f17efb06faf2f$var$Me) throw new Error($d06f17efb06faf2f$var$ln($d06f17efb06faf2f$var$Me));
    const d = t.length, h = e1.length, y = Math.max(0, Math.min(n, h));
    let w = i, b = y;
    const A = c > 1 || l, R = A ? Array(h) : [];
    let O;
    for(; (O = e1.indexOf(t, b)) > -1;){
        let J = $d06f17efb06faf2f$var$Xe(t, {
            currentLocation: O,
            expectedLocation: y,
            distance: o,
            ignoreLocation: f
        });
        if (w = Math.min(J, w), b = O + d, A) {
            let G = 0;
            for(; G < d;)R[O + G] = 1, G += 1;
        }
    }
    b = -1;
    let _ = [], T = 1, k = d + h;
    const g = 1 << d - 1;
    for(let J = 0; J < d; J += 1){
        let G = 0, Q = k;
        for(; G < Q;)$d06f17efb06faf2f$var$Xe(t, {
            errors: J,
            currentLocation: y + Q,
            expectedLocation: y,
            distance: o,
            ignoreLocation: f
        }) <= w ? G = Q : k = Q, Q = Math.floor((k - G) / 2 + G);
        k = Q;
        let fe = Math.max(1, y - Q + 1), de = a ? h : Math.min(y + Q, h) + d, Z = Array(de + 2);
        Z[de + 1] = (1 << J) - 1;
        for(let Y = de; Y >= fe; Y -= 1){
            let H = Y - 1, he = r[e1.charAt(H)];
            if (A && (R[H] = +!!he), Z[Y] = (Z[Y + 1] << 1 | 1) & he, J && (Z[Y] |= (_[Y + 1] | _[Y]) << 1 | 1 | _[Y + 1]), Z[Y] & g && (T = $d06f17efb06faf2f$var$Xe(t, {
                errors: J,
                currentLocation: H,
                expectedLocation: y,
                distance: o,
                ignoreLocation: f
            }), T <= w)) {
                if (w = T, b = H, b <= y) break;
                fe = Math.max(1, 2 * y - b);
            }
        }
        if ($d06f17efb06faf2f$var$Xe(t, {
            errors: J + 1,
            currentLocation: y,
            expectedLocation: y,
            distance: o,
            ignoreLocation: f
        }) > w) break;
        _ = Z;
    }
    const X = {
        isMatch: b >= 0,
        // Count exact matches (those with a score of 0) to be "almost" exact
        score: Math.max(1e-3, T)
    };
    if (A) {
        const J = $d06f17efb06faf2f$var$En(R, c);
        J.length ? l && (X.indices = J) : X.isMatch = !1;
    }
    return X;
}
function $d06f17efb06faf2f$var$_n(e1) {
    let t = {};
    for(let r = 0, n = e1.length; r < n; r += 1){
        const o = e1.charAt(r);
        t[o] = (t[o] || 0) | 1 << n - r - 1;
    }
    return t;
}
class $d06f17efb06faf2f$var$gr {
    constructor(t, { location: r = $d06f17efb06faf2f$var$N.location, threshold: n = $d06f17efb06faf2f$var$N.threshold, distance: o = $d06f17efb06faf2f$var$N.distance, includeMatches: i = $d06f17efb06faf2f$var$N.includeMatches, findAllMatches: a = $d06f17efb06faf2f$var$N.findAllMatches, minMatchCharLength: c = $d06f17efb06faf2f$var$N.minMatchCharLength, isCaseSensitive: l = $d06f17efb06faf2f$var$N.isCaseSensitive, ignoreLocation: f = $d06f17efb06faf2f$var$N.ignoreLocation } = {}){
        if (this.options = {
            location: r,
            threshold: n,
            distance: o,
            includeMatches: i,
            findAllMatches: a,
            minMatchCharLength: c,
            isCaseSensitive: l,
            ignoreLocation: f
        }, this.pattern = l ? t : t.toLowerCase(), this.chunks = [], !this.pattern.length) return;
        const d = (y, w)=>{
            this.chunks.push({
                pattern: y,
                alphabet: $d06f17efb06faf2f$var$_n(y),
                startIndex: w
            });
        }, h = this.pattern.length;
        if (h > $d06f17efb06faf2f$var$Me) {
            let y = 0;
            const w = h % $d06f17efb06faf2f$var$Me, b = h - w;
            for(; y < b;)d(this.pattern.substr(y, $d06f17efb06faf2f$var$Me), y), y += $d06f17efb06faf2f$var$Me;
            if (w) {
                const A = h - $d06f17efb06faf2f$var$Me;
                d(this.pattern.substr(A), A);
            }
        } else d(this.pattern, 0);
    }
    searchIn(t) {
        const { isCaseSensitive: r, includeMatches: n } = this.options;
        if (r || (t = t.toLowerCase()), this.pattern === t) {
            let b = {
                isMatch: !0,
                score: 0
            };
            return n && (b.indices = [
                [
                    0,
                    t.length - 1
                ]
            ]), b;
        }
        const { location: o, distance: i, threshold: a, findAllMatches: c, minMatchCharLength: l, ignoreLocation: f } = this.options;
        let d = [], h = 0, y = !1;
        this.chunks.forEach(({ pattern: b, alphabet: A, startIndex: R })=>{
            const { isMatch: O, score: _, indices: T } = $d06f17efb06faf2f$var$wn(t, b, A, {
                location: o + R,
                distance: i,
                threshold: a,
                findAllMatches: c,
                minMatchCharLength: l,
                includeMatches: n,
                ignoreLocation: f
            });
            O && (y = !0), h += _, O && T && (d = [
                ...d,
                ...T
            ]);
        });
        let w = {
            isMatch: y,
            score: y ? h / this.chunks.length : 1
        };
        return y && n && (w.indices = d), w;
    }
}
class $d06f17efb06faf2f$var$Ie {
    constructor(t){
        this.pattern = t;
    }
    static isMultiMatch(t) {
        return $d06f17efb06faf2f$var$Ht(t, this.multiRegex);
    }
    static isSingleMatch(t) {
        return $d06f17efb06faf2f$var$Ht(t, this.singleRegex);
    }
    search() {}
}
function $d06f17efb06faf2f$var$Ht(e1, t) {
    const r = e1.match(t);
    return r ? r[1] : null;
}
class $d06f17efb06faf2f$var$xn extends $d06f17efb06faf2f$var$Ie {
    constructor(t){
        super(t);
    }
    static get type() {
        return "exact";
    }
    static get multiRegex() {
        return /^="(.*)"$/;
    }
    static get singleRegex() {
        return /^=(.*)$/;
    }
    search(t) {
        const r = t === this.pattern;
        return {
            isMatch: r,
            score: r ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
class $d06f17efb06faf2f$var$Cn extends $d06f17efb06faf2f$var$Ie {
    constructor(t){
        super(t);
    }
    static get type() {
        return "inverse-exact";
    }
    static get multiRegex() {
        return /^!"(.*)"$/;
    }
    static get singleRegex() {
        return /^!(.*)$/;
    }
    search(t) {
        const n = t.indexOf(this.pattern) === -1;
        return {
            isMatch: n,
            score: n ? 0 : 1,
            indices: [
                0,
                t.length - 1
            ]
        };
    }
}
class $d06f17efb06faf2f$var$Rn extends $d06f17efb06faf2f$var$Ie {
    constructor(t){
        super(t);
    }
    static get type() {
        return "prefix-exact";
    }
    static get multiRegex() {
        return /^\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^\^(.*)$/;
    }
    search(t) {
        const r = t.startsWith(this.pattern);
        return {
            isMatch: r,
            score: r ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
class $d06f17efb06faf2f$var$An extends $d06f17efb06faf2f$var$Ie {
    constructor(t){
        super(t);
    }
    static get type() {
        return "inverse-prefix-exact";
    }
    static get multiRegex() {
        return /^!\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^!\^(.*)$/;
    }
    search(t) {
        const r = !t.startsWith(this.pattern);
        return {
            isMatch: r,
            score: r ? 0 : 1,
            indices: [
                0,
                t.length - 1
            ]
        };
    }
}
class $d06f17efb06faf2f$var$kn extends $d06f17efb06faf2f$var$Ie {
    constructor(t){
        super(t);
    }
    static get type() {
        return "suffix-exact";
    }
    static get multiRegex() {
        return /^"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^(.*)\$$/;
    }
    search(t) {
        const r = t.endsWith(this.pattern);
        return {
            isMatch: r,
            score: r ? 0 : 1,
            indices: [
                t.length - this.pattern.length,
                t.length - 1
            ]
        };
    }
}
class $d06f17efb06faf2f$var$Tn extends $d06f17efb06faf2f$var$Ie {
    constructor(t){
        super(t);
    }
    static get type() {
        return "inverse-suffix-exact";
    }
    static get multiRegex() {
        return /^!"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^!(.*)\$$/;
    }
    search(t) {
        const r = !t.endsWith(this.pattern);
        return {
            isMatch: r,
            score: r ? 0 : 1,
            indices: [
                0,
                t.length - 1
            ]
        };
    }
}
class $d06f17efb06faf2f$var$vr extends $d06f17efb06faf2f$var$Ie {
    constructor(t, { location: r = $d06f17efb06faf2f$var$N.location, threshold: n = $d06f17efb06faf2f$var$N.threshold, distance: o = $d06f17efb06faf2f$var$N.distance, includeMatches: i = $d06f17efb06faf2f$var$N.includeMatches, findAllMatches: a = $d06f17efb06faf2f$var$N.findAllMatches, minMatchCharLength: c = $d06f17efb06faf2f$var$N.minMatchCharLength, isCaseSensitive: l = $d06f17efb06faf2f$var$N.isCaseSensitive, ignoreLocation: f = $d06f17efb06faf2f$var$N.ignoreLocation } = {}){
        super(t), this._bitapSearch = new $d06f17efb06faf2f$var$gr(t, {
            location: r,
            threshold: n,
            distance: o,
            includeMatches: i,
            findAllMatches: a,
            minMatchCharLength: c,
            isCaseSensitive: l,
            ignoreLocation: f
        });
    }
    static get type() {
        return "fuzzy";
    }
    static get multiRegex() {
        return /^"(.*)"$/;
    }
    static get singleRegex() {
        return /^(.*)$/;
    }
    search(t) {
        return this._bitapSearch.searchIn(t);
    }
}
class $d06f17efb06faf2f$var$yr extends $d06f17efb06faf2f$var$Ie {
    constructor(t){
        super(t);
    }
    static get type() {
        return "include";
    }
    static get multiRegex() {
        return /^'"(.*)"$/;
    }
    static get singleRegex() {
        return /^'(.*)$/;
    }
    search(t) {
        let r = 0, n;
        const o = [], i = this.pattern.length;
        for(; (n = t.indexOf(this.pattern, r)) > -1;)r = n + i, o.push([
            n,
            r - 1
        ]);
        const a = !!o.length;
        return {
            isMatch: a,
            score: a ? 0 : 1,
            indices: o
        };
    }
}
const $d06f17efb06faf2f$var$gt = [
    $d06f17efb06faf2f$var$xn,
    $d06f17efb06faf2f$var$yr,
    $d06f17efb06faf2f$var$Rn,
    $d06f17efb06faf2f$var$An,
    $d06f17efb06faf2f$var$Tn,
    $d06f17efb06faf2f$var$kn,
    $d06f17efb06faf2f$var$Cn,
    $d06f17efb06faf2f$var$vr
], $d06f17efb06faf2f$var$Kt = $d06f17efb06faf2f$var$gt.length, $d06f17efb06faf2f$var$On = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/, $d06f17efb06faf2f$var$Pn = "|";
function $d06f17efb06faf2f$var$In(e1, t = {}) {
    return e1.split($d06f17efb06faf2f$var$Pn).map((r)=>{
        let n = r.trim().split($d06f17efb06faf2f$var$On).filter((i)=>i && !!i.trim()), o = [];
        for(let i = 0, a = n.length; i < a; i += 1){
            const c = n[i];
            let l = !1, f = -1;
            for(; !l && ++f < $d06f17efb06faf2f$var$Kt;){
                const d = $d06f17efb06faf2f$var$gt[f];
                let h = d.isMultiMatch(c);
                h && (o.push(new d(h, t)), l = !0);
            }
            if (!l) for(f = -1; ++f < $d06f17efb06faf2f$var$Kt;){
                const d = $d06f17efb06faf2f$var$gt[f];
                let h = d.isSingleMatch(c);
                if (h) {
                    o.push(new d(h, t));
                    break;
                }
            }
        }
        return o;
    });
}
const $d06f17efb06faf2f$var$Mn = /* @__PURE__ */ new Set([
    $d06f17efb06faf2f$var$vr.type,
    $d06f17efb06faf2f$var$yr.type
]);
class $d06f17efb06faf2f$var$Nn {
    constructor(t, { isCaseSensitive: r = $d06f17efb06faf2f$var$N.isCaseSensitive, includeMatches: n = $d06f17efb06faf2f$var$N.includeMatches, minMatchCharLength: o = $d06f17efb06faf2f$var$N.minMatchCharLength, ignoreLocation: i = $d06f17efb06faf2f$var$N.ignoreLocation, findAllMatches: a = $d06f17efb06faf2f$var$N.findAllMatches, location: c = $d06f17efb06faf2f$var$N.location, threshold: l = $d06f17efb06faf2f$var$N.threshold, distance: f = $d06f17efb06faf2f$var$N.distance } = {}){
        this.query = null, this.options = {
            isCaseSensitive: r,
            includeMatches: n,
            minMatchCharLength: o,
            findAllMatches: a,
            ignoreLocation: i,
            location: c,
            threshold: l,
            distance: f
        }, this.pattern = r ? t : t.toLowerCase(), this.query = $d06f17efb06faf2f$var$In(this.pattern, this.options);
    }
    static condition(t, r) {
        return r.useExtendedSearch;
    }
    searchIn(t) {
        const r = this.query;
        if (!r) return {
            isMatch: !1,
            score: 1
        };
        const { includeMatches: n, isCaseSensitive: o } = this.options;
        t = o ? t : t.toLowerCase();
        let i = 0, a = [], c = 0;
        for(let l = 0, f = r.length; l < f; l += 1){
            const d = r[l];
            a.length = 0, i = 0;
            for(let h = 0, y = d.length; h < y; h += 1){
                const w = d[h], { isMatch: b, indices: A, score: R } = w.search(t);
                if (b) {
                    if (i += 1, c += R, n) {
                        const O = w.constructor.type;
                        $d06f17efb06faf2f$var$Mn.has(O) ? a = [
                            ...a,
                            ...A
                        ] : a.push(A);
                    }
                } else {
                    c = 0, i = 0, a.length = 0;
                    break;
                }
            }
            if (i) {
                let h = {
                    isMatch: !0,
                    score: c / i
                };
                return n && (h.indices = a), h;
            }
        }
        return {
            isMatch: !1,
            score: 1
        };
    }
}
const $d06f17efb06faf2f$var$vt = [];
function $d06f17efb06faf2f$var$$n(...e1) {
    $d06f17efb06faf2f$var$vt.push(...e1);
}
function $d06f17efb06faf2f$var$yt(e1, t) {
    for(let r = 0, n = $d06f17efb06faf2f$var$vt.length; r < n; r += 1){
        let o = $d06f17efb06faf2f$var$vt[r];
        if (o.condition(e1, t)) return new o(e1, t);
    }
    return new $d06f17efb06faf2f$var$gr(e1, t);
}
const $d06f17efb06faf2f$var$tt = {
    AND: "$and",
    OR: "$or"
}, $d06f17efb06faf2f$var$bt = {
    PATH: "$path",
    PATTERN: "$val"
}, $d06f17efb06faf2f$var$St = (e1)=>!!(e1[$d06f17efb06faf2f$var$tt.AND] || e1[$d06f17efb06faf2f$var$tt.OR]), $d06f17efb06faf2f$var$jn = (e1)=>!!e1[$d06f17efb06faf2f$var$bt.PATH], $d06f17efb06faf2f$var$Dn = (e1)=>!$d06f17efb06faf2f$var$Te(e1) && $d06f17efb06faf2f$var$dr(e1) && !$d06f17efb06faf2f$var$St(e1), $d06f17efb06faf2f$var$Xt = (e1)=>({
        [$d06f17efb06faf2f$var$tt.AND]: Object.keys(e1).map((t)=>({
                [t]: e1[t]
            }))
    });
function $d06f17efb06faf2f$var$br(e1, t, { auto: r = !0 } = {}) {
    const n = (o)=>{
        let i = Object.keys(o);
        const a = $d06f17efb06faf2f$var$jn(o);
        if (!a && i.length > 1 && !$d06f17efb06faf2f$var$St(o)) return n($d06f17efb06faf2f$var$Xt(o));
        if ($d06f17efb06faf2f$var$Dn(o)) {
            const l = a ? o[$d06f17efb06faf2f$var$bt.PATH] : i[0], f = a ? o[$d06f17efb06faf2f$var$bt.PATTERN] : o[l];
            if (!$d06f17efb06faf2f$var$_e(f)) throw new Error($d06f17efb06faf2f$var$cn(l));
            const d = {
                keyId: $d06f17efb06faf2f$var$mt(l),
                pattern: f
            };
            return r && (d.searcher = $d06f17efb06faf2f$var$yt(f, t)), d;
        }
        let c = {
            children: [],
            operator: i[0]
        };
        return i.forEach((l)=>{
            const f = o[l];
            $d06f17efb06faf2f$var$Te(f) && f.forEach((d)=>{
                c.children.push(n(d));
            });
        }), c;
    };
    return $d06f17efb06faf2f$var$St(e1) || (e1 = $d06f17efb06faf2f$var$Xt(e1)), n(e1);
}
function $d06f17efb06faf2f$var$Ln(e1, { ignoreFieldNorm: t = $d06f17efb06faf2f$var$N.ignoreFieldNorm }) {
    e1.forEach((r)=>{
        let n = 1;
        r.matches.forEach(({ key: o, norm: i, score: a })=>{
            const c = o ? o.weight : null;
            n *= Math.pow(a === 0 && c ? Number.EPSILON : a, (c || 1) * (t ? 1 : i));
        }), r.score = n;
    });
}
function $d06f17efb06faf2f$var$Fn(e1, t) {
    const r = e1.matches;
    t.matches = [], $d06f17efb06faf2f$var$ge(r) && r.forEach((n)=>{
        if (!$d06f17efb06faf2f$var$ge(n.indices) || !n.indices.length) return;
        const { indices: o, value: i } = n;
        let a = {
            indices: o,
            value: i
        };
        n.key && (a.key = n.key.src), n.idx > -1 && (a.refIndex = n.idx), t.matches.push(a);
    });
}
function $d06f17efb06faf2f$var$Yn(e1, t) {
    t.score = e1.score;
}
function $d06f17efb06faf2f$var$zn(e1, t, { includeMatches: r = $d06f17efb06faf2f$var$N.includeMatches, includeScore: n = $d06f17efb06faf2f$var$N.includeScore } = {}) {
    const o = [];
    return r && o.push($d06f17efb06faf2f$var$Fn), n && o.push($d06f17efb06faf2f$var$Yn), e1.map((i)=>{
        const { idx: a } = i, c = {
            item: t[a],
            refIndex: a
        };
        return o.length && o.forEach((l)=>{
            l(i, c);
        }), c;
    });
}
class $d06f17efb06faf2f$var$Ve {
    constructor(t, r = {}, n){
        this.options = {
            ...$d06f17efb06faf2f$var$N,
            ...r
        }, this.options.useExtendedSearch, this._keyStore = new $d06f17efb06faf2f$var$dn(this.options.keys), this.setCollection(t, n);
    }
    setCollection(t, r) {
        if (this._docs = t, r && !(r instanceof $d06f17efb06faf2f$var$At)) throw new Error($d06f17efb06faf2f$var$an);
        this._myIndex = r || $d06f17efb06faf2f$var$mr(this.options.keys, this._docs, {
            getFn: this.options.getFn,
            fieldNormWeight: this.options.fieldNormWeight
        });
    }
    add(t) {
        $d06f17efb06faf2f$var$ge(t) && (this._docs.push(t), this._myIndex.add(t));
    }
    remove(t = ()=>!1) {
        const r = [];
        for(let n = 0, o = this._docs.length; n < o; n += 1){
            const i = this._docs[n];
            t(i, n) && (this.removeAt(n), n -= 1, o -= 1, r.push(i));
        }
        return r;
    }
    removeAt(t) {
        this._docs.splice(t, 1), this._myIndex.removeAt(t);
    }
    getIndex() {
        return this._myIndex;
    }
    search(t, { limit: r = -1 } = {}) {
        const { includeMatches: n, includeScore: o, shouldSort: i, sortFn: a, ignoreFieldNorm: c } = this.options;
        let l = $d06f17efb06faf2f$var$_e(t) ? $d06f17efb06faf2f$var$_e(this._docs[0]) ? this._searchStringList(t) : this._searchObjectList(t) : this._searchLogical(t);
        return $d06f17efb06faf2f$var$Ln(l, {
            ignoreFieldNorm: c
        }), i && l.sort(a), $d06f17efb06faf2f$var$fr(r) && r > -1 && (l = l.slice(0, r)), $d06f17efb06faf2f$var$zn(l, this._docs, {
            includeMatches: n,
            includeScore: o
        });
    }
    _searchStringList(t) {
        const r = $d06f17efb06faf2f$var$yt(t, this.options), { records: n } = this._myIndex, o = [];
        return n.forEach(({ v: i, i: a, n: c })=>{
            if (!$d06f17efb06faf2f$var$ge(i)) return;
            const { isMatch: l, score: f, indices: d } = r.searchIn(i);
            l && o.push({
                item: i,
                idx: a,
                matches: [
                    {
                        score: f,
                        value: i,
                        norm: c,
                        indices: d
                    }
                ]
            });
        }), o;
    }
    _searchLogical(t) {
        const r = $d06f17efb06faf2f$var$br(t, this.options), n = (c, l, f)=>{
            if (!c.children) {
                const { keyId: h, searcher: y } = c, w = this._findMatches({
                    key: this._keyStore.get(h),
                    value: this._myIndex.getValueForItemAtKeyId(l, h),
                    searcher: y
                });
                return w && w.length ? [
                    {
                        idx: f,
                        item: l,
                        matches: w
                    }
                ] : [];
            }
            const d = [];
            for(let h = 0, y = c.children.length; h < y; h += 1){
                const w = c.children[h], b = n(w, l, f);
                if (b.length) d.push(...b);
                else if (c.operator === $d06f17efb06faf2f$var$tt.AND) return [];
            }
            return d;
        }, o = this._myIndex.records, i = {}, a = [];
        return o.forEach(({ $: c, i: l })=>{
            if ($d06f17efb06faf2f$var$ge(c)) {
                let f = n(r, c, l);
                f.length && (i[l] || (i[l] = {
                    idx: l,
                    item: c,
                    matches: []
                }, a.push(i[l])), f.forEach(({ matches: d })=>{
                    i[l].matches.push(...d);
                }));
            }
        }), a;
    }
    _searchObjectList(t) {
        const r = $d06f17efb06faf2f$var$yt(t, this.options), { keys: n, records: o } = this._myIndex, i = [];
        return o.forEach(({ $: a, i: c })=>{
            if (!$d06f17efb06faf2f$var$ge(a)) return;
            let l = [];
            n.forEach((f, d)=>{
                l.push(...this._findMatches({
                    key: f,
                    value: a[d],
                    searcher: r
                }));
            }), l.length && i.push({
                idx: c,
                item: a,
                matches: l
            });
        }), i;
    }
    _findMatches({ key: t, value: r, searcher: n }) {
        if (!$d06f17efb06faf2f$var$ge(r)) return [];
        let o = [];
        if ($d06f17efb06faf2f$var$Te(r)) r.forEach(({ v: i, i: a, n: c })=>{
            if (!$d06f17efb06faf2f$var$ge(i)) return;
            const { isMatch: l, score: f, indices: d } = n.searchIn(i);
            l && o.push({
                score: f,
                key: t,
                value: i,
                idx: a,
                norm: c,
                indices: d
            });
        });
        else {
            const { v: i, n: a } = r, { isMatch: c, score: l, indices: f } = n.searchIn(i);
            c && o.push({
                score: l,
                key: t,
                value: i,
                norm: a,
                indices: f
            });
        }
        return o;
    }
}
$d06f17efb06faf2f$var$Ve.version = "6.6.2";
$d06f17efb06faf2f$var$Ve.createIndex = $d06f17efb06faf2f$var$mr;
$d06f17efb06faf2f$var$Ve.parseIndex = $d06f17efb06faf2f$var$Sn;
$d06f17efb06faf2f$var$Ve.config = $d06f17efb06faf2f$var$N;
$d06f17efb06faf2f$var$Ve.parseQuery = $d06f17efb06faf2f$var$br;
$d06f17efb06faf2f$var$$n($d06f17efb06faf2f$var$Nn);
var $d06f17efb06faf2f$var$Ye = {}, $d06f17efb06faf2f$var$Vn = {
    get exports () {
        return $d06f17efb06faf2f$var$Ye;
    },
    set exports (e){
        $d06f17efb06faf2f$var$Ye = e;
    }
}, $d06f17efb06faf2f$var$B = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d06f17efb06faf2f$var$Jt;
function $d06f17efb06faf2f$var$Wn() {
    if ($d06f17efb06faf2f$var$Jt) return $d06f17efb06faf2f$var$B;
    $d06f17efb06faf2f$var$Jt = 1;
    var e1 = typeof Symbol == "function" && Symbol.for, t = e1 ? Symbol.for("react.element") : 60103, r = e1 ? Symbol.for("react.portal") : 60106, n = e1 ? Symbol.for("react.fragment") : 60107, o = e1 ? Symbol.for("react.strict_mode") : 60108, i = e1 ? Symbol.for("react.profiler") : 60114, a = e1 ? Symbol.for("react.provider") : 60109, c = e1 ? Symbol.for("react.context") : 60110, l = e1 ? Symbol.for("react.async_mode") : 60111, f = e1 ? Symbol.for("react.concurrent_mode") : 60111, d = e1 ? Symbol.for("react.forward_ref") : 60112, h = e1 ? Symbol.for("react.suspense") : 60113, y = e1 ? Symbol.for("react.suspense_list") : 60120, w = e1 ? Symbol.for("react.memo") : 60115, b = e1 ? Symbol.for("react.lazy") : 60116, A = e1 ? Symbol.for("react.block") : 60121, R = e1 ? Symbol.for("react.fundamental") : 60117, O = e1 ? Symbol.for("react.responder") : 60118, _ = e1 ? Symbol.for("react.scope") : 60119;
    function T(g) {
        if (typeof g == "object" && g !== null) {
            var X = g.$$typeof;
            switch(X){
                case t:
                    switch(g = g.type, g){
                        case l:
                        case f:
                        case n:
                        case i:
                        case o:
                        case h:
                            return g;
                        default:
                            switch(g = g && g.$$typeof, g){
                                case c:
                                case d:
                                case b:
                                case w:
                                case a:
                                    return g;
                                default:
                                    return X;
                            }
                    }
                case r:
                    return X;
            }
        }
    }
    function k(g) {
        return T(g) === f;
    }
    return $d06f17efb06faf2f$var$B.AsyncMode = l, $d06f17efb06faf2f$var$B.ConcurrentMode = f, $d06f17efb06faf2f$var$B.ContextConsumer = c, $d06f17efb06faf2f$var$B.ContextProvider = a, $d06f17efb06faf2f$var$B.Element = t, $d06f17efb06faf2f$var$B.ForwardRef = d, $d06f17efb06faf2f$var$B.Fragment = n, $d06f17efb06faf2f$var$B.Lazy = b, $d06f17efb06faf2f$var$B.Memo = w, $d06f17efb06faf2f$var$B.Portal = r, $d06f17efb06faf2f$var$B.Profiler = i, $d06f17efb06faf2f$var$B.StrictMode = o, $d06f17efb06faf2f$var$B.Suspense = h, $d06f17efb06faf2f$var$B.isAsyncMode = function(g) {
        return k(g) || T(g) === l;
    }, $d06f17efb06faf2f$var$B.isConcurrentMode = k, $d06f17efb06faf2f$var$B.isContextConsumer = function(g) {
        return T(g) === c;
    }, $d06f17efb06faf2f$var$B.isContextProvider = function(g) {
        return T(g) === a;
    }, $d06f17efb06faf2f$var$B.isElement = function(g) {
        return typeof g == "object" && g !== null && g.$$typeof === t;
    }, $d06f17efb06faf2f$var$B.isForwardRef = function(g) {
        return T(g) === d;
    }, $d06f17efb06faf2f$var$B.isFragment = function(g) {
        return T(g) === n;
    }, $d06f17efb06faf2f$var$B.isLazy = function(g) {
        return T(g) === b;
    }, $d06f17efb06faf2f$var$B.isMemo = function(g) {
        return T(g) === w;
    }, $d06f17efb06faf2f$var$B.isPortal = function(g) {
        return T(g) === r;
    }, $d06f17efb06faf2f$var$B.isProfiler = function(g) {
        return T(g) === i;
    }, $d06f17efb06faf2f$var$B.isStrictMode = function(g) {
        return T(g) === o;
    }, $d06f17efb06faf2f$var$B.isSuspense = function(g) {
        return T(g) === h;
    }, $d06f17efb06faf2f$var$B.isValidElementType = function(g) {
        return typeof g == "string" || typeof g == "function" || g === n || g === f || g === i || g === o || g === h || g === y || typeof g == "object" && g !== null && (g.$$typeof === b || g.$$typeof === w || g.$$typeof === a || g.$$typeof === c || g.$$typeof === d || g.$$typeof === R || g.$$typeof === O || g.$$typeof === _ || g.$$typeof === A);
    }, $d06f17efb06faf2f$var$B.typeOf = T, $d06f17efb06faf2f$var$B;
}
var $d06f17efb06faf2f$var$U = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d06f17efb06faf2f$var$Qt;
function $d06f17efb06faf2f$var$Bn() {
    return $d06f17efb06faf2f$var$Qt || ($d06f17efb06faf2f$var$Qt = 1), $d06f17efb06faf2f$var$U;
}
(function(e1) {
    e1.exports = $d06f17efb06faf2f$var$Wn();
})($d06f17efb06faf2f$var$Vn);
function $d06f17efb06faf2f$var$Un(e1) {
    function t(C, E, x, M, u) {
        for(var D = 0, v = 0, K = 0, j = 0, F, p, oe = 0, se = 0, $, ie = $ = F = 0, V = 0, ce = 0, Ee = 0, ue = 0, je = x.length, Ce = je - 1, me, P = "", re = "", De = "", Re = "", we; V < je;){
            if (p = x.charCodeAt(V), V === Ce && v + j + K + D !== 0 && (v !== 0 && (p = v === 47 ? 10 : 47), j = K = D = 0, je++, Ce++), v + j + K + D === 0) {
                if (V === Ce && (0 < ce && (P = P.replace(y, "")), 0 < P.trim().length)) {
                    switch(p){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            P += x.charAt(V);
                    }
                    p = 59;
                }
                switch(p){
                    case 123:
                        for(P = P.trim(), F = P.charCodeAt(0), $ = 1, ue = ++V; V < je;){
                            switch(p = x.charCodeAt(V)){
                                case 123:
                                    $++;
                                    break;
                                case 125:
                                    $--;
                                    break;
                                case 47:
                                    switch(p = x.charCodeAt(V + 1)){
                                        case 42:
                                        case 47:
                                            e: {
                                                for(ie = V + 1; ie < Ce; ++ie)switch(x.charCodeAt(ie)){
                                                    case 47:
                                                        if (p === 42 && x.charCodeAt(ie - 1) === 42 && V + 2 !== ie) {
                                                            V = ie + 1;
                                                            break e;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (p === 47) {
                                                            V = ie + 1;
                                                            break e;
                                                        }
                                                }
                                                V = ie;
                                            }
                                    }
                                    break;
                                case 91:
                                    p++;
                                case 40:
                                    p++;
                                case 34:
                                case 39:
                                    for(; V++ < Ce && x.charCodeAt(V) !== p;);
                            }
                            if ($ === 0) break;
                            V++;
                        }
                        switch($ = x.substring(ue, V), F === 0 && (F = (P = P.replace(h, "").trim()).charCodeAt(0)), F){
                            case 64:
                                switch(0 < ce && (P = P.replace(y, "")), p = P.charCodeAt(1), p){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        ce = E;
                                        break;
                                    default:
                                        ce = he;
                                }
                                if ($ = t(E, ce, $, p, u + 1), ue = $.length, 0 < te && (ce = r(he, P, Ee), we = c(3, $, ce, E, q, Z, ue, p, u, M), P = ce.join(""), we !== void 0 && (ue = ($ = we.trim()).length) === 0 && (p = 0, $ = "")), 0 < ue) switch(p){
                                    case 115:
                                        P = P.replace(X, a);
                                    case 100:
                                    case 109:
                                    case 45:
                                        $ = P + "{" + $ + "}";
                                        break;
                                    case 107:
                                        P = P.replace(_, "$1 $2"), $ = P + "{" + $ + "}", $ = H === 1 || H === 2 && i("@" + $, 3) ? "@-webkit-" + $ + "@" + $ : "@" + $;
                                        break;
                                    default:
                                        $ = P + $, M === 112 && ($ = (re += $, ""));
                                }
                                else $ = "";
                                break;
                            default:
                                $ = t(E, r(E, P, Ee), $, M, u + 1);
                        }
                        De += $, $ = Ee = ce = ie = F = 0, P = "", p = x.charCodeAt(++V);
                        break;
                    case 125:
                    case 59:
                        if (P = (0 < ce ? P.replace(y, "") : P).trim(), 1 < (ue = P.length)) switch(ie === 0 && (F = P.charCodeAt(0), F === 45 || 96 < F && 123 > F) && (ue = (P = P.replace(" ", ":")).length), 0 < te && (we = c(1, P, E, C, q, Z, re.length, M, u, M)) !== void 0 && (ue = (P = we.trim()).length) === 0 && (P = "\x00\x00"), F = P.charCodeAt(0), p = P.charCodeAt(1), F){
                            case 0:
                                break;
                            case 64:
                                if (p === 105 || p === 99) {
                                    Re += P + x.charAt(V);
                                    break;
                                }
                            default:
                                P.charCodeAt(ue - 1) !== 58 && (re += o(P, F, p, P.charCodeAt(2)));
                        }
                        Ee = ce = ie = F = 0, P = "", p = x.charCodeAt(++V);
                }
            }
            switch(p){
                case 13:
                case 10:
                    v === 47 ? v = 0 : 1 + F === 0 && M !== 107 && 0 < P.length && (ce = 1, P += "\x00"), 0 < te * ye && c(0, P, E, C, q, Z, re.length, M, u, M), Z = 1, q++;
                    break;
                case 59:
                case 125:
                    if (v + j + K + D === 0) {
                        Z++;
                        break;
                    }
                default:
                    switch(Z++, me = x.charAt(V), p){
                        case 9:
                        case 32:
                            if (j + D + v === 0) switch(oe){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    me = "";
                                    break;
                                default:
                                    p !== 32 && (me = " ");
                            }
                            break;
                        case 0:
                            me = "\\0";
                            break;
                        case 12:
                            me = "\\f";
                            break;
                        case 11:
                            me = "\\v";
                            break;
                        case 38:
                            j + v + D === 0 && (ce = Ee = 1, me = "\f" + me);
                            break;
                        case 108:
                            if (j + v + D + Y === 0 && 0 < ie) switch(V - ie){
                                case 2:
                                    oe === 112 && x.charCodeAt(V - 3) === 58 && (Y = oe);
                                case 8:
                                    se === 111 && (Y = se);
                            }
                            break;
                        case 58:
                            j + v + D === 0 && (ie = V);
                            break;
                        case 44:
                            v + K + j + D === 0 && (ce = 1, me += "\r");
                            break;
                        case 34:
                        case 39:
                            v === 0 && (j = j === p ? 0 : j === 0 ? p : j);
                            break;
                        case 91:
                            j + v + K === 0 && D++;
                            break;
                        case 93:
                            j + v + K === 0 && D--;
                            break;
                        case 41:
                            j + v + D === 0 && K--;
                            break;
                        case 40:
                            if (j + v + D === 0) {
                                if (F === 0) switch(2 * oe + 3 * se){
                                    case 533:
                                        break;
                                    default:
                                        F = 1;
                                }
                                K++;
                            }
                            break;
                        case 64:
                            v + K + j + D + ie + $ === 0 && ($ = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < j + D + K)) switch(v){
                                case 0:
                                    switch(2 * p + 3 * x.charCodeAt(V + 1)){
                                        case 235:
                                            v = 47;
                                            break;
                                        case 220:
                                            ue = V, v = 42;
                                    }
                                    break;
                                case 42:
                                    p === 47 && oe === 42 && ue + 2 !== V && (x.charCodeAt(ue + 2) === 33 && (re += x.substring(ue, V + 1)), me = "", v = 0);
                            }
                    }
                    v === 0 && (P += me);
            }
            se = oe, oe = p, V++;
        }
        if (ue = re.length, 0 < ue) {
            if (ce = E, 0 < te && (we = c(2, re, ce, C, q, Z, ue, M, u, M), we !== void 0 && (re = we).length === 0)) return Re + re + De;
            if (re = ce.join(",") + "{" + re + "}", H * Y !== 0) {
                switch(H !== 2 || i(re, 2) || (Y = 0), Y){
                    case 111:
                        re = re.replace(k, ":-moz-$1") + re;
                        break;
                    case 112:
                        re = re.replace(T, "::-webkit-input-$1") + re.replace(T, "::-moz-$1") + re.replace(T, ":-ms-input-$1") + re;
                }
                Y = 0;
            }
        }
        return Re + re + De;
    }
    function r(C, E, x) {
        var M = E.trim().split(R);
        E = M;
        var u = M.length, D = C.length;
        switch(D){
            case 0:
            case 1:
                var v = 0;
                for(C = D === 0 ? "" : C[0] + " "; v < u; ++v)E[v] = n(C, E[v], x).trim();
                break;
            default:
                var K = v = 0;
                for(E = []; v < u; ++v)for(var j = 0; j < D; ++j)E[K++] = n(C[j] + " ", M[v], x).trim();
        }
        return E;
    }
    function n(C, E, x) {
        var M = E.charCodeAt(0);
        switch(33 > M && (M = (E = E.trim()).charCodeAt(0)), M){
            case 38:
                return E.replace(O, "$1" + C.trim());
            case 58:
                return C.trim() + E.replace(O, "$1" + C.trim());
            default:
                if (0 < 1 * x && 0 < E.indexOf("\f")) return E.replace(O, (C.charCodeAt(0) === 58 ? "" : "$1") + C.trim());
        }
        return C + E;
    }
    function o(C, E, x, M) {
        var u = C + ";", D = 2 * E + 3 * x + 4 * M;
        if (D === 944) {
            C = u.indexOf(":", 9) + 1;
            var v = u.substring(C, u.length - 1).trim();
            return v = u.substring(0, C).trim() + v + ";", H === 1 || H === 2 && i(v, 1) ? "-webkit-" + v + v : v;
        }
        if (H === 0 || H === 2 && !i(u, 1)) return u;
        switch(D){
            case 1015:
                return u.charCodeAt(10) === 97 ? "-webkit-" + u + u : u;
            case 951:
                return u.charCodeAt(3) === 116 ? "-webkit-" + u + u : u;
            case 963:
                return u.charCodeAt(5) === 110 ? "-webkit-" + u + u : u;
            case 1009:
                if (u.charCodeAt(4) !== 100) break;
            case 969:
            case 942:
                return "-webkit-" + u + u;
            case 978:
                return "-webkit-" + u + "-moz-" + u + u;
            case 1019:
            case 983:
                return "-webkit-" + u + "-moz-" + u + "-ms-" + u + u;
            case 883:
                if (u.charCodeAt(8) === 45) return "-webkit-" + u + u;
                if (0 < u.indexOf("image-set(", 11)) return u.replace(de, "$1-webkit-$2") + u;
                break;
            case 932:
                if (u.charCodeAt(4) === 45) switch(u.charCodeAt(5)){
                    case 103:
                        return "-webkit-box-" + u.replace("-grow", "") + "-webkit-" + u + "-ms-" + u.replace("grow", "positive") + u;
                    case 115:
                        return "-webkit-" + u + "-ms-" + u.replace("shrink", "negative") + u;
                    case 98:
                        return "-webkit-" + u + "-ms-" + u.replace("basis", "preferred-size") + u;
                }
                return "-webkit-" + u + "-ms-" + u + u;
            case 964:
                return "-webkit-" + u + "-ms-flex-" + u + u;
            case 1023:
                if (u.charCodeAt(8) !== 99) break;
                return v = u.substring(u.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify"), "-webkit-box-pack" + v + "-webkit-" + u + "-ms-flex-pack" + v + u;
            case 1005:
                return b.test(u) ? u.replace(w, ":-webkit-") + u.replace(w, ":-moz-") + u : u;
            case 1e3:
                switch(v = u.substring(13).trim(), E = v.indexOf("-") + 1, v.charCodeAt(0) + v.charCodeAt(E)){
                    case 226:
                        v = u.replace(g, "tb");
                        break;
                    case 232:
                        v = u.replace(g, "tb-rl");
                        break;
                    case 220:
                        v = u.replace(g, "lr");
                        break;
                    default:
                        return u;
                }
                return "-webkit-" + u + "-ms-" + v + u;
            case 1017:
                if (u.indexOf("sticky", 9) === -1) break;
            case 975:
                switch(E = (u = C).length - 10, v = (u.charCodeAt(E) === 33 ? u.substring(0, E) : u).substring(C.indexOf(":", 7) + 1).trim(), D = v.charCodeAt(0) + (v.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > v.charCodeAt(8)) break;
                    case 115:
                        u = u.replace(v, "-webkit-" + v) + ";" + u;
                        break;
                    case 207:
                    case 102:
                        u = u.replace(v, "-webkit-" + (102 < D ? "inline-" : "") + "box") + ";" + u.replace(v, "-webkit-" + v) + ";" + u.replace(v, "-ms-" + v + "box") + ";" + u;
                }
                return u + ";";
            case 938:
                if (u.charCodeAt(5) === 45) switch(u.charCodeAt(6)){
                    case 105:
                        return v = u.replace("-items", ""), "-webkit-" + u + "-webkit-box-" + v + "-ms-flex-" + v + u;
                    case 115:
                        return "-webkit-" + u + "-ms-flex-item-" + u.replace(G, "") + u;
                    default:
                        return "-webkit-" + u + "-ms-flex-line-pack" + u.replace("align-content", "").replace(G, "") + u;
                }
                break;
            case 973:
            case 989:
                if (u.charCodeAt(3) !== 45 || u.charCodeAt(4) === 122) break;
            case 931:
            case 953:
                if (fe.test(C) === !0) return (v = C.substring(C.indexOf(":") + 1)).charCodeAt(0) === 115 ? o(C.replace("stretch", "fill-available"), E, x, M).replace(":fill-available", ":stretch") : u.replace(v, "-webkit-" + v) + u.replace(v, "-moz-" + v.replace("fill-", "")) + u;
                break;
            case 962:
                if (u = "-webkit-" + u + (u.charCodeAt(5) === 102 ? "-ms-" + u : "") + u, x + M === 211 && u.charCodeAt(13) === 105 && 0 < u.indexOf("transform", 10)) return u.substring(0, u.indexOf(";", 27) + 1).replace(A, "$1-webkit-$2") + u;
        }
        return u;
    }
    function i(C, E) {
        var x = C.indexOf(E === 1 ? ":" : "{"), M = C.substring(0, E !== 3 ? x : 10);
        return x = C.substring(x + 1, C.length - 1), ve(E !== 2 ? M : M.replace(Q, "$1"), x, E);
    }
    function a(C, E) {
        var x = o(E, E.charCodeAt(0), E.charCodeAt(1), E.charCodeAt(2));
        return x !== E + ";" ? x.replace(J, " or ($1)").substring(4) : "(" + E + ")";
    }
    function c(C, E, x, M, u, D, v, K, j, F) {
        for(var p = 0, oe = E, se; p < te; ++p)switch(se = ne[p].call(d, C, oe, x, M, u, D, v, K, j, F)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                oe = se;
        }
        if (oe !== E) return oe;
    }
    function l(C) {
        switch(C){
            case void 0:
            case null:
                te = ne.length = 0;
                break;
            default:
                if (typeof C == "function") ne[te++] = C;
                else if (typeof C == "object") for(var E = 0, x = C.length; E < x; ++E)l(C[E]);
                else ye = !!C | 0;
        }
        return l;
    }
    function f(C) {
        return C = C.prefix, C !== void 0 && (ve = null, C ? typeof C != "function" ? H = 1 : (H = 2, ve = C) : H = 0), f;
    }
    function d(C, E) {
        var x = C;
        if (33 > x.charCodeAt(0) && (x = x.trim()), Se = x, x = [
            Se
        ], 0 < te) {
            var M = c(-1, E, x, x, q, Z, 0, 0, 0, 0);
            M !== void 0 && typeof M == "string" && (E = M);
        }
        var u = t(he, x, E, 0, 0);
        return 0 < te && (M = c(-2, u, x, x, q, Z, u.length, 0, 0, 0), M !== void 0 && (u = M)), Se = "", Y = 0, Z = q = 1, u;
    }
    var h = /^\0+/g, y = /[\0\r\f]/g, w = /: */g, b = /zoo|gra/, A = /([,: ])(transform)/g, R = /,\r+?/g, O = /([\t\r\n ])*\f?&/g, _ = /@(k\w+)\s*(\S*)\s*/, T = /::(place)/g, k = /:(read-only)/g, g = /[svh]\w+-[tblr]{2}/, X = /\(\s*(.*)\s*\)/g, J = /([\s\S]*?);/g, G = /-self|flex-/g, Q = /[^]*?(:[rp][el]a[\w-]+)[^]*/, fe = /stretch|:\s*\w+\-(?:conte|avail)/, de = /([^-])(image-set\()/, Z = 1, q = 1, Y = 0, H = 1, he = [], ne = [], te = 0, ve = null, ye = 0, Se = "";
    return d.use = l, d.set = f, e1 !== void 0 && f(e1), d;
}
var $d06f17efb06faf2f$var$Gn = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
function $d06f17efb06faf2f$var$Hn(e1) {
    var t = /* @__PURE__ */ Object.create(null);
    return function(r) {
        return t[r] === void 0 && (t[r] = e1(r)), t[r];
    };
}
var $d06f17efb06faf2f$var$Kn = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, $d06f17efb06faf2f$var$Zt = /* @__PURE__ */ $d06f17efb06faf2f$var$Hn(function(e1) {
    return $d06f17efb06faf2f$var$Kn.test(e1) || e1.charCodeAt(0) === 111 && e1.charCodeAt(1) === 110 && e1.charCodeAt(2) < 91;
}), $d06f17efb06faf2f$var$kt = $d06f17efb06faf2f$var$Ye, $d06f17efb06faf2f$var$Xn = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
}, $d06f17efb06faf2f$var$Jn = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, $d06f17efb06faf2f$var$Qn = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
}, $d06f17efb06faf2f$var$Sr = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, $d06f17efb06faf2f$var$Tt = {};
$d06f17efb06faf2f$var$Tt[$d06f17efb06faf2f$var$kt.ForwardRef] = $d06f17efb06faf2f$var$Qn;
$d06f17efb06faf2f$var$Tt[$d06f17efb06faf2f$var$kt.Memo] = $d06f17efb06faf2f$var$Sr;
function $d06f17efb06faf2f$var$qt(e1) {
    return $d06f17efb06faf2f$var$kt.isMemo(e1) ? $d06f17efb06faf2f$var$Sr : $d06f17efb06faf2f$var$Tt[e1.$$typeof] || $d06f17efb06faf2f$var$Xn;
}
var $d06f17efb06faf2f$var$Zn = Object.defineProperty, $d06f17efb06faf2f$var$qn = Object.getOwnPropertyNames, $d06f17efb06faf2f$var$er = Object.getOwnPropertySymbols, $d06f17efb06faf2f$var$eo = Object.getOwnPropertyDescriptor, $d06f17efb06faf2f$var$to = Object.getPrototypeOf, $d06f17efb06faf2f$var$tr = Object.prototype;
function $d06f17efb06faf2f$var$Er(e1, t, r) {
    if (typeof t != "string") {
        if ($d06f17efb06faf2f$var$tr) {
            var n = $d06f17efb06faf2f$var$to(t);
            n && n !== $d06f17efb06faf2f$var$tr && $d06f17efb06faf2f$var$Er(e1, n, r);
        }
        var o = $d06f17efb06faf2f$var$qn(t);
        $d06f17efb06faf2f$var$er && (o = o.concat($d06f17efb06faf2f$var$er(t)));
        for(var i = $d06f17efb06faf2f$var$qt(e1), a = $d06f17efb06faf2f$var$qt(t), c = 0; c < o.length; ++c){
            var l = o[c];
            if (!$d06f17efb06faf2f$var$Jn[l] && !(r && r[l]) && !(a && a[l]) && !(i && i[l])) {
                var f = $d06f17efb06faf2f$var$eo(t, l);
                try {
                    $d06f17efb06faf2f$var$Zn(e1, l, f);
                } catch  {}
            }
        }
    }
    return e1;
}
var $d06f17efb06faf2f$var$ro = $d06f17efb06faf2f$var$Er;
function $d06f17efb06faf2f$var$xe() {
    return ($d06f17efb06faf2f$var$xe = Object.assign || function(e1) {
        for(var t = 1; t < arguments.length; t++){
            var r = arguments[t];
            for(var n in r)Object.prototype.hasOwnProperty.call(r, n) && (e1[n] = r[n]);
        }
        return e1;
    }).apply(this, arguments);
}
var $d06f17efb06faf2f$var$rr = function(e1, t) {
    for(var r = [
        e1[0]
    ], n = 0, o = t.length; n < o; n += 1)r.push(t[n], e1[n + 1]);
    return r;
}, $d06f17efb06faf2f$var$Et = function(e1) {
    return e1 !== null && typeof e1 == "object" && (e1.toString ? e1.toString() : Object.prototype.toString.call(e1)) === "[object Object]" && !$d06f17efb06faf2f$var$Ye.typeOf(e1);
}, $d06f17efb06faf2f$var$rt = Object.freeze([]), $d06f17efb06faf2f$var$Oe = Object.freeze({});
function $d06f17efb06faf2f$var$He(e1) {
    return typeof e1 == "function";
}
function $d06f17efb06faf2f$var$wt(e1) {
    return (0, e1.displayName) || e1.name || "Component";
}
function $d06f17efb06faf2f$var$Ot(e1) {
    return e1 && typeof e1.styledComponentId == "string";
}
var $d06f17efb06faf2f$var$ze = (typeof $cfae44f0dfdf62c0$exports < "u" && undefined, "data-styled"), $d06f17efb06faf2f$var$Pt = typeof window < "u" && "HTMLElement" in window, $d06f17efb06faf2f$var$no = Boolean(typeof SC_DISABLE_SPEEDY == "boolean" ? SC_DISABLE_SPEEDY : (typeof $cfae44f0dfdf62c0$exports, typeof $cfae44f0dfdf62c0$exports, false)), $d06f17efb06faf2f$var$oo = {}, $d06f17efb06faf2f$var$so = {};
function $d06f17efb06faf2f$var$io() {
    for(var e1 = arguments.length <= 0 ? void 0 : arguments[0], t = [], r = 1, n = arguments.length; r < n; r += 1)t.push(r < 0 || arguments.length <= r ? void 0 : arguments[r]);
    return t.forEach(function(o) {
        e1 = e1.replace(/%[a-z]/, o);
    }), e1;
}
function $d06f17efb06faf2f$var$We(e1) {
    for(var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)r[n - 1] = arguments[n];
    throw new Error("An error occurred. See https://git.io/JUIaE#" + e1 + " for more information." + (r.length > 0 ? " Args: " + r.join(", ") : ""));
}
var $d06f17efb06faf2f$var$ao = function() {
    function e1(r) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = r;
    }
    var t = e1.prototype;
    return t.indexOfGroup = function(r) {
        for(var n = 0, o = 0; o < r; o++)n += this.groupSizes[o];
        return n;
    }, t.insertRules = function(r, n) {
        if (r >= this.groupSizes.length) {
            for(var o = this.groupSizes, i = o.length, a = i; r >= a;)(a <<= 1) < 0 && $d06f17efb06faf2f$var$We(16, "" + r);
            this.groupSizes = new Uint32Array(a), this.groupSizes.set(o), this.length = a;
            for(var c = i; c < a; c++)this.groupSizes[c] = 0;
        }
        for(var l = this.indexOfGroup(r + 1), f = 0, d = n.length; f < d; f++)this.tag.insertRule(l, n[f]) && (this.groupSizes[r]++, l++);
    }, t.clearGroup = function(r) {
        if (r < this.length) {
            var n = this.groupSizes[r], o = this.indexOfGroup(r), i = o + n;
            this.groupSizes[r] = 0;
            for(var a = o; a < i; a++)this.tag.deleteRule(o);
        }
    }, t.getGroup = function(r) {
        var n = "";
        if (r >= this.length || this.groupSizes[r] === 0) return n;
        for(var o = this.groupSizes[r], i = this.indexOfGroup(r), a = i + o, c = i; c < a; c++)n += this.tag.getRule(c) + `/*!sc*/
`;
        return n;
    }, e1;
}(), $d06f17efb06faf2f$var$qe = /* @__PURE__ */ new Map(), $d06f17efb06faf2f$var$nt = /* @__PURE__ */ new Map(), $d06f17efb06faf2f$var$Ge = 1, $d06f17efb06faf2f$var$Je = function(e1) {
    if ($d06f17efb06faf2f$var$qe.has(e1)) return $d06f17efb06faf2f$var$qe.get(e1);
    for(; $d06f17efb06faf2f$var$nt.has($d06f17efb06faf2f$var$Ge);)$d06f17efb06faf2f$var$Ge++;
    var t = $d06f17efb06faf2f$var$Ge++;
    return $d06f17efb06faf2f$var$qe.set(e1, t), $d06f17efb06faf2f$var$nt.set(t, e1), t;
}, $d06f17efb06faf2f$var$co = function(e1) {
    return $d06f17efb06faf2f$var$nt.get(e1);
}, $d06f17efb06faf2f$var$lo = function(e1, t) {
    t >= $d06f17efb06faf2f$var$Ge && ($d06f17efb06faf2f$var$Ge = t + 1), $d06f17efb06faf2f$var$qe.set(e1, t), $d06f17efb06faf2f$var$nt.set(t, e1);
}, $d06f17efb06faf2f$var$uo = "style[" + $d06f17efb06faf2f$var$ze + '][data-styled-version="5.3.6"]', $d06f17efb06faf2f$var$fo = new RegExp("^" + $d06f17efb06faf2f$var$ze + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), $d06f17efb06faf2f$var$ho = function(e1, t, r) {
    for(var n, o = r.split(","), i = 0, a = o.length; i < a; i++)(n = o[i]) && e1.registerName(t, n);
}, $d06f17efb06faf2f$var$po = function(e1, t) {
    for(var r = (t.textContent || "").split(`/*!sc*/
`), n = [], o = 0, i = r.length; o < i; o++){
        var a = r[o].trim();
        if (a) {
            var c = a.match($d06f17efb06faf2f$var$fo);
            if (c) {
                var l = 0 | parseInt(c[1], 10), f = c[2];
                l !== 0 && ($d06f17efb06faf2f$var$lo(f, l), $d06f17efb06faf2f$var$ho(e1, f, c[3]), e1.getTag().insertRules(l, n)), n.length = 0;
            } else n.push(a);
        }
    }
}, $d06f17efb06faf2f$var$mo = function() {
    return typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : null;
}, $d06f17efb06faf2f$var$wr = function(e1) {
    var t = document.head, r = e1 || t, n = document.createElement("style"), o = function(c) {
        for(var l = c.childNodes, f = l.length; f >= 0; f--){
            var d = l[f];
            if (d && d.nodeType === 1 && d.hasAttribute($d06f17efb06faf2f$var$ze)) return d;
        }
    }(r), i = o !== void 0 ? o.nextSibling : null;
    n.setAttribute($d06f17efb06faf2f$var$ze, "active"), n.setAttribute("data-styled-version", "5.3.6");
    var a = $d06f17efb06faf2f$var$mo();
    return a && n.setAttribute("nonce", a), r.insertBefore(n, i), n;
}, $d06f17efb06faf2f$var$go = function() {
    function e1(r) {
        var n = this.element = $d06f17efb06faf2f$var$wr(r);
        n.appendChild(document.createTextNode("")), this.sheet = function(o) {
            if (o.sheet) return o.sheet;
            for(var i = document.styleSheets, a = 0, c = i.length; a < c; a++){
                var l = i[a];
                if (l.ownerNode === o) return l;
            }
            $d06f17efb06faf2f$var$We(17);
        }(n), this.length = 0;
    }
    var t = e1.prototype;
    return t.insertRule = function(r, n) {
        try {
            return this.sheet.insertRule(n, r), this.length++, !0;
        } catch  {
            return !1;
        }
    }, t.deleteRule = function(r) {
        this.sheet.deleteRule(r), this.length--;
    }, t.getRule = function(r) {
        var n = this.sheet.cssRules[r];
        return n !== void 0 && typeof n.cssText == "string" ? n.cssText : "";
    }, e1;
}(), $d06f17efb06faf2f$var$vo = function() {
    function e1(r) {
        var n = this.element = $d06f17efb06faf2f$var$wr(r);
        this.nodes = n.childNodes, this.length = 0;
    }
    var t = e1.prototype;
    return t.insertRule = function(r, n) {
        if (r <= this.length && r >= 0) {
            var o = document.createTextNode(n), i = this.nodes[r];
            return this.element.insertBefore(o, i || null), this.length++, !0;
        }
        return !1;
    }, t.deleteRule = function(r) {
        this.element.removeChild(this.nodes[r]), this.length--;
    }, t.getRule = function(r) {
        return r < this.length ? this.nodes[r].textContent : "";
    }, e1;
}(), $d06f17efb06faf2f$var$yo = function() {
    function e1(r) {
        this.rules = [], this.length = 0;
    }
    var t = e1.prototype;
    return t.insertRule = function(r, n) {
        return r <= this.length && (this.rules.splice(r, 0, n), this.length++, !0);
    }, t.deleteRule = function(r) {
        this.rules.splice(r, 1), this.length--;
    }, t.getRule = function(r) {
        return r < this.length ? this.rules[r] : "";
    }, e1;
}(), $d06f17efb06faf2f$var$nr = $d06f17efb06faf2f$var$Pt, $d06f17efb06faf2f$var$bo = {
    isServer: !$d06f17efb06faf2f$var$Pt,
    useCSSOMInjection: !$d06f17efb06faf2f$var$no
}, $d06f17efb06faf2f$var$ot = function() {
    function e1(r, n, o) {
        r === void 0 && (r = $d06f17efb06faf2f$var$Oe), n === void 0 && (n = {}), this.options = $d06f17efb06faf2f$var$xe({}, $d06f17efb06faf2f$var$bo, {}, r), this.gs = n, this.names = new Map(o), this.server = !!r.isServer, !this.server && $d06f17efb06faf2f$var$Pt && $d06f17efb06faf2f$var$nr && ($d06f17efb06faf2f$var$nr = !1, function(i) {
            for(var a = document.querySelectorAll($d06f17efb06faf2f$var$uo), c = 0, l = a.length; c < l; c++){
                var f = a[c];
                f && f.getAttribute($d06f17efb06faf2f$var$ze) !== "active" && ($d06f17efb06faf2f$var$po(i, f), f.parentNode && f.parentNode.removeChild(f));
            }
        }(this));
    }
    e1.registerId = function(r) {
        return $d06f17efb06faf2f$var$Je(r);
    };
    var t = e1.prototype;
    return t.reconstructWithOptions = function(r, n) {
        return n === void 0 && (n = !0), new e1($d06f17efb06faf2f$var$xe({}, this.options, {}, r), this.gs, n && this.names || void 0);
    }, t.allocateGSInstance = function(r) {
        return this.gs[r] = (this.gs[r] || 0) + 1;
    }, t.getTag = function() {
        var r, n, o, i, a;
        return this.tag || (this.tag = (o = (n = this.options).isServer, i = n.useCSSOMInjection, a = n.target, r = o ? new $d06f17efb06faf2f$var$yo(a) : i ? new $d06f17efb06faf2f$var$go(a) : new $d06f17efb06faf2f$var$vo(a), new $d06f17efb06faf2f$var$ao(r)));
    }, t.hasNameForId = function(r, n) {
        return this.names.has(r) && this.names.get(r).has(n);
    }, t.registerName = function(r, n) {
        if ($d06f17efb06faf2f$var$Je(r), this.names.has(r)) this.names.get(r).add(n);
        else {
            var o = /* @__PURE__ */ new Set();
            o.add(n), this.names.set(r, o);
        }
    }, t.insertRules = function(r, n, o) {
        this.registerName(r, n), this.getTag().insertRules($d06f17efb06faf2f$var$Je(r), o);
    }, t.clearNames = function(r) {
        this.names.has(r) && this.names.get(r).clear();
    }, t.clearRules = function(r) {
        this.getTag().clearGroup($d06f17efb06faf2f$var$Je(r)), this.clearNames(r);
    }, t.clearTag = function() {
        this.tag = void 0;
    }, t.toString = function() {
        return function(r) {
            for(var n = r.getTag(), o = n.length, i = "", a = 0; a < o; a++){
                var c = $d06f17efb06faf2f$var$co(a);
                if (c !== void 0) {
                    var l = r.names.get(c), f = n.getGroup(a);
                    if (l && f && l.size) {
                        var d = $d06f17efb06faf2f$var$ze + ".g" + a + '[id="' + c + '"]', h = "";
                        l !== void 0 && l.forEach(function(y) {
                            y.length > 0 && (h += y + ",");
                        }), i += "" + f + d + '{content:"' + h + `"}/*!sc*/
`;
                    }
                }
            }
            return i;
        }(this);
    }, e1;
}(), $d06f17efb06faf2f$var$So = /(a)(d)/gi, $d06f17efb06faf2f$var$or = function(e1) {
    return String.fromCharCode(e1 + (e1 > 25 ? 39 : 97));
};
function $d06f17efb06faf2f$var$_t(e1) {
    var t, r = "";
    for(t = Math.abs(e1); t > 52; t = t / 52 | 0)r = $d06f17efb06faf2f$var$or(t % 52) + r;
    return ($d06f17efb06faf2f$var$or(t % 52) + r).replace($d06f17efb06faf2f$var$So, "$1-$2");
}
var $d06f17efb06faf2f$var$Ne = function(e1, t) {
    for(var r = t.length; r;)e1 = 33 * e1 ^ t.charCodeAt(--r);
    return e1;
}, $d06f17efb06faf2f$var$_r = function(e1) {
    return $d06f17efb06faf2f$var$Ne(5381, e1);
};
function $d06f17efb06faf2f$var$xr(e1) {
    for(var t = 0; t < e1.length; t += 1){
        var r = e1[t];
        if ($d06f17efb06faf2f$var$He(r) && !$d06f17efb06faf2f$var$Ot(r)) return !1;
    }
    return !0;
}
var $d06f17efb06faf2f$var$Eo = $d06f17efb06faf2f$var$_r("5.3.6"), $d06f17efb06faf2f$var$wo = function() {
    function e1(t, r, n) {
        this.rules = t, this.staticRulesId = "", this.isStatic = (n === void 0 || n.isStatic) && $d06f17efb06faf2f$var$xr(t), this.componentId = r, this.baseHash = $d06f17efb06faf2f$var$Ne($d06f17efb06faf2f$var$Eo, r), this.baseStyle = n, $d06f17efb06faf2f$var$ot.registerId(r);
    }
    return e1.prototype.generateAndInjectStyles = function(t, r, n) {
        var o = this.componentId, i = [];
        if (this.baseStyle && i.push(this.baseStyle.generateAndInjectStyles(t, r, n)), this.isStatic && !n.hash) {
            if (this.staticRulesId && r.hasNameForId(o, this.staticRulesId)) i.push(this.staticRulesId);
            else {
                var a = $d06f17efb06faf2f$var$$e(this.rules, t, r, n).join(""), c = $d06f17efb06faf2f$var$_t($d06f17efb06faf2f$var$Ne(this.baseHash, a) >>> 0);
                if (!r.hasNameForId(o, c)) {
                    var l = n(a, "." + c, void 0, o);
                    r.insertRules(o, c, l);
                }
                i.push(c), this.staticRulesId = c;
            }
        } else {
            for(var f = this.rules.length, d = $d06f17efb06faf2f$var$Ne(this.baseHash, n.hash), h = "", y = 0; y < f; y++){
                var w = this.rules[y];
                if (typeof w == "string") h += w;
                else if (w) {
                    var b = $d06f17efb06faf2f$var$$e(w, t, r, n), A = Array.isArray(b) ? b.join("") : b;
                    d = $d06f17efb06faf2f$var$Ne(d, A + y), h += A;
                }
            }
            if (h) {
                var R = $d06f17efb06faf2f$var$_t(d >>> 0);
                if (!r.hasNameForId(o, R)) {
                    var O = n(h, "." + R, void 0, o);
                    r.insertRules(o, R, O);
                }
                i.push(R);
            }
        }
        return i.join(" ");
    }, e1;
}(), $d06f17efb06faf2f$var$_o = /^\s*\/\/.*$/gm, $d06f17efb06faf2f$var$xo = [
    ":",
    "[",
    ".",
    "#"
];
function $d06f17efb06faf2f$var$Co(e1) {
    var t, r, n, o, i = e1 === void 0 ? $d06f17efb06faf2f$var$Oe : e1, a = i.options, c = a === void 0 ? $d06f17efb06faf2f$var$Oe : a, l = i.plugins, f = l === void 0 ? $d06f17efb06faf2f$var$rt : l, d = new $d06f17efb06faf2f$var$Un(c), h = [], y = function(A) {
        function R(O) {
            if (O) try {
                A(O + "}");
            } catch  {}
        }
        return function(O, _, T, k, g, X, J, G, Q, fe) {
            switch(O){
                case 1:
                    if (Q === 0 && _.charCodeAt(0) === 64) return A(_ + ";"), "";
                    break;
                case 2:
                    if (G === 0) return _ + "/*|*/";
                    break;
                case 3:
                    switch(G){
                        case 102:
                        case 112:
                            return A(T[0] + _), "";
                        default:
                            return _ + (fe === 0 ? "/*|*/" : "");
                    }
                case -2:
                    _.split("/*|*/}").forEach(R);
            }
        };
    }(function(A) {
        h.push(A);
    }), w = function(A, R, O) {
        return R === 0 && $d06f17efb06faf2f$var$xo.indexOf(O[r.length]) !== -1 || O.match(o) ? A : "." + t;
    };
    function b(A, R, O, _) {
        _ === void 0 && (_ = "&");
        var T = A.replace($d06f17efb06faf2f$var$_o, ""), k = R && O ? O + " " + R + " { " + T + " }" : T;
        return t = _, r = R, n = new RegExp("\\" + r + "\\b", "g"), o = new RegExp("(\\" + r + "\\b){2,}"), d(O || !R ? "" : R, k);
    }
    return d.use([].concat(f, [
        function(A, R, O) {
            A === 2 && O.length && O[0].lastIndexOf(r) > 0 && (O[0] = O[0].replace(n, w));
        },
        y,
        function(A) {
            if (A === -2) {
                var R = h;
                return h = [], R;
            }
        }
    ])), b.hash = f.length ? f.reduce(function(A, R) {
        return R.name || $d06f17efb06faf2f$var$We(15), $d06f17efb06faf2f$var$Ne(A, R.name);
    }, 5381).toString() : "", b;
}
var $d06f17efb06faf2f$var$Cr = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext();
$d06f17efb06faf2f$var$Cr.Consumer;
var $d06f17efb06faf2f$var$Rr = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(), $d06f17efb06faf2f$var$Ro = ($d06f17efb06faf2f$var$Rr.Consumer, new $d06f17efb06faf2f$var$ot()), $d06f17efb06faf2f$var$xt = $d06f17efb06faf2f$var$Co();
function $d06f17efb06faf2f$var$Ar() {
    return (0, $acw62.useContext)($d06f17efb06faf2f$var$Cr) || $d06f17efb06faf2f$var$Ro;
}
function $d06f17efb06faf2f$var$kr() {
    return (0, $acw62.useContext)($d06f17efb06faf2f$var$Rr) || $d06f17efb06faf2f$var$xt;
}
var $d06f17efb06faf2f$var$Ao = function() {
    function e1(t, r) {
        var n = this;
        this.inject = function(o, i) {
            i === void 0 && (i = $d06f17efb06faf2f$var$xt);
            var a = n.name + i.hash;
            o.hasNameForId(n.id, a) || o.insertRules(n.id, a, i(n.rules, a, "@keyframes"));
        }, this.toString = function() {
            return $d06f17efb06faf2f$var$We(12, String(n.name));
        }, this.name = t, this.id = "sc-keyframes-" + t, this.rules = r;
    }
    return e1.prototype.getName = function(t) {
        return t === void 0 && (t = $d06f17efb06faf2f$var$xt), this.name + t.hash;
    }, e1;
}(), $d06f17efb06faf2f$var$ko = /([A-Z])/, $d06f17efb06faf2f$var$To = /([A-Z])/g, $d06f17efb06faf2f$var$Oo = /^ms-/, $d06f17efb06faf2f$var$Po = function(e1) {
    return "-" + e1.toLowerCase();
};
function $d06f17efb06faf2f$var$sr(e1) {
    return $d06f17efb06faf2f$var$ko.test(e1) ? e1.replace($d06f17efb06faf2f$var$To, $d06f17efb06faf2f$var$Po).replace($d06f17efb06faf2f$var$Oo, "-ms-") : e1;
}
var $d06f17efb06faf2f$var$ir = function(e1) {
    return e1 == null || e1 === !1 || e1 === "";
};
function $d06f17efb06faf2f$var$$e(e1, t, r, n) {
    if (Array.isArray(e1)) {
        for(var o, i = [], a = 0, c = e1.length; a < c; a += 1)(o = $d06f17efb06faf2f$var$$e(e1[a], t, r, n)) !== "" && (Array.isArray(o) ? i.push.apply(i, o) : i.push(o));
        return i;
    }
    if ($d06f17efb06faf2f$var$ir(e1)) return "";
    if ($d06f17efb06faf2f$var$Ot(e1)) return "." + e1.styledComponentId;
    if ($d06f17efb06faf2f$var$He(e1)) {
        if (typeof (f = e1) != "function" || f.prototype && f.prototype.isReactComponent || !t) return e1;
        var l = e1(t);
        return $d06f17efb06faf2f$var$$e(l, t, r, n);
    }
    var f;
    return e1 instanceof $d06f17efb06faf2f$var$Ao ? r ? (e1.inject(r, n), e1.getName(n)) : e1 : $d06f17efb06faf2f$var$Et(e1) ? function d(h, y) {
        var w, b, A = [];
        for(var R in h)h.hasOwnProperty(R) && !$d06f17efb06faf2f$var$ir(h[R]) && (Array.isArray(h[R]) && h[R].isCss || $d06f17efb06faf2f$var$He(h[R]) ? A.push($d06f17efb06faf2f$var$sr(R) + ":", h[R], ";") : $d06f17efb06faf2f$var$Et(h[R]) ? A.push.apply(A, d(h[R], R)) : A.push($d06f17efb06faf2f$var$sr(R) + ": " + (w = R, (b = h[R]) == null || typeof b == "boolean" || b === "" ? "" : typeof b != "number" || b === 0 || w in $d06f17efb06faf2f$var$Gn ? String(b).trim() : b + "px") + ";"));
        return y ? [
            y + " {"
        ].concat(A, [
            "}"
        ]) : A;
    }(e1) : e1.toString();
}
var $d06f17efb06faf2f$var$ar = function(e1) {
    return Array.isArray(e1) && (e1.isCss = !0), e1;
};
function $d06f17efb06faf2f$var$Tr(e1) {
    for(var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)r[n - 1] = arguments[n];
    return $d06f17efb06faf2f$var$He(e1) || $d06f17efb06faf2f$var$Et(e1) ? $d06f17efb06faf2f$var$ar($d06f17efb06faf2f$var$$e($d06f17efb06faf2f$var$rr($d06f17efb06faf2f$var$rt, [
        e1
    ].concat(r)))) : r.length === 0 && e1.length === 1 && typeof e1[0] == "string" ? e1 : $d06f17efb06faf2f$var$ar($d06f17efb06faf2f$var$$e($d06f17efb06faf2f$var$rr(e1, r)));
}
var $d06f17efb06faf2f$var$cr = /invalid hook call/i, $d06f17efb06faf2f$var$Qe = /* @__PURE__ */ new Set(), $d06f17efb06faf2f$var$Or = function(e1, t) {
    var r, n, o, i;
}, $d06f17efb06faf2f$var$Pr = function(e1, t, r) {
    return r === void 0 && (r = $d06f17efb06faf2f$var$Oe), e1.theme !== r.theme && e1.theme || t || r.theme;
}, $d06f17efb06faf2f$var$Io = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $d06f17efb06faf2f$var$Mo = /(^-|-$)/g;
function $d06f17efb06faf2f$var$ht(e1) {
    return e1.replace($d06f17efb06faf2f$var$Io, "-").replace($d06f17efb06faf2f$var$Mo, "");
}
var $d06f17efb06faf2f$var$Ir = function(e1) {
    return $d06f17efb06faf2f$var$_t($d06f17efb06faf2f$var$_r(e1) >>> 0);
};
function $d06f17efb06faf2f$var$Ze(e1) {
    return typeof e1 == "string" && true;
}
var $d06f17efb06faf2f$var$Ct = function(e1) {
    return typeof e1 == "function" || typeof e1 == "object" && e1 !== null && !Array.isArray(e1);
}, $d06f17efb06faf2f$var$No = function(e1) {
    return e1 !== "__proto__" && e1 !== "constructor" && e1 !== "prototype";
};
function $d06f17efb06faf2f$var$$o(e1, t, r) {
    var n = e1[r];
    $d06f17efb06faf2f$var$Ct(t) && $d06f17efb06faf2f$var$Ct(n) ? $d06f17efb06faf2f$var$Mr(n, t) : e1[r] = t;
}
function $d06f17efb06faf2f$var$Mr(e1) {
    for(var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)r[n - 1] = arguments[n];
    for(var o = 0, i = r; o < i.length; o++){
        var a = i[o];
        if ($d06f17efb06faf2f$var$Ct(a)) for(var c in a)$d06f17efb06faf2f$var$No(c) && $d06f17efb06faf2f$var$$o(e1, a[c], c);
    }
    return e1;
}
var $d06f17efb06faf2f$var$It = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext();
$d06f17efb06faf2f$var$It.Consumer;
var $d06f17efb06faf2f$var$pt = {};
function $d06f17efb06faf2f$var$Nr(e1, t, r) {
    var n = $d06f17efb06faf2f$var$Ot(e1), o = !$d06f17efb06faf2f$var$Ze(e1), i = t.attrs, a = i === void 0 ? $d06f17efb06faf2f$var$rt : i, c = t.componentId, l = c === void 0 ? function(_, T) {
        var k = typeof _ != "string" ? "sc" : $d06f17efb06faf2f$var$ht(_);
        $d06f17efb06faf2f$var$pt[k] = ($d06f17efb06faf2f$var$pt[k] || 0) + 1;
        var g = k + "-" + $d06f17efb06faf2f$var$Ir("5.3.6" + k + $d06f17efb06faf2f$var$pt[k]);
        return T ? T + "-" + g : g;
    }(t.displayName, t.parentComponentId) : c, f = t.displayName, d = f === void 0 ? function(_) {
        return $d06f17efb06faf2f$var$Ze(_) ? "styled." + _ : "Styled(" + $d06f17efb06faf2f$var$wt(_) + ")";
    }(e1) : f, h = t.displayName && t.componentId ? $d06f17efb06faf2f$var$ht(t.displayName) + "-" + t.componentId : t.componentId || l, y = n && e1.attrs ? Array.prototype.concat(e1.attrs, a).filter(Boolean) : a, w = t.shouldForwardProp;
    n && e1.shouldForwardProp && (w = t.shouldForwardProp ? function(_, T, k) {
        return e1.shouldForwardProp(_, T, k) && t.shouldForwardProp(_, T, k);
    } : e1.shouldForwardProp);
    var b, A = new $d06f17efb06faf2f$var$wo(r, h, n ? e1.componentStyle : void 0), R = A.isStatic && a.length === 0, O = function(_, T) {
        return function(k, g, X, J) {
            var G = k.attrs, Q = k.componentStyle, fe = k.defaultProps, de = k.foldedComponentIds, Z = k.shouldForwardProp, q = k.styledComponentId, Y = k.target;
            var H = function(M, u, D) {
                M === void 0 && (M = $d06f17efb06faf2f$var$Oe);
                var v = $d06f17efb06faf2f$var$xe({}, u, {
                    theme: M
                }), K = {};
                return D.forEach(function(j) {
                    var F, p, oe, se = j;
                    for(F in $d06f17efb06faf2f$var$He(se) && (se = se(v)), se)v[F] = K[F] = F === "className" ? (p = K[F], oe = se[F], p && oe ? p + " " + oe : p || oe) : se[F];
                }), [
                    v,
                    K
                ];
            }($d06f17efb06faf2f$var$Pr(g, (0, $acw62.useContext)($d06f17efb06faf2f$var$It), fe) || $d06f17efb06faf2f$var$Oe, g, G), he = H[0], ne = H[1], te = function(M, u, D, v) {
                var K = $d06f17efb06faf2f$var$Ar(), j = $d06f17efb06faf2f$var$kr(), F = u ? M.generateAndInjectStyles($d06f17efb06faf2f$var$Oe, K, j) : M.generateAndInjectStyles(D, K, j);
                return F;
            }(Q, J, he, void 0), ve = X, ye = ne.$as || g.$as || ne.as || g.as || Y, Se = $d06f17efb06faf2f$var$Ze(ye), C = ne !== g ? $d06f17efb06faf2f$var$xe({}, g, {}, ne) : g, E = {};
            for(var x in C)x[0] !== "$" && x !== "as" && (x === "forwardedAs" ? E.as = C[x] : (Z ? Z(x, $d06f17efb06faf2f$var$Zt, ye) : !Se || $d06f17efb06faf2f$var$Zt(x)) && (E[x] = C[x]));
            return g.style && ne.style !== g.style && (E.style = $d06f17efb06faf2f$var$xe({}, g.style, {}, ne.style)), E.className = Array.prototype.concat(de, q, te !== q ? te : null, g.className, ne.className).filter(Boolean).join(" "), E.ref = ve, (0, $acw62.createElement)(ye, E);
        }(b, _, T, R);
    };
    return O.displayName = d, (b = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(O)).attrs = y, b.componentStyle = A, b.displayName = d, b.shouldForwardProp = w, b.foldedComponentIds = n ? Array.prototype.concat(e1.foldedComponentIds, e1.styledComponentId) : $d06f17efb06faf2f$var$rt, b.styledComponentId = h, b.target = n ? e1.target : e1, b.withComponent = function(_) {
        var T = t.componentId, k = function(X, J) {
            if (X == null) return {};
            var G, Q, fe = {}, de = Object.keys(X);
            for(Q = 0; Q < de.length; Q++)G = de[Q], J.indexOf(G) >= 0 || (fe[G] = X[G]);
            return fe;
        }(t, [
            "componentId"
        ]), g = T && T + "-" + ($d06f17efb06faf2f$var$Ze(_) ? _ : $d06f17efb06faf2f$var$ht($d06f17efb06faf2f$var$wt(_)));
        return $d06f17efb06faf2f$var$Nr(_, $d06f17efb06faf2f$var$xe({}, k, {
            attrs: y,
            componentId: g
        }), r);
    }, Object.defineProperty(b, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(_) {
            this._foldedDefaultProps = n ? $d06f17efb06faf2f$var$Mr({}, e1.defaultProps, _) : _;
        }
    }), b.toString = function() {
        return "." + b.styledComponentId;
    }, o && $d06f17efb06faf2f$var$ro(b, e1, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0,
        withComponent: !0
    }), b;
}
var $d06f17efb06faf2f$var$Rt = function(e1) {
    return function t(r, n, o) {
        if (o === void 0 && (o = $d06f17efb06faf2f$var$Oe), !$d06f17efb06faf2f$var$Ye.isValidElementType(n)) return $d06f17efb06faf2f$var$We(1, String(n));
        var i = function() {
            return r(n, o, $d06f17efb06faf2f$var$Tr.apply(void 0, arguments));
        };
        return i.withConfig = function(a) {
            return t(r, n, $d06f17efb06faf2f$var$xe({}, o, {}, a));
        }, i.attrs = function(a) {
            return t(r, n, $d06f17efb06faf2f$var$xe({}, o, {
                attrs: Array.prototype.concat(o.attrs, a).filter(Boolean)
            }));
        }, i;
    }($d06f17efb06faf2f$var$Nr, e1);
};
[
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "textPath",
    "tspan"
].forEach(function(e1) {
    $d06f17efb06faf2f$var$Rt[e1] = $d06f17efb06faf2f$var$Rt(e1);
});
var $d06f17efb06faf2f$var$jo = function() {
    function e1(r, n) {
        this.rules = r, this.componentId = n, this.isStatic = $d06f17efb06faf2f$var$xr(r), $d06f17efb06faf2f$var$ot.registerId(this.componentId + 1);
    }
    var t = e1.prototype;
    return t.createStyles = function(r, n, o, i) {
        var a = i($d06f17efb06faf2f$var$$e(this.rules, n, o, i).join(""), ""), c = this.componentId + r;
        o.insertRules(c, c, a);
    }, t.removeStyles = function(r, n) {
        n.clearRules(this.componentId + r);
    }, t.renderStyles = function(r, n, o, i) {
        r > 2 && $d06f17efb06faf2f$var$ot.registerId(this.componentId + r), this.removeStyles(r, o), this.createStyles(r, n, o, i);
    }, e1;
}();
function $d06f17efb06faf2f$var$Do(e1) {
    for(var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)r[n - 1] = arguments[n];
    var o = $d06f17efb06faf2f$var$Tr.apply(void 0, [
        e1
    ].concat(r)), i = "sc-global-" + $d06f17efb06faf2f$var$Ir(JSON.stringify(o)), a = new $d06f17efb06faf2f$var$jo(o, i);
    function c(f) {
        var d = $d06f17efb06faf2f$var$Ar(), h = $d06f17efb06faf2f$var$kr(), y = (0, $acw62.useContext)($d06f17efb06faf2f$var$It), w = (0, $acw62.useRef)(d.allocateGSInstance(i)).current;
        return d.server && l(w, f, d, y, h), (0, $acw62.useLayoutEffect)(function() {
            if (!d.server) return l(w, f, d, y, h), function() {
                return a.removeStyles(w, d);
            };
        }, [
            w,
            f,
            d,
            y,
            h
        ]), null;
    }
    function l(f, d, h, y, w) {
        if (a.isStatic) a.renderStyles(f, $d06f17efb06faf2f$var$oo, h, w);
        else {
            var b = $d06f17efb06faf2f$var$xe({}, d, {
                theme: $d06f17efb06faf2f$var$Pr(d, y, c.defaultProps)
            });
            a.renderStyles(f, b, h, w);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(c);
}
const $d06f17efb06faf2f$var$Ke = $d06f17efb06faf2f$var$Rt, $d06f17efb06faf2f$var$Lo = $d06f17efb06faf2f$var$Ke.div`
  margin: 10px 0 0;
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.1) 0 0 0 0, rgba(0, 0, 0, 0.1) 0px 4px 11px;
  border-radius: 5px;
  > ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
    > li {
      padding: 10px 20px;
      background-color: #fff;
      border: 1px solid
        ${({ dropdownBorderColor: e1 })=>e1};
      height: 40px;
      display: flex;
      align-items: center;
      &:hover {
        background-color: ${({ dropdownHoverColor: e1 })=>e1};
        cursor: pointer;
      }
      &:first-child {
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
      }
      &:last-child {
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
      }
      &:not(:first-child) {
        border-top: 0;
      }
    }
  }
`, $d06f17efb06faf2f$var$Fo = ({ onClick: e1, matchedRecords: t = [], dropdownBorderColor: r, dropdownHoverColor: n })=>/* @__PURE__ */ $d06f17efb06faf2f$var$ke($d06f17efb06faf2f$var$Lo, {
        className: "react-search-box-dropdown",
        dropdownHoverColor: n,
        dropdownBorderColor: r,
        children: /* @__PURE__ */ $d06f17efb06faf2f$var$ke("ul", {
            children: t.map((o)=>/* @__PURE__ */ $d06f17efb06faf2f$var$ke("li", {
                    tabIndex: 0,
                    onKeyDown: (i)=>{
                        [
                            "Space",
                            "Enter"
                        ].includes(i.code) && e1(o);
                    },
                    className: "react-search-box-dropdown-list-item",
                    onClick: ()=>e1(o),
                    children: o.item.value
                }, o.item.key))
        })
    }), $d06f17efb06faf2f$var$Yo = (e1, t, r)=>{
    (0, $acw62.useEffect)(()=>{
        const n = (o)=>{
            e1.current && !e1.current.contains(o.target) && (t(!1), r(""));
        };
        return document.addEventListener("mousedown", n), ()=>{
            document.removeEventListener("mousedown", n);
        };
    }, [
        e1
    ]);
}, $d06f17efb06faf2f$var$zo = $d06f17efb06faf2f$var$Ke.input`
  font-size: ${({ inputFontSize: e1 })=>e1};
  padding: ${({ leftIcon: e1, iconBoxSize: t })=>e1 ? `10px ${t}` : "10px 20px"};
  height: ${({ inputHeight: e1 })=>e1};
  border: 1px solid ${({ inputBorderColor: e1 })=>e1};
  border-radius: 5px;
  color: ${({ inputFontColor: e1 })=>e1};
  background-color: ${({ inputBackgroundColor: e1 })=>e1};
  width: 100%;

  &:focus {
    outline: none;
  }
`, $d06f17efb06faf2f$var$Vo = $d06f17efb06faf2f$var$Ke.span`
  height: ${({ inputHeight: e1 })=>e1};
  width: ${({ iconBoxSize: e1 })=>e1};
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`, $d06f17efb06faf2f$var$Wo = $d06f17efb06faf2f$var$Ke.span`
  position: relative;
`, $d06f17efb06faf2f$var$Bo = ({ placeholder: e1, name: t, value: r, onChange: n, onFocus: o, inputFontColor: i, inputBorderColor: a, inputFontSize: c, inputHeight: l, inputBackgroundColor: f, autoFocus: d, leftIcon: h, iconBoxSize: y, type: w, onKeyDown: b })=>{
    const A = (0, $acw62.useRef)(null);
    return (0, $acw62.useEffect)(()=>{
        var O;
        d && ((O = A.current) == null || O.focus());
    }, []), /* @__PURE__ */ $d06f17efb06faf2f$var$ur($d06f17efb06faf2f$var$Wo, {
        children: [
            /* @__PURE__ */ $d06f17efb06faf2f$var$ke($d06f17efb06faf2f$var$zo, {
                type: w,
                placeholder: e1,
                name: t,
                value: r,
                onChange: n,
                onFocus: o,
                ref: A,
                inputFontColor: i,
                inputBorderColor: a,
                inputFontSize: c,
                inputHeight: l,
                inputBackgroundColor: f,
                leftIcon: h,
                iconBoxSize: y,
                onKeyDown: b
            }),
            (()=>h ? /* @__PURE__ */ $d06f17efb06faf2f$var$ke($d06f17efb06faf2f$var$Vo, {
                    iconBoxSize: y,
                    inputHeight: l,
                    children: h
                }) : null)()
        ]
    });
}, $d06f17efb06faf2f$var$Uo = $d06f17efb06faf2f$var$Do`
  * {
    box-sizing: border-box;
  }
`, $d06f17efb06faf2f$var$Go = $d06f17efb06faf2f$var$Ke.div`
  display: flex;
  flex-direction: column;
`, $d06f17efb06faf2f$export$2e2bcd8739ae039 = ({ placeholder: e1 = "", name: t = "", data: r = [], fuseConfigs: n, autoFocus: o = !1, onSelect: i, onFocus: a, onChange: c, inputBackgroundColor: l = "#fff", inputFontColor: f = "#000", inputBorderColor: d = "#cacaca96", inputFontSize: h = "14px", inputHeight: y = "40px", dropdownHoverColor: w = "#ccc", dropdownBorderColor: b = "#cacaca96", clearOnSelect: A = !1, leftIcon: R, iconBoxSize: O = "24px", type: _ = "text" })=>{
    const [T, k] = (0, $acw62.useState)([]), [g, X] = (0, $acw62.useState)(""), [J, G] = (0, $acw62.useState)(!1), Q = (0, $acw62.useRef)(null);
    $d06f17efb06faf2f$var$Yo(Q, G, X);
    const de = Object.assign({}, {
        /**
     * At what point does the match algorithm give up. A threshold of 0.0
     * requires a perfect match (of both letters and location), a threshold
     * of 1.0 would match anything.
     */ threshold: 0.05,
        /**
     * Determines approximately where in the text is the pattern expected to be found.
     */ location: 0,
        /**
     * Determines how close the match must be to the fuzzy location
     * (specified by location). An exact letter match which is distance
     * characters away from the fuzzy location would score as a complete
     * mismatch. A distance of 0 requires the match be at the exact
     * location specified, a distance of 1000 would require a perfect
     * match to be within 800 characters of the location to be found
     * using a threshold of 0.8.
     */ distance: 100,
        /**
     * When set to include matches, only the matches whose length exceeds this
     * value will be returned. (For instance, if you want to ignore single
     * character index returns, set to 2).
     */ minMatchCharLength: 1,
        /**
     * List of properties that will be searched. This supports nested properties,
     * weighted search, searching in arrays of strings and objects.
     */ keys: [
            "value"
        ]
    }, n), Z = new $d06f17efb06faf2f$var$Ve(r, de), q = (ne)=>{
        const { value: te } = ne.target, ve = Z.search(te);
        X(te), k(ve), G(!0), c && c(te);
    }, Y = ()=>/* @__PURE__ */ $d06f17efb06faf2f$var$ke($d06f17efb06faf2f$var$Bo, {
            placeholder: e1,
            name: t,
            value: g,
            onChange: q,
            autoFocus: o || !1,
            onFocus: a || void 0,
            inputFontColor: f,
            inputBorderColor: d,
            inputFontSize: h,
            inputHeight: y,
            inputBackgroundColor: l,
            leftIcon: R,
            iconBoxSize: O,
            onKeyDown: (te)=>{
                T.length === 1 && te.code === "Enter" && (te.preventDefault(), i(T[0]));
            },
            type: _
        }), H = (ne)=>{
        X(A ? "" : ne.item.value), G(!1), i && i(ne), c && c(ne.item.value);
    }, he = ()=>J ? /* @__PURE__ */ $d06f17efb06faf2f$var$ke($d06f17efb06faf2f$var$Fo, {
            matchedRecords: T,
            onClick: H,
            dropdownHoverColor: w,
            dropdownBorderColor: b
        }) : !1;
    return /* @__PURE__ */ $d06f17efb06faf2f$var$ke("div", {
        ref: Q,
        children: /* @__PURE__ */ $d06f17efb06faf2f$var$ur($d06f17efb06faf2f$var$Go, {
            children: [
                /* @__PURE__ */ $d06f17efb06faf2f$var$ke($d06f17efb06faf2f$var$Uo, {}),
                Y(),
                he()
            ]
        })
    });
};


/**
 * Fuse.js v7.0.0 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2023 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */ function $39e2a8da47246292$var$isArray(value) {
    return !Array.isArray ? $39e2a8da47246292$var$getTag(value) === "[object Array]" : Array.isArray(value);
}
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/baseToString.js
const $39e2a8da47246292$var$INFINITY = 1 / 0;
function $39e2a8da47246292$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    let result = value + "";
    return result == "0" && 1 / value == -$39e2a8da47246292$var$INFINITY ? "-0" : result;
}
function $39e2a8da47246292$var$toString(value) {
    return value == null ? "" : $39e2a8da47246292$var$baseToString(value);
}
function $39e2a8da47246292$var$isString(value) {
    return typeof value === "string";
}
function $39e2a8da47246292$var$isNumber(value) {
    return typeof value === "number";
}
// Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js
function $39e2a8da47246292$var$isBoolean(value) {
    return value === true || value === false || $39e2a8da47246292$var$isObjectLike(value) && $39e2a8da47246292$var$getTag(value) == "[object Boolean]";
}
function $39e2a8da47246292$var$isObject(value) {
    return typeof value === "object";
}
// Checks if `value` is object-like.
function $39e2a8da47246292$var$isObjectLike(value) {
    return $39e2a8da47246292$var$isObject(value) && value !== null;
}
function $39e2a8da47246292$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $39e2a8da47246292$var$isBlank(value) {
    return !value.trim().length;
}
// Gets the `toStringTag` of `value`.
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
function $39e2a8da47246292$var$getTag(value) {
    return value == null ? value === undefined ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(value);
}
const $39e2a8da47246292$var$EXTENDED_SEARCH_UNAVAILABLE = "Extended search is not available";
const $39e2a8da47246292$var$INCORRECT_INDEX_TYPE = "Incorrect 'index' type";
const $39e2a8da47246292$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = (key)=>`Invalid value for key ${key}`;
const $39e2a8da47246292$var$PATTERN_LENGTH_TOO_LARGE = (max)=>`Pattern length exceeds max of ${max}.`;
const $39e2a8da47246292$var$MISSING_KEY_PROPERTY = (name)=>`Missing ${name} property in key`;
const $39e2a8da47246292$var$INVALID_KEY_WEIGHT_VALUE = (key)=>`Property 'weight' in key '${key}' must be a positive integer`;
const $39e2a8da47246292$var$hasOwn = Object.prototype.hasOwnProperty;
class $39e2a8da47246292$var$KeyStore {
    constructor(keys){
        this._keys = [];
        this._keyMap = {};
        let totalWeight = 0;
        keys.forEach((key)=>{
            let obj = $39e2a8da47246292$var$createKey(key);
            this._keys.push(obj);
            this._keyMap[obj.id] = obj;
            totalWeight += obj.weight;
        });
        // Normalize weights so that their sum is equal to 1
        this._keys.forEach((key)=>{
            key.weight /= totalWeight;
        });
    }
    get(keyId) {
        return this._keyMap[keyId];
    }
    keys() {
        return this._keys;
    }
    toJSON() {
        return JSON.stringify(this._keys);
    }
}
function $39e2a8da47246292$var$createKey(key) {
    let path = null;
    let id = null;
    let src = null;
    let weight = 1;
    let getFn = null;
    if ($39e2a8da47246292$var$isString(key) || $39e2a8da47246292$var$isArray(key)) {
        src = key;
        path = $39e2a8da47246292$var$createKeyPath(key);
        id = $39e2a8da47246292$var$createKeyId(key);
    } else {
        if (!$39e2a8da47246292$var$hasOwn.call(key, "name")) throw new Error($39e2a8da47246292$var$MISSING_KEY_PROPERTY("name"));
        const name = key.name;
        src = name;
        if ($39e2a8da47246292$var$hasOwn.call(key, "weight")) {
            weight = key.weight;
            if (weight <= 0) throw new Error($39e2a8da47246292$var$INVALID_KEY_WEIGHT_VALUE(name));
        }
        path = $39e2a8da47246292$var$createKeyPath(name);
        id = $39e2a8da47246292$var$createKeyId(name);
        getFn = key.getFn;
    }
    return {
        path: path,
        id: id,
        weight: weight,
        src: src,
        getFn: getFn
    };
}
function $39e2a8da47246292$var$createKeyPath(key) {
    return $39e2a8da47246292$var$isArray(key) ? key : key.split(".");
}
function $39e2a8da47246292$var$createKeyId(key) {
    return $39e2a8da47246292$var$isArray(key) ? key.join(".") : key;
}
function $39e2a8da47246292$var$get(obj, path) {
    let list = [];
    let arr = false;
    const deepGet = (obj, path, index)=>{
        if (!$39e2a8da47246292$var$isDefined(obj)) return;
        if (!path[index]) // If there's no path left, we've arrived at the object we care about.
        list.push(obj);
        else {
            let key = path[index];
            const value = obj[key];
            if (!$39e2a8da47246292$var$isDefined(value)) return;
            // If we're at the last value in the path, and if it's a string/number/bool,
            // add it to the list
            if (index === path.length - 1 && ($39e2a8da47246292$var$isString(value) || $39e2a8da47246292$var$isNumber(value) || $39e2a8da47246292$var$isBoolean(value))) list.push($39e2a8da47246292$var$toString(value));
            else if ($39e2a8da47246292$var$isArray(value)) {
                arr = true;
                // Search each item in the array.
                for(let i = 0, len = value.length; i < len; i += 1)deepGet(value[i], path, index + 1);
            } else if (path.length) // An object. Recurse further.
            deepGet(value, path, index + 1);
        }
    };
    // Backwards compatibility (since path used to be a string)
    deepGet(obj, $39e2a8da47246292$var$isString(path) ? path.split(".") : path, 0);
    return arr ? list : list[0];
}
const $39e2a8da47246292$var$MatchOptions = {
    // Whether the matches should be included in the result set. When `true`, each record in the result
    // set will include the indices of the matched characters.
    // These can consequently be used for highlighting purposes.
    includeMatches: false,
    // When `true`, the matching function will continue to the end of a search pattern even if
    // a perfect match has already been located in the string.
    findAllMatches: false,
    // Minimum number of characters that must be matched before a result is considered a match
    minMatchCharLength: 1
};
const $39e2a8da47246292$var$BasicOptions = {
    // When `true`, the algorithm continues searching to the end of the input even if a perfect
    // match is found before the end of the same input.
    isCaseSensitive: false,
    // When true, the matching function will continue to the end of a search pattern even if
    includeScore: false,
    // List of properties that will be searched. This also supports nested properties.
    keys: [],
    // Whether to sort the result list, by score
    shouldSort: true,
    // Default sort function: sort by ascending score, ascending index
    sortFn: (a, b)=>a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1
};
const $39e2a8da47246292$var$FuzzyOptions = {
    // Approximately where in the text is the pattern expected to be found?
    location: 0,
    // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
    // (of both letters and location), a threshold of '1.0' would match anything.
    threshold: 0.6,
    // Determines how close the match must be to the fuzzy location (specified above).
    // An exact letter match which is 'distance' characters away from the fuzzy location
    // would score as a complete mismatch. A distance of '0' requires the match be at
    // the exact location specified, a threshold of '1000' would require a perfect match
    // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
    distance: 100
};
const $39e2a8da47246292$var$AdvancedOptions = {
    // When `true`, it enables the use of unix-like search commands
    useExtendedSearch: false,
    // The get function to use when fetching an object's properties.
    // The default will search nested paths *ie foo.bar.baz*
    getFn: $39e2a8da47246292$var$get,
    // When `true`, search will ignore `location` and `distance`, so it won't matter
    // where in the string the pattern appears.
    // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
    ignoreLocation: false,
    // When `true`, the calculation for the relevance score (used for sorting) will
    // ignore the field-length norm.
    // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
    ignoreFieldNorm: false,
    // The weight to determine how much field length norm effects scoring.
    fieldNormWeight: 1
};
var $39e2a8da47246292$var$Config = {
    ...$39e2a8da47246292$var$BasicOptions,
    ...$39e2a8da47246292$var$MatchOptions,
    ...$39e2a8da47246292$var$FuzzyOptions,
    ...$39e2a8da47246292$var$AdvancedOptions
};
const $39e2a8da47246292$var$SPACE = /[^ ]+/g;
// Field-length norm: the shorter the field, the higher the weight.
// Set to 3 decimals to reduce index size.
function $39e2a8da47246292$var$norm(weight = 1, mantissa = 3) {
    const cache = new Map();
    const m = Math.pow(10, mantissa);
    return {
        get (value) {
            const numTokens = value.match($39e2a8da47246292$var$SPACE).length;
            if (cache.has(numTokens)) return cache.get(numTokens);
            // Default function is 1/sqrt(x), weight makes that variable
            const norm = 1 / Math.pow(numTokens, 0.5 * weight);
            // In place of `toFixed(mantissa)`, for faster computation
            const n = parseFloat(Math.round(norm * m) / m);
            cache.set(numTokens, n);
            return n;
        },
        clear () {
            cache.clear();
        }
    };
}
class $39e2a8da47246292$var$FuseIndex {
    constructor({ getFn: getFn = $39e2a8da47246292$var$Config.getFn, fieldNormWeight: fieldNormWeight = $39e2a8da47246292$var$Config.fieldNormWeight } = {}){
        this.norm = $39e2a8da47246292$var$norm(fieldNormWeight, 3);
        this.getFn = getFn;
        this.isCreated = false;
        this.setIndexRecords();
    }
    setSources(docs = []) {
        this.docs = docs;
    }
    setIndexRecords(records = []) {
        this.records = records;
    }
    setKeys(keys = []) {
        this.keys = keys;
        this._keysMap = {};
        keys.forEach((key, idx)=>{
            this._keysMap[key.id] = idx;
        });
    }
    create() {
        if (this.isCreated || !this.docs.length) return;
        this.isCreated = true;
        // List is Array<String>
        if ($39e2a8da47246292$var$isString(this.docs[0])) this.docs.forEach((doc, docIndex)=>{
            this._addString(doc, docIndex);
        });
        else // List is Array<Object>
        this.docs.forEach((doc, docIndex)=>{
            this._addObject(doc, docIndex);
        });
        this.norm.clear();
    }
    // Adds a doc to the end of the index
    add(doc) {
        const idx = this.size();
        if ($39e2a8da47246292$var$isString(doc)) this._addString(doc, idx);
        else this._addObject(doc, idx);
    }
    // Removes the doc at the specified index of the index
    removeAt(idx) {
        this.records.splice(idx, 1);
        // Change ref index of every subsquent doc
        for(let i = idx, len = this.size(); i < len; i += 1)this.records[i].i -= 1;
    }
    getValueForItemAtKeyId(item, keyId) {
        return item[this._keysMap[keyId]];
    }
    size() {
        return this.records.length;
    }
    _addString(doc, docIndex) {
        if (!$39e2a8da47246292$var$isDefined(doc) || $39e2a8da47246292$var$isBlank(doc)) return;
        let record = {
            v: doc,
            i: docIndex,
            n: this.norm.get(doc)
        };
        this.records.push(record);
    }
    _addObject(doc, docIndex) {
        let record = {
            i: docIndex,
            $: {}
        };
        // Iterate over every key (i.e, path), and fetch the value at that key
        this.keys.forEach((key, keyIndex)=>{
            let value = key.getFn ? key.getFn(doc) : this.getFn(doc, key.path);
            if (!$39e2a8da47246292$var$isDefined(value)) return;
            if ($39e2a8da47246292$var$isArray(value)) {
                let subRecords = [];
                const stack = [
                    {
                        nestedArrIndex: -1,
                        value: value
                    }
                ];
                while(stack.length){
                    const { nestedArrIndex: nestedArrIndex, value: value } = stack.pop();
                    if (!$39e2a8da47246292$var$isDefined(value)) continue;
                    if ($39e2a8da47246292$var$isString(value) && !$39e2a8da47246292$var$isBlank(value)) {
                        let subRecord = {
                            v: value,
                            i: nestedArrIndex,
                            n: this.norm.get(value)
                        };
                        subRecords.push(subRecord);
                    } else if ($39e2a8da47246292$var$isArray(value)) value.forEach((item, k)=>{
                        stack.push({
                            nestedArrIndex: k,
                            value: item
                        });
                    });
                }
                record.$[keyIndex] = subRecords;
            } else if ($39e2a8da47246292$var$isString(value) && !$39e2a8da47246292$var$isBlank(value)) {
                let subRecord = {
                    v: value,
                    n: this.norm.get(value)
                };
                record.$[keyIndex] = subRecord;
            }
        });
        this.records.push(record);
    }
    toJSON() {
        return {
            keys: this.keys,
            records: this.records
        };
    }
}
function $39e2a8da47246292$var$createIndex(keys, docs, { getFn: getFn = $39e2a8da47246292$var$Config.getFn, fieldNormWeight: fieldNormWeight = $39e2a8da47246292$var$Config.fieldNormWeight } = {}) {
    const myIndex = new $39e2a8da47246292$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys.map($39e2a8da47246292$var$createKey));
    myIndex.setSources(docs);
    myIndex.create();
    return myIndex;
}
function $39e2a8da47246292$var$parseIndex(data, { getFn: getFn = $39e2a8da47246292$var$Config.getFn, fieldNormWeight: fieldNormWeight = $39e2a8da47246292$var$Config.fieldNormWeight } = {}) {
    const { keys: keys, records: records } = data;
    const myIndex = new $39e2a8da47246292$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys);
    myIndex.setIndexRecords(records);
    return myIndex;
}
function $39e2a8da47246292$var$computeScore$1(pattern, { errors: errors = 0, currentLocation: currentLocation = 0, expectedLocation: expectedLocation = 0, distance: distance = $39e2a8da47246292$var$Config.distance, ignoreLocation: ignoreLocation = $39e2a8da47246292$var$Config.ignoreLocation } = {}) {
    const accuracy = errors / pattern.length;
    if (ignoreLocation) return accuracy;
    const proximity = Math.abs(expectedLocation - currentLocation);
    if (!distance) // Dodge divide by zero error.
    return proximity ? 1.0 : accuracy;
    return accuracy + proximity / distance;
}
function $39e2a8da47246292$var$convertMaskToIndices(matchmask = [], minMatchCharLength = $39e2a8da47246292$var$Config.minMatchCharLength) {
    let indices = [];
    let start = -1;
    let end = -1;
    let i = 0;
    for(let len = matchmask.length; i < len; i += 1){
        let match = matchmask[i];
        if (match && start === -1) start = i;
        else if (!match && start !== -1) {
            end = i - 1;
            if (end - start + 1 >= minMatchCharLength) indices.push([
                start,
                end
            ]);
            start = -1;
        }
    }
    // (i-1 - start) + 1 => i - start
    if (matchmask[i - 1] && i - start >= minMatchCharLength) indices.push([
        start,
        i - 1
    ]);
    return indices;
}
// Machine word size
const $39e2a8da47246292$var$MAX_BITS = 32;
function $39e2a8da47246292$var$search(text, pattern, patternAlphabet, { location: location = $39e2a8da47246292$var$Config.location, distance: distance = $39e2a8da47246292$var$Config.distance, threshold: threshold = $39e2a8da47246292$var$Config.threshold, findAllMatches: findAllMatches = $39e2a8da47246292$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $39e2a8da47246292$var$Config.minMatchCharLength, includeMatches: includeMatches = $39e2a8da47246292$var$Config.includeMatches, ignoreLocation: ignoreLocation = $39e2a8da47246292$var$Config.ignoreLocation } = {}) {
    if (pattern.length > $39e2a8da47246292$var$MAX_BITS) throw new Error($39e2a8da47246292$var$PATTERN_LENGTH_TOO_LARGE($39e2a8da47246292$var$MAX_BITS));
    const patternLen = pattern.length;
    // Set starting location at beginning text and initialize the alphabet.
    const textLen = text.length;
    // Handle the case when location > text.length
    const expectedLocation = Math.max(0, Math.min(location, textLen));
    // Highest score beyond which we give up.
    let currentThreshold = threshold;
    // Is there a nearby exact match? (speedup)
    let bestLocation = expectedLocation;
    // Performance: only computer matches when the minMatchCharLength > 1
    // OR if `includeMatches` is true.
    const computeMatches = minMatchCharLength > 1 || includeMatches;
    // A mask of the matches, used for building the indices
    const matchMask = computeMatches ? Array(textLen) : [];
    let index;
    // Get all exact matches, here for speed up
    while((index = text.indexOf(pattern, bestLocation)) > -1){
        let score = $39e2a8da47246292$var$computeScore$1(pattern, {
            currentLocation: index,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        currentThreshold = Math.min(score, currentThreshold);
        bestLocation = index + patternLen;
        if (computeMatches) {
            let i = 0;
            while(i < patternLen){
                matchMask[index + i] = 1;
                i += 1;
            }
        }
    }
    // Reset the best location
    bestLocation = -1;
    let lastBitArr = [];
    let finalScore = 1;
    let binMax = patternLen + textLen;
    const mask = 1 << patternLen - 1;
    for(let i = 0; i < patternLen; i += 1){
        // Scan for the best match; each iteration allows for one more error.
        // Run a binary search to determine how far from the match location we can stray
        // at this error level.
        let binMin = 0;
        let binMid = binMax;
        while(binMin < binMid){
            const score = $39e2a8da47246292$var$computeScore$1(pattern, {
                errors: i,
                currentLocation: expectedLocation + binMid,
                expectedLocation: expectedLocation,
                distance: distance,
                ignoreLocation: ignoreLocation
            });
            if (score <= currentThreshold) binMin = binMid;
            else binMax = binMid;
            binMid = Math.floor((binMax - binMin) / 2 + binMin);
        }
        // Use the result from this iteration as the maximum for the next.
        binMax = binMid;
        let start = Math.max(1, expectedLocation - binMid + 1);
        let finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;
        // Initialize the bit array
        let bitArr = Array(finish + 2);
        bitArr[finish + 1] = (1 << i) - 1;
        for(let j = finish; j >= start; j -= 1){
            let currentLocation = j - 1;
            let charMatch = patternAlphabet[text.charAt(currentLocation)];
            if (computeMatches) // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
            matchMask[currentLocation] = +!!charMatch;
            // First pass: exact match
            bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;
            // Subsequent passes: fuzzy match
            if (i) bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
            if (bitArr[j] & mask) {
                finalScore = $39e2a8da47246292$var$computeScore$1(pattern, {
                    errors: i,
                    currentLocation: currentLocation,
                    expectedLocation: expectedLocation,
                    distance: distance,
                    ignoreLocation: ignoreLocation
                });
                // This match will almost certainly be better than any existing match.
                // But check anyway.
                if (finalScore <= currentThreshold) {
                    // Indeed it is
                    currentThreshold = finalScore;
                    bestLocation = currentLocation;
                    // Already passed `loc`, downhill from here on in.
                    if (bestLocation <= expectedLocation) break;
                    // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
                    start = Math.max(1, 2 * expectedLocation - bestLocation);
                }
            }
        }
        // No hope for a (better) match at greater error levels.
        const score = $39e2a8da47246292$var$computeScore$1(pattern, {
            errors: i + 1,
            currentLocation: expectedLocation,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        if (score > currentThreshold) break;
        lastBitArr = bitArr;
    }
    const result = {
        isMatch: bestLocation >= 0,
        // Count exact matches (those with a score of 0) to be "almost" exact
        score: Math.max(0.001, finalScore)
    };
    if (computeMatches) {
        const indices = $39e2a8da47246292$var$convertMaskToIndices(matchMask, minMatchCharLength);
        if (!indices.length) result.isMatch = false;
        else if (includeMatches) result.indices = indices;
    }
    return result;
}
function $39e2a8da47246292$var$createPatternAlphabet(pattern) {
    let mask = {};
    for(let i = 0, len = pattern.length; i < len; i += 1){
        const char = pattern.charAt(i);
        mask[char] = (mask[char] || 0) | 1 << len - i - 1;
    }
    return mask;
}
class $39e2a8da47246292$var$BitapSearch {
    constructor(pattern, { location: location = $39e2a8da47246292$var$Config.location, threshold: threshold = $39e2a8da47246292$var$Config.threshold, distance: distance = $39e2a8da47246292$var$Config.distance, includeMatches: includeMatches = $39e2a8da47246292$var$Config.includeMatches, findAllMatches: findAllMatches = $39e2a8da47246292$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $39e2a8da47246292$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $39e2a8da47246292$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $39e2a8da47246292$var$Config.ignoreLocation } = {}){
        this.options = {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.chunks = [];
        if (!this.pattern.length) return;
        const addChunk = (pattern, startIndex)=>{
            this.chunks.push({
                pattern: pattern,
                alphabet: $39e2a8da47246292$var$createPatternAlphabet(pattern),
                startIndex: startIndex
            });
        };
        const len = this.pattern.length;
        if (len > $39e2a8da47246292$var$MAX_BITS) {
            let i = 0;
            const remainder = len % $39e2a8da47246292$var$MAX_BITS;
            const end = len - remainder;
            while(i < end){
                addChunk(this.pattern.substr(i, $39e2a8da47246292$var$MAX_BITS), i);
                i += $39e2a8da47246292$var$MAX_BITS;
            }
            if (remainder) {
                const startIndex = len - $39e2a8da47246292$var$MAX_BITS;
                addChunk(this.pattern.substr(startIndex), startIndex);
            }
        } else addChunk(this.pattern, 0);
    }
    searchIn(text) {
        const { isCaseSensitive: isCaseSensitive, includeMatches: includeMatches } = this.options;
        if (!isCaseSensitive) text = text.toLowerCase();
        // Exact match
        if (this.pattern === text) {
            let result = {
                isMatch: true,
                score: 0
            };
            if (includeMatches) result.indices = [
                [
                    0,
                    text.length - 1
                ]
            ];
            return result;
        }
        // Otherwise, use Bitap algorithm
        const { location: location, distance: distance, threshold: threshold, findAllMatches: findAllMatches, minMatchCharLength: minMatchCharLength, ignoreLocation: ignoreLocation } = this.options;
        let allIndices = [];
        let totalScore = 0;
        let hasMatches = false;
        this.chunks.forEach(({ pattern: pattern, alphabet: alphabet, startIndex: startIndex })=>{
            const { isMatch: isMatch, score: score, indices: indices } = $39e2a8da47246292$var$search(text, pattern, alphabet, {
                location: location + startIndex,
                distance: distance,
                threshold: threshold,
                findAllMatches: findAllMatches,
                minMatchCharLength: minMatchCharLength,
                includeMatches: includeMatches,
                ignoreLocation: ignoreLocation
            });
            if (isMatch) hasMatches = true;
            totalScore += score;
            if (isMatch && indices) allIndices = [
                ...allIndices,
                ...indices
            ];
        });
        let result = {
            isMatch: hasMatches,
            score: hasMatches ? totalScore / this.chunks.length : 1
        };
        if (hasMatches && includeMatches) result.indices = allIndices;
        return result;
    }
}
class $39e2a8da47246292$var$BaseMatch {
    constructor(pattern){
        this.pattern = pattern;
    }
    static isMultiMatch(pattern) {
        return $39e2a8da47246292$var$getMatch(pattern, this.multiRegex);
    }
    static isSingleMatch(pattern) {
        return $39e2a8da47246292$var$getMatch(pattern, this.singleRegex);
    }
    search() {}
}
function $39e2a8da47246292$var$getMatch(pattern, exp) {
    const matches = pattern.match(exp);
    return matches ? matches[1] : null;
}
// Token: 'file
class $39e2a8da47246292$var$ExactMatch extends $39e2a8da47246292$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "exact";
    }
    static get multiRegex() {
        return /^="(.*)"$/;
    }
    static get singleRegex() {
        return /^=(.*)$/;
    }
    search(text) {
        const isMatch = text === this.pattern;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !fire
class $39e2a8da47246292$var$InverseExactMatch extends $39e2a8da47246292$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "inverse-exact";
    }
    static get multiRegex() {
        return /^!"(.*)"$/;
    }
    static get singleRegex() {
        return /^!(.*)$/;
    }
    search(text) {
        const index = text.indexOf(this.pattern);
        const isMatch = index === -1;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: ^file
class $39e2a8da47246292$var$PrefixExactMatch extends $39e2a8da47246292$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "prefix-exact";
    }
    static get multiRegex() {
        return /^\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^\^(.*)$/;
    }
    search(text) {
        const isMatch = text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !^fire
class $39e2a8da47246292$var$InversePrefixExactMatch extends $39e2a8da47246292$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "inverse-prefix-exact";
    }
    static get multiRegex() {
        return /^!\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^!\^(.*)$/;
    }
    search(text) {
        const isMatch = !text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: .file$
class $39e2a8da47246292$var$SuffixExactMatch extends $39e2a8da47246292$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "suffix-exact";
    }
    static get multiRegex() {
        return /^"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^(.*)\$$/;
    }
    search(text) {
        const isMatch = text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                text.length - this.pattern.length,
                text.length - 1
            ]
        };
    }
}
// Token: !.file$
class $39e2a8da47246292$var$InverseSuffixExactMatch extends $39e2a8da47246292$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "inverse-suffix-exact";
    }
    static get multiRegex() {
        return /^!"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^!(.*)\$$/;
    }
    search(text) {
        const isMatch = !text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
class $39e2a8da47246292$var$FuzzyMatch extends $39e2a8da47246292$var$BaseMatch {
    constructor(pattern, { location: location = $39e2a8da47246292$var$Config.location, threshold: threshold = $39e2a8da47246292$var$Config.threshold, distance: distance = $39e2a8da47246292$var$Config.distance, includeMatches: includeMatches = $39e2a8da47246292$var$Config.includeMatches, findAllMatches: findAllMatches = $39e2a8da47246292$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $39e2a8da47246292$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $39e2a8da47246292$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $39e2a8da47246292$var$Config.ignoreLocation } = {}){
        super(pattern);
        this._bitapSearch = new $39e2a8da47246292$var$BitapSearch(pattern, {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        });
    }
    static get type() {
        return "fuzzy";
    }
    static get multiRegex() {
        return /^"(.*)"$/;
    }
    static get singleRegex() {
        return /^(.*)$/;
    }
    search(text) {
        return this._bitapSearch.searchIn(text);
    }
}
// Token: 'file
class $39e2a8da47246292$var$IncludeMatch extends $39e2a8da47246292$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "include";
    }
    static get multiRegex() {
        return /^'"(.*)"$/;
    }
    static get singleRegex() {
        return /^'(.*)$/;
    }
    search(text) {
        let location = 0;
        let index;
        const indices = [];
        const patternLen = this.pattern.length;
        // Get all exact matches
        while((index = text.indexOf(this.pattern, location)) > -1){
            location = index + patternLen;
            indices.push([
                index,
                location - 1
            ]);
        }
        const isMatch = !!indices.length;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: indices
        };
    }
}
// ❗Order is important. DO NOT CHANGE.
const $39e2a8da47246292$var$searchers = [
    $39e2a8da47246292$var$ExactMatch,
    $39e2a8da47246292$var$IncludeMatch,
    $39e2a8da47246292$var$PrefixExactMatch,
    $39e2a8da47246292$var$InversePrefixExactMatch,
    $39e2a8da47246292$var$InverseSuffixExactMatch,
    $39e2a8da47246292$var$SuffixExactMatch,
    $39e2a8da47246292$var$InverseExactMatch,
    $39e2a8da47246292$var$FuzzyMatch
];
const $39e2a8da47246292$var$searchersLen = $39e2a8da47246292$var$searchers.length;
// Regex to split by spaces, but keep anything in quotes together
const $39e2a8da47246292$var$SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
const $39e2a8da47246292$var$OR_TOKEN = "|";
// Return a 2D array representation of the query, for simpler parsing.
// Example:
// "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
function $39e2a8da47246292$var$parseQuery(pattern, options = {}) {
    return pattern.split($39e2a8da47246292$var$OR_TOKEN).map((item)=>{
        let query = item.trim().split($39e2a8da47246292$var$SPACE_RE).filter((item)=>item && !!item.trim());
        let results = [];
        for(let i = 0, len = query.length; i < len; i += 1){
            const queryItem = query[i];
            // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
            let found = false;
            let idx = -1;
            while(!found && ++idx < $39e2a8da47246292$var$searchersLen){
                const searcher = $39e2a8da47246292$var$searchers[idx];
                let token = searcher.isMultiMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    found = true;
                }
            }
            if (found) continue;
            // 2. Handle single query matches (i.e, once that are *not* quoted)
            idx = -1;
            while(++idx < $39e2a8da47246292$var$searchersLen){
                const searcher = $39e2a8da47246292$var$searchers[idx];
                let token = searcher.isSingleMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    break;
                }
            }
        }
        return results;
    });
}
// These extended matchers can return an array of matches, as opposed
// to a singl match
const $39e2a8da47246292$var$MultiMatchSet = new Set([
    $39e2a8da47246292$var$FuzzyMatch.type,
    $39e2a8da47246292$var$IncludeMatch.type
]);
/**
 * Command-like searching
 * ======================
 *
 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
 * search in a given text.
 *
 * Search syntax:
 *
 * | Token       | Match type                 | Description                            |
 * | ----------- | -------------------------- | -------------------------------------- |
 * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
 * | `=scheme`   | exact-match                | Items that are `scheme`                |
 * | `'python`   | include-match              | Items that include `python`            |
 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
 *
 * A single pipe character acts as an OR operator. For example, the following
 * query matches entries that start with `core` and end with either`go`, `rb`,
 * or`py`.
 *
 * ```
 * ^core go$ | rb$ | py$
 * ```
 */ class $39e2a8da47246292$var$ExtendedSearch {
    constructor(pattern, { isCaseSensitive: isCaseSensitive = $39e2a8da47246292$var$Config.isCaseSensitive, includeMatches: includeMatches = $39e2a8da47246292$var$Config.includeMatches, minMatchCharLength: minMatchCharLength = $39e2a8da47246292$var$Config.minMatchCharLength, ignoreLocation: ignoreLocation = $39e2a8da47246292$var$Config.ignoreLocation, findAllMatches: findAllMatches = $39e2a8da47246292$var$Config.findAllMatches, location: location = $39e2a8da47246292$var$Config.location, threshold: threshold = $39e2a8da47246292$var$Config.threshold, distance: distance = $39e2a8da47246292$var$Config.distance } = {}){
        this.query = null;
        this.options = {
            isCaseSensitive: isCaseSensitive,
            includeMatches: includeMatches,
            minMatchCharLength: minMatchCharLength,
            findAllMatches: findAllMatches,
            ignoreLocation: ignoreLocation,
            location: location,
            threshold: threshold,
            distance: distance
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.query = $39e2a8da47246292$var$parseQuery(this.pattern, this.options);
    }
    static condition(_, options) {
        return options.useExtendedSearch;
    }
    searchIn(text) {
        const query = this.query;
        if (!query) return {
            isMatch: false,
            score: 1
        };
        const { includeMatches: includeMatches, isCaseSensitive: isCaseSensitive } = this.options;
        text = isCaseSensitive ? text : text.toLowerCase();
        let numMatches = 0;
        let allIndices = [];
        let totalScore = 0;
        // ORs
        for(let i = 0, qLen = query.length; i < qLen; i += 1){
            const searchers = query[i];
            // Reset indices
            allIndices.length = 0;
            numMatches = 0;
            // ANDs
            for(let j = 0, pLen = searchers.length; j < pLen; j += 1){
                const searcher = searchers[j];
                const { isMatch: isMatch, indices: indices, score: score } = searcher.search(text);
                if (isMatch) {
                    numMatches += 1;
                    totalScore += score;
                    if (includeMatches) {
                        const type = searcher.constructor.type;
                        if ($39e2a8da47246292$var$MultiMatchSet.has(type)) allIndices = [
                            ...allIndices,
                            ...indices
                        ];
                        else allIndices.push(indices);
                    }
                } else {
                    totalScore = 0;
                    numMatches = 0;
                    allIndices.length = 0;
                    break;
                }
            }
            // OR condition, so if TRUE, return
            if (numMatches) {
                let result = {
                    isMatch: true,
                    score: totalScore / numMatches
                };
                if (includeMatches) result.indices = allIndices;
                return result;
            }
        }
        // Nothing was matched
        return {
            isMatch: false,
            score: 1
        };
    }
}
const $39e2a8da47246292$var$registeredSearchers = [];
function $39e2a8da47246292$var$register(...args) {
    $39e2a8da47246292$var$registeredSearchers.push(...args);
}
function $39e2a8da47246292$var$createSearcher(pattern, options) {
    for(let i = 0, len = $39e2a8da47246292$var$registeredSearchers.length; i < len; i += 1){
        let searcherClass = $39e2a8da47246292$var$registeredSearchers[i];
        if (searcherClass.condition(pattern, options)) return new searcherClass(pattern, options);
    }
    return new $39e2a8da47246292$var$BitapSearch(pattern, options);
}
const $39e2a8da47246292$var$LogicalOperator = {
    AND: "$and",
    OR: "$or"
};
const $39e2a8da47246292$var$KeyType = {
    PATH: "$path",
    PATTERN: "$val"
};
const $39e2a8da47246292$var$isExpression = (query)=>!!(query[$39e2a8da47246292$var$LogicalOperator.AND] || query[$39e2a8da47246292$var$LogicalOperator.OR]);
const $39e2a8da47246292$var$isPath = (query)=>!!query[$39e2a8da47246292$var$KeyType.PATH];
const $39e2a8da47246292$var$isLeaf = (query)=>!$39e2a8da47246292$var$isArray(query) && $39e2a8da47246292$var$isObject(query) && !$39e2a8da47246292$var$isExpression(query);
const $39e2a8da47246292$var$convertToExplicit = (query)=>({
        [$39e2a8da47246292$var$LogicalOperator.AND]: Object.keys(query).map((key)=>({
                [key]: query[key]
            }))
    });
// When `auto` is `true`, the parse function will infer and initialize and add
// the appropriate `Searcher` instance
function $39e2a8da47246292$var$parse(query, options, { auto: auto = true } = {}) {
    const next = (query)=>{
        let keys = Object.keys(query);
        const isQueryPath = $39e2a8da47246292$var$isPath(query);
        if (!isQueryPath && keys.length > 1 && !$39e2a8da47246292$var$isExpression(query)) return next($39e2a8da47246292$var$convertToExplicit(query));
        if ($39e2a8da47246292$var$isLeaf(query)) {
            const key = isQueryPath ? query[$39e2a8da47246292$var$KeyType.PATH] : keys[0];
            const pattern = isQueryPath ? query[$39e2a8da47246292$var$KeyType.PATTERN] : query[key];
            if (!$39e2a8da47246292$var$isString(pattern)) throw new Error($39e2a8da47246292$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
            const obj = {
                keyId: $39e2a8da47246292$var$createKeyId(key),
                pattern: pattern
            };
            if (auto) obj.searcher = $39e2a8da47246292$var$createSearcher(pattern, options);
            return obj;
        }
        let node = {
            children: [],
            operator: keys[0]
        };
        keys.forEach((key)=>{
            const value = query[key];
            if ($39e2a8da47246292$var$isArray(value)) value.forEach((item)=>{
                node.children.push(next(item));
            });
        });
        return node;
    };
    if (!$39e2a8da47246292$var$isExpression(query)) query = $39e2a8da47246292$var$convertToExplicit(query);
    return next(query);
}
// Practical scoring function
function $39e2a8da47246292$var$computeScore(results, { ignoreFieldNorm: ignoreFieldNorm = $39e2a8da47246292$var$Config.ignoreFieldNorm }) {
    results.forEach((result)=>{
        let totalScore = 1;
        result.matches.forEach(({ key: key, norm: norm, score: score })=>{
            const weight = key ? key.weight : null;
            totalScore *= Math.pow(score === 0 && weight ? Number.EPSILON : score, (weight || 1) * (ignoreFieldNorm ? 1 : norm));
        });
        result.score = totalScore;
    });
}
function $39e2a8da47246292$var$transformMatches(result, data) {
    const matches = result.matches;
    data.matches = [];
    if (!$39e2a8da47246292$var$isDefined(matches)) return;
    matches.forEach((match)=>{
        if (!$39e2a8da47246292$var$isDefined(match.indices) || !match.indices.length) return;
        const { indices: indices, value: value } = match;
        let obj = {
            indices: indices,
            value: value
        };
        if (match.key) obj.key = match.key.src;
        if (match.idx > -1) obj.refIndex = match.idx;
        data.matches.push(obj);
    });
}
function $39e2a8da47246292$var$transformScore(result, data) {
    data.score = result.score;
}
function $39e2a8da47246292$var$format(results, docs, { includeMatches: includeMatches = $39e2a8da47246292$var$Config.includeMatches, includeScore: includeScore = $39e2a8da47246292$var$Config.includeScore } = {}) {
    const transformers = [];
    if (includeMatches) transformers.push($39e2a8da47246292$var$transformMatches);
    if (includeScore) transformers.push($39e2a8da47246292$var$transformScore);
    return results.map((result)=>{
        const { idx: idx } = result;
        const data = {
            item: docs[idx],
            refIndex: idx
        };
        if (transformers.length) transformers.forEach((transformer)=>{
            transformer(result, data);
        });
        return data;
    });
}
class $39e2a8da47246292$export$2e2bcd8739ae039 {
    constructor(docs, options = {}, index){
        this.options = {
            ...$39e2a8da47246292$var$Config,
            ...options
        };
        this.options.useExtendedSearch;
        this._keyStore = new $39e2a8da47246292$var$KeyStore(this.options.keys);
        this.setCollection(docs, index);
    }
    setCollection(docs, index) {
        this._docs = docs;
        if (index && !(index instanceof $39e2a8da47246292$var$FuseIndex)) throw new Error($39e2a8da47246292$var$INCORRECT_INDEX_TYPE);
        this._myIndex = index || $39e2a8da47246292$var$createIndex(this.options.keys, this._docs, {
            getFn: this.options.getFn,
            fieldNormWeight: this.options.fieldNormWeight
        });
    }
    add(doc) {
        if (!$39e2a8da47246292$var$isDefined(doc)) return;
        this._docs.push(doc);
        this._myIndex.add(doc);
    }
    remove(predicate = ()=>false) {
        const results = [];
        for(let i = 0, len = this._docs.length; i < len; i += 1){
            const doc = this._docs[i];
            if (predicate(doc, i)) {
                this.removeAt(i);
                i -= 1;
                len -= 1;
                results.push(doc);
            }
        }
        return results;
    }
    removeAt(idx) {
        this._docs.splice(idx, 1);
        this._myIndex.removeAt(idx);
    }
    getIndex() {
        return this._myIndex;
    }
    search(query, { limit: limit = -1 } = {}) {
        const { includeMatches: includeMatches, includeScore: includeScore, shouldSort: shouldSort, sortFn: sortFn, ignoreFieldNorm: ignoreFieldNorm } = this.options;
        let results = $39e2a8da47246292$var$isString(query) ? $39e2a8da47246292$var$isString(this._docs[0]) ? this._searchStringList(query) : this._searchObjectList(query) : this._searchLogical(query);
        $39e2a8da47246292$var$computeScore(results, {
            ignoreFieldNorm: ignoreFieldNorm
        });
        if (shouldSort) results.sort(sortFn);
        if ($39e2a8da47246292$var$isNumber(limit) && limit > -1) results = results.slice(0, limit);
        return $39e2a8da47246292$var$format(results, this._docs, {
            includeMatches: includeMatches,
            includeScore: includeScore
        });
    }
    _searchStringList(query) {
        const searcher = $39e2a8da47246292$var$createSearcher(query, this.options);
        const { records: records } = this._myIndex;
        const results = [];
        // Iterate over every string in the index
        records.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$39e2a8da47246292$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) results.push({
                item: text,
                idx: idx,
                matches: [
                    {
                        score: score,
                        value: text,
                        norm: norm,
                        indices: indices
                    }
                ]
            });
        });
        return results;
    }
    _searchLogical(query) {
        const expression = $39e2a8da47246292$var$parse(query, this.options);
        const evaluate = (node, item, idx)=>{
            if (!node.children) {
                const { keyId: keyId, searcher: searcher } = node;
                const matches = this._findMatches({
                    key: this._keyStore.get(keyId),
                    value: this._myIndex.getValueForItemAtKeyId(item, keyId),
                    searcher: searcher
                });
                if (matches && matches.length) return [
                    {
                        idx: idx,
                        item: item,
                        matches: matches
                    }
                ];
                return [];
            }
            const res = [];
            for(let i = 0, len = node.children.length; i < len; i += 1){
                const child = node.children[i];
                const result = evaluate(child, item, idx);
                if (result.length) res.push(...result);
                else if (node.operator === $39e2a8da47246292$var$LogicalOperator.AND) return [];
            }
            return res;
        };
        const records = this._myIndex.records;
        const resultMap = {};
        const results = [];
        records.forEach(({ $: item, i: idx })=>{
            if ($39e2a8da47246292$var$isDefined(item)) {
                let expResults = evaluate(expression, item, idx);
                if (expResults.length) {
                    // Dedupe when adding
                    if (!resultMap[idx]) {
                        resultMap[idx] = {
                            idx: idx,
                            item: item,
                            matches: []
                        };
                        results.push(resultMap[idx]);
                    }
                    expResults.forEach(({ matches: matches })=>{
                        resultMap[idx].matches.push(...matches);
                    });
                }
            }
        });
        return results;
    }
    _searchObjectList(query) {
        const searcher = $39e2a8da47246292$var$createSearcher(query, this.options);
        const { keys: keys, records: records } = this._myIndex;
        const results = [];
        // List is Array<Object>
        records.forEach(({ $: item, i: idx })=>{
            if (!$39e2a8da47246292$var$isDefined(item)) return;
            let matches = [];
            // Iterate over every key (i.e, path), and fetch the value at that key
            keys.forEach((key, keyIndex)=>{
                matches.push(...this._findMatches({
                    key: key,
                    value: item[keyIndex],
                    searcher: searcher
                }));
            });
            if (matches.length) results.push({
                idx: idx,
                item: item,
                matches: matches
            });
        });
        return results;
    }
    _findMatches({ key: key, value: value, searcher: searcher }) {
        if (!$39e2a8da47246292$var$isDefined(value)) return [];
        let matches = [];
        if ($39e2a8da47246292$var$isArray(value)) value.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$39e2a8da47246292$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                idx: idx,
                norm: norm,
                indices: indices
            });
        });
        else {
            const { v: text, n: norm } = value;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                norm: norm,
                indices: indices
            });
        }
        return matches;
    }
}
$39e2a8da47246292$export$2e2bcd8739ae039.version = "7.0.0";
$39e2a8da47246292$export$2e2bcd8739ae039.createIndex = $39e2a8da47246292$var$createIndex;
$39e2a8da47246292$export$2e2bcd8739ae039.parseIndex = $39e2a8da47246292$var$parseIndex;
$39e2a8da47246292$export$2e2bcd8739ae039.config = $39e2a8da47246292$var$Config;
$39e2a8da47246292$export$2e2bcd8739ae039.parseQuery = $39e2a8da47246292$var$parse;
$39e2a8da47246292$var$register($39e2a8da47246292$var$ExtendedSearch);



const $8fe923f6c9c50d38$var$SynthesisManager = ()=>{
    const { data: data } = (0, $b5949519849ab230$export$aa5e0ae5ba54b6fb)();
    const [synthesisData, setSynthesisData] = (0, $acw62.useState)([]);
    const [searchInput, setSearchInput] = (0, $acw62.useState)("");
    const showEmptyDataPrompt = (!synthesisData || !synthesisData?.length) && !searchInput;
    const showEmptySeachResults = (!synthesisData || !synthesisData?.length) && searchInput;
    const defaultValue = synthesisData?.length ? `${synthesisData[0]?.created}-${synthesisData[0]?.id}` : undefined;
    (0, $acw62.useEffect)(()=>{
        if (data) setSynthesisData(data);
    }, [
        data
    ]);
    const filterSynthesis = (input)=>{
        setSearchInput(input);
        const fuse = new (0, $39e2a8da47246292$export$2e2bcd8739ae039)(data, {
            shouldSort: true,
            keys: [
                "title",
                "summary",
                "created"
            ]
        });
        const result = fuse.search(input);
        const finalResult = result.length ? result.map((item)=>item.item) : data;
        setSynthesisData(finalResult);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2903b8a25a65807a$export$42a852a2b6b56249), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                fw: 700,
                className: "panel-title",
                mb: (0, $7db4b5652a829202$export$bca14c5b3b88a9c9).padding.sm,
                pt: (0, $7db4b5652a829202$export$bca14c5b3b88a9c9).padding.md,
                children: "Information Synthesis"
            }),
            !showEmptyDataPrompt && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8978bf78d2f2c844$export$e71c4d32a2263218), {
                style: {
                    height: "60px",
                    overflow: "hidden"
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d06f17efb06faf2f$export$2e2bcd8739ae039), {
                    placeholder: searchInput.length ? searchInput : "Search for a synthesis...",
                    data: synthesisData?.map((synthesis)=>({
                            ...synthesis,
                            key: synthesis.id,
                            value: synthesis.s3_path
                        })),
                    onChange: (input)=>filterSynthesis(input),
                    inputFontSize: 700,
                    inputHeight: 75,
                    clearOnSelect: false
                })
            }),
            showEmptyDataPrompt && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $99c68b09e9ea9061$export$2e2bcd8739ae039), {
                svgLink: (0, (/*@__PURE__*/$parcel$interopDefault($099aedb85c366131$exports))),
                description: "Consili is synthesizing your data. You\u2019ll be notified of any new developments"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $082a1c451bb0006a$export$a766cd26d0d69044), {
                chevronPosition: "right",
                variant: "contained",
                defaultValue: defaultValue,
                children: [
                    showEmptySeachResults && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $99c68b09e9ea9061$export$2e2bcd8739ae039), {
                        svgLink: (0, (/*@__PURE__*/$parcel$interopDefault($099aedb85c366131$exports))),
                        description: "No syntheses were found with your search parameters"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $082a1c451bb0006a$export$a766cd26d0d69044), {
                        chevronPosition: "right",
                        variant: "contained",
                        defaultValue: defaultValue
                    }),
                    synthesisData && synthesisData.map((synthesis)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $082a1c451bb0006a$export$a766cd26d0d69044).Item, {
                            value: `${synthesis.id}-${synthesis.created}`,
                            mb: 5,
                            style: {
                                borderColor: "transparent"
                            },
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6fb8c9ac3c56e201$export$2e2bcd8739ae039), {
                                synthesis: synthesis
                            }, synthesis.id)
                        }, synthesis.id))
                ]
            })
        ]
    });
};
var $8fe923f6c9c50d38$export$2e2bcd8739ae039 = $8fe923f6c9c50d38$var$SynthesisManager;


parcelRequire("acw62");



var $af3dec009d6364b6$exports = {};
$af3dec009d6364b6$exports = new URL("triggers_empty_state.7b4ff42b.svg", import.meta.url).toString();



const $e5414662e62ed3b8$var$TriggersManager = ()=>{
    const handleSynthesisClick = ()=>{};
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2903b8a25a65807a$export$42a852a2b6b56249), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                fw: 700,
                className: "panel-title",
                mb: (0, $7db4b5652a829202$export$bca14c5b3b88a9c9).padding.sm,
                pt: (0, $7db4b5652a829202$export$bca14c5b3b88a9c9).padding.md,
                children: "Information Triggers"
            }),
            " ",
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $99c68b09e9ea9061$export$2e2bcd8739ae039), {
                svgLink: (0, (/*@__PURE__*/$parcel$interopDefault($af3dec009d6364b6$exports))),
                description: "Consili will update you when triggers become available",
                onClick: handleSynthesisClick
            })
        ]
    });
};
var $e5414662e62ed3b8$export$2e2bcd8739ae039 = $e5414662e62ed3b8$var$TriggersManager;





var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");



"use client";
function $6bb9b48dd0676e4d$export$82ef48a36e8cf480(value) {
    if (typeof value === "object" && value !== null) {
        if ("base" in value) return value.base;
        return void 0;
    }
    return value;
}





"use client";
function $b9b1fda19a1e53ae$export$81071dc242003613({ spacing: spacing, verticalSpacing: verticalSpacing, cols: cols, selector: selector }) {
    var _a;
    const theme = (0, $692af3391f7b0a55$export$5eb0e84f6418b457)();
    const _verticalSpacing = verticalSpacing === void 0 ? spacing : verticalSpacing;
    const baseStyles = (0, $3fdf1c4abf64babc$export$d697c39a2985a4c)({
        "--sg-spacing-x": (0, $fcab4af601ce7e99$export$f63796f8a9382bfb)((0, $6bb9b48dd0676e4d$export$82ef48a36e8cf480)(spacing)),
        "--sg-spacing-y": (0, $fcab4af601ce7e99$export$f63796f8a9382bfb)((0, $6bb9b48dd0676e4d$export$82ef48a36e8cf480)(_verticalSpacing)),
        "--sg-cols": (_a = (0, $6bb9b48dd0676e4d$export$82ef48a36e8cf480)(cols)) == null ? void 0 : _a.toString()
    });
    const queries = (0, $76cd5f02de8ee394$export$ed97f33186d4b816)(theme.breakpoints).reduce((acc, breakpoint)=>{
        if (!acc[breakpoint]) acc[breakpoint] = {};
        if (typeof spacing === "object" && spacing[breakpoint] !== void 0) acc[breakpoint]["--sg-spacing-x"] = (0, $fcab4af601ce7e99$export$f63796f8a9382bfb)(spacing[breakpoint]);
        if (typeof _verticalSpacing === "object" && _verticalSpacing[breakpoint] !== void 0) acc[breakpoint]["--sg-spacing-y"] = (0, $fcab4af601ce7e99$export$f63796f8a9382bfb)(_verticalSpacing[breakpoint]);
        if (typeof cols === "object" && cols[breakpoint] !== void 0) acc[breakpoint]["--sg-cols"] = cols[breakpoint];
        return acc;
    }, {});
    const sortedBreakpoints = (0, $e4e164d3d352ee58$export$bd80382e31449c0e)((0, $76cd5f02de8ee394$export$ed97f33186d4b816)(queries), theme).filter((breakpoint)=>(0, $76cd5f02de8ee394$export$ed97f33186d4b816)(queries[breakpoint.value]).length > 0);
    const media = sortedBreakpoints.map((breakpoint)=>({
            query: `(min-width: ${theme.breakpoints[breakpoint.value]})`,
            styles: queries[breakpoint.value]
        }));
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e221d2b030e78e40$export$6b8bda124c097cf0), {
        styles: baseStyles,
        media: media,
        selector: selector
    });
}


"use client";
var $653a93786d3cfe08$var$classes = {
    "root": "m-2415a157"
};
var $653a93786d3cfe08$export$2e2bcd8739ae039 = $653a93786d3cfe08$var$classes;







"use client";
var $79fda614df4f4d2c$var$__defProp = Object.defineProperty;
var $79fda614df4f4d2c$var$__defProps = Object.defineProperties;
var $79fda614df4f4d2c$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $79fda614df4f4d2c$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $79fda614df4f4d2c$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $79fda614df4f4d2c$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $79fda614df4f4d2c$var$__defNormalProp = (obj, key, value)=>key in obj ? $79fda614df4f4d2c$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $79fda614df4f4d2c$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($79fda614df4f4d2c$var$__hasOwnProp.call(b, prop)) $79fda614df4f4d2c$var$__defNormalProp(a, prop, b[prop]);
    if ($79fda614df4f4d2c$var$__getOwnPropSymbols) {
        for (var prop of $79fda614df4f4d2c$var$__getOwnPropSymbols(b))if ($79fda614df4f4d2c$var$__propIsEnum.call(b, prop)) $79fda614df4f4d2c$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $79fda614df4f4d2c$var$__spreadProps = (a, b)=>$79fda614df4f4d2c$var$__defProps(a, $79fda614df4f4d2c$var$__getOwnPropDescs(b));
var $79fda614df4f4d2c$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($79fda614df4f4d2c$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $79fda614df4f4d2c$var$__getOwnPropSymbols) {
        for (var prop of $79fda614df4f4d2c$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $79fda614df4f4d2c$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $79fda614df4f4d2c$var$defaultProps = {
    cols: 1,
    spacing: "md"
};
const $79fda614df4f4d2c$export$de97fecb6d4b30a5 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("SimpleGrid", $79fda614df4f4d2c$var$defaultProps, _props);
    const _a = props, { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, cols: cols, verticalSpacing: verticalSpacing, spacing: spacing } = _a, others = $79fda614df4f4d2c$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "cols",
        "verticalSpacing",
        "spacing"
    ]);
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: "SimpleGrid",
        classes: $653a93786d3cfe08$export$2e2bcd8739ae039,
        props: props,
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        vars: vars
    });
    const responsiveClassName = (0, $6f7b5997f3c2d4f0$export$27120f2982e012b1)();
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b9b1fda19a1e53ae$export$81071dc242003613), $79fda614df4f4d2c$var$__spreadProps($79fda614df4f4d2c$var$__spreadValues({}, props), {
        selector: `.${responsiveClassName}`
    })), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $79fda614df4f4d2c$var$__spreadValues($79fda614df4f4d2c$var$__spreadValues({
        ref: ref
    }, getStyles("root", {
        className: responsiveClassName
    })), others)));
});
$79fda614df4f4d2c$export$de97fecb6d4b30a5.classes = (0, $653a93786d3cfe08$export$2e2bcd8739ae039);
$79fda614df4f4d2c$export$de97fecb6d4b30a5.displayName = "@mantine/core/SimpleGrid";



/**
 * @tabler/icons-react v2.42.0 - MIT
 */ 
var $afab9302702ce1a2$export$2e2bcd8739ae039 = (0, $a86819fe50d185cb$export$2e2bcd8739ae039)("chevron-right", "IconChevronRight", [
    [
        "path",
        {
            d: "M9 6l6 6l-6 6",
            key: "svg-0"
        }
    ]
]);



const $6ac5b64770364b12$var$getRandomColor = ()=>{
    const letters = "0123456789ABCDEF";
    let color = "#";
    for(let i = 0; i < 6; i++)color += letters[Math.floor(Math.random() * 16)];
    return color;
};
const $6ac5b64770364b12$var$OperationsUserPage = ({ updatePage: updatePage })=>{
    const users = (0, $1861b69a0d0c7fdf$export$7ef2f7af32a216c1)();
    const [userData, setUserData] = (0, $acw62.useState)([]);
    const regexPattern = /([a-zA-Z]).*?([a-zA-Z])/;
    (0, $acw62.useEffect)(()=>{
        if (!users.isLoading && users.isSuccess) setUserData([
            ...users.data
        ].sort((a, b)=>a.id - b.id) ?? []);
    }, [
        users
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                size: "lg",
                fw: 700,
                pb: 10,
                children: "Select User Account"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79fda614df4f4d2c$export$de97fecb6d4b30a5), {
                cols: 1,
                verticalSpacing: "md",
                children: userData.map((user)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3e91b7d399f248d1$export$60332b2344f7fe41), {
                        padding: "lg",
                        radius: "md",
                        withBorder: true,
                        style: {
                            cursor: "pointer"
                        },
                        onClick: ()=>updatePage(user),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c1d4661523e5510$export$e2255cf6045e8d47), {
                                    round: "25px",
                                    size: "50px",
                                    color: $6ac5b64770364b12$var$getRandomColor(),
                                    children: `${user.username.match(regexPattern)[1].toUpperCase()}${user.username.match(regexPattern)[2].toUpperCase()}`
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                    size: "md",
                                    fw: 500,
                                    children: user.username
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $afab9302702ce1a2$export$2e2bcd8739ae039), {
                                    style: {
                                        marginLeft: "auto"
                                    }
                                })
                            ]
                        })
                    }, user.id))
            })
        ]
    });
};
var $6ac5b64770364b12$export$2e2bcd8739ae039 = $6ac5b64770364b12$var$OperationsUserPage;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
"use client";
const $a1496057e74f601e$var$CheckboxGroupContext = (0, $acw62.createContext)(null);
const $a1496057e74f601e$export$95a3c27e07a551c3 = $a1496057e74f601e$var$CheckboxGroupContext.Provider;
const $a1496057e74f601e$export$5575526870d5c2ae = ()=>(0, $acw62.useContext)($a1496057e74f601e$var$CheckboxGroupContext);



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");

"use client";
function $94e1709ea2607796$export$42d595865b8ce06d({ children: children, role: role }) {
    const ctx = (0, $71cd98bbd243f876$export$40fbe3aaaeb9dc6c)();
    if (!ctx) return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: role,
        "aria-labelledby": ctx.labelId,
        "aria-describedby": ctx.describedBy
    }, children);
}




"use client";
var $3dd35abf5a50b4ce$var$__defProp = Object.defineProperty;
var $3dd35abf5a50b4ce$var$__defProps = Object.defineProperties;
var $3dd35abf5a50b4ce$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $3dd35abf5a50b4ce$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $3dd35abf5a50b4ce$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $3dd35abf5a50b4ce$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $3dd35abf5a50b4ce$var$__defNormalProp = (obj, key, value)=>key in obj ? $3dd35abf5a50b4ce$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $3dd35abf5a50b4ce$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($3dd35abf5a50b4ce$var$__hasOwnProp.call(b, prop)) $3dd35abf5a50b4ce$var$__defNormalProp(a, prop, b[prop]);
    if ($3dd35abf5a50b4ce$var$__getOwnPropSymbols) {
        for (var prop of $3dd35abf5a50b4ce$var$__getOwnPropSymbols(b))if ($3dd35abf5a50b4ce$var$__propIsEnum.call(b, prop)) $3dd35abf5a50b4ce$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $3dd35abf5a50b4ce$var$__spreadProps = (a, b)=>$3dd35abf5a50b4ce$var$__defProps(a, $3dd35abf5a50b4ce$var$__getOwnPropDescs(b));
var $3dd35abf5a50b4ce$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($3dd35abf5a50b4ce$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $3dd35abf5a50b4ce$var$__getOwnPropSymbols) {
        for (var prop of $3dd35abf5a50b4ce$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $3dd35abf5a50b4ce$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $3dd35abf5a50b4ce$var$defaultProps = {};
const $3dd35abf5a50b4ce$export$4aa08d5625cb8ead = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((props, ref)=>{
    const _a = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("CheckboxGroup", $3dd35abf5a50b4ce$var$defaultProps, props), { value: value, defaultValue: defaultValue, onChange: onChange, size: size, wrapperProps: wrapperProps, children: children } = _a, others = $3dd35abf5a50b4ce$var$__objRest(_a, [
        "value",
        "defaultValue",
        "onChange",
        "size",
        "wrapperProps",
        "children"
    ]);
    const [_value, setValue] = (0, $4197894a742d9f84$export$ec55e9daaf703a7d)({
        value: value,
        defaultValue: defaultValue,
        finalValue: [],
        onChange: onChange
    });
    const handleChange = (event)=>{
        const itemValue = event.currentTarget.value;
        setValue(_value.includes(itemValue) ? _value.filter((item)=>item !== itemValue) : [
            ..._value,
            itemValue
        ]);
    };
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a1496057e74f601e$export$95a3c27e07a551c3), {
        value: {
            value: _value,
            onChange: handleChange,
            size: size
        }
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e2e9ff0d29bd408f$export$f5b8910cec6cf069).Wrapper, $3dd35abf5a50b4ce$var$__spreadProps($3dd35abf5a50b4ce$var$__spreadValues($3dd35abf5a50b4ce$var$__spreadValues({
        size: size,
        ref: ref
    }, wrapperProps), others), {
        labelElement: "div",
        __staticSelector: "CheckboxGroup"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $94e1709ea2607796$export$42d595865b8ce06d), {
        role: "group"
    }, children)));
});
$3dd35abf5a50b4ce$export$4aa08d5625cb8ead.classes = (0, $e2e9ff0d29bd408f$export$f5b8910cec6cf069).Wrapper.classes;
$3dd35abf5a50b4ce$export$4aa08d5625cb8ead.displayName = "@mantine/core/CheckboxGroup";



"use client";
var $ecebfb3e6b922634$var$classes = {
    "root": "m-bf2d988c",
    "inner": "m-26062bec",
    "input": "m-26063560",
    "icon": "m-bf295423"
};
var $ecebfb3e6b922634$export$2e2bcd8739ae039 = $ecebfb3e6b922634$var$classes;



var $acw62 = parcelRequire("acw62");
"use client";
var $4bb5d8b4f550b7b3$var$classes = {
    "root": "m-5f75b09e",
    "body": "m-5f6e695e",
    "labelWrapper": "m-d3ea56bb",
    "label": "m-8ee546b8",
    "description": "m-328f68c0",
    "error": "m-8e8a99cc"
};
var $4bb5d8b4f550b7b3$export$2e2bcd8739ae039 = $4bb5d8b4f550b7b3$var$classes;






"use client";
var $9b80d6eb923a334e$var$__defProp = Object.defineProperty;
var $9b80d6eb923a334e$var$__defProps = Object.defineProperties;
var $9b80d6eb923a334e$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $9b80d6eb923a334e$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $9b80d6eb923a334e$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $9b80d6eb923a334e$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $9b80d6eb923a334e$var$__defNormalProp = (obj, key, value)=>key in obj ? $9b80d6eb923a334e$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $9b80d6eb923a334e$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($9b80d6eb923a334e$var$__hasOwnProp.call(b, prop)) $9b80d6eb923a334e$var$__defNormalProp(a, prop, b[prop]);
    if ($9b80d6eb923a334e$var$__getOwnPropSymbols) {
        for (var prop of $9b80d6eb923a334e$var$__getOwnPropSymbols(b))if ($9b80d6eb923a334e$var$__propIsEnum.call(b, prop)) $9b80d6eb923a334e$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $9b80d6eb923a334e$var$__spreadProps = (a, b)=>$9b80d6eb923a334e$var$__defProps(a, $9b80d6eb923a334e$var$__getOwnPropDescs(b));
var $9b80d6eb923a334e$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($9b80d6eb923a334e$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $9b80d6eb923a334e$var$__getOwnPropSymbols) {
        for (var prop of $9b80d6eb923a334e$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $9b80d6eb923a334e$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $9b80d6eb923a334e$export$d1f5de965ed48630 = (0, $4bb5d8b4f550b7b3$export$2e2bcd8739ae039);
const $9b80d6eb923a334e$export$36d3e0619bb09209 = (0, $acw62.forwardRef)((_a, ref)=>{
    var _b = _a, { __staticSelector: __staticSelector, __stylesApiProps: __stylesApiProps, className: className, classNames: classNames, styles: styles, unstyled: unstyled, children: children, label: label, description: description, id: id, disabled: disabled, error: error, size: size, labelPosition: labelPosition = "left", variant: variant, style: style, vars: vars } = _b, others = $9b80d6eb923a334e$var$__objRest(_b, [
        "__staticSelector",
        "__stylesApiProps",
        "className",
        "classNames",
        "styles",
        "unstyled",
        "children",
        "label",
        "description",
        "id",
        "disabled",
        "error",
        "size",
        "labelPosition",
        "variant",
        "style",
        "vars"
    ]);
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: __staticSelector,
        props: __stylesApiProps,
        className: className,
        style: style,
        classes: $4bb5d8b4f550b7b3$export$2e2bcd8739ae039,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $9b80d6eb923a334e$var$__spreadValues($9b80d6eb923a334e$var$__spreadProps($9b80d6eb923a334e$var$__spreadValues({}, getStyles("root")), {
        ref: ref,
        __vars: {
            "--label-fz": (0, $fcab4af601ce7e99$export$7d055c252aebca58)(size),
            "--label-lh": (0, $fcab4af601ce7e99$export$31b21d0167753bb4)(size, "label-lh")
        },
        mod: {
            "label-position": labelPosition
        },
        variant: variant,
        size: size
    }), others), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $9b80d6eb923a334e$var$__spreadValues({}, getStyles("body")), children, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $9b80d6eb923a334e$var$__spreadValues({}, getStyles("labelWrapper")), label && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", $9b80d6eb923a334e$var$__spreadProps($9b80d6eb923a334e$var$__spreadValues({}, getStyles("label")), {
        "data-disabled": disabled || void 0,
        htmlFor: id
    }), label), description && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e2e9ff0d29bd408f$export$f5b8910cec6cf069).Description, $9b80d6eb923a334e$var$__spreadValues({
        size: size,
        __inheritStyles: false
    }, getStyles("description")), description), error && error !== "boolean" && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e2e9ff0d29bd408f$export$f5b8910cec6cf069).Error, $9b80d6eb923a334e$var$__spreadValues({
        size: size,
        __inheritStyles: false
    }, getStyles("error")), error))));
});
$9b80d6eb923a334e$export$36d3e0619bb09209.displayName = "@mantine/core/InlineInput";










"use client";
var $d55bdb080ff7602c$var$__defProp = Object.defineProperty;
var $d55bdb080ff7602c$var$__defProps = Object.defineProperties;
var $d55bdb080ff7602c$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $d55bdb080ff7602c$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $d55bdb080ff7602c$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $d55bdb080ff7602c$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $d55bdb080ff7602c$var$__defNormalProp = (obj, key, value)=>key in obj ? $d55bdb080ff7602c$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $d55bdb080ff7602c$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($d55bdb080ff7602c$var$__hasOwnProp.call(b, prop)) $d55bdb080ff7602c$var$__defNormalProp(a, prop, b[prop]);
    if ($d55bdb080ff7602c$var$__getOwnPropSymbols) {
        for (var prop of $d55bdb080ff7602c$var$__getOwnPropSymbols(b))if ($d55bdb080ff7602c$var$__propIsEnum.call(b, prop)) $d55bdb080ff7602c$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $d55bdb080ff7602c$var$__spreadProps = (a, b)=>$d55bdb080ff7602c$var$__defProps(a, $d55bdb080ff7602c$var$__getOwnPropDescs(b));
var $d55bdb080ff7602c$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($d55bdb080ff7602c$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $d55bdb080ff7602c$var$__getOwnPropSymbols) {
        for (var prop of $d55bdb080ff7602c$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $d55bdb080ff7602c$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $d55bdb080ff7602c$var$defaultProps = {
    labelPosition: "right",
    icon: (0, $5513f088f1bc8bdf$export$c0a1936901b0e55)
};
const $d55bdb080ff7602c$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((theme, { radius: radius, color: color, size: size })=>({
        root: {
            "--checkbox-size": (0, $fcab4af601ce7e99$export$31b21d0167753bb4)(size, "checkbox-size"),
            "--checkbox-radius": radius === void 0 ? void 0 : (0, $fcab4af601ce7e99$export$35724d9c2979edc5)(radius),
            "--checkbox-color": color ? (0, $0a9c57cec2a3e373$export$e22c5d06d177c3fa)(color, theme) : void 0
        }
    }));
const $d55bdb080ff7602c$export$48513f6b9f8ce62d = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("Checkbox", $d55bdb080ff7602c$var$defaultProps, _props);
    const _a = props, { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, color: color, label: label, id: id, size: size, radius: radius, wrapperProps: wrapperProps, children: children, checked: checked, labelPosition: labelPosition, description: description, error: error, disabled: disabled, variant: variant, indeterminate: indeterminate, icon: icon, rootRef: rootRef } = _a, others = $d55bdb080ff7602c$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "color",
        "label",
        "id",
        "size",
        "radius",
        "wrapperProps",
        "children",
        "checked",
        "labelPosition",
        "description",
        "error",
        "disabled",
        "variant",
        "indeterminate",
        "icon",
        "rootRef"
    ]);
    const ctx = (0, $a1496057e74f601e$export$5575526870d5c2ae)();
    const _size = size || (ctx == null ? void 0 : ctx.size);
    const Icon = icon;
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: "Checkbox",
        props: props,
        classes: $ecebfb3e6b922634$export$2e2bcd8739ae039,
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        vars: vars,
        varsResolver: $d55bdb080ff7602c$var$varsResolver
    });
    const { styleProps: styleProps, rest: rest } = (0, $2e4262c949ef0e61$export$fbc67becbdd26fbf)(others);
    const uuid = (0, $cee42e5537afff93$export$f680877a34711e37)(id);
    const contextProps = ctx ? {
        checked: ctx.value.includes(rest.value),
        onChange: ctx.onChange
    } : {};
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9b80d6eb923a334e$export$36d3e0619bb09209), $d55bdb080ff7602c$var$__spreadValues($d55bdb080ff7602c$var$__spreadValues($d55bdb080ff7602c$var$__spreadProps($d55bdb080ff7602c$var$__spreadValues({}, getStyles("root")), {
        __staticSelector: "Checkbox",
        __stylesApiProps: props,
        id: uuid,
        size: _size,
        labelPosition: labelPosition,
        label: label,
        description: description,
        error: error,
        disabled: disabled,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        "data-checked": contextProps.checked || void 0,
        variant: variant,
        ref: rootRef
    }), styleProps), wrapperProps), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $d55bdb080ff7602c$var$__spreadProps($d55bdb080ff7602c$var$__spreadValues({}, getStyles("inner")), {
        mod: {
            "data-label-position": labelPosition
        }
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $d55bdb080ff7602c$var$__spreadProps($d55bdb080ff7602c$var$__spreadValues($d55bdb080ff7602c$var$__spreadValues($d55bdb080ff7602c$var$__spreadValues({
        component: "input",
        id: uuid,
        ref: ref,
        checked: checked,
        disabled: disabled,
        mod: {
            error: !!error,
            indeterminate: indeterminate
        }
    }, getStyles("input", {
        focusable: true
    })), rest), contextProps), {
        type: "checkbox"
    })), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, $d55bdb080ff7602c$var$__spreadValues({
        indeterminate: indeterminate
    }, getStyles("icon")))));
});
$d55bdb080ff7602c$export$48513f6b9f8ce62d.classes = $d55bdb080ff7602c$var$__spreadValues($d55bdb080ff7602c$var$__spreadValues({}, (0, $ecebfb3e6b922634$export$2e2bcd8739ae039)), (0, $9b80d6eb923a334e$export$d1f5de965ed48630));
$d55bdb080ff7602c$export$48513f6b9f8ce62d.displayName = "@mantine/core/Checkbox";
$d55bdb080ff7602c$export$48513f6b9f8ce62d.Group = (0, $3dd35abf5a50b4ce$export$4aa08d5625cb8ead);


var $acw62 = parcelRequire("acw62");
"use client";
var $746950b42ffaa06e$var$classes = {
    "root": "m-6d731127"
};
var $746950b42ffaa06e$export$2e2bcd8739ae039 = $746950b42ffaa06e$var$classes;








"use client";
var $8d008d85a5081d2e$var$__defProp = Object.defineProperty;
var $8d008d85a5081d2e$var$__defProps = Object.defineProperties;
var $8d008d85a5081d2e$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $8d008d85a5081d2e$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $8d008d85a5081d2e$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $8d008d85a5081d2e$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $8d008d85a5081d2e$var$__defNormalProp = (obj, key, value)=>key in obj ? $8d008d85a5081d2e$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $8d008d85a5081d2e$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($8d008d85a5081d2e$var$__hasOwnProp.call(b, prop)) $8d008d85a5081d2e$var$__defNormalProp(a, prop, b[prop]);
    if ($8d008d85a5081d2e$var$__getOwnPropSymbols) {
        for (var prop of $8d008d85a5081d2e$var$__getOwnPropSymbols(b))if ($8d008d85a5081d2e$var$__propIsEnum.call(b, prop)) $8d008d85a5081d2e$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $8d008d85a5081d2e$var$__spreadProps = (a, b)=>$8d008d85a5081d2e$var$__defProps(a, $8d008d85a5081d2e$var$__getOwnPropDescs(b));
var $8d008d85a5081d2e$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($8d008d85a5081d2e$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $8d008d85a5081d2e$var$__getOwnPropSymbols) {
        for (var prop of $8d008d85a5081d2e$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $8d008d85a5081d2e$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $8d008d85a5081d2e$var$defaultProps = {
    gap: "md",
    align: "stretch",
    justify: "flex-start"
};
const $8d008d85a5081d2e$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((_, { gap: gap, align: align, justify: justify })=>({
        root: {
            "--stack-gap": (0, $fcab4af601ce7e99$export$f63796f8a9382bfb)(gap),
            "--stack-align": align,
            "--stack-justify": justify
        }
    }));
const $8d008d85a5081d2e$export$694e0d28c7ffc90c = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("Stack", $8d008d85a5081d2e$var$defaultProps, _props);
    const _a = props, { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, align: align, justify: justify, gap: gap, variant: variant } = _a, others = $8d008d85a5081d2e$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "align",
        "justify",
        "gap",
        "variant"
    ]);
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: "Stack",
        props: props,
        classes: $746950b42ffaa06e$export$2e2bcd8739ae039,
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        vars: vars,
        varsResolver: $8d008d85a5081d2e$var$varsResolver
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $8d008d85a5081d2e$var$__spreadValues($8d008d85a5081d2e$var$__spreadProps($8d008d85a5081d2e$var$__spreadValues({
        ref: ref
    }, getStyles("root")), {
        variant: variant
    }), others));
});
$8d008d85a5081d2e$export$694e0d28c7ffc90c.classes = (0, $746950b42ffaa06e$export$2e2bcd8739ae039);
$8d008d85a5081d2e$export$694e0d28c7ffc90c.displayName = "@mantine/core/Stack";









var $acw62 = parcelRequire("acw62");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $7eed31699f9c14e5$var$extendStatics = function(d, b) {
    $7eed31699f9c14e5$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $7eed31699f9c14e5$var$extendStatics(d, b);
};
function $7eed31699f9c14e5$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $7eed31699f9c14e5$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $7eed31699f9c14e5$export$18ce0697a983be9b = function() {
    $7eed31699f9c14e5$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7eed31699f9c14e5$export$18ce0697a983be9b.apply(this, arguments);
};
function $7eed31699f9c14e5$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $7eed31699f9c14e5$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $7eed31699f9c14e5$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $7eed31699f9c14e5$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.push(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.push(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $7eed31699f9c14e5$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $7eed31699f9c14e5$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $7eed31699f9c14e5$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $7eed31699f9c14e5$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $7eed31699f9c14e5$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $7eed31699f9c14e5$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $7eed31699f9c14e5$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $7eed31699f9c14e5$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $7eed31699f9c14e5$export$45d3717a4c69092e(o, m, p);
}
function $7eed31699f9c14e5$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $7eed31699f9c14e5$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $7eed31699f9c14e5$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($7eed31699f9c14e5$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $7eed31699f9c14e5$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $7eed31699f9c14e5$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $7eed31699f9c14e5$export$10c90e4f7922046c(v) {
    return this instanceof $7eed31699f9c14e5$export$10c90e4f7922046c ? (this.v = v, this) : new $7eed31699f9c14e5$export$10c90e4f7922046c(v);
}
function $7eed31699f9c14e5$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $7eed31699f9c14e5$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $7eed31699f9c14e5$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $7eed31699f9c14e5$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $7eed31699f9c14e5$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $7eed31699f9c14e5$export$19a8beecd37a4c45 === "function" ? $7eed31699f9c14e5$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $7eed31699f9c14e5$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $7eed31699f9c14e5$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $7eed31699f9c14e5$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $7eed31699f9c14e5$export$45d3717a4c69092e(result, mod, k);
    }
    $7eed31699f9c14e5$var$__setModuleDefault(result, mod);
    return result;
}
function $7eed31699f9c14e5$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $7eed31699f9c14e5$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $7eed31699f9c14e5$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $7eed31699f9c14e5$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}


function $6bb1e54ce1bc6efa$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $bcd4e42ca4163639$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $bcd4e42ca4163639$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $6bb1e54ce1bc6efa$export$2e2bcd8739ae039)(function(prop) {
    return $bcd4e42ca4163639$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});



var $acw62 = parcelRequire("acw62");
var $d2b63732fb4ff365$exports = {};
//
$d2b63732fb4ff365$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


var $298fb931ed4fbf8b$export$71ad59f2e432cfe8 = "-ms-";
var $298fb931ed4fbf8b$export$2c0f367103c8d01c = "-moz-";
var $298fb931ed4fbf8b$export$39dfd62a25e0fe93 = "-webkit-";
var $298fb931ed4fbf8b$export$a29989082612d0d9 = "comm";
var $298fb931ed4fbf8b$export$aa3a2e812ca8570d = "rule";
var $298fb931ed4fbf8b$export$527d108ccf083c2b = "decl";
var $298fb931ed4fbf8b$export$d3d35020fa5b54f0 = "@page";
var $298fb931ed4fbf8b$export$500415a86c544f73 = "@media";
var $298fb931ed4fbf8b$export$a763edbf796b780a = "@import";
var $298fb931ed4fbf8b$export$2790aeb8b4e5c826 = "@charset";
var $298fb931ed4fbf8b$export$1cc683e23b84b133 = "@viewport";
var $298fb931ed4fbf8b$export$9447a5efea57e862 = "@supports";
var $298fb931ed4fbf8b$export$ef011b4e114b1fba = "@document";
var $298fb931ed4fbf8b$export$6aad947bda0f3f46 = "@namespace";
var $298fb931ed4fbf8b$export$b44a8529a35fcb60 = "@keyframes";
var $298fb931ed4fbf8b$export$2c16de31893252e6 = "@font-face";
var $298fb931ed4fbf8b$export$3d846dd52e150c6f = "@counter-style";
var $298fb931ed4fbf8b$export$22314bfbb57653fe = "@font-feature-values";
var $298fb931ed4fbf8b$export$d773506282b3cfe6 = "@layer";
var $298fb931ed4fbf8b$export$2335f513bbd82c6d = Math.abs;
var $298fb931ed4fbf8b$export$6788812c4e6611e6 = String.fromCharCode;
var $298fb931ed4fbf8b$export$e6e34fd1f2686227 = Object.assign;
function $298fb931ed4fbf8b$export$d6af199866bfb566(e, r) {
    return $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 1)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 2)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 3) : 0;
}
function $298fb931ed4fbf8b$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $298fb931ed4fbf8b$export$f8e21b1e77979a08(e, r, a) {
    return e.indexOf(r, a);
}
function $298fb931ed4fbf8b$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $298fb931ed4fbf8b$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $298fb931ed4fbf8b$export$36776f635604f274(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$f9084667e487ed46(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $298fb931ed4fbf8b$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
function $298fb931ed4fbf8b$export$3dea766d36a8935f(e, r) {
    return e.filter(function(e) {
        return !$298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r);
    });
}
var $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = 1;
var $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1;
var $298fb931ed4fbf8b$export$f24224f1c91d8156 = 0;
var $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0;
var $298fb931ed4fbf8b$export$c0306caf338ac095 = 0;
var $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "";
function $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, n, c, s, t, u) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $298fb931ed4fbf8b$export$53f1d5ea8de3d7c,
        column: $298fb931ed4fbf8b$export$4e0c71f277ca26b3,
        length: t,
        return: "",
        siblings: u
    };
}
function $298fb931ed4fbf8b$export$784d13d8ee351f07(e, r) {
    return $298fb931ed4fbf8b$export$e6e34fd1f2686227($298fb931ed4fbf8b$export$35059013cd4a06db("", null, null, "", null, null, 0, e.siblings), e, {
        length: -e.length
    }, r);
}
function $298fb931ed4fbf8b$export$590e8b2c435046d9(e) {
    while(e.root)e = $298fb931ed4fbf8b$export$784d13d8ee351f07(e.root, {
        children: [
            e
        ]
    });
    $298fb931ed4fbf8b$export$10d8903dec122b9d(e, e.siblings);
}
function $298fb931ed4fbf8b$export$eba6f6f03b0a92e7() {
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$232faf9add678146() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 > 0 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, --$298fb931ed4fbf8b$export$5880b8b5730aff45) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3--, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c--;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$48cfd1e771a65c4f() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 < $298fb931ed4fbf8b$export$f24224f1c91d8156 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45++) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3++, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c++;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$4d3fb11e950abb9e() {
    return $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$e88cb2efb12ae807() {
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, r) {
    return $298fb931ed4fbf8b$export$2f35ab04d2335697($298fb931ed4fbf8b$export$30a86d91af8ff6e6, e, r);
}
function $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $298fb931ed4fbf8b$export$2de70f21292aac9e(e) {
    return $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$f24224f1c91d8156 = $298fb931ed4fbf8b$export$36776f635604f274($298fb931ed4fbf8b$export$30a86d91af8ff6e6 = e), $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0, [];
}
function $298fb931ed4fbf8b$export$45918ac1574455b1(e) {
    return $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "", e;
}
function $298fb931ed4fbf8b$export$410ac95b9ec204b8(e) {
    return $298fb931ed4fbf8b$export$87c2784dc9fc4ab($298fb931ed4fbf8b$export$58adb3bec8346d0f($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1, $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $298fb931ed4fbf8b$export$660b2ee2d4fb4eff(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$5f8c09e3ae6f64e1($298fb931ed4fbf8b$export$2de70f21292aac9e(e)));
}
function $298fb931ed4fbf8b$export$7af1228ff777d175(e) {
    while($298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$4d3fb11e950abb9e())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 33) $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    else break;
    return $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) > 2 || $298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $298fb931ed4fbf8b$export$5f8c09e3ae6f64e1(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095)){
        case 0:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$c0306caf338ac095), e);
            break;
        default:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$c0306caf338ac095), e);
    }
    return e;
}
function $298fb931ed4fbf8b$export$955ba06d119e085e(e, r) {
    while(--r && $298fb931ed4fbf8b$export$48cfd1e771a65c4f())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 48 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 102 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 57 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 65 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 70 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 97) break;
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$e88cb2efb12ae807() + (r < 6 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() == 32 && $298fb931ed4fbf8b$export$48cfd1e771a65c4f() == 32));
}
function $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$c0306caf338ac095){
        case e:
            return $298fb931ed4fbf8b$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $298fb931ed4fbf8b$export$c889f2fcc19dbf12($298fb931ed4fbf8b$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
            break;
    }
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$4254d4e2b3745c4c(e, r) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 57) break;
    else if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 84 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $298fb931ed4fbf8b$export$58adb3bec8346d0f(r, $298fb931ed4fbf8b$export$5880b8b5730aff45 - 1) + "*" + $298fb931ed4fbf8b$export$6788812c4e6611e6(e === 47 ? e : $298fb931ed4fbf8b$export$48cfd1e771a65c4f());
}
function $298fb931ed4fbf8b$export$c2ab62c7bf24634(e) {
    while(!$298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$4d3fb11e950abb9e()))$298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$ef7acd7185315e22(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $298fb931ed4fbf8b$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $298fb931ed4fbf8b$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var g = 0;
    var m = "";
    var x = c;
    var y = s;
    var j = n;
    var A = m;
    while(w)switch(h = g, g = $298fb931ed4fbf8b$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $298fb931ed4fbf8b$export$a9db5e087081082d(A, l - 1) == 58) {
                if ($298fb931ed4fbf8b$export$f8e21b1e77979a08(A += $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$410ac95b9ec204b8(g), "&", "&\f"), "&\f", $298fb931ed4fbf8b$export$2335f513bbd82c6d(f ? u[f - 1] : 0)) != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            A += $298fb931ed4fbf8b$export$410ac95b9ec204b8(g);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            A += $298fb931ed4fbf8b$export$7af1228ff777d175(h);
            break;
        case 92:
            A += $298fb931ed4fbf8b$export$955ba06d119e085e($298fb931ed4fbf8b$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($298fb931ed4fbf8b$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$4a34f930e789283c($298fb931ed4fbf8b$export$4254d4e2b3745c4c($298fb931ed4fbf8b$export$48cfd1e771a65c4f(), $298fb931ed4fbf8b$export$e88cb2efb12ae807()), r, a, i), i);
                    break;
                default:
                    A += "/";
            }
            break;
        case 123 * b:
            u[f++] = $298fb931ed4fbf8b$export$36776f635604f274(A) * d;
        case 125 * b:
        case 59:
        case 0:
            switch(g){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) A = $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(A, /\f/g, "");
                    if (p > 0 && $298fb931ed4fbf8b$export$36776f635604f274(A) - l) $298fb931ed4fbf8b$export$10d8903dec122b9d(p > 32 ? $298fb931ed4fbf8b$export$f8483753829ec8f3(A + ";", n, a, l - 1, i) : $298fb931ed4fbf8b$export$f8483753829ec8f3($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(A, " ", "") + ";", n, a, l - 2, i), i);
                    break;
                case 59:
                    A += ";";
                default:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d(j = $298fb931ed4fbf8b$export$3307ffa7023ede1e(A, r, a, f, o, c, u, m, x = [], y = [], l, s), s);
                    if (g === 123) {
                        if (o === 0) $298fb931ed4fbf8b$export$98e6a39c04603d36(A, r, j, j, x, s, l, u, y);
                        else switch(v === 99 && $298fb931ed4fbf8b$export$a9db5e087081082d(A, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(e, j, j, n && $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$3307ffa7023ede1e(e, j, j, 0, 0, c, u, m, c, x = [], l, y), y), c, y, l, u, n ? x : y);
                                break;
                            default:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(A, j, j, j, [
                                    ""
                                ], y, 0, u, y);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, m = A = "", l = t;
            break;
        case 58:
            l = 1 + $298fb931ed4fbf8b$export$36776f635604f274(A), p = h;
        default:
            if (b < 1) {
                if (g == 123) --b;
                else if (g == 125 && b++ == 0 && $298fb931ed4fbf8b$export$232faf9add678146() == 125) continue;
            }
            switch(A += $298fb931ed4fbf8b$export$6788812c4e6611e6(g), g * b){
                case 38:
                    d = o > 0 ? 1 : (A += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($298fb931ed4fbf8b$export$36776f635604f274(A) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 45) A += $298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$48cfd1e771a65c4f());
                    v = $298fb931ed4fbf8b$export$4d3fb11e950abb9e(), o = l = $298fb931ed4fbf8b$export$36776f635604f274(m = A += $298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$e88cb2efb12ae807())), g++;
                    break;
                case 45:
                    if (h === 45 && $298fb931ed4fbf8b$export$36776f635604f274(A) == 2) b = 0;
            }
    }
    return s;
}
function $298fb931ed4fbf8b$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l, v) {
    var p = s - 1;
    var h = s === 0 ? t : [
        ""
    ];
    var b = $298fb931ed4fbf8b$export$f9084667e487ed46(h);
    for(var w = 0, d = 0, g = 0; w < n; ++w)for(var $ = 0, m = $298fb931ed4fbf8b$export$2f35ab04d2335697(e, p + 1, p = $298fb931ed4fbf8b$export$2335f513bbd82c6d(d = u[w])), x = e; $ < b; ++$)if (x = $298fb931ed4fbf8b$export$87c2784dc9fc4ab(d > 0 ? h[$] + " " + m : $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(m, /&\f/g, h[$]))) f[g++] = x;
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, s === 0 ? $298fb931ed4fbf8b$export$aa3a2e812ca8570d : i, f, o, l, v);
}
function $298fb931ed4fbf8b$export$4a34f930e789283c(e, r, a, c) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$a29989082612d0d9, $298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$eba6f6f03b0a92e7()), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 2, -2), 0, c);
}
function $298fb931ed4fbf8b$export$f8483753829ec8f3(e, r, a, n, c) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$527d108ccf083c2b, $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 0, n), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, n + 1, -1), n, c);
}
function $298fb931ed4fbf8b$export$82e9f45cca5ba907(n, c, s) {
    switch($298fb931ed4fbf8b$export$d6af199866bfb566(n, c)){
        case 5103:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-$1$2" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-item-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-line-pack" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-grow", "") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-pack:$3" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-column-align" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n + (s = s[c].value), "span", 0) ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$298fb931ed4fbf8b$export$f8e21b1e77979a08(s, "span", 0) ? $298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) : +$298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) - +$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($298fb931ed4fbf8b$export$36776f635604f274(n) - 1 - c > 6) switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n, "stretch", 0) ? $298fb931ed4fbf8b$export$82e9f45cca5ba907($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 6) === 121) return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, $298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    for(var n = 0; n < e.length; n++)a += r(e[n], n, e, r) || "";
    return a;
}
function $298fb931ed4fbf8b$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $298fb931ed4fbf8b$export$a763edbf796b780a:
        case $298fb931ed4fbf8b$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $298fb931ed4fbf8b$export$a29989082612d0d9:
            return "";
        case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            if (!$298fb931ed4fbf8b$export$36776f635604f274(e.value = e.props.join(","))) return "";
    }
    return $298fb931ed4fbf8b$export$36776f635604f274(a = $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $298fb931ed4fbf8b$export$5a7767152ae0305f(e) {
    var r = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $298fb931ed4fbf8b$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $298fb931ed4fbf8b$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $298fb931ed4fbf8b$export$527d108ccf083c2b:
                n.return = $298fb931ed4fbf8b$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                    $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                        value: $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (n.length) return $298fb931ed4fbf8b$export$1be1fc439b849fdf(u = n.props, function(c) {
                    switch($298fb931ed4fbf8b$export$4659b591c19bdf3d(c, i = /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                props: [
                                    $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $298fb931ed4fbf8b$export$e6e34fd1f2686227(n, {
                                props: $298fb931ed4fbf8b$export$3dea766d36a8935f(u, i)
                            });
                            break;
                        case "::placeholder":
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                props: [
                                    $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "input-$1")
                                ]
                            }));
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                props: [
                                    $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                props: [
                                    $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "input-$1")
                                ]
                            }));
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $298fb931ed4fbf8b$export$e6e34fd1f2686227(n, {
                                props: $298fb931ed4fbf8b$export$3dea766d36a8935f(u, i)
                            });
                            break;
                    }
                    return "";
                });
        }
    }
}
function $298fb931ed4fbf8b$export$76a88f7de6507443(e) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $298fb931ed4fbf8b$export$1be1fc439b849fdf($298fb931ed4fbf8b$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($298fb931ed4fbf8b$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $298fb931ed4fbf8b$export$2f35ab04d2335697(r, 1, $298fb931ed4fbf8b$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $298fb931ed4fbf8b$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $298fb931ed4fbf8b$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $936be3b045ab836e$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $936be3b045ab836e$export$2e2bcd8739ae039 = $936be3b045ab836e$var$unitlessKeys;



var $27ab9eeb1c7feda9$var$f = ("undefined" != typeof $cfae44f0dfdf62c0$exports && void 0 !== $cfae44f0dfdf62c0$exports.env && undefined, "data-styled"), $27ab9eeb1c7feda9$var$m = "active", $27ab9eeb1c7feda9$var$y = "data-styled-version", $27ab9eeb1c7feda9$export$83d89fbfd8236492 = "6.1.8", $27ab9eeb1c7feda9$var$g = "/*!sc*/\n", $27ab9eeb1c7feda9$var$S = "undefined" != typeof window && "HTMLElement" in window, $27ab9eeb1c7feda9$var$w = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : ("undefined" != typeof $cfae44f0dfdf62c0$exports && $cfae44f0dfdf62c0$exports.env, "undefined" != typeof $cfae44f0dfdf62c0$exports && $cfae44f0dfdf62c0$exports.env, false)), $27ab9eeb1c7feda9$var$b = {}, $27ab9eeb1c7feda9$var$E = /invalid hook call/i, $27ab9eeb1c7feda9$var$N = new Set, $27ab9eeb1c7feda9$var$P = function(t, n) {
    var o, s, i, a, e;
}, $27ab9eeb1c7feda9$var$_ = Object.freeze([]), $27ab9eeb1c7feda9$var$C = Object.freeze({});
function $27ab9eeb1c7feda9$var$I(e, t, n) {
    return void 0 === n && (n = $27ab9eeb1c7feda9$var$C), e.theme !== n.theme && e.theme || t || n.theme;
}
var $27ab9eeb1c7feda9$var$A = new Set([
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "track",
    "u",
    "ul",
    "use",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
]), $27ab9eeb1c7feda9$var$O = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $27ab9eeb1c7feda9$var$D = /(^-|-$)/g;
function $27ab9eeb1c7feda9$var$R(e) {
    return e.replace($27ab9eeb1c7feda9$var$O, "-").replace($27ab9eeb1c7feda9$var$D, "");
}
var $27ab9eeb1c7feda9$var$T = /(a)(d)/gi, $27ab9eeb1c7feda9$var$k = 52, $27ab9eeb1c7feda9$var$j = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $27ab9eeb1c7feda9$var$x(e) {
    var t, n = "";
    for(t = Math.abs(e); t > $27ab9eeb1c7feda9$var$k; t = t / $27ab9eeb1c7feda9$var$k | 0)n = $27ab9eeb1c7feda9$var$j(t % $27ab9eeb1c7feda9$var$k) + n;
    return ($27ab9eeb1c7feda9$var$j(t % $27ab9eeb1c7feda9$var$k) + n).replace($27ab9eeb1c7feda9$var$T, "$1-$2");
}
var $27ab9eeb1c7feda9$var$V, $27ab9eeb1c7feda9$var$F = 5381, $27ab9eeb1c7feda9$var$M = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $27ab9eeb1c7feda9$var$$ = function(e) {
    return $27ab9eeb1c7feda9$var$M($27ab9eeb1c7feda9$var$F, e);
};
function $27ab9eeb1c7feda9$var$z(e) {
    return $27ab9eeb1c7feda9$var$x($27ab9eeb1c7feda9$var$$(e) >>> 0);
}
function $27ab9eeb1c7feda9$var$B(e) {
    return (0, e.displayName) || e.name || "Component";
}
function $27ab9eeb1c7feda9$var$L(e) {
    return "string" == typeof e && true;
}
var $27ab9eeb1c7feda9$var$G = "function" == typeof Symbol && Symbol.for, $27ab9eeb1c7feda9$var$Y = $27ab9eeb1c7feda9$var$G ? Symbol.for("react.memo") : 60115, $27ab9eeb1c7feda9$var$W = $27ab9eeb1c7feda9$var$G ? Symbol.for("react.forward_ref") : 60112, $27ab9eeb1c7feda9$var$q = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
}, $27ab9eeb1c7feda9$var$H = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, $27ab9eeb1c7feda9$var$U = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, $27ab9eeb1c7feda9$var$J = (($27ab9eeb1c7feda9$var$V = {})[$27ab9eeb1c7feda9$var$W] = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
}, $27ab9eeb1c7feda9$var$V[$27ab9eeb1c7feda9$var$Y] = $27ab9eeb1c7feda9$var$U, $27ab9eeb1c7feda9$var$V);
function $27ab9eeb1c7feda9$var$X(e) {
    var t;
    return ("type" in (t = e) && t.type.$$typeof) === $27ab9eeb1c7feda9$var$Y ? $27ab9eeb1c7feda9$var$U : "$$typeof" in e ? $27ab9eeb1c7feda9$var$J[e.$$typeof] : $27ab9eeb1c7feda9$var$q;
}
var $27ab9eeb1c7feda9$var$Z = Object.defineProperty, $27ab9eeb1c7feda9$var$K = Object.getOwnPropertyNames, $27ab9eeb1c7feda9$var$Q = Object.getOwnPropertySymbols, $27ab9eeb1c7feda9$var$ee = Object.getOwnPropertyDescriptor, $27ab9eeb1c7feda9$var$te = Object.getPrototypeOf, $27ab9eeb1c7feda9$var$ne = Object.prototype;
function $27ab9eeb1c7feda9$var$oe(e, t, n) {
    if ("string" != typeof t) {
        if ($27ab9eeb1c7feda9$var$ne) {
            var o = $27ab9eeb1c7feda9$var$te(t);
            o && o !== $27ab9eeb1c7feda9$var$ne && $27ab9eeb1c7feda9$var$oe(e, o, n);
        }
        var r = $27ab9eeb1c7feda9$var$K(t);
        $27ab9eeb1c7feda9$var$Q && (r = r.concat($27ab9eeb1c7feda9$var$Q(t)));
        for(var s = $27ab9eeb1c7feda9$var$X(e), i = $27ab9eeb1c7feda9$var$X(t), a = 0; a < r.length; ++a){
            var c = r[a];
            if (!(c in $27ab9eeb1c7feda9$var$H || n && n[c] || i && c in i || s && c in s)) {
                var l = $27ab9eeb1c7feda9$var$ee(t, c);
                try {
                    $27ab9eeb1c7feda9$var$Z(e, c, l);
                } catch (e) {}
            }
        }
    }
    return e;
}
function $27ab9eeb1c7feda9$var$re(e) {
    return "function" == typeof e;
}
function $27ab9eeb1c7feda9$export$7ba318d8d2f06c76(e) {
    return "object" == typeof e && "styledComponentId" in e;
}
function $27ab9eeb1c7feda9$var$ie(e, t) {
    return e && t ? "".concat(e, " ").concat(t) : e || t || "";
}
function $27ab9eeb1c7feda9$var$ae(e, t) {
    if (0 === e.length) return "";
    for(var n = e[0], o = 1; o < e.length; o++)n += t ? t + e[o] : e[o];
    return n;
}
function $27ab9eeb1c7feda9$var$ce(e) {
    return null !== e && "object" == typeof e && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function $27ab9eeb1c7feda9$var$le(e, t, n) {
    if (void 0 === n && (n = !1), !n && !$27ab9eeb1c7feda9$var$ce(e) && !Array.isArray(e)) return t;
    if (Array.isArray(t)) for(var o = 0; o < t.length; o++)e[o] = $27ab9eeb1c7feda9$var$le(e[o], t[o]);
    else if ($27ab9eeb1c7feda9$var$ce(t)) for(var o in t)e[o] = $27ab9eeb1c7feda9$var$le(e[o], t[o]);
    return e;
}
function $27ab9eeb1c7feda9$var$ue(e, t) {
    Object.defineProperty(e, "toString", {
        value: t
    });
}
var $27ab9eeb1c7feda9$var$pe = {};
function $27ab9eeb1c7feda9$var$de() {
    for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
    for(var n = e[0], o = [], r = 1, s = e.length; r < s; r += 1)o.push(e[r]);
    return o.forEach(function(e) {
        n = n.replace(/%[a-z]/, e);
    }), n;
}
function $27ab9eeb1c7feda9$var$he(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    return new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t, " for more information.").concat(n.length > 0 ? " Args: ".concat(n.join(", ")) : ""));
}
var $27ab9eeb1c7feda9$var$fe = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    return e.prototype.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, e.prototype.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, o = n.length, r = o; e >= r;)if ((r <<= 1) < 0) throw $27ab9eeb1c7feda9$var$he(16, "".concat(e));
            this.groupSizes = new Uint32Array(r), this.groupSizes.set(n), this.length = r;
            for(var s = o; s < r; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = (s = 0, t.length); s < a; s++)this.tag.insertRule(i, t[s]) && (this.groupSizes[e]++, i++);
    }, e.prototype.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), o = n + t;
            this.groupSizes[e] = 0;
            for(var r = n; r < o; r++)this.tag.deleteRule(n);
        }
    }, e.prototype.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], o = this.indexOfGroup(e), r = o + n, s = o; s < r; s++)t += "".concat(this.tag.getRule(s)).concat($27ab9eeb1c7feda9$var$g);
        return t;
    }, e;
}(), $27ab9eeb1c7feda9$var$me = new Map, $27ab9eeb1c7feda9$var$ye = new Map, $27ab9eeb1c7feda9$var$ve = 1, $27ab9eeb1c7feda9$var$ge = function(e) {
    if ($27ab9eeb1c7feda9$var$me.has(e)) return $27ab9eeb1c7feda9$var$me.get(e);
    for(; $27ab9eeb1c7feda9$var$ye.has($27ab9eeb1c7feda9$var$ve);)$27ab9eeb1c7feda9$var$ve++;
    var t = $27ab9eeb1c7feda9$var$ve++;
    return $27ab9eeb1c7feda9$var$me.set(e, t), $27ab9eeb1c7feda9$var$ye.set(t, e), t;
}, $27ab9eeb1c7feda9$var$Se = function(e, t) {
    $27ab9eeb1c7feda9$var$ve = t + 1, $27ab9eeb1c7feda9$var$me.set(e, t), $27ab9eeb1c7feda9$var$ye.set(t, e);
}, $27ab9eeb1c7feda9$var$we = "style[".concat($27ab9eeb1c7feda9$var$f, "][").concat($27ab9eeb1c7feda9$var$y, '="').concat($27ab9eeb1c7feda9$export$83d89fbfd8236492, '"]'), $27ab9eeb1c7feda9$var$be = new RegExp("^".concat($27ab9eeb1c7feda9$var$f, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), $27ab9eeb1c7feda9$var$Ee = function(e, t, n) {
    for(var o, r = n.split(","), s = 0, i = r.length; s < i; s++)(o = r[s]) && e.registerName(t, o);
}, $27ab9eeb1c7feda9$var$Ne = function(e, t) {
    for(var n, o = (null !== (n = t.textContent) && void 0 !== n ? n : "").split($27ab9eeb1c7feda9$var$g), r = [], s = 0, i = o.length; s < i; s++){
        var a = o[s].trim();
        if (a) {
            var c = a.match($27ab9eeb1c7feda9$var$be);
            if (c) {
                var l = 0 | parseInt(c[1], 10), u = c[2];
                0 !== l && ($27ab9eeb1c7feda9$var$Se(u, l), $27ab9eeb1c7feda9$var$Ee(e, u, c[3]), e.getTag().insertRules(l, r)), r.length = 0;
            } else r.push(a);
        }
    }
};
function $27ab9eeb1c7feda9$var$Pe() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}
var $27ab9eeb1c7feda9$var$_e = function(e) {
    var t = document.head, n = e || t, o = document.createElement("style"), r = function(e) {
        var t = Array.from(e.querySelectorAll("style[".concat($27ab9eeb1c7feda9$var$f, "]")));
        return t[t.length - 1];
    }(n), s = void 0 !== r ? r.nextSibling : null;
    o.setAttribute($27ab9eeb1c7feda9$var$f, $27ab9eeb1c7feda9$var$m), o.setAttribute($27ab9eeb1c7feda9$var$y, $27ab9eeb1c7feda9$export$83d89fbfd8236492);
    var i = $27ab9eeb1c7feda9$var$Pe();
    return i && o.setAttribute("nonce", i), n.insertBefore(o, s), o;
}, $27ab9eeb1c7feda9$var$Ce = function() {
    function e(e) {
        this.element = $27ab9eeb1c7feda9$var$_e(e), this.element.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, o = t.length; n < o; n++){
                var r = t[n];
                if (r.ownerNode === e) return r;
            }
            throw $27ab9eeb1c7feda9$var$he(17);
        }(this.element), this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, e.prototype.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, e.prototype.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return t && t.cssText ? t.cssText : "";
    }, e;
}(), $27ab9eeb1c7feda9$var$Ie = function() {
    function e(e) {
        this.element = $27ab9eeb1c7feda9$var$_e(e), this.nodes = this.element.childNodes, this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t);
            return this.element.insertBefore(n, this.nodes[e] || null), this.length++, !0;
        }
        return !1;
    }, e.prototype.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $27ab9eeb1c7feda9$var$Ae = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, e.prototype.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $27ab9eeb1c7feda9$var$Oe = $27ab9eeb1c7feda9$var$S, $27ab9eeb1c7feda9$var$De = {
    isServer: !$27ab9eeb1c7feda9$var$S,
    useCSSOMInjection: !$27ab9eeb1c7feda9$var$w
}, $27ab9eeb1c7feda9$var$Re = function() {
    function e(e, n, o) {
        void 0 === e && (e = $27ab9eeb1c7feda9$var$C), void 0 === n && (n = {});
        var r = this;
        this.options = (0, $7eed31699f9c14e5$export$18ce0697a983be9b)((0, $7eed31699f9c14e5$export$18ce0697a983be9b)({}, $27ab9eeb1c7feda9$var$De), e), this.gs = n, this.names = new Map(o), this.server = !!e.isServer, !this.server && $27ab9eeb1c7feda9$var$S && $27ab9eeb1c7feda9$var$Oe && ($27ab9eeb1c7feda9$var$Oe = !1, function(e) {
            for(var t = document.querySelectorAll($27ab9eeb1c7feda9$var$we), n = 0, o = t.length; n < o; n++){
                var r = t[n];
                r && r.getAttribute($27ab9eeb1c7feda9$var$f) !== $27ab9eeb1c7feda9$var$m && ($27ab9eeb1c7feda9$var$Ne(e, r), r.parentNode && r.parentNode.removeChild(r));
            }
        }(this)), $27ab9eeb1c7feda9$var$ue(this, function() {
            return function(e) {
                for(var t = e.getTag(), n = t.length, o = "", r = function(n) {
                    var r = function(e) {
                        return $27ab9eeb1c7feda9$var$ye.get(e);
                    }(n);
                    if (void 0 === r) return "continue";
                    var s = e.names.get(r), i = t.getGroup(n);
                    if (void 0 === s || 0 === i.length) return "continue";
                    var a = "".concat($27ab9eeb1c7feda9$var$f, ".g").concat(n, '[id="').concat(r, '"]'), c = "";
                    void 0 !== s && s.forEach(function(e) {
                        e.length > 0 && (c += "".concat(e, ","));
                    }), o += "".concat(i).concat(a, '{content:"').concat(c, '"}').concat($27ab9eeb1c7feda9$var$g);
                }, s = 0; s < n; s++)r(s);
                return o;
            }(r);
        });
    }
    return e.registerId = function(e) {
        return $27ab9eeb1c7feda9$var$ge(e);
    }, e.prototype.reconstructWithOptions = function(n, o) {
        return void 0 === o && (o = !0), new e((0, $7eed31699f9c14e5$export$18ce0697a983be9b)((0, $7eed31699f9c14e5$export$18ce0697a983be9b)({}, this.options), n), this.gs, o && this.names || void 0);
    }, e.prototype.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, e.prototype.getTag = function() {
        var e;
        return this.tag || (this.tag = (e = function(e) {
            var t = e.useCSSOMInjection, n = e.target;
            return e.isServer ? new $27ab9eeb1c7feda9$var$Ae(n) : t ? new $27ab9eeb1c7feda9$var$Ce(n) : new $27ab9eeb1c7feda9$var$Ie(n);
        }(this.options), new $27ab9eeb1c7feda9$var$fe(e)));
    }, e.prototype.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, e.prototype.registerName = function(e, t) {
        if ($27ab9eeb1c7feda9$var$ge(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, e.prototype.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($27ab9eeb1c7feda9$var$ge(e), n);
    }, e.prototype.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, e.prototype.clearRules = function(e) {
        this.getTag().clearGroup($27ab9eeb1c7feda9$var$ge(e)), this.clearNames(e);
    }, e.prototype.clearTag = function() {
        this.tag = void 0;
    }, e;
}(), $27ab9eeb1c7feda9$var$Te = /&/g, $27ab9eeb1c7feda9$var$ke = /^\s*\/\/.*$/gm;
function $27ab9eeb1c7feda9$var$je(e, t) {
    return e.map(function(e) {
        return "rule" === e.type && (e.value = "".concat(t, " ").concat(e.value), e.value = e.value.replaceAll(",", ",".concat(t, " ")), e.props = e.props.map(function(e) {
            return "".concat(t, " ").concat(e);
        })), Array.isArray(e.children) && "@keyframes" !== e.type && (e.children = $27ab9eeb1c7feda9$var$je(e.children, t)), e;
    });
}
function $27ab9eeb1c7feda9$var$xe(e) {
    var t, n, o, r = void 0 === e ? $27ab9eeb1c7feda9$var$C : e, s = r.options, i = void 0 === s ? $27ab9eeb1c7feda9$var$C : s, a = r.plugins, c = void 0 === a ? $27ab9eeb1c7feda9$var$_ : a, l = function(e, o, r) {
        return r.startsWith(n) && r.endsWith(n) && r.replaceAll(n, "").length > 0 ? ".".concat(t) : e;
    }, u = c.slice();
    u.push(function(e) {
        e.type === $298fb931ed4fbf8b$export$aa3a2e812ca8570d && e.value.includes("&") && (e.props[0] = e.props[0].replace($27ab9eeb1c7feda9$var$Te, n).replace(o, l));
    }), i.prefix && u.push($298fb931ed4fbf8b$export$e08c7d021b829b7a), u.push($298fb931ed4fbf8b$export$fac44ee5b035f737);
    var p = function(e, r, s, a) {
        void 0 === r && (r = ""), void 0 === s && (s = ""), void 0 === a && (a = "&"), t = a, n = r, o = new RegExp("\\".concat(n, "\\b"), "g");
        var c = e.replace($27ab9eeb1c7feda9$var$ke, ""), l = $298fb931ed4fbf8b$export$ef7acd7185315e22(s || r ? "".concat(s, " ").concat(r, " { ").concat(c, " }") : c);
        i.namespace && (l = $27ab9eeb1c7feda9$var$je(l, i.namespace));
        var p = [];
        return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(l, $298fb931ed4fbf8b$export$5a7767152ae0305f(u.concat($298fb931ed4fbf8b$export$38bcb760f1d4871c(function(e) {
            return p.push(e);
        })))), p;
    };
    return p.hash = c.length ? c.reduce(function(e, t) {
        return t.name || $27ab9eeb1c7feda9$var$he(15), $27ab9eeb1c7feda9$var$M(e, t.name);
    }, $27ab9eeb1c7feda9$var$F).toString() : "", p;
}
var $27ab9eeb1c7feda9$var$Ve = new $27ab9eeb1c7feda9$var$Re, $27ab9eeb1c7feda9$var$Fe = $27ab9eeb1c7feda9$var$xe(), $27ab9eeb1c7feda9$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    shouldForwardProp: void 0,
    styleSheet: $27ab9eeb1c7feda9$var$Ve,
    stylis: $27ab9eeb1c7feda9$var$Fe
}), $27ab9eeb1c7feda9$export$91317688fc694efa = $27ab9eeb1c7feda9$export$8c190ef828af4c86.Consumer, $27ab9eeb1c7feda9$var$ze = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(void 0);
function $27ab9eeb1c7feda9$var$Be() {
    return (0, $acw62.useContext)($27ab9eeb1c7feda9$export$8c190ef828af4c86);
}
function $27ab9eeb1c7feda9$export$a473771da2f0ff7c(e) {
    var t = (0, $acw62.useState)(e.stylisPlugins), n = t[0], r = t[1], c = $27ab9eeb1c7feda9$var$Be().styleSheet, l = (0, $acw62.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target,
        c
    ]), u = (0, $acw62.useMemo)(function() {
        return $27ab9eeb1c7feda9$var$xe({
            options: {
                namespace: e.namespace,
                prefix: e.enableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.enableVendorPrefixes,
        e.namespace,
        n
    ]);
    (0, $acw62.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($d2b63732fb4ff365$exports)))(n, e.stylisPlugins) || r(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]);
    var d = (0, $acw62.useMemo)(function() {
        return {
            shouldForwardProp: e.shouldForwardProp,
            styleSheet: l,
            stylis: u
        };
    }, [
        e.shouldForwardProp,
        l,
        u
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($27ab9eeb1c7feda9$export$8c190ef828af4c86.Provider, {
        value: d
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($27ab9eeb1c7feda9$var$ze.Provider, {
        value: u
    }, e.children));
}
var $27ab9eeb1c7feda9$var$Ge = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $27ab9eeb1c7feda9$var$Fe);
            var o = n.name + t.hash;
            e.hasNameForId(n.id, o) || e.insertRules(n.id, o, t(n.rules, o, "@keyframes"));
        }, this.name = e, this.id = "sc-keyframes-".concat(e), this.rules = t, $27ab9eeb1c7feda9$var$ue(this, function() {
            throw $27ab9eeb1c7feda9$var$he(12, String(n.name));
        });
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $27ab9eeb1c7feda9$var$Fe), this.name + e.hash;
    }, e;
}(), $27ab9eeb1c7feda9$var$Ye = function(e) {
    return e >= "A" && e <= "Z";
};
function $27ab9eeb1c7feda9$var$We(e) {
    for(var t = "", n = 0; n < e.length; n++){
        var o = e[n];
        if (1 === n && "-" === o && "-" === e[0]) return e;
        $27ab9eeb1c7feda9$var$Ye(o) ? t += "-" + o.toLowerCase() : t += o;
    }
    return t.startsWith("ms-") ? "-" + t : t;
}
var $27ab9eeb1c7feda9$var$qe = function(e) {
    return null == e || !1 === e || "" === e;
}, $27ab9eeb1c7feda9$var$He = function(t) {
    var n, o, r = [];
    for(var s in t){
        var i = t[s];
        t.hasOwnProperty(s) && !$27ab9eeb1c7feda9$var$qe(i) && (Array.isArray(i) && i.isCss || $27ab9eeb1c7feda9$var$re(i) ? r.push("".concat($27ab9eeb1c7feda9$var$We(s), ":"), i, ";") : $27ab9eeb1c7feda9$var$ce(i) ? r.push.apply(r, (0, $7eed31699f9c14e5$export$1216008129fb82ed)((0, $7eed31699f9c14e5$export$1216008129fb82ed)([
            "".concat(s, " {")
        ], $27ab9eeb1c7feda9$var$He(i), !1), [
            "}"
        ], !1)) : r.push("".concat($27ab9eeb1c7feda9$var$We(s), ": ").concat((n = s, null == (o = i) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || n in (0, $936be3b045ab836e$export$2e2bcd8739ae039) || n.startsWith("--") ? String(o).trim() : "".concat(o, "px")), ";")));
    }
    return r;
};
function $27ab9eeb1c7feda9$var$Ue(e, t, n, o) {
    if ($27ab9eeb1c7feda9$var$qe(e)) return [];
    if ($27ab9eeb1c7feda9$export$7ba318d8d2f06c76(e)) return [
        ".".concat(e.styledComponentId)
    ];
    if ($27ab9eeb1c7feda9$var$re(e)) {
        if (!$27ab9eeb1c7feda9$var$re(s = e) || s.prototype && s.prototype.isReactComponent || !t) return [
            e
        ];
        var r = e(t);
        return $27ab9eeb1c7feda9$var$Ue(r, t, n, o);
    }
    var s;
    return e instanceof $27ab9eeb1c7feda9$var$Ge ? n ? (e.inject(n, o), [
        e.getName(o)
    ]) : [
        e
    ] : $27ab9eeb1c7feda9$var$ce(e) ? $27ab9eeb1c7feda9$var$He(e) : Array.isArray(e) ? Array.prototype.concat.apply($27ab9eeb1c7feda9$var$_, e.map(function(e) {
        return $27ab9eeb1c7feda9$var$Ue(e, t, n, o);
    })) : [
        e.toString()
    ];
}
function $27ab9eeb1c7feda9$var$Je(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($27ab9eeb1c7feda9$var$re(n) && !$27ab9eeb1c7feda9$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $27ab9eeb1c7feda9$var$Xe = $27ab9eeb1c7feda9$var$$($27ab9eeb1c7feda9$export$83d89fbfd8236492), $27ab9eeb1c7feda9$var$Ze = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $27ab9eeb1c7feda9$var$Je(e), this.componentId = t, this.baseHash = $27ab9eeb1c7feda9$var$M($27ab9eeb1c7feda9$var$Xe, t), this.baseStyle = n, $27ab9eeb1c7feda9$var$Re.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var o = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, t, n) : "";
        if (this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(this.componentId, this.staticRulesId)) o = $27ab9eeb1c7feda9$var$ie(o, this.staticRulesId);
            else {
                var r = $27ab9eeb1c7feda9$var$ae($27ab9eeb1c7feda9$var$Ue(this.rules, e, t, n)), s = $27ab9eeb1c7feda9$var$x($27ab9eeb1c7feda9$var$M(this.baseHash, r) >>> 0);
                if (!t.hasNameForId(this.componentId, s)) {
                    var i = n(r, ".".concat(s), void 0, this.componentId);
                    t.insertRules(this.componentId, s, i);
                }
                o = $27ab9eeb1c7feda9$var$ie(o, s), this.staticRulesId = s;
            }
        } else {
            for(var a = $27ab9eeb1c7feda9$var$M(this.baseHash, n.hash), c = "", l = 0; l < this.rules.length; l++){
                var u = this.rules[l];
                if ("string" == typeof u) c += u;
                else if (u) {
                    var p = $27ab9eeb1c7feda9$var$ae($27ab9eeb1c7feda9$var$Ue(u, e, t, n));
                    a = $27ab9eeb1c7feda9$var$M(a, p + l), c += p;
                }
            }
            if (c) {
                var d = $27ab9eeb1c7feda9$var$x(a >>> 0);
                t.hasNameForId(this.componentId, d) || t.insertRules(this.componentId, d, n(c, ".".concat(d), void 0, this.componentId)), o = $27ab9eeb1c7feda9$var$ie(o, d);
            }
        }
        return o;
    }, e;
}(), $27ab9eeb1c7feda9$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(void 0), $27ab9eeb1c7feda9$export$b631efc24e9d5e2f = $27ab9eeb1c7feda9$export$2c657da244d00bd6.Consumer;
function $27ab9eeb1c7feda9$export$93d4e7f90805808f() {
    var e = (0, $acw62.useContext)($27ab9eeb1c7feda9$export$2c657da244d00bd6);
    if (!e) throw $27ab9eeb1c7feda9$var$he(18);
    return e;
}
function $27ab9eeb1c7feda9$export$d8964aec282183a3(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($27ab9eeb1c7feda9$export$2c657da244d00bd6), r = (0, $acw62.useMemo)(function() {
        return function(e, n) {
            if (!e) throw $27ab9eeb1c7feda9$var$he(14);
            if ($27ab9eeb1c7feda9$var$re(e)) {
                var o = e(n);
                return o;
            }
            if (Array.isArray(e) || "object" != typeof e) throw $27ab9eeb1c7feda9$var$he(8);
            return n ? (0, $7eed31699f9c14e5$export$18ce0697a983be9b)((0, $7eed31699f9c14e5$export$18ce0697a983be9b)({}, n), e) : e;
        }(e.theme, n);
    }, [
        e.theme,
        n
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($27ab9eeb1c7feda9$export$2c657da244d00bd6.Provider, {
        value: r
    }, e.children) : null;
}
var $27ab9eeb1c7feda9$var$nt = {}, $27ab9eeb1c7feda9$var$ot = new Set;
function $27ab9eeb1c7feda9$var$rt(e, r, s) {
    var i = $27ab9eeb1c7feda9$export$7ba318d8d2f06c76(e), a = e, c = !$27ab9eeb1c7feda9$var$L(e), p = r.attrs, d = void 0 === p ? $27ab9eeb1c7feda9$var$_ : p, h = r.componentId, f = void 0 === h ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $27ab9eeb1c7feda9$var$R(e);
        $27ab9eeb1c7feda9$var$nt[n] = ($27ab9eeb1c7feda9$var$nt[n] || 0) + 1;
        var o = "".concat(n, "-").concat($27ab9eeb1c7feda9$var$z($27ab9eeb1c7feda9$export$83d89fbfd8236492 + n + $27ab9eeb1c7feda9$var$nt[n]));
        return t ? "".concat(t, "-").concat(o) : o;
    }(r.displayName, r.parentComponentId) : h, m = r.displayName, y = void 0 === m ? function(e) {
        return $27ab9eeb1c7feda9$var$L(e) ? "styled.".concat(e) : "Styled(".concat($27ab9eeb1c7feda9$var$B(e), ")");
    }(e) : m, g = r.displayName && r.componentId ? "".concat($27ab9eeb1c7feda9$var$R(r.displayName), "-").concat(r.componentId) : r.componentId || f, S = i && a.attrs ? a.attrs.concat(d).filter(Boolean) : d, w = r.shouldForwardProp;
    if (i && a.shouldForwardProp) {
        var b = a.shouldForwardProp;
        if (r.shouldForwardProp) {
            var E = r.shouldForwardProp;
            w = function(e, t) {
                return b(e, t) && E(e, t);
            };
        } else w = b;
    }
    var N = new $27ab9eeb1c7feda9$var$Ze(s, g, i ? a.componentStyle : void 0);
    function O(e, r) {
        return function(e, r, s) {
            var i = e.attrs, a = e.componentStyle, c = e.defaultProps, p = e.foldedComponentIds, d = e.styledComponentId, h = e.target, f = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($27ab9eeb1c7feda9$export$2c657da244d00bd6), m = $27ab9eeb1c7feda9$var$Be(), y = e.shouldForwardProp || m.shouldForwardProp;
            var v = $27ab9eeb1c7feda9$var$I(r, f, c) || $27ab9eeb1c7feda9$var$C, g = function(e, n, o) {
                for(var r, s = (0, $7eed31699f9c14e5$export$18ce0697a983be9b)((0, $7eed31699f9c14e5$export$18ce0697a983be9b)({}, n), {
                    className: void 0,
                    theme: o
                }), i = 0; i < e.length; i += 1){
                    var a = $27ab9eeb1c7feda9$var$re(r = e[i]) ? r(s) : r;
                    for(var c in a)s[c] = "className" === c ? $27ab9eeb1c7feda9$var$ie(s[c], a[c]) : "style" === c ? (0, $7eed31699f9c14e5$export$18ce0697a983be9b)((0, $7eed31699f9c14e5$export$18ce0697a983be9b)({}, s[c]), a[c]) : a[c];
                }
                return n.className && (s.className = $27ab9eeb1c7feda9$var$ie(s.className, n.className)), s;
            }(i, r, v), S = g.as || h, w = {};
            for(var b in g)void 0 === g[b] || "$" === b[0] || "as" === b || "theme" === b && g.theme === v || ("forwardedAs" === b ? w.as = g.forwardedAs : y && !y(b, S) || (w[b] = g[b], y));
            var E = function(e, t) {
                var n = $27ab9eeb1c7feda9$var$Be(), o = e.generateAndInjectStyles(t, n.styleSheet, n.stylis);
                return o;
            }(a, g);
            var N = $27ab9eeb1c7feda9$var$ie(p, d);
            return E && (N += " " + E), g.className && (N += " " + g.className), w[$27ab9eeb1c7feda9$var$L(S) && !$27ab9eeb1c7feda9$var$A.has(S) ? "class" : "className"] = N, w.ref = s, (0, $acw62.createElement)(S, w);
        }(D, e, r);
    }
    O.displayName = y;
    var D = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(O);
    return D.attrs = S, D.componentStyle = N, D.displayName = y, D.shouldForwardProp = w, D.foldedComponentIds = i ? $27ab9eeb1c7feda9$var$ie(a.foldedComponentIds, a.styledComponentId) : "", D.styledComponentId = g, D.target = i ? a.target : e, Object.defineProperty(D, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(e) {
            this._foldedDefaultProps = i ? function(e) {
                for(var t = [], n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
                for(var o = 0, r = t; o < r.length; o++)$27ab9eeb1c7feda9$var$le(e, r[o], !0);
                return e;
            }({}, a.defaultProps, e) : e;
        }
    }), $27ab9eeb1c7feda9$var$ue(D, function() {
        return ".".concat(D.styledComponentId);
    }), c && $27ab9eeb1c7feda9$var$oe(D, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0
    }), D;
}
function $27ab9eeb1c7feda9$var$st(e, t) {
    for(var n = [
        e[0]
    ], o = 0, r = t.length; o < r; o += 1)n.push(t[o], e[o + 1]);
    return n;
}
var $27ab9eeb1c7feda9$var$it = function(e) {
    return Object.assign(e, {
        isCss: !0
    });
};
function $27ab9eeb1c7feda9$export$dbf350e5966cf602(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    if ($27ab9eeb1c7feda9$var$re(t) || $27ab9eeb1c7feda9$var$ce(t)) return $27ab9eeb1c7feda9$var$it($27ab9eeb1c7feda9$var$Ue($27ab9eeb1c7feda9$var$st($27ab9eeb1c7feda9$var$_, (0, $7eed31699f9c14e5$export$1216008129fb82ed)([
        t
    ], n, !0))));
    var r = t;
    return 0 === n.length && 1 === r.length && "string" == typeof r[0] ? $27ab9eeb1c7feda9$var$Ue(r) : $27ab9eeb1c7feda9$var$it($27ab9eeb1c7feda9$var$Ue($27ab9eeb1c7feda9$var$st(r, n)));
}
function $27ab9eeb1c7feda9$var$ct(n, o, r) {
    if (void 0 === r && (r = $27ab9eeb1c7feda9$var$C), !o) throw $27ab9eeb1c7feda9$var$he(1, o);
    var s = function(t) {
        for(var s = [], i = 1; i < arguments.length; i++)s[i - 1] = arguments[i];
        return n(o, r, $27ab9eeb1c7feda9$export$dbf350e5966cf602.apply(void 0, (0, $7eed31699f9c14e5$export$1216008129fb82ed)([
            t
        ], s, !1)));
    };
    return s.attrs = function(e) {
        return $27ab9eeb1c7feda9$var$ct(n, o, (0, $7eed31699f9c14e5$export$18ce0697a983be9b)((0, $7eed31699f9c14e5$export$18ce0697a983be9b)({}, r), {
            attrs: Array.prototype.concat(r.attrs, e).filter(Boolean)
        }));
    }, s.withConfig = function(e) {
        return $27ab9eeb1c7feda9$var$ct(n, o, (0, $7eed31699f9c14e5$export$18ce0697a983be9b)((0, $7eed31699f9c14e5$export$18ce0697a983be9b)({}, r), e));
    }, s;
}
var $27ab9eeb1c7feda9$var$lt = function(e) {
    return $27ab9eeb1c7feda9$var$ct($27ab9eeb1c7feda9$var$rt, e);
}, $27ab9eeb1c7feda9$export$2e2bcd8739ae039 = $27ab9eeb1c7feda9$var$lt;
$27ab9eeb1c7feda9$var$A.forEach(function(e) {
    $27ab9eeb1c7feda9$export$2e2bcd8739ae039[e] = $27ab9eeb1c7feda9$var$lt(e);
});
var $27ab9eeb1c7feda9$var$pt = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $27ab9eeb1c7feda9$var$Je(e), $27ab9eeb1c7feda9$var$Re.registerId(this.componentId + 1);
    }
    return e.prototype.createStyles = function(e, t, n, o) {
        var r = o($27ab9eeb1c7feda9$var$ae($27ab9eeb1c7feda9$var$Ue(this.rules, t, n, o)), ""), s = this.componentId + e;
        n.insertRules(s, s, r);
    }, e.prototype.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, e.prototype.renderStyles = function(e, t, n, o) {
        e > 2 && $27ab9eeb1c7feda9$var$Re.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, o);
    }, e;
}();
function $27ab9eeb1c7feda9$export$f0f03736edb61697(n) {
    for(var r = [], s = 1; s < arguments.length; s++)r[s - 1] = arguments[s];
    var i = $27ab9eeb1c7feda9$export$dbf350e5966cf602.apply(void 0, (0, $7eed31699f9c14e5$export$1216008129fb82ed)([
        n
    ], r, !1)), a = "sc-global-".concat($27ab9eeb1c7feda9$var$z(JSON.stringify(i))), c = new $27ab9eeb1c7feda9$var$pt(i, a);
    var l = function(e) {
        var t = $27ab9eeb1c7feda9$var$Be(), n = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($27ab9eeb1c7feda9$export$2c657da244d00bd6), r = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(t.styleSheet.allocateGSInstance(a)).current;
        return t.styleSheet.server && u(r, e, t.styleSheet, n, t.stylis), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect(function() {
            if (!t.styleSheet.server) return u(r, e, t.styleSheet, n, t.stylis), function() {
                return c.removeStyles(r, t.styleSheet);
            };
        }, [
            r,
            e,
            t.styleSheet,
            n,
            t.stylis
        ]), null;
    };
    function u(e, n, o, r, s) {
        if (c.isStatic) c.renderStyles(e, $27ab9eeb1c7feda9$var$b, o, s);
        else {
            var i = (0, $7eed31699f9c14e5$export$18ce0697a983be9b)((0, $7eed31699f9c14e5$export$18ce0697a983be9b)({}, n), {
                theme: $27ab9eeb1c7feda9$var$I(n, r, l.defaultProps)
            });
            c.renderStyles(e, i, o, s);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(l);
}
function $27ab9eeb1c7feda9$export$d25ddfdf17c3ad3e(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    var r = $27ab9eeb1c7feda9$var$ae($27ab9eeb1c7feda9$export$dbf350e5966cf602.apply(void 0, (0, $7eed31699f9c14e5$export$1216008129fb82ed)([
        t
    ], n, !1))), s = $27ab9eeb1c7feda9$var$z(r);
    return new $27ab9eeb1c7feda9$var$Ge(s, r);
}
function $27ab9eeb1c7feda9$export$e8748c6a27b910dc(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(n, r) {
        var s = $27ab9eeb1c7feda9$var$I(n, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($27ab9eeb1c7feda9$export$2c657da244d00bd6), e.defaultProps);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(e, (0, $7eed31699f9c14e5$export$18ce0697a983be9b)({}, n, {
            theme: s,
            ref: r
        }));
    });
    return n.displayName = "WithTheme(".concat($27ab9eeb1c7feda9$var$B(e), ")"), $27ab9eeb1c7feda9$var$oe(n, e);
}
var $27ab9eeb1c7feda9$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString(), n = $27ab9eeb1c7feda9$var$Pe(), o = $27ab9eeb1c7feda9$var$ae([
                n && 'nonce="'.concat(n, '"'),
                "".concat($27ab9eeb1c7feda9$var$f, '="true"'),
                "".concat($27ab9eeb1c7feda9$var$y, '="').concat($27ab9eeb1c7feda9$export$83d89fbfd8236492, '"')
            ].filter(Boolean), " ");
            return "<style ".concat(o, ">").concat(t, "</style>");
        }, this.getStyleTags = function() {
            if (e.sealed) throw $27ab9eeb1c7feda9$var$he(2);
            return e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var n;
            if (e.sealed) throw $27ab9eeb1c7feda9$var$he(2);
            var r = ((n = {})[$27ab9eeb1c7feda9$var$f] = "", n[$27ab9eeb1c7feda9$var$y] = $27ab9eeb1c7feda9$export$83d89fbfd8236492, n.dangerouslySetInnerHTML = {
                __html: e.instance.toString()
            }, n), s = $27ab9eeb1c7feda9$var$Pe();
            return s && (r.nonce = s), [
                (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", (0, $7eed31699f9c14e5$export$18ce0697a983be9b)({}, r, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $27ab9eeb1c7feda9$var$Re({
            isServer: !0
        }), this.sealed = !1;
    }
    return e.prototype.collectStyles = function(e) {
        if (this.sealed) throw $27ab9eeb1c7feda9$var$he(2);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($27ab9eeb1c7feda9$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, e.prototype.interleaveWithNodeStream = function(e) {
        throw $27ab9eeb1c7feda9$var$he(3);
    }, e;
}(), $27ab9eeb1c7feda9$export$5c87cfe6c475f500 = {
    StyleSheet: $27ab9eeb1c7feda9$var$Re,
    mainSheet: $27ab9eeb1c7feda9$var$Ve
};
var $27ab9eeb1c7feda9$var$vt = "__sc-".concat($27ab9eeb1c7feda9$var$f, "__");


// Such export is called Tree Shaking. It allows to import only the components
// that are needed while webpack will remove the rest of the code from the bundle.
const $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c = "#4fa94d";
const $b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18 = {
    "aria-busy": true,
    role: "progressbar"
};
const $b074148cf394a24e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56 = (0, $27ab9eeb1c7feda9$export$2e2bcd8739ae039).div`
  display: ${(props)=>props.$visible ? "flex" : "none"};
`;
const $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c = "http://www.w3.org/2000/svg";
const $b074148cf394a24e$export$153755f98d9861de = ({ height: height = "100", width: width = "100", color: color = $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "audio-loading", wrapperStyle: wrapperStyle = {}, wrapperClass: wrapperClass, visible: visible = true })=>(0, $7b02d682eb115277$exports.jsx)($b074148cf394a24e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        $visible: visible,
        style: {
            ...wrapperStyle
        },
        className: wrapperClass,
        "data-testid": "audio-loading",
        "aria-label": ariaLabel,
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $7b02d682eb115277$exports.jsxs)("svg", {
            height: `${height}`,
            width: `${width}`,
            fill: color,
            viewBox: "0 0 55 80",
            xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            "data-testid": "audio-svg",
            children: [
                (0, $7b02d682eb115277$exports.jsx)("title", {
                    children: "Audio Visualization"
                }),
                (0, $7b02d682eb115277$exports.jsx)("desc", {
                    children: "Animated representation of audio data"
                }),
                (0, $7b02d682eb115277$exports.jsxs)("g", {
                    transform: "matrix(1 0 0 -1 0 80)",
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)("rect", {
                            width: "10",
                            height: "20",
                            rx: "3",
                            children: (0, $7b02d682eb115277$exports.jsx)("animate", {
                                attributeName: "height",
                                begin: "0s",
                                dur: "4.3s",
                                values: "20;45;57;80;64;32;66;45;64;23;66;13;64;56;34;34;2;23;76;79;20",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsx)("rect", {
                            x: "15",
                            width: "10",
                            height: "80",
                            rx: "3",
                            children: (0, $7b02d682eb115277$exports.jsx)("animate", {
                                attributeName: "height",
                                begin: "0s",
                                dur: "2s",
                                values: "80;55;33;5;75;23;73;33;12;14;60;80",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsx)("rect", {
                            x: "30",
                            width: "10",
                            height: "50",
                            rx: "3",
                            children: (0, $7b02d682eb115277$exports.jsx)("animate", {
                                attributeName: "height",
                                begin: "0s",
                                dur: "1.4s",
                                values: "50;34;78;23;56;23;34;76;80;54;21;50",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsx)("rect", {
                            x: "45",
                            width: "10",
                            height: "30",
                            rx: "3",
                            children: (0, $7b02d682eb115277$exports.jsx)("animate", {
                                attributeName: "height",
                                begin: "0s",
                                dur: "2s",
                                values: "30;45;13;80;56;72;45;76;34;23;67;30",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        })
                    ]
                })
            ]
        })
    });
const $b074148cf394a24e$export$68949ad0373623af = ({ height: height = 100, width: width = 100, radius: radius = 5, color: color = $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "ball-triangle-loading", wrapperClass: wrapperClass, wrapperStyle: wrapperStyle, visible: visible = true })=>(0, $7b02d682eb115277$exports.jsx)($b074148cf394a24e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: {
            ...wrapperStyle
        },
        $visible: visible,
        className: wrapperClass,
        "data-testid": "ball-triangle-loading",
        "aria-label": ariaLabel,
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $7b02d682eb115277$exports.jsxs)("svg", {
            height: height,
            width: width,
            stroke: color,
            viewBox: "0 0 57 57",
            xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            "data-testid": "ball-triangle-svg",
            children: [
                (0, $7b02d682eb115277$exports.jsx)("title", {
                    children: "Ball Triangle"
                }),
                (0, $7b02d682eb115277$exports.jsx)("desc", {
                    children: "Animated representation of three balls"
                }),
                (0, $7b02d682eb115277$exports.jsx)("g", {
                    fill: "none",
                    fillRule: "evenodd",
                    children: (0, $7b02d682eb115277$exports.jsxs)("g", {
                        transform: "translate(1 1)",
                        strokeWidth: "2",
                        children: [
                            (0, $7b02d682eb115277$exports.jsxs)("circle", {
                                cx: "5",
                                cy: "50",
                                r: radius,
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                                        attributeName: "cy",
                                        begin: "0s",
                                        dur: "2.2s",
                                        values: "50;5;50;50",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                                        attributeName: "cx",
                                        begin: "0s",
                                        dur: "2.2s",
                                        values: "5;27;49;5",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    })
                                ]
                            }),
                            (0, $7b02d682eb115277$exports.jsxs)("circle", {
                                cx: "27",
                                cy: "5",
                                r: radius,
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                                        attributeName: "cy",
                                        begin: "0s",
                                        dur: "2.2s",
                                        from: "5",
                                        to: "5",
                                        values: "5;50;50;5",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                                        attributeName: "cx",
                                        begin: "0s",
                                        dur: "2.2s",
                                        from: "27",
                                        to: "27",
                                        values: "27;49;5;27",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    })
                                ]
                            }),
                            (0, $7b02d682eb115277$exports.jsxs)("circle", {
                                cx: "49",
                                cy: "50",
                                r: radius,
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                                        attributeName: "cy",
                                        begin: "0s",
                                        dur: "2.2s",
                                        values: "50;50;5;50",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                                        attributeName: "cx",
                                        from: "49",
                                        to: "49",
                                        begin: "0s",
                                        dur: "2.2s",
                                        values: "49;5;27;49",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
const $b074148cf394a24e$export$fbc7d6f7dd821b47 = ({ height: height = 80, width: width = 80, color: color = $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "bars-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $7b02d682eb115277$exports.jsx)($b074148cf394a24e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        $visible: visible,
        style: {
            ...wrapperStyle
        },
        className: wrapperClass,
        "data-testid": "bars-loading",
        "aria-label": ariaLabel,
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $7b02d682eb115277$exports.jsxs)("svg", {
            width: width,
            height: height,
            fill: color,
            viewBox: "0 0 135 140",
            xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            "data-testid": "bars-svg",
            children: [
                (0, $7b02d682eb115277$exports.jsxs)("rect", {
                    y: "10",
                    width: "15",
                    height: "120",
                    rx: "6",
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)("animate", {
                            attributeName: "height",
                            begin: "0.5s",
                            dur: "1s",
                            values: "120;110;100;90;80;70;60;50;40;140;120",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $7b02d682eb115277$exports.jsx)("animate", {
                            attributeName: "y",
                            begin: "0.5s",
                            dur: "1s",
                            values: "10;15;20;25;30;35;40;45;50;0;10",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $7b02d682eb115277$exports.jsxs)("rect", {
                    x: "30",
                    y: "10",
                    width: "15",
                    height: "120",
                    rx: "6",
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)("animate", {
                            attributeName: "height",
                            begin: "0.25s",
                            dur: "1s",
                            values: "120;110;100;90;80;70;60;50;40;140;120",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $7b02d682eb115277$exports.jsx)("animate", {
                            attributeName: "y",
                            begin: "0.25s",
                            dur: "1s",
                            values: "10;15;20;25;30;35;40;45;50;0;10",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $7b02d682eb115277$exports.jsxs)("rect", {
                    x: "60",
                    width: "15",
                    height: "140",
                    rx: "6",
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)("animate", {
                            attributeName: "height",
                            begin: "0s",
                            dur: "1s",
                            values: "120;110;100;90;80;70;60;50;40;140;120",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $7b02d682eb115277$exports.jsx)("animate", {
                            attributeName: "y",
                            begin: "0s",
                            dur: "1s",
                            values: "10;15;20;25;30;35;40;45;50;0;10",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $7b02d682eb115277$exports.jsxs)("rect", {
                    x: "90",
                    y: "10",
                    width: "15",
                    height: "120",
                    rx: "6",
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)("animate", {
                            attributeName: "height",
                            begin: "0.25s",
                            dur: "1s",
                            values: "120;110;100;90;80;70;60;50;40;140;120",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $7b02d682eb115277$exports.jsx)("animate", {
                            attributeName: "y",
                            begin: "0.25s",
                            dur: "1s",
                            values: "10;15;20;25;30;35;40;45;50;0;10",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $7b02d682eb115277$exports.jsxs)("rect", {
                    x: "120",
                    y: "10",
                    width: "15",
                    height: "120",
                    rx: "6",
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)("animate", {
                            attributeName: "height",
                            begin: "0.5s",
                            dur: "1s",
                            values: "120;110;100;90;80;70;60;50;40;140;120",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $7b02d682eb115277$exports.jsx)("animate", {
                            attributeName: "y",
                            begin: "0.5s",
                            dur: "1s",
                            values: "10;15;20;25;30;35;40;45;50;0;10",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                })
            ]
        })
    });
const $b074148cf394a24e$export$765808835a2dc0a2 = ({ height: height = 80, width: width = 80, color: color = $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "circles-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $7b02d682eb115277$exports.jsx)($b074148cf394a24e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "aria-label": ariaLabel,
        "data-testid": "circles-loading",
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $7b02d682eb115277$exports.jsxs)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 135 135",
            xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            fill: color,
            "data-testid": "circles-svg",
            children: [
                (0, $7b02d682eb115277$exports.jsx)("title", {
                    children: "circles-loading"
                }),
                (0, $7b02d682eb115277$exports.jsx)("desc", {
                    children: "Animated representation of circles"
                }),
                (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M67.447 58c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10zm9.448 9.447c0 5.523 4.477 10 10 10 5.522 0 10-4.477 10-10s-4.478-10-10-10c-5.523 0-10 4.477-10 10zm-9.448 9.448c-5.523 0-10 4.477-10 10 0 5.522 4.477 10 10 10s10-4.478 10-10c0-5.523-4.477-10-10-10zM58 67.447c0-5.523-4.477-10-10-10s-10 4.477-10 10 4.477 10 10 10 10-4.477 10-10z",
                    children: (0, $7b02d682eb115277$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "rotate",
                        from: "0 67 67",
                        to: "-360 67 67",
                        dur: "2.5s",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M28.19 40.31c6.627 0 12-5.374 12-12 0-6.628-5.373-12-12-12-6.628 0-12 5.372-12 12 0 6.626 5.372 12 12 12zm30.72-19.825c4.686 4.687 12.284 4.687 16.97 0 4.686-4.686 4.686-12.284 0-16.97-4.686-4.687-12.284-4.687-16.97 0-4.687 4.686-4.687 12.284 0 16.97zm35.74 7.705c0 6.627 5.37 12 12 12 6.626 0 12-5.373 12-12 0-6.628-5.374-12-12-12-6.63 0-12 5.372-12 12zm19.822 30.72c-4.686 4.686-4.686 12.284 0 16.97 4.687 4.686 12.285 4.686 16.97 0 4.687-4.686 4.687-12.284 0-16.97-4.685-4.687-12.283-4.687-16.97 0zm-7.704 35.74c-6.627 0-12 5.37-12 12 0 6.626 5.373 12 12 12s12-5.374 12-12c0-6.63-5.373-12-12-12zm-30.72 19.822c-4.686-4.686-12.284-4.686-16.97 0-4.686 4.687-4.686 12.285 0 16.97 4.686 4.687 12.284 4.687 16.97 0 4.687-4.685 4.687-12.283 0-16.97zm-35.74-7.704c0-6.627-5.372-12-12-12-6.626 0-12 5.373-12 12s5.374 12 12 12c6.628 0 12-5.373 12-12zm-19.823-30.72c4.687-4.686 4.687-12.284 0-16.97-4.686-4.686-12.284-4.686-16.97 0-4.687 4.686-4.687 12.284 0 16.97 4.686 4.687 12.284 4.687 16.97 0z",
                    children: (0, $7b02d682eb115277$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "rotate",
                        from: "0 67 67",
                        to: "360 67 67",
                        dur: "8s",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    });
const $b074148cf394a24e$export$17c11650828d97e = ({ wrapperStyle: wrapperStyle = {}, visible: visible = true, wrapperClass: wrapperClass = "", height: height = 100, width: width = 100, color: color = $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, outerCircleColor: outerCircleColor, innerCircleColor: innerCircleColor, barColor: barColor, ariaLabel: ariaLabel = "circles-with-bar-loading" })=>{
    return (0, $7b02d682eb115277$exports.jsx)($b074148cf394a24e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "aria-label": ariaLabel,
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        "data-testid": "circles-with-bar-wrapper",
        children: (0, $7b02d682eb115277$exports.jsxs)("svg", {
            version: "1.1",
            id: "L1",
            xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            x: "0px",
            y: "0px",
            height: `${height}`,
            width: `${width}`,
            viewBox: "0 0 100 100",
            enableBackground: "new 0 0 100 100",
            xmlSpace: "preserve",
            "data-testid": "circles-with-bar-svg",
            children: [
                (0, $7b02d682eb115277$exports.jsx)("title", {
                    children: "circles-with-bar-loading"
                }),
                (0, $7b02d682eb115277$exports.jsx)("desc", {
                    children: "Animated representation of circles with bar"
                }),
                (0, $7b02d682eb115277$exports.jsx)("circle", {
                    fill: "none",
                    stroke: `${outerCircleColor || color}`,
                    strokeWidth: "6",
                    strokeMiterlimit: "15",
                    strokeDasharray: "14.2472,14.2472",
                    cx: "50",
                    cy: "50",
                    r: "47",
                    children: (0, $7b02d682eb115277$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        attributeType: "XML",
                        type: "rotate",
                        dur: "5s",
                        from: "0 50 50",
                        to: "360 50 50",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $7b02d682eb115277$exports.jsx)("circle", {
                    fill: "none",
                    stroke: `${innerCircleColor || color}`,
                    strokeWidth: "1",
                    strokeMiterlimit: "10",
                    strokeDasharray: "10,10",
                    cx: "50",
                    cy: "50",
                    r: "39",
                    children: (0, $7b02d682eb115277$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        attributeType: "XML",
                        type: "rotate",
                        dur: "5s",
                        from: "0 50 50",
                        to: "-360 50 50",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $7b02d682eb115277$exports.jsxs)("g", {
                    fill: `${barColor || color}`,
                    "data-testid": "circles-with-bar-svg-bar",
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)("rect", {
                            x: "30",
                            y: "35",
                            width: "5",
                            height: "30",
                            children: (0, $7b02d682eb115277$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.1"
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsx)("rect", {
                            x: "40",
                            y: "35",
                            width: "5",
                            height: "30",
                            children: (0, $7b02d682eb115277$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.2"
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsx)("rect", {
                            x: "50",
                            y: "35",
                            width: "5",
                            height: "30",
                            children: (0, $7b02d682eb115277$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.3"
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsx)("rect", {
                            x: "60",
                            y: "35",
                            width: "5",
                            height: "30",
                            children: (0, $7b02d682eb115277$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.4"
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsx)("rect", {
                            x: "70",
                            y: "35",
                            width: "5",
                            height: "30",
                            children: (0, $7b02d682eb115277$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.5"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
const $b074148cf394a24e$export$ef2184bd89960b14 = ({ height: height = 80, width: width = 80, radius: radius = 12.5, color: color = $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "grid-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $7b02d682eb115277$exports.jsx)($b074148cf394a24e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "grid-loading",
        "aria-label": ariaLabel,
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $7b02d682eb115277$exports.jsxs)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 105 105",
            fill: color,
            "data-testid": "grid-svg",
            children: [
                (0, $7b02d682eb115277$exports.jsx)("circle", {
                    cx: "12.5",
                    cy: "12.5",
                    r: `${radius}`,
                    children: (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "0s",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $7b02d682eb115277$exports.jsx)("circle", {
                    cx: "12.5",
                    cy: "52.5",
                    r: `${radius}`,
                    children: (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "100ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $7b02d682eb115277$exports.jsx)("circle", {
                    cx: "52.5",
                    cy: "12.5",
                    r: `${radius}`,
                    children: (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "300ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $7b02d682eb115277$exports.jsx)("circle", {
                    cx: "52.5",
                    cy: "52.5",
                    r: `${radius}`,
                    children: (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "600ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $7b02d682eb115277$exports.jsx)("circle", {
                    cx: "92.5",
                    cy: "12.5",
                    r: `${radius}`,
                    children: (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "800ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $7b02d682eb115277$exports.jsx)("circle", {
                    cx: "92.5",
                    cy: "52.5",
                    r: `${radius}`,
                    children: (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "400ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $7b02d682eb115277$exports.jsx)("circle", {
                    cx: "12.5",
                    cy: "92.5",
                    r: `${radius}`,
                    children: (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "700ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $7b02d682eb115277$exports.jsx)("circle", {
                    cx: "52.5",
                    cy: "92.5",
                    r: `${radius}`,
                    children: (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "500ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $7b02d682eb115277$exports.jsx)("circle", {
                    cx: "92.5",
                    cy: "92.5",
                    r: `${radius}`,
                    children: (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "200ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    });
const $b074148cf394a24e$export$2da2f0c7403af3ce = ({ height: height = 80, width: width = 80, color: color = $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "hearts-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $7b02d682eb115277$exports.jsx)($b074148cf394a24e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "hearts-loading",
        "aria-label": ariaLabel,
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $7b02d682eb115277$exports.jsxs)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 140 64",
            xmlns: "http://www.w3.org/2000/svg",
            fill: color,
            "data-testid": "hearts-svg",
            children: [
                (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M30.262 57.02L7.195 40.723c-5.84-3.976-7.56-12.06-3.842-18.063 3.715-6 11.467-7.65 17.306-3.68l4.52 3.76 2.6-5.274c3.717-6.002 11.47-7.65 17.305-3.68 5.84 3.97 7.56 12.054 3.842 18.062L34.49 56.118c-.897 1.512-2.793 1.915-4.228.9z",
                    attributeName: "fill-opacity",
                    from: "0",
                    to: ".5",
                    children: (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "0s",
                        dur: "1.4s",
                        values: "0.5;1;0.5",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M105.512 56.12l-14.44-24.272c-3.716-6.008-1.996-14.093 3.843-18.062 5.835-3.97 13.588-2.322 17.306 3.68l2.6 5.274 4.52-3.76c5.84-3.97 13.592-2.32 17.307 3.68 3.718 6.003 1.998 14.088-3.842 18.064L109.74 57.02c-1.434 1.014-3.33.61-4.228-.9z",
                    attributeName: "fill-opacity",
                    from: "0",
                    to: ".5",
                    children: (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "0.7s",
                        dur: "1.4s",
                        values: "0.5;1;0.5",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M67.408 57.834l-23.01-24.98c-5.864-6.15-5.864-16.108 0-22.248 5.86-6.14 15.37-6.14 21.234 0L70 16.168l4.368-5.562c5.863-6.14 15.375-6.14 21.235 0 5.863 6.14 5.863 16.098 0 22.247l-23.007 24.98c-1.43 1.556-3.757 1.556-5.188 0z"
                })
            ]
        })
    });
const $b074148cf394a24e$var$$ad60b992c945fdb5$var$len = 242.776657104492;
const $b074148cf394a24e$var$$ad60b992c945fdb5$var$time = 1.6;
const $b074148cf394a24e$var$$ad60b992c945fdb5$var$anim = (0, $27ab9eeb1c7feda9$export$d25ddfdf17c3ad3e)`
12.5% {
  stroke-dasharray: ${$b074148cf394a24e$var$$ad60b992c945fdb5$var$len * 0.14}px, ${$b074148cf394a24e$var$$ad60b992c945fdb5$var$len}px;
  stroke-dashoffset: -${$b074148cf394a24e$var$$ad60b992c945fdb5$var$len * 0.11}px;
}
43.75% {
  stroke-dasharray: ${$b074148cf394a24e$var$$ad60b992c945fdb5$var$len * 0.35}px, ${$b074148cf394a24e$var$$ad60b992c945fdb5$var$len}px;
  stroke-dashoffset: -${$b074148cf394a24e$var$$ad60b992c945fdb5$var$len * 0.35}px;
}
100% {
  stroke-dasharray: ${$b074148cf394a24e$var$$ad60b992c945fdb5$var$len * 0.01}px, ${$b074148cf394a24e$var$$ad60b992c945fdb5$var$len}px;
  stroke-dashoffset: -${$b074148cf394a24e$var$$ad60b992c945fdb5$var$len * 0.99}px;
}
`;
const $b074148cf394a24e$var$$ad60b992c945fdb5$var$Path = (0, $27ab9eeb1c7feda9$export$2e2bcd8739ae039).path`
  stroke-dasharray: ${$b074148cf394a24e$var$$ad60b992c945fdb5$var$len * 0.01}px, ${$b074148cf394a24e$var$$ad60b992c945fdb5$var$len};
  stroke-dashoffset: 0;
  animation: ${$b074148cf394a24e$var$$ad60b992c945fdb5$var$anim} ${$b074148cf394a24e$var$$ad60b992c945fdb5$var$time}s linear infinite;
`;
const $b074148cf394a24e$export$8009d4483dfda42 = ({ color: color = $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, width: width = "200" })=>{
    return (0, $7b02d682eb115277$exports.jsxs)("svg", {
        xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
        width: `${width}`,
        height: `${Number(width) * 0.5}`,
        viewBox: `0 0 ${width} ${Number(100)}`,
        "data-testid": "infinity-spin",
        children: [
            (0, $7b02d682eb115277$exports.jsx)($b074148cf394a24e$var$$ad60b992c945fdb5$var$Path, {
                "data-testid": "infinity-spin-path-1",
                stroke: color,
                fill: "none",
                strokeWidth: "4",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: "10",
                d: "M93.9,46.4c9.3,9.5,13.8,17.9,23.5,17.9s17.5-7.8,17.5-17.5s-7.8-17.6-17.5-17.5c-9.7,0.1-13.3,7.2-22.1,17.1 c-8.9,8.8-15.7,17.9-25.4,17.9s-17.5-7.8-17.5-17.5s7.8-17.5,17.5-17.5S86.2,38.6,93.9,46.4z"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                "data-testid": "infinity-spin-path-2",
                opacity: "0.07",
                fill: "none",
                stroke: color,
                strokeWidth: "4",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: "10",
                d: "M93.9,46.4c9.3,9.5,13.8,17.9,23.5,17.9s17.5-7.8,17.5-17.5s-7.8-17.6-17.5-17.5c-9.7,0.1-13.3,7.2-22.1,17.1 c-8.9,8.8-15.7,17.9-25.4,17.9s-17.5-7.8-17.5-17.5s7.8-17.5,17.5-17.5S86.2,38.6,93.9,46.4z"
            })
        ]
    });
};
const $b074148cf394a24e$export$d2101d81f63866ab = ({ wrapperStyle: wrapperStyle = {}, visible: visible = true, wrapperClass: wrapperClass = "", height: height = 100, width: width = 100, color: color = $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "line-wave-loading", firstLineColor: firstLineColor, middleLineColor: middleLineColor, lastLineColor: lastLineColor })=>{
    return (0, $7b02d682eb115277$exports.jsx)($b074148cf394a24e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "line-wave-wrapper",
        "aria-label": ariaLabel,
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $7b02d682eb115277$exports.jsxs)("svg", {
            version: "1.1",
            height: `${height}`,
            width: `${width}`,
            xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            x: "0px",
            y: "0px",
            viewBox: "0 0 100 100",
            enableBackground: "new 0 0 0 0",
            xmlSpace: "preserve",
            "data-testid": "line-wave-svg",
            children: [
                (0, $7b02d682eb115277$exports.jsx)("rect", {
                    x: "20",
                    y: "50",
                    width: "4",
                    height: "10",
                    fill: firstLineColor || color,
                    children: (0, $7b02d682eb115277$exports.jsx)("animateTransform", {
                        attributeType: "xml",
                        attributeName: "transform",
                        type: "translate",
                        values: "0 0; 0 20; 0 0",
                        begin: "0",
                        dur: "0.6s",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $7b02d682eb115277$exports.jsx)("rect", {
                    x: "30",
                    y: "50",
                    width: "4",
                    height: "10",
                    fill: middleLineColor || color,
                    children: (0, $7b02d682eb115277$exports.jsx)("animateTransform", {
                        attributeType: "xml",
                        attributeName: "transform",
                        type: "translate",
                        values: "0 0; 0 20; 0 0",
                        begin: "0.2s",
                        dur: "0.6s",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $7b02d682eb115277$exports.jsx)("rect", {
                    x: "40",
                    y: "50",
                    width: "4",
                    height: "10",
                    fill: lastLineColor || color,
                    children: (0, $7b02d682eb115277$exports.jsx)("animateTransform", {
                        attributeType: "xml",
                        attributeName: "transform",
                        type: "translate",
                        values: "0 0; 0 20; 0 0",
                        begin: "0.4s",
                        dur: "0.6s",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    });
};
const $b074148cf394a24e$export$64ea884904791f4 = ({ height: height = 90, width: width = 80, radius: radius = 12.5, color: color = $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, secondaryColor: secondaryColor = $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "mutating-dots-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $7b02d682eb115277$exports.jsx)($b074148cf394a24e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "mutating-dots-loading",
        "aria-label": ariaLabel,
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $7b02d682eb115277$exports.jsxs)("svg", {
            id: "goo-loader",
            width: width,
            height: height,
            "data-testid": "mutating-dots-svg",
            children: [
                (0, $7b02d682eb115277$exports.jsxs)("filter", {
                    id: "fancy-goo",
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)("feGaussianBlur", {
                            in: "SourceGraphic",
                            stdDeviation: "6",
                            result: "blur"
                        }),
                        (0, $7b02d682eb115277$exports.jsx)("feColorMatrix", {
                            in: "blur",
                            mode: "matrix",
                            values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9",
                            result: "goo"
                        }),
                        (0, $7b02d682eb115277$exports.jsx)("feComposite", {
                            in: "SourceGraphic",
                            in2: "goo",
                            operator: "atop"
                        })
                    ]
                }),
                (0, $7b02d682eb115277$exports.jsxs)("g", {
                    filter: "url(#fancy-goo)",
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)("animateTransform", {
                            id: "mainAnim",
                            attributeName: "transform",
                            attributeType: "XML",
                            type: "rotate",
                            from: "0 50 50",
                            to: "359 50 50",
                            dur: "1.2s",
                            repeatCount: "indefinite"
                        }),
                        (0, $7b02d682eb115277$exports.jsx)("circle", {
                            cx: "50%",
                            cy: "40",
                            r: radius,
                            fill: color,
                            children: (0, $7b02d682eb115277$exports.jsx)("animate", {
                                id: "cAnim1",
                                attributeType: "XML",
                                attributeName: "cy",
                                dur: "0.6s",
                                begin: "0;cAnim1.end+0.2s",
                                calcMode: "spline",
                                values: "40;20;40",
                                keyTimes: "0;0.3;1",
                                keySplines: "0.09, 0.45, 0.16, 1;0.09, 0.45, 0.16, 1"
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsx)("circle", {
                            cx: "50%",
                            cy: "60",
                            r: radius,
                            fill: secondaryColor,
                            children: (0, $7b02d682eb115277$exports.jsx)("animate", {
                                id: "cAnim2",
                                attributeType: "XML",
                                attributeName: "cy",
                                dur: "0.6s",
                                begin: "0.4s;cAnim2.end+0.2s",
                                calcMode: "spline",
                                values: "60;80;60",
                                keyTimes: "0;0.3;1",
                                keySplines: "0.09, 0.45, 0.16, 1;0.09, 0.45, 0.16, 1"
                            })
                        })
                    ]
                })
            ]
        })
    });
/**
 * The radius of the circle
 * The Loader size is set with the width and height of the SVG
 * @type {number}
 */ const $b074148cf394a24e$var$$a5fa864d4dd36deb$var$RADIUS = 20;
/**
 * Compute Path depending on circle radius
 * The structure with radius 20 is "M20 0c0-9.94-8.06-20-20-20"
 * @param radius of the circle radius default 20
 * @returns {string}
 */ const $b074148cf394a24e$var$$a5fa864d4dd36deb$var$getPath = (radius)=>{
    return [
        "M" + radius + " 0c0-9.94-8.06",
        radius,
        radius,
        radius
    ].join("-");
};
/**
 * Compute the size of the view box depending on the radius and Stroke-Width
 * @param strokeWidth Stroke-Width of the full circle
 * @param secondaryStrokeWidth Stroke-Width of the 1/4 circle
 * @param radius radius of the circle
 * @returns {string}
 */ const $b074148cf394a24e$var$$a5fa864d4dd36deb$var$getViewBoxSize = (strokeWidth, secondaryStrokeWidth, radius)=>{
    const maxStrokeWidth = Math.max(strokeWidth, secondaryStrokeWidth);
    const startingPoint = -radius - maxStrokeWidth / 2 + 1;
    const endpoint = radius * 2 + maxStrokeWidth;
    return [
        startingPoint,
        startingPoint,
        endpoint,
        endpoint
    ].join(" ");
};
const $b074148cf394a24e$export$67ad50c48ca3ede4 = ({ height: height = 80, width: width = 80, color: color = $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, secondaryColor: secondaryColor = $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "oval-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true, strokeWidth: strokeWidth = 2, strokeWidthSecondary: strokeWidthSecondary })=>(0, $7b02d682eb115277$exports.jsx)($b074148cf394a24e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "oval-loading",
        "aria-label": ariaLabel,
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $7b02d682eb115277$exports.jsx)("svg", {
            width: width,
            height: height,
            viewBox: $b074148cf394a24e$var$$a5fa864d4dd36deb$var$getViewBoxSize(Number(strokeWidth), Number(strokeWidthSecondary || strokeWidth), $b074148cf394a24e$var$$a5fa864d4dd36deb$var$RADIUS),
            xmlns: "http://www.w3.org/2000/svg",
            stroke: color,
            "data-testid": "oval-svg",
            children: (0, $7b02d682eb115277$exports.jsx)("g", {
                fill: "none",
                fillRule: "evenodd",
                children: (0, $7b02d682eb115277$exports.jsxs)("g", {
                    transform: "translate(1 1)",
                    strokeWidth: Number(strokeWidthSecondary || strokeWidth),
                    "data-testid": "oval-secondary-group",
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)("circle", {
                            strokeOpacity: ".5",
                            cx: "0",
                            cy: "0",
                            r: $b074148cf394a24e$var$$a5fa864d4dd36deb$var$RADIUS,
                            stroke: secondaryColor,
                            strokeWidth: strokeWidth
                        }),
                        (0, $7b02d682eb115277$exports.jsx)("path", {
                            d: $b074148cf394a24e$var$$a5fa864d4dd36deb$var$getPath($b074148cf394a24e$var$$a5fa864d4dd36deb$var$RADIUS),
                            children: (0, $7b02d682eb115277$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                from: "0 0 0",
                                to: "360 0 0",
                                dur: "1s",
                                repeatCount: "indefinite"
                            })
                        })
                    ]
                })
            })
        })
    });
const $b074148cf394a24e$export$83d2259ec538613b = ({ height: height = 80, width: width = 80, radius: radius = 1, color: color = $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "puff-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $7b02d682eb115277$exports.jsx)($b074148cf394a24e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "puff-loading",
        "aria-label": ariaLabel,
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $7b02d682eb115277$exports.jsx)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 44 44",
            xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            stroke: color,
            "data-testid": "puff-svg",
            children: (0, $7b02d682eb115277$exports.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                strokeWidth: "2",
                children: [
                    (0, $7b02d682eb115277$exports.jsxs)("circle", {
                        cx: "22",
                        cy: "22",
                        r: radius,
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)("animate", {
                                attributeName: "r",
                                begin: "0s",
                                dur: "1.8s",
                                values: "1; 20",
                                calcMode: "spline",
                                keyTimes: "0; 1",
                                keySplines: "0.165, 0.84, 0.44, 1",
                                repeatCount: "indefinite"
                            }),
                            (0, $7b02d682eb115277$exports.jsx)("animate", {
                                attributeName: "strokeOpacity",
                                begin: "0s",
                                dur: "1.8s",
                                values: "1; 0",
                                calcMode: "spline",
                                keyTimes: "0; 1",
                                keySplines: "0.3, 0.61, 0.355, 1",
                                repeatCount: "indefinite"
                            })
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)("circle", {
                        cx: "22",
                        cy: "22",
                        r: radius,
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)("animate", {
                                attributeName: "r",
                                begin: "-0.9s",
                                dur: "1.8s",
                                values: "1; 20",
                                calcMode: "spline",
                                keyTimes: "0; 1",
                                keySplines: "0.165, 0.84, 0.44, 1",
                                repeatCount: "indefinite"
                            }),
                            (0, $7b02d682eb115277$exports.jsx)("animate", {
                                attributeName: "strokeOpacity",
                                begin: "-0.9s",
                                dur: "1.8s",
                                values: "1; 0",
                                calcMode: "spline",
                                keyTimes: "0; 1",
                                keySplines: "0.3, 0.61, 0.355, 1",
                                repeatCount: "indefinite"
                            })
                        ]
                    })
                ]
            })
        })
    });
const $b074148cf394a24e$export$8e22e563e5362f75 = ({ radius: radius = 45, strokeWidth: strokeWidth = 5, color: color = $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, secondaryColor: secondaryColor, ariaLabel: ariaLabel = "revolving-dot-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $7b02d682eb115277$exports.jsx)($b074148cf394a24e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "aria-label": ariaLabel,
        "data-testid": "revolving-dot-loading",
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $7b02d682eb115277$exports.jsxs)("svg", {
            version: "1.1",
            width: `calc(${radius} * 2.5)`,
            height: `calc(${radius} * 2.5)`,
            xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            x: "0px",
            y: "0px",
            "data-testid": "revolving-dot-svg",
            children: [
                (0, $7b02d682eb115277$exports.jsx)("circle", {
                    fill: "none",
                    stroke: secondaryColor || color,
                    strokeWidth: strokeWidth,
                    cx: `calc(${radius} * 1.28)`,
                    cy: `calc(${radius} * 1.28)`,
                    r: radius,
                    style: {
                        opacity: 0.5
                    }
                }),
                (0, $7b02d682eb115277$exports.jsx)("circle", {
                    fill: color,
                    stroke: color,
                    strokeWidth: "3",
                    cx: `calc(${radius} * 1.28)`,
                    cy: `calc(${radius} / 3.5)`,
                    r: `calc(${radius} / 5)`,
                    style: {
                        transformOrigin: "50% 50%"
                    },
                    children: (0, $7b02d682eb115277$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        dur: "2s",
                        type: "rotate",
                        from: "0",
                        to: "360",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    });
const $b074148cf394a24e$export$fdd9e2f491a77de7 = ({ height: height = 80, width: width = 80, radius: radius = 6, color: color = $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "rings-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $7b02d682eb115277$exports.jsx)($b074148cf394a24e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "rings-loading",
        "aria-label": ariaLabel,
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $7b02d682eb115277$exports.jsx)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 45 45",
            xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            stroke: color,
            "data-testid": "rings-svg",
            children: (0, $7b02d682eb115277$exports.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                transform: "translate(1 1)",
                strokeWidth: "2",
                children: [
                    (0, $7b02d682eb115277$exports.jsxs)("circle", {
                        cx: "22",
                        cy: "22",
                        r: radius,
                        strokeOpacity: "0",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)("animate", {
                                attributeName: "r",
                                begin: "1.5s",
                                dur: "3s",
                                values: "6;22",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            }),
                            (0, $7b02d682eb115277$exports.jsx)("animate", {
                                attributeName: "stroke-opacity",
                                begin: "1.5s",
                                dur: "3s",
                                values: "1;0",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            }),
                            (0, $7b02d682eb115277$exports.jsx)("animate", {
                                attributeName: "stroke-width",
                                begin: "1.5s",
                                dur: "3s",
                                values: "2;0",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)("circle", {
                        cx: "22",
                        cy: "22",
                        r: radius,
                        strokeOpacity: "0",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)("animate", {
                                attributeName: "r",
                                begin: "3s",
                                dur: "3s",
                                values: "6;22",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            }),
                            (0, $7b02d682eb115277$exports.jsx)("animate", {
                                attributeName: "strokeOpacity",
                                begin: "3s",
                                dur: "3s",
                                values: "1;0",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            }),
                            (0, $7b02d682eb115277$exports.jsx)("animate", {
                                attributeName: "strokeWidth",
                                begin: "3s",
                                dur: "3s",
                                values: "2;0",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("circle", {
                        cx: "22",
                        cy: "22",
                        r: Number(radius) + 2,
                        children: (0, $7b02d682eb115277$exports.jsx)("animate", {
                            attributeName: "r",
                            begin: "0s",
                            dur: "1.5s",
                            values: "6;1;2;3;4;5;6",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    })
                ]
            })
        })
    });
const $b074148cf394a24e$export$bb511942ded86554 = ({ wrapperClass: wrapperClass = "", color: color = $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, height: height = 100, width: width = 100, strokeWidth: strokeWidth = 4, ariaLabel: ariaLabel = "rotating-square-loading", wrapperStyle: wrapperStyle = {}, visible: visible = true })=>{
    return (0, $7b02d682eb115277$exports.jsx)($b074148cf394a24e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "rotating-square-wrapper",
        "aria-label": ariaLabel,
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $7b02d682eb115277$exports.jsxs)("svg", {
            version: "1.1",
            xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            x: "0px",
            y: "0px",
            viewBox: "0 0 100 100",
            enableBackground: "new 0 0 100 100",
            height: `${height}`,
            width: `${width}`,
            "data-testid": "rotating-square-svg",
            xmlSpace: "preserve",
            children: [
                (0, $7b02d682eb115277$exports.jsx)("rect", {
                    fill: "none",
                    stroke: color,
                    strokeWidth: strokeWidth,
                    x: "25",
                    y: "25",
                    width: "50",
                    height: "50",
                    children: (0, $7b02d682eb115277$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        dur: "0.5s",
                        from: "0 50 50",
                        to: "180 50 50",
                        type: "rotate",
                        id: "strokeBox",
                        attributeType: "XML",
                        begin: "rectBox.end"
                    })
                }),
                (0, $7b02d682eb115277$exports.jsx)("rect", {
                    x: "27",
                    y: "27",
                    fill: color,
                    width: "46",
                    height: "50",
                    children: (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "height",
                        dur: "1.3s",
                        attributeType: "XML",
                        from: "50",
                        to: "0",
                        id: "rectBox",
                        fill: "freeze",
                        begin: "0s;strokeBox.end"
                    })
                })
            ]
        })
    });
};
const $b074148cf394a24e$var$$5819da83a926266a$var$POINTS = [
    0,
    30,
    60,
    90,
    120,
    150,
    180,
    210,
    240,
    270,
    300,
    330
];
const $b074148cf394a24e$var$$5819da83a926266a$var$spin = (0, $27ab9eeb1c7feda9$export$d25ddfdf17c3ad3e)`
to {
   transform: rotate(360deg);
 }
`;
const $b074148cf394a24e$var$$5819da83a926266a$var$Svg = (0, $27ab9eeb1c7feda9$export$2e2bcd8739ae039).svg`
  animation: ${$b074148cf394a24e$var$$5819da83a926266a$var$spin} 0.75s steps(12, end) infinite;
  animation-duration: 0.75s;
`;
const $b074148cf394a24e$var$$5819da83a926266a$var$Polyline = (0, $27ab9eeb1c7feda9$export$2e2bcd8739ae039).polyline`
  stroke-width: ${(props)=>props.width}px;
  stroke-linecap: round;

  &:nth-child(12n + 0) {
    stroke-opacity: 0.08;
  }

  &:nth-child(12n + 1) {
    stroke-opacity: 0.17;
  }

  &:nth-child(12n + 2) {
    stroke-opacity: 0.25;
  }

  &:nth-child(12n + 3) {
    stroke-opacity: 0.33;
  }

  &:nth-child(12n + 4) {
    stroke-opacity: 0.42;
  }

  &:nth-child(12n + 5) {
    stroke-opacity: 0.5;
  }

  &:nth-child(12n + 6) {
    stroke-opacity: 0.58;
  }

  &:nth-child(12n + 7) {
    stroke-opacity: 0.66;
  }

  &:nth-child(12n + 8) {
    stroke-opacity: 0.75;
  }

  &:nth-child(12n + 9) {
    stroke-opacity: 0.83;
  }

  &:nth-child(12n + 11) {
    stroke-opacity: 0.92;
  }
`;
const $b074148cf394a24e$export$d20df8773b6b77b5 = ({ strokeColor: strokeColor = $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, strokeWidth: strokeWidth = "5", animationDuration: animationDuration = "0.75", width: width = "96", visible: visible = true, ariaLabel: ariaLabel = "rotating-lines-loading" })=>{
    const lines = (0, $acw62.useCallback)(()=>$b074148cf394a24e$var$$5819da83a926266a$var$POINTS.map((point)=>(0, $7b02d682eb115277$exports.jsx)($b074148cf394a24e$var$$5819da83a926266a$var$Polyline, {
                points: "24,12 24,4",
                width: strokeWidth,
                transform: `rotate(${point}, 24, 24)`
            }, point)), [
        strokeWidth
    ]);
    return !visible ? null : (0, $7b02d682eb115277$exports.jsx)($b074148cf394a24e$var$$5819da83a926266a$var$Svg, {
        xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 48 48",
        width: width,
        stroke: strokeColor,
        speed: animationDuration,
        "data-testid": "rotating-lines-svg",
        "aria-label": ariaLabel,
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: lines()
    });
};
const $b074148cf394a24e$export$f8e5ae7506d65b32 = ({ height: height = 80, width: width = 80, strokeWidth: strokeWidth = 2, radius: radius = 1, color: color = $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "tail-spin-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>{
    const strokeWidthNum = parseInt(String(strokeWidth));
    const viewBoxValue = strokeWidthNum + 36;
    const halfStrokeWidth = strokeWidthNum / 2;
    const processedRadius = halfStrokeWidth + parseInt(String(radius)) - 1;
    return (0, $7b02d682eb115277$exports.jsx)($b074148cf394a24e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "tail-spin-loading",
        "aria-label": ariaLabel,
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $7b02d682eb115277$exports.jsxs)("svg", {
            width: width,
            height: height,
            viewBox: `0 0 ${viewBoxValue} ${viewBoxValue}`,
            xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            "data-testid": "tail-spin-svg",
            children: [
                (0, $7b02d682eb115277$exports.jsx)("defs", {
                    children: (0, $7b02d682eb115277$exports.jsxs)("linearGradient", {
                        x1: "8.042%",
                        y1: "0%",
                        x2: "65.682%",
                        y2: "23.865%",
                        id: "a",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)("stop", {
                                stopColor: color,
                                stopOpacity: "0",
                                offset: "0%"
                            }),
                            (0, $7b02d682eb115277$exports.jsx)("stop", {
                                stopColor: color,
                                stopOpacity: ".631",
                                offset: "63.146%"
                            }),
                            (0, $7b02d682eb115277$exports.jsx)("stop", {
                                stopColor: color,
                                offset: "100%"
                            })
                        ]
                    })
                }),
                (0, $7b02d682eb115277$exports.jsx)("g", {
                    fill: "none",
                    fillRule: "evenodd",
                    children: (0, $7b02d682eb115277$exports.jsxs)("g", {
                        transform: `translate(${halfStrokeWidth} ${halfStrokeWidth})`,
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)("path", {
                                d: "M36 18c0-9.94-8.06-18-18-18",
                                id: "Oval-2",
                                stroke: color,
                                strokeWidth: strokeWidth,
                                children: (0, $7b02d682eb115277$exports.jsx)("animateTransform", {
                                    attributeName: "transform",
                                    type: "rotate",
                                    from: "0 18 18",
                                    to: "360 18 18",
                                    dur: "0.9s",
                                    repeatCount: "indefinite"
                                })
                            }),
                            (0, $7b02d682eb115277$exports.jsx)("circle", {
                                fill: "#fff",
                                cx: "36",
                                cy: "18",
                                r: processedRadius,
                                children: (0, $7b02d682eb115277$exports.jsx)("animateTransform", {
                                    attributeName: "transform",
                                    type: "rotate",
                                    from: "0 18 18",
                                    to: "360 18 18",
                                    dur: "0.9s",
                                    repeatCount: "indefinite"
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
const $b074148cf394a24e$export$e21573137ccb7f5d = ({ wrapperStyle: wrapperStyle = {}, visible: visible = true, wrapperClass: wrapperClass = "", height: height = 100, width: width = 100, color: color = $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "three-circles-loading", outerCircleColor: outerCircleColor, innerCircleColor: innerCircleColor, middleCircleColor: middleCircleColor })=>{
    return (0, $7b02d682eb115277$exports.jsx)($b074148cf394a24e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "three-circles-wrapper",
        "aria-label": ariaLabel,
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $7b02d682eb115277$exports.jsxs)("svg", {
            version: "1.1",
            height: `${height}`,
            width: `${width}`,
            xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            viewBox: "0 0 100 100",
            enableBackground: "new 0 0 100 100",
            xmlSpace: "preserve",
            "data-testid": "three-circles-svg",
            children: [
                (0, $7b02d682eb115277$exports.jsx)("path", {
                    fill: outerCircleColor || color,
                    d: "M31.6,3.5C5.9,13.6-6.6,42.7,3.5,68.4c10.1,25.7,39.2,38.3,64.9,28.1l-3.1-7.9c-21.3,8.4-45.4-2-53.8-23.3 c-8.4-21.3,2-45.4,23.3-53.8L31.6,3.5z",
                    children: (0, $7b02d682eb115277$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        attributeType: "XML",
                        type: "rotate",
                        dur: "2s",
                        from: "0 50 50",
                        to: "360 50 50",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $7b02d682eb115277$exports.jsx)("path", {
                    fill: middleCircleColor || color,
                    d: "M42.3,39.6c5.7-4.3,13.9-3.1,18.1,2.7c4.3,5.7,3.1,13.9-2.7,18.1l4.1,5.5c8.8-6.5,10.6-19,4.1-27.7 c-6.5-8.8-19-10.6-27.7-4.1L42.3,39.6z",
                    children: (0, $7b02d682eb115277$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        attributeType: "XML",
                        type: "rotate",
                        dur: "1s",
                        from: "0 50 50",
                        to: "-360 50 50",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $7b02d682eb115277$exports.jsx)("path", {
                    fill: innerCircleColor || color,
                    d: "M82,35.7C74.1,18,53.4,10.1,35.7,18S10.1,46.6,18,64.3l7.6-3.4c-6-13.5,0-29.3,13.5-35.3s29.3,0,35.3,13.5 L82,35.7z",
                    children: (0, $7b02d682eb115277$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        attributeType: "XML",
                        type: "rotate",
                        dur: "2s",
                        from: "0 50 50",
                        to: "360 50 50",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    });
};
const $b074148cf394a24e$export$4bf83b24a11cff0b = ({ height: height = 80, width: width = 80, radius: radius = 9, color: color = $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "three-dots-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $7b02d682eb115277$exports.jsx)($b074148cf394a24e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "three-dots-loading",
        "aria-label": ariaLabel,
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $7b02d682eb115277$exports.jsxs)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 120 30",
            xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            fill: color,
            "data-testid": "three-dots-svg",
            children: [
                (0, $7b02d682eb115277$exports.jsxs)("circle", {
                    cx: "15",
                    cy: "15",
                    r: Number(radius) + 6,
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)("animate", {
                            attributeName: "r",
                            from: "15",
                            to: "15",
                            begin: "0s",
                            dur: "0.8s",
                            values: "15;9;15",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $7b02d682eb115277$exports.jsx)("animate", {
                            attributeName: "fill-opacity",
                            from: "1",
                            to: "1",
                            begin: "0s",
                            dur: "0.8s",
                            values: "1;.5;1",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $7b02d682eb115277$exports.jsxs)("circle", {
                    cx: "60",
                    cy: "15",
                    r: radius,
                    attributeName: "fill-opacity",
                    from: "1",
                    to: "0.3",
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)("animate", {
                            attributeName: "r",
                            from: "9",
                            to: "9",
                            begin: "0s",
                            dur: "0.8s",
                            values: "9;15;9",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $7b02d682eb115277$exports.jsx)("animate", {
                            attributeName: "fill-opacity",
                            from: "0.5",
                            to: "0.5",
                            begin: "0s",
                            dur: "0.8s",
                            values: ".5;1;.5",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $7b02d682eb115277$exports.jsxs)("circle", {
                    cx: "105",
                    cy: "15",
                    r: Number(radius) + 6,
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)("animate", {
                            attributeName: "r",
                            from: "15",
                            to: "15",
                            begin: "0s",
                            dur: "0.8s",
                            values: "15;9;15",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $7b02d682eb115277$exports.jsx)("animate", {
                            attributeName: "fill-opacity",
                            from: "1",
                            to: "1",
                            begin: "0s",
                            dur: "0.8s",
                            values: "1;.5;1",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                })
            ]
        })
    });
const $b074148cf394a24e$var$$afa12dd3e98f740f$var$VIEW_BOX_VALUES = "-3 -4 39 39";
const $b074148cf394a24e$var$$afa12dd3e98f740f$var$POLYGON_POINTS = "16,0 32,32 0,32";
/** Styles */ const $b074148cf394a24e$var$$afa12dd3e98f740f$var$dash = (0, $27ab9eeb1c7feda9$export$d25ddfdf17c3ad3e)`
to {
   stroke-dashoffset: 136;
 }
`;
const $b074148cf394a24e$var$$afa12dd3e98f740f$var$Polygon = (0, $27ab9eeb1c7feda9$export$2e2bcd8739ae039).polygon`
  stroke-dasharray: 17;
  animation: ${$b074148cf394a24e$var$$afa12dd3e98f740f$var$dash} 2.5s cubic-bezier(0.35, 0.04, 0.63, 0.95) infinite;
`;
const $b074148cf394a24e$var$$afa12dd3e98f740f$var$SVG = (0, $27ab9eeb1c7feda9$export$2e2bcd8739ae039).svg`
  transform-origin: 50% 65%;
`;
const $b074148cf394a24e$export$5a465592bfe74b48 = ({ height: height = 80, width: width = 80, color: color = $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "triangle-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>{
    return (0, $7b02d682eb115277$exports.jsx)($b074148cf394a24e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: `${wrapperClass}`,
        "data-testid": "triangle-loading",
        "aria-label": ariaLabel,
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $7b02d682eb115277$exports.jsx)($b074148cf394a24e$var$$afa12dd3e98f740f$var$SVG, {
            id: "triangle",
            width: width,
            height: height,
            xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            viewBox: $b074148cf394a24e$var$$afa12dd3e98f740f$var$VIEW_BOX_VALUES,
            "data-testid": "triangle-svg",
            children: (0, $7b02d682eb115277$exports.jsx)($b074148cf394a24e$var$$afa12dd3e98f740f$var$Polygon, {
                fill: "transparent",
                stroke: color,
                strokeWidth: "1",
                points: $b074148cf394a24e$var$$afa12dd3e98f740f$var$POLYGON_POINTS
            })
        })
    });
};
const $b074148cf394a24e$export$4c68f1a79f88778c = ({ height: height = 80, width: width = 80, radius: radius = 48, color: color = $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "watch-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $7b02d682eb115277$exports.jsx)($b074148cf394a24e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "watch-loading",
        "aria-label": ariaLabel,
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $7b02d682eb115277$exports.jsxs)("svg", {
            width: width,
            height: height,
            version: "1.1",
            id: "L2",
            xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            x: "0px",
            y: "0px",
            viewBox: "0 0 100 100",
            enableBackground: "new 0 0 100 100",
            xmlSpace: "preserve",
            "data-testid": "watch-svg",
            children: [
                (0, $7b02d682eb115277$exports.jsx)("circle", {
                    fill: "none",
                    stroke: color,
                    strokeWidth: "4",
                    strokeMiterlimit: "10",
                    cx: "50",
                    cy: "50",
                    r: radius
                }),
                (0, $7b02d682eb115277$exports.jsx)("line", {
                    fill: "none",
                    strokeLinecap: "round",
                    stroke: color,
                    strokeWidth: "4",
                    strokeMiterlimit: "10",
                    x1: "50",
                    y1: "50",
                    x2: "85",
                    y2: "50.5",
                    children: (0, $7b02d682eb115277$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        dur: "2s",
                        type: "rotate",
                        from: "0 50 50",
                        to: "360 50 50",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $7b02d682eb115277$exports.jsx)("line", {
                    fill: "none",
                    strokeLinecap: "round",
                    stroke: color,
                    strokeWidth: "4",
                    strokeMiterlimit: "10",
                    x1: "50",
                    y1: "50",
                    x2: "49.5",
                    y2: "74",
                    children: (0, $7b02d682eb115277$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        dur: "15s",
                        type: "rotate",
                        from: "0 50 50",
                        to: "360 50 50",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    });
const $b074148cf394a24e$export$1ed1943372cc63a9 = ({ color: color = $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, width: width = "100", visible: visible = true })=>{
    return visible ? (0, $7b02d682eb115277$exports.jsxs)("svg", {
        xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
        width: width,
        height: width,
        viewBox: "0 0 100 100",
        "data-testid": "falling-lines",
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $7b02d682eb115277$exports.jsxs)("rect", {
                y: "25",
                width: "10",
                height: "50",
                rx: "4",
                ry: "4",
                fill: color,
                "data-testid": "falling-lines-rect-1",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "x",
                        values: "10;100",
                        dur: "1.2s",
                        repeatCount: "indefinite"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "rotate",
                        from: "0 10 70",
                        to: "-60 100 70",
                        dur: "1.2s",
                        repeatCount: "indefinite"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "opacity",
                        values: "0;1;0",
                        dur: "1.2s",
                        repeatCount: "indefinite"
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)("rect", {
                y: "25",
                width: "10",
                height: "50",
                rx: "4",
                ry: "4",
                fill: color,
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "x",
                        values: "10;100",
                        dur: "1.2s",
                        begin: "0.4s",
                        repeatCount: "indefinite"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "rotate",
                        from: "0 10 70",
                        to: "-60 100 70",
                        dur: "1.2s",
                        begin: "0.4s",
                        repeatCount: "indefinite"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "opacity",
                        values: "0;1;0",
                        dur: "1.2s",
                        begin: "0.4s",
                        repeatCount: "indefinite"
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)("rect", {
                y: "25",
                width: "10",
                height: "50",
                rx: "4",
                ry: "4",
                fill: color,
                "data-testid": "falling-lines-rect-2",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "x",
                        values: "10;100",
                        dur: "1.2s",
                        begin: "0.8s",
                        repeatCount: "indefinite"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "rotate",
                        from: "0 10 70",
                        to: "-60 100 70",
                        dur: "1.2s",
                        begin: "0.8s",
                        repeatCount: "indefinite"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "opacity",
                        values: "0;1;0",
                        dur: "1.2s",
                        begin: "0.8s",
                        repeatCount: "indefinite"
                    })
                ]
            })
        ]
    }) : null;
};
const $b074148cf394a24e$export$d25f4198d7ad6c78 = ({ visible: visible = true, height: height = "80", width: width = "80", ariaLabel: ariaLabel = "vortex-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, colors: colors = [
    "#1B5299",
    "#EF8354",
    "#DB5461",
    "#1B5299",
    "#EF8354",
    "#DB5461"
] })=>{
    return !visible ? null : (0, $7b02d682eb115277$exports.jsx)("svg", {
        height: height,
        width: width,
        xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        "data-testid": "vortex-svg",
        "aria-label": ariaLabel,
        style: wrapperStyle,
        className: wrapperClass,
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $7b02d682eb115277$exports.jsx)("g", {
            transform: "translate(50,50)",
            children: (0, $7b02d682eb115277$exports.jsx)("g", {
                transform: "scale(0.7)",
                children: (0, $7b02d682eb115277$exports.jsx)("g", {
                    transform: "translate(-50,-50)",
                    children: (0, $7b02d682eb115277$exports.jsxs)("g", {
                        transform: "rotate(137.831 50 50)",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                repeatCount: "indefinite",
                                values: "360 50 50;0 50 50",
                                keyTimes: "0;1",
                                dur: "1",
                                keySplines: "0.5 0.5 0.5 0.5",
                                calcMode: "spline"
                            }),
                            (0, $7b02d682eb115277$exports.jsx)("path", {
                                fill: colors[0],
                                d: "M30.4,9.7c-7.4,10.9-11.8,23.8-12.3,37.9c0.2,1,0.5,1.9,0.7,2.8c1.4-5.2,3.4-10.3,6.2-15.1 c2.6-4.4,5.6-8.4,9-12c0.7-0.7,1.4-1.4,2.1-2.1c7.4-7,16.4-12,26-14.6C51.5,3.6,40.2,4.9,30.4,9.7z"
                            }),
                            (0, $7b02d682eb115277$exports.jsx)("path", {
                                fill: colors[1],
                                d: "M24.8,64.2c-2.6-4.4-4.5-9.1-5.9-13.8c-0.3-0.9-0.5-1.9-0.7-2.8c-2.4-9.9-2.2-20.2,0.4-29.8 C10.6,25.5,6,36,5.3,46.8C11,58.6,20,68.9,31.9,76.3c0.9,0.3,1.9,0.5,2.8,0.8C31,73.3,27.6,69,24.8,64.2z"
                            }),
                            (0, $7b02d682eb115277$exports.jsx)("path", {
                                fill: colors[2],
                                d: "M49.6,78.9c-5.1,0-10.1-0.6-14.9-1.8c-1-0.2-1.9-0.5-2.8-0.8c-9.8-2.9-18.5-8.2-25.6-15.2 c2.8,10.8,9.5,20,18.5,26c13.1,0.9,26.6-1.7,38.9-8.3c0.7-0.7,1.4-1.4,2.1-2.1C60.7,78.2,55.3,78.9,49.6,78.9z"
                            }),
                            (0, $7b02d682eb115277$exports.jsx)("path", {
                                fill: colors[3],
                                d: "M81.1,49.6c-1.4,5.2-3.4,10.3-6.2,15.1c-2.6,4.4-5.6,8.4-9,12c-0.7,0.7-1.4,1.4-2.1,2.1 c-7.4,7-16.4,12-26,14.6c10.7,3,22.1,1.7,31.8-3.1c7.4-10.9,11.8-23.8,12.3-37.9C81.6,51.5,81.4,50.6,81.1,49.6z"
                            }),
                            (0, $7b02d682eb115277$exports.jsx)("path", {
                                fill: colors[4],
                                d: "M75.2,12.9c-13.1-0.9-26.6,1.7-38.9,8.3c-0.7,0.7-1.4,1.4-2.1,2.1c5.2-1.4,10.6-2.2,16.2-2.2 c5.1,0,10.1,0.6,14.9,1.8c1,0.2,1.9,0.5,2.8,0.8c9.8,2.9,18.5,8.2,25.6,15.2C90.9,28.1,84.2,18.9,75.2,12.9z"
                            }),
                            (0, $7b02d682eb115277$exports.jsx)("path", {
                                fill: colors[5],
                                d: "M94.7,53.2C89,41.4,80,31.1,68.1,23.7c-0.9-0.3-1.9-0.5-2.8-0.8c3.8,3.8,7.2,8.1,10,13 c2.6,4.4,4.5,9.1,5.9,13.8c0.3,0.9,0.5,1.9,0.7,2.8c2.4,9.9,2.2,20.2-0.4,29.8C89.4,74.5,94,64,94.7,53.2z"
                            })
                        ]
                    })
                })
            })
        })
    });
};
const $b074148cf394a24e$export$f64f16a115ce395d = ({ visible: visible = true, height: height = "80", width: width = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "rotating-triangle-loading", colors: colors = [
    "#1B5299",
    "#EF8354",
    "#DB5461"
] })=>{
    return !visible ? null : (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: width,
        height: height,
        xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "rotating-triangle-svg",
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $7b02d682eb115277$exports.jsx)("g", {
            transform: "translate(50,42)",
            children: (0, $7b02d682eb115277$exports.jsx)("g", {
                transform: "scale(0.8)",
                children: (0, $7b02d682eb115277$exports.jsxs)("g", {
                    transform: "translate(-50,-50)",
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)("polygon", {
                            points: "72.5,50 50,11 27.5,50 50,50",
                            fill: colors[0],
                            transform: "rotate(186 50 38.5)",
                            children: (0, $7b02d682eb115277$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                calcMode: "linear",
                                values: "0 50 38.5;360 50 38.5",
                                keyTimes: "0;1",
                                dur: "1s",
                                begin: "0s",
                                repeatCount: "indefinite"
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsx)("polygon", {
                            points: "5,89 50,89 27.5,50",
                            fill: colors[1],
                            transform: "rotate(186 27.5 77.5)",
                            children: (0, $7b02d682eb115277$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                calcMode: "linear",
                                values: "0 27.5 77.5;360 27.5 77.5",
                                keyTimes: "0;1",
                                dur: "1s",
                                begin: "0s",
                                repeatCount: "indefinite"
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsx)("polygon", {
                            points: "72.5,50 50,89 95,89",
                            fill: colors[2],
                            transform: "rotate(186 72.2417 77.5)",
                            children: (0, $7b02d682eb115277$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                calcMode: "linear",
                                values: "0 72.5 77.5;360 72 77.5",
                                keyTimes: "0;1",
                                dur: "1s",
                                begin: "0s",
                                repeatCount: "indefinite"
                            })
                        })
                    ]
                })
            })
        })
    });
};
const $b074148cf394a24e$export$d7b12c4107be0d61 = ({ visible: visible = true, height: height = "80", width: width = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "radio-loading", colors: colors = [
    $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c,
    $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c,
    $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c
] })=>{
    return !visible ? null : (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: width,
        height: height,
        xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "radio-bar-svg",
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "28",
                cy: "75",
                r: "11",
                fill: colors[0],
                children: (0, $7b02d682eb115277$exports.jsx)("animate", {
                    attributeName: "fill-opacity",
                    calcMode: "linear",
                    values: "0;1;1",
                    keyTimes: "0;0.2;1",
                    dur: "1",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M28 47A28 28 0 0 1 56 75",
                fill: "none",
                strokeWidth: "10",
                stroke: colors[1],
                children: (0, $7b02d682eb115277$exports.jsx)("animate", {
                    attributeName: "stroke-opacity",
                    calcMode: "linear",
                    values: "0;1;1",
                    keyTimes: "0;0.2;1",
                    dur: "1",
                    begin: "0.1s",
                    repeatCount: "indefinite"
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M28 25A50 50 0 0 1 78 75",
                fill: "none",
                strokeWidth: "10",
                stroke: colors[2],
                children: (0, $7b02d682eb115277$exports.jsx)("animate", {
                    attributeName: "stroke-opacity",
                    calcMode: "linear",
                    values: "0;1;1",
                    keyTimes: "0;0.2;1",
                    dur: "1",
                    begin: "0.2s",
                    repeatCount: "indefinite"
                })
            })
        ]
    });
};
const $b074148cf394a24e$export$c17561cb55d4db30 = ({ visible: visible = true, height: height = "80", width: width = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "progress-bar-loading", borderColor: borderColor = "#F4442E", barColor: barColor = "#51E5FF" })=>{
    return !visible ? null : (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: width,
        height: height,
        xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "progress-bar-svg",
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("defs", {
                children: (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                    x: "0",
                    y: "0",
                    width: "100",
                    height: "100",
                    id: "lds-progress-cpid-5009611b8a418",
                    children: (0, $7b02d682eb115277$exports.jsxs)("rect", {
                        x: "0",
                        y: "0",
                        width: "66.6667",
                        height: "100",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)("animate", {
                                attributeName: "width",
                                calcMode: "linear",
                                values: "0;100;100",
                                keyTimes: "0;0.5;1",
                                dur: "1",
                                begin: "0s",
                                repeatCount: "indefinite"
                            }),
                            (0, $7b02d682eb115277$exports.jsx)("animate", {
                                attributeName: "x",
                                calcMode: "linear",
                                values: "0;0;100",
                                keyTimes: "0;0.5;1",
                                dur: "1",
                                begin: "0s",
                                repeatCount: "indefinite"
                            })
                        ]
                    })
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fill: "none",
                strokeWidth: "2.7928",
                d: "M82,63H18c-7.2,0-13-5.8-13-13v0c0-7.2,5.8-13,13-13h64c7.2,0,13,5.8,13,13v0C95,57.2,89.2,63,82,63z",
                stroke: borderColor
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M81.3,58.7H18.7c-4.8,0-8.7-3.9-8.7-8.7v0c0-4.8,3.9-8.7,8.7-8.7h62.7c4.8,0,8.7,3.9,8.7,8.7v0C90,54.8,86.1,58.7,81.3,58.7z",
                fill: barColor,
                clipPath: "url(#lds-progress-cpid-5009611b8a418)"
            })
        ]
    });
};
const $b074148cf394a24e$export$bdf537af43a20db5 = ({ visible: visible = true, height: height = "80", width: width = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "magnifying-glass-loading", glassColor: glassColor = "#c0efff", color: color = "#e15b64" })=>{
    return !visible ? null : (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: width,
        height: height,
        xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "magnifying-glass-svg",
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $7b02d682eb115277$exports.jsx)("g", {
            transform: "translate(50,50)",
            children: (0, $7b02d682eb115277$exports.jsx)("g", {
                transform: "scale(0.82)",
                children: (0, $7b02d682eb115277$exports.jsx)("g", {
                    transform: "translate(-50,-50)",
                    children: (0, $7b02d682eb115277$exports.jsxs)("g", {
                        transform: "translate(16.3636 -20)",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "translate",
                                calcMode: "linear",
                                values: "-20 -20;20 -20;0 20;-20 -20",
                                keyTimes: "0;0.33;0.66;1",
                                dur: "1s",
                                begin: "0s",
                                repeatCount: "indefinite"
                            }),
                            (0, $7b02d682eb115277$exports.jsx)("path", {
                                d: "M44.19,26.158c-4.817,0-9.345,1.876-12.751,5.282c-3.406,3.406-5.282,7.934-5.282,12.751 c0,4.817,1.876,9.345,5.282,12.751c3.406,3.406,7.934,5.282,12.751,5.282s9.345-1.876,12.751-5.282 c3.406-3.406,5.282-7.934,5.282-12.751c0-4.817-1.876-9.345-5.282-12.751C53.536,28.033,49.007,26.158,44.19,26.158z",
                                fill: glassColor
                            }),
                            (0, $7b02d682eb115277$exports.jsx)("path", {
                                d: "M78.712,72.492L67.593,61.373l-3.475-3.475c1.621-2.352,2.779-4.926,3.475-7.596c1.044-4.008,1.044-8.23,0-12.238 c-1.048-4.022-3.146-7.827-6.297-10.979C56.572,22.362,50.381,20,44.19,20C38,20,31.809,22.362,27.085,27.085 c-9.447,9.447-9.447,24.763,0,34.21C31.809,66.019,38,68.381,44.19,68.381c4.798,0,9.593-1.425,13.708-4.262l9.695,9.695 l4.899,4.899C73.351,79.571,74.476,80,75.602,80s2.251-0.429,3.11-1.288C80.429,76.994,80.429,74.209,78.712,72.492z M56.942,56.942 c-3.406,3.406-7.934,5.282-12.751,5.282s-9.345-1.876-12.751-5.282c-3.406-3.406-5.282-7.934-5.282-12.751 c0-4.817,1.876-9.345,5.282-12.751c3.406-3.406,7.934-5.282,12.751-5.282c4.817,0,9.345,1.876,12.751,5.282 c3.406,3.406,5.282,7.934,5.282,12.751C62.223,49.007,60.347,53.536,56.942,56.942z",
                                fill: color
                            })
                        ]
                    })
                })
            })
        })
    });
};
const $b074148cf394a24e$export$8e3fad5cade57efa = ({ width: width = "80", height: height = "80", backgroundColor: backgroundColor = $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ballColors: ballColors = [
    "#fc636b",
    "#6a67ce",
    "#ffb900"
], wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "fidget-spinner-loader", visible: visible = true })=>{
    return !visible ? null : (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: width,
        height: height,
        xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "fidget-spinner-svg",
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $7b02d682eb115277$exports.jsxs)("g", {
            transform: "rotate(6 50 50)",
            children: [
                (0, $7b02d682eb115277$exports.jsx)("g", {
                    transform: "translate(50 50)",
                    children: (0, $7b02d682eb115277$exports.jsx)("g", {
                        transform: "scale(0.9)",
                        children: (0, $7b02d682eb115277$exports.jsxs)("g", {
                            transform: "translate(-50 -58)",
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)("path", {
                                    d: "M27.1,79.4c-1.1,0.6-2.4,1-3.7,1c-2.6,0-5.1-1.4-6.4-3.7c-2-3.5-0.8-8,2.7-10.1c1.1-0.6,2.4-1,3.7-1c2.6,0,5.1,1.4,6.4,3.7 C31.8,72.9,30.6,77.4,27.1,79.4z",
                                    fill: ballColors[0]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)("path", {
                                    d: "M72.9,79.4c1.1,0.6,2.4,1,3.7,1c2.6,0,5.1-1.4,6.4-3.7c2-3.5,0.8-8-2.7-10.1c-1.1-0.6-2.4-1-3.7-1c-2.6,0-5.1,1.4-6.4,3.7 C68.2,72.9,69.4,77.4,72.9,79.4z",
                                    fill: ballColors[1]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)("circle", {
                                    cx: "50",
                                    cy: "27",
                                    r: "7.4",
                                    fill: ballColors[2]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)("path", {
                                    d: "M86.5,57.5c-3.1-1.9-6.4-2.8-9.8-2.8c-0.5,0-0.9,0-1.4,0c-0.4,0-0.8,0-1.1,0c-2.1,0-4.2-0.4-6.2-1.2 c-0.8-3.6-2.8-6.9-5.4-9.3c0.4-2.5,1.3-4.8,2.7-6.9c2-2.9,3.2-6.5,3.2-10.4c0-10.2-8.2-18.4-18.4-18.4c-0.3,0-0.6,0-0.9,0 C39.7,9,32,16.8,31.6,26.2c-0.2,4.1,1,7.9,3.2,11c1.4,2.1,2.3,4.5,2.7,6.9c-2.6,2.5-4.6,5.7-5.4,9.3c-1.9,0.7-4,1.1-6.1,1.1 c-0.4,0-0.8,0-1.2,0c-0.5,0-0.9-0.1-1.4-0.1c-3.1,0-6.3,0.8-9.2,2.5c-9.1,5.2-12,17-6.3,25.9c3.5,5.4,9.5,8.4,15.6,8.4 c2.9,0,5.8-0.7,8.5-2.1c3.6-1.9,6.3-4.9,8-8.3c1.1-2.3,2.7-4.2,4.6-5.8c1.7,0.5,3.5,0.8,5.4,0.8c1.9,0,3.7-0.3,5.4-0.8 c1.9,1.6,3.5,3.5,4.6,5.7c1.5,3.2,4,6,7.4,8c2.9,1.7,6.1,2.5,9.2,2.5c6.6,0,13.1-3.6,16.4-10C97.3,73.1,94.4,62.5,86.5,57.5z M29.6,83.7c-1.9,1.1-4,1.6-6.1,1.6c-4.2,0-8.4-2.2-10.6-6.1c-3.4-5.9-1.4-13.4,4.5-16.8c1.9-1.1,4-1.6,6.1-1.6 c4.2,0,8.4,2.2,10.6,6.1C37.5,72.8,35.4,80.3,29.6,83.7z M50,39.3c-6.8,0-12.3-5.5-12.3-12.3S43.2,14.7,50,14.7 c6.8,0,12.3,5.5,12.3,12.3S56.8,39.3,50,39.3z M87.2,79.2c-2.3,3.9-6.4,6.1-10.6,6.1c-2.1,0-4.2-0.5-6.1-1.6 c-5.9-3.4-7.9-10.9-4.5-16.8c2.3-3.9,6.4-6.1,10.6-6.1c2.1,0,4.2,0.5,6.1,1.6C88.6,65.8,90.6,73.3,87.2,79.2z",
                                    fill: backgroundColor
                                })
                            ]
                        })
                    })
                }),
                (0, $7b02d682eb115277$exports.jsx)("animateTransform", {
                    attributeName: "transform",
                    type: "rotate",
                    calcMode: "linear",
                    values: "0 50 50;360 50 50",
                    keyTimes: "0;1",
                    dur: "1s",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            ]
        })
    });
};
const $b074148cf394a24e$export$bee07fdc425df572 = ({ visible: visible = true, width: width = "80", height: height = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "dna-loading" })=>{
    return !visible ? null : (0, $7b02d682eb115277$exports.jsxs)("svg", {
        xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
        width: width,
        height: height,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "dna-svg",
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $7b02d682eb115277$exports.jsxs)("circle", {
                cx: "6.451612903225806",
                cy: "60.6229",
                r: "3.41988",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.5s"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "0s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.5s"
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)("circle", {
                cx: "6.451612903225806",
                cy: "39.3771",
                r: "2.58012",
                fill: "#46dff0",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.5s"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.5s"
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)("circle", {
                cx: "16.129032258064512",
                cy: "68.1552",
                r: "3.17988",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.7s"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.2s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.7s"
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)("circle", {
                cx: "16.129032258064512",
                cy: "31.8448",
                r: "2.82012",
                fill: "#46dff0",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.7s"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.2s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.7s"
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)("circle", {
                cx: "25.806451612903224",
                cy: "69.3634",
                r: "2.93988",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.9s"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.4s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.9s"
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)("circle", {
                cx: "25.806451612903224",
                cy: "30.6366",
                r: "3.06012",
                fill: "#46dff0",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.9s"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.4s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.9s"
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)("circle", {
                cx: "35.48387096774193",
                cy: "65.3666",
                r: "2.69988",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.1s"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.6s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.1s"
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)("circle", {
                cx: "35.48387096774193",
                cy: "34.6334",
                r: "3.30012",
                fill: "#46dff0",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.1s"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.6s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.1s"
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)("circle", {
                cx: "45.16129032258064",
                cy: "53.8474",
                r: "2.45988",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.3s"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.8s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.3s"
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)("circle", {
                cx: "45.16129032258064",
                cy: "46.1526",
                r: "3.54012",
                fill: "#46dff0",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.3s"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.8s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.3s"
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)("circle", {
                cx: "54.838709677419345",
                cy: "39.3771",
                r: "2.58012",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.5s"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.5s"
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)("circle", {
                cx: "54.838709677419345",
                cy: "60.6229",
                r: "3.41988",
                fill: "#46dff0",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.5s"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.5s"
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)("circle", {
                cx: "64.51612903225805",
                cy: "31.8448",
                r: "2.82012",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.7s"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.2s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.7s"
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)("circle", {
                cx: "64.51612903225805",
                cy: "68.1552",
                r: "3.17988",
                fill: "#46dff0",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.7s"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.2s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.7s"
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)("circle", {
                cx: "74.19354838709677",
                cy: "30.6366",
                r: "3.06012",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.9s"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.4s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.9s"
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)("circle", {
                cx: "74.19354838709677",
                cy: "69.3634",
                r: "2.93988",
                fill: "#46dff0",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.9s"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.4s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.9s"
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)("circle", {
                cx: "83.87096774193547",
                cy: "34.6334",
                r: "3.30012",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.1s"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.6s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.1s"
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)("circle", {
                cx: "83.87096774193547",
                cy: "65.3666",
                r: "2.69988",
                fill: "#46dff0",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-3.1s"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.6s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.1s"
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)("circle", {
                cx: "93.54838709677418",
                cy: "46.1526",
                r: "3.54012",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.3s"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.8s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.3s"
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)("circle", {
                cx: "93.54838709677418",
                cy: "53.8474",
                r: "2.45988",
                fill: "#46dff0",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-3.3s"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.8s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.3s"
                    })
                ]
            })
        ]
    });
};
const $b074148cf394a24e$export$f93420b62a5bdffa = ({ visible: visible = true, width: width = "80", height: height = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "discuss-loading", colors: colors = [
    "#ff727d",
    "#ff727d"
] })=>{
    return !visible ? null : (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: width,
        height: height,
        xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "discuss-svg",
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fill: "none",
                d: "M82 50A32 32 0 1 1 23.533421623214014 32.01333190873183 L21.71572875253809 21.7157287525381 L32.013331908731814 23.53342162321403 A32 32 0 0 1 82 50",
                strokeWidth: "5",
                stroke: colors[0]
            }),
            (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "50",
                cy: "50",
                fill: "none",
                strokeLinecap: "round",
                r: "20",
                strokeWidth: "5",
                stroke: colors[1],
                strokeDasharray: "31.41592653589793 31.41592653589793",
                transform: "rotate(96 50 50)",
                children: (0, $7b02d682eb115277$exports.jsx)("animateTransform", {
                    attributeName: "transform",
                    type: "rotate",
                    calcMode: "linear",
                    values: "0 50 50;360 50 50",
                    keyTimes: "0;1",
                    dur: "1s",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            })
        ]
    });
};
const $b074148cf394a24e$export$dc036a5afb9ca26f = ({ visible: visible = true, width: width = "80", height: height = "80", colors: colors = [
    "#e15b64",
    "#f47e60",
    "#f8b26a",
    "#abbd81",
    "#849b87"
], wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "color-ring-loading" })=>{
    return !visible ? null : (0, $7b02d682eb115277$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: width,
        height: height,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "color-ring-svg",
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("defs", {
                children: (0, $7b02d682eb115277$exports.jsx)("mask", {
                    id: "ldio-4offds5dlws-mask",
                    children: (0, $7b02d682eb115277$exports.jsx)("circle", {
                        cx: "50",
                        cy: "50",
                        r: "26",
                        stroke: "#fff",
                        strokeLinecap: "round",
                        strokeDasharray: "122.52211349000194 40.840704496667314",
                        strokeWidth: "9",
                        transform: "rotate(198.018 50 50)",
                        children: (0, $7b02d682eb115277$exports.jsx)("animateTransform", {
                            attributeName: "transform",
                            type: "rotate",
                            values: "0 50 50;360 50 50",
                            keyTimes: "0;1",
                            dur: "1s",
                            repeatCount: "indefinite"
                        })
                    })
                })
            }),
            (0, $7b02d682eb115277$exports.jsxs)("g", {
                mask: "url(#ldio-4offds5dlws-mask)",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("rect", {
                        x: "14.5",
                        y: "0",
                        width: "15",
                        height: "100",
                        fill: colors[0],
                        children: (0, $7b02d682eb115277$exports.jsx)("animate", {
                            attributeName: "fill",
                            values: colors.join(";").toString(),
                            keyTimes: "0;0.25;0.5;0.75;1",
                            dur: "1s",
                            repeatCount: "indefinite",
                            begin: "-0.8s"
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("rect", {
                        x: "28.5",
                        y: "0",
                        width: "15",
                        height: "100",
                        fill: colors[1],
                        children: (0, $7b02d682eb115277$exports.jsx)("animate", {
                            attributeName: "fill",
                            values: colors.join(";").toString(),
                            keyTimes: "0;0.25;0.5;0.75;1",
                            dur: "1s",
                            repeatCount: "indefinite",
                            begin: "-0.6s"
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("rect", {
                        x: "42.5",
                        y: "0",
                        width: "15",
                        height: "100",
                        fill: colors[2],
                        children: (0, $7b02d682eb115277$exports.jsx)("animate", {
                            attributeName: "fill",
                            values: colors.join(";").toString(),
                            keyTimes: "0;0.25;0.5;0.75;1",
                            dur: "1s",
                            repeatCount: "indefinite",
                            begin: "-0.4s"
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("rect", {
                        x: "56.5",
                        y: "0",
                        width: "15",
                        height: "100",
                        fill: colors[3],
                        children: (0, $7b02d682eb115277$exports.jsx)("animate", {
                            attributeName: "fill",
                            values: colors.join(";").toString(),
                            keyTimes: "0;0.25;0.5;0.75;1",
                            dur: "1s",
                            repeatCount: "indefinite",
                            begin: "-0.2s"
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("rect", {
                        x: "70.5",
                        y: "0",
                        width: "15",
                        height: "100",
                        fill: colors[4],
                        children: (0, $7b02d682eb115277$exports.jsx)("animate", {
                            attributeName: "fill",
                            values: colors.join(";").toString(),
                            keyTimes: "0;0.25;0.5;0.75;1",
                            dur: "1s",
                            repeatCount: "indefinite",
                            begin: "0s"
                        })
                    })
                ]
            })
        ]
    });
};
const $b074148cf394a24e$export$4d299b491347818a = ({ visible: visible = true, width: width = "80", height: height = "80", backgroundColor: backgroundColor = "#ff6d00", color: color = "#fff", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "comment-loading" })=>{
    return !visible ? null : (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: width,
        height: height,
        xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "comment-svg",
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M78,19H22c-6.6,0-12,5.4-12,12v31c0,6.6,5.4,12,12,12h37.2c0.4,3,1.8,5.6,3.7,7.6c2.4,2.5,5.1,4.1,9.1,4 c-1.4-2.1-2-7.2-2-10.3c0-0.4,0-0.8,0-1.3h8c6.6,0,12-5.4,12-12V31C90,24.4,84.6,19,78,19z",
                fill: backgroundColor
            }),
            (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "30",
                cy: "47",
                r: "5",
                fill: color,
                children: (0, $7b02d682eb115277$exports.jsx)("animate", {
                    attributeName: "opacity",
                    calcMode: "linear",
                    values: "0;1;1",
                    keyTimes: "0;0.2;1",
                    dur: "1",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "50",
                cy: "47",
                r: "5",
                fill: color,
                children: (0, $7b02d682eb115277$exports.jsx)("animate", {
                    attributeName: "opacity",
                    calcMode: "linear",
                    values: "0;0;1;1",
                    keyTimes: "0;0.2;0.4;1",
                    dur: "1",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "70",
                cy: "47",
                r: "5",
                fill: color,
                children: (0, $7b02d682eb115277$exports.jsx)("animate", {
                    attributeName: "opacity",
                    calcMode: "linear",
                    values: "0;0;1;1",
                    keyTimes: "0;0.4;0.6;1",
                    dur: "1",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            })
        ]
    });
};
const $b074148cf394a24e$export$2ba1b65b747a57aa = ({ visible: visible = true, width: width = "80", height: height = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "blocks-loading" })=>{
    return !visible ? null : (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: width,
        height: height,
        className: wrapperClass,
        style: wrapperStyle,
        xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        "aria-label": ariaLabel,
        "data-testid": "blocks-svg",
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("title", {
                children: "Blocks"
            }),
            (0, $7b02d682eb115277$exports.jsx)("desc", {
                children: "Animated representation of blocks"
            }),
            (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "17",
                y: "17",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $7b02d682eb115277$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0s",
                    calcMode: "discrete"
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "40",
                y: "17",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $7b02d682eb115277$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.125s",
                    calcMode: "discrete"
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "63",
                y: "17",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $7b02d682eb115277$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.25s",
                    calcMode: "discrete"
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "17",
                y: "40",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $7b02d682eb115277$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.875s",
                    calcMode: "discrete"
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "63",
                y: "40",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $7b02d682eb115277$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.375s",
                    calcMode: "discrete"
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "17",
                y: "63",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $7b02d682eb115277$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.75s",
                    calcMode: "discrete"
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "40",
                y: "63",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $7b02d682eb115277$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.625s",
                    calcMode: "discrete"
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "63",
                y: "63",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $7b02d682eb115277$exports.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.5s",
                    calcMode: "discrete"
                })
            })
        ]
    });
};
const $b074148cf394a24e$export$f3c41beb83007357 = ({ visible: visible = true, width: width = "80", height: height = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "hourglass-loading", colors: colors = [
    "#306cce",
    "#72a1ed"
] })=>{
    return !visible ? null : (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: width,
        height: height,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 350 350",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "hourglass-svg",
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("animateTransform", {
                attributeName: "transform",
                type: "rotate",
                values: "0; 0; -30; 360; 360",
                keyTimes: "0; 0.40; 0.55; 0.65; 1",
                dur: "3s",
                begin: "0s",
                calcMode: "linear",
                repeatCount: "indefinite"
            }),
            (0, $7b02d682eb115277$exports.jsxs)("g", {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        fill: colors[0],
                        stroke: colors[0],
                        d: "M324.658,20.572v-2.938C324.658,7.935,316.724,0,307.025,0H40.313c-9.699,0-17.635,7.935-17.635,17.634v2.938     c0,9.699,7.935,17.634,17.635,17.634h6.814c3.5,0,3.223,3.267,3.223,4.937c0,19.588,8.031,42.231,14.186,56.698     c12.344,29.012,40.447,52.813,63.516,69.619c4.211,3.068,3.201,5.916,0.756,7.875c-22.375,17.924-51.793,40.832-64.271,70.16     c-6.059,14.239-13.934,36.4-14.18,55.772c-0.025,1.987,0.771,5.862-3.979,5.862h-6.064c-9.699,0-17.635,7.936-17.635,17.634v2.94     c0,9.698,7.935,17.634,17.635,17.634h266.713c9.699,0,17.633-7.936,17.633-17.634v-2.94c0-9.698-7.934-17.634-17.633-17.634     h-3.816c-7,0-6.326-5.241-6.254-7.958c0.488-18.094-4.832-38.673-12.617-54.135c-17.318-34.389-44.629-56.261-61.449-68.915     c-3.65-2.745-4.018-6.143,0-8.906c17.342-11.929,44.131-34.526,61.449-68.916c8.289-16.464,13.785-38.732,12.447-57.621     c-0.105-1.514-0.211-4.472,3.758-4.472h6.482C316.725,38.206,324.658,30.272,324.658,20.572z M270.271,93.216     c-16.113,31.998-41.967,54.881-64.455,68.67c-1.354,0.831-3.936,2.881-3.936,8.602v6.838c0,6.066,2.752,7.397,4.199,8.286     c22.486,13.806,48.143,36.636,64.191,68.508c7.414,14.727,11.266,32.532,10.885,46.702c-0.078,2.947,1.053,8.308-6.613,8.308     H72.627c-6.75,0-6.475-3.37-6.459-5.213c0.117-12.895,4.563-30.757,12.859-50.255c14.404-33.854,44.629-54.988,64.75-67.577     c0.896-0.561,2.629-1.567,2.629-6.922v-10.236c0-5.534-2.656-7.688-4.057-8.57c-20.098-12.688-49.256-33.618-63.322-66.681     c-8.383-19.702-12.834-37.732-12.861-50.657c-0.002-1.694,0.211-4.812,3.961-4.812h206.582c4.168,0,4.127,3.15,4.264,4.829     C282.156,57.681,278.307,77.257,270.271,93.216z"
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)("g", {
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)("path", {
                                fill: colors[1],
                                stroke: colors[1],
                                d: "M169.541,196.2l-68.748,86.03c-2.27,2.842-1.152,5.166,2.484,5.166h140.781c3.637,0,4.756-2.324,2.484-5.166     l-68.746-86.03C175.525,193.358,171.811,193.358,169.541,196.2z"
                            }),
                            (0, $7b02d682eb115277$exports.jsx)("animate", {
                                attributeName: "opacity",
                                values: "0; 0; 1; 1; 0; 0",
                                keyTimes: "0; 0.1; 0.4; 0.6; 0.61; 1",
                                dur: "3s",
                                repeatCount: "indefinite"
                            })
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)("g", {
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)("path", {
                                fill: colors[1],
                                stroke: colors[1],
                                d: "M168.986,156.219c2.576,2.568,6.789,2.568,9.363,0l34.576-34.489c2.574-2.568,1.707-4.67-1.932-4.67H136.34     c-3.637,0-4.506,2.102-1.932,4.67L168.986,156.219z"
                            }),
                            (0, $7b02d682eb115277$exports.jsx)("animate", {
                                attributeName: "opacity",
                                values: "1; 1; 0; 0; 1; 1",
                                keyTimes: "0; 0.1; 0.4; 0.65; 0.66; 1",
                                dur: "3s",
                                repeatCount: "indefinite"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};



const $cb784e14d145db34$var$UserPage = ({ selectedUser: selectedUser, setIsUserPageOpen: setIsUserPageOpen, updateSourceData: updateSourceData, rerunAnalysis: rerunAnalysis, showResponseError: showResponseError, showResponseValid: showResponseValid, showResponseNoSources: showResponseNoSources, showAnalyzing: showAnalyzing })=>{
    const userdata = (0, $b5949519849ab230$export$8cf58282b30b665b)({
        userid: selectedUser.id
    });
    const [sourceDatas, setSourceDatas] = (0, $acw62.useState)([]);
    (0, $acw62.useEffect)(()=>{
        if (userdata.isSuccess) setSourceDatas([
            ...userdata.data
        ].sort((a, b)=>new Date(b.publication_date) - new Date(a.publication_date)) ?? []);
    }, [
        userdata
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4), {
                mb: 10,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                        size: "lg",
                        fw: 700,
                        children: [
                            "User Operations for ",
                            selectedUser.username
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                        style: {
                            background: (0, $7db4b5652a829202$export$bca14c5b3b88a9c9).colors.blue[4]
                        },
                        ml: "auto",
                        onClick: ()=>setIsUserPageOpen(false),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $058c864623b900db$export$2e2bcd8739ae039), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                style: {
                    background: (0, $7db4b5652a829202$export$bca14c5b3b88a9c9).colors.blue[4]
                },
                ml: "auto",
                mb: 10,
                onClick: ()=>rerunAnalysis(),
                children: "Re-Run Analysis"
            }),
            showAnalyzing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4), {
                justify: "left",
                mb: 10,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b074148cf394a24e$export$e21573137ccb7f5d), {
                        color: (0, $7db4b5652a829202$export$bca14c5b3b88a9c9).colors.blue[4],
                        height: 25,
                        width: 25
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                        fw: 700,
                        children: [
                            " ",
                            "Waiting for analysis to be scheduled for ",
                            selectedUser.username,
                            " ",
                            "check #system-consili for the status"
                        ]
                    })
                ]
            }),
            showResponseError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                c: "red",
                fw: 700,
                size: "md",
                children: [
                    "Analysis could not be scheduled for ",
                    selectedUser.username,
                    " check #system-consili for the status"
                ]
            }),
            showResponseValid && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                c: "darkgreen",
                fw: 700,
                size: "md",
                children: [
                    "Analysis has been scheduled for ",
                    selectedUser.username,
                    " check #system-consili for the status"
                ]
            }),
            showResponseNoSources && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                c: "red",
                fw: 700,
                size: "md",
                children: "Please select sources!"
            }),
            sourceDatas.map((sourcedata)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3e91b7d399f248d1$export$60332b2344f7fe41), {
                    padding: "lg",
                    radius: "md",
                    withBorder: true,
                    style: {
                        cursor: "pointer"
                    },
                    mb: 10,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                        size: "md",
                                        fw: 700,
                                        children: sourcedata.title
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                        size: "md",
                                        fw: 700,
                                        ml: "auto",
                                        children: sourcedata.publication_date.split("T")[0]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                size: "md",
                                fw: 400,
                                children: sourcedata.summary ?? "No summary currently available."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4), {
                                style: {
                                    justifyContent: "right"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                        size: "sm",
                                        fw: 300,
                                        children: "Enable Re-Run"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d55bdb080ff7602c$export$48513f6b9f8ce62d), {
                                        onChange: ()=>updateSourceData(sourcedata)
                                    })
                                ]
                            })
                        ]
                    })
                }, sourcedata.id)),
            sourceDatas.length == 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $99c68b09e9ea9061$export$2e2bcd8739ae039), {
                svgLink: (0, (/*@__PURE__*/$parcel$interopDefault($d5e4bba30610058b$exports))),
                description: "No source datas related to this user's interests"
            })
        ]
    });
};
var $cb784e14d145db34$export$2e2bcd8739ae039 = $cb784e14d145db34$var$UserPage;





const $8c693ecbbd0b36db$var$OperationsManager = ()=>{
    const [isUserPageOpen, setIsUserPageOpen] = (0, $acw62.useState)(false);
    const [selectedUser, setSelectedUser] = (0, $acw62.useState)(undefined);
    const [sourceDatas, setSourceDatas] = (0, $acw62.useState)([]);
    const [analyze, { isLoading: isAnalysisFetching, isError: analysisError, isSuccess: successfulAnalysis }] = (0, $b5949519849ab230$export$b0aaa60cef02693d)();
    const [showConfirmationModal, setShowConfirmationModal] = (0, $acw62.useState)(false);
    const [showResponseError, setShowResponseError] = (0, $acw62.useState)(false);
    const [showAnalyzing, setShowAnalyzing] = (0, $acw62.useState)(false);
    const [showResponseValid, setShowResponseValid] = (0, $acw62.useState)(false);
    const [showResponseNoSources, setShowResponseNoSources] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        setShowConfirmationModal(false);
        if (analysisError) {
            setShowResponseError(true);
            setShowAnalyzing(false);
        } else if (successfulAnalysis) {
            setShowResponseValid(true);
            setShowAnalyzing(false);
        }
    }, [
        isAnalysisFetching,
        successfulAnalysis,
        analysisError
    ]);
    const updatePage = (user)=>{
        setSelectedUser(user);
        setIsUserPageOpen(true);
    };
    const updateSourceData = (sourceData)=>{
        if (sourceDatas.includes(sourceData)) setSourceDatas(sourceDatas.filter((item)=>item !== sourceData));
        else setSourceDatas([
            ...sourceDatas,
            sourceData
        ]);
    };
    const handleRerunAnalysis = ()=>{
        if (sourceDatas.length == 0) {
            setShowResponseNoSources(true);
            return;
        } else setShowResponseNoSources(false);
        setShowConfirmationModal(true);
        setShowResponseError(false);
        setShowResponseValid(false);
    };
    const confirmRerunAnalysis = ()=>{
        setShowAnalyzing(true);
        analyze({
            sourcedatas: sourceDatas.map((item)=>item.id),
            user: selectedUser
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            !isUserPageOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6ac5b64770364b12$export$2e2bcd8739ae039), {
                updatePage: updatePage
            }),
            isUserPageOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb784e14d145db34$export$2e2bcd8739ae039), {
                selectedUser: selectedUser,
                setIsUserPageOpen: (val)=>setIsUserPageOpen(val),
                updateSourceData: (sourcedata)=>updateSourceData(sourcedata),
                rerunAnalysis: ()=>handleRerunAnalysis(),
                showResponseError: showResponseError,
                showResponseValid: showResponseValid,
                showResponseNoSources: showResponseNoSources,
                showAnalyzing: showAnalyzing
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $b1b81586258b47fb$export$2b77a92f1a5ad772), {
                opened: showConfirmationModal,
                onClose: close,
                title: "Confirm Analysis",
                withCloseButton: false,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                        mb: 5,
                        children: [
                            " ",
                            "Are you sure you want to analyze these source datas for",
                            " ",
                            selectedUser?.username,
                            "?"
                        ]
                    }),
                    sourceDatas.map((sourceData)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                            size: "xs",
                            fw: 500,
                            children: [
                                "- ",
                                sourceData.s3_path
                            ]
                        }, sourceData.id)),
                    !showAnalyzing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4), {
                        justify: "space-between",
                        mt: 5,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                                onClick: ()=>setShowConfirmationModal(false),
                                color: "red",
                                children: "No"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                                onClick: confirmRerunAnalysis,
                                color: "blue",
                                children: "Yes"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $8c693ecbbd0b36db$export$2e2bcd8739ae039 = $8c693ecbbd0b36db$var$OperationsManager;



const $8b294e964c12237c$var$headerStyles = (opened)=>({
        width: opened ? "calc(100% - 620px)" : "100%",
        transition: "width 0.1s ease-in-out"
    });
const $8b294e964c12237c$var$mainStyles = (opened)=>({
        width: opened ? "calc(100% - 620px)" : "100%",
        transition: "width 0.1s ease-in-out"
    });
const $8b294e964c12237c$var$Home = ()=>{
    const user = (0, $1861b69a0d0c7fdf$export$68dae0b0cacaa18a)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [panelNumber, setPanelNumber] = (0, $acw62.useState)(0);
    const [isEditing, setisEditing] = (0, $acw62.useState)(false);
    const [firstOpen, setFirstOpen] = (0, $acw62.useState)(true);
    const [isStaffUser, setIsStaffUser] = (0, $acw62.useState)(false);
    const updateIsEditing = ()=>{
        setisEditing(!isEditing);
    };
    const [mobileOpened, { toggle: toggleMobile }] = (0, $f8988135042e9951$export$6e3e27031a30522f)();
    (0, $acw62.useEffect)(()=>{
        if (panelNumber !== 0) setFirstOpen(false);
    }, [
        panelNumber
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!user.isLoading && !user.isSuccess) navigate("/login");
        if (!user.isLoading && user.isSuccess && user?.data[0]?.is_staff) setIsStaffUser(true);
    }, [
        user
    ]);
    const handlePanelChange = (newPanelNumber)=>{
        if (newPanelNumber === 0 && panelNumber !== 0) setisEditing(false);
        setPanelNumber(newPanelNumber);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $dc95f0b8bd3f9327$export$2afed54d6b7d68d9), {
        header: {
            height: 60
        },
        navbar: {
            width: 250,
            breakpoint: "sm",
            collapsed: {
                mobile: !mobileOpened
            }
        },
        padding: "md",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dc95f0b8bd3f9327$export$2afed54d6b7d68d9).Header, {
                style: $8b294e964c12237c$var$headerStyles(),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e9bd92b954fbb741$export$2e2bcd8739ae039), {
                    user: user,
                    mobileOpened: mobileOpened,
                    toggleMobile: toggleMobile
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dc95f0b8bd3f9327$export$2afed54d6b7d68d9).Navbar, {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $01c485f3d0343c1a$export$2e2bcd8739ae039), {
                    handlePanelChange: handlePanelChange,
                    panelNumber: panelNumber,
                    isStaffUser: isStaffUser
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $dc95f0b8bd3f9327$export$2afed54d6b7d68d9).Main, {
                style: $8b294e964c12237c$var$mainStyles(),
                children: [
                    panelNumber === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $444b5dceb35062a9$export$2e2bcd8739ae039), {
                        setShowChatLogo: updateIsEditing,
                        firstOpen: firstOpen,
                        setFirstOpen: (value)=>setFirstOpen(value)
                    }),
                    panelNumber === 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8fe923f6c9c50d38$export$2e2bcd8739ae039), {}),
                    panelNumber === 2 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e5414662e62ed3b8$export$2e2bcd8739ae039), {}),
                    panelNumber === 3 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                    panelNumber === 4 && isStaffUser && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8c693ecbbd0b36db$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
};
var $8b294e964c12237c$export$2e2bcd8739ae039 = $8b294e964c12237c$var$Home;



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
"use client";
const $91f3c5e1e7069c36$export$f33d260505b4b38f = ({ reveal: reveal })=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            width: "var(--psi-icon-size)",
            height: "var(--psi-icon-size)"
        }
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: reveal ? "M13.3536 2.35355C13.5488 2.15829 13.5488 1.84171 13.3536 1.64645C13.1583 1.45118 12.8417 1.45118 12.6464 1.64645L10.6828 3.61012C9.70652 3.21671 8.63759 3 7.5 3C4.30786 3 1.65639 4.70638 0.0760002 7.23501C-0.0253338 7.39715 -0.0253334 7.60288 0.0760014 7.76501C0.902945 9.08812 2.02314 10.1861 3.36061 10.9323L1.64645 12.6464C1.45118 12.8417 1.45118 13.1583 1.64645 13.3536C1.84171 13.5488 2.15829 13.5488 2.35355 13.3536L4.31723 11.3899C5.29348 11.7833 6.36241 12 7.5 12C10.6921 12 13.3436 10.2936 14.924 7.76501C15.0253 7.60288 15.0253 7.39715 14.924 7.23501C14.0971 5.9119 12.9769 4.81391 11.6394 4.06771L13.3536 2.35355ZM9.90428 4.38861C9.15332 4.1361 8.34759 4 7.5 4C4.80285 4 2.52952 5.37816 1.09622 7.50001C1.87284 8.6497 2.89609 9.58106 4.09974 10.1931L9.90428 4.38861ZM5.09572 10.6114L10.9003 4.80685C12.1039 5.41894 13.1272 6.35031 13.9038 7.50001C12.4705 9.62183 10.1971 11 7.5 11C6.65241 11 5.84668 10.8639 5.09572 10.6114Z" : "M7.5 11C4.80285 11 2.52952 9.62184 1.09622 7.50001C2.52952 5.37816 4.80285 4 7.5 4C10.1971 4 12.4705 5.37816 13.9038 7.50001C12.4705 9.62183 10.1971 11 7.5 11ZM7.5 3C4.30786 3 1.65639 4.70638 0.0760002 7.23501C-0.0253338 7.39715 -0.0253334 7.60288 0.0760014 7.76501C1.65639 10.2936 4.30786 12 7.5 12C10.6921 12 13.3436 10.2936 14.924 7.76501C15.0253 7.60288 15.0253 7.39715 14.924 7.23501C13.3436 4.70638 10.6921 3 7.5 3ZM7.5 9.5C8.60457 9.5 9.5 8.60457 9.5 7.5C9.5 6.39543 8.60457 5.5 7.5 5.5C6.39543 5.5 5.5 6.39543 5.5 7.5C5.5 8.60457 6.39543 9.5 7.5 9.5Z",
        fill: "currentColor",
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));


"use client";
var $b0f2c82d3cd3b81f$var$classes = {
    "root": "m-f61ca620",
    "input": "m-ccf8da4c",
    "innerInput": "m-f2d85dd2",
    "visibilityToggle": "m-b1072d44"
};
var $b0f2c82d3cd3b81f$export$2e2bcd8739ae039 = $b0f2c82d3cd3b81f$var$classes;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
"use client";
var $26a2a5a3efbc7af7$var$classes = {
    "root": "m-8d3f4000",
    "loader": "m-302b9fb1",
    "group": "m-1a0f1b21"
};
var $26a2a5a3efbc7af7$export$2e2bcd8739ae039 = $26a2a5a3efbc7af7$var$classes;








"use client";
var $0d9419fe2f9f5fd3$var$__defProp = Object.defineProperty;
var $0d9419fe2f9f5fd3$var$__defProps = Object.defineProperties;
var $0d9419fe2f9f5fd3$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $0d9419fe2f9f5fd3$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $0d9419fe2f9f5fd3$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $0d9419fe2f9f5fd3$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $0d9419fe2f9f5fd3$var$__defNormalProp = (obj, key, value)=>key in obj ? $0d9419fe2f9f5fd3$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $0d9419fe2f9f5fd3$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($0d9419fe2f9f5fd3$var$__hasOwnProp.call(b, prop)) $0d9419fe2f9f5fd3$var$__defNormalProp(a, prop, b[prop]);
    if ($0d9419fe2f9f5fd3$var$__getOwnPropSymbols) {
        for (var prop of $0d9419fe2f9f5fd3$var$__getOwnPropSymbols(b))if ($0d9419fe2f9f5fd3$var$__propIsEnum.call(b, prop)) $0d9419fe2f9f5fd3$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $0d9419fe2f9f5fd3$var$__spreadProps = (a, b)=>$0d9419fe2f9f5fd3$var$__defProps(a, $0d9419fe2f9f5fd3$var$__getOwnPropDescs(b));
var $0d9419fe2f9f5fd3$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($0d9419fe2f9f5fd3$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $0d9419fe2f9f5fd3$var$__getOwnPropSymbols) {
        for (var prop of $0d9419fe2f9f5fd3$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $0d9419fe2f9f5fd3$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $0d9419fe2f9f5fd3$var$defaultProps = {
    orientation: "horizontal"
};
const $0d9419fe2f9f5fd3$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((_, { borderWidth: borderWidth })=>({
        group: {
            "--ai-border-width": (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(borderWidth)
        }
    }));
const $0d9419fe2f9f5fd3$export$e0bcefd5d6a90b2f = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("ActionIconGroup", $0d9419fe2f9f5fd3$var$defaultProps, _props);
    const _a = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("ActionIconGroup", $0d9419fe2f9f5fd3$var$defaultProps, _props), { className: className, style: style, classNames: classNames, styles: styles, unstyled: unstyled, orientation: orientation, vars: vars, borderWidth: borderWidth, variant: variant } = _a, others = $0d9419fe2f9f5fd3$var$__objRest(_a, [
        "className",
        "style",
        "classNames",
        "styles",
        "unstyled",
        "orientation",
        "vars",
        "borderWidth",
        "variant"
    ]);
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: "ActionIconGroup",
        props: props,
        classes: $26a2a5a3efbc7af7$export$2e2bcd8739ae039,
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        vars: vars,
        varsResolver: $0d9419fe2f9f5fd3$var$varsResolver,
        rootSelector: "group"
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $0d9419fe2f9f5fd3$var$__spreadValues($0d9419fe2f9f5fd3$var$__spreadProps($0d9419fe2f9f5fd3$var$__spreadValues({}, getStyles("group")), {
        ref: ref,
        variant: variant,
        mod: {
            "data-orientation": orientation
        },
        role: "group"
    }), others));
});
$0d9419fe2f9f5fd3$export$e0bcefd5d6a90b2f.classes = (0, $26a2a5a3efbc7af7$export$2e2bcd8739ae039);
$0d9419fe2f9f5fd3$export$e0bcefd5d6a90b2f.displayName = "@mantine/core/ActionIconGroup";










"use client";
var $5eeb3c9a10486755$var$__defProp = Object.defineProperty;
var $5eeb3c9a10486755$var$__defProps = Object.defineProperties;
var $5eeb3c9a10486755$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $5eeb3c9a10486755$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $5eeb3c9a10486755$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $5eeb3c9a10486755$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $5eeb3c9a10486755$var$__defNormalProp = (obj, key, value)=>key in obj ? $5eeb3c9a10486755$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $5eeb3c9a10486755$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($5eeb3c9a10486755$var$__hasOwnProp.call(b, prop)) $5eeb3c9a10486755$var$__defNormalProp(a, prop, b[prop]);
    if ($5eeb3c9a10486755$var$__getOwnPropSymbols) {
        for (var prop of $5eeb3c9a10486755$var$__getOwnPropSymbols(b))if ($5eeb3c9a10486755$var$__propIsEnum.call(b, prop)) $5eeb3c9a10486755$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $5eeb3c9a10486755$var$__spreadProps = (a, b)=>$5eeb3c9a10486755$var$__defProps(a, $5eeb3c9a10486755$var$__getOwnPropDescs(b));
var $5eeb3c9a10486755$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($5eeb3c9a10486755$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $5eeb3c9a10486755$var$__getOwnPropSymbols) {
        for (var prop of $5eeb3c9a10486755$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $5eeb3c9a10486755$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $5eeb3c9a10486755$var$defaultProps = {};
const $5eeb3c9a10486755$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((theme, { size: size, radius: radius, variant: variant, gradient: gradient, color: color })=>{
    const colors = theme.variantColorResolver({
        color: color || theme.primaryColor,
        theme: theme,
        gradient: gradient,
        variant: variant || "filled"
    });
    return {
        root: {
            "--ai-size": (0, $fcab4af601ce7e99$export$31b21d0167753bb4)(size, "ai-size"),
            "--ai-radius": radius === void 0 ? void 0 : (0, $fcab4af601ce7e99$export$35724d9c2979edc5)(radius),
            "--ai-bg": color || variant ? colors.background : void 0,
            "--ai-hover": color || variant ? colors.hover : void 0,
            "--ai-color": color || variant ? colors.color : void 0,
            "--ai-bd": color || variant ? colors.border : void 0
        }
    };
});
const $5eeb3c9a10486755$export$c8e5c1392561c508 = (0, $dfead8eb7283bc39$export$197bdd704df40a29)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("ActionIcon", $5eeb3c9a10486755$var$defaultProps, _props);
    const _a = props, { className: className, unstyled: unstyled, variant: variant, classNames: classNames, styles: styles, style: style, loading: loading, loaderProps: loaderProps, size: size, color: color, radius: radius, __staticSelector: __staticSelector, gradient: gradient, vars: vars, children: children, disabled: disabled, "data-disabled": dataDisabled } = _a, others = $5eeb3c9a10486755$var$__objRest(_a, [
        "className",
        "unstyled",
        "variant",
        "classNames",
        "styles",
        "style",
        "loading",
        "loaderProps",
        "size",
        "color",
        "radius",
        "__staticSelector",
        "gradient",
        "vars",
        "children",
        "disabled",
        "data-disabled"
    ]);
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: [
            "ActionIcon",
            __staticSelector
        ],
        props: props,
        className: className,
        style: style,
        classes: $26a2a5a3efbc7af7$export$2e2bcd8739ae039,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        vars: vars,
        varsResolver: $5eeb3c9a10486755$var$varsResolver
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b9babe59f8fa61e8$export$3167f6ecaaaa3457), $5eeb3c9a10486755$var$__spreadProps($5eeb3c9a10486755$var$__spreadValues($5eeb3c9a10486755$var$__spreadValues({}, getStyles("root", {
        active: !disabled && !loading && !dataDisabled
    })), others), {
        unstyled: unstyled,
        variant: variant,
        size: size,
        disabled: disabled || loading,
        ref: ref,
        mod: {
            loading: loading,
            disabled: disabled || dataDisabled
        }
    }), loading ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f943dfe4129424c6$export$3b0d6d7590275603), $5eeb3c9a10486755$var$__spreadValues($5eeb3c9a10486755$var$__spreadProps($5eeb3c9a10486755$var$__spreadValues({}, getStyles("loader")), {
        color: "var(--ai-color)",
        size: "calc(var(--ai-size) * 0.55)"
    }), loaderProps)) : children);
});
$5eeb3c9a10486755$export$c8e5c1392561c508.classes = (0, $26a2a5a3efbc7af7$export$2e2bcd8739ae039);
$5eeb3c9a10486755$export$c8e5c1392561c508.displayName = "@mantine/core/ActionIcon";
$5eeb3c9a10486755$export$c8e5c1392561c508.Group = (0, $0d9419fe2f9f5fd3$export$e0bcefd5d6a90b2f);











"use client";
var $3c023900663954b7$var$__defProp = Object.defineProperty;
var $3c023900663954b7$var$__defProps = Object.defineProperties;
var $3c023900663954b7$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $3c023900663954b7$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $3c023900663954b7$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $3c023900663954b7$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $3c023900663954b7$var$__defNormalProp = (obj, key, value)=>key in obj ? $3c023900663954b7$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $3c023900663954b7$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($3c023900663954b7$var$__hasOwnProp.call(b, prop)) $3c023900663954b7$var$__defNormalProp(a, prop, b[prop]);
    if ($3c023900663954b7$var$__getOwnPropSymbols) {
        for (var prop of $3c023900663954b7$var$__getOwnPropSymbols(b))if ($3c023900663954b7$var$__propIsEnum.call(b, prop)) $3c023900663954b7$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $3c023900663954b7$var$__spreadProps = (a, b)=>$3c023900663954b7$var$__defProps(a, $3c023900663954b7$var$__getOwnPropDescs(b));
var $3c023900663954b7$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($3c023900663954b7$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $3c023900663954b7$var$__getOwnPropSymbols) {
        for (var prop of $3c023900663954b7$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $3c023900663954b7$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $3c023900663954b7$var$defaultProps = {
    __staticSelector: "PasswordInput",
    visibilityToggleIcon: (0, $91f3c5e1e7069c36$export$f33d260505b4b38f)
};
const $3c023900663954b7$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((_, { size: size })=>({
        root: {
            "--psi-icon-size": (0, $fcab4af601ce7e99$export$31b21d0167753bb4)(size, "psi-icon-size"),
            "--psi-button-size": (0, $fcab4af601ce7e99$export$31b21d0167753bb4)(size, "psi-button-size")
        }
    }));
const $3c023900663954b7$export$b28585a458fee016 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("PasswordInput", $3c023900663954b7$var$defaultProps, _props);
    const _a = props, { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, vars: vars, required: required, error: error, leftSection: leftSection, disabled: disabled, id: id, variant: variant, inputContainer: inputContainer, description: description, label: label, size: size, __staticSelector: __staticSelector, errorProps: errorProps, descriptionProps: descriptionProps, labelProps: labelProps, withAsterisk: withAsterisk, inputWrapperOrder: inputWrapperOrder, wrapperProps: wrapperProps, radius: radius, rightSection: rightSection, rightSectionWidth: rightSectionWidth, leftSectionWidth: leftSectionWidth, visible: visible, defaultVisible: defaultVisible, onVisibilityChange: onVisibilityChange, visibilityToggleIcon: visibilityToggleIcon, visibilityToggleButtonProps: visibilityToggleButtonProps, rightSectionProps: rightSectionProps, leftSectionProps: leftSectionProps, leftSectionPointerEvents: leftSectionPointerEvents } = _a, others = $3c023900663954b7$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "required",
        "error",
        "leftSection",
        "disabled",
        "id",
        "variant",
        "inputContainer",
        "description",
        "label",
        "size",
        "__staticSelector",
        "errorProps",
        "descriptionProps",
        "labelProps",
        "withAsterisk",
        "inputWrapperOrder",
        "wrapperProps",
        "radius",
        "rightSection",
        "rightSectionWidth",
        "leftSectionWidth",
        "visible",
        "defaultVisible",
        "onVisibilityChange",
        "visibilityToggleIcon",
        "visibilityToggleButtonProps",
        "rightSectionProps",
        "leftSectionProps",
        "leftSectionPointerEvents"
    ]);
    const uuid = (0, $cee42e5537afff93$export$f680877a34711e37)(id);
    const [_visible, setVisibility] = (0, $4197894a742d9f84$export$ec55e9daaf703a7d)({
        value: visible,
        defaultValue: defaultVisible,
        finalValue: false,
        onChange: onVisibilityChange
    });
    const toggleVisibility = ()=>setVisibility(!_visible);
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: "PasswordInput",
        classes: $b0f2c82d3cd3b81f$export$2e2bcd8739ae039,
        props: props,
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        vars: vars,
        varsResolver: $3c023900663954b7$var$varsResolver
    });
    const { resolvedClassNames: resolvedClassNames, resolvedStyles: resolvedStyles } = (0, $3da94ce37793f66c$export$92dc9b0c0bd35ec0)({
        classNames: classNames,
        styles: styles,
        props: props
    });
    const { styleProps: styleProps, rest: rest } = (0, $2e4262c949ef0e61$export$fbc67becbdd26fbf)(others);
    const VisibilityToggleIcon = visibilityToggleIcon;
    const visibilityToggleButton = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5eeb3c9a10486755$export$c8e5c1392561c508), $3c023900663954b7$var$__spreadProps($3c023900663954b7$var$__spreadValues($3c023900663954b7$var$__spreadProps($3c023900663954b7$var$__spreadValues({}, getStyles("visibilityToggle")), {
        radius: radius,
        "aria-hidden": !visibilityToggleButtonProps,
        tabIndex: -1
    }), visibilityToggleButtonProps), {
        variant: "subtle",
        color: "gray",
        unstyled: unstyled,
        onMouseDown: (event)=>{
            var _a2;
            event.preventDefault();
            (_a2 = visibilityToggleButtonProps == null ? void 0 : visibilityToggleButtonProps.onMouseDown) == null || _a2.call(visibilityToggleButtonProps, event);
            toggleVisibility();
        },
        onKeyDown: (event)=>{
            var _a2;
            (_a2 = visibilityToggleButtonProps == null ? void 0 : visibilityToggleButtonProps.onKeyDown) == null || _a2.call(visibilityToggleButtonProps, event);
            if (event.key === " ") {
                event.preventDefault();
                toggleVisibility();
            }
        }
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(VisibilityToggleIcon, {
        reveal: _visible
    }));
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e2e9ff0d29bd408f$export$f5b8910cec6cf069).Wrapper, $3c023900663954b7$var$__spreadValues($3c023900663954b7$var$__spreadValues($3c023900663954b7$var$__spreadValues({
        required: required,
        id: uuid,
        label: label,
        error: error,
        description: description,
        size: size,
        classNames: resolvedClassNames,
        styles: resolvedStyles,
        __staticSelector: __staticSelector,
        errorProps: errorProps,
        descriptionProps: descriptionProps,
        unstyled: unstyled,
        withAsterisk: withAsterisk,
        inputWrapperOrder: inputWrapperOrder,
        inputContainer: inputContainer,
        variant: variant,
        labelProps: $3c023900663954b7$var$__spreadProps($3c023900663954b7$var$__spreadValues({}, labelProps), {
            htmlFor: uuid
        })
    }, getStyles("root")), styleProps), wrapperProps), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e2e9ff0d29bd408f$export$f5b8910cec6cf069), {
        component: "div",
        error: error,
        leftSection: leftSection,
        size: size,
        classNames: $3c023900663954b7$var$__spreadProps($3c023900663954b7$var$__spreadValues({}, resolvedClassNames), {
            input: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)((0, $b0f2c82d3cd3b81f$export$2e2bcd8739ae039).input, resolvedClassNames.input)
        }),
        styles: resolvedStyles,
        radius: radius,
        disabled: disabled,
        __staticSelector: __staticSelector,
        rightSectionWidth: rightSectionWidth,
        rightSection: rightSection != null ? rightSection : visibilityToggleButton,
        variant: variant,
        unstyled: unstyled,
        leftSectionWidth: leftSectionWidth,
        rightSectionPointerEvents: "all",
        rightSectionProps: rightSectionProps,
        leftSectionProps: leftSectionProps,
        leftSectionPointerEvents: leftSectionPointerEvents,
        withAria: false
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", $3c023900663954b7$var$__spreadProps($3c023900663954b7$var$__spreadValues($3c023900663954b7$var$__spreadProps($3c023900663954b7$var$__spreadValues({
        required: required,
        "data-invalid": !!error || void 0,
        "data-with-left-section": !!leftSection || void 0
    }, getStyles("innerInput")), {
        disabled: disabled,
        id: uuid,
        ref: ref
    }), rest), {
        autoComplete: rest.autoComplete || "off",
        type: _visible ? "text" : "password"
    }))));
});
$3c023900663954b7$export$b28585a458fee016.classes = $3c023900663954b7$var$__spreadValues($3c023900663954b7$var$__spreadValues({}, (0, $ebdc9ebef4cbe70e$export$36eab7f492831059).classes), (0, $b0f2c82d3cd3b81f$export$2e2bcd8739ae039));
$3c023900663954b7$export$b28585a458fee016.displayName = "@mantine/core/PasswordInput";



var $acw62 = parcelRequire("acw62");
var $54da56340462fe8a$exports = {};
"use strict";
// do not edit .js files directly - edit src/index.jst
$54da56340462fe8a$exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};


"use client";
function $050f52ec202b2dd6$export$6b61e0ca48e4cc51(setValue) {
    return (val)=>{
        if (!val) setValue(val);
        else if (typeof val === "function") setValue(val);
        else if (typeof val === "object" && "nativeEvent" in val) {
            const { currentTarget: currentTarget } = val;
            if (currentTarget instanceof HTMLInputElement) {
                if (currentTarget.type === "checkbox") setValue(currentTarget.checked);
                else setValue(currentTarget.value);
            } else if (currentTarget instanceof HTMLTextAreaElement || currentTarget instanceof HTMLSelectElement) setValue(currentTarget.value);
        } else setValue(val);
    };
}


"use client";
function $fb6d8477f832b098$export$adb32d9701ab5642(path) {
    if (typeof path !== "string") return [];
    return path.split(".");
}


"use client";
function $01782b034c263e96$export$2aa3fd96c49a84a8(path, values) {
    const splittedPath = (0, $fb6d8477f832b098$export$adb32d9701ab5642)(path);
    if (splittedPath.length === 0 || typeof values !== "object" || values === null) return void 0;
    let value = values[splittedPath[0]];
    for(let i = 1; i < splittedPath.length; i += 1){
        if (value === void 0) break;
        value = value[splittedPath[i]];
    }
    return value;
}


function $fd8254fed3b816be$var$set(obj, key, val) {
    if (typeof val.value === "object") val.value = $fd8254fed3b816be$export$a963eb2bdf550004(val.value);
    if (!val.enumerable || val.get || val.set || !val.configurable || !val.writable || key === "__proto__") Object.defineProperty(obj, key, val);
    else obj[key] = val.value;
}
function $fd8254fed3b816be$export$a963eb2bdf550004(x) {
    if (typeof x !== "object") return x;
    var i = 0, k, list, tmp, str = Object.prototype.toString.call(x);
    if (str === "[object Object]") tmp = Object.create(x.__proto__ || null);
    else if (str === "[object Array]") tmp = Array(x.length);
    else if (str === "[object Set]") {
        tmp = new Set;
        x.forEach(function(val) {
            tmp.add($fd8254fed3b816be$export$a963eb2bdf550004(val));
        });
    } else if (str === "[object Map]") {
        tmp = new Map;
        x.forEach(function(val, key) {
            tmp.set($fd8254fed3b816be$export$a963eb2bdf550004(key), $fd8254fed3b816be$export$a963eb2bdf550004(val));
        });
    } else if (str === "[object Date]") tmp = new Date(+x);
    else if (str === "[object RegExp]") tmp = new RegExp(x.source, x.flags);
    else if (str === "[object DataView]") tmp = new x.constructor($fd8254fed3b816be$export$a963eb2bdf550004(x.buffer));
    else if (str === "[object ArrayBuffer]") tmp = x.slice(0);
    else if (str.slice(-6) === "Array]") // ArrayBuffer.isView(x)
    // ~> `new` bcuz `Buffer.slice` => ref
    tmp = new x.constructor(x);
    if (tmp) {
        for(list = Object.getOwnPropertySymbols(x); i < list.length; i++)$fd8254fed3b816be$var$set(tmp, list[i], Object.getOwnPropertyDescriptor(x, list[i]));
        for(i = 0, list = Object.getOwnPropertyNames(x); i < list.length; i++){
            if (Object.hasOwnProperty.call(tmp, k = list[i]) && tmp[k] === x[k]) continue;
            $fd8254fed3b816be$var$set(tmp, k, Object.getOwnPropertyDescriptor(x, k));
        }
    }
    return tmp || x;
}



"use client";
function $08c02c46e9ebb639$export$1518ffc4a8ff94f2(path, value, values) {
    const splittedPath = (0, $fb6d8477f832b098$export$adb32d9701ab5642)(path);
    if (splittedPath.length === 0) return values;
    const cloned = (0, $fd8254fed3b816be$export$a963eb2bdf550004)(values);
    if (splittedPath.length === 1) {
        cloned[splittedPath[0]] = value;
        return cloned;
    }
    let val = cloned[splittedPath[0]];
    for(let i = 1; i < splittedPath.length - 1; i += 1){
        if (val === void 0) return cloned;
        val = val[splittedPath[i]];
    }
    val[splittedPath[splittedPath.length - 1]] = value;
    return cloned;
}




"use client";
function $683a62f1d1d5ece9$export$f20b96e0c356d4c0(path, { from: from, to: to }, values) {
    const currentValue = (0, $01782b034c263e96$export$2aa3fd96c49a84a8)(path, values);
    if (!Array.isArray(currentValue)) return values;
    const cloned = [
        ...currentValue
    ];
    const item = currentValue[from];
    cloned.splice(from, 1);
    cloned.splice(to, 0, item);
    return (0, $08c02c46e9ebb639$export$1518ffc4a8ff94f2)(path, cloned, values);
}




"use client";
function $55f49881a9e76f3c$export$b3bad8010921a684(path, value, index, values) {
    const currentValue = (0, $01782b034c263e96$export$2aa3fd96c49a84a8)(path, values);
    if (!Array.isArray(currentValue)) return values;
    const cloned = [
        ...currentValue
    ];
    cloned.splice(typeof index === "number" ? index : cloned.length, 0, value);
    return (0, $08c02c46e9ebb639$export$1518ffc4a8ff94f2)(path, cloned, values);
}




"use client";
function $6d6597f633c8fd1e$export$5c4e774b0e27d36b(path, index, values) {
    const currentValue = (0, $01782b034c263e96$export$2aa3fd96c49a84a8)(path, values);
    if (!Array.isArray(currentValue)) return values;
    return (0, $08c02c46e9ebb639$export$1518ffc4a8ff94f2)(path, currentValue.filter((_, itemIndex)=>itemIndex !== index), values);
}


"use client";
function $80e3dc3fafdbf810$export$50c01357805887bf(errors) {
    if (errors === null || typeof errors !== "object") return {};
    return Object.keys(errors).reduce((acc, key)=>{
        const errorValue = errors[key];
        if (errorValue !== void 0 && errorValue !== null && errorValue !== false) acc[key] = errorValue;
        return acc;
    }, {});
}





"use client";
function $5550236fbd9c2f02$var$getValidationResults(errors) {
    const filteredErrors = (0, $80e3dc3fafdbf810$export$50c01357805887bf)(errors);
    return {
        hasErrors: Object.keys(filteredErrors).length > 0,
        errors: filteredErrors
    };
}
function $5550236fbd9c2f02$var$validateRulesRecord(rules, values, path = "", errors = {}) {
    if (typeof rules !== "object" || rules === null) return errors;
    return Object.keys(rules).reduce((acc, ruleKey)=>{
        const rule = rules[ruleKey];
        const rulePath = `${path === "" ? "" : `${path}.`}${ruleKey}`;
        const value = (0, $01782b034c263e96$export$2aa3fd96c49a84a8)(rulePath, values);
        let arrayValidation = false;
        if (typeof rule === "function") acc[rulePath] = rule(value, values, rulePath);
        if (typeof rule === "object" && Array.isArray(value)) {
            arrayValidation = true;
            value.forEach((_item, index)=>$5550236fbd9c2f02$var$validateRulesRecord(rule, values, `${rulePath}.${index}`, acc));
        }
        if (typeof rule === "object" && typeof value === "object" && value !== null) {
            if (!arrayValidation) $5550236fbd9c2f02$var$validateRulesRecord(rule, values, rulePath, acc);
        }
        return acc;
    }, errors);
}
function $5550236fbd9c2f02$export$2d64a4bedfb714a9(validate, values) {
    if (typeof validate === "function") return $5550236fbd9c2f02$var$getValidationResults(validate(values));
    return $5550236fbd9c2f02$var$getValidationResults($5550236fbd9c2f02$var$validateRulesRecord(validate, values));
}



"use client";
function $3f6f8726c711eef9$export$ffdb9de87c39ed82(path, rules, values) {
    if (typeof path !== "string") return {
        hasError: false,
        error: null
    };
    const results = (0, $5550236fbd9c2f02$export$2d64a4bedfb714a9)(rules, values);
    const pathInError = Object.keys(results.errors).find((errorKey)=>path.split(".").every((pathPart, i)=>pathPart === errorKey.split(".")[i]));
    return {
        hasError: !!pathInError,
        error: pathInError ? results.errors[pathInError] : null
    };
}


"use client";
const $a5b647c769706a64$export$e078f86f56537ccb = "__MANTINE_FORM_INDEX__";


"use client";
function $a576141ab26bb791$export$34266bfc4c1c4a91(path, validateInputOnChange) {
    if (!validateInputOnChange) return false;
    if (typeof validateInputOnChange === "boolean") return validateInputOnChange;
    if (Array.isArray(validateInputOnChange)) return validateInputOnChange.includes(path.replace(/[.][0-9]/g, `.${(0, $a5b647c769706a64$export$e078f86f56537ccb)}`));
    return false;
}


"use client";
function $c281fa36805436b8$export$b70265791d2079d4(status, path) {
    const paths = Object.keys(status);
    if (typeof path === "string") {
        const nestedPaths = paths.filter((statusPath)=>statusPath.startsWith(`${path}.`));
        return status[path] || nestedPaths.some((statusPath)=>status[statusPath]) || false;
    }
    return paths.some((statusPath)=>status[statusPath]);
}


"use client";
function $88cc1c010d770688$export$dcb7f82c6790c936(field, state) {
    if (state === null || typeof state !== "object") return {};
    const clone = {
        ...state
    };
    Object.keys(state).forEach((errorKey)=>{
        if (errorKey.includes(`${String(field)}.`)) delete clone[errorKey];
    });
    return clone;
}



"use client";
function $597c338b0fa7061b$var$getIndexFromKeyAfterPath(key, path) {
    const split = key.substring(path.length + 1).split(".")[0];
    return parseInt(split, 10);
}
function $597c338b0fa7061b$export$ba2d26425e4eb134(path, index, errors, change) {
    if (index === void 0) return errors;
    const pathString = `${String(path)}`;
    let clearedErrors = errors;
    if (change === -1) clearedErrors = (0, $88cc1c010d770688$export$dcb7f82c6790c936)(`${pathString}.${index}`, clearedErrors);
    const cloned = {
        ...clearedErrors
    };
    const changedKeys = /* @__PURE__ */ new Set();
    Object.entries(clearedErrors).filter(([key])=>{
        if (!key.startsWith(`${pathString}.`)) return false;
        const currIndex = $597c338b0fa7061b$var$getIndexFromKeyAfterPath(key, pathString);
        if (Number.isNaN(currIndex)) return false;
        return currIndex >= index;
    }).forEach(([key, value])=>{
        const currIndex = $597c338b0fa7061b$var$getIndexFromKeyAfterPath(key, pathString);
        const newKey = key.replace(`${pathString}.${currIndex}`, `${pathString}.${currIndex + change}`);
        cloned[newKey] = value;
        changedKeys.add(newKey);
        if (!changedKeys.has(key)) delete cloned[key];
    });
    return cloned;
}


"use client";
function $0e38273e00058696$export$4c6f820938a962f6(path, { from: from, to: to }, errors) {
    const oldKeyStart = `${path}.${from}`;
    const newKeyStart = `${path}.${to}`;
    const clone = {
        ...errors
    };
    Object.keys(errors).every((key)=>{
        let oldKey;
        let newKey;
        if (key.startsWith(oldKeyStart)) {
            oldKey = key;
            newKey = key.replace(oldKeyStart, newKeyStart);
        }
        if (key.startsWith(newKeyStart)) {
            oldKey = key.replace(newKeyStart, oldKeyStart);
            newKey = key;
        }
        if (oldKey && newKey) {
            const value1 = clone[oldKey];
            const value2 = clone[newKey];
            value2 === void 0 ? delete clone[oldKey] : clone[oldKey] = value2;
            value1 === void 0 ? delete clone[newKey] : clone[newKey] = value1;
            return false;
        }
        return true;
    });
    return clone;
}



var $acw62 = parcelRequire("acw62");
"use client";
function $80d4563552714773$var$dispatchEvent(type, detail) {
    window.dispatchEvent(new CustomEvent(type, {
        detail: detail
    }));
}
function $80d4563552714773$var$validateFormName(name) {
    if (!/^[0-9a-zA-Z-]+$/.test(name)) throw new Error(`[@mantine/use-form] Form name "${name}" is invalid, it should contain only letters, numbers and dashes`);
}
const $80d4563552714773$export$363c9f3eb56bbdbe = typeof window !== "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
function $80d4563552714773$export$de74bf749910319(name) {
    $80d4563552714773$var$validateFormName(name);
    const setFieldValue = (path, value)=>$80d4563552714773$var$dispatchEvent(`mantine-form:${name}:set-field-value`, {
            path: path,
            value: value
        });
    const setValues = (values)=>$80d4563552714773$var$dispatchEvent(`mantine-form:${name}:set-values`, values);
    const setInitialValues = (values)=>$80d4563552714773$var$dispatchEvent(`mantine-form:${name}:set-initial-values`, values);
    const setErrors = (errors)=>$80d4563552714773$var$dispatchEvent(`mantine-form:${name}:set-errors`, errors);
    const setFieldError = (path, error)=>$80d4563552714773$var$dispatchEvent(`mantine-form:${name}:set-field-error`, {
            path: path,
            error: error
        });
    const clearFieldError = (path)=>$80d4563552714773$var$dispatchEvent(`mantine-form:${name}:clear-field-error`, path);
    const clearErrors = ()=>$80d4563552714773$var$dispatchEvent(`mantine-form:${name}:clear-errors`);
    const reset = ()=>$80d4563552714773$var$dispatchEvent(`mantine-form:${name}:reset`);
    const validate = ()=>$80d4563552714773$var$dispatchEvent(`mantine-form:${name}:validate`);
    const validateField = (path)=>$80d4563552714773$var$dispatchEvent(`mantine-form:${name}:validate-field`, path);
    const reorderListItem = (path, payload)=>$80d4563552714773$var$dispatchEvent(`mantine-form:${name}:reorder-list-item`, {
            path: path,
            payload: payload
        });
    const removeListItem = (path, index)=>$80d4563552714773$var$dispatchEvent(`mantine-form:${name}:remove-list-item`, {
            path: path,
            index: index
        });
    const insertListItem = (path, item, index)=>$80d4563552714773$var$dispatchEvent(`mantine-form:${name}:insert-list-item`, {
            path: path,
            index: index,
            item: item
        });
    const setDirty = (value)=>$80d4563552714773$var$dispatchEvent(`mantine-form:${name}:set-dirty`, value);
    const setTouched = (value)=>$80d4563552714773$var$dispatchEvent(`mantine-form:${name}:set-touched`, value);
    const resetDirty = (values)=>$80d4563552714773$var$dispatchEvent(`mantine-form:${name}:reset-dirty`, values);
    const resetTouched = ()=>$80d4563552714773$var$dispatchEvent(`mantine-form:${name}:reset-touched`);
    return {
        setFieldValue: setFieldValue,
        setValues: setValues,
        setInitialValues: setInitialValues,
        setErrors: setErrors,
        setFieldError: setFieldError,
        clearFieldError: clearFieldError,
        clearErrors: clearErrors,
        reset: reset,
        validate: validate,
        validateField: validateField,
        reorderListItem: reorderListItem,
        removeListItem: removeListItem,
        insertListItem: insertListItem,
        setDirty: setDirty,
        setTouched: setTouched,
        resetDirty: resetDirty,
        resetTouched: resetTouched
    };
}
function $80d4563552714773$var$useFormEvent(eventKey, handler) {
    $80d4563552714773$export$363c9f3eb56bbdbe(()=>{
        if (eventKey) {
            window.addEventListener(eventKey, handler);
            return ()=>window.removeEventListener(eventKey, handler);
        }
        return void 0;
    }, [
        eventKey
    ]);
}
function $80d4563552714773$export$77fabb0edba603a8(name, form) {
    if (name) $80d4563552714773$var$validateFormName(name);
    $80d4563552714773$var$useFormEvent(`mantine-form:${name}:set-field-value`, (event)=>form.setFieldValue(event.detail.path, event.detail.value));
    $80d4563552714773$var$useFormEvent(`mantine-form:${name}:set-values`, (event)=>form.setValues(event.detail));
    $80d4563552714773$var$useFormEvent(`mantine-form:${name}:set-initial-values`, (event)=>form.setInitialValues(event.detail));
    $80d4563552714773$var$useFormEvent(`mantine-form:${name}:set-errors`, (event)=>form.setErrors(event.detail));
    $80d4563552714773$var$useFormEvent(`mantine-form:${name}:set-field-error`, (event)=>form.setFieldError(event.detail.path, event.detail.error));
    $80d4563552714773$var$useFormEvent(`mantine-form:${name}:clear-field-error`, (event)=>form.clearFieldError(event.detail));
    $80d4563552714773$var$useFormEvent(`mantine-form:${name}:clear-errors`, form.clearErrors);
    $80d4563552714773$var$useFormEvent(`mantine-form:${name}:reset`, form.reset);
    $80d4563552714773$var$useFormEvent(`mantine-form:${name}:validate`, form.validate);
    $80d4563552714773$var$useFormEvent(`mantine-form:${name}:validate-field`, (event)=>form.validateField(event.detail));
    $80d4563552714773$var$useFormEvent(`mantine-form:${name}:reorder-list-item`, (event)=>form.reorderListItem(event.detail.path, event.detail.payload));
    $80d4563552714773$var$useFormEvent(`mantine-form:${name}:remove-list-item`, (event)=>form.removeListItem(event.detail.path, event.detail.index));
    $80d4563552714773$var$useFormEvent(`mantine-form:${name}:insert-list-item`, (event)=>form.insertListItem(event.detail.path, event.detail.item, event.detail.index));
    $80d4563552714773$var$useFormEvent(`mantine-form:${name}:set-dirty`, (event)=>form.setDirty(event.detail));
    $80d4563552714773$var$useFormEvent(`mantine-form:${name}:set-touched`, (event)=>form.setTouched(event.detail));
    $80d4563552714773$var$useFormEvent(`mantine-form:${name}:reset-dirty`, (event)=>form.resetDirty(event.detail));
    $80d4563552714773$var$useFormEvent(`mantine-form:${name}:reset-touched`, form.resetTouched);
}


"use client";
function $c94d6fa0b3c58098$export$87c0cf8eb5a167e0({ name: name, initialValues: initialValues = {}, initialErrors: initialErrors = {}, initialDirty: initialDirty = {}, initialTouched: initialTouched = {}, clearInputErrorOnChange: clearInputErrorOnChange = true, validateInputOnChange: validateInputOnChange = false, validateInputOnBlur: validateInputOnBlur = false, onValuesChange: onValuesChange, transformValues: transformValues = (values)=>values, validate: rules } = {}) {
    const [touched, setTouched] = (0, $acw62.useState)(initialTouched);
    const [dirty, setDirty] = (0, $acw62.useState)(initialDirty);
    const [values, _setValues] = (0, $acw62.useState)(initialValues);
    const [errors, _setErrors] = (0, $acw62.useState)((0, $80e3dc3fafdbf810$export$50c01357805887bf)(initialErrors));
    const valuesSnapshot = (0, $acw62.useRef)(initialValues);
    const setValuesSnapshot = (_values)=>{
        valuesSnapshot.current = _values;
    };
    const resetTouched = (0, $acw62.useCallback)(()=>setTouched({}), []);
    const resetDirty = (_values)=>{
        const newSnapshot = _values ? {
            ...values,
            ..._values
        } : values;
        setValuesSnapshot(newSnapshot);
        setDirty({});
    };
    const setErrors = (0, $acw62.useCallback)((errs)=>_setErrors((current)=>(0, $80e3dc3fafdbf810$export$50c01357805887bf)(typeof errs === "function" ? errs(current) : errs)), []);
    const clearErrors = (0, $acw62.useCallback)(()=>_setErrors({}), []);
    const reset = (0, $acw62.useCallback)(()=>{
        _setValues(valuesSnapshot.current);
        clearErrors();
        setDirty({});
        resetTouched();
    }, []);
    const setFieldError = (0, $acw62.useCallback)((path, error)=>setErrors((current)=>({
                ...current,
                [path]: error
            })), []);
    const clearFieldError = (0, $acw62.useCallback)((path)=>setErrors((current)=>{
            if (typeof path !== "string") return current;
            const clone = {
                ...current
            };
            delete clone[path];
            return clone;
        }), []);
    const clearFieldDirty = (0, $acw62.useCallback)((path)=>setDirty((current)=>{
            if (typeof path !== "string") return current;
            const result = (0, $88cc1c010d770688$export$dcb7f82c6790c936)(path, current);
            delete result[path];
            return result;
        }), []);
    const setFieldValue = (0, $acw62.useCallback)((path, value)=>{
        const shouldValidate = (0, $a576141ab26bb791$export$34266bfc4c1c4a91)(path, validateInputOnChange);
        clearFieldDirty(path);
        setTouched((currentTouched)=>({
                ...currentTouched,
                [path]: true
            }));
        _setValues((current)=>{
            const result = (0, $08c02c46e9ebb639$export$1518ffc4a8ff94f2)(path, value, current);
            if (shouldValidate) {
                const validationResults = (0, $3f6f8726c711eef9$export$ffdb9de87c39ed82)(path, rules, result);
                validationResults.hasError ? setFieldError(path, validationResults.error) : clearFieldError(path);
            }
            onValuesChange?.(result);
            return result;
        });
        !shouldValidate && clearInputErrorOnChange && setFieldError(path, null);
    }, []);
    const setValues = (0, $acw62.useCallback)((payload)=>{
        _setValues((currentValues)=>{
            const valuesPartial = typeof payload === "function" ? payload(currentValues) : payload;
            const result = {
                ...currentValues,
                ...valuesPartial
            };
            onValuesChange?.(result);
            return result;
        });
        clearInputErrorOnChange && clearErrors();
    }, []);
    const reorderListItem = (0, $acw62.useCallback)((path, payload)=>{
        clearFieldDirty(path);
        _setValues((current)=>{
            const result = (0, $683a62f1d1d5ece9$export$f20b96e0c356d4c0)(path, payload, current);
            onValuesChange?.(result);
            return result;
        });
        _setErrors((errs)=>(0, $0e38273e00058696$export$4c6f820938a962f6)(path, payload, errs));
    }, []);
    const removeListItem = (0, $acw62.useCallback)((path, index)=>{
        clearFieldDirty(path);
        _setValues((current)=>{
            const result = (0, $6d6597f633c8fd1e$export$5c4e774b0e27d36b)(path, index, current);
            onValuesChange?.(result);
            return result;
        });
        _setErrors((errs)=>(0, $597c338b0fa7061b$export$ba2d26425e4eb134)(path, index, errs, -1));
    }, []);
    const insertListItem = (0, $acw62.useCallback)((path, item, index)=>{
        clearFieldDirty(path);
        _setValues((current)=>{
            const result = (0, $55f49881a9e76f3c$export$b3bad8010921a684)(path, item, index, current);
            onValuesChange?.(result);
            return result;
        });
        _setErrors((errs)=>(0, $597c338b0fa7061b$export$ba2d26425e4eb134)(path, index, errs, 1));
    }, []);
    const validate = (0, $acw62.useCallback)(()=>{
        const results = (0, $5550236fbd9c2f02$export$2d64a4bedfb714a9)(rules, values);
        _setErrors(results.errors);
        return results;
    }, [
        values,
        rules
    ]);
    const validateField = (0, $acw62.useCallback)((path)=>{
        const results = (0, $3f6f8726c711eef9$export$ffdb9de87c39ed82)(path, rules, values);
        results.hasError ? setFieldError(path, results.error) : clearFieldError(path);
        return results;
    }, [
        values,
        rules
    ]);
    const getInputProps = (path, { type: type = "input", withError: withError = true, withFocus: withFocus = true } = {})=>{
        const onChange = (0, $050f52ec202b2dd6$export$6b61e0ca48e4cc51)((value)=>setFieldValue(path, value));
        const payload = {
            onChange: onChange
        };
        if (withError) payload.error = errors[path];
        if (type === "checkbox") payload.checked = (0, $01782b034c263e96$export$2aa3fd96c49a84a8)(path, values);
        else payload.value = (0, $01782b034c263e96$export$2aa3fd96c49a84a8)(path, values);
        if (withFocus) {
            payload.onFocus = ()=>setTouched((current)=>({
                        ...current,
                        [path]: true
                    }));
            payload.onBlur = ()=>{
                if ((0, $a576141ab26bb791$export$34266bfc4c1c4a91)(path, validateInputOnBlur)) {
                    const validationResults = (0, $3f6f8726c711eef9$export$ffdb9de87c39ed82)(path, rules, values);
                    validationResults.hasError ? setFieldError(path, validationResults.error) : clearFieldError(path);
                }
            };
        }
        return payload;
    };
    const onSubmit = (handleSubmit, handleValidationFailure)=>(event)=>{
            event?.preventDefault();
            const results = validate();
            if (results.hasErrors) handleValidationFailure?.(results.errors, values, event);
            else handleSubmit?.(transformValues(values), event);
        };
    const getTransformedValues = (input)=>transformValues(input || values);
    const onReset = (0, $acw62.useCallback)((event)=>{
        event.preventDefault();
        reset();
    }, []);
    const isDirty = (path)=>{
        if (path) {
            const overriddenValue = (0, $01782b034c263e96$export$2aa3fd96c49a84a8)(path, dirty);
            if (typeof overriddenValue === "boolean") return overriddenValue;
            const sliceOfValues = (0, $01782b034c263e96$export$2aa3fd96c49a84a8)(path, values);
            const sliceOfInitialValues = (0, $01782b034c263e96$export$2aa3fd96c49a84a8)(path, valuesSnapshot.current);
            return !(0, (/*@__PURE__*/$parcel$interopDefault($54da56340462fe8a$exports)))(sliceOfValues, sliceOfInitialValues);
        }
        const isOverridden = Object.keys(dirty).length > 0;
        if (isOverridden) return (0, $c281fa36805436b8$export$b70265791d2079d4)(dirty);
        return !(0, (/*@__PURE__*/$parcel$interopDefault($54da56340462fe8a$exports)))(values, valuesSnapshot.current);
    };
    const isTouched = (0, $acw62.useCallback)((path)=>(0, $c281fa36805436b8$export$b70265791d2079d4)(touched, path), [
        touched
    ]);
    const isValid = (0, $acw62.useCallback)((path)=>path ? !(0, $3f6f8726c711eef9$export$ffdb9de87c39ed82)(path, rules, values).hasError : !(0, $5550236fbd9c2f02$export$2d64a4bedfb714a9)(rules, values).hasErrors, [
        values,
        rules
    ]);
    const form = {
        values: values,
        errors: errors,
        setValues: setValues,
        setInitialValues: setValuesSnapshot,
        setErrors: setErrors,
        setFieldValue: setFieldValue,
        setFieldError: setFieldError,
        clearFieldError: clearFieldError,
        clearErrors: clearErrors,
        reset: reset,
        validate: validate,
        validateField: validateField,
        reorderListItem: reorderListItem,
        removeListItem: removeListItem,
        insertListItem: insertListItem,
        getInputProps: getInputProps,
        onSubmit: onSubmit,
        onReset: onReset,
        isDirty: isDirty,
        isTouched: isTouched,
        setTouched: setTouched,
        setDirty: setDirty,
        resetTouched: resetTouched,
        resetDirty: resetDirty,
        isValid: isValid,
        getTransformedValues: getTransformedValues
    };
    (0, $80d4563552714773$export$77fabb0edba603a8)(name, form);
    return form;
}



const $553320d33b0a5e36$var$emailRegex = /[-A-Za-z0-9!#$%&'*+/=?^_`{|}~]+(?:\.[-A-Za-z0-9!#$%&'*+/=?^_`{|}~]+)*@(?:[A-Za-z0-9](?:[-A-Za-z0-9]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[-A-Za-z0-9]*[A-Za-z0-9])?/;
const $553320d33b0a5e36$export$18148d12c805c5b0 = (email)=>{
    return $553320d33b0a5e36$var$emailRegex.test(email) ? null : "Invalid email";
};


var $fd882af322e8eaf8$exports = {};




(function() {
    var crypt = (parcelRequire("12eZZ")), utf8 = (parcelRequire("a74v9")).utf8, isBuffer = (parcelRequire("7B5Ea")), bin = (parcelRequire("a74v9")).bin, // The core
    md5 = function(message, options) {
        // Convert to byte array
        if (message.constructor == String) {
            if (options && options.encoding === "binary") message = bin.stringToBytes(message);
            else message = utf8.stringToBytes(message);
        } else if (isBuffer(message)) message = Array.prototype.slice.call(message, 0);
        else if (!Array.isArray(message) && message.constructor !== Uint8Array) message = message.toString();
        // else, assume byte array already
        var m = crypt.bytesToWords(message), l = message.length * 8, a = 1732584193, b = -271733879, c = -1732584194, d = 271733878;
        // Swap endian
        for(var i = 0; i < m.length; i++)m[i] = (m[i] << 8 | m[i] >>> 24) & 0x00FF00FF | (m[i] << 24 | m[i] >>> 8) & 0xFF00FF00;
        // Padding
        m[l >>> 5] |= 0x80 << l % 32;
        m[(l + 64 >>> 9 << 4) + 14] = l;
        // Method shortcuts
        var FF = md5._ff, GG = md5._gg, HH = md5._hh, II = md5._ii;
        for(var i = 0; i < m.length; i += 16){
            var aa = a, bb = b, cc = c, dd = d;
            a = FF(a, b, c, d, m[i + 0], 7, -680876936);
            d = FF(d, a, b, c, m[i + 1], 12, -389564586);
            c = FF(c, d, a, b, m[i + 2], 17, 606105819);
            b = FF(b, c, d, a, m[i + 3], 22, -1044525330);
            a = FF(a, b, c, d, m[i + 4], 7, -176418897);
            d = FF(d, a, b, c, m[i + 5], 12, 1200080426);
            c = FF(c, d, a, b, m[i + 6], 17, -1473231341);
            b = FF(b, c, d, a, m[i + 7], 22, -45705983);
            a = FF(a, b, c, d, m[i + 8], 7, 1770035416);
            d = FF(d, a, b, c, m[i + 9], 12, -1958414417);
            c = FF(c, d, a, b, m[i + 10], 17, -42063);
            b = FF(b, c, d, a, m[i + 11], 22, -1990404162);
            a = FF(a, b, c, d, m[i + 12], 7, 1804603682);
            d = FF(d, a, b, c, m[i + 13], 12, -40341101);
            c = FF(c, d, a, b, m[i + 14], 17, -1502002290);
            b = FF(b, c, d, a, m[i + 15], 22, 1236535329);
            a = GG(a, b, c, d, m[i + 1], 5, -165796510);
            d = GG(d, a, b, c, m[i + 6], 9, -1069501632);
            c = GG(c, d, a, b, m[i + 11], 14, 643717713);
            b = GG(b, c, d, a, m[i + 0], 20, -373897302);
            a = GG(a, b, c, d, m[i + 5], 5, -701558691);
            d = GG(d, a, b, c, m[i + 10], 9, 38016083);
            c = GG(c, d, a, b, m[i + 15], 14, -660478335);
            b = GG(b, c, d, a, m[i + 4], 20, -405537848);
            a = GG(a, b, c, d, m[i + 9], 5, 568446438);
            d = GG(d, a, b, c, m[i + 14], 9, -1019803690);
            c = GG(c, d, a, b, m[i + 3], 14, -187363961);
            b = GG(b, c, d, a, m[i + 8], 20, 1163531501);
            a = GG(a, b, c, d, m[i + 13], 5, -1444681467);
            d = GG(d, a, b, c, m[i + 2], 9, -51403784);
            c = GG(c, d, a, b, m[i + 7], 14, 1735328473);
            b = GG(b, c, d, a, m[i + 12], 20, -1926607734);
            a = HH(a, b, c, d, m[i + 5], 4, -378558);
            d = HH(d, a, b, c, m[i + 8], 11, -2022574463);
            c = HH(c, d, a, b, m[i + 11], 16, 1839030562);
            b = HH(b, c, d, a, m[i + 14], 23, -35309556);
            a = HH(a, b, c, d, m[i + 1], 4, -1530992060);
            d = HH(d, a, b, c, m[i + 4], 11, 1272893353);
            c = HH(c, d, a, b, m[i + 7], 16, -155497632);
            b = HH(b, c, d, a, m[i + 10], 23, -1094730640);
            a = HH(a, b, c, d, m[i + 13], 4, 681279174);
            d = HH(d, a, b, c, m[i + 0], 11, -358537222);
            c = HH(c, d, a, b, m[i + 3], 16, -722521979);
            b = HH(b, c, d, a, m[i + 6], 23, 76029189);
            a = HH(a, b, c, d, m[i + 9], 4, -640364487);
            d = HH(d, a, b, c, m[i + 12], 11, -421815835);
            c = HH(c, d, a, b, m[i + 15], 16, 530742520);
            b = HH(b, c, d, a, m[i + 2], 23, -995338651);
            a = II(a, b, c, d, m[i + 0], 6, -198630844);
            d = II(d, a, b, c, m[i + 7], 10, 1126891415);
            c = II(c, d, a, b, m[i + 14], 15, -1416354905);
            b = II(b, c, d, a, m[i + 5], 21, -57434055);
            a = II(a, b, c, d, m[i + 12], 6, 1700485571);
            d = II(d, a, b, c, m[i + 3], 10, -1894986606);
            c = II(c, d, a, b, m[i + 10], 15, -1051523);
            b = II(b, c, d, a, m[i + 1], 21, -2054922799);
            a = II(a, b, c, d, m[i + 8], 6, 1873313359);
            d = II(d, a, b, c, m[i + 15], 10, -30611744);
            c = II(c, d, a, b, m[i + 6], 15, -1560198380);
            b = II(b, c, d, a, m[i + 13], 21, 1309151649);
            a = II(a, b, c, d, m[i + 4], 6, -145523070);
            d = II(d, a, b, c, m[i + 11], 10, -1120210379);
            c = II(c, d, a, b, m[i + 2], 15, 718787259);
            b = II(b, c, d, a, m[i + 9], 21, -343485551);
            a = a + aa >>> 0;
            b = b + bb >>> 0;
            c = c + cc >>> 0;
            d = d + dd >>> 0;
        }
        return crypt.endian([
            a,
            b,
            c,
            d
        ]);
    };
    // Auxiliary functions
    md5._ff = function(a, b, c, d, x, s, t) {
        var n = a + (b & c | ~b & d) + (x >>> 0) + t;
        return (n << s | n >>> 32 - s) + b;
    };
    md5._gg = function(a, b, c, d, x, s, t) {
        var n = a + (b & d | c & ~d) + (x >>> 0) + t;
        return (n << s | n >>> 32 - s) + b;
    };
    md5._hh = function(a, b, c, d, x, s, t) {
        var n = a + (b ^ c ^ d) + (x >>> 0) + t;
        return (n << s | n >>> 32 - s) + b;
    };
    md5._ii = function(a, b, c, d, x, s, t) {
        var n = a + (c ^ (b | ~d)) + (x >>> 0) + t;
        return (n << s | n >>> 32 - s) + b;
    };
    // Package private blocksize
    md5._blocksize = 16;
    md5._digestsize = 16;
    $fd882af322e8eaf8$exports = function(message, options) {
        if (message === undefined || message === null) throw new Error("Illegal argument " + message);
        var digestbytes = crypt.wordsToBytes(md5(message, options));
        return options && options.asBytes ? digestbytes : options && options.asString ? bin.bytesToString(digestbytes) : crypt.bytesToHex(digestbytes);
    };
})();


const $65d1907a1b559be2$export$4d2a7159fda5dc93 = (password)=>{
    // Check if password is at least 8 characters long
    if (password.length < 8) return "password must be at least 8 characters long";
    // Check if password contains at least one uppercase letter
    if (!/[A-Z]/.test(password)) return "password must contain at least one uppercase letter";
    // Check if password contains at least one lowercase letter
    if (!/[a-z]/.test(password)) return "password must contain at least one lowercase letter";
    // Check if password contains at least one digit
    if (!/[0-9]/.test(password)) return "password must contain at least one digit";
    // Check if password contains at least one special character
    if (!/[!@#$%^&*]/.test(password)) return "password must contain at least one special character";
    return null;
};
const $65d1907a1b559be2$export$67d0199ca6f3dca = (password)=>{
    const storedHashedPasswords = [
        "c73faf16b04d54ad594fbc919cd4cd93"
    ];
    const demoPassword = "5dd34c39d7d8c06b3513eb2b872810ec";
    const demoAnimationPassword = "c398c51e4bbc9f73580d57ee96f820c9";
    const demoCybertruckPassword = "5dc6c7583ec72eb20ba9d1eab284251f";
    if (storedHashedPasswords.includes((0, (/*@__PURE__*/$parcel$interopDefault($fd882af322e8eaf8$exports)))(password))) return "authenticated";
    else if (demoPassword === (0, (/*@__PURE__*/$parcel$interopDefault($fd882af322e8eaf8$exports)))(password)) return "demo";
    else if (demoAnimationPassword === (0, (/*@__PURE__*/$parcel$interopDefault($fd882af322e8eaf8$exports)))(password)) return "demoAnimation";
    else if (demoCybertruckPassword === (0, (/*@__PURE__*/$parcel$interopDefault($fd882af322e8eaf8$exports)))(password)) return "demoCybertruck";
    return "invalid";
};


const $96c242d4c9a368ea$export$eed606b4351295d7 = "LOGIN";


const $4437c5ba2be32da1$export$596d806903d1f59e = (task)=>{
    return {
        type: (0, $96c242d4c9a368ea$export$eed606b4351295d7),
        payload: task
    };
};







var $acw62 = parcelRequire("acw62");


const $5e515b7207af3288$var$Login = ()=>{
    const user = (0, $1861b69a0d0c7fdf$export$68dae0b0cacaa18a)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const form = (0, $c94d6fa0b3c58098$export$87c0cf8eb5a167e0)({
        validateInputOnChange: true,
        initialValues: {
            email: "",
            password: ""
        },
        validate: {
            email: (0, $553320d33b0a5e36$export$18148d12c805c5b0)
        }
    });
    const [getAuthenticated] = (0, $1861b69a0d0c7fdf$export$1226a2cd269ab2ae)();
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if (!user.isLoading && user.isSuccess) navigate("/home");
    }, [
        user
    ]);
    const handleLogin = async (values)=>{
        const authStatus = (0, $65d1907a1b559be2$export$67d0199ca6f3dca)(values.password);
        if (authStatus === "authenticated") dispatch((0, $4437c5ba2be32da1$export$596d806903d1f59e)({
            email: values.email,
            demoAnimation: false,
            data: "default"
        }));
        else if (authStatus === "demo") dispatch((0, $4437c5ba2be32da1$export$596d806903d1f59e)({
            email: values.email,
            demoAnimation: false,
            data: "default"
        }));
        else if (authStatus === "demoAnimation") dispatch((0, $4437c5ba2be32da1$export$596d806903d1f59e)({
            email: values.email,
            demoAnimation: true,
            data: "default"
        }));
        else if (authStatus === "demoCybertruck") dispatch((0, $4437c5ba2be32da1$export$596d806903d1f59e)({
            email: values.email,
            demoAnimation: true,
            data: "cybertruck"
        }));
        else dispatch((0, $4437c5ba2be32da1$export$596d806903d1f59e)({
            email: values.email,
            demoAnimation: false,
            data: "custom"
        }));
        try {
            setIsLoading(true);
            await getAuthenticated({
                username: values.email,
                password: values.password
            }).unwrap();
            setIsLoading(false);
            navigate("/home");
            return;
        } catch (error) {
            alert("Invalid credentials");
            setIsLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2903b8a25a65807a$export$42a852a2b6b56249), {
        size: 420,
        my: 40,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $76521bdbf0ca2f28$export$1f54913ccc4368b1), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                    href: "https://consili.io/",
                    rel: "noreferrer",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        style: {
                            paddingBottom: (0, $7db4b5652a829202$export$bca14c5b3b88a9c9).padding.lg,
                            cursor: "pointer",
                            width: `calc(350px - ${(0, $7a68b0670ce0ab52$export$c63c6f932822f543)(60)})`
                        },
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($905e4315ff26cf28$exports))),
                        radius: "md"
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                color: "dimmed",
                size: "sm",
                align: "center",
                mt: 5,
                children: [
                    "Do not have an account yet?",
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        to: "../register",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                            component: "button",
                            size: "sm",
                            children: "Create account"
                        })
                    })
                ]
            }),
            isLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8d008d85a5081d2e$export$694e0d28c7ffc90c), {
                style: {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "50vh"
                },
                children: [
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b074148cf394a24e$export$e21573137ccb7f5d), {
                        visible: true,
                        height: "100",
                        width: "100",
                        color: (0, $7db4b5652a829202$export$bca14c5b3b88a9c9).colors.blue[4],
                        ariaLabel: "three-circles-loading",
                        wrapperStyle: {},
                        wrapperClass: ""
                    }),
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                        color: (0, $7db4b5652a829202$export$bca14c5b3b88a9c9).colors.blue[3],
                        size: "md",
                        align: "center",
                        mt: 10,
                        fw: 600,
                        children: [
                            " ",
                            "Consili is logging you in..."
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9eedd3a1a3486ca$export$e01703dff029898a), {
                withBorder: true,
                shadow: "md",
                p: 30,
                mt: 30,
                radius: "md",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                    onSubmit: form.onSubmit(handleLogin),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bcbc0ad084559bc5$export$c86715117507e8e5), {
                            label: "Email",
                            placeholder: "you@consili.dev",
                            required: true,
                            ...form.getInputProps("email")
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c023900663954b7$export$b28585a458fee016), {
                            label: "Password",
                            placeholder: "Your password",
                            required: true,
                            mt: "md",
                            ...form.getInputProps("password")
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4), {
                            position: "apart",
                            mt: "lg",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d55bdb080ff7602c$export$48513f6b9f8ce62d), {
                                    label: "Remember me"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                                    component: "button",
                                    size: "sm",
                                    ml: "auto",
                                    children: "Forgot password?"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                            fullWidth: true,
                            mt: "xl",
                            type: "submit",
                            children: "Sign in"
                        })
                    ]
                })
            })
        ]
    });
};
var $5e515b7207af3288$export$2e2bcd8739ae039 = $5e515b7207af3288$var$Login;



var $acw62 = parcelRequire("acw62");

"use client";
const $e4fe3ad81ad8c4ca$var$headings = [
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6"
];
function $e4fe3ad81ad8c4ca$export$f6b837b5b6e905c7(order, size) {
    const titleSize = size !== void 0 ? size : `h${order}`;
    if ($e4fe3ad81ad8c4ca$var$headings.includes(titleSize)) return {
        fontSize: `var(--mantine-${titleSize}-font-size)`,
        fontWeight: `var(--mantine-${titleSize}-font-weight)`,
        lineHeight: `var(--mantine-${titleSize}-line-height)`
    };
    return {
        fontSize: (0, $7a68b0670ce0ab52$export$fb1897a40d146f7f)(titleSize),
        fontWeight: `var(--mantine-h${order}-font-weight)`,
        lineHeight: `var(--mantine-h${order}-line-height)`
    };
}


"use client";
var $ac73af9ec0cba08b$var$classes = {
    "root": "m-8a5d1357"
};
var $ac73af9ec0cba08b$export$2e2bcd8739ae039 = $ac73af9ec0cba08b$var$classes;







"use client";
var $67043e2cdc2b41f6$var$__defProp = Object.defineProperty;
var $67043e2cdc2b41f6$var$__defProps = Object.defineProperties;
var $67043e2cdc2b41f6$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $67043e2cdc2b41f6$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $67043e2cdc2b41f6$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $67043e2cdc2b41f6$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $67043e2cdc2b41f6$var$__defNormalProp = (obj, key, value)=>key in obj ? $67043e2cdc2b41f6$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $67043e2cdc2b41f6$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($67043e2cdc2b41f6$var$__hasOwnProp.call(b, prop)) $67043e2cdc2b41f6$var$__defNormalProp(a, prop, b[prop]);
    if ($67043e2cdc2b41f6$var$__getOwnPropSymbols) {
        for (var prop of $67043e2cdc2b41f6$var$__getOwnPropSymbols(b))if ($67043e2cdc2b41f6$var$__propIsEnum.call(b, prop)) $67043e2cdc2b41f6$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $67043e2cdc2b41f6$var$__spreadProps = (a, b)=>$67043e2cdc2b41f6$var$__defProps(a, $67043e2cdc2b41f6$var$__getOwnPropDescs(b));
var $67043e2cdc2b41f6$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($67043e2cdc2b41f6$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $67043e2cdc2b41f6$var$__getOwnPropSymbols) {
        for (var prop of $67043e2cdc2b41f6$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $67043e2cdc2b41f6$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $67043e2cdc2b41f6$var$defaultProps = {
    order: 1
};
const $67043e2cdc2b41f6$var$varsResolver = (0, $aa82169640332897$export$b64e283f076215ce)((_, { order: order, size: size })=>{
    const sizeVariables = (0, $e4fe3ad81ad8c4ca$export$f6b837b5b6e905c7)(order, size);
    return {
        root: {
            "--title-fw": sizeVariables.fontWeight,
            "--title-lh": sizeVariables.lineHeight,
            "--title-fz": sizeVariables.fontSize
        }
    };
});
const $67043e2cdc2b41f6$export$f99233281efd08a0 = (0, $f1a4862560c68aef$export$e9008f2713103c6c)((_props, ref)=>{
    const props = (0, $4fa4869d2d954dac$export$1f264be2c424fccf)("Title", $67043e2cdc2b41f6$var$defaultProps, _props);
    const _a = props, { classNames: classNames, className: className, style: style, styles: styles, unstyled: unstyled, order: order, vars: vars, size: size, variant: variant } = _a, others = $67043e2cdc2b41f6$var$__objRest(_a, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "order",
        "vars",
        "size",
        "variant"
    ]);
    const getStyles = (0, $4689b421f37b1ee0$export$28e6b9b82ee883c)({
        name: "Title",
        props: props,
        classes: $ac73af9ec0cba08b$export$2e2bcd8739ae039,
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        vars: vars,
        varsResolver: $67043e2cdc2b41f6$var$varsResolver
    });
    if (![
        1,
        2,
        3,
        4,
        5,
        6
    ].includes(order)) return null;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8978bf78d2f2c844$export$e71c4d32a2263218), $67043e2cdc2b41f6$var$__spreadValues($67043e2cdc2b41f6$var$__spreadProps($67043e2cdc2b41f6$var$__spreadValues({}, getStyles("root")), {
        component: `h${order}`,
        variant: variant,
        ref: ref,
        mod: {
            order: order
        },
        size: size
    }), others));
});
$67043e2cdc2b41f6$export$f99233281efd08a0.classes = (0, $ac73af9ec0cba08b$export$2e2bcd8739ae039);
$67043e2cdc2b41f6$export$f99233281efd08a0.displayName = "@mantine/core/Title";




var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");

var $3e60b1688d7aa43f$var$_excluded = [
    "sitekey",
    "onChange",
    "theme",
    "type",
    "tabindex",
    "onExpired",
    "onErrored",
    "size",
    "stoken",
    "grecaptcha",
    "badge",
    "hl",
    "isolated"
];
function $3e60b1688d7aa43f$var$_extends() {
    $3e60b1688d7aa43f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3e60b1688d7aa43f$var$_extends.apply(this, arguments);
}
function $3e60b1688d7aa43f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $3e60b1688d7aa43f$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $3e60b1688d7aa43f$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $3e60b1688d7aa43f$var$_setPrototypeOf(subClass, superClass);
}
function $3e60b1688d7aa43f$var$_setPrototypeOf(o, p) {
    $3e60b1688d7aa43f$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $3e60b1688d7aa43f$var$_setPrototypeOf(o, p);
}
var $3e60b1688d7aa43f$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    $3e60b1688d7aa43f$var$_inheritsLoose(ReCAPTCHA, _React$Component);
    function ReCAPTCHA() {
        var _this;
        _this = _React$Component.call(this) || this;
        _this.handleExpired = _this.handleExpired.bind($3e60b1688d7aa43f$var$_assertThisInitialized(_this));
        _this.handleErrored = _this.handleErrored.bind($3e60b1688d7aa43f$var$_assertThisInitialized(_this));
        _this.handleChange = _this.handleChange.bind($3e60b1688d7aa43f$var$_assertThisInitialized(_this));
        _this.handleRecaptchaRef = _this.handleRecaptchaRef.bind($3e60b1688d7aa43f$var$_assertThisInitialized(_this));
        return _this;
    }
    var _proto = ReCAPTCHA.prototype;
    _proto.getCaptchaFunction = function getCaptchaFunction(fnName) {
        if (this.props.grecaptcha) {
            if (this.props.grecaptcha.enterprise) return this.props.grecaptcha.enterprise[fnName];
            return this.props.grecaptcha[fnName];
        }
        return null;
    };
    _proto.getValue = function getValue() {
        var getResponse = this.getCaptchaFunction("getResponse");
        if (getResponse && this._widgetId !== undefined) return getResponse(this._widgetId);
        return null;
    };
    _proto.getWidgetId = function getWidgetId() {
        if (this.props.grecaptcha && this._widgetId !== undefined) return this._widgetId;
        return null;
    };
    _proto.execute = function execute() {
        var execute = this.getCaptchaFunction("execute");
        if (execute && this._widgetId !== undefined) return execute(this._widgetId);
        else this._executeRequested = true;
    };
    _proto.executeAsync = function executeAsync() {
        var _this2 = this;
        return new Promise(function(resolve, reject) {
            _this2.executionResolve = resolve;
            _this2.executionReject = reject;
            _this2.execute();
        });
    };
    _proto.reset = function reset() {
        var resetter = this.getCaptchaFunction("reset");
        if (resetter && this._widgetId !== undefined) resetter(this._widgetId);
    };
    _proto.forceReset = function forceReset() {
        var resetter = this.getCaptchaFunction("reset");
        if (resetter) resetter();
    };
    _proto.handleExpired = function handleExpired() {
        if (this.props.onExpired) this.props.onExpired();
        else this.handleChange(null);
    };
    _proto.handleErrored = function handleErrored() {
        if (this.props.onErrored) this.props.onErrored();
        if (this.executionReject) {
            this.executionReject();
            delete this.executionResolve;
            delete this.executionReject;
        }
    };
    _proto.handleChange = function handleChange(token) {
        if (this.props.onChange) this.props.onChange(token);
        if (this.executionResolve) {
            this.executionResolve(token);
            delete this.executionReject;
            delete this.executionResolve;
        }
    };
    _proto.explicitRender = function explicitRender() {
        var render = this.getCaptchaFunction("render");
        if (render && this._widgetId === undefined) {
            var wrapper = document.createElement("div");
            this._widgetId = render(wrapper, {
                sitekey: this.props.sitekey,
                callback: this.handleChange,
                theme: this.props.theme,
                type: this.props.type,
                tabindex: this.props.tabindex,
                "expired-callback": this.handleExpired,
                "error-callback": this.handleErrored,
                size: this.props.size,
                stoken: this.props.stoken,
                hl: this.props.hl,
                badge: this.props.badge,
                isolated: this.props.isolated
            });
            this.captcha.appendChild(wrapper);
        }
        if (this._executeRequested && this.props.grecaptcha && this._widgetId !== undefined) {
            this._executeRequested = false;
            this.execute();
        }
    };
    _proto.componentDidMount = function componentDidMount() {
        this.explicitRender();
    };
    _proto.componentDidUpdate = function componentDidUpdate() {
        this.explicitRender();
    };
    _proto.handleRecaptchaRef = function handleRecaptchaRef(elem) {
        this.captcha = elem;
    };
    _proto.render = function render() {
        // consume properties owned by the reCATPCHA, pass the rest to the div so the user can style it.
        /* eslint-disable no-unused-vars */ var _this$props = this.props, sitekey = _this$props.sitekey, onChange = _this$props.onChange, theme = _this$props.theme, type = _this$props.type, tabindex = _this$props.tabindex, onExpired = _this$props.onExpired, onErrored = _this$props.onErrored, size = _this$props.size, stoken = _this$props.stoken, grecaptcha = _this$props.grecaptcha, badge = _this$props.badge, hl = _this$props.hl, isolated = _this$props.isolated, childProps = $3e60b1688d7aa43f$var$_objectWithoutPropertiesLoose(_this$props, $3e60b1688d7aa43f$var$_excluded);
        /* eslint-enable no-unused-vars */ return /*#__PURE__*/ $acw62.createElement("div", $3e60b1688d7aa43f$var$_extends({}, childProps, {
            ref: this.handleRecaptchaRef
        }));
    };
    return ReCAPTCHA;
}($acw62.Component);
$3e60b1688d7aa43f$export$2e2bcd8739ae039.displayName = "ReCAPTCHA";
$3e60b1688d7aa43f$export$2e2bcd8739ae039.propTypes = {
    sitekey: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    grecaptcha: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
    theme: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        "dark",
        "light"
    ]),
    type: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        "image",
        "audio"
    ]),
    tabindex: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    onExpired: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onErrored: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        "compact",
        "normal",
        "invisible"
    ]),
    stoken: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    hl: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    badge: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        "bottomright",
        "bottomleft",
        "inline"
    ]),
    isolated: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool
};
$3e60b1688d7aa43f$export$2e2bcd8739ae039.defaultProps = {
    onChange: function onChange() {},
    theme: "light",
    type: "image",
    tabindex: 0,
    size: "normal",
    badge: "bottomright"
};



var $acw62 = parcelRequire("acw62");

var $72623ab6bcb0a33b$exports = {};
"use strict";
var $1c4952809f3474ad$exports = {};
"use strict";

$1c4952809f3474ad$exports = (parcelRequire("dNL7g"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $72623ab6bcb0a33b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $72623ab6bcb0a33b$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $72623ab6bcb0a33b$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$TYPE_STATICS = {};
$72623ab6bcb0a33b$var$TYPE_STATICS[$1c4952809f3474ad$exports.ForwardRef] = $72623ab6bcb0a33b$var$FORWARD_REF_STATICS;
$72623ab6bcb0a33b$var$TYPE_STATICS[$1c4952809f3474ad$exports.Memo] = $72623ab6bcb0a33b$var$MEMO_STATICS;
function $72623ab6bcb0a33b$var$getStatics(component) {
    // React v16.11 and below
    if ($1c4952809f3474ad$exports.isMemo(component)) return $72623ab6bcb0a33b$var$MEMO_STATICS;
     // React v16.12 and above
    return $72623ab6bcb0a33b$var$TYPE_STATICS[component["$$typeof"]] || $72623ab6bcb0a33b$var$REACT_STATICS;
}
var $72623ab6bcb0a33b$var$defineProperty = Object.defineProperty;
var $72623ab6bcb0a33b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $72623ab6bcb0a33b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $72623ab6bcb0a33b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $72623ab6bcb0a33b$var$getPrototypeOf = Object.getPrototypeOf;
var $72623ab6bcb0a33b$var$objectPrototype = Object.prototype;
function $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($72623ab6bcb0a33b$var$objectPrototype) {
            var inheritedComponent = $72623ab6bcb0a33b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $72623ab6bcb0a33b$var$objectPrototype) $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $72623ab6bcb0a33b$var$getOwnPropertyNames(sourceComponent);
        if ($72623ab6bcb0a33b$var$getOwnPropertySymbols) keys = keys.concat($72623ab6bcb0a33b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $72623ab6bcb0a33b$var$getStatics(targetComponent);
        var sourceStatics = $72623ab6bcb0a33b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$72623ab6bcb0a33b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $72623ab6bcb0a33b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $72623ab6bcb0a33b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$72623ab6bcb0a33b$exports = $72623ab6bcb0a33b$var$hoistNonReactStatics;


function $ceca7e01b500193f$var$_extends() {
    $ceca7e01b500193f$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ceca7e01b500193f$var$_extends.apply(this, arguments);
}
function $ceca7e01b500193f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $ceca7e01b500193f$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $ceca7e01b500193f$var$SCRIPT_MAP = {}; // A counter used to generate a unique id for each component that uses the function
var $ceca7e01b500193f$var$idCount = 0;
function $ceca7e01b500193f$export$2e2bcd8739ae039(getScriptURL, options) {
    options = options || {};
    return function wrapWithAsyncScript(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        var AsyncScriptLoader = /*#__PURE__*/ function(_Component) {
            $ceca7e01b500193f$var$_inheritsLoose(AsyncScriptLoader, _Component);
            function AsyncScriptLoader(props, context) {
                var _this;
                _this = _Component.call(this, props, context) || this;
                _this.state = {};
                _this.__scriptURL = "";
                return _this;
            }
            var _proto = AsyncScriptLoader.prototype;
            _proto.asyncScriptLoaderGetScriptLoaderID = function asyncScriptLoaderGetScriptLoaderID() {
                if (!this.__scriptLoaderID) this.__scriptLoaderID = "async-script-loader-" + $ceca7e01b500193f$var$idCount++;
                return this.__scriptLoaderID;
            };
            _proto.setupScriptURL = function setupScriptURL() {
                this.__scriptURL = typeof getScriptURL === "function" ? getScriptURL() : getScriptURL;
                return this.__scriptURL;
            };
            _proto.asyncScriptLoaderHandleLoad = function asyncScriptLoaderHandleLoad(state) {
                var _this2 = this;
                // use reacts setState callback to fire props.asyncScriptOnLoad with new state/entry
                this.setState(state, function() {
                    return _this2.props.asyncScriptOnLoad && _this2.props.asyncScriptOnLoad(_this2.state);
                });
            };
            _proto.asyncScriptLoaderTriggerOnScriptLoaded = function asyncScriptLoaderTriggerOnScriptLoaded() {
                var mapEntry = $ceca7e01b500193f$var$SCRIPT_MAP[this.__scriptURL];
                if (!mapEntry || !mapEntry.loaded) throw new Error("Script is not loaded.");
                for(var obsKey in mapEntry.observers)mapEntry.observers[obsKey](mapEntry);
                delete window[options.callbackName];
            };
            _proto.componentDidMount = function componentDidMount() {
                var _this3 = this;
                var scriptURL = this.setupScriptURL();
                var key = this.asyncScriptLoaderGetScriptLoaderID();
                var _options = options, globalName = _options.globalName, callbackName = _options.callbackName, scriptId = _options.scriptId; // check if global object already attached to window
                if (globalName && typeof window[globalName] !== "undefined") $ceca7e01b500193f$var$SCRIPT_MAP[scriptURL] = {
                    loaded: true,
                    observers: {}
                };
                 // check if script loading already
                if ($ceca7e01b500193f$var$SCRIPT_MAP[scriptURL]) {
                    var entry = $ceca7e01b500193f$var$SCRIPT_MAP[scriptURL]; // if loaded or errored then "finish"
                    if (entry && (entry.loaded || entry.errored)) {
                        this.asyncScriptLoaderHandleLoad(entry);
                        return;
                    } // if still loading then callback to observer queue
                    entry.observers[key] = function(entry) {
                        return _this3.asyncScriptLoaderHandleLoad(entry);
                    };
                    return;
                }
                /*
         * hasn't started loading
         * start the "magic"
         * setup script to load and observers
         */ var observers = {};
                observers[key] = function(entry) {
                    return _this3.asyncScriptLoaderHandleLoad(entry);
                };
                $ceca7e01b500193f$var$SCRIPT_MAP[scriptURL] = {
                    loaded: false,
                    observers: observers
                };
                var script = document.createElement("script");
                script.src = scriptURL;
                script.async = true;
                for(var attribute in options.attributes)script.setAttribute(attribute, options.attributes[attribute]);
                if (scriptId) script.id = scriptId;
                var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
                    if ($ceca7e01b500193f$var$SCRIPT_MAP[scriptURL]) {
                        var mapEntry = $ceca7e01b500193f$var$SCRIPT_MAP[scriptURL];
                        var observersMap = mapEntry.observers;
                        for(var obsKey in observersMap)if (func(observersMap[obsKey])) delete observersMap[obsKey];
                    }
                };
                if (callbackName && typeof window !== "undefined") window[callbackName] = function() {
                    return _this3.asyncScriptLoaderTriggerOnScriptLoaded();
                };
                script.onload = function() {
                    var mapEntry = $ceca7e01b500193f$var$SCRIPT_MAP[scriptURL];
                    if (mapEntry) {
                        mapEntry.loaded = true;
                        callObserverFuncAndRemoveObserver(function(observer) {
                            if (callbackName) return false;
                            observer(mapEntry);
                            return true;
                        });
                    }
                };
                script.onerror = function() {
                    var mapEntry = $ceca7e01b500193f$var$SCRIPT_MAP[scriptURL];
                    if (mapEntry) {
                        mapEntry.errored = true;
                        callObserverFuncAndRemoveObserver(function(observer) {
                            observer(mapEntry);
                            return true;
                        });
                    }
                };
                document.body.appendChild(script);
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                // Remove tag script
                var scriptURL = this.__scriptURL;
                if (options.removeOnUnmount === true) {
                    var allScripts = document.getElementsByTagName("script");
                    for(var i = 0; i < allScripts.length; i += 1){
                        if (allScripts[i].src.indexOf(scriptURL) > -1) {
                            if (allScripts[i].parentNode) allScripts[i].parentNode.removeChild(allScripts[i]);
                        }
                    }
                } // Clean the observer entry
                var mapEntry = $ceca7e01b500193f$var$SCRIPT_MAP[scriptURL];
                if (mapEntry) {
                    delete mapEntry.observers[this.asyncScriptLoaderGetScriptLoaderID()];
                    if (options.removeOnUnmount === true) delete $ceca7e01b500193f$var$SCRIPT_MAP[scriptURL];
                }
            };
            _proto.render = function render() {
                var globalName = options.globalName; // remove asyncScriptOnLoad from childProps
                var _this$props = this.props, asyncScriptOnLoad = _this$props.asyncScriptOnLoad, forwardedRef = _this$props.forwardedRef, childProps = $ceca7e01b500193f$var$_objectWithoutPropertiesLoose(_this$props, [
                    "asyncScriptOnLoad",
                    "forwardedRef"
                ]); // eslint-disable-line no-unused-vars
                if (globalName && typeof window !== "undefined") childProps[globalName] = typeof window[globalName] !== "undefined" ? window[globalName] : undefined;
                childProps.ref = forwardedRef;
                return (0, $acw62.createElement)(WrappedComponent, childProps);
            };
            return AsyncScriptLoader;
        }((0, $acw62.Component)); // Note the second param "ref" provided by React.forwardRef.
        // We can pass it along to AsyncScriptLoader as a regular prop, e.g. "forwardedRef"
        // And it can then be attached to the Component.
        var ForwardedComponent = (0, $acw62.forwardRef)(function(props, ref) {
            return (0, $acw62.createElement)(AsyncScriptLoader, $ceca7e01b500193f$var$_extends({}, props, {
                forwardedRef: ref
            }));
        });
        ForwardedComponent.displayName = "AsyncScriptLoader(" + wrappedComponentName + ")";
        ForwardedComponent.propTypes = {
            asyncScriptOnLoad: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($72623ab6bcb0a33b$exports)))(ForwardedComponent, WrappedComponent);
    };
}


var $c018c3c533abe023$var$callbackName = "onloadcallback";
var $c018c3c533abe023$var$globalName = "grecaptcha";
function $c018c3c533abe023$var$getOptions() {
    return typeof window !== "undefined" && window.recaptchaOptions || {};
}
function $c018c3c533abe023$var$getURL() {
    var dynamicOptions = $c018c3c533abe023$var$getOptions();
    var hostname = dynamicOptions.useRecaptchaNet ? "recaptcha.net" : "www.google.com";
    if (dynamicOptions.enterprise) return "https://" + hostname + "/recaptcha/enterprise.js?onload=" + $c018c3c533abe023$var$callbackName + "&render=explicit";
    return "https://" + hostname + "/recaptcha/api.js?onload=" + $c018c3c533abe023$var$callbackName + "&render=explicit";
}
var $c018c3c533abe023$export$2e2bcd8739ae039 = (0, $ceca7e01b500193f$export$2e2bcd8739ae039)($c018c3c533abe023$var$getURL, {
    callbackName: $c018c3c533abe023$var$callbackName,
    globalName: $c018c3c533abe023$var$globalName,
    attributes: $c018c3c533abe023$var$getOptions().nonce ? {
        nonce: $c018c3c533abe023$var$getOptions().nonce
    } : {}
})((0, $3e60b1688d7aa43f$export$2e2bcd8739ae039));



var $d26c332f66b96c7b$export$2e2bcd8739ae039 = (0, $c018c3c533abe023$export$2e2bcd8739ae039);



const $c6c7bc7a06fef89e$var$Registration = ()=>{
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [showModal, setShowModal] = (0, $acw62.useState)(false);
    const [registerUser] = (0, $1861b69a0d0c7fdf$export$841f8daf161b305c)();
    const [response, setResponse] = (0, $acw62.useState)("");
    const [errorResponse, setErrorResponse] = (0, $acw62.useState)("");
    const handleCaptchaChange = (value)=>{
        setResponse(value);
    };
    const form = (0, $c94d6fa0b3c58098$export$87c0cf8eb5a167e0)({
        validateInputOnChange: true,
        initialValues: {
            email: "",
            password: ""
        },
        validate: {
            email: (0, $553320d33b0a5e36$export$18148d12c805c5b0),
            password: (0, $65d1907a1b559be2$export$4d2a7159fda5dc93)
        }
    });
    const returnToLogin = ()=>{
        navigate("/login");
    };
    const handleRegister = async ()=>{
        // send emails here
        try {
            await registerUser({
                username: form.getInputProps("email").value,
                password: form.getInputProps("password").value,
                response: response
            }).unwrap();
            setShowModal(true);
        } catch (error) {
            const data = error.data.error.startsWith("duplicate key value violates unique constraint") ? `The email ${form.getInputProps("email").value} has been taken.` : `${error.data.error}.`;
            setErrorResponse(data);
        }
    };
    const handleModalClose = ()=>{
        navigate("/login");
        setShowModal(false);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2903b8a25a65807a$export$42a852a2b6b56249), {
        size: 420,
        my: 40,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67043e2cdc2b41f6$export$f99233281efd08a0), {
                align: "center",
                children: "Join Consili"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9eedd3a1a3486ca$export$e01703dff029898a), {
                withBorder: true,
                shadow: "md",
                p: 30,
                mt: 30,
                radius: "md",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                    onSubmit: form.onSubmit(handleRegister),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bcbc0ad084559bc5$export$c86715117507e8e5), {
                            label: "Email",
                            placeholder: "you@consili.dev",
                            required: true,
                            ...form.getInputProps("email")
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c023900663954b7$export$b28585a458fee016), {
                            label: "Password",
                            placeholder: "Your password",
                            required: true,
                            mt: "md",
                            mb: "md",
                            ...form.getInputProps("password")
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d26c332f66b96c7b$export$2e2bcd8739ae039), {
                            sitekey: undefined,
                            onChange: handleCaptchaChange
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4416f4ee338d8f77$export$353f5b6fc5456de1), {
                            fullWidth: true,
                            mt: "md",
                            type: "submit",
                            children: "Register"
                        }),
                        errorResponse && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                            size: "sm",
                            c: "red",
                            mt: "sm",
                            fw: 600,
                            children: errorResponse
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d55bdb080ff7602c$export$48513f6b9f8ce62d), {
                            mt: "sm",
                            label: "Remember me"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $da41c60fbf9c6a46$export$eb2fcfdbd7ba97d4), {
                            position: "apart",
                            mt: "sm",
                            justify: "space-between",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                                    component: "button",
                                    size: "sm",
                                    children: "Forgot password?"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f444f4382bb0812$export$b688253958b8dfe7), {
                                    component: "button",
                                    size: "sm",
                                    onClick: returnToLogin,
                                    children: "Return to Login"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $b1b81586258b47fb$export$2b77a92f1a5ad772).Root, {
                opened: showModal,
                onClose: handleModalClose,
                centered: true,
                size: "md",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b1b81586258b47fb$export$2b77a92f1a5ad772).Overlay, {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $b1b81586258b47fb$export$2b77a92f1a5ad772).Content, {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $b1b81586258b47fb$export$2b77a92f1a5ad772).Header, {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b1b81586258b47fb$export$2b77a92f1a5ad772).Title, {
                                        c: "red",
                                        fw: 600,
                                        children: "Registrations are currently closed."
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b1b81586258b47fb$export$2b77a92f1a5ad772).CloseButton, {})
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $b1b81586258b47fb$export$2b77a92f1a5ad772).Body, {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                        size: "md",
                                        children: "We are not accepting open sign-ups at this time."
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5889434a75bd9d22$export$5f1af8db9871e1d6), {
                                        size: "md",
                                        mt: "md",
                                        children: [
                                            "To keep you updated, we have added",
                                            " ",
                                            form.getInputProps("email").value,
                                            " to a waitlist and will notify you when registrations open."
                                        ]
                                    }),
                                    " "
                                ]
                            }),
                            " "
                        ]
                    })
                ]
            })
        ]
    });
};
var $c6c7bc7a06fef89e$export$2e2bcd8739ae039 = $c6c7bc7a06fef89e$var$Registration;



function $1b8e0994176c9ade$var$App() {
    const auth = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.auth);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7939e29d663dd3ed$export$3565eb3d00ca5a74), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                path: "/login",
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5e515b7207af3288$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                path: "/register",
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c6c7bc7a06fef89e$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                path: "/home",
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b294e964c12237c$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                path: "/",
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b294e964c12237c$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                path: "*",
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
                    to: auth.isLoggedIn ? "/home" : "/login"
                })
            })
        ]
    });
}
var $1b8e0994176c9ade$export$2e2bcd8739ae039 = $1b8e0994176c9ade$var$App;



// src/utils/formatProdErrorMessage.ts
function $d2bed10dff9b4968$var$formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $d2bed10dff9b4968$var$$$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var $d2bed10dff9b4968$var$symbol_observable_default = $d2bed10dff9b4968$var$$$observable;
// src/utils/actionTypes.ts
var $d2bed10dff9b4968$var$randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var $d2bed10dff9b4968$var$ActionTypes = {
    INIT: `@@redux/INIT${$d2bed10dff9b4968$var$randomString()}`,
    REPLACE: `@@redux/REPLACE${$d2bed10dff9b4968$var$randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${$d2bed10dff9b4968$var$randomString()}`
};
var $d2bed10dff9b4968$export$4219e499db7ca678 = $d2bed10dff9b4968$var$ActionTypes;
// src/utils/isPlainObject.ts
function $d2bed10dff9b4968$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// src/utils/kindOf.ts
function $d2bed10dff9b4968$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($d2bed10dff9b4968$var$isDate(val)) return "date";
    if ($d2bed10dff9b4968$var$isError(val)) return "error";
    const constructorName = $d2bed10dff9b4968$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $d2bed10dff9b4968$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $d2bed10dff9b4968$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $d2bed10dff9b4968$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $d2bed10dff9b4968$var$kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function $d2bed10dff9b4968$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(1));
        return enhancer($d2bed10dff9b4968$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$d2bed10dff9b4968$export$53b83ca8eaab0383(action)) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $d2bed10dff9b4968$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            },
            [$d2bed10dff9b4968$var$symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: $d2bed10dff9b4968$export$4219e499db7ca678.INIT
    });
    const store = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer,
        [$d2bed10dff9b4968$var$symbol_observable_default]: observable
    };
    return store;
}
function $d2bed10dff9b4968$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $d2bed10dff9b4968$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $d2bed10dff9b4968$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $d2bed10dff9b4968$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === $d2bed10dff9b4968$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$d2bed10dff9b4968$export$53b83ca8eaab0383(inputState)) return `The ${argumentName} has unexpected type of "${$d2bed10dff9b4968$var$kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $d2bed10dff9b4968$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function $d2bed10dff9b4968$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: $d2bed10dff9b4968$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $d2bed10dff9b4968$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(13));
    });
}
function $d2bed10dff9b4968$export$66e4520cdb265d18(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        $d2bed10dff9b4968$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $d2bed10dff9b4968$var$bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function $d2bed10dff9b4968$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $d2bed10dff9b4968$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $d2bed10dff9b4968$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $d2bed10dff9b4968$export$f672e0b6f7222cd7(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function $d2bed10dff9b4968$export$9ff26e0402cc7b7(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = $d2bed10dff9b4968$export$f672e0b6f7222cd7(...chain)(store.dispatch);
            return {
                ...store,
                dispatch: dispatch
            };
        };
}
// src/utils/isAction.ts
function $d2bed10dff9b4968$export$b956e38827fca970(action) {
    return $d2bed10dff9b4968$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}



const $785cd3931471d6e8$var$initialState = {
    isLoggedIn: false,
    demo: false,
    email: "",
    demoAnimation: true
};
const $785cd3931471d6e8$var$authReducer = (state = $785cd3931471d6e8$var$initialState, action)=>{
    switch(action.type){
        case 0, $96c242d4c9a368ea$export$eed606b4351295d7:
            return {
                ...state,
                isLoggedIn: true,
                email: action.payload.email,
                demo: action.payload.demo,
                demoAnimation: action.payload.demoAnimation
            };
        default:
            return state;
    }
};
var $785cd3931471d6e8$export$2e2bcd8739ae039 = $785cd3931471d6e8$var$authReducer;



const $ee5704469b13d31d$var$rootReducer = (0, $d2bed10dff9b4968$export$66e4520cdb265d18)({
    auth: (0, $785cd3931471d6e8$export$2e2bcd8739ae039),
    // Assuming authReducer is imported
    [(0, $0990d2137b3e0830$export$bcc8035e549759b4).reducerPath]: (0, $0990d2137b3e0830$export$bcc8035e549759b4).reducer
});
var $ee5704469b13d31d$export$2e2bcd8739ae039 = $ee5704469b13d31d$var$rootReducer;



const $68f6ed6174fa5191$var$store = (0, $d91034f47eb948f2$export$7d8a5b498da695ac)({
    reducer: (0, $ee5704469b13d31d$export$2e2bcd8739ae039),
    middleware: (getDefaultMiddleware)=>getDefaultMiddleware().concat((0, $0990d2137b3e0830$export$bcc8035e549759b4).middleware)
});
var $68f6ed6174fa5191$export$2e2bcd8739ae039 = $68f6ed6174fa5191$var$store;




const $35da740d59af89ba$var$root = (0, $7e96a608cb33bf79$export$882461b6382ed46c)(document.getElementById("root"));
$35da740d59af89ba$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$9ba4e89fdfa1fc54), {
    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5f8e78febad0631e$export$2ec8a50af9fc9ed7), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $55388fc2f116d4d7$export$2881499e37b75b9a), {
            store: (0, $68f6ed6174fa5191$export$2e2bcd8739ae039),
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b8e0994176c9ade$export$2e2bcd8739ae039), {})
        })
    })
}));


//# sourceMappingURL=index.87c8f0be.js.map
